/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(24);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {/* Riot v3.4.4, @license MIT */
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.riot = global.riot || {})));
	}(this, (function (exports) { 'use strict';
	
	var __TAGS_CACHE = [];
	var __TAG_IMPL = {};
	var GLOBAL_MIXIN = '__global_mixin';
	var ATTRS_PREFIX = 'riot-';
	var REF_DIRECTIVES = ['ref', 'data-ref'];
	var IS_DIRECTIVE = 'data-is';
	var CONDITIONAL_DIRECTIVE = 'if';
	var LOOP_DIRECTIVE = 'each';
	var LOOP_NO_REORDER_DIRECTIVE = 'no-reorder';
	var SHOW_DIRECTIVE = 'show';
	var HIDE_DIRECTIVE = 'hide';
	var RIOT_EVENTS_KEY = '__riot-events__';
	var T_STRING = 'string';
	var T_OBJECT = 'object';
	var T_UNDEF  = 'undefined';
	var T_FUNCTION = 'function';
	var XLINK_NS = 'http://www.w3.org/1999/xlink';
	var XLINK_REGEX = /^xlink:(\w+)/;
	var WIN = typeof window === T_UNDEF ? undefined : window;
	var RE_SPECIAL_TAGS = /^(?:t(?:body|head|foot|[rhd])|caption|col(?:group)?|opt(?:ion|group))$/;
	var RE_SPECIAL_TAGS_NO_OPTION = /^(?:t(?:body|head|foot|[rhd])|caption|col(?:group)?)$/;
	var RE_EVENTS_PREFIX = /^on/;
	var RE_RESERVED_NAMES = /^(?:_(?:item|id|parent)|update|root|(?:un)?mount|mixin|is(?:Mounted|Loop)|tags|refs|parent|opts|trigger|o(?:n|ff|ne))$/;
	var RE_HTML_ATTRS = /([-\w]+) ?= ?(?:"([^"]*)|'([^']*)|({[^}]*}))/g;
	var CASE_SENSITIVE_ATTRIBUTES = { 'viewbox': 'viewBox' };
	var RE_BOOL_ATTRS = /^(?:disabled|checked|readonly|required|allowfullscreen|auto(?:focus|play)|compact|controls|default|formnovalidate|hidden|ismap|itemscope|loop|multiple|muted|no(?:resize|shade|validate|wrap)?|open|reversed|seamless|selected|sortable|truespeed|typemustmatch)$/;
	var IE_VERSION = (WIN && WIN.document || {}).documentMode | 0;
	
	/**
	 * Check Check if the passed argument is undefined
	 * @param   { String } value -
	 * @returns { Boolean } -
	 */
	function isBoolAttr(value) {
	  return RE_BOOL_ATTRS.test(value)
	}
	
	/**
	 * Check if passed argument is a function
	 * @param   { * } value -
	 * @returns { Boolean } -
	 */
	function isFunction(value) {
	  return typeof value === T_FUNCTION
	}
	
	/**
	 * Check if passed argument is an object, exclude null
	 * NOTE: use isObject(x) && !isArray(x) to excludes arrays.
	 * @param   { * } value -
	 * @returns { Boolean } -
	 */
	function isObject(value) {
	  return value && typeof value === T_OBJECT // typeof null is 'object'
	}
	
	/**
	 * Check if passed argument is undefined
	 * @param   { * } value -
	 * @returns { Boolean } -
	 */
	function isUndefined(value) {
	  return typeof value === T_UNDEF
	}
	
	/**
	 * Check if passed argument is a string
	 * @param   { * } value -
	 * @returns { Boolean } -
	 */
	function isString(value) {
	  return typeof value === T_STRING
	}
	
	/**
	 * Check if passed argument is empty. Different from falsy, because we dont consider 0 or false to be blank
	 * @param { * } value -
	 * @returns { Boolean } -
	 */
	function isBlank(value) {
	  return isUndefined(value) || value === null || value === ''
	}
	
	/**
	 * Check if passed argument is a kind of array
	 * @param   { * } value -
	 * @returns { Boolean } -
	 */
	function isArray(value) {
	  return Array.isArray(value) || value instanceof Array
	}
	
	/**
	 * Check whether object's property could be overridden
	 * @param   { Object }  obj - source object
	 * @param   { String }  key - object property
	 * @returns { Boolean } -
	 */
	function isWritable(obj, key) {
	  var descriptor = Object.getOwnPropertyDescriptor(obj, key);
	  return isUndefined(obj[key]) || descriptor && descriptor.writable
	}
	
	/**
	 * Check if passed argument is a reserved name
	 * @param   { String } value -
	 * @returns { Boolean } -
	 */
	function isReservedName(value) {
	  return RE_RESERVED_NAMES.test(value)
	}
	
	var check = Object.freeze({
		isBoolAttr: isBoolAttr,
		isFunction: isFunction,
		isObject: isObject,
		isUndefined: isUndefined,
		isString: isString,
		isBlank: isBlank,
		isArray: isArray,
		isWritable: isWritable,
		isReservedName: isReservedName
	});
	
	/**
	 * Shorter and fast way to select multiple nodes in the DOM
	 * @param   { String } selector - DOM selector
	 * @param   { Object } ctx - DOM node where the targets of our search will is located
	 * @returns { Object } dom nodes found
	 */
	function $$(selector, ctx) {
	  return Array.prototype.slice.call((ctx || document).querySelectorAll(selector))
	}
	
	/**
	 * Shorter and fast way to select a single node in the DOM
	 * @param   { String } selector - unique dom selector
	 * @param   { Object } ctx - DOM node where the target of our search will is located
	 * @returns { Object } dom node found
	 */
	function $(selector, ctx) {
	  return (ctx || document).querySelector(selector)
	}
	
	/**
	 * Create a document fragment
	 * @returns { Object } document fragment
	 */
	function createFrag() {
	  return document.createDocumentFragment()
	}
	
	/**
	 * Create a document text node
	 * @returns { Object } create a text node to use as placeholder
	 */
	function createDOMPlaceholder() {
	  return document.createTextNode('')
	}
	
	/**
	 * Create a generic DOM node
	 * @param   { String } name - name of the DOM node we want to create
	 * @returns { Object } DOM node just created
	 */
	function mkEl(name) {
	  return document.createElement(name)
	}
	
	/**
	 * Set the inner html of any DOM node SVGs included
	 * @param { Object } container - DOM node where we'll inject new html
	 * @param { String } html - html to inject
	 */
	/* istanbul ignore next */
	function setInnerHTML(container, html) {
	  if (!isUndefined(container.innerHTML))
	    { container.innerHTML = html; }
	    // some browsers do not support innerHTML on the SVGs tags
	  else {
	    var doc = new DOMParser().parseFromString(html, 'application/xml');
	    var node = container.ownerDocument.importNode(doc.documentElement, true);
	    container.appendChild(node);
	  }
	}
	
	/**
	 * Toggle the visibility of any DOM node
	 * @param   { Object }  dom - DOM node we want to hide
	 * @param   { Boolean } show - do we want to show it?
	 */
	
	function toggleVisibility(dom, show) {
	  dom.style.display = show ? '' : 'none';
	  dom['hidden'] = show ? false : true;
	}
	
	/**
	 * Remove any DOM attribute from a node
	 * @param   { Object } dom - DOM node we want to update
	 * @param   { String } name - name of the property we want to remove
	 */
	function remAttr(dom, name) {
	  dom.removeAttribute(name);
	}
	
	/**
	 * Convert a style object to a string
	 * @param   { Object } style - style object we need to parse
	 * @returns { String } resulting css string
	 * @example
	 * styleObjectToString({ color: 'red', height: '10px'}) // => 'color: red; height: 10px'
	 */
	function styleObjectToString(style) {
	  return Object.keys(style).reduce(function (acc, prop) {
	    return (acc + " " + prop + ": " + (style[prop]) + ";")
	  }, '')
	}
	
	/**
	 * Get the value of any DOM attribute on a node
	 * @param   { Object } dom - DOM node we want to parse
	 * @param   { String } name - name of the attribute we want to get
	 * @returns { String | undefined } name of the node attribute whether it exists
	 */
	function getAttr(dom, name) {
	  return dom.getAttribute(name)
	}
	
	/**
	 * Set any DOM attribute
	 * @param { Object } dom - DOM node we want to update
	 * @param { String } name - name of the property we want to set
	 * @param { String } val - value of the property we want to set
	 */
	function setAttr(dom, name, val) {
	  var xlink = XLINK_REGEX.exec(name);
	  if (xlink && xlink[1])
	    { dom.setAttributeNS(XLINK_NS, xlink[1], val); }
	  else
	    { dom.setAttribute(name, val); }
	}
	
	/**
	 * Insert safely a tag to fix #1962 #1649
	 * @param   { HTMLElement } root - children container
	 * @param   { HTMLElement } curr - node to insert
	 * @param   { HTMLElement } next - node that should preceed the current node inserted
	 */
	function safeInsert(root, curr, next) {
	  root.insertBefore(curr, next.parentNode && next);
	}
	
	/**
	 * Minimize risk: only zero or one _space_ between attr & value
	 * @param   { String }   html - html string we want to parse
	 * @param   { Function } fn - callback function to apply on any attribute found
	 */
	function walkAttrs(html, fn) {
	  if (!html)
	    { return }
	  var m;
	  while (m = RE_HTML_ATTRS.exec(html))
	    { fn(m[1].toLowerCase(), m[2] || m[3] || m[4]); }
	}
	
	/**
	 * Walk down recursively all the children tags starting dom node
	 * @param   { Object }   dom - starting node where we will start the recursion
	 * @param   { Function } fn - callback to transform the child node just found
	 * @param   { Object }   context - fn can optionally return an object, which is passed to children
	 */
	function walkNodes(dom, fn, context) {
	  if (dom) {
	    var res = fn(dom, context);
	    var next;
	    // stop the recursion
	    if (res === false) { return }
	
	    dom = dom.firstChild;
	
	    while (dom) {
	      next = dom.nextSibling;
	      walkNodes(dom, fn, res);
	      dom = next;
	    }
	  }
	}
	
	var dom = Object.freeze({
		$$: $$,
		$: $,
		createFrag: createFrag,
		createDOMPlaceholder: createDOMPlaceholder,
		mkEl: mkEl,
		setInnerHTML: setInnerHTML,
		toggleVisibility: toggleVisibility,
		remAttr: remAttr,
		styleObjectToString: styleObjectToString,
		getAttr: getAttr,
		setAttr: setAttr,
		safeInsert: safeInsert,
		walkAttrs: walkAttrs,
		walkNodes: walkNodes
	});
	
	var styleNode;
	var cssTextProp;
	var byName = {};
	var remainder = [];
	var needsInject = false;
	
	// skip the following code on the server
	if (WIN) {
	  styleNode = (function () {
	    // create a new style element with the correct type
	    var newNode = mkEl('style');
	    setAttr(newNode, 'type', 'text/css');
	
	    // replace any user node or insert the new one into the head
	    var userNode = $('style[type=riot]');
	    /* istanbul ignore next */
	    if (userNode) {
	      if (userNode.id) { newNode.id = userNode.id; }
	      userNode.parentNode.replaceChild(newNode, userNode);
	    }
	    else { document.getElementsByTagName('head')[0].appendChild(newNode); }
	
	    return newNode
	  })();
	  cssTextProp = styleNode.styleSheet;
	}
	
	/**
	 * Object that will be used to inject and manage the css of every tag instance
	 */
	var styleManager = {
	  styleNode: styleNode,
	  /**
	   * Save a tag style to be later injected into DOM
	   * @param { String } css - css string
	   * @param { String } name - if it's passed we will map the css to a tagname
	   */
	  add: function add(css, name) {
	    if (name) { byName[name] = css; }
	    else { remainder.push(css); }
	    needsInject = true;
	  },
	  /**
	   * Inject all previously saved tag styles into DOM
	   * innerHTML seems slow: http://jsperf.com/riot-insert-style
	   */
	  inject: function inject() {
	    if (!WIN || !needsInject) { return }
	    needsInject = false;
	    var style = Object.keys(byName)
	      .map(function(k) { return byName[k] })
	      .concat(remainder).join('\n');
	    /* istanbul ignore next */
	    if (cssTextProp) { cssTextProp.cssText = style; }
	    else { styleNode.innerHTML = style; }
	  }
	};
	
	/**
	 * The riot template engine
	 * @version v3.0.3
	 */
	/**
	 * riot.util.brackets
	 *
	 * - `brackets    ` - Returns a string or regex based on its parameter
	 * - `brackets.set` - Change the current riot brackets
	 *
	 * @module
	 */
	
	/* global riot */
	
	/* istanbul ignore next */
	var brackets = (function (UNDEF) {
	
	  var
	    REGLOB = 'g',
	
	    R_MLCOMMS = /\/\*[^*]*\*+(?:[^*\/][^*]*\*+)*\//g,
	
	    R_STRINGS = /"[^"\\]*(?:\\[\S\s][^"\\]*)*"|'[^'\\]*(?:\\[\S\s][^'\\]*)*'|`[^`\\]*(?:\\[\S\s][^`\\]*)*`/g,
	
	    S_QBLOCKS = R_STRINGS.source + '|' +
	      /(?:\breturn\s+|(?:[$\w\)\]]|\+\+|--)\s*(\/)(?![*\/]))/.source + '|' +
	      /\/(?=[^*\/])[^[\/\\]*(?:(?:\[(?:\\.|[^\]\\]*)*\]|\\.)[^[\/\\]*)*?(\/)[gim]*/.source,
	
	    UNSUPPORTED = RegExp('[\\' + 'x00-\\x1F<>a-zA-Z0-9\'",;\\\\]'),
	
	    NEED_ESCAPE = /(?=[[\]()*+?.^$|])/g,
	
	    FINDBRACES = {
	      '(': RegExp('([()])|'   + S_QBLOCKS, REGLOB),
	      '[': RegExp('([[\\]])|' + S_QBLOCKS, REGLOB),
	      '{': RegExp('([{}])|'   + S_QBLOCKS, REGLOB)
	    },
	
	    DEFAULT = '{ }';
	
	  var _pairs = [
	    '{', '}',
	    '{', '}',
	    /{[^}]*}/,
	    /\\([{}])/g,
	    /\\({)|{/g,
	    RegExp('\\\\(})|([[({])|(})|' + S_QBLOCKS, REGLOB),
	    DEFAULT,
	    /^\s*{\^?\s*([$\w]+)(?:\s*,\s*(\S+))?\s+in\s+(\S.*)\s*}/,
	    /(^|[^\\]){=[\S\s]*?}/
	  ];
	
	  var
	    cachedBrackets = UNDEF,
	    _regex,
	    _cache = [],
	    _settings;
	
	  function _loopback (re) { return re }
	
	  function _rewrite (re, bp) {
	    if (!bp) { bp = _cache; }
	    return new RegExp(
	      re.source.replace(/{/g, bp[2]).replace(/}/g, bp[3]), re.global ? REGLOB : ''
	    )
	  }
	
	  function _create (pair) {
	    if (pair === DEFAULT) { return _pairs }
	
	    var arr = pair.split(' ');
	
	    if (arr.length !== 2 || UNSUPPORTED.test(pair)) {
	      throw new Error('Unsupported brackets "' + pair + '"')
	    }
	    arr = arr.concat(pair.replace(NEED_ESCAPE, '\\').split(' '));
	
	    arr[4] = _rewrite(arr[1].length > 1 ? /{[\S\s]*?}/ : _pairs[4], arr);
	    arr[5] = _rewrite(pair.length > 3 ? /\\({|})/g : _pairs[5], arr);
	    arr[6] = _rewrite(_pairs[6], arr);
	    arr[7] = RegExp('\\\\(' + arr[3] + ')|([[({])|(' + arr[3] + ')|' + S_QBLOCKS, REGLOB);
	    arr[8] = pair;
	    return arr
	  }
	
	  function _brackets (reOrIdx) {
	    return reOrIdx instanceof RegExp ? _regex(reOrIdx) : _cache[reOrIdx]
	  }
	
	  _brackets.split = function split (str, tmpl, _bp) {
	    // istanbul ignore next: _bp is for the compiler
	    if (!_bp) { _bp = _cache; }
	
	    var
	      parts = [],
	      match,
	      isexpr,
	      start,
	      pos,
	      re = _bp[6];
	
	    isexpr = start = re.lastIndex = 0;
	
	    while ((match = re.exec(str))) {
	
	      pos = match.index;
	
	      if (isexpr) {
	
	        if (match[2]) {
	          re.lastIndex = skipBraces(str, match[2], re.lastIndex);
	          continue
	        }
	        if (!match[3]) {
	          continue
	        }
	      }
	
	      if (!match[1]) {
	        unescapeStr(str.slice(start, pos));
	        start = re.lastIndex;
	        re = _bp[6 + (isexpr ^= 1)];
	        re.lastIndex = start;
	      }
	    }
	
	    if (str && start < str.length) {
	      unescapeStr(str.slice(start));
	    }
	
	    return parts
	
	    function unescapeStr (s) {
	      if (tmpl || isexpr) {
	        parts.push(s && s.replace(_bp[5], '$1'));
	      } else {
	        parts.push(s);
	      }
	    }
	
	    function skipBraces (s, ch, ix) {
	      var
	        match,
	        recch = FINDBRACES[ch];
	
	      recch.lastIndex = ix;
	      ix = 1;
	      while ((match = recch.exec(s))) {
	        if (match[1] &&
	          !(match[1] === ch ? ++ix : --ix)) { break }
	      }
	      return ix ? s.length : recch.lastIndex
	    }
	  };
	
	  _brackets.hasExpr = function hasExpr (str) {
	    return _cache[4].test(str)
	  };
	
	  _brackets.loopKeys = function loopKeys (expr) {
	    var m = expr.match(_cache[9]);
	
	    return m
	      ? { key: m[1], pos: m[2], val: _cache[0] + m[3].trim() + _cache[1] }
	      : { val: expr.trim() }
	  };
	
	  _brackets.array = function array (pair) {
	    return pair ? _create(pair) : _cache
	  };
	
	  function _reset (pair) {
	    if ((pair || (pair = DEFAULT)) !== _cache[8]) {
	      _cache = _create(pair);
	      _regex = pair === DEFAULT ? _loopback : _rewrite;
	      _cache[9] = _regex(_pairs[9]);
	    }
	    cachedBrackets = pair;
	  }
	
	  function _setSettings (o) {
	    var b;
	
	    o = o || {};
	    b = o.brackets;
	    Object.defineProperty(o, 'brackets', {
	      set: _reset,
	      get: function () { return cachedBrackets },
	      enumerable: true
	    });
	    _settings = o;
	    _reset(b);
	  }
	
	  Object.defineProperty(_brackets, 'settings', {
	    set: _setSettings,
	    get: function () { return _settings }
	  });
	
	  /* istanbul ignore next: in the browser riot is always in the scope */
	  _brackets.settings = typeof riot !== 'undefined' && riot.settings || {};
	  _brackets.set = _reset;
	
	  _brackets.R_STRINGS = R_STRINGS;
	  _brackets.R_MLCOMMS = R_MLCOMMS;
	  _brackets.S_QBLOCKS = S_QBLOCKS;
	
	  return _brackets
	
	})();
	
	/**
	 * @module tmpl
	 *
	 * tmpl          - Root function, returns the template value, render with data
	 * tmpl.hasExpr  - Test the existence of a expression inside a string
	 * tmpl.loopKeys - Get the keys for an 'each' loop (used by `_each`)
	 */
	
	/* istanbul ignore next */
	var tmpl = (function () {
	
	  var _cache = {};
	
	  function _tmpl (str, data) {
	    if (!str) { return str }
	
	    return (_cache[str] || (_cache[str] = _create(str))).call(data, _logErr)
	  }
	
	  _tmpl.hasExpr = brackets.hasExpr;
	
	  _tmpl.loopKeys = brackets.loopKeys;
	
	  // istanbul ignore next
	  _tmpl.clearCache = function () { _cache = {}; };
	
	  _tmpl.errorHandler = null;
	
	  function _logErr (err, ctx) {
	
	    err.riotData = {
	      tagName: ctx && ctx.__ && ctx.__.tagName,
	      _riot_id: ctx && ctx._riot_id  //eslint-disable-line camelcase
	    };
	
	    if (_tmpl.errorHandler) { _tmpl.errorHandler(err); }
	    else if (
	      typeof console !== 'undefined' &&
	      typeof console.error === 'function'
	    ) {
	      if (err.riotData.tagName) {
	        console.error('Riot template error thrown in the <%s> tag', err.riotData.tagName);
	      }
	      console.error(err);
	    }
	  }
	
	  function _create (str) {
	    var expr = _getTmpl(str);
	
	    if (expr.slice(0, 11) !== 'try{return ') { expr = 'return ' + expr; }
	
	    return new Function('E', expr + ';')    // eslint-disable-line no-new-func
	  }
	
	  var
	    CH_IDEXPR = String.fromCharCode(0x2057),
	    RE_CSNAME = /^(?:(-?[_A-Za-z\xA0-\xFF][-\w\xA0-\xFF]*)|\u2057(\d+)~):/,
	    RE_QBLOCK = RegExp(brackets.S_QBLOCKS, 'g'),
	    RE_DQUOTE = /\u2057/g,
	    RE_QBMARK = /\u2057(\d+)~/g;
	
	  function _getTmpl (str) {
	    var
	      qstr = [],
	      expr,
	      parts = brackets.split(str.replace(RE_DQUOTE, '"'), 1);
	
	    if (parts.length > 2 || parts[0]) {
	      var i, j, list = [];
	
	      for (i = j = 0; i < parts.length; ++i) {
	
	        expr = parts[i];
	
	        if (expr && (expr = i & 1
	
	            ? _parseExpr(expr, 1, qstr)
	
	            : '"' + expr
	                .replace(/\\/g, '\\\\')
	                .replace(/\r\n?|\n/g, '\\n')
	                .replace(/"/g, '\\"') +
	              '"'
	
	          )) { list[j++] = expr; }
	
	      }
	
	      expr = j < 2 ? list[0]
	           : '[' + list.join(',') + '].join("")';
	
	    } else {
	
	      expr = _parseExpr(parts[1], 0, qstr);
	    }
	
	    if (qstr[0]) {
	      expr = expr.replace(RE_QBMARK, function (_, pos) {
	        return qstr[pos]
	          .replace(/\r/g, '\\r')
	          .replace(/\n/g, '\\n')
	      });
	    }
	    return expr
	  }
	
	  var
	    RE_BREND = {
	      '(': /[()]/g,
	      '[': /[[\]]/g,
	      '{': /[{}]/g
	    };
	
	  function _parseExpr (expr, asText, qstr) {
	
	    expr = expr
	          .replace(RE_QBLOCK, function (s, div) {
	            return s.length > 2 && !div ? CH_IDEXPR + (qstr.push(s) - 1) + '~' : s
	          })
	          .replace(/\s+/g, ' ').trim()
	          .replace(/\ ?([[\({},?\.:])\ ?/g, '$1');
	
	    if (expr) {
	      var
	        list = [],
	        cnt = 0,
	        match;
	
	      while (expr &&
	            (match = expr.match(RE_CSNAME)) &&
	            !match.index
	        ) {
	        var
	          key,
	          jsb,
	          re = /,|([[{(])|$/g;
	
	        expr = RegExp.rightContext;
	        key  = match[2] ? qstr[match[2]].slice(1, -1).trim().replace(/\s+/g, ' ') : match[1];
	
	        while (jsb = (match = re.exec(expr))[1]) { skipBraces(jsb, re); }
	
	        jsb  = expr.slice(0, match.index);
	        expr = RegExp.rightContext;
	
	        list[cnt++] = _wrapExpr(jsb, 1, key);
	      }
	
	      expr = !cnt ? _wrapExpr(expr, asText)
	           : cnt > 1 ? '[' + list.join(',') + '].join(" ").trim()' : list[0];
	    }
	    return expr
	
	    function skipBraces (ch, re) {
	      var
	        mm,
	        lv = 1,
	        ir = RE_BREND[ch];
	
	      ir.lastIndex = re.lastIndex;
	      while (mm = ir.exec(expr)) {
	        if (mm[0] === ch) { ++lv; }
	        else if (!--lv) { break }
	      }
	      re.lastIndex = lv ? expr.length : ir.lastIndex;
	    }
	  }
	
	  // istanbul ignore next: not both
	  var // eslint-disable-next-line max-len
	    JS_CONTEXT = '"in this?this:' + (typeof window !== 'object' ? 'global' : 'window') + ').',
	    JS_VARNAME = /[,{][\$\w]+(?=:)|(^ *|[^$\w\.{])(?!(?:typeof|true|false|null|undefined|in|instanceof|is(?:Finite|NaN)|void|NaN|new|Date|RegExp|Math)(?![$\w]))([$_A-Za-z][$\w]*)/g,
	    JS_NOPROPS = /^(?=(\.[$\w]+))\1(?:[^.[(]|$)/;
	
	  function _wrapExpr (expr, asText, key) {
	    var tb;
	
	    expr = expr.replace(JS_VARNAME, function (match, p, mvar, pos, s) {
	      if (mvar) {
	        pos = tb ? 0 : pos + match.length;
	
	        if (mvar !== 'this' && mvar !== 'global' && mvar !== 'window') {
	          match = p + '("' + mvar + JS_CONTEXT + mvar;
	          if (pos) { tb = (s = s[pos]) === '.' || s === '(' || s === '['; }
	        } else if (pos) {
	          tb = !JS_NOPROPS.test(s.slice(pos));
	        }
	      }
	      return match
	    });
	
	    if (tb) {
	      expr = 'try{return ' + expr + '}catch(e){E(e,this)}';
	    }
	
	    if (key) {
	
	      expr = (tb
	          ? 'function(){' + expr + '}.call(this)' : '(' + expr + ')'
	        ) + '?"' + key + '":""';
	
	    } else if (asText) {
	
	      expr = 'function(v){' + (tb
	          ? expr.replace('return ', 'v=') : 'v=(' + expr + ')'
	        ) + ';return v||v===0?v:""}.call(this)';
	    }
	
	    return expr
	  }
	
	  _tmpl.version = brackets.version = 'v3.0.3';
	
	  return _tmpl
	
	})();
	
	/* istanbul ignore next */
	var observable$1 = function(el) {
	
	  /**
	   * Extend the original object or create a new empty one
	   * @type { Object }
	   */
	
	  el = el || {};
	
	  /**
	   * Private variables
	   */
	  var callbacks = {},
	    slice = Array.prototype.slice;
	
	  /**
	   * Public Api
	   */
	
	  // extend the el object adding the observable methods
	  Object.defineProperties(el, {
	    /**
	     * Listen to the given `event` ands
	     * execute the `callback` each time an event is triggered.
	     * @param  { String } event - event id
	     * @param  { Function } fn - callback function
	     * @returns { Object } el
	     */
	    on: {
	      value: function(event, fn) {
	        if (typeof fn == 'function')
	          { (callbacks[event] = callbacks[event] || []).push(fn); }
	        return el
	      },
	      enumerable: false,
	      writable: false,
	      configurable: false
	    },
	
	    /**
	     * Removes the given `event` listeners
	     * @param   { String } event - event id
	     * @param   { Function } fn - callback function
	     * @returns { Object } el
	     */
	    off: {
	      value: function(event, fn) {
	        if (event == '*' && !fn) { callbacks = {}; }
	        else {
	          if (fn) {
	            var arr = callbacks[event];
	            for (var i = 0, cb; cb = arr && arr[i]; ++i) {
	              if (cb == fn) { arr.splice(i--, 1); }
	            }
	          } else { delete callbacks[event]; }
	        }
	        return el
	      },
	      enumerable: false,
	      writable: false,
	      configurable: false
	    },
	
	    /**
	     * Listen to the given `event` and
	     * execute the `callback` at most once
	     * @param   { String } event - event id
	     * @param   { Function } fn - callback function
	     * @returns { Object } el
	     */
	    one: {
	      value: function(event, fn) {
	        function on() {
	          el.off(event, on);
	          fn.apply(el, arguments);
	        }
	        return el.on(event, on)
	      },
	      enumerable: false,
	      writable: false,
	      configurable: false
	    },
	
	    /**
	     * Execute all callback functions that listen to
	     * the given `event`
	     * @param   { String } event - event id
	     * @returns { Object } el
	     */
	    trigger: {
	      value: function(event) {
	        var arguments$1 = arguments;
	
	
	        // getting the arguments
	        var arglen = arguments.length - 1,
	          args = new Array(arglen),
	          fns,
	          fn,
	          i;
	
	        for (i = 0; i < arglen; i++) {
	          args[i] = arguments$1[i + 1]; // skip first argument
	        }
	
	        fns = slice.call(callbacks[event] || [], 0);
	
	        for (i = 0; fn = fns[i]; ++i) {
	          fn.apply(el, args);
	        }
	
	        if (callbacks['*'] && event != '*')
	          { el.trigger.apply(el, ['*', event].concat(args)); }
	
	        return el
	      },
	      enumerable: false,
	      writable: false,
	      configurable: false
	    }
	  });
	
	  return el
	
	};
	
	/**
	 * Specialized function for looping an array-like collection with `each={}`
	 * @param   { Array } list - collection of items
	 * @param   {Function} fn - callback function
	 * @returns { Array } the array looped
	 */
	function each(list, fn) {
	  var len = list ? list.length : 0;
	  var i = 0;
	  for (; i < len; ++i) {
	    fn(list[i], i);
	  }
	  return list
	}
	
	/**
	 * Check whether an array contains an item
	 * @param   { Array } array - target array
	 * @param   { * } item - item to test
	 * @returns { Boolean } -
	 */
	function contains(array, item) {
	  return array.indexOf(item) !== -1
	}
	
	/**
	 * Convert a string containing dashes to camel case
	 * @param   { String } str - input string
	 * @returns { String } my-string -> myString
	 */
	function toCamel(str) {
	  return str.replace(/-(\w)/g, function (_, c) { return c.toUpperCase(); })
	}
	
	/**
	 * Faster String startsWith alternative
	 * @param   { String } str - source string
	 * @param   { String } value - test string
	 * @returns { Boolean } -
	 */
	function startsWith(str, value) {
	  return str.slice(0, value.length) === value
	}
	
	/**
	 * Helper function to set an immutable property
	 * @param   { Object } el - object where the new property will be set
	 * @param   { String } key - object key where the new property will be stored
	 * @param   { * } value - value of the new property
	 * @param   { Object } options - set the propery overriding the default options
	 * @returns { Object } - the initial object
	 */
	function defineProperty(el, key, value, options) {
	  Object.defineProperty(el, key, extend({
	    value: value,
	    enumerable: false,
	    writable: false,
	    configurable: true
	  }, options));
	  return el
	}
	
	/**
	 * Extend any object with other properties
	 * @param   { Object } src - source object
	 * @returns { Object } the resulting extended object
	 *
	 * var obj = { foo: 'baz' }
	 * extend(obj, {bar: 'bar', foo: 'bar'})
	 * console.log(obj) => {bar: 'bar', foo: 'bar'}
	 *
	 */
	function extend(src) {
	  var obj, args = arguments;
	  for (var i = 1; i < args.length; ++i) {
	    if (obj = args[i]) {
	      for (var key in obj) {
	        // check if this property of the source object could be overridden
	        if (isWritable(src, key))
	          { src[key] = obj[key]; }
	      }
	    }
	  }
	  return src
	}
	
	var misc = Object.freeze({
		each: each,
		contains: contains,
		toCamel: toCamel,
		startsWith: startsWith,
		defineProperty: defineProperty,
		extend: extend
	});
	
	var settings$1 = extend(Object.create(brackets.settings), {
	  skipAnonymousTags: true
	});
	
	/**
	 * Trigger DOM events
	 * @param   { HTMLElement } dom - dom element target of the event
	 * @param   { Function } handler - user function
	 * @param   { Object } e - event object
	 */
	function handleEvent(dom, handler, e) {
	  var ptag = this.__.parent,
	    item = this.__.item;
	
	  if (!item)
	    { while (ptag && !item) {
	      item = ptag.__.item;
	      ptag = ptag.__.parent;
	    } }
	
	  // override the event properties
	  /* istanbul ignore next */
	  if (isWritable(e, 'currentTarget')) { e.currentTarget = dom; }
	  /* istanbul ignore next */
	  if (isWritable(e, 'target')) { e.target = e.srcElement; }
	  /* istanbul ignore next */
	  if (isWritable(e, 'which')) { e.which = e.charCode || e.keyCode; }
	
	  e.item = item;
	
	  handler.call(this, e);
	
	  if (!e.preventUpdate) {
	    var p = getImmediateCustomParentTag(this);
	    // fixes #2083
	    if (p.isMounted) { p.update(); }
	  }
	}
	
	/**
	 * Attach an event to a DOM node
	 * @param { String } name - event name
	 * @param { Function } handler - event callback
	 * @param { Object } dom - dom node
	 * @param { Tag } tag - tag instance
	 */
	function setEventHandler(name, handler, dom, tag) {
	  var eventName,
	    cb = handleEvent.bind(tag, dom, handler);
	
	  // avoid to bind twice the same event
	  // possible fix for #2332
	  dom[name] = null;
	
	  // normalize event name
	  eventName = name.replace(RE_EVENTS_PREFIX, '');
	
	  // cache the listener into the listeners array
	  if (!contains(tag.__.listeners, dom)) { tag.__.listeners.push(dom); }
	  if (!dom[RIOT_EVENTS_KEY]) { dom[RIOT_EVENTS_KEY] = {}; }
	  if (dom[RIOT_EVENTS_KEY][name]) { dom.removeEventListener(eventName, dom[RIOT_EVENTS_KEY][name]); }
	
	  dom[RIOT_EVENTS_KEY][name] = cb;
	  dom.addEventListener(eventName, cb, false);
	}
	
	/**
	 * Update dynamically created data-is tags with changing expressions
	 * @param { Object } expr - expression tag and expression info
	 * @param { Tag }    parent - parent for tag creation
	 * @param { String } tagName - tag implementation we want to use
	 */
	function updateDataIs(expr, parent, tagName) {
	  var conf, isVirtual, head, ref;
	
	  if (expr.tag && expr.tagName === tagName) {
	    expr.tag.update();
	    return
	  }
	
	  isVirtual = expr.dom.tagName === 'VIRTUAL';
	  // sync _parent to accommodate changing tagnames
	  if (expr.tag) {
	    // need placeholder before unmount
	    if(isVirtual) {
	      head = expr.tag.__.head;
	      ref = createDOMPlaceholder();
	      head.parentNode.insertBefore(ref, head);
	    }
	
	    expr.tag.unmount(true);
	  }
	
	  if (!isString(tagName)) { return }
	
	  expr.impl = __TAG_IMPL[tagName];
	  conf = {root: expr.dom, parent: parent, hasImpl: true, tagName: tagName};
	  expr.tag = initChildTag(expr.impl, conf, expr.dom.innerHTML, parent);
	  each(expr.attrs, function (a) { return setAttr(expr.tag.root, a.name, a.value); });
	  expr.tagName = tagName;
	  expr.tag.mount();
	  if (isVirtual)
	    { makeReplaceVirtual(expr.tag, ref || expr.tag.root); } // root exist first time, after use placeholder
	
	  // parent is the placeholder tag, not the dynamic tag so clean up
	  parent.__.onUnmount = function() {
	    var delName = expr.tag.opts.dataIs,
	      tags = expr.tag.parent.tags,
	      _tags = expr.tag.__.parent.tags;
	    arrayishRemove(tags, delName, expr.tag);
	    arrayishRemove(_tags, delName, expr.tag);
	    expr.tag.unmount();
	  };
	}
	
	/**
	 * Nomalize any attribute removing the "riot-" prefix
	 * @param   { String } attrName - original attribute name
	 * @returns { String } valid html attribute name
	 */
	function normalizeAttrName(attrName) {
	  if (!attrName) { return null }
	  attrName = attrName.replace(ATTRS_PREFIX, '');
	  if (CASE_SENSITIVE_ATTRIBUTES[attrName]) { attrName = CASE_SENSITIVE_ATTRIBUTES[attrName]; }
	  return attrName
	}
	
	/**
	 * Update on single tag expression
	 * @this Tag
	 * @param { Object } expr - expression logic
	 * @returns { undefined }
	 */
	function updateExpression(expr) {
	  if (this.root && getAttr(this.root,'virtualized')) { return }
	
	  var dom = expr.dom,
	    // remove the riot- prefix
	    attrName = normalizeAttrName(expr.attr),
	    isToggle = contains([SHOW_DIRECTIVE, HIDE_DIRECTIVE], attrName),
	    isVirtual = expr.root && expr.root.tagName === 'VIRTUAL',
	    parent = dom && (expr.parent || dom.parentNode),
	    // detect the style attributes
	    isStyleAttr = attrName === 'style',
	    isClassAttr = attrName === 'class',
	    hasValue,
	    isObj,
	    value;
	
	  // if it's a tag we could totally skip the rest
	  if (expr._riot_id) {
	    if (expr.isMounted) {
	      expr.update();
	    // if it hasn't been mounted yet, do that now.
	    } else {
	      expr.mount();
	      if (isVirtual) {
	        makeReplaceVirtual(expr, expr.root);
	      }
	    }
	    return
	  }
	  // if this expression has the update method it means it can handle the DOM changes by itself
	  if (expr.update) { return expr.update() }
	
	  // ...it seems to be a simple expression so we try to calculat its value
	  value = tmpl(expr.expr, isToggle ? extend(Object.create(this.parent), this) : this);
	  hasValue = !isBlank(value);
	  isObj = isObject(value);
	
	  // convert the style/class objects to strings
	  if (isObj) {
	    isObj = !isClassAttr && !isStyleAttr;
	    if (isClassAttr) {
	      value = tmpl(JSON.stringify(value), this);
	    } else if (isStyleAttr) {
	      value = styleObjectToString(value);
	    }
	  }
	
	  // remove original attribute
	  if (expr.attr && (!expr.isAttrRemoved || !hasValue)) {
	    remAttr(dom, expr.attr);
	    expr.isAttrRemoved = true;
	  }
	
	  // for the boolean attributes we don't need the value
	  // we can convert it to checked=true to checked=checked
	  if (expr.bool) { value = value ? attrName : false; }
	  if (expr.isRtag) { return updateDataIs(expr, this, value) }
	  if (expr.wasParsedOnce && expr.value === value) { return }
	
	  // update the expression value
	  expr.value = value;
	  expr.wasParsedOnce = true;
	
	  // if the value is an object we can not do much more with it
	  if (isObj && !isToggle) { return }
	  // avoid to render undefined/null values
	  if (isBlank(value)) { value = ''; }
	
	  // textarea and text nodes have no attribute name
	  if (!attrName) {
	    // about #815 w/o replace: the browser converts the value to a string,
	    // the comparison by "==" does too, but not in the server
	    value += '';
	    // test for parent avoids error with invalid assignment to nodeValue
	    if (parent) {
	      // cache the parent node because somehow it will become null on IE
	      // on the next iteration
	      expr.parent = parent;
	      if (parent.tagName === 'TEXTAREA') {
	        parent.value = value;                    // #1113
	        if (!IE_VERSION) { dom.nodeValue = value; }  // #1625 IE throws here, nodeValue
	      }                                         // will be available on 'updated'
	      else { dom.nodeValue = value; }
	    }
	    return
	  }
	
	
	  // event handler
	  if (isFunction(value)) {
	    setEventHandler(attrName, value, dom, this);
	  // show / hide
	  } else if (isToggle) {
	    toggleVisibility(dom, attrName === HIDE_DIRECTIVE ? !value : value);
	  // handle attributes
	  } else {
	    if (expr.bool) {
	      dom[attrName] = value;
	    }
	
	    if (attrName === 'value' && dom.value !== value) {
	      dom.value = value;
	    }
	
	    if (hasValue && value !== false) {
	      setAttr(dom, attrName, value);
	    }
	
	    // make sure that in case of style changes
	    // the element stays hidden
	    if (isStyleAttr && dom.hidden) { toggleVisibility(dom, false); }
	  }
	}
	
	/**
	 * Update all the expressions in a Tag instance
	 * @this Tag
	 * @param { Array } expressions - expression that must be re evaluated
	 */
	function updateAllExpressions(expressions) {
	  each(expressions, updateExpression.bind(this));
	}
	
	var IfExpr = {
	  init: function init(dom, tag, expr) {
	    remAttr(dom, CONDITIONAL_DIRECTIVE);
	    this.tag = tag;
	    this.expr = expr;
	    this.stub = document.createTextNode('');
	    this.pristine = dom;
	
	    var p = dom.parentNode;
	    p.insertBefore(this.stub, dom);
	    p.removeChild(dom);
	
	    return this
	  },
	  update: function update() {
	    this.value = tmpl(this.expr, this.tag);
	
	    if (this.value && !this.current) { // insert
	      this.current = this.pristine.cloneNode(true);
	      this.stub.parentNode.insertBefore(this.current, this.stub);
	      this.expressions = [];
	      parseExpressions.apply(this.tag, [this.current, this.expressions, true]);
	    } else if (!this.value && this.current) { // remove
	      unmountAll(this.expressions);
	      if (this.current._tag) {
	        this.current._tag.unmount();
	      } else if (this.current.parentNode) {
	        this.current.parentNode.removeChild(this.current);
	      }
	      this.current = null;
	      this.expressions = [];
	    }
	
	    if (this.value) { updateAllExpressions.call(this.tag, this.expressions); }
	  },
	  unmount: function unmount() {
	    unmountAll(this.expressions || []);
	    delete this.pristine;
	    delete this.parentNode;
	    delete this.stub;
	  }
	};
	
	var RefExpr = {
	  init: function init(dom, parent, attrName, attrValue) {
	    this.dom = dom;
	    this.attr = attrName;
	    this.rawValue = attrValue;
	    this.parent = parent;
	    this.hasExp = tmpl.hasExpr(attrValue);
	    return this
	  },
	  update: function update() {
	    var old = this.value;
	    var customParent = this.parent && getImmediateCustomParentTag(this.parent);
	    // if the referenced element is a custom tag, then we set the tag itself, rather than DOM
	    var tagOrDom = this.tag || this.dom;
	
	    this.value = this.hasExp ? tmpl(this.rawValue, this.parent) : this.rawValue;
	
	    // the name changed, so we need to remove it from the old key (if present)
	    if (!isBlank(old) && customParent) { arrayishRemove(customParent.refs, old, tagOrDom); }
	    if (!isBlank(this.value)) {
	      // add it to the refs of parent tag (this behavior was changed >=3.0)
	      if (customParent) { arrayishAdd(
	        customParent.refs,
	        this.value,
	        tagOrDom,
	        // use an array if it's a looped node and the ref is not an expression
	        null,
	        this.parent.__.index
	      ); }
	    }
	
	    // if it's the first time we pass here let's remove the ref attribute
	    // #2329
	    if (!old) { remAttr(this.dom, this.attr); }
	  },
	  unmount: function unmount() {
	    var tagOrDom = this.tag || this.dom;
	    var customParent = this.parent && getImmediateCustomParentTag(this.parent);
	    if (!isBlank(this.value) && customParent)
	      { arrayishRemove(customParent.refs, this.value, tagOrDom); }
	    delete this.dom;
	    delete this.parent;
	  }
	};
	
	/**
	 * Convert the item looped into an object used to extend the child tag properties
	 * @param   { Object } expr - object containing the keys used to extend the children tags
	 * @param   { * } key - value to assign to the new object returned
	 * @param   { * } val - value containing the position of the item in the array
	 * @param   { Object } base - prototype object for the new item
	 * @returns { Object } - new object containing the values of the original item
	 *
	 * The variables 'key' and 'val' are arbitrary.
	 * They depend on the collection type looped (Array, Object)
	 * and on the expression used on the each tag
	 *
	 */
	function mkitem(expr, key, val, base) {
	  var item = base ? Object.create(base) : {};
	  item[expr.key] = key;
	  if (expr.pos) { item[expr.pos] = val; }
	  return item
	}
	
	/**
	 * Unmount the redundant tags
	 * @param   { Array } items - array containing the current items to loop
	 * @param   { Array } tags - array containing all the children tags
	 */
	function unmountRedundant(items, tags) {
	  var i = tags.length,
	    j = items.length;
	
	  while (i > j) {
	    i--;
	    remove.apply(tags[i], [tags, i]);
	  }
	}
	
	
	/**
	 * Remove a child tag
	 * @this Tag
	 * @param   { Array } tags - tags collection
	 * @param   { Number } i - index of the tag to remove
	 */
	function remove(tags, i) {
	  tags.splice(i, 1);
	  this.unmount();
	  arrayishRemove(this.parent, this, this.__.tagName, true);
	}
	
	/**
	 * Move the nested custom tags in non custom loop tags
	 * @this Tag
	 * @param   { Number } i - current position of the loop tag
	 */
	function moveNestedTags(i) {
	  var this$1 = this;
	
	  each(Object.keys(this.tags), function (tagName) {
	    moveChildTag.apply(this$1.tags[tagName], [tagName, i]);
	  });
	}
	
	/**
	 * Move a child tag
	 * @this Tag
	 * @param   { HTMLElement } root - dom node containing all the loop children
	 * @param   { Tag } nextTag - instance of the next tag preceding the one we want to move
	 * @param   { Boolean } isVirtual - is it a virtual tag?
	 */
	function move(root, nextTag, isVirtual) {
	  if (isVirtual)
	    { moveVirtual.apply(this, [root, nextTag]); }
	  else
	    { safeInsert(root, this.root, nextTag.root); }
	}
	
	/**
	 * Insert and mount a child tag
	 * @this Tag
	 * @param   { HTMLElement } root - dom node containing all the loop children
	 * @param   { Tag } nextTag - instance of the next tag preceding the one we want to insert
	 * @param   { Boolean } isVirtual - is it a virtual tag?
	 */
	function insert(root, nextTag, isVirtual) {
	  if (isVirtual)
	    { makeVirtual.apply(this, [root, nextTag]); }
	  else
	    { safeInsert(root, this.root, nextTag.root); }
	}
	
	/**
	 * Append a new tag into the DOM
	 * @this Tag
	 * @param   { HTMLElement } root - dom node containing all the loop children
	 * @param   { Boolean } isVirtual - is it a virtual tag?
	 */
	function append(root, isVirtual) {
	  if (isVirtual)
	    { makeVirtual.call(this, root); }
	  else
	    { root.appendChild(this.root); }
	}
	
	/**
	 * Manage tags having the 'each'
	 * @param   { HTMLElement } dom - DOM node we need to loop
	 * @param   { Tag } parent - parent tag instance where the dom node is contained
	 * @param   { String } expr - string contained in the 'each' attribute
	 * @returns { Object } expression object for this each loop
	 */
	function _each(dom, parent, expr) {
	
	  // remove the each property from the original tag
	  remAttr(dom, LOOP_DIRECTIVE);
	
	  var mustReorder = typeof getAttr(dom, LOOP_NO_REORDER_DIRECTIVE) !== T_STRING || remAttr(dom, LOOP_NO_REORDER_DIRECTIVE),
	    tagName = getTagName(dom),
	    impl = __TAG_IMPL[tagName],
	    parentNode = dom.parentNode,
	    placeholder = createDOMPlaceholder(),
	    child = getTag(dom),
	    ifExpr = getAttr(dom, CONDITIONAL_DIRECTIVE),
	    tags = [],
	    oldItems = [],
	    hasKeys,
	    isLoop = true,
	    isAnonymous = !__TAG_IMPL[tagName],
	    isVirtual = dom.tagName === 'VIRTUAL';
	
	  // parse the each expression
	  expr = tmpl.loopKeys(expr);
	  expr.isLoop = true;
	
	  if (ifExpr) { remAttr(dom, CONDITIONAL_DIRECTIVE); }
	
	  // insert a marked where the loop tags will be injected
	  parentNode.insertBefore(placeholder, dom);
	  parentNode.removeChild(dom);
	
	  expr.update = function updateEach() {
	    // get the new items collection
	    expr.value = tmpl(expr.val, parent);
	
	    var frag = createFrag(),
	      items = expr.value,
	      isObject$$1 = !isArray(items) && !isString(items),
	      root = placeholder.parentNode;
	
	    // if this DOM was removed the update here is useless
	    // this condition fixes also a weird async issue on IE in our unit test
	    if (!root) { return }
	
	    // object loop. any changes cause full redraw
	    if (isObject$$1) {
	      hasKeys = items || false;
	      items = hasKeys ?
	        Object.keys(items).map(function (key) {
	          return mkitem(expr, items[key], key)
	        }) : [];
	    } else {
	      hasKeys = false;
	    }
	
	    if (ifExpr) {
	      items = items.filter(function(item, i) {
	        if (expr.key && !isObject$$1)
	          { return !!tmpl(ifExpr, mkitem(expr, item, i, parent)) }
	
	        return !!tmpl(ifExpr, extend(Object.create(parent), item))
	      });
	    }
	
	    // loop all the new items
	    each(items, function(item, i) {
	      // reorder only if the items are objects
	      var
	        doReorder = mustReorder && typeof item === T_OBJECT && !hasKeys,
	        oldPos = oldItems.indexOf(item),
	        isNew = oldPos === -1,
	        pos = !isNew && doReorder ? oldPos : i,
	        // does a tag exist in this position?
	        tag = tags[pos],
	        mustAppend = i >= oldItems.length,
	        mustCreate =  doReorder && isNew || !doReorder && !tag;
	
	      item = !hasKeys && expr.key ? mkitem(expr, item, i) : item;
	
	      // new tag
	      if (mustCreate) {
	        tag = new Tag$1(impl, {
	          parent: parent,
	          isLoop: isLoop,
	          isAnonymous: isAnonymous,
	          tagName: tagName,
	          root: dom.cloneNode(isAnonymous),
	          item: item,
	          index: i,
	        }, dom.innerHTML);
	
	        // mount the tag
	        tag.mount();
	
	        if (mustAppend)
	          { append.apply(tag, [frag || root, isVirtual]); }
	        else
	          { insert.apply(tag, [root, tags[i], isVirtual]); }
	
	        if (!mustAppend) { oldItems.splice(i, 0, item); }
	        tags.splice(i, 0, tag);
	        if (child) { arrayishAdd(parent.tags, tagName, tag, true); }
	      } else if (pos !== i && doReorder) {
	        // move
	        if (contains(items, oldItems[pos])) {
	          move.apply(tag, [root, tags[i], isVirtual]);
	          // move the old tag instance
	          tags.splice(i, 0, tags.splice(pos, 1)[0]);
	          // move the old item
	          oldItems.splice(i, 0, oldItems.splice(pos, 1)[0]);
	        }
	
	        // update the position attribute if it exists
	        if (expr.pos) { tag[expr.pos] = i; }
	
	        // if the loop tags are not custom
	        // we need to move all their custom tags into the right position
	        if (!child && tag.tags) { moveNestedTags.call(tag, i); }
	      }
	
	      // cache the original item to use it in the events bound to this node
	      // and its children
	      tag.__.item = item;
	      tag.__.index = i;
	      tag.__.parent = parent;
	
	      if (!mustCreate) { tag.update(item); }
	    });
	
	    // remove the redundant tags
	    unmountRedundant(items, tags);
	
	    // clone the items array
	    oldItems = items.slice();
	
	    // this condition is weird u
	    root.insertBefore(frag, placeholder);
	  };
	
	  expr.unmount = function() {
	    each(tags, function(t) { t.unmount(); });
	  };
	
	  return expr
	}
	
	/**
	 * Walk the tag DOM to detect the expressions to evaluate
	 * @this Tag
	 * @param   { HTMLElement } root - root tag where we will start digging the expressions
	 * @param   { Array } expressions - empty array where the expressions will be added
	 * @param   { Boolean } mustIncludeRoot - flag to decide whether the root must be parsed as well
	 * @returns { Object } an object containing the root noode and the dom tree
	 */
	function parseExpressions(root, expressions, mustIncludeRoot) {
	  var this$1 = this;
	
	  var tree = {parent: {children: expressions}};
	
	  walkNodes(root, function (dom, ctx) {
	    var type = dom.nodeType, parent = ctx.parent, attr, expr, tagImpl;
	    if (!mustIncludeRoot && dom === root) { return {parent: parent} }
	
	    // text node
	    if (type === 3 && dom.parentNode.tagName !== 'STYLE' && tmpl.hasExpr(dom.nodeValue))
	      { parent.children.push({dom: dom, expr: dom.nodeValue}); }
	
	    if (type !== 1) { return ctx } // not an element
	
	    var isVirtual = dom.tagName === 'VIRTUAL';
	
	    // loop. each does it's own thing (for now)
	    if (attr = getAttr(dom, LOOP_DIRECTIVE)) {
	      if(isVirtual) { setAttr(dom, 'loopVirtual', true); } // ignore here, handled in _each
	      parent.children.push(_each(dom, this$1, attr));
	      return false
	    }
	
	    // if-attrs become the new parent. Any following expressions (either on the current
	    // element, or below it) become children of this expression.
	    if (attr = getAttr(dom, CONDITIONAL_DIRECTIVE)) {
	      parent.children.push(Object.create(IfExpr).init(dom, this$1, attr));
	      return false
	    }
	
	    if (expr = getAttr(dom, IS_DIRECTIVE)) {
	      if (tmpl.hasExpr(expr)) {
	        parent.children.push({isRtag: true, expr: expr, dom: dom, attrs: [].slice.call(dom.attributes)});
	        return false
	      }
	    }
	
	    // if this is a tag, stop traversing here.
	    // we ignore the root, since parseExpressions is called while we're mounting that root
	    tagImpl = getTag(dom);
	    if(isVirtual) {
	      if(getAttr(dom, 'virtualized')) {dom.parentElement.removeChild(dom); } // tag created, remove from dom
	      if(!tagImpl && !getAttr(dom, 'virtualized') && !getAttr(dom, 'loopVirtual'))  // ok to create virtual tag
	        { tagImpl = { tmpl: dom.outerHTML }; }
	    }
	
	    if (tagImpl && (dom !== root || mustIncludeRoot)) {
	      if(isVirtual && !getAttr(dom, IS_DIRECTIVE)) { // handled in update
	        // can not remove attribute like directives
	        // so flag for removal after creation to prevent maximum stack error
	        setAttr(dom, 'virtualized', true);
	
	        var tag = new Tag$1({ tmpl: dom.outerHTML },
	          {root: dom, parent: this$1},
	          dom.innerHTML);
	        parent.children.push(tag); // no return, anonymous tag, keep parsing
	      } else {
	        var conf = {root: dom, parent: this$1, hasImpl: true};
	        parent.children.push(initChildTag(tagImpl, conf, dom.innerHTML, this$1));
	        return false
	      }
	    }
	
	    // attribute expressions
	    parseAttributes.apply(this$1, [dom, dom.attributes, function(attr, expr) {
	      if (!expr) { return }
	      parent.children.push(expr);
	    }]);
	
	    // whatever the parent is, all child elements get the same parent.
	    // If this element had an if-attr, that's the parent for all child elements
	    return {parent: parent}
	  }, tree);
	}
	
	/**
	 * Calls `fn` for every attribute on an element. If that attr has an expression,
	 * it is also passed to fn.
	 * @this Tag
	 * @param   { HTMLElement } dom - dom node to parse
	 * @param   { Array } attrs - array of attributes
	 * @param   { Function } fn - callback to exec on any iteration
	 */
	function parseAttributes(dom, attrs, fn) {
	  var this$1 = this;
	
	  each(attrs, function (attr) {
	    var name = attr.name, bool = isBoolAttr(name), expr;
	
	    if (contains(REF_DIRECTIVES, name)) {
	      expr =  Object.create(RefExpr).init(dom, this$1, name, attr.value);
	    } else if (tmpl.hasExpr(attr.value)) {
	      expr = {dom: dom, expr: attr.value, attr: name, bool: bool};
	    }
	
	    fn(attr, expr);
	  });
	}
	
	/*
	  Includes hacks needed for the Internet Explorer version 9 and below
	  See: http://kangax.github.io/compat-table/es5/#ie8
	       http://codeplanet.io/dropping-ie8/
	*/
	
	var reHasYield  = /<yield\b/i;
	var reYieldAll  = /<yield\s*(?:\/>|>([\S\s]*?)<\/yield\s*>|>)/ig;
	var reYieldSrc  = /<yield\s+to=['"]([^'">]*)['"]\s*>([\S\s]*?)<\/yield\s*>/ig;
	var reYieldDest = /<yield\s+from=['"]?([-\w]+)['"]?\s*(?:\/>|>([\S\s]*?)<\/yield\s*>)/ig;
	var rootEls = { tr: 'tbody', th: 'tr', td: 'tr', col: 'colgroup' };
	var tblTags = IE_VERSION && IE_VERSION < 10 ? RE_SPECIAL_TAGS : RE_SPECIAL_TAGS_NO_OPTION;
	var GENERIC = 'div';
	
	
	/*
	  Creates the root element for table or select child elements:
	  tr/th/td/thead/tfoot/tbody/caption/col/colgroup/option/optgroup
	*/
	function specialTags(el, tmpl, tagName) {
	
	  var
	    select = tagName[0] === 'o',
	    parent = select ? 'select>' : 'table>';
	
	  // trim() is important here, this ensures we don't have artifacts,
	  // so we can check if we have only one element inside the parent
	  el.innerHTML = '<' + parent + tmpl.trim() + '</' + parent;
	  parent = el.firstChild;
	
	  // returns the immediate parent if tr/th/td/col is the only element, if not
	  // returns the whole tree, as this can include additional elements
	  /* istanbul ignore next */
	  if (select) {
	    parent.selectedIndex = -1;  // for IE9, compatible w/current riot behavior
	  } else {
	    // avoids insertion of cointainer inside container (ex: tbody inside tbody)
	    var tname = rootEls[tagName];
	    if (tname && parent.childElementCount === 1) { parent = $(tname, parent); }
	  }
	  return parent
	}
	
	/*
	  Replace the yield tag from any tag template with the innerHTML of the
	  original tag in the page
	*/
	function replaceYield(tmpl, html) {
	  // do nothing if no yield
	  if (!reHasYield.test(tmpl)) { return tmpl }
	
	  // be careful with #1343 - string on the source having `$1`
	  var src = {};
	
	  html = html && html.replace(reYieldSrc, function (_, ref, text) {
	    src[ref] = src[ref] || text;   // preserve first definition
	    return ''
	  }).trim();
	
	  return tmpl
	    .replace(reYieldDest, function (_, ref, def) {  // yield with from - to attrs
	      return src[ref] || def || ''
	    })
	    .replace(reYieldAll, function (_, def) {        // yield without any "from"
	      return html || def || ''
	    })
	}
	
	/**
	 * Creates a DOM element to wrap the given content. Normally an `DIV`, but can be
	 * also a `TABLE`, `SELECT`, `TBODY`, `TR`, or `COLGROUP` element.
	 *
	 * @param   { String } tmpl  - The template coming from the custom tag definition
	 * @param   { String } html - HTML content that comes from the DOM element where you
	 *           will mount the tag, mostly the original tag in the page
	 * @returns { HTMLElement } DOM element with _tmpl_ merged through `YIELD` with the _html_.
	 */
	function mkdom(tmpl, html) {
	  var match   = tmpl && tmpl.match(/^\s*<([-\w]+)/),
	    tagName = match && match[1].toLowerCase(),
	    el = mkEl(GENERIC);
	
	  // replace all the yield tags with the tag inner html
	  tmpl = replaceYield(tmpl, html);
	
	  /* istanbul ignore next */
	  if (tblTags.test(tagName))
	    { el = specialTags(el, tmpl, tagName); }
	  else
	    { setInnerHTML(el, tmpl); }
	
	  return el
	}
	
	/**
	 * Another way to create a riot tag a bit more es6 friendly
	 * @param { HTMLElement } el - tag DOM selector or DOM node/s
	 * @param { Object } opts - tag logic
	 * @returns { Tag } new riot tag instance
	 */
	function Tag$2(el, opts) {
	  // get the tag properties from the class constructor
	  var ref = this;
	  var name = ref.name;
	  var tmpl = ref.tmpl;
	  var css = ref.css;
	  var attrs = ref.attrs;
	  var onCreate = ref.onCreate;
	  // register a new tag and cache the class prototype
	  if (!__TAG_IMPL[name]) {
	    tag$1(name, tmpl, css, attrs, onCreate);
	    // cache the class constructor
	    __TAG_IMPL[name].class = this.constructor;
	  }
	
	  // mount the tag using the class instance
	  mountTo(el, name, opts, this);
	  // inject the component css
	  if (css) { styleManager.inject(); }
	
	  return this
	}
	
	/**
	 * Create a new riot tag implementation
	 * @param   { String }   name - name/id of the new riot tag
	 * @param   { String }   tmpl - tag template
	 * @param   { String }   css - custom tag css
	 * @param   { String }   attrs - root tag attributes
	 * @param   { Function } fn - user function
	 * @returns { String } name/id of the tag just created
	 */
	function tag$1(name, tmpl, css, attrs, fn) {
	  if (isFunction(attrs)) {
	    fn = attrs;
	
	    if (/^[\w\-]+\s?=/.test(css)) {
	      attrs = css;
	      css = '';
	    } else
	      { attrs = ''; }
	  }
	
	  if (css) {
	    if (isFunction(css))
	      { fn = css; }
	    else
	      { styleManager.add(css); }
	  }
	
	  name = name.toLowerCase();
	  __TAG_IMPL[name] = { name: name, tmpl: tmpl, attrs: attrs, fn: fn };
	
	  return name
	}
	
	/**
	 * Create a new riot tag implementation (for use by the compiler)
	 * @param   { String }   name - name/id of the new riot tag
	 * @param   { String }   tmpl - tag template
	 * @param   { String }   css - custom tag css
	 * @param   { String }   attrs - root tag attributes
	 * @param   { Function } fn - user function
	 * @returns { String } name/id of the tag just created
	 */
	function tag2$1(name, tmpl, css, attrs, fn) {
	  if (css) { styleManager.add(css, name); }
	
	  __TAG_IMPL[name] = { name: name, tmpl: tmpl, attrs: attrs, fn: fn };
	
	  return name
	}
	
	/**
	 * Mount a tag using a specific tag implementation
	 * @param   { * } selector - tag DOM selector or DOM node/s
	 * @param   { String } tagName - tag implementation name
	 * @param   { Object } opts - tag logic
	 * @returns { Array } new tags instances
	 */
	function mount$1(selector, tagName, opts) {
	  var tags = [];
	
	  function pushTagsTo(root) {
	    if (root.tagName) {
	      var riotTag = getAttr(root, IS_DIRECTIVE);
	
	      // have tagName? force riot-tag to be the same
	      if (tagName && riotTag !== tagName) {
	        riotTag = tagName;
	        setAttr(root, IS_DIRECTIVE, tagName);
	      }
	
	      var tag = mountTo(root, riotTag || root.tagName.toLowerCase(), opts);
	
	      if (tag)
	        { tags.push(tag); }
	    } else if (root.length)
	      { each(root, pushTagsTo); } // assume nodeList
	  }
	
	  // inject styles into DOM
	  styleManager.inject();
	
	  if (isObject(tagName)) {
	    opts = tagName;
	    tagName = 0;
	  }
	
	  var elem;
	  var allTags;
	
	  // crawl the DOM to find the tag
	  if (isString(selector)) {
	    selector = selector === '*' ?
	      // select all registered tags
	      // & tags found with the riot-tag attribute set
	      allTags = selectTags() :
	      // or just the ones named like the selector
	      selector + selectTags(selector.split(/, */));
	
	    // make sure to pass always a selector
	    // to the querySelectorAll function
	    elem = selector ? $$(selector) : [];
	  }
	  else
	    // probably you have passed already a tag or a NodeList
	    { elem = selector; }
	
	  // select all the registered and mount them inside their root elements
	  if (tagName === '*') {
	    // get all custom tags
	    tagName = allTags || selectTags();
	    // if the root els it's just a single tag
	    if (elem.tagName)
	      { elem = $$(tagName, elem); }
	    else {
	      // select all the children for all the different root elements
	      var nodeList = [];
	
	      each(elem, function (_el) { return nodeList.push($$(tagName, _el)); });
	
	      elem = nodeList;
	    }
	    // get rid of the tagName
	    tagName = 0;
	  }
	
	  pushTagsTo(elem);
	
	  return tags
	}
	
	// Create a mixin that could be globally shared across all the tags
	var mixins = {};
	var globals = mixins[GLOBAL_MIXIN] = {};
	var mixins_id = 0;
	
	/**
	 * Create/Return a mixin by its name
	 * @param   { String }  name - mixin name (global mixin if object)
	 * @param   { Object }  mix - mixin logic
	 * @param   { Boolean } g - is global?
	 * @returns { Object }  the mixin logic
	 */
	function mixin$1(name, mix, g) {
	  // Unnamed global
	  if (isObject(name)) {
	    mixin$1(("__unnamed_" + (mixins_id++)), name, true);
	    return
	  }
	
	  var store = g ? globals : mixins;
	
	  // Getter
	  if (!mix) {
	    if (isUndefined(store[name]))
	      { throw new Error('Unregistered mixin: ' + name) }
	
	    return store[name]
	  }
	
	  // Setter
	  store[name] = isFunction(mix) ?
	    extend(mix.prototype, store[name] || {}) && mix :
	    extend(store[name] || {}, mix);
	}
	
	/**
	 * Update all the tags instances created
	 * @returns { Array } all the tags instances
	 */
	function update$1() {
	  return each(__TAGS_CACHE, function (tag) { return tag.update(); })
	}
	
	function unregister$1(name) {
	  delete __TAG_IMPL[name];
	}
	
	var version$1 = 'v3.4.4';
	
	
	var core = Object.freeze({
		Tag: Tag$2,
		tag: tag$1,
		tag2: tag2$1,
		mount: mount$1,
		mixin: mixin$1,
		update: update$1,
		unregister: unregister$1,
		version: version$1
	});
	
	// counter to give a unique id to all the Tag instances
	var __uid = 0;
	
	/**
	 * We need to update opts for this tag. That requires updating the expressions
	 * in any attributes on the tag, and then copying the result onto opts.
	 * @this Tag
	 * @param   {Boolean} isLoop - is it a loop tag?
	 * @param   { Tag }  parent - parent tag node
	 * @param   { Boolean }  isAnonymous - is it a tag without any impl? (a tag not registered)
	 * @param   { Object }  opts - tag options
	 * @param   { Array }  instAttrs - tag attributes array
	 */
	function updateOpts(isLoop, parent, isAnonymous, opts, instAttrs) {
	  // isAnonymous `each` tags treat `dom` and `root` differently. In this case
	  // (and only this case) we don't need to do updateOpts, because the regular parse
	  // will update those attrs. Plus, isAnonymous tags don't need opts anyway
	  if (isLoop && isAnonymous) { return }
	
	  var ctx = !isAnonymous && isLoop ? this : parent || this;
	  each(instAttrs, function (attr) {
	    if (attr.expr) { updateAllExpressions.call(ctx, [attr.expr]); }
	    // normalize the attribute names
	    opts[toCamel(attr.name).replace(ATTRS_PREFIX, '')] = attr.expr ? attr.expr.value : attr.value;
	  });
	}
	
	
	/**
	 * Tag class
	 * @constructor
	 * @param { Object } impl - it contains the tag template, and logic
	 * @param { Object } conf - tag options
	 * @param { String } innerHTML - html that eventually we need to inject in the tag
	 */
	function Tag$1(impl, conf, innerHTML) {
	  if ( impl === void 0 ) impl = {};
	  if ( conf === void 0 ) conf = {};
	
	  var opts = extend({}, conf.opts),
	    parent = conf.parent,
	    isLoop = conf.isLoop,
	    isAnonymous = !!conf.isAnonymous,
	    skipAnonymous = settings$1.skipAnonymousTags && isAnonymous,
	    item = cleanUpData(conf.item),
	    index = conf.index, // available only for the looped nodes
	    instAttrs = [], // All attributes on the Tag when it's first parsed
	    implAttrs = [], // expressions on this type of Tag
	    expressions = [],
	    root = conf.root,
	    tagName = conf.tagName || getTagName(root),
	    isVirtual = tagName === 'virtual',
	    propsInSyncWithParent = [],
	    dom;
	
	  // make this tag observable
	  if (!skipAnonymous) { observable$1(this); }
	  // only call unmount if we have a valid __TAG_IMPL (has name property)
	  if (impl.name && root._tag) { root._tag.unmount(true); }
	
	  // not yet mounted
	  this.isMounted = false;
	
	  defineProperty(this, '__', {
	    isAnonymous: isAnonymous,
	    instAttrs: instAttrs,
	    innerHTML: innerHTML,
	    tagName: tagName,
	    index: index,
	    isLoop: isLoop,
	    // tags having event listeners
	    // it would be better to use weak maps here but we can not introduce breaking changes now
	    listeners: [],
	    // these vars will be needed only for the virtual tags
	    virts: [],
	    tail: null,
	    head: null,
	    parent: null,
	    item: null
	  });
	
	  // create a unique id to this tag
	  // it could be handy to use it also to improve the virtual dom rendering speed
	  defineProperty(this, '_riot_id', ++__uid); // base 1 allows test !t._riot_id
	  defineProperty(this, 'root', root);
	  extend(this, { opts: opts }, item);
	  // protect the "tags" and "refs" property from being overridden
	  defineProperty(this, 'parent', parent || null);
	  defineProperty(this, 'tags', {});
	  defineProperty(this, 'refs', {});
	
	  dom = isLoop && isAnonymous ? root : mkdom(impl.tmpl, innerHTML, isLoop);
	
	  /**
	   * Update the tag expressions and options
	   * @param   { * }  data - data we want to use to extend the tag properties
	   * @returns { Tag } the current tag instance
	   */
	  defineProperty(this, 'update', function tagUpdate(data) {
	    var nextOpts = {},
	      canTrigger = this.isMounted && !skipAnonymous;
	
	    // make sure the data passed will not override
	    // the component core methods
	    data = cleanUpData(data);
	    extend(this, data);
	    updateOpts.apply(this, [isLoop, parent, isAnonymous, nextOpts, instAttrs]);
	
	    if (canTrigger && this.isMounted && isFunction(this.shouldUpdate) && !this.shouldUpdate(data, nextOpts)) {
	      return this
	    }
	
	    // inherit properties from the parent, but only for isAnonymous tags
	    if (isLoop && isAnonymous) { inheritFrom.apply(this, [this.parent, propsInSyncWithParent]); }
	    extend(opts, nextOpts);
	    if (canTrigger) { this.trigger('update', data); }
	    updateAllExpressions.call(this, expressions);
	    if (canTrigger) { this.trigger('updated'); }
	
	    return this
	
	  }.bind(this));
	
	  /**
	   * Add a mixin to this tag
	   * @returns { Tag } the current tag instance
	   */
	  defineProperty(this, 'mixin', function tagMixin() {
	    var this$1 = this;
	
	    each(arguments, function (mix) {
	      var instance, obj;
	      var props = [];
	
	      // properties blacklisted and will not be bound to the tag instance
	      var propsBlacklist = ['init', '__proto__'];
	
	      mix = isString(mix) ? mixin$1(mix) : mix;
	
	      // check if the mixin is a function
	      if (isFunction(mix)) {
	        // create the new mixin instance
	        instance = new mix();
	      } else { instance = mix; }
	
	      var proto = Object.getPrototypeOf(instance);
	
	      // build multilevel prototype inheritance chain property list
	      do { props = props.concat(Object.getOwnPropertyNames(obj || instance)); }
	      while (obj = Object.getPrototypeOf(obj || instance))
	
	      // loop the keys in the function prototype or the all object keys
	      each(props, function (key) {
	        // bind methods to this
	        // allow mixins to override other properties/parent mixins
	        if (!contains(propsBlacklist, key)) {
	          // check for getters/setters
	          var descriptor = Object.getOwnPropertyDescriptor(instance, key) || Object.getOwnPropertyDescriptor(proto, key);
	          var hasGetterSetter = descriptor && (descriptor.get || descriptor.set);
	
	          // apply method only if it does not already exist on the instance
	          if (!this$1.hasOwnProperty(key) && hasGetterSetter) {
	            Object.defineProperty(this$1, key, descriptor);
	          } else {
	            this$1[key] = isFunction(instance[key]) ?
	              instance[key].bind(this$1) :
	              instance[key];
	          }
	        }
	      });
	
	      // init method will be called automatically
	      if (instance.init)
	        { instance.init.bind(this$1)(); }
	    });
	    return this
	  }.bind(this));
	
	  /**
	   * Mount the current tag instance
	   * @returns { Tag } the current tag instance
	   */
	  defineProperty(this, 'mount', function tagMount() {
	    var this$1 = this;
	
	    root._tag = this; // keep a reference to the tag just created
	
	    // Read all the attrs on this instance. This give us the info we need for updateOpts
	    parseAttributes.apply(parent, [root, root.attributes, function (attr, expr) {
	      if (!isAnonymous && RefExpr.isPrototypeOf(expr)) { expr.tag = this$1; }
	      attr.expr = expr;
	      instAttrs.push(attr);
	    }]);
	
	    // update the root adding custom attributes coming from the compiler
	    implAttrs = [];
	    walkAttrs(impl.attrs, function (k, v) { implAttrs.push({name: k, value: v}); });
	    parseAttributes.apply(this, [root, implAttrs, function (attr, expr) {
	      if (expr) { expressions.push(expr); }
	      else { setAttr(root, attr.name, attr.value); }
	    }]);
	
	    // initialiation
	    updateOpts.apply(this, [isLoop, parent, isAnonymous, opts, instAttrs]);
	
	    // add global mixins
	    var globalMixin = mixin$1(GLOBAL_MIXIN);
	
	    if (globalMixin && !skipAnonymous) {
	      for (var i in globalMixin) {
	        if (globalMixin.hasOwnProperty(i)) {
	          this$1.mixin(globalMixin[i]);
	        }
	      }
	    }
	
	    if (impl.fn) { impl.fn.call(this, opts); }
	
	    if (!skipAnonymous) { this.trigger('before-mount'); }
	
	    // parse layout after init. fn may calculate args for nested custom tags
	    parseExpressions.apply(this, [dom, expressions, isAnonymous]);
	
	    this.update(item);
	
	    if (!isAnonymous) {
	      while (dom.firstChild) { root.appendChild(dom.firstChild); }
	    }
	
	    defineProperty(this, 'root', root);
	    defineProperty(this, 'isMounted', true);
	
	    if (skipAnonymous) { return }
	
	    // if it's not a child tag we can trigger its mount event
	    if (!this.parent) {
	      this.trigger('mount');
	    }
	    // otherwise we need to wait that the parent "mount" or "updated" event gets triggered
	    else {
	      var p = getImmediateCustomParentTag(this.parent);
	      p.one(!p.isMounted ? 'mount' : 'updated', function () {
	        this$1.trigger('mount');
	      });
	    }
	
	    return this
	
	  }.bind(this));
	
	  /**
	   * Unmount the tag instance
	   * @param { Boolean } mustKeepRoot - if it's true the root node will not be removed
	   * @returns { Tag } the current tag instance
	   */
	  defineProperty(this, 'unmount', function tagUnmount(mustKeepRoot) {
	    var this$1 = this;
	
	    var el = this.root,
	      p = el.parentNode,
	      ptag,
	      tagIndex = __TAGS_CACHE.indexOf(this);
	
	    if (!skipAnonymous) { this.trigger('before-unmount'); }
	
	    // clear all attributes coming from the mounted tag
	    walkAttrs(impl.attrs, function (name) {
	      if (startsWith(name, ATTRS_PREFIX))
	        { name = name.slice(ATTRS_PREFIX.length); }
	      remAttr(root, name);
	    });
	
	    // remove all the event listeners
	    this.__.listeners.forEach(function (dom) {
	      Object.keys(dom[RIOT_EVENTS_KEY]).forEach(function (eventName) {
	        dom.removeEventListener(eventName, dom[RIOT_EVENTS_KEY][eventName]);
	      });
	    });
	
	    // remove this tag instance from the global virtualDom variable
	    if (tagIndex !== -1)
	      { __TAGS_CACHE.splice(tagIndex, 1); }
	
	    if (p || isVirtual) {
	      if (parent) {
	        ptag = getImmediateCustomParentTag(parent);
	
	        if (isVirtual) {
	          Object.keys(this.tags).forEach(function (tagName) {
	            arrayishRemove(ptag.tags, tagName, this$1.tags[tagName]);
	          });
	        } else {
	          arrayishRemove(ptag.tags, tagName, this);
	          if(parent !== ptag) // remove from _parent too
	            { arrayishRemove(parent.tags, tagName, this); }
	        }
	      } else {
	        // remove the tag contents
	        setInnerHTML(el, '');
	      }
	
	      if (p && !mustKeepRoot) { p.removeChild(el); }
	    }
	
	    if (this.__.virts) {
	      each(this.__.virts, function (v) {
	        if (v.parentNode) { v.parentNode.removeChild(v); }
	      });
	    }
	
	    // allow expressions to unmount themselves
	    unmountAll(expressions);
	    each(instAttrs, function (a) { return a.expr && a.expr.unmount && a.expr.unmount(); });
	
	    // custom internal unmount function to avoid relying on the observable
	    if (this.__.onUnmount) { this.__.onUnmount(); }
	
	    if (!skipAnonymous) {
	      this.trigger('unmount');
	      this.off('*');
	    }
	
	    defineProperty(this, 'isMounted', false);
	
	    delete this.root._tag;
	
	    return this
	
	  }.bind(this));
	}
	
	/**
	 * Detect the tag implementation by a DOM node
	 * @param   { Object } dom - DOM node we need to parse to get its tag implementation
	 * @returns { Object } it returns an object containing the implementation of a custom tag (template and boot function)
	 */
	function getTag(dom) {
	  return dom.tagName && __TAG_IMPL[getAttr(dom, IS_DIRECTIVE) ||
	    getAttr(dom, IS_DIRECTIVE) || dom.tagName.toLowerCase()]
	}
	
	/**
	 * Inherit properties from a target tag instance
	 * @this Tag
	 * @param   { Tag } target - tag where we will inherit properties
	 * @param   { Array } propsInSyncWithParent - array of properties to sync with the target
	 */
	function inheritFrom(target, propsInSyncWithParent) {
	  var this$1 = this;
	
	  each(Object.keys(target), function (k) {
	    // some properties must be always in sync with the parent tag
	    var mustSync = !isReservedName(k) && contains(propsInSyncWithParent, k);
	
	    if (isUndefined(this$1[k]) || mustSync) {
	      // track the property to keep in sync
	      // so we can keep it updated
	      if (!mustSync) { propsInSyncWithParent.push(k); }
	      this$1[k] = target[k];
	    }
	  });
	}
	
	/**
	 * Move the position of a custom tag in its parent tag
	 * @this Tag
	 * @param   { String } tagName - key where the tag was stored
	 * @param   { Number } newPos - index where the new tag will be stored
	 */
	function moveChildTag(tagName, newPos) {
	  var parent = this.parent,
	    tags;
	  // no parent no move
	  if (!parent) { return }
	
	  tags = parent.tags[tagName];
	
	  if (isArray(tags))
	    { tags.splice(newPos, 0, tags.splice(tags.indexOf(this), 1)[0]); }
	  else { arrayishAdd(parent.tags, tagName, this); }
	}
	
	/**
	 * Create a new child tag including it correctly into its parent
	 * @param   { Object } child - child tag implementation
	 * @param   { Object } opts - tag options containing the DOM node where the tag will be mounted
	 * @param   { String } innerHTML - inner html of the child node
	 * @param   { Object } parent - instance of the parent tag including the child custom tag
	 * @returns { Object } instance of the new child tag just created
	 */
	function initChildTag(child, opts, innerHTML, parent) {
	  var tag = new Tag$1(child, opts, innerHTML),
	    tagName = opts.tagName || getTagName(opts.root, true),
	    ptag = getImmediateCustomParentTag(parent);
	  // fix for the parent attribute in the looped elements
	  defineProperty(tag, 'parent', ptag);
	  // store the real parent tag
	  // in some cases this could be different from the custom parent tag
	  // for example in nested loops
	  tag.__.parent = parent;
	
	  // add this tag to the custom parent tag
	  arrayishAdd(ptag.tags, tagName, tag);
	
	  // and also to the real parent tag
	  if (ptag !== parent)
	    { arrayishAdd(parent.tags, tagName, tag); }
	
	  // empty the child node once we got its template
	  // to avoid that its children get compiled multiple times
	  opts.root.innerHTML = '';
	
	  return tag
	}
	
	/**
	 * Loop backward all the parents tree to detect the first custom parent tag
	 * @param   { Object } tag - a Tag instance
	 * @returns { Object } the instance of the first custom parent tag found
	 */
	function getImmediateCustomParentTag(tag) {
	  var ptag = tag;
	  while (ptag.__.isAnonymous) {
	    if (!ptag.parent) { break }
	    ptag = ptag.parent;
	  }
	  return ptag
	}
	
	/**
	 * Trigger the unmount method on all the expressions
	 * @param   { Array } expressions - DOM expressions
	 */
	function unmountAll(expressions) {
	  each(expressions, function(expr) {
	    if (expr instanceof Tag$1) { expr.unmount(true); }
	    else if (expr.tagName) { expr.tag.unmount(true); }
	    else if (expr.unmount) { expr.unmount(); }
	  });
	}
	
	/**
	 * Get the tag name of any DOM node
	 * @param   { Object } dom - DOM node we want to parse
	 * @param   { Boolean } skipDataIs - hack to ignore the data-is attribute when attaching to parent
	 * @returns { String } name to identify this dom node in riot
	 */
	function getTagName(dom, skipDataIs) {
	  var child = getTag(dom),
	    namedTag = !skipDataIs && getAttr(dom, IS_DIRECTIVE);
	  return namedTag && !tmpl.hasExpr(namedTag) ?
	                namedTag :
	              child ? child.name : dom.tagName.toLowerCase()
	}
	
	/**
	 * With this function we avoid that the internal Tag methods get overridden
	 * @param   { Object } data - options we want to use to extend the tag instance
	 * @returns { Object } clean object without containing the riot internal reserved words
	 */
	function cleanUpData(data) {
	  if (!(data instanceof Tag$1) && !(data && isFunction(data.trigger)))
	    { return data }
	
	  var o = {};
	  for (var key in data) {
	    if (!RE_RESERVED_NAMES.test(key)) { o[key] = data[key]; }
	  }
	  return o
	}
	
	/**
	 * Set the property of an object for a given key. If something already
	 * exists there, then it becomes an array containing both the old and new value.
	 * @param { Object } obj - object on which to set the property
	 * @param { String } key - property name
	 * @param { Object } value - the value of the property to be set
	 * @param { Boolean } ensureArray - ensure that the property remains an array
	 * @param { Number } index - add the new item in a certain array position
	 */
	function arrayishAdd(obj, key, value, ensureArray, index) {
	  var dest = obj[key];
	  var isArr = isArray(dest);
	  var hasIndex = !isUndefined(index);
	
	  if (dest && dest === value) { return }
	
	  // if the key was never set, set it once
	  if (!dest && ensureArray) { obj[key] = [value]; }
	  else if (!dest) { obj[key] = value; }
	  // if it was an array and not yet set
	  else {
	    if (isArr) {
	      var oldIndex = dest.indexOf(value);
	      // this item never changed its position
	      if (oldIndex === index) { return }
	      // remove the item from its old position
	      if (oldIndex !== -1) { dest.splice(oldIndex, 1); }
	      // move or add the item
	      if (hasIndex) {
	        dest.splice(index, 0, value);
	      } else {
	        dest.push(value);
	      }
	    } else { obj[key] = [dest, value]; }
	  }
	}
	
	/**
	 * Removes an item from an object at a given key. If the key points to an array,
	 * then the item is just removed from the array.
	 * @param { Object } obj - object on which to remove the property
	 * @param { String } key - property name
	 * @param { Object } value - the value of the property to be removed
	 * @param { Boolean } ensureArray - ensure that the property remains an array
	*/
	function arrayishRemove(obj, key, value, ensureArray) {
	  if (isArray(obj[key])) {
	    var index = obj[key].indexOf(value);
	    if (index !== -1) { obj[key].splice(index, 1); }
	    if (!obj[key].length) { delete obj[key]; }
	    else if (obj[key].length === 1 && !ensureArray) { obj[key] = obj[key][0]; }
	  } else
	    { delete obj[key]; } // otherwise just delete the key
	}
	
	/**
	 * Mount a tag creating new Tag instance
	 * @param   { Object } root - dom node where the tag will be mounted
	 * @param   { String } tagName - name of the riot tag we want to mount
	 * @param   { Object } opts - options to pass to the Tag instance
	 * @param   { Object } ctx - optional context that will be used to extend an existing class ( used in riot.Tag )
	 * @returns { Tag } a new Tag instance
	 */
	function mountTo(root, tagName, opts, ctx) {
	  var impl = __TAG_IMPL[tagName],
	    implClass = __TAG_IMPL[tagName].class,
	    tag = ctx || (implClass ? Object.create(implClass.prototype) : {}),
	    // cache the inner HTML to fix #855
	    innerHTML = root._innerHTML = root._innerHTML || root.innerHTML;
	
	  // clear the inner html
	  root.innerHTML = '';
	
	  var conf = extend({ root: root, opts: opts }, { parent: opts ? opts.parent : null });
	
	  if (impl && root) { Tag$1.apply(tag, [impl, conf, innerHTML]); }
	
	  if (tag && tag.mount) {
	    tag.mount(true);
	    // add this tag to the virtualDom variable
	    if (!contains(__TAGS_CACHE, tag)) { __TAGS_CACHE.push(tag); }
	  }
	
	  return tag
	}
	
	/**
	 * makes a tag virtual and replaces a reference in the dom
	 * @this Tag
	 * @param { tag } the tag to make virtual
	 * @param { ref } the dom reference location
	 */
	function makeReplaceVirtual(tag, ref) {
	  var frag = createFrag();
	  makeVirtual.call(tag, frag);
	  ref.parentNode.replaceChild(frag, ref);
	}
	
	/**
	 * Adds the elements for a virtual tag
	 * @this Tag
	 * @param { Node } src - the node that will do the inserting or appending
	 * @param { Tag } target - only if inserting, insert before this tag's first child
	 */
	function makeVirtual(src, target) {
	  var this$1 = this;
	
	  var head = createDOMPlaceholder(),
	    tail = createDOMPlaceholder(),
	    frag = createFrag(),
	    sib, el;
	
	  this.root.insertBefore(head, this.root.firstChild);
	  this.root.appendChild(tail);
	
	  this.__.head = el = head;
	  this.__.tail = tail;
	
	  while (el) {
	    sib = el.nextSibling;
	    frag.appendChild(el);
	    this$1.__.virts.push(el); // hold for unmounting
	    el = sib;
	  }
	
	  if (target)
	    { src.insertBefore(frag, target.__.head); }
	  else
	    { src.appendChild(frag); }
	}
	
	/**
	 * Move virtual tag and all child nodes
	 * @this Tag
	 * @param { Node } src  - the node that will do the inserting
	 * @param { Tag } target - insert before this tag's first child
	 */
	function moveVirtual(src, target) {
	  var this$1 = this;
	
	  var el = this.__.head,
	    frag = createFrag(),
	    sib;
	
	  while (el) {
	    sib = el.nextSibling;
	    frag.appendChild(el);
	    el = sib;
	    if (el === this$1.__.tail) {
	      frag.appendChild(el);
	      src.insertBefore(frag, target.__.head);
	      break
	    }
	  }
	}
	
	/**
	 * Get selectors for tags
	 * @param   { Array } tags - tag names to select
	 * @returns { String } selector
	 */
	function selectTags(tags) {
	  // select all tags
	  if (!tags) {
	    var keys = Object.keys(__TAG_IMPL);
	    return keys + selectTags(keys)
	  }
	
	  return tags
	    .filter(function (t) { return !/[^-\w]/.test(t); })
	    .reduce(function (list, t) {
	      var name = t.trim().toLowerCase();
	      return list + ",[" + IS_DIRECTIVE + "=\"" + name + "\"]"
	    }, '')
	}
	
	
	var tags = Object.freeze({
		getTag: getTag,
		inheritFrom: inheritFrom,
		moveChildTag: moveChildTag,
		initChildTag: initChildTag,
		getImmediateCustomParentTag: getImmediateCustomParentTag,
		unmountAll: unmountAll,
		getTagName: getTagName,
		cleanUpData: cleanUpData,
		arrayishAdd: arrayishAdd,
		arrayishRemove: arrayishRemove,
		mountTo: mountTo,
		makeReplaceVirtual: makeReplaceVirtual,
		makeVirtual: makeVirtual,
		moveVirtual: moveVirtual,
		selectTags: selectTags
	});
	
	/**
	 * Riot public api
	 */
	var settings = settings$1;
	var util = {
	  tmpl: tmpl,
	  brackets: brackets,
	  styleManager: styleManager,
	  vdom: __TAGS_CACHE,
	  styleNode: styleManager.styleNode,
	  // export the riot internal utils as well
	  dom: dom,
	  check: check,
	  misc: misc,
	  tags: tags
	};
	
	// export the core props/methods
	var Tag$$1 = Tag$2;
	var tag$$1 = tag$1;
	var tag2$$1 = tag2$1;
	var mount$$1 = mount$1;
	var mixin$$1 = mixin$1;
	var update$$1 = update$1;
	var unregister$$1 = unregister$1;
	var version$$1 = version$1;
	var observable = observable$1;
	
	var riot$1 = extend({}, core, {
	  observable: observable$1,
	  settings: settings,
	  util: util,
	});
	
	exports.settings = settings;
	exports.util = util;
	exports.Tag = Tag$$1;
	exports.tag = tag$$1;
	exports.tag2 = tag2$$1;
	exports.mount = mount$$1;
	exports.mixin = mixin$$1;
	exports.update = update$$1;
	exports.unregister = unregister$$1;
	exports.version = version$$1;
	exports.observable = observable;
	exports['default'] = riot$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Axis = __webpack_require__(28);
	
	Object.defineProperty(exports, 'axisLeft', {
	  enumerable: true,
	  get: function get() {
	    return _d3Axis.axisLeft;
	  }
	});
	Object.defineProperty(exports, 'axisBottom', {
	  enumerable: true,
	  get: function get() {
	    return _d3Axis.axisBottom;
	  }
	});
	
	var _d3Shape = __webpack_require__(36);
	
	Object.defineProperty(exports, 'line', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.line;
	  }
	});
	
	var _d3Scale = __webpack_require__(34);
	
	Object.defineProperty(exports, 'scaleLinear', {
	  enumerable: true,
	  get: function get() {
	    return _d3Scale.scaleLinear;
	  }
	});
	Object.defineProperty(exports, 'scaleTime', {
	  enumerable: true,
	  get: function get() {
	    return _d3Scale.scaleTime;
	  }
	});
	Object.defineProperty(exports, 'scaleQuantile', {
	  enumerable: true,
	  get: function get() {
	    return _d3Scale.scaleQuantile;
	  }
	});
	
	var _d3Selection = __webpack_require__(35);
	
	Object.defineProperty(exports, 'select', {
	  enumerable: true,
	  get: function get() {
	    return _d3Selection.select;
	  }
	});
	
	var _d3TimeFormat = __webpack_require__(10);
	
	Object.defineProperty(exports, 'timeParse', {
	  enumerable: true,
	  get: function get() {
	    return _d3TimeFormat.timeParse;
	  }
	});
	Object.defineProperty(exports, 'timeFormat', {
	  enumerable: true,
	  get: function get() {
	    return _d3TimeFormat.timeFormat;
	  }
	});
	
	var _d3Dsv = __webpack_require__(30);
	
	Object.defineProperty(exports, 'csvParse', {
	  enumerable: true,
	  get: function get() {
	    return _d3Dsv.csvParse;
	  }
	});
	
	var _d3Geo = __webpack_require__(31);
	
	Object.defineProperty(exports, 'geoPath', {
	  enumerable: true,
	  get: function get() {
	    return _d3Geo.geoPath;
	  }
	});
	Object.defineProperty(exports, 'geoMercator', {
	  enumerable: true,
	  get: function get() {
	    return _d3Geo.geoMercator;
	  }
	});
	
	var _d3Format = __webpack_require__(9);
	
	Object.defineProperty(exports, 'formatLocale', {
	  enumerable: true,
	  get: function get() {
	    return _d3Format.formatLocale;
	  }
	});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _d = __webpack_require__(2);
	
	var d3 = _interopRequireWildcard(_d);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var formatDate = d3.timeFormat('%Y');
	var parseDate = d3.timeParse('%Y');
	var toDate = function toDate(str) {
	  return parseDate(str);
	};
	
	module.exports = {
	  fromDate: function fromDate(date) {
	    return formatDate(date);
	  },
	  convertDate: function convertDate(str) {
	    return formatDate(parseDate(str));
	  },
	  toDate: toDate,
	  years: ["2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016"].map(function (y) {
	    return toDate(y);
	  })
	};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d = __webpack_require__(2);
	
	var d3 = _interopRequireWildcard(_d);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var colors = ['#ffffe5', '#fff7bc', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#993404', '#662506'];
	exports.default = d3.scaleQuantile().domain([5, 10]).range(colors);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (hilighted) {
	  return hilighted && hilighted.classed('-hilight', false);
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _topojson = __webpack_require__(41);
	
	var topojson = _interopRequireWildcard(_topojson);
	
	var _d = __webpack_require__(2);
	
	var d3 = _interopRequireWildcard(_d);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _data = d3.csvParse(__webpack_require__(40));
	var search = function search(str) {
	  return _data.filter(function (d) {
	    return d.search.indexOf(str) > -1;
	  });
	};
	var data = {};
	_data.map(function (d) {
	  return data[d.ags] = d;
	});
	var geoSrc = __webpack_require__(39);
	var geoData = topojson.feature(geoSrc, geoSrc.objects.nrw);
	geoData.features.map(function (f) {
	  var id = f.properties.AGS;
	  f.data = data[id];
	  f.data.name = f.properties.GEN;
	  f.id = id;
	});
	
	module.exports = {
	  search: search,
	  geoData: geoData
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var pairs = function(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	};
	
	function pair(a, b) {
	  return [a, b];
	}
	
	var cross = function(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var reverse = stop < start,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  if (reverse) n = start, start = stop, stop = n;
	
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	};
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var quantile = function(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	};
	
	var mean = function(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	};
	
	var median = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	var Kn = 18;
	var Xn = 0.950470;
	var Yn = 1;
	var Zn = 1.088830;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var b = rgb2xyz(o.r),
	      a = rgb2xyz(o.g),
	      l = rgb2xyz(o.b),
	      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function xyz2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2xyz(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	};
	
	var exponent = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};
	
	var formatNumerals = function(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	};
	
	var formatDefault = function(x, p) {
	  x = x.toPrecision(p);
	
	  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (x[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      case "e": break out;
	      default: if (i0 > 0) i0 = 0; break;
	    }
	  }
	
	  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	};
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var formatTypes = {
	  "": formatDefault,
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	  var match,
	      fill = match[1] || " ",
	      align = match[2] || ">",
	      sign = match[3] || "-",
	      symbol = match[4] || "",
	      zero = !!match[5],
	      width = match[6] && +match[6],
	      comma = !!match[7],
	      precision = match[8] && +match[8].slice(1),
	      type = match[9] || "";
	
	  // The "n" type is an alias for ",g".
	  if (type === "n") comma = true, type = "g";
	
	  // Map invalid types to the default format.
	  else if (!formatTypes[type]) type = "";
	
	  // If zero fill is specified, padding goes after sign and before digits.
	  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	  this.fill = fill;
	  this.align = align;
	  this.sign = sign;
	  this.symbol = symbol;
	  this.zero = zero;
	  this.width = width;
	  this.comma = comma;
	  this.precision = precision;
	  this.type = type;
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + this.type;
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        type = specifier.type;
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = !type || /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? (type ? 6 : 12)
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var locale;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	};
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	};
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	};
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(11)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "S": formatSeconds,
	    "U": formatWeekNumberSunday,
	    "w": formatWeekdayNumber,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "S": formatUTCSeconds,
	    "U": formatUTCWeekNumberSunday,
	    "w": formatUTCWeekdayNumber,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "S": parseSeconds,
	    "U": parseWeekNumberSunday,
	    "w": parseWeekdayNumber,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0);
	      if (i != string.length) return null;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	        var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekdayNumber(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekdayNumber(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	var locale$1;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale$1 = formatLocale(definition);
	  exports.timeFormat = locale$1.format;
	  exports.timeParse = locale$1.parse;
	  exports.utcFormat = locale$1.utcFormat;
	  exports.utcParse = locale$1.utcParse;
	  return locale$1;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.6. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date;
	var t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [];
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) while (--step >= 0) while (offseti(date, 1), !test(date)) {} // eslint-disable-line no-empty
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(17);
	
	__webpack_require__(16);
	
	__webpack_require__(14);
	
	__webpack_require__(15);
	
	riot.tag2('cor-mj-munis-map', '<map-searchbox ref="searchbox"></map-searchbox> <map-infobox ref="infobox" config="{opts.config}"></map-infobox> <munis-map ref="munis-map"></munis-map> <munis-map-legend ref="munis-map-legend"></munis-map-legend>', '', 'class="{getClass(\'app-wrapper\')}"', function (opts) {});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	var _init_history_chart = __webpack_require__(19);
	
	var _init_history_chart2 = _interopRequireDefault(_init_history_chart);
	
	var _draw_line = __webpack_require__(18);
	
	var _draw_line2 = _interopRequireDefault(_draw_line);
	
	var _update_line = __webpack_require__(21);
	
	var _update_line2 = _interopRequireDefault(_update_line);
	
	var _transform_data = __webpack_require__(20);
	
	var _transform_data2 = _interopRequireDefault(_transform_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	riot.tag2('history-chart', '', '', 'class="{getClass()}"', function (opts) {
	  var _this = this;
	
	  this.drawed = false; // identify if we already drawed a line
	
	  this.on('mount', function () {
	    _this.chart = (0, _init_history_chart2.default)({
	      element: _this.root,
	      getClass: _this.getClass
	    }, _this.opts.config);
	  });
	
	  this.on('update', function () {
	    var _chart = _this.chart,
	        g = _chart.g,
	        line = _chart.line;
	
	    var data = (0, _transform_data2.default)(_this.opts.data, _this.opts.config.keys);
	    if (data) {
	      if (_this.drawed) {
	        (0, _update_line2.default)({ g: g, line: line, data: data });
	      } else {
	        (0, _draw_line2.default)({ g: g, line: line, data: data });
	        _this.drawed = true;
	      }
	    }
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(13);
	
	riot.tag2('map-infobox', '<button class="{getClass(\'close-btn\')}" aria-label="Close" onclick="{close}"></button> <header class="{getClass(\'header\')}"> <section class="{getClass(\'header__section\')}"> <span class="{getClass(\'state\')}">Nordrhein-Westfalen</span> <h3 class="{getClass(\'title\')}">{data.name}</h3> </section> <section class="{getClass(\'header__section\')}"> <span class="{getClass(\'population\')}"><strong>{_f(data.t)}</strong>&nbsp;Einwohner</span> <span class="{getClass(\'f-ratio\')}">davon <strong>{_f(data.fRatio)}&nbsp;%</strong>&nbsp;Frauen</span> </section> <span class="-clear-"></span> </header> <section class="{getClass(\'section\')}"> <h4 class="{getClass(\'section__title\')}">Anteil der Minijobber</h4> <dl> <dt>{_f(data.pwa)}&nbsp;%</dt> <dt class="-small">{_f(data.wa)}</dt> <dd class="badge badge--e">ausschließlich</dd> </dl> <dl> <dt>{_f(data.pwn)}&nbsp;%</dt> <dt class="-small">{_f(data.wn)}</dt> <dd class="badge badge--i">Nebenjob</dd> </dl> <dl> <dt>{_f(data.pwi)}&nbsp;%</dt> <dt class="-small">{_f(data.wi)}</dt> <dd class="badge badge--t">Gesamt</dd> </dl> <span class="-clear-"></span> </section> <section class="{getClass(\'section\') + \' \' + getClass(\'section--last\')}"> <h4 class="{getClass(\'section__title\')}">Entwicklung seit 2003</h4> <history-chart ref="history-chart" config="{opts.config.historyChart}" data="{data}"></history-chart> </section> <span class="-clear-"></span>', '', 'if="{data}" class="{getClass()} {-visible: visible}"', function (opts) {
	  var _this = this;
	
	  this.visible = false;
	  this.data = {};
	
	  riot.control.on(riot.EVT.updateInfobox, function (data) {
	    data.fRatio = Math.round(data.f / data.t * 1000) / 10;
	    _this.update({
	      data: data,
	      visible: true
	    });
	  });
	
	  riot.control.on(riot.EVT.hideInfobox, function () {
	    _this.close();
	  });
	
	  this.close = function () {
	    return _this.update({ visible: false });
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	var _entry = __webpack_require__(6);
	
	riot.tag2('map-searchbox', '<input type="text" oninput="{doSearch}" class="{getClass(\'input\')}" placeholder="Suche nach Deiner Stadt..."> <ul if="{results.length}" class="{getClass(\'result-list\')}"> <li each="{results}" class="{parent.getClass(\'result-list__item\')}" onclick="{handleClick}"> {name} <span>{plz}</span> </li> </ul>', '', 'class="{getClass()}"', function (opts) {
	  var _this = this;
	
	  this.results = [];
	
	  this.doSearch = function (e) {
	    riot.control.trigger(riot.EVT.hideInfobox);
	    var str = e.target.value.toLowerCase();
	    if (str.length > 2) {
	      var results = (0, _entry.search)(str);
	      _this.update({ results: results });
	    } else {
	      _this.clearResults();
	    }
	  };
	
	  this.handleClick = function (e) {
	    _this.clearResults();
	    _this._jumpTo(e.item);
	  };
	
	  this.clearResults = function () {
	    _this.update({ results: [] });
	  };
	
	  riot.control.on(riot.EVT.clearResults, function () {
	    _this.clearResults();
	  });
	
	  this._jumpTo = function (data) {
	    riot.control.trigger(riot.EVT.updateInfobox, data);
	    riot.control.trigger(riot.EVT.hilight, data.ags);
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	var _get_color = __webpack_require__(4);
	
	var _get_color2 = _interopRequireDefault(_get_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	riot.tag2('munis-map-legend', '<span class="{getClass(\'annotation\')}">Anteil der <strong>ausschließlich</strong> geringfügig Beschäftigten am Wohnort</span> <ul class="{getClass(\'list\')}"> <li each="{ticks}" class="{parent.getClass(\'list-item\')}"> {value}&nbsp;%<span riot-style="background-color:{color};"></span> </li> </ul>', '', 'class="{getClass()}"', function (opts) {
	
	  this.ticks = _get_color2.default.quantiles().map(function (q) {
	    return {
	      color: (0, _get_color2.default)(q),
	      value: Math.round(q * 10) / 10
	    };
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	var _d = __webpack_require__(2);
	
	var d3 = _interopRequireWildcard(_d);
	
	var _render_map = __webpack_require__(23);
	
	var _render_map2 = _interopRequireDefault(_render_map);
	
	var _hilight_path = __webpack_require__(22);
	
	var _hilight_path2 = _interopRequireDefault(_hilight_path);
	
	var _unhilight_path = __webpack_require__(5);
	
	var _unhilight_path2 = _interopRequireDefault(_unhilight_path);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	riot.tag2('munis-map', '<div class="{getClass(\'svg-wrapper\')}" id="svg-map"></div>', '', 'class="{getClass()}"', function (opts) {
	  var _this = this;
	
	  this.on('mount', function () {
	    _this.selection = (0, _render_map2.default)({
	      element: d3.select('#svg-map'),
	      getClass: _this.getClass
	    });
	  });
	
	  riot.control.on(riot.EVT.hilight, function (id) {
	    return _this.hilighted = (0, _hilight_path2.default)(_this.selection, id, _this.hilighted);
	  });
	  riot.control.on(riot.EVT.unhilight, function () {
	    return (0, _unhilight_path2.default)(_this.hilighted);
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var g = _ref.g,
	      line = _ref.line,
	      data = _ref.data;
	
	  g.selectAll('.line').data(data).enter().append('path').attr('class', function (d) {
	    return 'line line--' + d.id;
	  }).attr('d', function (d) {
	    return line(d.values);
	  });
	};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d = __webpack_require__(2);
	
	var d3 = _interopRequireWildcard(_d);
	
	var _date = __webpack_require__(3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = function (_ref, _ref2) {
	  var element = _ref.element,
	      getClass = _ref.getClass;
	  var width = _ref2.width,
	      height = _ref2.height,
	      margin = _ref2.margin,
	      xExtent = _ref2.xExtent,
	      yExtent = _ref2.yExtent,
	      yTickValues = _ref2.yTickValues;
	
	  var x = d3.scaleTime().rangeRound([0, width]).domain([(0, _date.toDate)(xExtent[0]), (0, _date.toDate)(xExtent[1])]);
	  var y = d3.scaleLinear().rangeRound([height, 0]).domain(yExtent);
	
	  var line = d3.line().x(function (d) {
	    return x(d.year);
	  }).y(function (d) {
	    return y(d.value);
	  }).defined(function (d) {
	    return !isNaN(d.value);
	  });
	  // .curve(d3.curveStep())
	
	  var top = margin.top,
	      right = margin.right,
	      bottom = margin.bottom,
	      left = margin.left;
	
	
	  var g = d3.select(element).append('svg').attr('preserveAspectRatio', 'xMinYMin meet').attr('viewBox', '0 0 ' + (width + left + right) + ' ' + (height + top + bottom)).attr('class', getClass('svg')).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	  g.append('g').attr('class', 'axis axis--x').attr('transform', 'translate(0,' + height + ')').call(d3.axisBottom(x).ticks(6));
	
	  g.append('g').attr('class', 'axis axis--y').call(d3.axisLeft(y).tickValues(yTickValues)).append('text').attr('transform', 'rotate(-90)').attr('y', 6).attr('dy', '0.71em').style('text-anchor', 'end').text('Anteil in %');
	
	  return { g: g, line: line };
	};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _date = __webpack_require__(3);
	
	exports.default = function (data, keys) {
	  if (Object.keys(data).length > 0 && keys) {
	    return keys.map(function (k) {
	      return {
	        id: k,
	        values: data[k].split(',').map(function (d, i) {
	          return {
	            year: _date.years[i],
	            value: +d
	          };
	        })
	      };
	    });
	  }
	};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var g = _ref.g,
	        line = _ref.line,
	        data = _ref.data;
	
	    g.selectAll('path.line').data(data).attr('class', function (d) {
	        return 'line line--' + d.id;
	    }).attr('d', function (d) {
	        return line(d.values);
	    });
	};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _unhilight_path = __webpack_require__(5);
	
	var _unhilight_path2 = _interopRequireDefault(_unhilight_path);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (selection, id, hilighted) {
	  hilighted && (0, _unhilight_path2.default)(hilighted);
	  var path = selection.select(function (d) {
	    return d.id === id && this;
	  });
	  path.node().parentNode.appendChild(path.node());
	  path.classed('-hilight', true);
	  return path;
	};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d = __webpack_require__(2);
	
	var d3 = _interopRequireWildcard(_d);
	
	var _entry = __webpack_require__(6);
	
	var _get_color = __webpack_require__(4);
	
	var _get_color2 = _interopRequireDefault(_get_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = function (_ref) {
	  var element = _ref.element,
	      getClass = _ref.getClass;
	
	  var path = d3.geoPath().projection(d3.geoMercator().fitSize([600, 600], _entry.geoData));
	
	  return element.append('svg').attr('class', getClass('svg')).attr('preserveAspectRatio', 'xMinYMin meet').attr('viewBox', '0 0 600 600').append('g').selectAll('path').data(_entry.geoData.features).enter().append('path').attr('class', getClass('path')).attr('d', path).attr('fill', function (d) {
	    return (0, _get_color2.default)(+d.data.pwa);
	  }).on('mouseover', function (d) {
	    riot.control.trigger(riot.EVT.hilight, d.id);
	    riot.control.trigger(riot.EVT.updateInfobox, d.data);
	  });
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	__webpack_require__(37);
	
	__webpack_require__(27);
	
	var _class_name = __webpack_require__(25);
	
	var _class_name2 = _interopRequireDefault(_class_name);
	
	var _number_format = __webpack_require__(26);
	
	var _number_format2 = _interopRequireDefault(_number_format);
	
	__webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (false) {
	  module.hot.accept();
	}
	
	// import 'babel-polyfill'
	
	
	// load config
	var config = __webpack_require__(38);
	
	// event bus
	
	
	// setup responsiveness
	// import {getWindowWidth, getActiveBreakpointFunc} from './responsive.js'
	// const getActiveBreakpoint = getActiveBreakpointFunc(config.global.breakpoints)
	// riot.STORE.breakpoint = getActiveBreakpoint(getWindowWidth())
	// riot.STORE.getActiveBreakpoint = getActiveBreakpoint
	
	// mixins
	
	riot.mixin((0, _class_name2.default)(config.global.cssNamespace));
	riot.mixin(_number_format2.default);
	
	// mount app
	
	riot.mount('[data-riot-mount="cor-mj-munis-map-nrw"]', 'cor-mj-munis-map', { config: config });
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	// riot mixin for computing class names
	//
	// it takes a global `cssNamespace` on init that becomes prefix for all classes.
	//
	// components can have the `ref`-attribute set to append this (say, the name for this component) to the
	// global prefix
	//
	// components then have `this.getClass` that computes the acutal class name for something, e.g:
	//    global namespace is 'foo', components ref-attr is 'bar', then
	//      `getClass('title')` results in a class named 'foo-bar__title'
	//     if ref is undefined, `getClass('title')` becomes 'foo-title'
	
	exports.default = function (cssNamespace) {
	  return {
	    getClass: function getClass(name) {
	      var ref = this.opts.ref;
	      var part = ref ? cssNamespace + "-" + ref : false;
	      return name ? part ? part + "__" + name : cssNamespace + "-" + name : part;
	    }
	  };
	};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _d = __webpack_require__(2);
	
	var d3 = _interopRequireWildcard(_d);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var loc = d3.formatLocale({
	  thousands: '.',
	  decimal: ',',
	  grouping: [3]
	}); // riot mixin for formatting numbers to german locale
	
	
	var format = loc.format(',');
	
	module.exports = { _f: function _f(val) {
	    return val && format(val);
	  } };

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {'use strict';
	
	var _d = __webpack_require__(2);
	
	var d3 = _interopRequireWildcard(_d);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// event names
	riot.EVT = {
	  updateInfobox: 'uib',
	  hideInfobox: 'hib',
	  clearResults: 'cr',
	  hilight: 'h',
	  unhilight: 'u'
	};
	
	// event bus
	riot.control = riot.observable();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-axis/ Version 1.0.7. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var slice = Array.prototype.slice;
	
	var identity = function(x) {
	  return x;
	};
	
	var top = 1;
	var right = 2;
	var bottom = 3;
	var left = 4;
	var epsilon = 1e-6;
	
	function translateX(x) {
	  return "translate(" + (x + 0.5) + ",0)";
	}
	
	function translateY(y) {
	  return "translate(0," + (y + 0.5) + ")";
	}
	
	function center(scale) {
	  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
	  if (scale.round()) offset = Math.round(offset);
	  return function(d) {
	    return scale(d) + offset;
	  };
	}
	
	function entering() {
	  return !this.__axis;
	}
	
	function axis(orient, scale) {
	  var tickArguments = [],
	      tickValues = null,
	      tickFormat = null,
	      tickSizeInner = 6,
	      tickSizeOuter = 6,
	      tickPadding = 3,
	      k = orient === top || orient === left ? -1 : 1,
	      x = orient === left || orient === right ? "x" : "y",
	      transform = orient === top || orient === bottom ? translateX : translateY;
	
	  function axis(context) {
	    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
	        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity) : tickFormat,
	        spacing = Math.max(tickSizeInner, 0) + tickPadding,
	        range = scale.range(),
	        range0 = range[0] + 0.5,
	        range1 = range[range.length - 1] + 0.5,
	        position = (scale.bandwidth ? center : identity)(scale.copy()),
	        selection = context.selection ? context.selection() : context,
	        path = selection.selectAll(".domain").data([null]),
	        tick = selection.selectAll(".tick").data(values, scale).order(),
	        tickExit = tick.exit(),
	        tickEnter = tick.enter().append("g").attr("class", "tick"),
	        line = tick.select("line"),
	        text = tick.select("text");
	
	    path = path.merge(path.enter().insert("path", ".tick")
	        .attr("class", "domain")
	        .attr("stroke", "#000"));
	
	    tick = tick.merge(tickEnter);
	
	    line = line.merge(tickEnter.append("line")
	        .attr("stroke", "#000")
	        .attr(x + "2", k * tickSizeInner));
	
	    text = text.merge(tickEnter.append("text")
	        .attr("fill", "#000")
	        .attr(x, k * spacing)
	        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
	
	    if (context !== selection) {
	      path = path.transition(context);
	      tick = tick.transition(context);
	      line = line.transition(context);
	      text = text.transition(context);
	
	      tickExit = tickExit.transition(context)
	          .attr("opacity", epsilon)
	          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });
	
	      tickEnter
	          .attr("opacity", epsilon)
	          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
	    }
	
	    tickExit.remove();
	
	    path
	        .attr("d", orient === left || orient == right
	            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
	            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);
	
	    tick
	        .attr("opacity", 1)
	        .attr("transform", function(d) { return transform(position(d)); });
	
	    line
	        .attr(x + "2", k * tickSizeInner);
	
	    text
	        .attr(x, k * spacing)
	        .text(format);
	
	    selection.filter(entering)
	        .attr("fill", "none")
	        .attr("font-size", 10)
	        .attr("font-family", "sans-serif")
	        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
	
	    selection
	        .each(function() { this.__axis = position; });
	  }
	
	  axis.scale = function(_) {
	    return arguments.length ? (scale = _, axis) : scale;
	  };
	
	  axis.ticks = function() {
	    return tickArguments = slice.call(arguments), axis;
	  };
	
	  axis.tickArguments = function(_) {
	    return arguments.length ? (tickArguments = _ == null ? [] : slice.call(_), axis) : tickArguments.slice();
	  };
	
	  axis.tickValues = function(_) {
	    return arguments.length ? (tickValues = _ == null ? null : slice.call(_), axis) : tickValues && tickValues.slice();
	  };
	
	  axis.tickFormat = function(_) {
	    return arguments.length ? (tickFormat = _, axis) : tickFormat;
	  };
	
	  axis.tickSize = function(_) {
	    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeInner = function(_) {
	    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeOuter = function(_) {
	    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
	  };
	
	  axis.tickPadding = function(_) {
	    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
	  };
	
	  return axis;
	}
	
	function axisTop(scale) {
	  return axis(top, scale);
	}
	
	function axisRight(scale) {
	  return axis(right, scale);
	}
	
	function axisBottom(scale) {
	  return axis(bottom, scale);
	}
	
	function axisLeft(scale) {
	  return axis(left, scale);
	}
	
	exports.axisTop = axisTop;
	exports.axisRight = axisRight;
	exports.axisBottom = axisBottom;
	exports.axisLeft = axisLeft;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) return rollup != null
	        ? rollup(array) : (sortValues != null
	        ? array.sort(sortValues)
	        : array);
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-dsv/ Version 1.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function objectConverter(columns) {
	  return new Function("d", "return {" + columns.map(function(name, i) {
	    return JSON.stringify(name) + ": d[" + i + "]";
	  }).join(",") + "}");
	}
	
	function customConverter(columns, f) {
	  var object = objectConverter(columns);
	  return function(row, i) {
	    return f(object(row), i, columns);
	  };
	}
	
	// Compute unique columns in order of discovery.
	function inferColumns(rows) {
	  var columnSet = Object.create(null),
	      columns = [];
	
	  rows.forEach(function(row) {
	    for (var column in row) {
	      if (!(column in columnSet)) {
	        columns.push(columnSet[column] = column);
	      }
	    }
	  });
	
	  return columns;
	}
	
	var dsv = function(delimiter) {
	  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
	      delimiterCode = delimiter.charCodeAt(0);
	
	  function parse(text, f) {
	    var convert, columns, rows = parseRows(text, function(row, i) {
	      if (convert) return convert(row, i - 1);
	      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
	    });
	    rows.columns = columns;
	    return rows;
	  }
	
	  function parseRows(text, f) {
	    var EOL = {}, // sentinel value for end-of-line
	        EOF = {}, // sentinel value for end-of-file
	        rows = [], // output rows
	        N = text.length,
	        I = 0, // current character index
	        n = 0, // the current line number
	        t, // the current token
	        eol; // is the current token followed by EOL?
	
	    function token() {
	      if (I >= N) return EOF; // special case: end of file
	      if (eol) return eol = false, EOL; // special case: end of line
	
	      // special case: quotes
	      var j = I, c;
	      if (text.charCodeAt(j) === 34) {
	        var i = j;
	        while (i++ < N) {
	          if (text.charCodeAt(i) === 34) {
	            if (text.charCodeAt(i + 1) !== 34) break;
	            ++i;
	          }
	        }
	        I = i + 2;
	        c = text.charCodeAt(i + 1);
	        if (c === 13) {
	          eol = true;
	          if (text.charCodeAt(i + 2) === 10) ++I;
	        } else if (c === 10) {
	          eol = true;
	        }
	        return text.slice(j + 1, i).replace(/""/g, "\"");
	      }
	
	      // common case: find next delimiter or newline
	      while (I < N) {
	        var k = 1;
	        c = text.charCodeAt(I++);
	        if (c === 10) eol = true; // \n
	        else if (c === 13) { eol = true; if (text.charCodeAt(I) === 10) ++I, ++k; } // \r|\r\n
	        else if (c !== delimiterCode) continue;
	        return text.slice(j, I - k);
	      }
	
	      // special case: last token before EOF
	      return text.slice(j);
	    }
	
	    while ((t = token()) !== EOF) {
	      var a = [];
	      while (t !== EOL && t !== EOF) {
	        a.push(t);
	        t = token();
	      }
	      if (f && (a = f(a, n++)) == null) continue;
	      rows.push(a);
	    }
	
	    return rows;
	  }
	
	  function format(rows, columns) {
	    if (columns == null) columns = inferColumns(rows);
	    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
	      return columns.map(function(column) {
	        return formatValue(row[column]);
	      }).join(delimiter);
	    })).join("\n");
	  }
	
	  function formatRows(rows) {
	    return rows.map(formatRow).join("\n");
	  }
	
	  function formatRow(row) {
	    return row.map(formatValue).join(delimiter);
	  }
	
	  function formatValue(text) {
	    return text == null ? ""
	        : reFormat.test(text += "") ? "\"" + text.replace(/\"/g, "\"\"") + "\""
	        : text;
	  }
	
	  return {
	    parse: parse,
	    parseRows: parseRows,
	    format: format,
	    formatRows: formatRows
	  };
	};
	
	var csv = dsv(",");
	
	var csvParse = csv.parse;
	var csvParseRows = csv.parseRows;
	var csvFormat = csv.format;
	var csvFormatRows = csv.formatRows;
	
	var tsv = dsv("\t");
	
	var tsvParse = tsv.parse;
	var tsvParseRows = tsv.parseRows;
	var tsvFormat = tsv.format;
	var tsvFormatRows = tsv.formatRows;
	
	exports.dsvFormat = dsv;
	exports.csvParse = csvParse;
	exports.csvParseRows = csvParseRows;
	exports.csvFormat = csvFormat;
	exports.csvFormatRows = csvFormatRows;
	exports.tsvParse = tsvParse;
	exports.tsvParseRows = tsvParseRows;
	exports.tsvFormat = tsvFormat;
	exports.tsvFormatRows = tsvFormatRows;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-geo/ Version 1.6.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(7)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Array) { 'use strict';
	
	// Adds floating point numbers with twice the normal precision.
	// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
	// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
	// 305–363 (1997).
	// Code adapted from GeographicLib by Charles F. F. Karney,
	// http://geographiclib.sourceforge.net/
	
	var adder = function() {
	  return new Adder;
	};
	
	function Adder() {
	  this.reset();
	}
	
	Adder.prototype = {
	  constructor: Adder,
	  reset: function() {
	    this.s = // rounded value
	    this.t = 0; // exact error
	  },
	  add: function(y) {
	    add(temp, y, this.t);
	    add(this, temp.s, this.s);
	    if (this.s) this.t += temp.t;
	    else this.s = temp.t;
	  },
	  valueOf: function() {
	    return this.s;
	  }
	};
	
	var temp = new Adder;
	
	function add(adder, a, b) {
	  var x = adder.s = a + b,
	      bv = x - a,
	      av = x - bv;
	  adder.t = (a - av) + (b - bv);
	}
	
	var epsilon = 1e-6;
	var epsilon2 = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var quarterPi = pi / 4;
	var tau = pi * 2;
	
	var degrees = 180 / pi;
	var radians = pi / 180;
	
	var abs = Math.abs;
	var atan = Math.atan;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var ceil = Math.ceil;
	var exp = Math.exp;
	
	var log = Math.log;
	var pow = Math.pow;
	var sin = Math.sin;
	var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
	var sqrt = Math.sqrt;
	var tan = Math.tan;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
	}
	
	function haversin(x) {
	  return (x = sin(x / 2)) * x;
	}
	
	function noop() {}
	
	function streamGeometry(geometry, stream) {
	  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
	    streamGeometryType[geometry.type](geometry, stream);
	  }
	}
	
	var streamObjectType = {
	  Feature: function(object, stream) {
	    streamGeometry(object.geometry, stream);
	  },
	  FeatureCollection: function(object, stream) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) streamGeometry(features[i].geometry, stream);
	  }
	};
	
	var streamGeometryType = {
	  Sphere: function(object, stream) {
	    stream.sphere();
	  },
	  Point: function(object, stream) {
	    object = object.coordinates;
	    stream.point(object[0], object[1], object[2]);
	  },
	  MultiPoint: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
	  },
	  LineString: function(object, stream) {
	    streamLine(object.coordinates, stream, 0);
	  },
	  MultiLineString: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamLine(coordinates[i], stream, 0);
	  },
	  Polygon: function(object, stream) {
	    streamPolygon(object.coordinates, stream);
	  },
	  MultiPolygon: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamPolygon(coordinates[i], stream);
	  },
	  GeometryCollection: function(object, stream) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) streamGeometry(geometries[i], stream);
	  }
	};
	
	function streamLine(coordinates, stream, closed) {
	  var i = -1, n = coordinates.length - closed, coordinate;
	  stream.lineStart();
	  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
	  stream.lineEnd();
	}
	
	function streamPolygon(coordinates, stream) {
	  var i = -1, n = coordinates.length;
	  stream.polygonStart();
	  while (++i < n) streamLine(coordinates[i], stream, 1);
	  stream.polygonEnd();
	}
	
	var geoStream = function(object, stream) {
	  if (object && streamObjectType.hasOwnProperty(object.type)) {
	    streamObjectType[object.type](object, stream);
	  } else {
	    streamGeometry(object, stream);
	  }
	};
	
	var areaRingSum = adder();
	
	var areaSum = adder();
	var lambda00;
	var phi00;
	var lambda0;
	var cosPhi0;
	var sinPhi0;
	
	var areaStream = {
	  point: noop,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: function() {
	    areaRingSum.reset();
	    areaStream.lineStart = areaRingStart;
	    areaStream.lineEnd = areaRingEnd;
	  },
	  polygonEnd: function() {
	    var areaRing = +areaRingSum;
	    areaSum.add(areaRing < 0 ? tau + areaRing : areaRing);
	    this.lineStart = this.lineEnd = this.point = noop;
	  },
	  sphere: function() {
	    areaSum.add(tau);
	  }
	};
	
	function areaRingStart() {
	  areaStream.point = areaPointFirst;
	}
	
	function areaRingEnd() {
	  areaPoint(lambda00, phi00);
	}
	
	function areaPointFirst(lambda, phi) {
	  areaStream.point = areaPoint;
	  lambda00 = lambda, phi00 = phi;
	  lambda *= radians, phi *= radians;
	  lambda0 = lambda, cosPhi0 = cos(phi = phi / 2 + quarterPi), sinPhi0 = sin(phi);
	}
	
	function areaPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  phi = phi / 2 + quarterPi; // half the angular distance from south pole
	
	  // Spherical excess E for a spherical triangle with vertices: south pole,
	  // previous point, current point.  Uses a formula derived from Cagnoli’s
	  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
	  var dLambda = lambda - lambda0,
	      sdLambda = dLambda >= 0 ? 1 : -1,
	      adLambda = sdLambda * dLambda,
	      cosPhi = cos(phi),
	      sinPhi = sin(phi),
	      k = sinPhi0 * sinPhi,
	      u = cosPhi0 * cosPhi + k * cos(adLambda),
	      v = k * sdLambda * sin(adLambda);
	  areaRingSum.add(atan2(v, u));
	
	  // Advance the previous points.
	  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
	}
	
	var area = function(object) {
	  areaSum.reset();
	  geoStream(object, areaStream);
	  return areaSum * 2;
	};
	
	function spherical(cartesian) {
	  return [atan2(cartesian[1], cartesian[0]), asin(cartesian[2])];
	}
	
	function cartesian(spherical) {
	  var lambda = spherical[0], phi = spherical[1], cosPhi = cos(phi);
	  return [cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi)];
	}
	
	function cartesianDot(a, b) {
	  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	}
	
	function cartesianCross(a, b) {
	  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	}
	
	// TODO return a
	function cartesianAddInPlace(a, b) {
	  a[0] += b[0], a[1] += b[1], a[2] += b[2];
	}
	
	function cartesianScale(vector, k) {
	  return [vector[0] * k, vector[1] * k, vector[2] * k];
	}
	
	// TODO return d
	function cartesianNormalizeInPlace(d) {
	  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	  d[0] /= l, d[1] /= l, d[2] /= l;
	}
	
	var lambda0$1;
	var phi0;
	var lambda1;
	var phi1;
	var lambda2;
	var lambda00$1;
	var phi00$1;
	var p0;
	var deltaSum = adder();
	var ranges;
	var range$1;
	
	var boundsStream = {
	  point: boundsPoint,
	  lineStart: boundsLineStart,
	  lineEnd: boundsLineEnd,
	  polygonStart: function() {
	    boundsStream.point = boundsRingPoint;
	    boundsStream.lineStart = boundsRingStart;
	    boundsStream.lineEnd = boundsRingEnd;
	    deltaSum.reset();
	    areaStream.polygonStart();
	  },
	  polygonEnd: function() {
	    areaStream.polygonEnd();
	    boundsStream.point = boundsPoint;
	    boundsStream.lineStart = boundsLineStart;
	    boundsStream.lineEnd = boundsLineEnd;
	    if (areaRingSum < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
	    else if (deltaSum > epsilon) phi1 = 90;
	    else if (deltaSum < -epsilon) phi0 = -90;
	    range$1[0] = lambda0$1, range$1[1] = lambda1;
	  }
	};
	
	function boundsPoint(lambda, phi) {
	  ranges.push(range$1 = [lambda0$1 = lambda, lambda1 = lambda]);
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	}
	
	function linePoint(lambda, phi) {
	  var p = cartesian([lambda * radians, phi * radians]);
	  if (p0) {
	    var normal = cartesianCross(p0, p),
	        equatorial = [normal[1], -normal[0], 0],
	        inflection = cartesianCross(equatorial, normal);
	    cartesianNormalizeInPlace(inflection);
	    inflection = spherical(inflection);
	    var delta = lambda - lambda2,
	        sign$$1 = delta > 0 ? 1 : -1,
	        lambdai = inflection[0] * degrees * sign$$1,
	        phii,
	        antimeridian = abs(delta) > 180;
	    if (antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = inflection[1] * degrees;
	      if (phii > phi1) phi1 = phii;
	    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = -inflection[1] * degrees;
	      if (phii < phi0) phi0 = phii;
	    } else {
	      if (phi < phi0) phi0 = phi;
	      if (phi > phi1) phi1 = phi;
	    }
	    if (antimeridian) {
	      if (lambda < lambda2) {
	        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	      } else {
	        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	      }
	    } else {
	      if (lambda1 >= lambda0$1) {
	        if (lambda < lambda0$1) lambda0$1 = lambda;
	        if (lambda > lambda1) lambda1 = lambda;
	      } else {
	        if (lambda > lambda2) {
	          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	        } else {
	          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	        }
	      }
	    }
	  } else {
	    ranges.push(range$1 = [lambda0$1 = lambda, lambda1 = lambda]);
	  }
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	  p0 = p, lambda2 = lambda;
	}
	
	function boundsLineStart() {
	  boundsStream.point = linePoint;
	}
	
	function boundsLineEnd() {
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  boundsStream.point = boundsPoint;
	  p0 = null;
	}
	
	function boundsRingPoint(lambda, phi) {
	  if (p0) {
	    var delta = lambda - lambda2;
	    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
	  } else {
	    lambda00$1 = lambda, phi00$1 = phi;
	  }
	  areaStream.point(lambda, phi);
	  linePoint(lambda, phi);
	}
	
	function boundsRingStart() {
	  areaStream.lineStart();
	}
	
	function boundsRingEnd() {
	  boundsRingPoint(lambda00$1, phi00$1);
	  areaStream.lineEnd();
	  if (abs(deltaSum) > epsilon) lambda0$1 = -(lambda1 = 180);
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  p0 = null;
	}
	
	// Finds the left-right distance between two longitudes.
	// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
	// the distance between ±180° to be 360°.
	function angle(lambda0, lambda1) {
	  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
	}
	
	function rangeCompare(a, b) {
	  return a[0] - b[0];
	}
	
	function rangeContains(range$$1, x) {
	  return range$$1[0] <= range$$1[1] ? range$$1[0] <= x && x <= range$$1[1] : x < range$$1[0] || range$$1[1] < x;
	}
	
	var bounds = function(feature) {
	  var i, n, a, b, merged, deltaMax, delta;
	
	  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
	  ranges = [];
	  geoStream(feature, boundsStream);
	
	  // First, sort ranges by their minimum longitudes.
	  if (n = ranges.length) {
	    ranges.sort(rangeCompare);
	
	    // Then, merge any ranges that overlap.
	    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
	      b = ranges[i];
	      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
	        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	      } else {
	        merged.push(a = b);
	      }
	    }
	
	    // Finally, find the largest gap between the merged ranges.
	    // The final bounding box will be the inverse of this gap.
	    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
	      b = merged[i];
	      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
	    }
	  }
	
	  ranges = range$1 = null;
	
	  return lambda0$1 === Infinity || phi0 === Infinity
	      ? [[NaN, NaN], [NaN, NaN]]
	      : [[lambda0$1, phi0], [lambda1, phi1]];
	};
	
	var W0;
	var W1;
	var X0;
	var Y0;
	var Z0;
	var X1;
	var Y1;
	var Z1;
	var X2;
	var Y2;
	var Z2;
	var lambda00$2;
	var phi00$2;
	var x0;
	var y0;
	var z0; // previous point
	
	var centroidStream = {
	  sphere: noop,
	  point: centroidPoint,
	  lineStart: centroidLineStart,
	  lineEnd: centroidLineEnd,
	  polygonStart: function() {
	    centroidStream.lineStart = centroidRingStart;
	    centroidStream.lineEnd = centroidRingEnd;
	  },
	  polygonEnd: function() {
	    centroidStream.lineStart = centroidLineStart;
	    centroidStream.lineEnd = centroidLineEnd;
	  }
	};
	
	// Arithmetic mean of Cartesian vectors.
	function centroidPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi);
	  centroidPointCartesian(cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi));
	}
	
	function centroidPointCartesian(x, y, z) {
	  ++W0;
	  X0 += (x - X0) / W0;
	  Y0 += (y - Y0) / W0;
	  Z0 += (z - Z0) / W0;
	}
	
	function centroidLineStart() {
	  centroidStream.point = centroidLinePointFirst;
	}
	
	function centroidLinePointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi);
	  x0 = cosPhi * cos(lambda);
	  y0 = cosPhi * sin(lambda);
	  z0 = sin(phi);
	  centroidStream.point = centroidLinePoint;
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLinePoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi),
	      x = cosPhi * cos(lambda),
	      y = cosPhi * sin(lambda),
	      z = sin(phi),
	      w = atan2(sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLineEnd() {
	  centroidStream.point = centroidPoint;
	}
	
	// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
	// J. Applied Mechanics 42, 239 (1975).
	function centroidRingStart() {
	  centroidStream.point = centroidRingPointFirst;
	}
	
	function centroidRingEnd() {
	  centroidRingPoint(lambda00$2, phi00$2);
	  centroidStream.point = centroidPoint;
	}
	
	function centroidRingPointFirst(lambda, phi) {
	  lambda00$2 = lambda, phi00$2 = phi;
	  lambda *= radians, phi *= radians;
	  centroidStream.point = centroidRingPoint;
	  var cosPhi = cos(phi);
	  x0 = cosPhi * cos(lambda);
	  y0 = cosPhi * sin(lambda);
	  z0 = sin(phi);
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidRingPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi),
	      x = cosPhi * cos(lambda),
	      y = cosPhi * sin(lambda),
	      z = sin(phi),
	      cx = y0 * z - z0 * y,
	      cy = z0 * x - x0 * z,
	      cz = x0 * y - y0 * x,
	      m = sqrt(cx * cx + cy * cy + cz * cz),
	      w = asin(m), // line weight = angle
	      v = m && -w / m; // area weight multiplier
	  X2 += v * cx;
	  Y2 += v * cy;
	  Z2 += v * cz;
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	var centroid = function(object) {
	  W0 = W1 =
	  X0 = Y0 = Z0 =
	  X1 = Y1 = Z1 =
	  X2 = Y2 = Z2 = 0;
	  geoStream(object, centroidStream);
	
	  var x = X2,
	      y = Y2,
	      z = Z2,
	      m = x * x + y * y + z * z;
	
	  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
	  if (m < epsilon2) {
	    x = X1, y = Y1, z = Z1;
	    // If the feature has zero length, fall back to arithmetic mean of point vectors.
	    if (W1 < epsilon) x = X0, y = Y0, z = Z0;
	    m = x * x + y * y + z * z;
	    // If the feature still has an undefined ccentroid, then return.
	    if (m < epsilon2) return [NaN, NaN];
	  }
	
	  return [atan2(y, x) * degrees, asin(z / sqrt(m)) * degrees];
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var compose = function(a, b) {
	
	  function compose(x, y) {
	    return x = a(x, y), b(x[0], x[1]);
	  }
	
	  if (a.invert && b.invert) compose.invert = function(x, y) {
	    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	  };
	
	  return compose;
	};
	
	function rotationIdentity(lambda, phi) {
	  return [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
	}
	
	rotationIdentity.invert = rotationIdentity;
	
	function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
	  return (deltaLambda %= tau) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
	    : rotationLambda(deltaLambda))
	    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
	    : rotationIdentity);
	}
	
	function forwardRotationLambda(deltaLambda) {
	  return function(lambda, phi) {
	    return lambda += deltaLambda, [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
	  };
	}
	
	function rotationLambda(deltaLambda) {
	  var rotation = forwardRotationLambda(deltaLambda);
	  rotation.invert = forwardRotationLambda(-deltaLambda);
	  return rotation;
	}
	
	function rotationPhiGamma(deltaPhi, deltaGamma) {
	  var cosDeltaPhi = cos(deltaPhi),
	      sinDeltaPhi = sin(deltaPhi),
	      cosDeltaGamma = cos(deltaGamma),
	      sinDeltaGamma = sin(deltaGamma);
	
	  function rotation(lambda, phi) {
	    var cosPhi = cos(phi),
	        x = cos(lambda) * cosPhi,
	        y = sin(lambda) * cosPhi,
	        z = sin(phi),
	        k = z * cosDeltaPhi + x * sinDeltaPhi;
	    return [
	      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
	      asin(k * cosDeltaGamma + y * sinDeltaGamma)
	    ];
	  }
	
	  rotation.invert = function(lambda, phi) {
	    var cosPhi = cos(phi),
	        x = cos(lambda) * cosPhi,
	        y = sin(lambda) * cosPhi,
	        z = sin(phi),
	        k = z * cosDeltaGamma - y * sinDeltaGamma;
	    return [
	      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
	      asin(k * cosDeltaPhi - x * sinDeltaPhi)
	    ];
	  };
	
	  return rotation;
	}
	
	var rotation = function(rotate) {
	  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
	
	  function forward(coordinates) {
	    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
	  }
	
	  forward.invert = function(coordinates) {
	    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
	  };
	
	  return forward;
	};
	
	// Generates a circle centered at [0°, 0°], with a given radius and precision.
	function circleStream(stream, radius, delta, direction, t0, t1) {
	  if (!delta) return;
	  var cosRadius = cos(radius),
	      sinRadius = sin(radius),
	      step = direction * delta;
	  if (t0 == null) {
	    t0 = radius + direction * tau;
	    t1 = radius - step / 2;
	  } else {
	    t0 = circleRadius(cosRadius, t0);
	    t1 = circleRadius(cosRadius, t1);
	    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau;
	  }
	  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
	    point = spherical([cosRadius, -sinRadius * cos(t), -sinRadius * sin(t)]);
	    stream.point(point[0], point[1]);
	  }
	}
	
	// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
	function circleRadius(cosRadius, point) {
	  point = cartesian(point), point[0] -= cosRadius;
	  cartesianNormalizeInPlace(point);
	  var radius = acos(-point[1]);
	  return ((-point[2] < 0 ? -radius : radius) + tau - epsilon) % tau;
	}
	
	var circle = function() {
	  var center = constant([0, 0]),
	      radius = constant(90),
	      precision = constant(6),
	      ring,
	      rotate,
	      stream = {point: point};
	
	  function point(x, y) {
	    ring.push(x = rotate(x, y));
	    x[0] *= degrees, x[1] *= degrees;
	  }
	
	  function circle() {
	    var c = center.apply(this, arguments),
	        r = radius.apply(this, arguments) * radians,
	        p = precision.apply(this, arguments) * radians;
	    ring = [];
	    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
	    circleStream(stream, r, p, 1);
	    c = {type: "Polygon", coordinates: [ring]};
	    ring = rotate = null;
	    return c;
	  }
	
	  circle.center = function(_) {
	    return arguments.length ? (center = typeof _ === "function" ? _ : constant([+_[0], +_[1]]), circle) : center;
	  };
	
	  circle.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), circle) : radius;
	  };
	
	  circle.precision = function(_) {
	    return arguments.length ? (precision = typeof _ === "function" ? _ : constant(+_), circle) : precision;
	  };
	
	  return circle;
	};
	
	var clipBuffer = function() {
	  var lines = [],
	      line;
	  return {
	    point: function(x, y) {
	      line.push([x, y]);
	    },
	    lineStart: function() {
	      lines.push(line = []);
	    },
	    lineEnd: noop,
	    rejoin: function() {
	      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	    },
	    result: function() {
	      var result = lines;
	      lines = [];
	      line = null;
	      return result;
	    }
	  };
	};
	
	var clipLine = function(a, b, x0, y0, x1, y1) {
	  var ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
	  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
	  return true;
	};
	
	var pointEqual = function(a, b) {
	  return abs(a[0] - b[0]) < epsilon && abs(a[1] - b[1]) < epsilon;
	};
	
	function Intersection(point, points, other, entry) {
	  this.x = point;
	  this.z = points;
	  this.o = other; // another intersection
	  this.e = entry; // is an entry?
	  this.v = false; // visited
	  this.n = this.p = null; // next & previous
	}
	
	// A generalized polygon clipping algorithm: given a polygon that has been cut
	// into its visible line segments, and rejoins the segments by interpolating
	// along the clip edge.
	var clipPolygon = function(segments, compareIntersection, startInside, interpolate, stream) {
	  var subject = [],
	      clip = [],
	      i,
	      n;
	
	  segments.forEach(function(segment) {
	    if ((n = segment.length - 1) <= 0) return;
	    var n, p0 = segment[0], p1 = segment[n], x;
	
	    // If the first and last points of a segment are coincident, then treat as a
	    // closed ring. TODO if all rings are closed, then the winding order of the
	    // exterior ring should be checked.
	    if (pointEqual(p0, p1)) {
	      stream.lineStart();
	      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
	      stream.lineEnd();
	      return;
	    }
	
	    subject.push(x = new Intersection(p0, segment, null, true));
	    clip.push(x.o = new Intersection(p0, null, x, false));
	    subject.push(x = new Intersection(p1, segment, null, false));
	    clip.push(x.o = new Intersection(p1, null, x, true));
	  });
	
	  if (!subject.length) return;
	
	  clip.sort(compareIntersection);
	  link(subject);
	  link(clip);
	
	  for (i = 0, n = clip.length; i < n; ++i) {
	    clip[i].e = startInside = !startInside;
	  }
	
	  var start = subject[0],
	      points,
	      point;
	
	  while (1) {
	    // Find first unvisited intersection.
	    var current = start,
	        isSubject = true;
	    while (current.v) if ((current = current.n) === start) return;
	    points = current.z;
	    stream.lineStart();
	    do {
	      current.v = current.o.v = true;
	      if (current.e) {
	        if (isSubject) {
	          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.n.x, 1, stream);
	        }
	        current = current.n;
	      } else {
	        if (isSubject) {
	          points = current.p.z;
	          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.p.x, -1, stream);
	        }
	        current = current.p;
	      }
	      current = current.o;
	      points = current.z;
	      isSubject = !isSubject;
	    } while (!current.v);
	    stream.lineEnd();
	  }
	};
	
	function link(array) {
	  if (!(n = array.length)) return;
	  var n,
	      i = 0,
	      a = array[0],
	      b;
	  while (++i < n) {
	    a.n = b = array[i];
	    b.p = a;
	    a = b;
	  }
	  a.n = b = array[0];
	  b.p = a;
	}
	
	var clipMax = 1e9;
	var clipMin = -clipMax;
	
	// TODO Use d3-polygon’s polygonContains here for the ring check?
	// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?
	
	function clipExtent(x0, y0, x1, y1) {
	
	  function visible(x, y) {
	    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	  }
	
	  function interpolate(from, to, direction, stream) {
	    var a = 0, a1 = 0;
	    if (from == null
	        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
	        || comparePoint(from, to) < 0 ^ direction > 0) {
	      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	      while ((a = (a + direction + 4) % 4) !== a1);
	    } else {
	      stream.point(to[0], to[1]);
	    }
	  }
	
	  function corner(p, direction) {
	    return abs(p[0] - x0) < epsilon ? direction > 0 ? 0 : 3
	        : abs(p[0] - x1) < epsilon ? direction > 0 ? 2 : 1
	        : abs(p[1] - y0) < epsilon ? direction > 0 ? 1 : 0
	        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
	  }
	
	  function compareIntersection(a, b) {
	    return comparePoint(a.x, b.x);
	  }
	
	  function comparePoint(a, b) {
	    var ca = corner(a, 1),
	        cb = corner(b, 1);
	    return ca !== cb ? ca - cb
	        : ca === 0 ? b[1] - a[1]
	        : ca === 1 ? a[0] - b[0]
	        : ca === 2 ? a[1] - b[1]
	        : b[0] - a[0];
	  }
	
	  return function(stream) {
	    var activeStream = stream,
	        bufferStream = clipBuffer(),
	        segments,
	        polygon,
	        ring,
	        x__, y__, v__, // first point
	        x_, y_, v_, // previous point
	        first,
	        clean;
	
	    var clipStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: polygonStart,
	      polygonEnd: polygonEnd
	    };
	
	    function point(x, y) {
	      if (visible(x, y)) activeStream.point(x, y);
	    }
	
	    function polygonInside() {
	      var winding = 0;
	
	      for (var i = 0, n = polygon.length; i < n; ++i) {
	        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
	          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
	          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
	          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
	        }
	      }
	
	      return winding;
	    }
	
	    // Buffer geometry within a polygon and then clip it en masse.
	    function polygonStart() {
	      activeStream = bufferStream, segments = [], polygon = [], clean = true;
	    }
	
	    function polygonEnd() {
	      var startInside = polygonInside(),
	          cleanInside = clean && startInside,
	          visible = (segments = d3Array.merge(segments)).length;
	      if (cleanInside || visible) {
	        stream.polygonStart();
	        if (cleanInside) {
	          stream.lineStart();
	          interpolate(null, null, 1, stream);
	          stream.lineEnd();
	        }
	        if (visible) {
	          clipPolygon(segments, compareIntersection, startInside, interpolate, stream);
	        }
	        stream.polygonEnd();
	      }
	      activeStream = stream, segments = polygon = ring = null;
	    }
	
	    function lineStart() {
	      clipStream.point = linePoint;
	      if (polygon) polygon.push(ring = []);
	      first = true;
	      v_ = false;
	      x_ = y_ = NaN;
	    }
	
	    // TODO rather than special-case polygons, simply handle them separately.
	    // Ideally, coincident intersection points should be jittered to avoid
	    // clipping issues.
	    function lineEnd() {
	      if (segments) {
	        linePoint(x__, y__);
	        if (v__ && v_) bufferStream.rejoin();
	        segments.push(bufferStream.result());
	      }
	      clipStream.point = point;
	      if (v_) activeStream.lineEnd();
	    }
	
	    function linePoint(x, y) {
	      var v = visible(x, y);
	      if (polygon) ring.push([x, y]);
	      if (first) {
	        x__ = x, y__ = y, v__ = v;
	        first = false;
	        if (v) {
	          activeStream.lineStart();
	          activeStream.point(x, y);
	        }
	      } else {
	        if (v && v_) activeStream.point(x, y);
	        else {
	          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
	              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
	          if (clipLine(a, b, x0, y0, x1, y1)) {
	            if (!v_) {
	              activeStream.lineStart();
	              activeStream.point(a[0], a[1]);
	            }
	            activeStream.point(b[0], b[1]);
	            if (!v) activeStream.lineEnd();
	            clean = false;
	          } else if (v) {
	            activeStream.lineStart();
	            activeStream.point(x, y);
	            clean = false;
	          }
	        }
	      }
	      x_ = x, y_ = y, v_ = v;
	    }
	
	    return clipStream;
	  };
	}
	
	var extent = function() {
	  var x0 = 0,
	      y0 = 0,
	      x1 = 960,
	      y1 = 500,
	      cache,
	      cacheStream,
	      clip;
	
	  return clip = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
	    },
	    extent: function(_) {
	      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
	    }
	  };
	};
	
	var sum = adder();
	
	var polygonContains = function(polygon, point) {
	  var lambda = point[0],
	      phi = point[1],
	      normal = [sin(lambda), -cos(lambda), 0],
	      angle = 0,
	      winding = 0;
	
	  sum.reset();
	
	  for (var i = 0, n = polygon.length; i < n; ++i) {
	    if (!(m = (ring = polygon[i]).length)) continue;
	    var ring,
	        m,
	        point0 = ring[m - 1],
	        lambda0 = point0[0],
	        phi0 = point0[1] / 2 + quarterPi,
	        sinPhi0 = sin(phi0),
	        cosPhi0 = cos(phi0);
	
	    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
	      var point1 = ring[j],
	          lambda1 = point1[0],
	          phi1 = point1[1] / 2 + quarterPi,
	          sinPhi1 = sin(phi1),
	          cosPhi1 = cos(phi1),
	          delta = lambda1 - lambda0,
	          sign$$1 = delta >= 0 ? 1 : -1,
	          absDelta = sign$$1 * delta,
	          antimeridian = absDelta > pi,
	          k = sinPhi0 * sinPhi1;
	
	      sum.add(atan2(k * sign$$1 * sin(absDelta), cosPhi0 * cosPhi1 + k * cos(absDelta)));
	      angle += antimeridian ? delta + sign$$1 * tau : delta;
	
	      // Are the longitudes either side of the point’s meridian (lambda),
	      // and are the latitudes smaller than the parallel (phi)?
	      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
	        var arc = cartesianCross(cartesian(point0), cartesian(point1));
	        cartesianNormalizeInPlace(arc);
	        var intersection = cartesianCross(normal, arc);
	        cartesianNormalizeInPlace(intersection);
	        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection[2]);
	        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
	          winding += antimeridian ^ delta >= 0 ? 1 : -1;
	        }
	      }
	    }
	  }
	
	  // First, determine whether the South pole is inside or outside:
	  //
	  // It is inside if:
	  // * the polygon winds around it in a clockwise direction.
	  // * the polygon does not (cumulatively) wind around it, but has a negative
	  //   (counter-clockwise) area.
	  //
	  // Second, count the (signed) number of times a segment crosses a lambda
	  // from the point to the South pole.  If it is zero, then the point is the
	  // same side as the South pole.
	
	  return (angle < -epsilon || angle < epsilon && sum < -epsilon) ^ (winding & 1);
	};
	
	var lengthSum = adder();
	var lambda0$2;
	var sinPhi0$1;
	var cosPhi0$1;
	
	var lengthStream = {
	  sphere: noop,
	  point: noop,
	  lineStart: lengthLineStart,
	  lineEnd: noop,
	  polygonStart: noop,
	  polygonEnd: noop
	};
	
	function lengthLineStart() {
	  lengthStream.point = lengthPointFirst;
	  lengthStream.lineEnd = lengthLineEnd;
	}
	
	function lengthLineEnd() {
	  lengthStream.point = lengthStream.lineEnd = noop;
	}
	
	function lengthPointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  lambda0$2 = lambda, sinPhi0$1 = sin(phi), cosPhi0$1 = cos(phi);
	  lengthStream.point = lengthPoint;
	}
	
	function lengthPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var sinPhi = sin(phi),
	      cosPhi = cos(phi),
	      delta = abs(lambda - lambda0$2),
	      cosDelta = cos(delta),
	      sinDelta = sin(delta),
	      x = cosPhi * sinDelta,
	      y = cosPhi0$1 * sinPhi - sinPhi0$1 * cosPhi * cosDelta,
	      z = sinPhi0$1 * sinPhi + cosPhi0$1 * cosPhi * cosDelta;
	  lengthSum.add(atan2(sqrt(x * x + y * y), z));
	  lambda0$2 = lambda, sinPhi0$1 = sinPhi, cosPhi0$1 = cosPhi;
	}
	
	var length = function(object) {
	  lengthSum.reset();
	  geoStream(object, lengthStream);
	  return +lengthSum;
	};
	
	var coordinates = [null, null];
	var object = {type: "LineString", coordinates: coordinates};
	
	var distance = function(a, b) {
	  coordinates[0] = a;
	  coordinates[1] = b;
	  return length(object);
	};
	
	var containsObjectType = {
	  Feature: function(object, point) {
	    return containsGeometry(object.geometry, point);
	  },
	  FeatureCollection: function(object, point) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
	    return false;
	  }
	};
	
	var containsGeometryType = {
	  Sphere: function() {
	    return true;
	  },
	  Point: function(object, point) {
	    return containsPoint(object.coordinates, point);
	  },
	  MultiPoint: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
	    return false;
	  },
	  LineString: function(object, point) {
	    return containsLine(object.coordinates, point);
	  },
	  MultiLineString: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsLine(coordinates[i], point)) return true;
	    return false;
	  },
	  Polygon: function(object, point) {
	    return containsPolygon(object.coordinates, point);
	  },
	  MultiPolygon: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
	    return false;
	  },
	  GeometryCollection: function(object, point) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
	    return false;
	  }
	};
	
	function containsGeometry(geometry, point) {
	  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
	      ? containsGeometryType[geometry.type](geometry, point)
	      : false;
	}
	
	function containsPoint(coordinates, point) {
	  return distance(coordinates, point) === 0;
	}
	
	function containsLine(coordinates, point) {
	  var ab = distance(coordinates[0], coordinates[1]),
	      ao = distance(coordinates[0], point),
	      ob = distance(point, coordinates[1]);
	  return ao + ob <= ab + epsilon;
	}
	
	function containsPolygon(coordinates, point) {
	  return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
	}
	
	function ringRadians(ring) {
	  return ring = ring.map(pointRadians), ring.pop(), ring;
	}
	
	function pointRadians(point) {
	  return [point[0] * radians, point[1] * radians];
	}
	
	var contains = function(object, point) {
	  return (object && containsObjectType.hasOwnProperty(object.type)
	      ? containsObjectType[object.type]
	      : containsGeometry)(object, point);
	};
	
	function graticuleX(y0, y1, dy) {
	  var y = d3Array.range(y0, y1 - epsilon, dy).concat(y1);
	  return function(x) { return y.map(function(y) { return [x, y]; }); };
	}
	
	function graticuleY(x0, x1, dx) {
	  var x = d3Array.range(x0, x1 - epsilon, dx).concat(x1);
	  return function(y) { return x.map(function(x) { return [x, y]; }); };
	}
	
	function graticule() {
	  var x1, x0, X1, X0,
	      y1, y0, Y1, Y0,
	      dx = 10, dy = dx, DX = 90, DY = 360,
	      x, y, X, Y,
	      precision = 2.5;
	
	  function graticule() {
	    return {type: "MultiLineString", coordinates: lines()};
	  }
	
	  function lines() {
	    return d3Array.range(ceil(X0 / DX) * DX, X1, DX).map(X)
	        .concat(d3Array.range(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
	        .concat(d3Array.range(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon; }).map(x))
	        .concat(d3Array.range(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon; }).map(y));
	  }
	
	  graticule.lines = function() {
	    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
	  };
	
	  graticule.outline = function() {
	    return {
	      type: "Polygon",
	      coordinates: [
	        X(X0).concat(
	        Y(Y1).slice(1),
	        X(X1).reverse().slice(1),
	        Y(Y0).reverse().slice(1))
	      ]
	    };
	  };
	
	  graticule.extent = function(_) {
	    if (!arguments.length) return graticule.extentMinor();
	    return graticule.extentMajor(_).extentMinor(_);
	  };
	
	  graticule.extentMajor = function(_) {
	    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
	    X0 = +_[0][0], X1 = +_[1][0];
	    Y0 = +_[0][1], Y1 = +_[1][1];
	    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.extentMinor = function(_) {
	    if (!arguments.length) return [[x0, y0], [x1, y1]];
	    x0 = +_[0][0], x1 = +_[1][0];
	    y0 = +_[0][1], y1 = +_[1][1];
	    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.step = function(_) {
	    if (!arguments.length) return graticule.stepMinor();
	    return graticule.stepMajor(_).stepMinor(_);
	  };
	
	  graticule.stepMajor = function(_) {
	    if (!arguments.length) return [DX, DY];
	    DX = +_[0], DY = +_[1];
	    return graticule;
	  };
	
	  graticule.stepMinor = function(_) {
	    if (!arguments.length) return [dx, dy];
	    dx = +_[0], dy = +_[1];
	    return graticule;
	  };
	
	  graticule.precision = function(_) {
	    if (!arguments.length) return precision;
	    precision = +_;
	    x = graticuleX(y0, y1, 90);
	    y = graticuleY(x0, x1, precision);
	    X = graticuleX(Y0, Y1, 90);
	    Y = graticuleY(X0, X1, precision);
	    return graticule;
	  };
	
	  return graticule
	      .extentMajor([[-180, -90 + epsilon], [180, 90 - epsilon]])
	      .extentMinor([[-180, -80 - epsilon], [180, 80 + epsilon]]);
	}
	
	function graticule10() {
	  return graticule()();
	}
	
	var interpolate = function(a, b) {
	  var x0 = a[0] * radians,
	      y0 = a[1] * radians,
	      x1 = b[0] * radians,
	      y1 = b[1] * radians,
	      cy0 = cos(y0),
	      sy0 = sin(y0),
	      cy1 = cos(y1),
	      sy1 = sin(y1),
	      kx0 = cy0 * cos(x0),
	      ky0 = cy0 * sin(x0),
	      kx1 = cy1 * cos(x1),
	      ky1 = cy1 * sin(x1),
	      d = 2 * asin(sqrt(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
	      k = sin(d);
	
	  var interpolate = d ? function(t) {
	    var B = sin(t *= d) / k,
	        A = sin(d - t) / k,
	        x = A * kx0 + B * kx1,
	        y = A * ky0 + B * ky1,
	        z = A * sy0 + B * sy1;
	    return [
	      atan2(y, x) * degrees,
	      atan2(z, sqrt(x * x + y * y)) * degrees
	    ];
	  } : function() {
	    return [x0 * degrees, y0 * degrees];
	  };
	
	  interpolate.distance = d;
	
	  return interpolate;
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var areaSum$1 = adder();
	var areaRingSum$1 = adder();
	var x00;
	var y00;
	var x0$1;
	var y0$1;
	
	var areaStream$1 = {
	  point: noop,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: function() {
	    areaStream$1.lineStart = areaRingStart$1;
	    areaStream$1.lineEnd = areaRingEnd$1;
	  },
	  polygonEnd: function() {
	    areaStream$1.lineStart = areaStream$1.lineEnd = areaStream$1.point = noop;
	    areaSum$1.add(abs(areaRingSum$1));
	    areaRingSum$1.reset();
	  },
	  result: function() {
	    var area = areaSum$1 / 2;
	    areaSum$1.reset();
	    return area;
	  }
	};
	
	function areaRingStart$1() {
	  areaStream$1.point = areaPointFirst$1;
	}
	
	function areaPointFirst$1(x, y) {
	  areaStream$1.point = areaPoint$1;
	  x00 = x0$1 = x, y00 = y0$1 = y;
	}
	
	function areaPoint$1(x, y) {
	  areaRingSum$1.add(y0$1 * x - x0$1 * y);
	  x0$1 = x, y0$1 = y;
	}
	
	function areaRingEnd$1() {
	  areaPoint$1(x00, y00);
	}
	
	var x0$2 = Infinity;
	var y0$2 = x0$2;
	var x1 = -x0$2;
	var y1 = x1;
	
	var boundsStream$1 = {
	  point: boundsPoint$1,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: noop,
	  polygonEnd: noop,
	  result: function() {
	    var bounds = [[x0$2, y0$2], [x1, y1]];
	    x1 = y1 = -(y0$2 = x0$2 = Infinity);
	    return bounds;
	  }
	};
	
	function boundsPoint$1(x, y) {
	  if (x < x0$2) x0$2 = x;
	  if (x > x1) x1 = x;
	  if (y < y0$2) y0$2 = y;
	  if (y > y1) y1 = y;
	}
	
	// TODO Enforce positive area for exterior, negative area for interior?
	
	var X0$1 = 0;
	var Y0$1 = 0;
	var Z0$1 = 0;
	var X1$1 = 0;
	var Y1$1 = 0;
	var Z1$1 = 0;
	var X2$1 = 0;
	var Y2$1 = 0;
	var Z2$1 = 0;
	var x00$1;
	var y00$1;
	var x0$3;
	var y0$3;
	
	var centroidStream$1 = {
	  point: centroidPoint$1,
	  lineStart: centroidLineStart$1,
	  lineEnd: centroidLineEnd$1,
	  polygonStart: function() {
	    centroidStream$1.lineStart = centroidRingStart$1;
	    centroidStream$1.lineEnd = centroidRingEnd$1;
	  },
	  polygonEnd: function() {
	    centroidStream$1.point = centroidPoint$1;
	    centroidStream$1.lineStart = centroidLineStart$1;
	    centroidStream$1.lineEnd = centroidLineEnd$1;
	  },
	  result: function() {
	    var centroid = Z2$1 ? [X2$1 / Z2$1, Y2$1 / Z2$1]
	        : Z1$1 ? [X1$1 / Z1$1, Y1$1 / Z1$1]
	        : Z0$1 ? [X0$1 / Z0$1, Y0$1 / Z0$1]
	        : [NaN, NaN];
	    X0$1 = Y0$1 = Z0$1 =
	    X1$1 = Y1$1 = Z1$1 =
	    X2$1 = Y2$1 = Z2$1 = 0;
	    return centroid;
	  }
	};
	
	function centroidPoint$1(x, y) {
	  X0$1 += x;
	  Y0$1 += y;
	  ++Z0$1;
	}
	
	function centroidLineStart$1() {
	  centroidStream$1.point = centroidPointFirstLine;
	}
	
	function centroidPointFirstLine(x, y) {
	  centroidStream$1.point = centroidPointLine;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidPointLine(x, y) {
	  var dx = x - x0$3, dy = y - y0$3, z = sqrt(dx * dx + dy * dy);
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidLineEnd$1() {
	  centroidStream$1.point = centroidPoint$1;
	}
	
	function centroidRingStart$1() {
	  centroidStream$1.point = centroidPointFirstRing;
	}
	
	function centroidRingEnd$1() {
	  centroidPointRing(x00$1, y00$1);
	}
	
	function centroidPointFirstRing(x, y) {
	  centroidStream$1.point = centroidPointRing;
	  centroidPoint$1(x00$1 = x0$3 = x, y00$1 = y0$3 = y);
	}
	
	function centroidPointRing(x, y) {
	  var dx = x - x0$3,
	      dy = y - y0$3,
	      z = sqrt(dx * dx + dy * dy);
	
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	
	  z = y0$3 * x - x0$3 * y;
	  X2$1 += z * (x0$3 + x);
	  Y2$1 += z * (y0$3 + y);
	  Z2$1 += z * 3;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function PathContext(context) {
	  this._context = context;
	}
	
	PathContext.prototype = {
	  _radius: 4.5,
	  pointRadius: function(_) {
	    return this._radius = _, this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._context.closePath();
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._context.moveTo(x, y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._context.lineTo(x, y);
	        break;
	      }
	      default: {
	        this._context.moveTo(x + this._radius, y);
	        this._context.arc(x, y, this._radius, 0, tau);
	        break;
	      }
	    }
	  },
	  result: noop
	};
	
	var lengthSum$1 = adder();
	var lengthRing;
	var x00$2;
	var y00$2;
	var x0$4;
	var y0$4;
	
	var lengthStream$1 = {
	  point: noop,
	  lineStart: function() {
	    lengthStream$1.point = lengthPointFirst$1;
	  },
	  lineEnd: function() {
	    if (lengthRing) lengthPoint$1(x00$2, y00$2);
	    lengthStream$1.point = noop;
	  },
	  polygonStart: function() {
	    lengthRing = true;
	  },
	  polygonEnd: function() {
	    lengthRing = null;
	  },
	  result: function() {
	    var length = +lengthSum$1;
	    lengthSum$1.reset();
	    return length;
	  }
	};
	
	function lengthPointFirst$1(x, y) {
	  lengthStream$1.point = lengthPoint$1;
	  x00$2 = x0$4 = x, y00$2 = y0$4 = y;
	}
	
	function lengthPoint$1(x, y) {
	  x0$4 -= x, y0$4 -= y;
	  lengthSum$1.add(sqrt(x0$4 * x0$4 + y0$4 * y0$4));
	  x0$4 = x, y0$4 = y;
	}
	
	function PathString() {
	  this._string = [];
	}
	
	PathString.prototype = {
	  _radius: 4.5,
	  _circle: circle$1(4.5),
	  pointRadius: function(_) {
	    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
	    return this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._string.push("Z");
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._string.push("M", x, ",", y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._string.push("L", x, ",", y);
	        break;
	      }
	      default: {
	        if (this._circle == null) this._circle = circle$1(this._radius);
	        this._string.push("M", x, ",", y, this._circle);
	        break;
	      }
	    }
	  },
	  result: function() {
	    if (this._string.length) {
	      var result = this._string.join("");
	      this._string = [];
	      return result;
	    } else {
	      return null;
	    }
	  }
	};
	
	function circle$1(radius) {
	  return "m0," + radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
	      + "z";
	}
	
	var index = function(projection, context) {
	  var pointRadius = 4.5,
	      projectionStream,
	      contextStream;
	
	  function path(object) {
	    if (object) {
	      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	      geoStream(object, projectionStream(contextStream));
	    }
	    return contextStream.result();
	  }
	
	  path.area = function(object) {
	    geoStream(object, projectionStream(areaStream$1));
	    return areaStream$1.result();
	  };
	
	  path.measure = function(object) {
	    geoStream(object, projectionStream(lengthStream$1));
	    return lengthStream$1.result();
	  };
	
	  path.bounds = function(object) {
	    geoStream(object, projectionStream(boundsStream$1));
	    return boundsStream$1.result();
	  };
	
	  path.centroid = function(object) {
	    geoStream(object, projectionStream(centroidStream$1));
	    return centroidStream$1.result();
	  };
	
	  path.projection = function(_) {
	    return arguments.length ? (projectionStream = _ == null ? (projection = null, identity) : (projection = _).stream, path) : projection;
	  };
	
	  path.context = function(_) {
	    if (!arguments.length) return context;
	    contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
	    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	    return path;
	  };
	
	  path.pointRadius = function(_) {
	    if (!arguments.length) return pointRadius;
	    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	    return path;
	  };
	
	  return path.projection(projection).context(context);
	};
	
	var clip = function(pointVisible, clipLine, interpolate, start) {
	  return function(rotate, sink) {
	    var line = clipLine(sink),
	        rotatedStart = rotate.invert(start[0], start[1]),
	        ringBuffer = clipBuffer(),
	        ringSink = clipLine(ringBuffer),
	        polygonStarted = false,
	        polygon,
	        segments,
	        ring;
	
	    var clip = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        clip.point = pointRing;
	        clip.lineStart = ringStart;
	        clip.lineEnd = ringEnd;
	        segments = [];
	        polygon = [];
	      },
	      polygonEnd: function() {
	        clip.point = point;
	        clip.lineStart = lineStart;
	        clip.lineEnd = lineEnd;
	        segments = d3Array.merge(segments);
	        var startInside = polygonContains(polygon, rotatedStart);
	        if (segments.length) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          clipPolygon(segments, compareIntersection, startInside, interpolate, sink);
	        } else if (startInside) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          interpolate(null, null, 1, sink);
	          sink.lineEnd();
	        }
	        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
	        segments = polygon = null;
	      },
	      sphere: function() {
	        sink.polygonStart();
	        sink.lineStart();
	        interpolate(null, null, 1, sink);
	        sink.lineEnd();
	        sink.polygonEnd();
	      }
	    };
	
	    function point(lambda, phi) {
	      var point = rotate(lambda, phi);
	      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
	    }
	
	    function pointLine(lambda, phi) {
	      var point = rotate(lambda, phi);
	      line.point(point[0], point[1]);
	    }
	
	    function lineStart() {
	      clip.point = pointLine;
	      line.lineStart();
	    }
	
	    function lineEnd() {
	      clip.point = point;
	      line.lineEnd();
	    }
	
	    function pointRing(lambda, phi) {
	      ring.push([lambda, phi]);
	      var point = rotate(lambda, phi);
	      ringSink.point(point[0], point[1]);
	    }
	
	    function ringStart() {
	      ringSink.lineStart();
	      ring = [];
	    }
	
	    function ringEnd() {
	      pointRing(ring[0][0], ring[0][1]);
	      ringSink.lineEnd();
	
	      var clean = ringSink.clean(),
	          ringSegments = ringBuffer.result(),
	          i, n = ringSegments.length, m,
	          segment,
	          point;
	
	      ring.pop();
	      polygon.push(ring);
	      ring = null;
	
	      if (!n) return;
	
	      // No intersections.
	      if (clean & 1) {
	        segment = ringSegments[0];
	        if ((m = segment.length - 1) > 0) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
	          sink.lineEnd();
	        }
	        return;
	      }
	
	      // Rejoin connected segments.
	      // TODO reuse ringBuffer.rejoin()?
	      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	
	      segments.push(ringSegments.filter(validSegment));
	    }
	
	    return clip;
	  };
	};
	
	function validSegment(segment) {
	  return segment.length > 1;
	}
	
	// Intersections are sorted along the clip edge. For both antimeridian cutting
	// and circle clipping, the same comparison is used.
	function compareIntersection(a, b) {
	  return ((a = a.x)[0] < 0 ? a[1] - halfPi - epsilon : halfPi - a[1])
	       - ((b = b.x)[0] < 0 ? b[1] - halfPi - epsilon : halfPi - b[1]);
	}
	
	var clipAntimeridian = clip(
	  function() { return true; },
	  clipAntimeridianLine,
	  clipAntimeridianInterpolate,
	  [-pi, -halfPi]
	);
	
	// Takes a line and cuts into visible segments. Return values: 0 - there were
	// intersections or the line was empty; 1 - no intersections; 2 - there were
	// intersections, and the first and last segments should be rejoined.
	function clipAntimeridianLine(stream) {
	  var lambda0 = NaN,
	      phi0 = NaN,
	      sign0 = NaN,
	      clean; // no intersections
	
	  return {
	    lineStart: function() {
	      stream.lineStart();
	      clean = 1;
	    },
	    point: function(lambda1, phi1) {
	      var sign1 = lambda1 > 0 ? pi : -pi,
	          delta = abs(lambda1 - lambda0);
	      if (abs(delta - pi) < epsilon) { // line crosses a pole
	        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi : -halfPi);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        stream.point(lambda1, phi0);
	        clean = 0;
	      } else if (sign0 !== sign1 && delta >= pi) { // line crosses antimeridian
	        if (abs(lambda0 - sign0) < epsilon) lambda0 -= sign0 * epsilon; // handle degeneracies
	        if (abs(lambda1 - sign1) < epsilon) lambda1 -= sign1 * epsilon;
	        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        clean = 0;
	      }
	      stream.point(lambda0 = lambda1, phi0 = phi1);
	      sign0 = sign1;
	    },
	    lineEnd: function() {
	      stream.lineEnd();
	      lambda0 = phi0 = NaN;
	    },
	    clean: function() {
	      return 2 - clean; // if intersections, rejoin first and last segments
	    }
	  };
	}
	
	function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
	  var cosPhi0,
	      cosPhi1,
	      sinLambda0Lambda1 = sin(lambda0 - lambda1);
	  return abs(sinLambda0Lambda1) > epsilon
	      ? atan((sin(phi0) * (cosPhi1 = cos(phi1)) * sin(lambda1)
	          - sin(phi1) * (cosPhi0 = cos(phi0)) * sin(lambda0))
	          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
	      : (phi0 + phi1) / 2;
	}
	
	function clipAntimeridianInterpolate(from, to, direction, stream) {
	  var phi;
	  if (from == null) {
	    phi = direction * halfPi;
	    stream.point(-pi, phi);
	    stream.point(0, phi);
	    stream.point(pi, phi);
	    stream.point(pi, 0);
	    stream.point(pi, -phi);
	    stream.point(0, -phi);
	    stream.point(-pi, -phi);
	    stream.point(-pi, 0);
	    stream.point(-pi, phi);
	  } else if (abs(from[0] - to[0]) > epsilon) {
	    var lambda = from[0] < to[0] ? pi : -pi;
	    phi = direction * lambda / 2;
	    stream.point(-lambda, phi);
	    stream.point(0, phi);
	    stream.point(lambda, phi);
	  } else {
	    stream.point(to[0], to[1]);
	  }
	}
	
	var clipCircle = function(radius, delta) {
	  var cr = cos(radius),
	      smallRadius = cr > 0,
	      notHemisphere = abs(cr) > epsilon; // TODO optimise for this common case
	
	  function interpolate(from, to, direction, stream) {
	    circleStream(stream, radius, delta, direction, from, to);
	  }
	
	  function visible(lambda, phi) {
	    return cos(lambda) * cos(phi) > cr;
	  }
	
	  // Takes a line and cuts into visible segments. Return values used for polygon
	  // clipping: 0 - there were intersections or the line was empty; 1 - no
	  // intersections 2 - there were intersections, and the first and last segments
	  // should be rejoined.
	  function clipLine(stream) {
	    var point0, // previous point
	        c0, // code for previous point
	        v0, // visibility of previous point
	        v00, // visibility of first point
	        clean; // no intersections
	    return {
	      lineStart: function() {
	        v00 = v0 = false;
	        clean = 1;
	      },
	      point: function(lambda, phi) {
	        var point1 = [lambda, phi],
	            point2,
	            v = visible(lambda, phi),
	            c = smallRadius
	              ? v ? 0 : code(lambda, phi)
	              : v ? code(lambda + (lambda < 0 ? pi : -pi), phi) : 0;
	        if (!point0 && (v00 = v0 = v)) stream.lineStart();
	        // Handle degeneracies.
	        // TODO ignore if not clipping polygons.
	        if (v !== v0) {
	          point2 = intersect(point0, point1);
	          if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) {
	            point1[0] += epsilon;
	            point1[1] += epsilon;
	            v = visible(point1[0], point1[1]);
	          }
	        }
	        if (v !== v0) {
	          clean = 0;
	          if (v) {
	            // outside going in
	            stream.lineStart();
	            point2 = intersect(point1, point0);
	            stream.point(point2[0], point2[1]);
	          } else {
	            // inside going out
	            point2 = intersect(point0, point1);
	            stream.point(point2[0], point2[1]);
	            stream.lineEnd();
	          }
	          point0 = point2;
	        } else if (notHemisphere && point0 && smallRadius ^ v) {
	          var t;
	          // If the codes for two points are different, or are both zero,
	          // and there this segment intersects with the small circle.
	          if (!(c & c0) && (t = intersect(point1, point0, true))) {
	            clean = 0;
	            if (smallRadius) {
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	            } else {
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	            }
	          }
	        }
	        if (v && (!point0 || !pointEqual(point0, point1))) {
	          stream.point(point1[0], point1[1]);
	        }
	        point0 = point1, v0 = v, c0 = c;
	      },
	      lineEnd: function() {
	        if (v0) stream.lineEnd();
	        point0 = null;
	      },
	      // Rejoin first and last segments if there were intersections and the first
	      // and last points were visible.
	      clean: function() {
	        return clean | ((v00 && v0) << 1);
	      }
	    };
	  }
	
	  // Intersects the great circle between a and b with the clip circle.
	  function intersect(a, b, two) {
	    var pa = cartesian(a),
	        pb = cartesian(b);
	
	    // We have two planes, n1.p = d1 and n2.p = d2.
	    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
	    var n1 = [1, 0, 0], // normal
	        n2 = cartesianCross(pa, pb),
	        n2n2 = cartesianDot(n2, n2),
	        n1n2 = n2[0], // cartesianDot(n1, n2),
	        determinant = n2n2 - n1n2 * n1n2;
	
	    // Two polar points.
	    if (!determinant) return !two && a;
	
	    var c1 =  cr * n2n2 / determinant,
	        c2 = -cr * n1n2 / determinant,
	        n1xn2 = cartesianCross(n1, n2),
	        A = cartesianScale(n1, c1),
	        B = cartesianScale(n2, c2);
	    cartesianAddInPlace(A, B);
	
	    // Solve |p(t)|^2 = 1.
	    var u = n1xn2,
	        w = cartesianDot(A, u),
	        uu = cartesianDot(u, u),
	        t2 = w * w - uu * (cartesianDot(A, A) - 1);
	
	    if (t2 < 0) return;
	
	    var t = sqrt(t2),
	        q = cartesianScale(u, (-w - t) / uu);
	    cartesianAddInPlace(q, A);
	    q = spherical(q);
	
	    if (!two) return q;
	
	    // Two intersection points.
	    var lambda0 = a[0],
	        lambda1 = b[0],
	        phi0 = a[1],
	        phi1 = b[1],
	        z;
	
	    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
	
	    var delta = lambda1 - lambda0,
	        polar = abs(delta - pi) < epsilon,
	        meridian = polar || delta < epsilon;
	
	    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
	
	    // Check that the first point is between a and b.
	    if (meridian
	        ? polar
	          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon ? phi0 : phi1)
	          : phi0 <= q[1] && q[1] <= phi1
	        : delta > pi ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
	      var q1 = cartesianScale(u, (-w + t) / uu);
	      cartesianAddInPlace(q1, A);
	      return [q, spherical(q1)];
	    }
	  }
	
	  // Generates a 4-bit vector representing the location of a point relative to
	  // the small circle's bounding box.
	  function code(lambda, phi) {
	    var r = smallRadius ? radius : pi - radius,
	        code = 0;
	    if (lambda < -r) code |= 1; // left
	    else if (lambda > r) code |= 2; // right
	    if (phi < -r) code |= 4; // below
	    else if (phi > r) code |= 8; // above
	    return code;
	  }
	
	  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi, radius - pi]);
	};
	
	var transform = function(methods) {
	  return {
	    stream: transformer(methods)
	  };
	};
	
	function transformer(methods) {
	  return function(stream) {
	    var s = new TransformStream;
	    for (var key in methods) s[key] = methods[key];
	    s.stream = stream;
	    return s;
	  };
	}
	
	function TransformStream() {}
	
	TransformStream.prototype = {
	  constructor: TransformStream,
	  point: function(x, y) { this.stream.point(x, y); },
	  sphere: function() { this.stream.sphere(); },
	  lineStart: function() { this.stream.lineStart(); },
	  lineEnd: function() { this.stream.lineEnd(); },
	  polygonStart: function() { this.stream.polygonStart(); },
	  polygonEnd: function() { this.stream.polygonEnd(); }
	};
	
	function fitExtent(projection, extent, object) {
	  var w = extent[1][0] - extent[0][0],
	      h = extent[1][1] - extent[0][1],
	      clip = projection.clipExtent && projection.clipExtent();
	
	  projection
	      .scale(150)
	      .translate([0, 0]);
	
	  if (clip != null) projection.clipExtent(null);
	
	  geoStream(object, projection.stream(boundsStream$1));
	
	  var b = boundsStream$1.result(),
	      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
	      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
	      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
	
	  if (clip != null) projection.clipExtent(clip);
	
	  return projection
	      .scale(k * 150)
	      .translate([x, y]);
	}
	
	function fitSize(projection, size, object) {
	  return fitExtent(projection, [[0, 0], size], object);
	}
	
	var maxDepth = 16;
	var cosMinDistance = cos(30 * radians); // cos(minimum angular distance)
	
	var resample = function(project, delta2) {
	  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
	};
	
	function resampleNone(project) {
	  return transformer({
	    point: function(x, y) {
	      x = project(x, y);
	      this.stream.point(x[0], x[1]);
	    }
	  });
	}
	
	function resample$1(project, delta2) {
	
	  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
	    var dx = x1 - x0,
	        dy = y1 - y0,
	        d2 = dx * dx + dy * dy;
	    if (d2 > 4 * delta2 && depth--) {
	      var a = a0 + a1,
	          b = b0 + b1,
	          c = c0 + c1,
	          m = sqrt(a * a + b * b + c * c),
	          phi2 = asin(c /= m),
	          lambda2 = abs(abs(c) - 1) < epsilon || abs(lambda0 - lambda1) < epsilon ? (lambda0 + lambda1) / 2 : atan2(b, a),
	          p = project(lambda2, phi2),
	          x2 = p[0],
	          y2 = p[1],
	          dx2 = x2 - x0,
	          dy2 = y2 - y0,
	          dz = dy * dx2 - dx * dy2;
	      if (dz * dz / d2 > delta2 // perpendicular projected distance
	          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
	          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
	        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
	        stream.point(x2, y2);
	        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
	      }
	    }
	  }
	  return function(stream) {
	    var lambda00, x00, y00, a00, b00, c00, // first point
	        lambda0, x0, y0, a0, b0, c0; // previous point
	
	    var resampleStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
	      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
	    };
	
	    function point(x, y) {
	      x = project(x, y);
	      stream.point(x[0], x[1]);
	    }
	
	    function lineStart() {
	      x0 = NaN;
	      resampleStream.point = linePoint;
	      stream.lineStart();
	    }
	
	    function linePoint(lambda, phi) {
	      var c = cartesian([lambda, phi]), p = project(lambda, phi);
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	      stream.point(x0, y0);
	    }
	
	    function lineEnd() {
	      resampleStream.point = point;
	      stream.lineEnd();
	    }
	
	    function ringStart() {
	      lineStart();
	      resampleStream.point = ringPoint;
	      resampleStream.lineEnd = ringEnd;
	    }
	
	    function ringPoint(lambda, phi) {
	      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	      resampleStream.point = linePoint;
	    }
	
	    function ringEnd() {
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
	      resampleStream.lineEnd = lineEnd;
	      lineEnd();
	    }
	
	    return resampleStream;
	  };
	}
	
	var transformRadians = transformer({
	  point: function(x, y) {
	    this.stream.point(x * radians, y * radians);
	  }
	});
	
	function projection(project) {
	  return projectionMutator(function() { return project; })();
	}
	
	function projectionMutator(projectAt) {
	  var project,
	      k = 150, // scale
	      x = 480, y = 250, // translate
	      dx, dy, lambda = 0, phi = 0, // center
	      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
	      theta = null, preclip = clipAntimeridian, // clip angle
	      x0 = null, y0, x1, y1, postclip = identity, // clip extent
	      delta2 = 0.5, projectResample = resample(projectTransform, delta2), // precision
	      cache,
	      cacheStream;
	
	  function projection(point) {
	    point = projectRotate(point[0] * radians, point[1] * radians);
	    return [point[0] * k + dx, dy - point[1] * k];
	  }
	
	  function invert(point) {
	    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
	    return point && [point[0] * degrees, point[1] * degrees];
	  }
	
	  function projectTransform(x, y) {
	    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
	  }
	
	  projection.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
	  };
	
	  projection.clipAngle = function(_) {
	    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians, 6 * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees;
	  };
	
	  projection.clipExtent = function(_) {
	    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  projection.scale = function(_) {
	    return arguments.length ? (k = +_, recenter()) : k;
	  };
	
	  projection.translate = function(_) {
	    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
	  };
	
	  projection.center = function(_) {
	    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees, phi * degrees];
	  };
	
	  projection.rotate = function(_) {
	    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees, deltaPhi * degrees, deltaGamma * degrees];
	  };
	
	  projection.precision = function(_) {
	    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
	  };
	
	  projection.fitExtent = function(extent, object) {
	    return fitExtent(projection, extent, object);
	  };
	
	  projection.fitSize = function(size, object) {
	    return fitSize(projection, size, object);
	  };
	
	  function recenter() {
	    projectRotate = compose(rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma), project);
	    var center = project(lambda, phi);
	    dx = x - center[0] * k;
	    dy = y + center[1] * k;
	    return reset();
	  }
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return function() {
	    project = projectAt.apply(this, arguments);
	    projection.invert = project.invert && invert;
	    return recenter();
	  };
	}
	
	function conicProjection(projectAt) {
	  var phi0 = 0,
	      phi1 = pi / 3,
	      m = projectionMutator(projectAt),
	      p = m(phi0, phi1);
	
	  p.parallels = function(_) {
	    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees, phi1 * degrees];
	  };
	
	  return p;
	}
	
	function cylindricalEqualAreaRaw(phi0) {
	  var cosPhi0 = cos(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda * cosPhi0, sin(phi) / cosPhi0];
	  }
	
	  forward.invert = function(x, y) {
	    return [x / cosPhi0, asin(y * cosPhi0)];
	  };
	
	  return forward;
	}
	
	function conicEqualAreaRaw(y0, y1) {
	  var sy0 = sin(y0), n = (sy0 + sin(y1)) / 2;
	
	  // Are the parallels symmetrical around the Equator?
	  if (abs(n) < epsilon) return cylindricalEqualAreaRaw(y0);
	
	  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c) / n;
	
	  function project(x, y) {
	    var r = sqrt(c - 2 * n * sin(y)) / n;
	    return [r * sin(x *= n), r0 - r * cos(x)];
	  }
	
	  project.invert = function(x, y) {
	    var r0y = r0 - y;
	    return [atan2(x, abs(r0y)) / n * sign(r0y), asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
	  };
	
	  return project;
	}
	
	var conicEqualArea = function() {
	  return conicProjection(conicEqualAreaRaw)
	      .scale(155.424)
	      .center([0, 33.6442]);
	};
	
	var albers = function() {
	  return conicEqualArea()
	      .parallels([29.5, 45.5])
	      .scale(1070)
	      .translate([480, 250])
	      .rotate([96, 0])
	      .center([-0.6, 38.7]);
	};
	
	// The projections must have mutually exclusive clip regions on the sphere,
	// as this will avoid emitting interleaving lines and polygons.
	function multiplex(streams) {
	  var n = streams.length;
	  return {
	    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
	    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
	    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
	    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
	    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
	    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
	  };
	}
	
	// A composite projection for the United States, configured by default for
	// 960×500. The projection also works quite well at 960×600 if you change the
	// scale to 1285 and adjust the translate accordingly. The set of standard
	// parallels for each region comes from USGS, which is published here:
	// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
	var albersUsa = function() {
	  var cache,
	      cacheStream,
	      lower48 = albers(), lower48Point,
	      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
	      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
	      point, pointStream = {point: function(x, y) { point = [x, y]; }};
	
	  function albersUsa(coordinates) {
	    var x = coordinates[0], y = coordinates[1];
	    return point = null,
	        (lower48Point.point(x, y), point)
	        || (alaskaPoint.point(x, y), point)
	        || (hawaiiPoint.point(x, y), point);
	  }
	
	  albersUsa.invert = function(coordinates) {
	    var k = lower48.scale(),
	        t = lower48.translate(),
	        x = (coordinates[0] - t[0]) / k,
	        y = (coordinates[1] - t[1]) / k;
	    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
	        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
	        : lower48).invert(coordinates);
	  };
	
	  albersUsa.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
	  };
	
	  albersUsa.precision = function(_) {
	    if (!arguments.length) return lower48.precision();
	    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
	    return reset();
	  };
	
	  albersUsa.scale = function(_) {
	    if (!arguments.length) return lower48.scale();
	    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
	    return albersUsa.translate(lower48.translate());
	  };
	
	  albersUsa.translate = function(_) {
	    if (!arguments.length) return lower48.translate();
	    var k = lower48.scale(), x = +_[0], y = +_[1];
	
	    lower48Point = lower48
	        .translate(_)
	        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
	        .stream(pointStream);
	
	    alaskaPoint = alaska
	        .translate([x - 0.307 * k, y + 0.201 * k])
	        .clipExtent([[x - 0.425 * k + epsilon, y + 0.120 * k + epsilon], [x - 0.214 * k - epsilon, y + 0.234 * k - epsilon]])
	        .stream(pointStream);
	
	    hawaiiPoint = hawaii
	        .translate([x - 0.205 * k, y + 0.212 * k])
	        .clipExtent([[x - 0.214 * k + epsilon, y + 0.166 * k + epsilon], [x - 0.115 * k - epsilon, y + 0.234 * k - epsilon]])
	        .stream(pointStream);
	
	    return reset();
	  };
	
	  albersUsa.fitExtent = function(extent, object) {
	    return fitExtent(albersUsa, extent, object);
	  };
	
	  albersUsa.fitSize = function(size, object) {
	    return fitSize(albersUsa, size, object);
	  };
	
	  function reset() {
	    cache = cacheStream = null;
	    return albersUsa;
	  }
	
	  return albersUsa.scale(1070);
	};
	
	function azimuthalRaw(scale) {
	  return function(x, y) {
	    var cx = cos(x),
	        cy = cos(y),
	        k = scale(cx * cy);
	    return [
	      k * cy * sin(x),
	      k * sin(y)
	    ];
	  }
	}
	
	function azimuthalInvert(angle) {
	  return function(x, y) {
	    var z = sqrt(x * x + y * y),
	        c = angle(z),
	        sc = sin(c),
	        cc = cos(c);
	    return [
	      atan2(x * sc, z * cc),
	      asin(z && y * sc / z)
	    ];
	  }
	}
	
	var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
	  return sqrt(2 / (1 + cxcy));
	});
	
	azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
	  return 2 * asin(z / 2);
	});
	
	var azimuthalEqualArea = function() {
	  return projection(azimuthalEqualAreaRaw)
	      .scale(124.75)
	      .clipAngle(180 - 1e-3);
	};
	
	var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
	  return (c = acos(c)) && c / sin(c);
	});
	
	azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
	  return z;
	});
	
	var azimuthalEquidistant = function() {
	  return projection(azimuthalEquidistantRaw)
	      .scale(79.4188)
	      .clipAngle(180 - 1e-3);
	};
	
	function mercatorRaw(lambda, phi) {
	  return [lambda, log(tan((halfPi + phi) / 2))];
	}
	
	mercatorRaw.invert = function(x, y) {
	  return [x, 2 * atan(exp(y)) - halfPi];
	};
	
	var mercator = function() {
	  return mercatorProjection(mercatorRaw)
	      .scale(961 / tau);
	};
	
	function mercatorProjection(project) {
	  var m = projection(project),
	      center = m.center,
	      scale = m.scale,
	      translate = m.translate,
	      clipExtent = m.clipExtent,
	      x0 = null, y0, x1, y1; // clip extent
	
	  m.scale = function(_) {
	    return arguments.length ? (scale(_), reclip()) : scale();
	  };
	
	  m.translate = function(_) {
	    return arguments.length ? (translate(_), reclip()) : translate();
	  };
	
	  m.center = function(_) {
	    return arguments.length ? (center(_), reclip()) : center();
	  };
	
	  m.clipExtent = function(_) {
	    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  function reclip() {
	    var k = pi * scale(),
	        t = m(rotation(m.rotate()).invert([0, 0]));
	    return clipExtent(x0 == null
	        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
	        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
	        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
	  }
	
	  return reclip();
	}
	
	function tany(y) {
	  return tan((halfPi + y) / 2);
	}
	
	function conicConformalRaw(y0, y1) {
	  var cy0 = cos(y0),
	      n = y0 === y1 ? sin(y0) : log(cy0 / cos(y1)) / log(tany(y1) / tany(y0)),
	      f = cy0 * pow(tany(y0), n) / n;
	
	  if (!n) return mercatorRaw;
	
	  function project(x, y) {
	    if (f > 0) { if (y < -halfPi + epsilon) y = -halfPi + epsilon; }
	    else { if (y > halfPi - epsilon) y = halfPi - epsilon; }
	    var r = f / pow(tany(y), n);
	    return [r * sin(n * x), f - r * cos(n * x)];
	  }
	
	  project.invert = function(x, y) {
	    var fy = f - y, r = sign(n) * sqrt(x * x + fy * fy);
	    return [atan2(x, abs(fy)) / n * sign(fy), 2 * atan(pow(f / r, 1 / n)) - halfPi];
	  };
	
	  return project;
	}
	
	var conicConformal = function() {
	  return conicProjection(conicConformalRaw)
	      .scale(109.5)
	      .parallels([30, 30]);
	};
	
	function equirectangularRaw(lambda, phi) {
	  return [lambda, phi];
	}
	
	equirectangularRaw.invert = equirectangularRaw;
	
	var equirectangular = function() {
	  return projection(equirectangularRaw)
	      .scale(152.63);
	};
	
	function conicEquidistantRaw(y0, y1) {
	  var cy0 = cos(y0),
	      n = y0 === y1 ? sin(y0) : (cy0 - cos(y1)) / (y1 - y0),
	      g = cy0 / n + y0;
	
	  if (abs(n) < epsilon) return equirectangularRaw;
	
	  function project(x, y) {
	    var gy = g - y, nx = n * x;
	    return [gy * sin(nx), g - gy * cos(nx)];
	  }
	
	  project.invert = function(x, y) {
	    var gy = g - y;
	    return [atan2(x, abs(gy)) / n * sign(gy), g - sign(n) * sqrt(x * x + gy * gy)];
	  };
	
	  return project;
	}
	
	var conicEquidistant = function() {
	  return conicProjection(conicEquidistantRaw)
	      .scale(131.154)
	      .center([0, 13.9389]);
	};
	
	function gnomonicRaw(x, y) {
	  var cy = cos(y), k = cos(x) * cy;
	  return [cy * sin(x) / k, sin(y) / k];
	}
	
	gnomonicRaw.invert = azimuthalInvert(atan);
	
	var gnomonic = function() {
	  return projection(gnomonicRaw)
	      .scale(144.049)
	      .clipAngle(60);
	};
	
	function scaleTranslate(kx, ky, tx, ty) {
	  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? identity : transformer({
	    point: function(x, y) {
	      this.stream.point(x * kx + tx, y * ky + ty);
	    }
	  });
	}
	
	var identity$1 = function() {
	  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = identity, // scale, translate and reflect
	      x0 = null, y0, x1, y1, clip = identity, // clip extent
	      cache,
	      cacheStream,
	      projection;
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return projection = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = transform(clip(cacheStream = stream));
	    },
	    clipExtent: function(_) {
	      return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	    },
	    scale: function(_) {
	      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
	    },
	    translate: function(_) {
	      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
	    },
	    reflectX: function(_) {
	      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
	    },
	    reflectY: function(_) {
	      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
	    },
	    fitExtent: function(extent, object) {
	      return fitExtent(projection, extent, object);
	    },
	    fitSize: function(size, object) {
	      return fitSize(projection, size, object);
	    }
	  };
	};
	
	function orthographicRaw(x, y) {
	  return [cos(y) * sin(x), sin(y)];
	}
	
	orthographicRaw.invert = azimuthalInvert(asin);
	
	var orthographic = function() {
	  return projection(orthographicRaw)
	      .scale(249.5)
	      .clipAngle(90 + epsilon);
	};
	
	function stereographicRaw(x, y) {
	  var cy = cos(y), k = 1 + cos(x) * cy;
	  return [cy * sin(x) / k, sin(y) / k];
	}
	
	stereographicRaw.invert = azimuthalInvert(function(z) {
	  return 2 * atan(z);
	});
	
	var stereographic = function() {
	  return projection(stereographicRaw)
	      .scale(250)
	      .clipAngle(142);
	};
	
	function transverseMercatorRaw(lambda, phi) {
	  return [log(tan((halfPi + phi) / 2)), -lambda];
	}
	
	transverseMercatorRaw.invert = function(x, y) {
	  return [-y, 2 * atan(exp(x)) - halfPi];
	};
	
	var transverseMercator = function() {
	  var m = mercatorProjection(transverseMercatorRaw),
	      center = m.center,
	      rotate = m.rotate;
	
	  m.center = function(_) {
	    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
	  };
	
	  m.rotate = function(_) {
	    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
	  };
	
	  return rotate([0, 0, 90])
	      .scale(159.155);
	};
	
	exports.geoArea = area;
	exports.geoBounds = bounds;
	exports.geoCentroid = centroid;
	exports.geoCircle = circle;
	exports.geoClipExtent = extent;
	exports.geoContains = contains;
	exports.geoDistance = distance;
	exports.geoGraticule = graticule;
	exports.geoGraticule10 = graticule10;
	exports.geoInterpolate = interpolate;
	exports.geoLength = length;
	exports.geoPath = index;
	exports.geoAlbers = albers;
	exports.geoAlbersUsa = albersUsa;
	exports.geoAzimuthalEqualArea = azimuthalEqualArea;
	exports.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
	exports.geoAzimuthalEquidistant = azimuthalEquidistant;
	exports.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
	exports.geoConicConformal = conicConformal;
	exports.geoConicConformalRaw = conicConformalRaw;
	exports.geoConicEqualArea = conicEqualArea;
	exports.geoConicEqualAreaRaw = conicEqualAreaRaw;
	exports.geoConicEquidistant = conicEquidistant;
	exports.geoConicEquidistantRaw = conicEquidistantRaw;
	exports.geoEquirectangular = equirectangular;
	exports.geoEquirectangularRaw = equirectangularRaw;
	exports.geoGnomonic = gnomonic;
	exports.geoGnomonicRaw = gnomonicRaw;
	exports.geoIdentity = identity$1;
	exports.geoProjection = projection;
	exports.geoProjectionMutator = projectionMutator;
	exports.geoMercator = mercator;
	exports.geoMercatorRaw = mercatorRaw;
	exports.geoOrthographic = orthographic;
	exports.geoOrthographicRaw = orthographicRaw;
	exports.geoStereographic = stereographic;
	exports.geoStereographicRaw = stereographicRaw;
	exports.geoTransverseMercator = transverseMercator;
	exports.geoTransverseMercatorRaw = transverseMercatorRaw;
	exports.geoRotation = rotation;
	exports.geoStream = geoStream;
	exports.geoTransform = transform;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.1.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(8)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb$1 = ((function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	}))(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = d3Color.rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(nb),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var number = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var string = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var value = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	      : b instanceof d3Color.color ? rgb$1
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	};
	
	var round = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var zoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb$1;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ Version 1.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI;
	var tau = 2 * pi;
	var epsilon = 1e-6;
	var tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.6. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(7), __webpack_require__(29), __webpack_require__(32), __webpack_require__(9), __webpack_require__(11), __webpack_require__(10), __webpack_require__(8)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = d3Array.tickStep(start, stop, interval);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-selection/ Version 1.1.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var xhtml = "http://www.w3.org/1999/xhtml";
	
	var namespaces = {
	  svg: "http://www.w3.org/2000/svg",
	  xhtml: xhtml,
	  xlink: "http://www.w3.org/1999/xlink",
	  xml: "http://www.w3.org/XML/1998/namespace",
	  xmlns: "http://www.w3.org/2000/xmlns/"
	};
	
	var namespace = function(name) {
	  var prefix = name += "", i = prefix.indexOf(":");
	  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
	};
	
	function creatorInherit(name) {
	  return function() {
	    var document = this.ownerDocument,
	        uri = this.namespaceURI;
	    return uri === xhtml && document.documentElement.namespaceURI === xhtml
	        ? document.createElement(name)
	        : document.createElementNS(uri, name);
	  };
	}
	
	function creatorFixed(fullname) {
	  return function() {
	    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
	  };
	}
	
	var creator = function(name) {
	  var fullname = namespace(name);
	  return (fullname.local
	      ? creatorFixed
	      : creatorInherit)(fullname);
	};
	
	var nextId = 0;
	
	function local() {
	  return new Local;
	}
	
	function Local() {
	  this._ = "@" + (++nextId).toString(36);
	}
	
	Local.prototype = local.prototype = {
	  constructor: Local,
	  get: function(node) {
	    var id = this._;
	    while (!(id in node)) if (!(node = node.parentNode)) return;
	    return node[id];
	  },
	  set: function(node, value) {
	    return node[this._] = value;
	  },
	  remove: function(node) {
	    return this._ in node && delete node[this._];
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	var matcher = function(selector) {
	  return function() {
	    return this.matches(selector);
	  };
	};
	
	if (typeof document !== "undefined") {
	  var element = document.documentElement;
	  if (!element.matches) {
	    var vendorMatches = element.webkitMatchesSelector
	        || element.msMatchesSelector
	        || element.mozMatchesSelector
	        || element.oMatchesSelector;
	    matcher = function(selector) {
	      return function() {
	        return vendorMatches.call(this, selector);
	      };
	    };
	  }
	}
	
	var matcher$1 = matcher;
	
	var filterEvents = {};
	
	exports.event = null;
	
	if (typeof document !== "undefined") {
	  var element$1 = document.documentElement;
	  if (!("onmouseenter" in element$1)) {
	    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
	  }
	}
	
	function filterContextListener(listener, index, group) {
	  listener = contextListener(listener, index, group);
	  return function(event) {
	    var related = event.relatedTarget;
	    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
	      listener.call(this, event);
	    }
	  };
	}
	
	function contextListener(listener, index, group) {
	  return function(event1) {
	    var event0 = exports.event; // Events can be reentrant (e.g., focus).
	    exports.event = event1;
	    try {
	      listener.call(this, this.__data__, index, group);
	    } finally {
	      exports.event = event0;
	    }
	  };
	}
	
	function parseTypenames(typenames) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    return {type: t, name: name};
	  });
	}
	
	function onRemove(typename) {
	  return function() {
	    var on = this.__on;
	    if (!on) return;
	    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
	      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	      } else {
	        on[++i] = o;
	      }
	    }
	    if (++i) on.length = i;
	    else delete this.__on;
	  };
	}
	
	function onAdd(typename, value, capture) {
	  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
	  return function(d, i, group) {
	    var on = this.__on, o, listener = wrap(value, i, group);
	    if (on) for (var j = 0, m = on.length; j < m; ++j) {
	      if ((o = on[j]).type === typename.type && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
	        o.value = value;
	        return;
	      }
	    }
	    this.addEventListener(typename.type, listener, capture);
	    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
	    if (!on) this.__on = [o];
	    else on.push(o);
	  };
	}
	
	var selection_on = function(typename, value, capture) {
	  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
	
	  if (arguments.length < 2) {
	    var on = this.node().__on;
	    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
	      for (i = 0, o = on[j]; i < n; ++i) {
	        if ((t = typenames[i]).type === o.type && t.name === o.name) {
	          return o.value;
	        }
	      }
	    }
	    return;
	  }
	
	  on = value ? onAdd : onRemove;
	  if (capture == null) capture = false;
	  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
	  return this;
	};
	
	function customEvent(event1, listener, that, args) {
	  var event0 = exports.event;
	  event1.sourceEvent = exports.event;
	  exports.event = event1;
	  try {
	    return listener.apply(that, args);
	  } finally {
	    exports.event = event0;
	  }
	}
	
	var sourceEvent = function() {
	  var current = exports.event, source;
	  while (source = current.sourceEvent) current = source;
	  return current;
	};
	
	var point = function(node, event) {
	  var svg = node.ownerSVGElement || node;
	
	  if (svg.createSVGPoint) {
	    var point = svg.createSVGPoint();
	    point.x = event.clientX, point.y = event.clientY;
	    point = point.matrixTransform(node.getScreenCTM().inverse());
	    return [point.x, point.y];
	  }
	
	  var rect = node.getBoundingClientRect();
	  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
	};
	
	var mouse = function(node) {
	  var event = sourceEvent();
	  if (event.changedTouches) event = event.changedTouches[0];
	  return point(node, event);
	};
	
	function none() {}
	
	var selector = function(selector) {
	  return selector == null ? none : function() {
	    return this.querySelector(selector);
	  };
	};
	
	var selection_select = function(select) {
	  if (typeof select !== "function") select = selector(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	};
	
	function empty() {
	  return [];
	}
	
	var selectorAll = function(selector) {
	  return selector == null ? empty : function() {
	    return this.querySelectorAll(selector);
	  };
	};
	
	var selection_selectAll = function(select) {
	  if (typeof select !== "function") select = selectorAll(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        subgroups.push(select.call(node, node.__data__, i, group));
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, parents);
	};
	
	var selection_filter = function(match) {
	  if (typeof match !== "function") match = matcher$1(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	};
	
	var sparse = function(update) {
	  return new Array(update.length);
	};
	
	var selection_enter = function() {
	  return new Selection(this._enter || this._groups.map(sparse), this._parents);
	};
	
	function EnterNode(parent, datum) {
	  this.ownerDocument = parent.ownerDocument;
	  this.namespaceURI = parent.namespaceURI;
	  this._next = null;
	  this._parent = parent;
	  this.__data__ = datum;
	}
	
	EnterNode.prototype = {
	  constructor: EnterNode,
	  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
	  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
	  querySelector: function(selector) { return this._parent.querySelector(selector); },
	  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var keyPrefix = "$"; // Protect against keys like “__proto__”.
	
	function bindIndex(parent, group, enter, update, exit, data) {
	  var i = 0,
	      node,
	      groupLength = group.length,
	      dataLength = data.length;
	
	  // Put any non-null nodes that fit into update.
	  // Put any null nodes into enter.
	  // Put any remaining data into enter.
	  for (; i < dataLength; ++i) {
	    if (node = group[i]) {
	      node.__data__ = data[i];
	      update[i] = node;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Put any non-null nodes that don’t fit into exit.
	  for (; i < groupLength; ++i) {
	    if (node = group[i]) {
	      exit[i] = node;
	    }
	  }
	}
	
	function bindKey(parent, group, enter, update, exit, data, key) {
	  var i,
	      node,
	      nodeByKeyValue = {},
	      groupLength = group.length,
	      dataLength = data.length,
	      keyValues = new Array(groupLength),
	      keyValue;
	
	  // Compute the key for each node.
	  // If multiple nodes have the same key, the duplicates are added to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if (node = group[i]) {
	      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
	      if (keyValue in nodeByKeyValue) {
	        exit[i] = node;
	      } else {
	        nodeByKeyValue[keyValue] = node;
	      }
	    }
	  }
	
	  // Compute the key for each datum.
	  // If there a node associated with this key, join and add it to update.
	  // If there is not (or the key is a duplicate), add it to enter.
	  for (i = 0; i < dataLength; ++i) {
	    keyValue = keyPrefix + key.call(parent, data[i], i, data);
	    if (node = nodeByKeyValue[keyValue]) {
	      update[i] = node;
	      node.__data__ = data[i];
	      nodeByKeyValue[keyValue] = null;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Add any remaining nodes that were not bound to data to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
	      exit[i] = node;
	    }
	  }
	}
	
	var selection_data = function(value, key) {
	  if (!value) {
	    data = new Array(this.size()), j = -1;
	    this.each(function(d) { data[++j] = d; });
	    return data;
	  }
	
	  var bind = key ? bindKey : bindIndex,
	      parents = this._parents,
	      groups = this._groups;
	
	  if (typeof value !== "function") value = constant(value);
	
	  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
	    var parent = parents[j],
	        group = groups[j],
	        groupLength = group.length,
	        data = value.call(parent, parent && parent.__data__, j, parents),
	        dataLength = data.length,
	        enterGroup = enter[j] = new Array(dataLength),
	        updateGroup = update[j] = new Array(dataLength),
	        exitGroup = exit[j] = new Array(groupLength);
	
	    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
	
	    // Now connect the enter nodes to their following update node, such that
	    // appendChild can insert the materialized enter node before this node,
	    // rather than at the end of the parent node.
	    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
	      if (previous = enterGroup[i0]) {
	        if (i0 >= i1) i1 = i0 + 1;
	        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
	        previous._next = next || null;
	      }
	    }
	  }
	
	  update = new Selection(update, parents);
	  update._enter = enter;
	  update._exit = exit;
	  return update;
	};
	
	var selection_exit = function() {
	  return new Selection(this._exit || this._groups.map(sparse), this._parents);
	};
	
	var selection_merge = function(selection) {
	
	  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Selection(merges, this._parents);
	};
	
	var selection_order = function() {
	
	  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
	    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
	      if (node = group[i]) {
	        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	        next = node;
	      }
	    }
	  }
	
	  return this;
	};
	
	var selection_sort = function(compare) {
	  if (!compare) compare = ascending;
	
	  function compareNode(a, b) {
	    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
	  }
	
	  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        sortgroup[i] = node;
	      }
	    }
	    sortgroup.sort(compareNode);
	  }
	
	  return new Selection(sortgroups, this._parents).order();
	};
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	var selection_call = function() {
	  var callback = arguments[0];
	  arguments[0] = this;
	  callback.apply(null, arguments);
	  return this;
	};
	
	var selection_nodes = function() {
	  var nodes = new Array(this.size()), i = -1;
	  this.each(function() { nodes[++i] = this; });
	  return nodes;
	};
	
	var selection_node = function() {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
	      var node = group[i];
	      if (node) return node;
	    }
	  }
	
	  return null;
	};
	
	var selection_size = function() {
	  var size = 0;
	  this.each(function() { ++size; });
	  return size;
	};
	
	var selection_empty = function() {
	  return !this.node();
	};
	
	var selection_each = function(callback) {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
	      if (node = group[i]) callback.call(node, node.__data__, i, group);
	    }
	  }
	
	  return this;
	};
	
	function attrRemove(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant(name, value) {
	  return function() {
	    this.setAttribute(name, value);
	  };
	}
	
	function attrConstantNS(fullname, value) {
	  return function() {
	    this.setAttributeNS(fullname.space, fullname.local, value);
	  };
	}
	
	function attrFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttribute(name);
	    else this.setAttribute(name, v);
	  };
	}
	
	function attrFunctionNS(fullname, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
	    else this.setAttributeNS(fullname.space, fullname.local, v);
	  };
	}
	
	var selection_attr = function(name, value) {
	  var fullname = namespace(name);
	
	  if (arguments.length < 2) {
	    var node = this.node();
	    return fullname.local
	        ? node.getAttributeNS(fullname.space, fullname.local)
	        : node.getAttribute(fullname);
	  }
	
	  return this.each((value == null
	      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
	      ? (fullname.local ? attrFunctionNS : attrFunction)
	      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
	};
	
	var defaultView = function(node) {
	  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
	      || (node.document && node) // node is a Window
	      || node.defaultView; // node is a Document
	};
	
	function styleRemove(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant(name, value, priority) {
	  return function() {
	    this.style.setProperty(name, value, priority);
	  };
	}
	
	function styleFunction(name, value, priority) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.style.removeProperty(name);
	    else this.style.setProperty(name, v, priority);
	  };
	}
	
	var selection_style = function(name, value, priority) {
	  return arguments.length > 1
	      ? this.each((value == null
	            ? styleRemove : typeof value === "function"
	            ? styleFunction
	            : styleConstant)(name, value, priority == null ? "" : priority))
	      : styleValue(this.node(), name);
	};
	
	function styleValue(node, name) {
	  return node.style.getPropertyValue(name)
	      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
	}
	
	function propertyRemove(name) {
	  return function() {
	    delete this[name];
	  };
	}
	
	function propertyConstant(name, value) {
	  return function() {
	    this[name] = value;
	  };
	}
	
	function propertyFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) delete this[name];
	    else this[name] = v;
	  };
	}
	
	var selection_property = function(name, value) {
	  return arguments.length > 1
	      ? this.each((value == null
	          ? propertyRemove : typeof value === "function"
	          ? propertyFunction
	          : propertyConstant)(name, value))
	      : this.node()[name];
	};
	
	function classArray(string) {
	  return string.trim().split(/^|\s+/);
	}
	
	function classList(node) {
	  return node.classList || new ClassList(node);
	}
	
	function ClassList(node) {
	  this._node = node;
	  this._names = classArray(node.getAttribute("class") || "");
	}
	
	ClassList.prototype = {
	  add: function(name) {
	    var i = this._names.indexOf(name);
	    if (i < 0) {
	      this._names.push(name);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  remove: function(name) {
	    var i = this._names.indexOf(name);
	    if (i >= 0) {
	      this._names.splice(i, 1);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  contains: function(name) {
	    return this._names.indexOf(name) >= 0;
	  }
	};
	
	function classedAdd(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.add(names[i]);
	}
	
	function classedRemove(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.remove(names[i]);
	}
	
	function classedTrue(names) {
	  return function() {
	    classedAdd(this, names);
	  };
	}
	
	function classedFalse(names) {
	  return function() {
	    classedRemove(this, names);
	  };
	}
	
	function classedFunction(names, value) {
	  return function() {
	    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
	  };
	}
	
	var selection_classed = function(name, value) {
	  var names = classArray(name + "");
	
	  if (arguments.length < 2) {
	    var list = classList(this.node()), i = -1, n = names.length;
	    while (++i < n) if (!list.contains(names[i])) return false;
	    return true;
	  }
	
	  return this.each((typeof value === "function"
	      ? classedFunction : value
	      ? classedTrue
	      : classedFalse)(names, value));
	};
	
	function textRemove() {
	  this.textContent = "";
	}
	
	function textConstant(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.textContent = v == null ? "" : v;
	  };
	}
	
	var selection_text = function(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? textRemove : (typeof value === "function"
	          ? textFunction
	          : textConstant)(value))
	      : this.node().textContent;
	};
	
	function htmlRemove() {
	  this.innerHTML = "";
	}
	
	function htmlConstant(value) {
	  return function() {
	    this.innerHTML = value;
	  };
	}
	
	function htmlFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.innerHTML = v == null ? "" : v;
	  };
	}
	
	var selection_html = function(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? htmlRemove : (typeof value === "function"
	          ? htmlFunction
	          : htmlConstant)(value))
	      : this.node().innerHTML;
	};
	
	function raise() {
	  if (this.nextSibling) this.parentNode.appendChild(this);
	}
	
	var selection_raise = function() {
	  return this.each(raise);
	};
	
	function lower() {
	  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
	}
	
	var selection_lower = function() {
	  return this.each(lower);
	};
	
	var selection_append = function(name) {
	  var create = typeof name === "function" ? name : creator(name);
	  return this.select(function() {
	    return this.appendChild(create.apply(this, arguments));
	  });
	};
	
	function constantNull() {
	  return null;
	}
	
	var selection_insert = function(name, before) {
	  var create = typeof name === "function" ? name : creator(name),
	      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
	  return this.select(function() {
	    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
	  });
	};
	
	function remove() {
	  var parent = this.parentNode;
	  if (parent) parent.removeChild(this);
	}
	
	var selection_remove = function() {
	  return this.each(remove);
	};
	
	var selection_datum = function(value) {
	  return arguments.length
	      ? this.property("__data__", value)
	      : this.node().__data__;
	};
	
	function dispatchEvent(node, type, params) {
	  var window = defaultView(node),
	      event = window.CustomEvent;
	
	  if (typeof event === "function") {
	    event = new event(type, params);
	  } else {
	    event = window.document.createEvent("Event");
	    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
	    else event.initEvent(type, false, false);
	  }
	
	  node.dispatchEvent(event);
	}
	
	function dispatchConstant(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params);
	  };
	}
	
	function dispatchFunction(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params.apply(this, arguments));
	  };
	}
	
	var selection_dispatch = function(type, params) {
	  return this.each((typeof params === "function"
	      ? dispatchFunction
	      : dispatchConstant)(type, params));
	};
	
	var root = [null];
	
	function Selection(groups, parents) {
	  this._groups = groups;
	  this._parents = parents;
	}
	
	function selection() {
	  return new Selection([[document.documentElement]], root);
	}
	
	Selection.prototype = selection.prototype = {
	  constructor: Selection,
	  select: selection_select,
	  selectAll: selection_selectAll,
	  filter: selection_filter,
	  data: selection_data,
	  enter: selection_enter,
	  exit: selection_exit,
	  merge: selection_merge,
	  order: selection_order,
	  sort: selection_sort,
	  call: selection_call,
	  nodes: selection_nodes,
	  node: selection_node,
	  size: selection_size,
	  empty: selection_empty,
	  each: selection_each,
	  attr: selection_attr,
	  style: selection_style,
	  property: selection_property,
	  classed: selection_classed,
	  text: selection_text,
	  html: selection_html,
	  raise: selection_raise,
	  lower: selection_lower,
	  append: selection_append,
	  insert: selection_insert,
	  remove: selection_remove,
	  datum: selection_datum,
	  on: selection_on,
	  dispatch: selection_dispatch
	};
	
	var select = function(selector) {
	  return typeof selector === "string"
	      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
	      : new Selection([[selector]], root);
	};
	
	var selectAll = function(selector) {
	  return typeof selector === "string"
	      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
	      : new Selection([selector == null ? [] : selector], root);
	};
	
	var touch = function(node, touches, identifier) {
	  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;
	
	  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
	    if ((touch = touches[i]).identifier === identifier) {
	      return point(node, touch);
	    }
	  }
	
	  return null;
	};
	
	var touches = function(node, touches) {
	  if (touches == null) touches = sourceEvent().touches;
	
	  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
	    points[i] = point(node, touches[i]);
	  }
	
	  return points;
	};
	
	exports.creator = creator;
	exports.local = local;
	exports.matcher = matcher$1;
	exports.mouse = mouse;
	exports.namespace = namespace;
	exports.namespaces = namespaces;
	exports.select = select;
	exports.selectAll = selectAll;
	exports.selection = selection;
	exports.selector = selector;
	exports.selectorAll = selectorAll;
	exports.style = styleValue;
	exports.touch = touch;
	exports.touches = touches;
	exports.window = defaultView;
	exports.customEvent = customEvent;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.1.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(33)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	var constant = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function radialLine(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var radialLine$1 = function() {
	  return radialLine(line().curve(curveRadialLinear));
	};
	
	var radialArea = function() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return radialLine(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return radialLine(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return radialLine(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return radialLine(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var slice = Array.prototype.slice;
	
	var radialPoint = function(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	};
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$$1 = x,
	      y$$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), link) : x$$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), link) : y$$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = radialPoint(x0, y0),
	      p1 = radialPoint(x0, y0 = (y0 + y1) / 2),
	      p2 = radialPoint(x1, y0),
	      p3 = radialPoint(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	var kx = Math.sin(tau / 10) * kr;
	var ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = ((function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	}))(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var diverging = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = yp;
	      }
	    }
	  }
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending = function(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$1 = function(series) {
	  return ascending(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.radialArea = radialArea;
	exports.radialLine = radialLine$1;
	exports.linkHorizontal = linkHorizontal;
	exports.linkVertical = linkVertical;
	exports.linkRadial = linkRadial;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	module.exports = {
		"global": {
			"cssNamespace": "mjmmnrw",
			"breakpoints": {
				"small": 600,
				"medium": 768,
				"large": 1280
			}
		},
		"historyChart": {
			"keys": [
				"pwi_h",
				"pwa_h",
				"pwn_h"
			],
			"width": 300,
			"height": 80,
			"margin": {
				"top": 10,
				"right": 20,
				"bottom": 20,
				"left": 20
			},
			"xExtent": [
				"2003",
				"2016"
			],
			"yExtent": [
				0,
				15
			],
			"yTickValues": [
				0,
				5,
				10,
				15
			]
		}
	};

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	module.exports = {
		"type": "Topology",
		"arcs": [
			[
				[
					3529,
					1843
				],
				[
					68,
					-65
				]
			],
			[
				[
					3597,
					1778
				],
				[
					58,
					-74
				],
				[
					48,
					8
				]
			],
			[
				[
					3703,
					1712
				],
				[
					27,
					-171
				],
				[
					36,
					-39
				]
			],
			[
				[
					3766,
					1502
				],
				[
					-157,
					28
				],
				[
					-79,
					-84
				]
			],
			[
				[
					3530,
					1446
				],
				[
					-124,
					147
				]
			],
			[
				[
					3406,
					1593
				],
				[
					-114,
					31
				]
			],
			[
				[
					3292,
					1624
				],
				[
					-32,
					48
				]
			],
			[
				[
					3260,
					1672
				],
				[
					31,
					150
				]
			],
			[
				[
					3291,
					1822
				],
				[
					90,
					45
				]
			],
			[
				[
					3381,
					1867
				],
				[
					43,
					45
				],
				[
					105,
					-69
				]
			],
			[
				[
					2161,
					2900
				],
				[
					59,
					-85
				],
				[
					60,
					-3
				],
				[
					53,
					-192
				],
				[
					-88,
					-161
				]
			],
			[
				[
					2245,
					2459
				],
				[
					-38,
					-37
				]
			],
			[
				[
					2207,
					2422
				],
				[
					-129,
					29
				]
			],
			[
				[
					2078,
					2451
				],
				[
					69,
					82
				],
				[
					-137,
					161
				]
			],
			[
				[
					2010,
					2694
				],
				[
					41,
					97
				]
			],
			[
				[
					2051,
					2791
				],
				[
					81,
					47
				]
			],
			[
				[
					2132,
					2838
				],
				[
					-22,
					72
				]
			],
			[
				[
					2110,
					2910
				],
				[
					1,
					23
				]
			],
			[
				[
					2111,
					2933
				],
				[
					50,
					-33
				]
			],
			[
				[
					5431,
					3450
				],
				[
					53,
					-85
				]
			],
			[
				[
					5484,
					3365
				],
				[
					-9,
					-58
				]
			],
			[
				[
					5475,
					3307
				],
				[
					-28,
					-22
				]
			],
			[
				[
					5447,
					3285
				],
				[
					20,
					-60
				]
			],
			[
				[
					5467,
					3225
				],
				[
					75,
					26
				]
			],
			[
				[
					5542,
					3251
				],
				[
					41,
					-29
				]
			],
			[
				[
					5583,
					3222
				],
				[
					112,
					-135
				]
			],
			[
				[
					5695,
					3087
				],
				[
					-37,
					-46
				]
			],
			[
				[
					5658,
					3041
				],
				[
					-23,
					-10
				]
			],
			[
				[
					5635,
					3031
				],
				[
					-44,
					97
				]
			],
			[
				[
					5591,
					3128
				],
				[
					-277,
					-69
				],
				[
					-222,
					-160
				]
			],
			[
				[
					5092,
					2899
				],
				[
					-43,
					-2
				]
			],
			[
				[
					5049,
					2897
				],
				[
					-2,
					26
				],
				[
					9,
					16
				],
				[
					-23,
					23
				]
			],
			[
				[
					5033,
					2962
				],
				[
					20,
					66
				]
			],
			[
				[
					5053,
					3028
				],
				[
					74,
					224
				]
			],
			[
				[
					5127,
					3252
				],
				[
					-23,
					30
				]
			],
			[
				[
					5104,
					3282
				],
				[
					7,
					5
				],
				[
					-13,
					27
				],
				[
					190,
					93
				],
				[
					32,
					-16
				]
			],
			[
				[
					5320,
					3391
				],
				[
					111,
					59
				]
			],
			[
				[
					4152,
					3384
				],
				[
					80,
					0
				],
				[
					91,
					-89
				]
			],
			[
				[
					4323,
					3295
				],
				[
					-75,
					-67
				]
			],
			[
				[
					4248,
					3228
				],
				[
					-101,
					-149
				]
			],
			[
				[
					4147,
					3079
				],
				[
					12,
					-8
				]
			],
			[
				[
					4159,
					3071
				],
				[
					-6,
					-2
				],
				[
					-42,
					27
				]
			],
			[
				[
					4111,
					3096
				],
				[
					-158,
					-24
				]
			],
			[
				[
					3953,
					3072
				],
				[
					-50,
					22
				]
			],
			[
				[
					3903,
					3094
				],
				[
					15,
					98
				]
			],
			[
				[
					3918,
					3192
				],
				[
					27,
					43
				]
			],
			[
				[
					3945,
					3235
				],
				[
					34,
					-4
				]
			],
			[
				[
					3979,
					3231
				],
				[
					5,
					59
				]
			],
			[
				[
					3984,
					3290
				],
				[
					24,
					49
				]
			],
			[
				[
					4008,
					3339
				],
				[
					28,
					51
				]
			],
			[
				[
					4036,
					3390
				],
				[
					17,
					-5
				]
			],
			[
				[
					4053,
					3385
				],
				[
					80,
					30
				]
			],
			[
				[
					4133,
					3415
				],
				[
					19,
					-31
				]
			],
			[
				[
					6602,
					5166
				],
				[
					16,
					40
				]
			],
			[
				[
					6618,
					5206
				],
				[
					148,
					-97
				]
			],
			[
				[
					6766,
					5109
				],
				[
					48,
					13
				]
			],
			[
				[
					6814,
					5122
				],
				[
					18,
					-68
				],
				[
					-163,
					-135
				],
				[
					31,
					-91
				],
				[
					-67,
					-115
				],
				[
					21,
					-48
				],
				[
					-24,
					-18
				],
				[
					-3,
					-51
				]
			],
			[
				[
					6627,
					4596
				],
				[
					-44,
					10
				],
				[
					-7,
					11
				],
				[
					-46,
					-19
				],
				[
					-32,
					-46
				]
			],
			[
				[
					6498,
					4552
				],
				[
					-58,
					0
				]
			],
			[
				[
					6440,
					4552
				],
				[
					-66,
					91
				],
				[
					-25,
					136
				],
				[
					-78,
					96
				],
				[
					11,
					74
				]
			],
			[
				[
					6282,
					4949
				],
				[
					21,
					63
				]
			],
			[
				[
					6303,
					5012
				],
				[
					2,
					26
				],
				[
					227,
					109
				]
			],
			[
				[
					6532,
					5147
				],
				[
					-6,
					30
				]
			],
			[
				[
					6526,
					5177
				],
				[
					11,
					2
				],
				[
					-7,
					5
				],
				[
					6,
					12
				],
				[
					44,
					1
				],
				[
					22,
					-31
				]
			],
			[
				[
					4697,
					7537
				],
				[
					68,
					43
				],
				[
					78,
					-68
				]
			],
			[
				[
					4843,
					7512
				],
				[
					104,
					-85
				]
			],
			[
				[
					4947,
					7427
				],
				[
					-149,
					-239
				],
				[
					-56,
					-23
				]
			],
			[
				[
					4742,
					7165
				],
				[
					-160,
					151
				]
			],
			[
				[
					4582,
					7316
				],
				[
					-45,
					53
				]
			],
			[
				[
					4537,
					7369
				],
				[
					-35,
					22
				]
			],
			[
				[
					4502,
					7391
				],
				[
					-52,
					24
				]
			],
			[
				[
					4450,
					7415
				],
				[
					140,
					159
				]
			],
			[
				[
					4590,
					7574
				],
				[
					107,
					-37
				]
			],
			[
				[
					3721,
					5031
				],
				[
					129,
					17
				],
				[
					131,
					-57
				],
				[
					150,
					26
				]
			],
			[
				[
					4131,
					5017
				],
				[
					16,
					-27
				]
			],
			[
				[
					4147,
					4990
				],
				[
					67,
					-99
				]
			],
			[
				[
					4214,
					4891
				],
				[
					21,
					-25
				]
			],
			[
				[
					4235,
					4866
				],
				[
					-4,
					-15
				]
			],
			[
				[
					4231,
					4851
				],
				[
					12,
					-76
				]
			],
			[
				[
					4243,
					4775
				],
				[
					-97,
					-56
				]
			],
			[
				[
					4146,
					4719
				],
				[
					28,
					-121
				]
			],
			[
				[
					4174,
					4598
				],
				[
					-56,
					-56
				]
			],
			[
				[
					4118,
					4542
				],
				[
					-32,
					39
				]
			],
			[
				[
					4086,
					4581
				],
				[
					-72,
					-55
				]
			],
			[
				[
					4014,
					4526
				],
				[
					-8,
					-41
				]
			],
			[
				[
					4006,
					4485
				],
				[
					-65,
					-76
				]
			],
			[
				[
					3941,
					4409
				],
				[
					-14,
					-22
				]
			],
			[
				[
					3927,
					4387
				],
				[
					6,
					-36
				]
			],
			[
				[
					3933,
					4351
				],
				[
					-104,
					-7
				]
			],
			[
				[
					3829,
					4344
				],
				[
					8,
					65
				]
			],
			[
				[
					3837,
					4409
				],
				[
					-17,
					19
				],
				[
					-92,
					-16
				],
				[
					-21,
					70
				]
			],
			[
				[
					3707,
					4482
				],
				[
					-62,
					95
				],
				[
					-84,
					40
				]
			],
			[
				[
					3561,
					4617
				],
				[
					-27,
					-2
				]
			],
			[
				[
					3534,
					4615
				],
				[
					-95,
					83
				],
				[
					26,
					74
				]
			],
			[
				[
					3465,
					4772
				],
				[
					51,
					-6
				]
			],
			[
				[
					3516,
					4766
				],
				[
					69,
					30
				]
			],
			[
				[
					3585,
					4796
				],
				[
					-30,
					156
				],
				[
					48,
					96
				]
			],
			[
				[
					3603,
					5048
				],
				[
					59,
					-14
				]
			],
			[
				[
					3662,
					5034
				],
				[
					9,
					24
				]
			],
			[
				[
					3671,
					5058
				],
				[
					44,
					25
				]
			],
			[
				[
					3715,
					5083
				],
				[
					18,
					-20
				]
			],
			[
				[
					3733,
					5063
				],
				[
					-12,
					-32
				]
			],
			[
				[
					1961,
					809
				],
				[
					162,
					-85
				],
				[
					-16,
					-113
				]
			],
			[
				[
					2107,
					611
				],
				[
					-52,
					-112
				]
			],
			[
				[
					2055,
					499
				],
				[
					-53,
					-24
				]
			],
			[
				[
					2002,
					475
				],
				[
					-26,
					54
				]
			],
			[
				[
					1976,
					529
				],
				[
					-264,
					-49
				],
				[
					-1,
					-56
				]
			],
			[
				[
					1711,
					424
				],
				[
					-16,
					-2
				]
			],
			[
				[
					1695,
					422
				],
				[
					-66,
					68
				]
			],
			[
				[
					1629,
					490
				],
				[
					-11,
					-1
				]
			],
			[
				[
					1618,
					489
				],
				[
					70,
					149
				],
				[
					86,
					70
				]
			],
			[
				[
					1774,
					708
				],
				[
					8,
					47
				]
			],
			[
				[
					1782,
					755
				],
				[
					90,
					-1
				]
			],
			[
				[
					1872,
					754
				],
				[
					32,
					13
				]
			],
			[
				[
					1904,
					767
				],
				[
					57,
					42
				]
			],
			[
				[
					6816,
					5883
				],
				[
					87,
					12
				]
			],
			[
				[
					6903,
					5895
				],
				[
					80,
					-115
				],
				[
					98,
					-60
				],
				[
					146,
					-4
				]
			],
			[
				[
					7227,
					5716
				],
				[
					46,
					23
				]
			],
			[
				[
					7273,
					5739
				],
				[
					18,
					-113
				]
			],
			[
				[
					7291,
					5626
				],
				[
					-61,
					-53
				],
				[
					18,
					-46
				],
				[
					-14,
					-65
				],
				[
					32,
					-15
				]
			],
			[
				[
					7266,
					5447
				],
				[
					-28,
					-28
				]
			],
			[
				[
					7238,
					5419
				],
				[
					-26,
					-16
				]
			],
			[
				[
					7212,
					5403
				],
				[
					-108,
					48
				]
			],
			[
				[
					7104,
					5451
				],
				[
					-28,
					20
				]
			],
			[
				[
					7076,
					5471
				],
				[
					-22,
					-13
				]
			],
			[
				[
					7054,
					5458
				],
				[
					-28,
					-52
				]
			],
			[
				[
					7026,
					5406
				],
				[
					-181,
					9
				],
				[
					-87,
					-56
				]
			],
			[
				[
					6758,
					5359
				],
				[
					-62,
					-52
				]
			],
			[
				[
					6696,
					5307
				],
				[
					-12,
					32
				]
			],
			[
				[
					6684,
					5339
				],
				[
					22,
					10
				]
			],
			[
				[
					6706,
					5349
				],
				[
					-6,
					74
				]
			],
			[
				[
					6700,
					5423
				],
				[
					13,
					104
				]
			],
			[
				[
					6713,
					5527
				],
				[
					-45,
					70
				]
			],
			[
				[
					6668,
					5597
				],
				[
					0,
					200
				],
				[
					94,
					56
				]
			],
			[
				[
					6762,
					5853
				],
				[
					-7,
					8
				]
			],
			[
				[
					6755,
					5861
				],
				[
					61,
					22
				]
			],
			[
				[
					1541,
					1266
				],
				[
					110,
					27
				]
			],
			[
				[
					1651,
					1293
				],
				[
					35,
					-77
				]
			],
			[
				[
					1686,
					1216
				],
				[
					-42,
					-56
				]
			],
			[
				[
					1644,
					1160
				],
				[
					-24,
					-111
				]
			],
			[
				[
					1620,
					1049
				],
				[
					-21,
					31
				]
			],
			[
				[
					1599,
					1080
				],
				[
					-120,
					-24
				],
				[
					-167,
					77
				]
			],
			[
				[
					1312,
					1133
				],
				[
					-38,
					-56
				]
			],
			[
				[
					1274,
					1077
				],
				[
					-26,
					48
				]
			],
			[
				[
					1248,
					1125
				],
				[
					3,
					32
				]
			],
			[
				[
					1251,
					1157
				],
				[
					27,
					13
				]
			],
			[
				[
					1278,
					1170
				],
				[
					25,
					80
				]
			],
			[
				[
					1303,
					1250
				],
				[
					81,
					54
				]
			],
			[
				[
					1384,
					1304
				],
				[
					157,
					-38
				]
			],
			[
				[
					2693,
					5064
				],
				[
					40,
					-25
				],
				[
					24,
					-177
				],
				[
					-26,
					-48
				]
			],
			[
				[
					2731,
					4814
				],
				[
					-28,
					4
				]
			],
			[
				[
					2703,
					4818
				],
				[
					-44,
					49
				]
			],
			[
				[
					2659,
					4867
				],
				[
					-50,
					9
				]
			],
			[
				[
					2609,
					4876
				],
				[
					-67,
					58
				]
			],
			[
				[
					2542,
					4934
				],
				[
					-4,
					91
				],
				[
					120,
					83
				]
			],
			[
				[
					2658,
					5108
				],
				[
					7,
					71
				]
			],
			[
				[
					2665,
					5179
				],
				[
					35,
					-14
				]
			],
			[
				[
					2700,
					5165
				],
				[
					-7,
					-101
				]
			],
			[
				[
					1650,
					2175
				],
				[
					24,
					-125
				],
				[
					96,
					-35
				]
			],
			[
				[
					1770,
					2015
				],
				[
					6,
					-56
				]
			],
			[
				[
					1776,
					1959
				],
				[
					-100,
					-19
				],
				[
					-71,
					-53
				]
			],
			[
				[
					1605,
					1887
				],
				[
					-45,
					50
				]
			],
			[
				[
					1560,
					1937
				],
				[
					-42,
					134
				]
			],
			[
				[
					1518,
					2071
				],
				[
					19,
					15
				]
			],
			[
				[
					1537,
					2086
				],
				[
					15,
					79
				]
			],
			[
				[
					1552,
					2165
				],
				[
					35,
					68
				]
			],
			[
				[
					1587,
					2233
				],
				[
					63,
					-58
				]
			],
			[
				[
					1324,
					5968
				],
				[
					-13,
					-12
				]
			],
			[
				[
					1311,
					5956
				],
				[
					4,
					-42
				]
			],
			[
				[
					1315,
					5914
				],
				[
					24,
					-11
				]
			],
			[
				[
					1339,
					5903
				],
				[
					78,
					8
				],
				[
					60,
					26
				]
			],
			[
				[
					1477,
					5937
				],
				[
					35,
					-103
				],
				[
					72,
					-85
				],
				[
					-102,
					-30
				],
				[
					-8,
					-148
				]
			],
			[
				[
					1474,
					5571
				],
				[
					-31,
					-12
				],
				[
					-38,
					-63
				]
			],
			[
				[
					1405,
					5496
				],
				[
					-33,
					22
				],
				[
					-67,
					19
				]
			],
			[
				[
					1305,
					5537
				],
				[
					8,
					114
				]
			],
			[
				[
					1313,
					5651
				],
				[
					-23,
					51
				],
				[
					-33,
					9
				],
				[
					-94,
					-6
				],
				[
					-60,
					32
				],
				[
					-39,
					118
				],
				[
					-40,
					58
				]
			],
			[
				[
					1024,
					5913
				],
				[
					210,
					113
				]
			],
			[
				[
					1234,
					6026
				],
				[
					90,
					-58
				]
			],
			[
				[
					3788,
					5304
				],
				[
					-11,
					-29
				]
			],
			[
				[
					3777,
					5275
				],
				[
					45,
					-34
				]
			],
			[
				[
					3822,
					5241
				],
				[
					-10,
					-58
				]
			],
			[
				[
					3812,
					5183
				],
				[
					-53,
					-68
				]
			],
			[
				[
					3759,
					5115
				],
				[
					-88,
					-57
				]
			],
			[
				[
					3662,
					5034
				],
				[
					-59,
					14
				]
			],
			[
				[
					3603,
					5048
				],
				[
					-73,
					36
				]
			],
			[
				[
					3530,
					5084
				],
				[
					6,
					21
				]
			],
			[
				[
					3536,
					5105
				],
				[
					-56,
					46
				]
			],
			[
				[
					3480,
					5151
				],
				[
					8,
					14
				]
			],
			[
				[
					3488,
					5165
				],
				[
					10,
					11
				]
			],
			[
				[
					3498,
					5176
				],
				[
					66,
					5
				]
			],
			[
				[
					3564,
					5181
				],
				[
					13,
					100
				],
				[
					117,
					-11
				],
				[
					20,
					66
				]
			],
			[
				[
					3714,
					5336
				],
				[
					74,
					-32
				]
			],
			[
				[
					2368,
					1717
				],
				[
					18,
					-12
				]
			],
			[
				[
					2386,
					1705
				],
				[
					68,
					-61
				]
			],
			[
				[
					2454,
					1644
				],
				[
					20,
					-12
				]
			],
			[
				[
					2474,
					1632
				],
				[
					29,
					-37
				]
			],
			[
				[
					2503,
					1595
				],
				[
					-50,
					-49
				]
			],
			[
				[
					2453,
					1546
				],
				[
					-130,
					-77
				]
			],
			[
				[
					2323,
					1469
				],
				[
					-72,
					-6
				]
			],
			[
				[
					2251,
					1463
				],
				[
					-16,
					-39
				]
			],
			[
				[
					2235,
					1424
				],
				[
					-108,
					-5
				]
			],
			[
				[
					2127,
					1419
				],
				[
					55,
					151
				],
				[
					50,
					77
				]
			],
			[
				[
					2232,
					1647
				],
				[
					-11,
					8
				]
			],
			[
				[
					2221,
					1655
				],
				[
					37,
					60
				]
			],
			[
				[
					2258,
					1715
				],
				[
					75,
					26
				]
			],
			[
				[
					2333,
					1741
				],
				[
					35,
					74
				]
			],
			[
				[
					2368,
					1815
				],
				[
					26,
					-33
				]
			],
			[
				[
					2394,
					1782
				],
				[
					-26,
					-65
				]
			],
			[
				[
					2559,
					1587
				],
				[
					-4,
					-20
				]
			],
			[
				[
					2555,
					1567
				],
				[
					51,
					-52
				]
			],
			[
				[
					2606,
					1515
				],
				[
					47,
					-68
				]
			],
			[
				[
					2653,
					1447
				],
				[
					46,
					-97
				]
			],
			[
				[
					2699,
					1350
				],
				[
					-34,
					-21
				]
			],
			[
				[
					2665,
					1329
				],
				[
					-15,
					-57
				],
				[
					-158,
					30
				],
				[
					-30,
					-104
				]
			],
			[
				[
					2462,
					1198
				],
				[
					-64,
					46
				]
			],
			[
				[
					2398,
					1244
				],
				[
					10,
					174
				],
				[
					-53,
					6
				]
			],
			[
				[
					2355,
					1424
				],
				[
					98,
					122
				]
			],
			[
				[
					2503,
					1595
				],
				[
					56,
					-8
				]
			],
			[
				[
					6683,
					7708
				],
				[
					86,
					-74
				]
			],
			[
				[
					6769,
					7634
				],
				[
					-5,
					-19
				]
			],
			[
				[
					6764,
					7615
				],
				[
					-45,
					-74
				]
			],
			[
				[
					6719,
					7541
				],
				[
					7,
					-48
				]
			],
			[
				[
					6726,
					7493
				],
				[
					25,
					1
				]
			],
			[
				[
					6751,
					7494
				],
				[
					-80,
					-96
				]
			],
			[
				[
					6671,
					7398
				],
				[
					-16,
					28
				]
			],
			[
				[
					6655,
					7426
				],
				[
					-50,
					0
				]
			],
			[
				[
					6605,
					7426
				],
				[
					30,
					130
				],
				[
					-41,
					94
				]
			],
			[
				[
					6594,
					7650
				],
				[
					17,
					83
				]
			],
			[
				[
					6611,
					7733
				],
				[
					72,
					-25
				]
			],
			[
				[
					4537,
					7369
				],
				[
					45,
					-53
				]
			],
			[
				[
					4742,
					7165
				],
				[
					12,
					-61
				]
			],
			[
				[
					4754,
					7104
				],
				[
					3,
					-25
				]
			],
			[
				[
					4757,
					7079
				],
				[
					-81,
					-3
				]
			],
			[
				[
					4676,
					7076
				],
				[
					-51,
					41
				],
				[
					-83,
					-28
				],
				[
					-34,
					5
				],
				[
					-78,
					61
				]
			],
			[
				[
					4430,
					7155
				],
				[
					-11,
					-14
				]
			],
			[
				[
					4419,
					7141
				],
				[
					8,
					166
				],
				[
					-31,
					101
				]
			],
			[
				[
					4396,
					7408
				],
				[
					106,
					-17
				]
			],
			[
				[
					2167,
					1532
				],
				[
					-31,
					-99
				]
			],
			[
				[
					2136,
					1433
				],
				[
					-75,
					27
				]
			],
			[
				[
					2061,
					1460
				],
				[
					-39,
					-190
				]
			],
			[
				[
					2022,
					1270
				],
				[
					-76,
					-30
				]
			],
			[
				[
					1946,
					1240
				],
				[
					-40,
					-63
				],
				[
					-132,
					81
				],
				[
					-69,
					-30
				]
			],
			[
				[
					1705,
					1228
				],
				[
					-19,
					-12
				]
			],
			[
				[
					1686,
					1216
				],
				[
					-25,
					65
				]
			],
			[
				[
					1661,
					1281
				],
				[
					84,
					68
				],
				[
					-12,
					79
				]
			],
			[
				[
					1733,
					1428
				],
				[
					-11,
					27
				]
			],
			[
				[
					1722,
					1455
				],
				[
					92,
					131
				],
				[
					116,
					-70
				],
				[
					53,
					141
				]
			],
			[
				[
					1983,
					1657
				],
				[
					-15,
					17
				]
			],
			[
				[
					1968,
					1674
				],
				[
					7,
					8
				],
				[
					6,
					-9
				],
				[
					12,
					4
				],
				[
					1,
					-9
				],
				[
					27,
					6
				],
				[
					18,
					-29
				],
				[
					128,
					-113
				]
			],
			[
				[
					4757,
					7079
				],
				[
					36,
					-31
				]
			],
			[
				[
					4793,
					7048
				],
				[
					57,
					-14
				],
				[
					77,
					-103
				],
				[
					-41,
					-103
				]
			],
			[
				[
					4886,
					6828
				],
				[
					-64,
					-123
				]
			],
			[
				[
					4822,
					6705
				],
				[
					-25,
					6
				]
			],
			[
				[
					4797,
					6711
				],
				[
					-146,
					2
				],
				[
					-39,
					115
				],
				[
					25,
					63
				],
				[
					-112,
					61
				]
			],
			[
				[
					4525,
					6952
				],
				[
					-72,
					-2
				]
			],
			[
				[
					4453,
					6950
				],
				[
					67,
					139
				]
			],
			[
				[
					4520,
					7089
				],
				[
					113,
					27
				],
				[
					43,
					-40
				]
			],
			[
				[
					2939,
					7429
				],
				[
					-89,
					-125
				],
				[
					-78,
					-59
				]
			],
			[
				[
					2772,
					7245
				],
				[
					-27,
					15
				]
			],
			[
				[
					2745,
					7260
				],
				[
					-151,
					163
				]
			],
			[
				[
					2594,
					7423
				],
				[
					77,
					183
				],
				[
					100,
					2
				],
				[
					94,
					62
				],
				[
					84,
					5
				],
				[
					-11,
					-167
				],
				[
					1,
					-79
				]
			],
			[
				[
					3847,
					5630
				],
				[
					25,
					-24
				]
			],
			[
				[
					3872,
					5606
				],
				[
					-14,
					-25
				]
			],
			[
				[
					3858,
					5581
				],
				[
					97,
					-7
				],
				[
					34,
					-68
				]
			],
			[
				[
					3989,
					5506
				],
				[
					4,
					-47
				]
			],
			[
				[
					3993,
					5459
				],
				[
					25,
					-8
				]
			],
			[
				[
					4018,
					5451
				],
				[
					4,
					-20
				]
			],
			[
				[
					4022,
					5431
				],
				[
					-12,
					-89
				]
			],
			[
				[
					4010,
					5342
				],
				[
					4,
					-71
				]
			],
			[
				[
					4014,
					5271
				],
				[
					-107,
					-4
				]
			],
			[
				[
					3907,
					5267
				],
				[
					-51,
					26
				]
			],
			[
				[
					3856,
					5293
				],
				[
					-1,
					-15
				]
			],
			[
				[
					3855,
					5278
				],
				[
					-78,
					-3
				]
			],
			[
				[
					3788,
					5304
				],
				[
					-14,
					24
				],
				[
					-80,
					17
				]
			],
			[
				[
					3694,
					5345
				],
				[
					73,
					42
				]
			],
			[
				[
					3767,
					5387
				],
				[
					19,
					44
				]
			],
			[
				[
					3786,
					5431
				],
				[
					-64,
					96
				]
			],
			[
				[
					3722,
					5527
				],
				[
					8,
					26
				]
			],
			[
				[
					3730,
					5553
				],
				[
					59,
					36
				]
			],
			[
				[
					3789,
					5589
				],
				[
					58,
					41
				]
			],
			[
				[
					3164,
					5980
				],
				[
					140,
					-70
				],
				[
					35,
					-87
				]
			],
			[
				[
					3339,
					5823
				],
				[
					-8,
					-39
				]
			],
			[
				[
					3331,
					5784
				],
				[
					51,
					-97
				],
				[
					100,
					-51
				]
			],
			[
				[
					3482,
					5636
				],
				[
					-89,
					-65
				]
			],
			[
				[
					3393,
					5571
				],
				[
					-84,
					-56
				]
			],
			[
				[
					3309,
					5515
				],
				[
					-9,
					-15
				]
			],
			[
				[
					3300,
					5500
				],
				[
					-41,
					0
				]
			],
			[
				[
					3259,
					5500
				],
				[
					-71,
					-19
				]
			],
			[
				[
					3188,
					5481
				],
				[
					1,
					14
				]
			],
			[
				[
					3189,
					5495
				],
				[
					-99,
					59
				]
			],
			[
				[
					3090,
					5554
				],
				[
					-54,
					-5
				]
			],
			[
				[
					3036,
					5549
				],
				[
					-109,
					-35
				]
			],
			[
				[
					2927,
					5514
				],
				[
					-106,
					-26
				]
			],
			[
				[
					2821,
					5488
				],
				[
					74,
					55
				]
			],
			[
				[
					2895,
					5543
				],
				[
					3,
					45
				]
			],
			[
				[
					2898,
					5588
				],
				[
					23,
					29
				]
			],
			[
				[
					2921,
					5617
				],
				[
					-11,
					159
				]
			],
			[
				[
					2910,
					5776
				],
				[
					-19,
					35
				]
			],
			[
				[
					2891,
					5811
				],
				[
					88,
					30
				],
				[
					50,
					66
				]
			],
			[
				[
					3029,
					5907
				],
				[
					135,
					73
				]
			],
			[
				[
					6702,
					4603
				],
				[
					156,
					-86
				],
				[
					75,
					27
				]
			],
			[
				[
					6933,
					4544
				],
				[
					13,
					-50
				]
			],
			[
				[
					6946,
					4494
				],
				[
					-135,
					-247
				]
			],
			[
				[
					6811,
					4247
				],
				[
					-116,
					-211
				],
				[
					-38,
					16
				],
				[
					-157,
					-173
				],
				[
					-25,
					72
				]
			],
			[
				[
					6475,
					3951
				],
				[
					6,
					99
				],
				[
					-90,
					29
				],
				[
					-14,
					88
				],
				[
					-79,
					-5
				],
				[
					-26,
					125
				]
			],
			[
				[
					6272,
					4287
				],
				[
					-6,
					25
				]
			],
			[
				[
					6266,
					4312
				],
				[
					-17,
					51
				]
			],
			[
				[
					6249,
					4363
				],
				[
					14,
					38
				],
				[
					-19,
					30
				],
				[
					196,
					121
				]
			],
			[
				[
					6498,
					4552
				],
				[
					39,
					51
				],
				[
					42,
					9
				],
				[
					54,
					-17
				],
				[
					69,
					8
				]
			],
			[
				[
					1340,
					2092
				],
				[
					12,
					-45
				]
			],
			[
				[
					1352,
					2047
				],
				[
					91,
					15
				]
			],
			[
				[
					1443,
					2062
				],
				[
					19,
					-16
				]
			],
			[
				[
					1462,
					2046
				],
				[
					56,
					25
				]
			],
			[
				[
					1560,
					1937
				],
				[
					8,
					-60
				]
			],
			[
				[
					1568,
					1877
				],
				[
					-18,
					-68
				]
			],
			[
				[
					1550,
					1809
				],
				[
					-8,
					-44
				]
			],
			[
				[
					1542,
					1765
				],
				[
					-19,
					-67
				],
				[
					-121,
					-73
				]
			],
			[
				[
					1402,
					1625
				],
				[
					-28,
					38
				]
			],
			[
				[
					1374,
					1663
				],
				[
					-93,
					92
				]
			],
			[
				[
					1281,
					1755
				],
				[
					-20,
					39
				]
			],
			[
				[
					1261,
					1794
				],
				[
					44,
					97
				],
				[
					-79,
					85
				]
			],
			[
				[
					1226,
					1976
				],
				[
					16,
					44
				]
			],
			[
				[
					1242,
					2020
				],
				[
					55,
					47
				]
			],
			[
				[
					1297,
					2067
				],
				[
					43,
					25
				]
			],
			[
				[
					3331,
					3928
				],
				[
					-12,
					-100
				]
			],
			[
				[
					3319,
					3828
				],
				[
					30,
					-13
				]
			],
			[
				[
					3349,
					3815
				],
				[
					27,
					-51
				]
			],
			[
				[
					3376,
					3764
				],
				[
					20,
					-91
				]
			],
			[
				[
					3396,
					3673
				],
				[
					27,
					-13
				]
			],
			[
				[
					3423,
					3660
				],
				[
					26,
					-46
				]
			],
			[
				[
					3449,
					3614
				],
				[
					-18,
					-101
				]
			],
			[
				[
					3431,
					3513
				],
				[
					-26,
					0
				]
			],
			[
				[
					3405,
					3513
				],
				[
					-58,
					-4
				]
			],
			[
				[
					3347,
					3509
				],
				[
					-19,
					42
				]
			],
			[
				[
					3328,
					3551
				],
				[
					-30,
					22
				]
			],
			[
				[
					3298,
					3573
				],
				[
					-28,
					2
				]
			],
			[
				[
					3270,
					3575
				],
				[
					-72,
					-54
				]
			],
			[
				[
					3198,
					3521
				],
				[
					-23,
					17
				]
			],
			[
				[
					3175,
					3538
				],
				[
					-69,
					-21
				]
			],
			[
				[
					3106,
					3517
				],
				[
					-57,
					-82
				],
				[
					27,
					-65
				]
			],
			[
				[
					3076,
					3370
				],
				[
					-76,
					9
				]
			],
			[
				[
					3000,
					3379
				],
				[
					-27,
					52
				]
			],
			[
				[
					2973,
					3431
				],
				[
					-43,
					123
				]
			],
			[
				[
					2930,
					3554
				],
				[
					-110,
					-51
				]
			],
			[
				[
					2820,
					3503
				],
				[
					12,
					100
				]
			],
			[
				[
					2832,
					3603
				],
				[
					-70,
					50
				]
			],
			[
				[
					2762,
					3653
				],
				[
					-19,
					0
				]
			],
			[
				[
					2743,
					3653
				],
				[
					40,
					12
				]
			],
			[
				[
					2783,
					3665
				],
				[
					63,
					33
				]
			],
			[
				[
					2846,
					3698
				],
				[
					59,
					97
				]
			],
			[
				[
					2905,
					3795
				],
				[
					35,
					57
				]
			],
			[
				[
					2940,
					3852
				],
				[
					46,
					43
				]
			],
			[
				[
					2986,
					3895
				],
				[
					124,
					33
				]
			],
			[
				[
					3110,
					3928
				],
				[
					6,
					-60
				]
			],
			[
				[
					3116,
					3868
				],
				[
					27,
					6
				]
			],
			[
				[
					3143,
					3874
				],
				[
					105,
					38
				]
			],
			[
				[
					3248,
					3912
				],
				[
					83,
					16
				]
			],
			[
				[
					7385,
					7760
				],
				[
					58,
					-10
				]
			],
			[
				[
					7443,
					7750
				],
				[
					22,
					18
				]
			],
			[
				[
					7465,
					7768
				],
				[
					145,
					-64
				],
				[
					98,
					-84
				],
				[
					-66,
					-73
				],
				[
					-2,
					-109
				],
				[
					-143,
					44
				]
			],
			[
				[
					7497,
					7482
				],
				[
					12,
					-39
				]
			],
			[
				[
					7509,
					7443
				],
				[
					-45,
					1
				]
			],
			[
				[
					7464,
					7444
				],
				[
					-31,
					-15
				]
			],
			[
				[
					7433,
					7429
				],
				[
					-78,
					12
				]
			],
			[
				[
					7355,
					7441
				],
				[
					-10,
					13
				]
			],
			[
				[
					7345,
					7454
				],
				[
					-38,
					12
				]
			],
			[
				[
					7307,
					7466
				],
				[
					-29,
					11
				]
			],
			[
				[
					7278,
					7477
				],
				[
					-51,
					12
				]
			],
			[
				[
					7227,
					7489
				],
				[
					-26,
					-11
				]
			],
			[
				[
					7201,
					7478
				],
				[
					-33,
					76
				],
				[
					-47,
					27
				],
				[
					-2,
					19
				],
				[
					28,
					37
				],
				[
					46,
					15
				],
				[
					5,
					43
				]
			],
			[
				[
					7198,
					7695
				],
				[
					23,
					7
				]
			],
			[
				[
					7221,
					7702
				],
				[
					36,
					-10
				]
			],
			[
				[
					7257,
					7692
				],
				[
					20,
					76
				],
				[
					77,
					14
				]
			],
			[
				[
					7354,
					7782
				],
				[
					31,
					-22
				]
			],
			[
				[
					1057,
					4608
				],
				[
					18,
					-81
				]
			],
			[
				[
					1075,
					4527
				],
				[
					-10,
					-86
				]
			],
			[
				[
					1065,
					4441
				],
				[
					-125,
					-208
				]
			],
			[
				[
					940,
					4233
				],
				[
					-27,
					-106
				]
			],
			[
				[
					913,
					4127
				],
				[
					-77,
					11
				]
			],
			[
				[
					836,
					4138
				],
				[
					-47,
					139
				],
				[
					44,
					304
				],
				[
					31,
					34
				]
			],
			[
				[
					864,
					4615
				],
				[
					69,
					0
				],
				[
					53,
					-65
				],
				[
					71,
					58
				]
			],
			[
				[
					4930,
					8172
				],
				[
					-31,
					-158
				],
				[
					21,
					-153
				],
				[
					-53,
					-48
				]
			],
			[
				[
					4867,
					7813
				],
				[
					-29,
					-92
				]
			],
			[
				[
					4838,
					7721
				],
				[
					-98,
					34
				]
			],
			[
				[
					4740,
					7755
				],
				[
					-41,
					49
				]
			],
			[
				[
					4699,
					7804
				],
				[
					-44,
					13
				]
			],
			[
				[
					4655,
					7817
				],
				[
					11,
					34
				],
				[
					-11,
					15
				],
				[
					14,
					22
				],
				[
					-20,
					24
				],
				[
					29,
					45
				],
				[
					0,
					62
				]
			],
			[
				[
					4678,
					8019
				],
				[
					-12,
					67
				]
			],
			[
				[
					4666,
					8086
				],
				[
					-43,
					33
				]
			],
			[
				[
					4623,
					8119
				],
				[
					13,
					47
				]
			],
			[
				[
					4636,
					8166
				],
				[
					33,
					27
				]
			],
			[
				[
					4669,
					8193
				],
				[
					71,
					-8
				],
				[
					118,
					47
				],
				[
					72,
					-60
				]
			],
			[
				[
					1305,
					5537
				],
				[
					92,
					-33
				],
				[
					21,
					-28
				],
				[
					33,
					-116
				]
			],
			[
				[
					1451,
					5360
				],
				[
					73,
					-28
				],
				[
					-24,
					-97
				]
			],
			[
				[
					1500,
					5235
				],
				[
					44,
					-20
				]
			],
			[
				[
					1544,
					5215
				],
				[
					-66,
					-50
				]
			],
			[
				[
					1478,
					5165
				],
				[
					8,
					-19
				]
			],
			[
				[
					1486,
					5146
				],
				[
					-29,
					-7
				]
			],
			[
				[
					1457,
					5139
				],
				[
					-19,
					61
				]
			],
			[
				[
					1438,
					5200
				],
				[
					-58,
					8
				]
			],
			[
				[
					1380,
					5208
				],
				[
					-14,
					-9
				]
			],
			[
				[
					1366,
					5199
				],
				[
					-7,
					14
				],
				[
					-24,
					-5
				],
				[
					-29,
					23
				]
			],
			[
				[
					1306,
					5231
				],
				[
					-87,
					73
				]
			],
			[
				[
					1219,
					5304
				],
				[
					-26,
					77
				]
			],
			[
				[
					1193,
					5381
				],
				[
					18,
					36
				]
			],
			[
				[
					1211,
					5417
				],
				[
					-57,
					82
				]
			],
			[
				[
					1154,
					5499
				],
				[
					132,
					155
				],
				[
					-21,
					39
				]
			],
			[
				[
					1265,
					5693
				],
				[
					48,
					-42
				]
			],
			[
				[
					2055,
					499
				],
				[
					36,
					-102
				],
				[
					97,
					-66
				],
				[
					-38,
					-113
				],
				[
					37,
					-72
				],
				[
					-75,
					-83
				],
				[
					-115,
					-46
				],
				[
					-93,
					118
				],
				[
					-42,
					-96
				],
				[
					-64,
					14
				],
				[
					5,
					93
				],
				[
					-55,
					104
				]
			],
			[
				[
					1748,
					250
				],
				[
					-37,
					174
				]
			],
			[
				[
					1976,
					529
				],
				[
					26,
					-54
				]
			],
			[
				[
					2664,
					3250
				],
				[
					33,
					-2
				]
			],
			[
				[
					2697,
					3248
				],
				[
					-13,
					-155
				],
				[
					-3,
					-124
				]
			],
			[
				[
					2681,
					2969
				],
				[
					-70,
					-11
				]
			],
			[
				[
					2611,
					2958
				],
				[
					-51,
					0
				]
			],
			[
				[
					2560,
					2958
				],
				[
					-44,
					134
				]
			],
			[
				[
					2516,
					3092
				],
				[
					-27,
					54
				]
			],
			[
				[
					2489,
					3146
				],
				[
					38,
					71
				]
			],
			[
				[
					2527,
					3217
				],
				[
					61,
					42
				]
			],
			[
				[
					2588,
					3259
				],
				[
					30,
					-13
				]
			],
			[
				[
					2618,
					3246
				],
				[
					46,
					4
				]
			],
			[
				[
					3479,
					1373
				],
				[
					54,
					-31
				]
			],
			[
				[
					3533,
					1342
				],
				[
					39,
					-89
				],
				[
					-61,
					-44
				],
				[
					-186,
					-56
				],
				[
					-95,
					14
				],
				[
					-13,
					81
				],
				[
					-28,
					56
				]
			],
			[
				[
					3189,
					1304
				],
				[
					59,
					41
				],
				[
					155,
					9
				]
			],
			[
				[
					3403,
					1354
				],
				[
					76,
					19
				]
			],
			[
				[
					7104,
					5451
				],
				[
					81,
					-68
				]
			],
			[
				[
					7185,
					5383
				],
				[
					-28,
					-163
				]
			],
			[
				[
					7157,
					5220
				],
				[
					-69,
					-20
				]
			],
			[
				[
					7088,
					5200
				],
				[
					-149,
					-60
				]
			],
			[
				[
					6939,
					5140
				],
				[
					-51,
					-27
				]
			],
			[
				[
					6888,
					5113
				],
				[
					-12,
					13
				]
			],
			[
				[
					6876,
					5126
				],
				[
					-36,
					83
				]
			],
			[
				[
					6840,
					5209
				],
				[
					-16,
					-5
				]
			],
			[
				[
					6824,
					5204
				],
				[
					-37,
					68
				]
			],
			[
				[
					6787,
					5272
				],
				[
					-22,
					20
				]
			],
			[
				[
					6765,
					5292
				],
				[
					-7,
					67
				]
			],
			[
				[
					7026,
					5406
				],
				[
					28,
					52
				]
			],
			[
				[
					7076,
					5471
				],
				[
					28,
					-20
				]
			],
			[
				[
					1262,
					702
				],
				[
					24,
					-33
				]
			],
			[
				[
					1286,
					669
				],
				[
					37,
					-6
				]
			],
			[
				[
					1323,
					663
				],
				[
					18,
					16
				]
			],
			[
				[
					1341,
					679
				],
				[
					74,
					-16
				]
			],
			[
				[
					1415,
					663
				],
				[
					82,
					15
				]
			],
			[
				[
					1497,
					678
				],
				[
					5,
					-16
				]
			],
			[
				[
					1502,
					662
				],
				[
					-16,
					-42
				]
			],
			[
				[
					1486,
					620
				],
				[
					54,
					-50
				]
			],
			[
				[
					1540,
					570
				],
				[
					-28,
					-58
				]
			],
			[
				[
					1512,
					512
				],
				[
					90,
					-25
				]
			],
			[
				[
					1602,
					487
				],
				[
					-5,
					-9
				]
			],
			[
				[
					1597,
					478
				],
				[
					32,
					12
				]
			],
			[
				[
					1695,
					422
				],
				[
					-63,
					-13
				]
			],
			[
				[
					1632,
					409
				],
				[
					-76,
					5
				],
				[
					-181,
					-113
				],
				[
					-29,
					10
				]
			],
			[
				[
					1346,
					311
				],
				[
					-49,
					-45
				],
				[
					22,
					-16
				],
				[
					5,
					-27
				],
				[
					-101,
					-39
				],
				[
					32,
					-155
				],
				[
					-135,
					138
				],
				[
					66,
					117
				],
				[
					19,
					128
				],
				[
					-90,
					88
				],
				[
					3,
					84
				],
				[
					-63,
					55
				]
			],
			[
				[
					1055,
					639
				],
				[
					34,
					33
				]
			],
			[
				[
					1089,
					672
				],
				[
					45,
					9
				]
			],
			[
				[
					1134,
					681
				],
				[
					96,
					27
				]
			],
			[
				[
					1230,
					708
				],
				[
					32,
					-6
				]
			],
			[
				[
					6760,
					3201
				],
				[
					-32,
					88
				],
				[
					-134,
					46
				]
			],
			[
				[
					6594,
					3335
				],
				[
					-14,
					61
				]
			],
			[
				[
					6580,
					3396
				],
				[
					-33,
					51
				]
			],
			[
				[
					6547,
					3447
				],
				[
					-12,
					99
				]
			],
			[
				[
					6535,
					3546
				],
				[
					25,
					117
				]
			],
			[
				[
					6560,
					3663
				],
				[
					74,
					54
				],
				[
					226,
					53
				],
				[
					67,
					-306
				],
				[
					-3,
					-118
				],
				[
					-130,
					-141
				],
				[
					-34,
					-4
				]
			],
			[
				[
					5113,
					5384
				],
				[
					22,
					-17
				]
			],
			[
				[
					5135,
					5367
				],
				[
					83,
					-142
				]
			],
			[
				[
					5218,
					5225
				],
				[
					89,
					-14
				]
			],
			[
				[
					5307,
					5211
				],
				[
					26,
					1
				],
				[
					-5,
					-30
				]
			],
			[
				[
					5328,
					5182
				],
				[
					-14,
					-1
				]
			],
			[
				[
					5314,
					5181
				],
				[
					-97,
					-135
				],
				[
					-32,
					-85
				]
			],
			[
				[
					5185,
					4961
				],
				[
					-86,
					-20
				]
			],
			[
				[
					5099,
					4941
				],
				[
					-37,
					95
				],
				[
					-139,
					-25
				]
			],
			[
				[
					4923,
					5011
				],
				[
					-11,
					57
				]
			],
			[
				[
					4912,
					5068
				],
				[
					-7,
					72
				]
			],
			[
				[
					4905,
					5140
				],
				[
					77,
					98
				],
				[
					25,
					139
				],
				[
					106,
					7
				]
			],
			[
				[
					5884,
					2691
				],
				[
					58,
					-42
				]
			],
			[
				[
					5942,
					2649
				],
				[
					13,
					-44
				],
				[
					-42,
					-33
				]
			],
			[
				[
					5913,
					2572
				],
				[
					-15,
					12
				]
			],
			[
				[
					5898,
					2584
				],
				[
					-6,
					25
				]
			],
			[
				[
					5892,
					2609
				],
				[
					-113,
					-64
				]
			],
			[
				[
					5779,
					2545
				],
				[
					-60,
					-113
				]
			],
			[
				[
					5719,
					2432
				],
				[
					-51,
					-58
				]
			],
			[
				[
					5668,
					2374
				],
				[
					-29,
					50
				]
			],
			[
				[
					5639,
					2424
				],
				[
					-10,
					24
				]
			],
			[
				[
					5629,
					2448
				],
				[
					6,
					110
				]
			],
			[
				[
					5635,
					2558
				],
				[
					5,
					72
				]
			],
			[
				[
					5640,
					2630
				],
				[
					-50,
					71
				]
			],
			[
				[
					5590,
					2701
				],
				[
					-17,
					47
				]
			],
			[
				[
					5573,
					2748
				],
				[
					64,
					7
				]
			],
			[
				[
					5637,
					2755
				],
				[
					17,
					26
				]
			],
			[
				[
					5654,
					2781
				],
				[
					46,
					94
				]
			],
			[
				[
					5700,
					2875
				],
				[
					82,
					-64
				],
				[
					65,
					1
				],
				[
					37,
					-121
				]
			],
			[
				[
					2600,
					2002
				],
				[
					60,
					23
				]
			],
			[
				[
					2660,
					2025
				],
				[
					-2,
					-28
				]
			],
			[
				[
					2658,
					1997
				],
				[
					17,
					-26
				],
				[
					82,
					-27
				],
				[
					19,
					-30
				],
				[
					3,
					-51
				]
			],
			[
				[
					2779,
					1863
				],
				[
					-173,
					13
				]
			],
			[
				[
					2606,
					1876
				],
				[
					-57,
					27
				]
			],
			[
				[
					2549,
					1903
				],
				[
					12,
					5
				]
			],
			[
				[
					2561,
					1908
				],
				[
					-20,
					103
				]
			],
			[
				[
					2541,
					2011
				],
				[
					37,
					33
				]
			],
			[
				[
					2578,
					2044
				],
				[
					22,
					-42
				]
			],
			[
				[
					4231,
					6879
				],
				[
					93,
					6
				],
				[
					35,
					-53
				]
			],
			[
				[
					4359,
					6832
				],
				[
					86,
					-5
				]
			],
			[
				[
					4445,
					6827
				],
				[
					67,
					-142
				],
				[
					-36,
					-68
				],
				[
					37,
					-162
				],
				[
					41,
					-15
				]
			],
			[
				[
					4554,
					6440
				],
				[
					5,
					-65
				]
			],
			[
				[
					4559,
					6375
				],
				[
					-16,
					-47
				],
				[
					-7,
					-42
				]
			],
			[
				[
					4536,
					6286
				],
				[
					-64,
					3
				]
			],
			[
				[
					4472,
					6289
				],
				[
					-32,
					26
				]
			],
			[
				[
					4440,
					6315
				],
				[
					-75,
					-11
				]
			],
			[
				[
					4365,
					6304
				],
				[
					30,
					-132
				]
			],
			[
				[
					4395,
					6172
				],
				[
					-48,
					30
				]
			],
			[
				[
					4347,
					6202
				],
				[
					-103,
					-38
				]
			],
			[
				[
					4244,
					6164
				],
				[
					24,
					-13
				]
			],
			[
				[
					4268,
					6151
				],
				[
					-40,
					-42
				]
			],
			[
				[
					4228,
					6109
				],
				[
					-32,
					12
				]
			],
			[
				[
					4196,
					6121
				],
				[
					-41,
					-54
				]
			],
			[
				[
					4155,
					6067
				],
				[
					-101,
					48
				],
				[
					-57,
					132
				],
				[
					-59,
					20
				],
				[
					-1,
					172
				]
			],
			[
				[
					3937,
					6439
				],
				[
					-72,
					64
				]
			],
			[
				[
					3865,
					6503
				],
				[
					70,
					74
				]
			],
			[
				[
					3935,
					6577
				],
				[
					29,
					32
				],
				[
					-22,
					87
				]
			],
			[
				[
					3942,
					6696
				],
				[
					17,
					3
				]
			],
			[
				[
					3959,
					6699
				],
				[
					-13,
					48
				]
			],
			[
				[
					3946,
					6747
				],
				[
					44,
					82
				]
			],
			[
				[
					3990,
					6829
				],
				[
					93,
					67
				]
			],
			[
				[
					4083,
					6896
				],
				[
					111,
					21
				]
			],
			[
				[
					4194,
					6917
				],
				[
					37,
					-38
				]
			],
			[
				[
					2928,
					2772
				],
				[
					27,
					-16
				]
			],
			[
				[
					2955,
					2756
				],
				[
					41,
					-47
				]
			],
			[
				[
					2996,
					2709
				],
				[
					190,
					31
				]
			],
			[
				[
					3186,
					2740
				],
				[
					82,
					-107
				]
			],
			[
				[
					3268,
					2633
				],
				[
					42,
					-15
				]
			],
			[
				[
					3310,
					2618
				],
				[
					-24,
					-18
				],
				[
					17,
					-33
				],
				[
					-26,
					-48
				],
				[
					-96,
					-58
				]
			],
			[
				[
					3181,
					2461
				],
				[
					-39,
					-67
				]
			],
			[
				[
					3142,
					2394
				],
				[
					-99,
					-51
				]
			],
			[
				[
					3043,
					2343
				],
				[
					-7,
					32
				]
			],
			[
				[
					3036,
					2375
				],
				[
					-50,
					55
				]
			],
			[
				[
					2986,
					2430
				],
				[
					-71,
					67
				]
			],
			[
				[
					2915,
					2497
				],
				[
					32,
					93
				],
				[
					-80,
					53
				],
				[
					-11,
					78
				]
			],
			[
				[
					2856,
					2721
				],
				[
					72,
					51
				]
			],
			[
				[
					3115,
					3113
				],
				[
					-25,
					-29
				]
			],
			[
				[
					3090,
					3084
				],
				[
					-58,
					-156
				],
				[
					-45,
					-8
				]
			],
			[
				[
					2987,
					2920
				],
				[
					-36,
					11
				]
			],
			[
				[
					2951,
					2931
				],
				[
					-79,
					9
				]
			],
			[
				[
					2872,
					2940
				],
				[
					14,
					117
				]
			],
			[
				[
					2886,
					3057
				],
				[
					157,
					42
				],
				[
					47,
					46
				]
			],
			[
				[
					3090,
					3145
				],
				[
					25,
					-32
				]
			],
			[
				[
					5780,
					4748
				],
				[
					150,
					-10
				]
			],
			[
				[
					5930,
					4738
				],
				[
					49,
					-96
				]
			],
			[
				[
					5979,
					4642
				],
				[
					79,
					-49
				],
				[
					50,
					-233
				]
			],
			[
				[
					6108,
					4360
				],
				[
					-136,
					-91
				]
			],
			[
				[
					5972,
					4269
				],
				[
					-133,
					-36
				],
				[
					-54,
					73
				],
				[
					-112,
					-1
				]
			],
			[
				[
					5673,
					4305
				],
				[
					-68,
					61
				]
			],
			[
				[
					5605,
					4366
				],
				[
					24,
					314
				],
				[
					45,
					59
				]
			],
			[
				[
					5674,
					4739
				],
				[
					17,
					36
				]
			],
			[
				[
					5691,
					4775
				],
				[
					89,
					-27
				]
			],
			[
				[
					3850,
					1915
				],
				[
					0,
					-14
				]
			],
			[
				[
					3850,
					1901
				],
				[
					31,
					-120
				],
				[
					72,
					-150
				]
			],
			[
				[
					3953,
					1631
				],
				[
					43,
					-11
				]
			],
			[
				[
					3996,
					1620
				],
				[
					-132,
					-89
				],
				[
					-98,
					-29
				]
			],
			[
				[
					3703,
					1712
				],
				[
					-74,
					29
				],
				[
					24,
					88
				]
			],
			[
				[
					3653,
					1829
				],
				[
					171,
					104
				]
			],
			[
				[
					3824,
					1933
				],
				[
					26,
					-18
				]
			],
			[
				[
					4111,
					1997
				],
				[
					138,
					0
				]
			],
			[
				[
					4249,
					1997
				],
				[
					14,
					-8
				]
			],
			[
				[
					4263,
					1989
				],
				[
					89,
					-148
				],
				[
					-48,
					-89
				],
				[
					-151,
					-30
				],
				[
					-39,
					-112
				],
				[
					-118,
					10
				]
			],
			[
				[
					3996,
					1620
				],
				[
					-43,
					11
				]
			],
			[
				[
					3850,
					1901
				],
				[
					0,
					14
				]
			],
			[
				[
					3850,
					1915
				],
				[
					-1,
					16
				]
			],
			[
				[
					3849,
					1931
				],
				[
					133,
					64
				]
			],
			[
				[
					3982,
					1995
				],
				[
					0,
					-8
				]
			],
			[
				[
					3982,
					1987
				],
				[
					80,
					39
				]
			],
			[
				[
					4062,
					2026
				],
				[
					49,
					-29
				]
			],
			[
				[
					1505,
					3614
				],
				[
					37,
					-29
				]
			],
			[
				[
					1542,
					3585
				],
				[
					12,
					-9
				]
			],
			[
				[
					1554,
					3576
				],
				[
					-80,
					8
				],
				[
					11,
					-137
				],
				[
					69,
					-119
				]
			],
			[
				[
					1554,
					3328
				],
				[
					11,
					-76
				]
			],
			[
				[
					1565,
					3252
				],
				[
					-82,
					20
				]
			],
			[
				[
					1483,
					3272
				],
				[
					-50,
					-66
				]
			],
			[
				[
					1433,
					3206
				],
				[
					-13,
					-14
				]
			],
			[
				[
					1420,
					3192
				],
				[
					9,
					-75
				]
			],
			[
				[
					1429,
					3117
				],
				[
					-60,
					1
				]
			],
			[
				[
					1369,
					3118
				],
				[
					-62,
					-104
				]
			],
			[
				[
					1307,
					3014
				],
				[
					-66,
					51
				],
				[
					-77,
					-13
				]
			],
			[
				[
					1164,
					3052
				],
				[
					-15,
					56
				]
			],
			[
				[
					1149,
					3108
				],
				[
					-14,
					41
				]
			],
			[
				[
					1135,
					3149
				],
				[
					-131,
					193
				]
			],
			[
				[
					1004,
					3342
				],
				[
					-7,
					32
				]
			],
			[
				[
					997,
					3374
				],
				[
					65,
					25
				],
				[
					29,
					99
				]
			],
			[
				[
					1091,
					3498
				],
				[
					0,
					73
				]
			],
			[
				[
					1091,
					3571
				],
				[
					203,
					-20
				],
				[
					58,
					46
				],
				[
					1,
					21
				],
				[
					11,
					-4
				],
				[
					35,
					52
				]
			],
			[
				[
					1399,
					3666
				],
				[
					106,
					-52
				]
			],
			[
				[
					5400,
					1836
				],
				[
					11,
					-16
				]
			],
			[
				[
					5411,
					1820
				],
				[
					110,
					-219
				],
				[
					-58,
					-162
				],
				[
					-105,
					32
				],
				[
					-144,
					-25
				],
				[
					2,
					114
				],
				[
					-72,
					80
				]
			],
			[
				[
					5144,
					1640
				],
				[
					40,
					73
				],
				[
					117,
					60
				]
			],
			[
				[
					5301,
					1773
				],
				[
					7,
					76
				]
			],
			[
				[
					5308,
					1849
				],
				[
					22,
					-3
				]
			],
			[
				[
					5330,
					1846
				],
				[
					70,
					-10
				]
			],
			[
				[
					4999,
					2356
				],
				[
					19,
					-37
				],
				[
					-64,
					-194
				]
			],
			[
				[
					4954,
					2125
				],
				[
					-14,
					-84
				]
			],
			[
				[
					4940,
					2041
				],
				[
					-48,
					13
				],
				[
					-56,
					107
				],
				[
					-129,
					31
				],
				[
					53,
					175
				]
			],
			[
				[
					4760,
					2367
				],
				[
					145,
					-4
				]
			],
			[
				[
					4905,
					2363
				],
				[
					65,
					24
				]
			],
			[
				[
					4970,
					2387
				],
				[
					29,
					-31
				]
			],
			[
				[
					8213,
					6121
				],
				[
					-22,
					32
				]
			],
			[
				[
					8191,
					6153
				],
				[
					-93,
					4
				]
			],
			[
				[
					8098,
					6157
				],
				[
					12,
					89
				]
			],
			[
				[
					8110,
					6246
				],
				[
					-76,
					28
				]
			],
			[
				[
					8034,
					6274
				],
				[
					-19,
					85
				]
			],
			[
				[
					8015,
					6359
				],
				[
					16,
					73
				]
			],
			[
				[
					8031,
					6432
				],
				[
					-51,
					77
				],
				[
					13,
					33
				],
				[
					23,
					16
				],
				[
					23,
					-21
				],
				[
					-3,
					28
				],
				[
					18,
					26
				],
				[
					108,
					13
				],
				[
					39,
					-60
				],
				[
					-14,
					-119
				],
				[
					54,
					-52
				],
				[
					91,
					-9
				],
				[
					32,
					-84
				],
				[
					-23,
					-163
				],
				[
					-71,
					-24
				],
				[
					-19,
					0
				],
				[
					-38,
					28
				]
			],
			[
				[
					1205,
					3894
				],
				[
					24,
					4
				]
			],
			[
				[
					1229,
					3898
				],
				[
					33,
					-24
				],
				[
					59,
					-86
				]
			],
			[
				[
					1321,
					3788
				],
				[
					-34,
					-17
				]
			],
			[
				[
					1287,
					3771
				],
				[
					112,
					-105
				]
			],
			[
				[
					1091,
					3571
				],
				[
					0,
					-32
				]
			],
			[
				[
					1091,
					3539
				],
				[
					-24,
					5
				],
				[
					-13,
					30
				],
				[
					-53,
					62
				],
				[
					-19,
					71
				]
			],
			[
				[
					982,
					3707
				],
				[
					-52,
					41
				]
			],
			[
				[
					930,
					3748
				],
				[
					11,
					47
				]
			],
			[
				[
					941,
					3795
				],
				[
					111,
					33
				]
			],
			[
				[
					1052,
					3828
				],
				[
					12,
					95
				]
			],
			[
				[
					1064,
					3923
				],
				[
					127,
					45
				]
			],
			[
				[
					1191,
					3968
				],
				[
					14,
					-74
				]
			],
			[
				[
					870,
					6003
				],
				[
					-7,
					-85
				]
			],
			[
				[
					863,
					5918
				],
				[
					21,
					-43
				]
			],
			[
				[
					884,
					5875
				],
				[
					-63,
					62
				],
				[
					-91,
					-84
				],
				[
					-49,
					-98
				],
				[
					-87,
					8
				],
				[
					-21,
					-106
				]
			],
			[
				[
					573,
					5657
				],
				[
					-25,
					11
				]
			],
			[
				[
					548,
					5668
				],
				[
					-20,
					-51
				],
				[
					-122,
					52
				]
			],
			[
				[
					406,
					5669
				],
				[
					30,
					77
				]
			],
			[
				[
					436,
					5746
				],
				[
					71,
					210
				],
				[
					-119,
					89
				]
			],
			[
				[
					388,
					6045
				],
				[
					59,
					110
				],
				[
					87,
					-64
				],
				[
					107,
					-14
				],
				[
					132,
					-64
				],
				[
					97,
					-10
				]
			],
			[
				[
					1091,
					3539
				],
				[
					0,
					-41
				]
			],
			[
				[
					997,
					3374
				],
				[
					-58,
					19
				]
			],
			[
				[
					939,
					3393
				],
				[
					-107,
					126
				]
			],
			[
				[
					832,
					3519
				],
				[
					-6,
					84
				]
			],
			[
				[
					826,
					3603
				],
				[
					-25,
					23
				]
			],
			[
				[
					801,
					3626
				],
				[
					67,
					34
				]
			],
			[
				[
					868,
					3660
				],
				[
					39,
					51
				]
			],
			[
				[
					907,
					3711
				],
				[
					23,
					37
				]
			],
			[
				[
					930,
					3748
				],
				[
					52,
					-41
				]
			],
			[
				[
					5205,
					2733
				],
				[
					-1,
					-19
				]
			],
			[
				[
					5204,
					2714
				],
				[
					-58,
					-76
				],
				[
					99,
					-74
				]
			],
			[
				[
					5245,
					2564
				],
				[
					45,
					-44
				]
			],
			[
				[
					5290,
					2520
				],
				[
					-69,
					-37
				]
			],
			[
				[
					5221,
					2483
				],
				[
					0,
					-19
				]
			],
			[
				[
					5221,
					2464
				],
				[
					-46,
					-52
				]
			],
			[
				[
					5175,
					2412
				],
				[
					-135,
					33
				]
			],
			[
				[
					5040,
					2445
				],
				[
					-44,
					-12
				]
			],
			[
				[
					4996,
					2433
				],
				[
					-35,
					-25
				]
			],
			[
				[
					4961,
					2408
				],
				[
					-35,
					10
				]
			],
			[
				[
					4926,
					2418
				],
				[
					44,
					117
				],
				[
					-13,
					95
				]
			],
			[
				[
					4957,
					2630
				],
				[
					89,
					153
				]
			],
			[
				[
					5046,
					2783
				],
				[
					46,
					6
				]
			],
			[
				[
					5092,
					2789
				],
				[
					81,
					49
				]
			],
			[
				[
					5173,
					2838
				],
				[
					32,
					-105
				]
			],
			[
				[
					563,
					2284
				],
				[
					82,
					-54
				]
			],
			[
				[
					645,
					2230
				],
				[
					-39,
					-11
				]
			],
			[
				[
					606,
					2219
				],
				[
					14,
					-47
				]
			],
			[
				[
					620,
					2172
				],
				[
					-17,
					-81
				]
			],
			[
				[
					603,
					2091
				],
				[
					-25,
					-51
				]
			],
			[
				[
					578,
					2040
				],
				[
					-32,
					18
				]
			],
			[
				[
					546,
					2058
				],
				[
					-37,
					-6
				]
			],
			[
				[
					509,
					2052
				],
				[
					26,
					-49
				]
			],
			[
				[
					535,
					2003
				],
				[
					22,
					-33
				]
			],
			[
				[
					557,
					1970
				],
				[
					0,
					-37
				]
			],
			[
				[
					557,
					1933
				],
				[
					-9,
					-20
				]
			],
			[
				[
					548,
					1913
				],
				[
					-69,
					-18
				],
				[
					-44,
					132
				]
			],
			[
				[
					435,
					2027
				],
				[
					72,
					125
				],
				[
					-31,
					85
				],
				[
					87,
					47
				]
			],
			[
				[
					219,
					2860
				],
				[
					10,
					-48
				]
			],
			[
				[
					229,
					2812
				],
				[
					-49,
					-113
				],
				[
					11,
					-93
				]
			],
			[
				[
					191,
					2606
				],
				[
					-145,
					-41
				],
				[
					20,
					110
				],
				[
					-64,
					65
				],
				[
					-2,
					78
				],
				[
					85,
					117
				],
				[
					60,
					-127
				],
				[
					74,
					52
				]
			],
			[
				[
					577,
					3057
				],
				[
					90,
					-69
				],
				[
					-3,
					-45
				],
				[
					36,
					-53
				]
			],
			[
				[
					700,
					2890
				],
				[
					111,
					-136
				]
			],
			[
				[
					811,
					2754
				],
				[
					-22,
					-36
				]
			],
			[
				[
					789,
					2718
				],
				[
					-62,
					-28
				],
				[
					-120,
					21
				]
			],
			[
				[
					607,
					2711
				],
				[
					-61,
					-52
				]
			],
			[
				[
					546,
					2659
				],
				[
					-37,
					9
				]
			],
			[
				[
					509,
					2668
				],
				[
					-19,
					-12
				]
			],
			[
				[
					490,
					2656
				],
				[
					-57,
					110
				]
			],
			[
				[
					433,
					2766
				],
				[
					-7,
					121
				]
			],
			[
				[
					426,
					2887
				],
				[
					-37,
					98
				],
				[
					53,
					78
				]
			],
			[
				[
					442,
					3063
				],
				[
					135,
					-6
				]
			],
			[
				[
					927,
					2425
				],
				[
					6,
					-61
				]
			],
			[
				[
					933,
					2364
				],
				[
					22,
					-9
				]
			],
			[
				[
					955,
					2355
				],
				[
					10,
					-27
				]
			],
			[
				[
					965,
					2328
				],
				[
					23,
					21
				]
			],
			[
				[
					988,
					2349
				],
				[
					43,
					-26
				]
			],
			[
				[
					1031,
					2323
				],
				[
					43,
					-101
				]
			],
			[
				[
					1074,
					2222
				],
				[
					29,
					-21
				],
				[
					-12,
					-14
				],
				[
					3,
					-28
				],
				[
					-24,
					-24
				]
			],
			[
				[
					1070,
					2135
				],
				[
					-16,
					20
				],
				[
					-19,
					-8
				],
				[
					-5,
					25
				],
				[
					-14,
					13
				]
			],
			[
				[
					1016,
					2185
				],
				[
					-62,
					-28
				]
			],
			[
				[
					954,
					2157
				],
				[
					-75,
					-3
				]
			],
			[
				[
					879,
					2154
				],
				[
					-30,
					-38
				]
			],
			[
				[
					849,
					2116
				],
				[
					-1,
					42
				],
				[
					-26,
					49
				]
			],
			[
				[
					822,
					2207
				],
				[
					-45,
					66
				]
			],
			[
				[
					777,
					2273
				],
				[
					69,
					74
				]
			],
			[
				[
					846,
					2347
				],
				[
					81,
					78
				]
			],
			[
				[
					3415,
					2986
				],
				[
					56,
					1
				],
				[
					15,
					-105
				]
			],
			[
				[
					3486,
					2882
				],
				[
					6,
					-26
				]
			],
			[
				[
					3492,
					2856
				],
				[
					-51,
					-83
				]
			],
			[
				[
					3441,
					2773
				],
				[
					-32,
					23
				]
			],
			[
				[
					3409,
					2796
				],
				[
					-17,
					-67
				]
			],
			[
				[
					3392,
					2729
				],
				[
					-22,
					-10
				]
			],
			[
				[
					3370,
					2719
				],
				[
					15,
					-37
				],
				[
					-69,
					-70
				],
				[
					-15,
					20
				],
				[
					-33,
					1
				]
			],
			[
				[
					3186,
					2740
				],
				[
					-30,
					50
				],
				[
					21,
					141
				]
			],
			[
				[
					3177,
					2931
				],
				[
					40,
					25
				]
			],
			[
				[
					3217,
					2956
				],
				[
					42,
					-1
				],
				[
					53,
					17
				],
				[
					68,
					45
				],
				[
					-7,
					-24
				],
				[
					42,
					-7
				]
			],
			[
				[
					3921,
					3563
				],
				[
					97,
					36
				]
			],
			[
				[
					4018,
					3599
				],
				[
					34,
					-126
				]
			],
			[
				[
					4052,
					3473
				],
				[
					31,
					3
				]
			],
			[
				[
					4083,
					3476
				],
				[
					26,
					-33
				]
			],
			[
				[
					4109,
					3443
				],
				[
					-56,
					-58
				]
			],
			[
				[
					4036,
					3390
				],
				[
					-28,
					-51
				]
			],
			[
				[
					3984,
					3290
				],
				[
					-5,
					-59
				]
			],
			[
				[
					3945,
					3235
				],
				[
					-50,
					-65
				]
			],
			[
				[
					3895,
					3170
				],
				[
					-26,
					64
				]
			],
			[
				[
					3869,
					3234
				],
				[
					-16,
					9
				]
			],
			[
				[
					3853,
					3243
				],
				[
					-90,
					93
				],
				[
					-12,
					60
				]
			],
			[
				[
					3751,
					3396
				],
				[
					-31,
					31
				]
			],
			[
				[
					3720,
					3427
				],
				[
					24,
					65
				]
			],
			[
				[
					3744,
					3492
				],
				[
					37,
					93
				]
			],
			[
				[
					3781,
					3585
				],
				[
					83,
					20
				]
			],
			[
				[
					3864,
					3605
				],
				[
					35,
					28
				]
			],
			[
				[
					3899,
					3633
				],
				[
					22,
					-70
				]
			],
			[
				[
					4680,
					3694
				],
				[
					111,
					-29
				],
				[
					131,
					9
				]
			],
			[
				[
					4922,
					3674
				],
				[
					33,
					-18
				]
			],
			[
				[
					4955,
					3656
				],
				[
					5,
					-48
				],
				[
					26,
					0
				]
			],
			[
				[
					4986,
					3608
				],
				[
					-41,
					-96
				],
				[
					30,
					-78
				],
				[
					-85,
					-66
				]
			],
			[
				[
					4890,
					3368
				],
				[
					-49,
					-44
				]
			],
			[
				[
					4841,
					3324
				],
				[
					-47,
					31
				]
			],
			[
				[
					4794,
					3355
				],
				[
					-112,
					-63
				]
			],
			[
				[
					4682,
					3292
				],
				[
					-27,
					-11
				]
			],
			[
				[
					4655,
					3281
				],
				[
					13,
					152
				],
				[
					-99,
					122
				]
			],
			[
				[
					4569,
					3555
				],
				[
					1,
					34
				],
				[
					-16,
					21
				]
			],
			[
				[
					4554,
					3610
				],
				[
					71,
					62
				]
			],
			[
				[
					4625,
					3672
				],
				[
					55,
					22
				]
			],
			[
				[
					6484,
					8682
				],
				[
					-10,
					-116
				],
				[
					-104,
					-127
				],
				[
					86,
					-139
				]
			],
			[
				[
					6456,
					8300
				],
				[
					-11,
					-44
				]
			],
			[
				[
					6445,
					8256
				],
				[
					-79,
					-99
				]
			],
			[
				[
					6366,
					8157
				],
				[
					14,
					-26
				]
			],
			[
				[
					6380,
					8131
				],
				[
					-52,
					-3
				]
			],
			[
				[
					6328,
					8128
				],
				[
					-31,
					19
				]
			],
			[
				[
					6297,
					8147
				],
				[
					-89,
					30
				]
			],
			[
				[
					6208,
					8177
				],
				[
					-12,
					-24
				]
			],
			[
				[
					6196,
					8153
				],
				[
					-321,
					181
				],
				[
					21,
					82
				],
				[
					-60,
					122
				],
				[
					150,
					-50
				],
				[
					170,
					14
				],
				[
					59,
					54
				],
				[
					11,
					124
				],
				[
					120,
					92
				],
				[
					138,
					-90
				]
			],
			[
				[
					1677,
					3280
				],
				[
					31,
					-3
				]
			],
			[
				[
					1708,
					3277
				],
				[
					-14,
					-87
				]
			],
			[
				[
					1694,
					3190
				],
				[
					-54,
					-97
				]
			],
			[
				[
					1640,
					3093
				],
				[
					-93,
					-81
				]
			],
			[
				[
					1547,
					3012
				],
				[
					38,
					-40
				]
			],
			[
				[
					1585,
					2972
				],
				[
					-39,
					-70
				]
			],
			[
				[
					1546,
					2902
				],
				[
					-66,
					-45
				]
			],
			[
				[
					1480,
					2857
				],
				[
					-27,
					-53
				]
			],
			[
				[
					1453,
					2804
				],
				[
					-51,
					36
				],
				[
					43,
					53
				]
			],
			[
				[
					1445,
					2893
				],
				[
					-42,
					21
				]
			],
			[
				[
					1403,
					2914
				],
				[
					-17,
					-7
				]
			],
			[
				[
					1386,
					2907
				],
				[
					-5,
					123
				]
			],
			[
				[
					1381,
					3030
				],
				[
					-12,
					88
				]
			],
			[
				[
					1429,
					3117
				],
				[
					-9,
					75
				]
			],
			[
				[
					1433,
					3206
				],
				[
					50,
					66
				]
			],
			[
				[
					1565,
					3252
				],
				[
					39,
					-20
				]
			],
			[
				[
					1604,
					3232
				],
				[
					73,
					48
				]
			],
			[
				[
					1810,
					3284
				],
				[
					94,
					-88
				],
				[
					102,
					5
				]
			],
			[
				[
					2006,
					3201
				],
				[
					13,
					-57
				]
			],
			[
				[
					2019,
					3144
				],
				[
					-25,
					-24
				],
				[
					-10,
					9
				]
			],
			[
				[
					1984,
					3129
				],
				[
					-42,
					-14
				]
			],
			[
				[
					1942,
					3115
				],
				[
					-43,
					-46
				]
			],
			[
				[
					1899,
					3069
				],
				[
					-16,
					-92
				],
				[
					-77,
					-123
				],
				[
					26,
					-80
				]
			],
			[
				[
					1832,
					2774
				],
				[
					-141,
					-35
				]
			],
			[
				[
					1691,
					2739
				],
				[
					-107,
					166
				]
			],
			[
				[
					1584,
					2905
				],
				[
					1,
					67
				]
			],
			[
				[
					1547,
					3012
				],
				[
					93,
					81
				]
			],
			[
				[
					1640,
					3093
				],
				[
					54,
					97
				]
			],
			[
				[
					1708,
					3277
				],
				[
					18,
					-1
				]
			],
			[
				[
					1726,
					3276
				],
				[
					39,
					-9
				]
			],
			[
				[
					1765,
					3267
				],
				[
					45,
					17
				]
			],
			[
				[
					794,
					1865
				],
				[
					127,
					-89
				],
				[
					84,
					16
				]
			],
			[
				[
					1005,
					1792
				],
				[
					47,
					-45
				]
			],
			[
				[
					1052,
					1747
				],
				[
					100,
					-39
				]
			],
			[
				[
					1152,
					1708
				],
				[
					24,
					-14
				]
			],
			[
				[
					1176,
					1694
				],
				[
					-92,
					-86
				],
				[
					-35,
					-189
				]
			],
			[
				[
					1049,
					1419
				],
				[
					-103,
					-23
				]
			],
			[
				[
					946,
					1396
				],
				[
					-76,
					83
				]
			],
			[
				[
					870,
					1479
				],
				[
					-53,
					-28
				]
			],
			[
				[
					817,
					1451
				],
				[
					-63,
					157
				],
				[
					33,
					90
				],
				[
					-59,
					80
				],
				[
					26,
					67
				]
			],
			[
				[
					754,
					1845
				],
				[
					-1,
					31
				]
			],
			[
				[
					753,
					1876
				],
				[
					41,
					-11
				]
			],
			[
				[
					2446,
					4163
				],
				[
					78,
					-58
				]
			],
			[
				[
					2524,
					4105
				],
				[
					7,
					-38
				]
			],
			[
				[
					2531,
					4067
				],
				[
					-22,
					-24
				]
			],
			[
				[
					2509,
					4043
				],
				[
					80,
					-186
				]
			],
			[
				[
					2589,
					3857
				],
				[
					2,
					10
				],
				[
					63,
					16
				],
				[
					9,
					-7
				]
			],
			[
				[
					2663,
					3876
				],
				[
					-3,
					-21
				]
			],
			[
				[
					2660,
					3855
				],
				[
					-97,
					-46
				]
			],
			[
				[
					2563,
					3809
				],
				[
					-56,
					-43
				]
			],
			[
				[
					2507,
					3766
				],
				[
					-110,
					-5
				]
			],
			[
				[
					2397,
					3761
				],
				[
					-49,
					18
				]
			],
			[
				[
					2348,
					3779
				],
				[
					-124,
					12
				],
				[
					13,
					282
				]
			],
			[
				[
					2237,
					4073
				],
				[
					31,
					16
				]
			],
			[
				[
					2268,
					4089
				],
				[
					31,
					-7
				]
			],
			[
				[
					2299,
					4082
				],
				[
					46,
					37
				]
			],
			[
				[
					2345,
					4119
				],
				[
					101,
					44
				]
			],
			[
				[
					3380,
					6300
				],
				[
					60,
					5
				],
				[
					132,
					-78
				],
				[
					161,
					-25
				]
			],
			[
				[
					3733,
					6202
				],
				[
					5,
					-45
				]
			],
			[
				[
					3738,
					6157
				],
				[
					14,
					-138
				]
			],
			[
				[
					3752,
					6019
				],
				[
					-32,
					-64
				]
			],
			[
				[
					3720,
					5955
				],
				[
					-192,
					-97
				],
				[
					-141,
					-25
				]
			],
			[
				[
					3387,
					5833
				],
				[
					-48,
					-10
				]
			],
			[
				[
					3164,
					5980
				],
				[
					-156,
					39
				]
			],
			[
				[
					3008,
					6019
				],
				[
					-60,
					58
				]
			],
			[
				[
					2948,
					6077
				],
				[
					35,
					36
				],
				[
					201,
					43
				],
				[
					113,
					111
				],
				[
					-13,
					75
				],
				[
					54,
					59
				]
			],
			[
				[
					3338,
					6401
				],
				[
					28,
					-68
				]
			],
			[
				[
					3366,
					6333
				],
				[
					14,
					-33
				]
			],
			[
				[
					2729,
					4095
				],
				[
					2,
					-87
				]
			],
			[
				[
					2731,
					4008
				],
				[
					-40,
					-36
				]
			],
			[
				[
					2691,
					3972
				],
				[
					-26,
					-55
				]
			],
			[
				[
					2665,
					3917
				],
				[
					-2,
					-41
				]
			],
			[
				[
					2663,
					3876
				],
				[
					-21,
					8
				],
				[
					-2,
					-12
				],
				[
					-17,
					4
				],
				[
					-34,
					-19
				]
			],
			[
				[
					2509,
					4043
				],
				[
					75,
					38
				]
			],
			[
				[
					2584,
					4081
				],
				[
					93,
					31
				]
			],
			[
				[
					2677,
					4112
				],
				[
					52,
					-17
				]
			],
			[
				[
					8213,
					6121
				],
				[
					50,
					-28
				]
			],
			[
				[
					8263,
					6093
				],
				[
					-33,
					-168
				],
				[
					-67,
					-89
				]
			],
			[
				[
					8163,
					5836
				],
				[
					-4,
					-15
				]
			],
			[
				[
					8159,
					5821
				],
				[
					-66,
					-8
				],
				[
					-37,
					55
				],
				[
					-122,
					-47
				]
			],
			[
				[
					7934,
					5821
				],
				[
					-24,
					106
				],
				[
					12,
					38
				]
			],
			[
				[
					7922,
					5965
				],
				[
					18,
					2
				]
			],
			[
				[
					7940,
					5967
				],
				[
					45,
					46
				]
			],
			[
				[
					7985,
					6013
				],
				[
					-12,
					27
				]
			],
			[
				[
					7973,
					6040
				],
				[
					48,
					82
				]
			],
			[
				[
					8021,
					6122
				],
				[
					39,
					24
				]
			],
			[
				[
					8060,
					6146
				],
				[
					131,
					7
				]
			],
			[
				[
					4727,
					4595
				],
				[
					22,
					-21
				],
				[
					8,
					-37
				]
			],
			[
				[
					4757,
					4537
				],
				[
					76,
					-113
				]
			],
			[
				[
					4833,
					4424
				],
				[
					39,
					-166
				]
			],
			[
				[
					4872,
					4258
				],
				[
					-49,
					-14
				]
			],
			[
				[
					4823,
					4244
				],
				[
					-14,
					23
				]
			],
			[
				[
					4809,
					4267
				],
				[
					-81,
					-2
				]
			],
			[
				[
					4728,
					4265
				],
				[
					-107,
					54
				]
			],
			[
				[
					4621,
					4319
				],
				[
					-33,
					17
				]
			],
			[
				[
					4588,
					4336
				],
				[
					-60,
					13
				]
			],
			[
				[
					4528,
					4349
				],
				[
					-44,
					-23
				]
			],
			[
				[
					4484,
					4326
				],
				[
					-28,
					113
				],
				[
					-62,
					94
				]
			],
			[
				[
					4394,
					4533
				],
				[
					70,
					35
				]
			],
			[
				[
					4464,
					4568
				],
				[
					143,
					-2
				]
			],
			[
				[
					4607,
					4566
				],
				[
					45,
					12
				]
			],
			[
				[
					4652,
					4578
				],
				[
					33,
					-8
				]
			],
			[
				[
					4685,
					4570
				],
				[
					42,
					25
				]
			],
			[
				[
					2930,
					3554
				],
				[
					43,
					-123
				]
			],
			[
				[
					3000,
					3379
				],
				[
					34,
					-82
				]
			],
			[
				[
					3034,
					3297
				],
				[
					-3,
					-28
				]
			],
			[
				[
					3031,
					3269
				],
				[
					59,
					24
				]
			],
			[
				[
					3090,
					3293
				],
				[
					3,
					-41
				]
			],
			[
				[
					3093,
					3252
				],
				[
					33,
					-72
				]
			],
			[
				[
					3126,
					3180
				],
				[
					-72,
					-34
				]
			],
			[
				[
					3054,
					3146
				],
				[
					-62,
					53
				]
			],
			[
				[
					2992,
					3199
				],
				[
					-86,
					24
				],
				[
					-190,
					-61
				]
			],
			[
				[
					2716,
					3162
				],
				[
					-19,
					86
				]
			],
			[
				[
					2664,
					3250
				],
				[
					-46,
					-4
				]
			],
			[
				[
					2588,
					3259
				],
				[
					36,
					79
				]
			],
			[
				[
					2624,
					3338
				],
				[
					40,
					-5
				]
			],
			[
				[
					2664,
					3333
				],
				[
					113,
					93
				]
			],
			[
				[
					2777,
					3426
				],
				[
					43,
					77
				]
			],
			[
				[
					1497,
					4563
				],
				[
					7,
					-45
				]
			],
			[
				[
					1504,
					4518
				],
				[
					48,
					-76
				]
			],
			[
				[
					1552,
					4442
				],
				[
					-30,
					-85
				]
			],
			[
				[
					1522,
					4357
				],
				[
					-65,
					1
				]
			],
			[
				[
					1457,
					4358
				],
				[
					-26,
					34
				]
			],
			[
				[
					1431,
					4392
				],
				[
					-63,
					75
				]
			],
			[
				[
					1368,
					4467
				],
				[
					-52,
					88
				]
			],
			[
				[
					1316,
					4555
				],
				[
					49,
					30
				]
			],
			[
				[
					1365,
					4585
				],
				[
					75,
					26
				]
			],
			[
				[
					1440,
					4611
				],
				[
					57,
					-48
				]
			],
			[
				[
					3070,
					7367
				],
				[
					-37,
					-45
				]
			],
			[
				[
					3033,
					7322
				],
				[
					34,
					-67
				],
				[
					63,
					-39
				]
			],
			[
				[
					3130,
					7216
				],
				[
					-105,
					-108
				],
				[
					-60,
					-3
				]
			],
			[
				[
					2965,
					7105
				],
				[
					0,
					-45
				]
			],
			[
				[
					2965,
					7060
				],
				[
					-43,
					2
				]
			],
			[
				[
					2922,
					7062
				],
				[
					-54,
					-42
				]
			],
			[
				[
					2868,
					7020
				],
				[
					-85,
					50
				],
				[
					-37,
					107
				]
			],
			[
				[
					2746,
					7177
				],
				[
					41,
					55
				]
			],
			[
				[
					2787,
					7232
				],
				[
					-15,
					13
				]
			],
			[
				[
					2939,
					7429
				],
				[
					131,
					-62
				]
			],
			[
				[
					3636,
					7762
				],
				[
					39,
					8
				],
				[
					51,
					-252
				],
				[
					45,
					-40
				]
			],
			[
				[
					3771,
					7478
				],
				[
					-4,
					-44
				]
			],
			[
				[
					3767,
					7434
				],
				[
					-17,
					-13
				]
			],
			[
				[
					3750,
					7421
				],
				[
					-45,
					60
				]
			],
			[
				[
					3705,
					7481
				],
				[
					-108,
					3
				]
			],
			[
				[
					3597,
					7484
				],
				[
					-106,
					163
				],
				[
					18,
					93
				]
			],
			[
				[
					3509,
					7740
				],
				[
					-8,
					92
				],
				[
					87,
					49
				]
			],
			[
				[
					3588,
					7881
				],
				[
					48,
					-119
				]
			],
			[
				[
					6832,
					6438
				],
				[
					120,
					-57
				]
			],
			[
				[
					6952,
					6381
				],
				[
					70,
					5
				]
			],
			[
				[
					7022,
					6386
				],
				[
					71,
					-63
				],
				[
					-3,
					-72
				]
			],
			[
				[
					7090,
					6251
				],
				[
					13,
					-39
				]
			],
			[
				[
					7103,
					6212
				],
				[
					-71,
					7
				],
				[
					-113,
					-57
				],
				[
					11,
					-16
				],
				[
					-10,
					-12
				]
			],
			[
				[
					6920,
					6134
				],
				[
					-66,
					127
				]
			],
			[
				[
					6854,
					6261
				],
				[
					-86,
					97
				]
			],
			[
				[
					6768,
					6358
				],
				[
					45,
					24
				],
				[
					-24,
					23
				],
				[
					43,
					33
				]
			],
			[
				[
					2530,
					3644
				],
				[
					39,
					-50
				]
			],
			[
				[
					2569,
					3594
				],
				[
					78,
					-28
				]
			],
			[
				[
					2647,
					3566
				],
				[
					12,
					-13
				]
			],
			[
				[
					2659,
					3553
				],
				[
					6,
					-23
				]
			],
			[
				[
					2665,
					3530
				],
				[
					13,
					-43
				]
			],
			[
				[
					2678,
					3487
				],
				[
					-108,
					-29
				]
			],
			[
				[
					2570,
					3458
				],
				[
					-25,
					-9
				]
			],
			[
				[
					2545,
					3449
				],
				[
					-62,
					7
				]
			],
			[
				[
					2483,
					3456
				],
				[
					8,
					61
				]
			],
			[
				[
					2491,
					3517
				],
				[
					-92,
					34
				],
				[
					-2,
					91
				],
				[
					133,
					2
				]
			],
			[
				[
					4841,
					3324
				],
				[
					65,
					12
				]
			],
			[
				[
					4906,
					3336
				],
				[
					80,
					-116
				],
				[
					109,
					77
				]
			],
			[
				[
					5095,
					3297
				],
				[
					32,
					-45
				]
			],
			[
				[
					5053,
					3028
				],
				[
					-34,
					-12
				]
			],
			[
				[
					5019,
					3016
				],
				[
					-85,
					-1
				]
			],
			[
				[
					4934,
					3015
				],
				[
					-53,
					-46
				],
				[
					-95,
					18
				]
			],
			[
				[
					4786,
					2987
				],
				[
					-90,
					-27
				]
			],
			[
				[
					4696,
					2960
				],
				[
					-15,
					8
				]
			],
			[
				[
					4681,
					2968
				],
				[
					14,
					27
				]
			],
			[
				[
					4695,
					2995
				],
				[
					5,
					169
				],
				[
					-33,
					85
				]
			],
			[
				[
					4667,
					3249
				],
				[
					15,
					43
				]
			],
			[
				[
					4794,
					3355
				],
				[
					47,
					-31
				]
			],
			[
				[
					925,
					3138
				],
				[
					27,
					-20
				]
			],
			[
				[
					952,
					3118
				],
				[
					158,
					-39
				]
			],
			[
				[
					1110,
					3079
				],
				[
					54,
					-27
				]
			],
			[
				[
					1307,
					3014
				],
				[
					74,
					16
				]
			],
			[
				[
					1381,
					3030
				],
				[
					5,
					-123
				]
			],
			[
				[
					1403,
					2914
				],
				[
					42,
					-21
				]
			],
			[
				[
					1445,
					2893
				],
				[
					-55,
					-39
				]
			],
			[
				[
					1390,
					2854
				],
				[
					-57,
					-49
				],
				[
					-141,
					-1
				],
				[
					-25,
					-71
				]
			],
			[
				[
					1167,
					2733
				],
				[
					-95,
					-15
				]
			],
			[
				[
					1072,
					2718
				],
				[
					-54,
					13
				]
			],
			[
				[
					1018,
					2731
				],
				[
					-14,
					46
				]
			],
			[
				[
					1004,
					2777
				],
				[
					16,
					3
				]
			],
			[
				[
					1020,
					2780
				],
				[
					-12,
					43
				]
			],
			[
				[
					1008,
					2823
				],
				[
					3,
					40
				]
			],
			[
				[
					1011,
					2863
				],
				[
					-49,
					-5
				],
				[
					-100,
					170
				],
				[
					-58,
					-14
				]
			],
			[
				[
					804,
					3014
				],
				[
					-24,
					56
				]
			],
			[
				[
					780,
					3070
				],
				[
					11,
					8
				]
			],
			[
				[
					791,
					3078
				],
				[
					-14,
					18
				]
			],
			[
				[
					777,
					3096
				],
				[
					29,
					16
				]
			],
			[
				[
					806,
					3112
				],
				[
					94,
					19
				]
			],
			[
				[
					900,
					3131
				],
				[
					25,
					7
				]
			],
			[
				[
					551,
					2462
				],
				[
					37,
					-11
				]
			],
			[
				[
					588,
					2451
				],
				[
					81,
					-65
				]
			],
			[
				[
					669,
					2386
				],
				[
					-12,
					-47
				]
			],
			[
				[
					657,
					2339
				],
				[
					8,
					-20
				]
			],
			[
				[
					665,
					2319
				],
				[
					-102,
					-35
				]
			],
			[
				[
					563,
					2284
				],
				[
					-54,
					55
				],
				[
					-171,
					63
				],
				[
					-7,
					54
				]
			],
			[
				[
					331,
					2456
				],
				[
					109,
					-66
				],
				[
					111,
					72
				]
			],
			[
				[
					3189,
					5495
				],
				[
					-23,
					-35
				]
			],
			[
				[
					3166,
					5460
				],
				[
					17,
					-171
				]
			],
			[
				[
					3183,
					5289
				],
				[
					-19,
					3
				]
			],
			[
				[
					3164,
					5292
				],
				[
					-39,
					-3
				]
			],
			[
				[
					3125,
					5289
				],
				[
					-66,
					-46
				]
			],
			[
				[
					3059,
					5243
				],
				[
					-62,
					-54
				]
			],
			[
				[
					2997,
					5189
				],
				[
					-128,
					-43
				]
			],
			[
				[
					2869,
					5146
				],
				[
					-84,
					63
				]
			],
			[
				[
					2785,
					5209
				],
				[
					10,
					1
				]
			],
			[
				[
					2795,
					5210
				],
				[
					-1,
					47
				]
			],
			[
				[
					2794,
					5257
				],
				[
					-35,
					109
				],
				[
					84,
					78
				]
			],
			[
				[
					2843,
					5444
				],
				[
					84,
					70
				]
			],
			[
				[
					3036,
					5549
				],
				[
					54,
					5
				]
			],
			[
				[
					4258,
					4763
				],
				[
					50,
					-115
				]
			],
			[
				[
					4308,
					4648
				],
				[
					11,
					5
				]
			],
			[
				[
					4319,
					4653
				],
				[
					3,
					-9
				],
				[
					-27,
					-27
				],
				[
					34,
					-67
				]
			],
			[
				[
					4329,
					4550
				],
				[
					-46,
					-26
				]
			],
			[
				[
					4283,
					4524
				],
				[
					-34,
					-3
				]
			],
			[
				[
					4249,
					4521
				],
				[
					-6,
					-25
				],
				[
					-16,
					-10
				]
			],
			[
				[
					4227,
					4486
				],
				[
					9,
					50
				]
			],
			[
				[
					4236,
					4536
				],
				[
					-71,
					50
				]
			],
			[
				[
					4165,
					4586
				],
				[
					9,
					12
				]
			],
			[
				[
					4146,
					4719
				],
				[
					112,
					44
				]
			],
			[
				[
					1154,
					5499
				],
				[
					-4,
					-23
				]
			],
			[
				[
					1150,
					5476
				],
				[
					-117,
					-4
				]
			],
			[
				[
					1033,
					5472
				],
				[
					-76,
					73
				],
				[
					-54,
					6
				]
			],
			[
				[
					903,
					5551
				],
				[
					37,
					32
				]
			],
			[
				[
					940,
					5583
				],
				[
					-13,
					205
				]
			],
			[
				[
					927,
					5788
				],
				[
					-64,
					130
				]
			],
			[
				[
					863,
					5918
				],
				[
					7,
					85
				]
			],
			[
				[
					870,
					6003
				],
				[
					53,
					-16
				],
				[
					109,
					-81
				],
				[
					36,
					-58
				],
				[
					31,
					-105
				],
				[
					32,
					-27
				],
				[
					38,
					-11
				],
				[
					96,
					-12
				]
			],
			[
				[
					2394,
					6415
				],
				[
					14,
					10
				]
			],
			[
				[
					2408,
					6425
				],
				[
					36,
					-57
				]
			],
			[
				[
					2444,
					6368
				],
				[
					44,
					-38
				]
			],
			[
				[
					2488,
					6330
				],
				[
					-18,
					-123
				]
			],
			[
				[
					2470,
					6207
				],
				[
					-13,
					-50
				]
			],
			[
				[
					2457,
					6157
				],
				[
					10,
					-27
				],
				[
					-8,
					-4
				],
				[
					38,
					-29
				]
			],
			[
				[
					2497,
					6097
				],
				[
					-56,
					-55
				],
				[
					74,
					-129
				],
				[
					4,
					-76
				]
			],
			[
				[
					2519,
					5837
				],
				[
					-113,
					-51
				]
			],
			[
				[
					2406,
					5786
				],
				[
					-90,
					103
				]
			],
			[
				[
					2316,
					5889
				],
				[
					-94,
					14
				]
			],
			[
				[
					2222,
					5903
				],
				[
					-66,
					-28
				]
			],
			[
				[
					2156,
					5875
				],
				[
					-32,
					-16
				]
			],
			[
				[
					2124,
					5859
				],
				[
					-57,
					197
				],
				[
					74,
					130
				],
				[
					-54,
					130
				]
			],
			[
				[
					2087,
					6316
				],
				[
					26,
					28
				]
			],
			[
				[
					2113,
					6344
				],
				[
					54,
					-19
				]
			],
			[
				[
					2167,
					6325
				],
				[
					154,
					54
				]
			],
			[
				[
					2321,
					6379
				],
				[
					73,
					36
				]
			],
			[
				[
					5426,
					2174
				],
				[
					100,
					-89
				]
			],
			[
				[
					5526,
					2085
				],
				[
					79,
					-41
				]
			],
			[
				[
					5605,
					2044
				],
				[
					-8,
					-47
				]
			],
			[
				[
					5597,
					1997
				],
				[
					-78,
					-123
				],
				[
					-108,
					-54
				]
			],
			[
				[
					5400,
					1836
				],
				[
					-70,
					10
				]
			],
			[
				[
					5308,
					1849
				],
				[
					-53,
					2
				]
			],
			[
				[
					5255,
					1851
				],
				[
					-30,
					37
				]
			],
			[
				[
					5225,
					1888
				],
				[
					18,
					39
				]
			],
			[
				[
					5243,
					1927
				],
				[
					-15,
					128
				],
				[
					90,
					56
				]
			],
			[
				[
					5318,
					2111
				],
				[
					22,
					15
				]
			],
			[
				[
					5340,
					2126
				],
				[
					32,
					18
				]
			],
			[
				[
					5372,
					2144
				],
				[
					54,
					30
				]
			],
			[
				[
					5658,
					3041
				],
				[
					-6,
					-10
				]
			],
			[
				[
					5652,
					3031
				],
				[
					60,
					-97
				]
			],
			[
				[
					5712,
					2934
				],
				[
					-12,
					-59
				]
			],
			[
				[
					5700,
					2875
				],
				[
					-46,
					-94
				]
			],
			[
				[
					5637,
					2755
				],
				[
					-51,
					1
				],
				[
					-45,
					-13
				],
				[
					-44,
					-22
				]
			],
			[
				[
					5497,
					2721
				],
				[
					-110,
					23
				]
			],
			[
				[
					5387,
					2744
				],
				[
					-73,
					16
				]
			],
			[
				[
					5314,
					2760
				],
				[
					-96,
					-73
				]
			],
			[
				[
					5218,
					2687
				],
				[
					-13,
					46
				]
			],
			[
				[
					5205,
					2733
				],
				[
					-32,
					105
				]
			],
			[
				[
					5173,
					2838
				],
				[
					-81,
					-49
				]
			],
			[
				[
					5092,
					2789
				],
				[
					-46,
					-6
				]
			],
			[
				[
					5046,
					2783
				],
				[
					-44,
					-4
				]
			],
			[
				[
					5002,
					2779
				],
				[
					-33,
					62
				],
				[
					61,
					71
				]
			],
			[
				[
					5030,
					2912
				],
				[
					13,
					-14
				],
				[
					49,
					1
				]
			],
			[
				[
					5591,
					3128
				],
				[
					44,
					-97
				]
			],
			[
				[
					2992,
					3199
				],
				[
					62,
					-53
				]
			],
			[
				[
					3054,
					3146
				],
				[
					29,
					11
				]
			],
			[
				[
					3083,
					3157
				],
				[
					7,
					-12
				]
			],
			[
				[
					2886,
					3057
				],
				[
					-84,
					-2
				],
				[
					-66,
					-58
				],
				[
					-52,
					39
				]
			],
			[
				[
					2684,
					3036
				],
				[
					1,
					61
				],
				[
					31,
					65
				]
			],
			[
				[
					3534,
					4615
				],
				[
					-2,
					-111
				]
			],
			[
				[
					3532,
					4504
				],
				[
					-133,
					-6
				]
			],
			[
				[
					3399,
					4498
				],
				[
					-16,
					-56
				]
			],
			[
				[
					3383,
					4442
				],
				[
					-67,
					-109
				]
			],
			[
				[
					3316,
					4333
				],
				[
					-173,
					26
				]
			],
			[
				[
					3143,
					4359
				],
				[
					-63,
					-23
				]
			],
			[
				[
					3080,
					4336
				],
				[
					-77,
					82
				]
			],
			[
				[
					3003,
					4418
				],
				[
					-4,
					83
				]
			],
			[
				[
					2999,
					4501
				],
				[
					-18,
					67
				]
			],
			[
				[
					2981,
					4568
				],
				[
					-23,
					39
				]
			],
			[
				[
					2958,
					4607
				],
				[
					80,
					37
				]
			],
			[
				[
					3038,
					4644
				],
				[
					35,
					51
				]
			],
			[
				[
					3073,
					4695
				],
				[
					42,
					4
				]
			],
			[
				[
					3115,
					4699
				],
				[
					56,
					21
				]
			],
			[
				[
					3171,
					4720
				],
				[
					36,
					50
				]
			],
			[
				[
					3207,
					4770
				],
				[
					49,
					-18
				]
			],
			[
				[
					3256,
					4752
				],
				[
					57,
					23
				]
			],
			[
				[
					3313,
					4775
				],
				[
					13,
					19
				]
			],
			[
				[
					3326,
					4794
				],
				[
					139,
					-22
				]
			],
			[
				[
					4218,
					2349
				],
				[
					20,
					-33
				]
			],
			[
				[
					4238,
					2316
				],
				[
					51,
					-38
				]
			],
			[
				[
					4289,
					2278
				],
				[
					24,
					12
				]
			],
			[
				[
					4313,
					2290
				],
				[
					30,
					-34
				]
			],
			[
				[
					4343,
					2256
				],
				[
					-75,
					-223
				]
			],
			[
				[
					4268,
					2033
				],
				[
					-19,
					-36
				]
			],
			[
				[
					4111,
					1997
				],
				[
					-49,
					29
				]
			],
			[
				[
					3982,
					1987
				],
				[
					1,
					43
				]
			],
			[
				[
					3983,
					2030
				],
				[
					-40,
					48
				]
			],
			[
				[
					3943,
					2078
				],
				[
					103,
					20
				]
			],
			[
				[
					4046,
					2098
				],
				[
					80,
					133
				],
				[
					64,
					33
				],
				[
					-11,
					92
				]
			],
			[
				[
					4179,
					2356
				],
				[
					46,
					8
				]
			],
			[
				[
					4225,
					2364
				],
				[
					-7,
					-15
				]
			],
			[
				[
					4488,
					2628
				],
				[
					25,
					-51
				]
			],
			[
				[
					4513,
					2577
				],
				[
					76,
					9
				]
			],
			[
				[
					4589,
					2586
				],
				[
					9,
					-75
				],
				[
					19,
					-41
				],
				[
					-15,
					-46
				]
			],
			[
				[
					4602,
					2424
				],
				[
					-121,
					-97
				]
			],
			[
				[
					4481,
					2327
				],
				[
					-66,
					-31
				]
			],
			[
				[
					4415,
					2296
				],
				[
					-68,
					7
				]
			],
			[
				[
					4347,
					2303
				],
				[
					-34,
					-13
				]
			],
			[
				[
					4289,
					2278
				],
				[
					-51,
					38
				]
			],
			[
				[
					4238,
					2316
				],
				[
					-20,
					33
				]
			],
			[
				[
					4225,
					2364
				],
				[
					-31,
					58
				]
			],
			[
				[
					4194,
					2422
				],
				[
					-66,
					166
				],
				[
					26,
					32
				]
			],
			[
				[
					4154,
					2620
				],
				[
					-16,
					32
				]
			],
			[
				[
					4138,
					2652
				],
				[
					46,
					14
				]
			],
			[
				[
					4184,
					2666
				],
				[
					22,
					-1
				],
				[
					30,
					16
				],
				[
					20,
					-2
				]
			],
			[
				[
					4256,
					2679
				],
				[
					2,
					-12
				]
			],
			[
				[
					4258,
					2667
				],
				[
					107,
					33
				]
			],
			[
				[
					4365,
					2700
				],
				[
					57,
					-7
				]
			],
			[
				[
					4422,
					2693
				],
				[
					66,
					-65
				]
			],
			[
				[
					4111,
					3096
				],
				[
					11,
					-14
				],
				[
					37,
					-11
				]
			],
			[
				[
					4159,
					3071
				],
				[
					11,
					-17
				]
			],
			[
				[
					4170,
					3054
				],
				[
					9,
					-65
				]
			],
			[
				[
					4179,
					2989
				],
				[
					-6,
					-11
				]
			],
			[
				[
					4173,
					2978
				],
				[
					-56,
					-106
				],
				[
					-57,
					19
				],
				[
					-152,
					-35
				],
				[
					-75,
					19
				]
			],
			[
				[
					3833,
					2875
				],
				[
					-22,
					16
				]
			],
			[
				[
					3811,
					2891
				],
				[
					-8,
					60
				]
			],
			[
				[
					3803,
					2951
				],
				[
					56,
					72
				]
			],
			[
				[
					3859,
					3023
				],
				[
					16,
					49
				]
			],
			[
				[
					3875,
					3072
				],
				[
					12,
					-3
				]
			],
			[
				[
					3887,
					3069
				],
				[
					66,
					3
				]
			],
			[
				[
					1998,
					2001
				],
				[
					15,
					-191
				],
				[
					-82,
					-54
				]
			],
			[
				[
					1931,
					1756
				],
				[
					5,
					-16
				]
			],
			[
				[
					1936,
					1740
				],
				[
					-64,
					40
				],
				[
					-176,
					22
				]
			],
			[
				[
					1696,
					1802
				],
				[
					-37,
					-21
				]
			],
			[
				[
					1659,
					1781
				],
				[
					16,
					-22
				]
			],
			[
				[
					1675,
					1759
				],
				[
					-80,
					-38
				]
			],
			[
				[
					1595,
					1721
				],
				[
					-2,
					56
				]
			],
			[
				[
					1593,
					1777
				],
				[
					-43,
					32
				]
			],
			[
				[
					1568,
					1877
				],
				[
					37,
					10
				]
			],
			[
				[
					1776,
					1959
				],
				[
					20,
					17
				]
			],
			[
				[
					1796,
					1976
				],
				[
					131,
					10
				]
			],
			[
				[
					1927,
					1986
				],
				[
					71,
					15
				]
			],
			[
				[
					2549,
					1903
				],
				[
					-2,
					-22
				]
			],
			[
				[
					2547,
					1881
				],
				[
					-121,
					-37
				]
			],
			[
				[
					2426,
					1844
				],
				[
					-47,
					-44
				]
			],
			[
				[
					2379,
					1800
				],
				[
					-11,
					15
				]
			],
			[
				[
					2368,
					1815
				],
				[
					-18,
					-2
				]
			],
			[
				[
					2350,
					1813
				],
				[
					-46,
					167
				]
			],
			[
				[
					2304,
					1980
				],
				[
					41,
					55
				]
			],
			[
				[
					2345,
					2035
				],
				[
					102,
					28
				]
			],
			[
				[
					2447,
					2063
				],
				[
					65,
					15
				]
			],
			[
				[
					2512,
					2078
				],
				[
					49,
					-170
				]
			],
			[
				[
					3422,
					1951
				],
				[
					20,
					4
				]
			],
			[
				[
					3442,
					1955
				],
				[
					-61,
					-88
				]
			],
			[
				[
					3381,
					1867
				],
				[
					-115,
					-40
				]
			],
			[
				[
					3266,
					1827
				],
				[
					-102,
					-2
				]
			],
			[
				[
					3164,
					1825
				],
				[
					-35,
					37
				]
			],
			[
				[
					3129,
					1862
				],
				[
					18,
					42
				]
			],
			[
				[
					3147,
					1904
				],
				[
					29,
					51
				]
			],
			[
				[
					3176,
					1955
				],
				[
					64,
					-41
				]
			],
			[
				[
					3240,
					1914
				],
				[
					68,
					-1
				],
				[
					81,
					60
				]
			],
			[
				[
					3389,
					1973
				],
				[
					33,
					-22
				]
			],
			[
				[
					4797,
					6711
				],
				[
					72,
					-36
				]
			],
			[
				[
					4869,
					6675
				],
				[
					-74,
					-69
				]
			],
			[
				[
					4795,
					6606
				],
				[
					22,
					-55
				]
			],
			[
				[
					4817,
					6551
				],
				[
					-45,
					-12
				]
			],
			[
				[
					4772,
					6539
				],
				[
					-80,
					-42
				]
			],
			[
				[
					4692,
					6497
				],
				[
					-60,
					-13
				]
			],
			[
				[
					4632,
					6484
				],
				[
					-71,
					-67
				]
			],
			[
				[
					4561,
					6417
				],
				[
					-7,
					23
				]
			],
			[
				[
					4445,
					6827
				],
				[
					-40,
					9
				]
			],
			[
				[
					4405,
					6836
				],
				[
					48,
					114
				]
			],
			[
				[
					4453,
					6950
				],
				[
					72,
					2
				]
			],
			[
				[
					3774,
					6018
				],
				[
					107,
					-33
				]
			],
			[
				[
					3881,
					5985
				],
				[
					9,
					4
				]
			],
			[
				[
					3890,
					5989
				],
				[
					91,
					-69
				],
				[
					16,
					-110
				]
			],
			[
				[
					3997,
					5810
				],
				[
					-12,
					-58
				]
			],
			[
				[
					3985,
					5752
				],
				[
					-107,
					-166
				]
			],
			[
				[
					3878,
					5586
				],
				[
					-6,
					20
				]
			],
			[
				[
					3847,
					5630
				],
				[
					-58,
					-41
				]
			],
			[
				[
					3789,
					5589
				],
				[
					-36,
					-14
				]
			],
			[
				[
					3753,
					5575
				],
				[
					-157,
					86
				]
			],
			[
				[
					3596,
					5661
				],
				[
					-43,
					-38
				]
			],
			[
				[
					3553,
					5623
				],
				[
					-49,
					28
				]
			],
			[
				[
					3504,
					5651
				],
				[
					-22,
					-15
				]
			],
			[
				[
					3331,
					5784
				],
				[
					56,
					49
				]
			],
			[
				[
					3720,
					5955
				],
				[
					54,
					63
				]
			],
			[
				[
					3266,
					1827
				],
				[
					25,
					-5
				]
			],
			[
				[
					3260,
					1672
				],
				[
					24,
					-35
				]
			],
			[
				[
					3284,
					1637
				],
				[
					-45,
					-1
				],
				[
					-33,
					-20
				]
			],
			[
				[
					3206,
					1616
				],
				[
					-21,
					33
				]
			],
			[
				[
					3185,
					1649
				],
				[
					-101,
					25
				]
			],
			[
				[
					3084,
					1674
				],
				[
					-75,
					83
				]
			],
			[
				[
					3009,
					1757
				],
				[
					45,
					52
				]
			],
			[
				[
					3054,
					1809
				],
				[
					75,
					53
				]
			],
			[
				[
					3129,
					1862
				],
				[
					35,
					-37
				]
			],
			[
				[
					2906,
					6114
				],
				[
					102,
					-95
				]
			],
			[
				[
					3008,
					6019
				],
				[
					115,
					-41
				],
				[
					-94,
					-71
				]
			],
			[
				[
					2891,
					5811
				],
				[
					-3,
					-11
				]
			],
			[
				[
					2888,
					5800
				],
				[
					-101,
					19
				],
				[
					-32,
					72
				]
			],
			[
				[
					2755,
					5891
				],
				[
					-79,
					11
				]
			],
			[
				[
					2676,
					5902
				],
				[
					-5,
					14
				]
			],
			[
				[
					2671,
					5916
				],
				[
					57,
					208
				]
			],
			[
				[
					2728,
					6124
				],
				[
					39,
					26
				]
			],
			[
				[
					2767,
					6150
				],
				[
					-8,
					11
				]
			],
			[
				[
					2759,
					6161
				],
				[
					62,
					81
				]
			],
			[
				[
					2821,
					6242
				],
				[
					20,
					6
				]
			],
			[
				[
					2841,
					6248
				],
				[
					65,
					-134
				]
			],
			[
				[
					3838,
					2222
				],
				[
					4,
					141
				]
			],
			[
				[
					3842,
					2363
				],
				[
					-23,
					27
				]
			],
			[
				[
					3819,
					2390
				],
				[
					14,
					4
				],
				[
					12,
					24
				],
				[
					43,
					11
				],
				[
					54,
					-42
				],
				[
					151,
					40
				],
				[
					62,
					-38
				]
			],
			[
				[
					4155,
					2389
				],
				[
					24,
					-33
				]
			],
			[
				[
					4046,
					2098
				],
				[
					-118,
					3
				]
			],
			[
				[
					3928,
					2101
				],
				[
					-37,
					58
				],
				[
					-69,
					19
				]
			],
			[
				[
					3822,
					2178
				],
				[
					16,
					44
				]
			],
			[
				[
					5019,
					3016
				],
				[
					14,
					-54
				]
			],
			[
				[
					5049,
					2897
				],
				[
					-19,
					15
				]
			],
			[
				[
					5002,
					2779
				],
				[
					-43,
					-136
				]
			],
			[
				[
					4959,
					2643
				],
				[
					-52,
					29
				]
			],
			[
				[
					4907,
					2672
				],
				[
					-87,
					-13
				]
			],
			[
				[
					4820,
					2659
				],
				[
					-156,
					-45
				]
			],
			[
				[
					4664,
					2614
				],
				[
					-19,
					10
				]
			],
			[
				[
					4645,
					2624
				],
				[
					52,
					59
				],
				[
					-27,
					122
				],
				[
					41,
					122
				]
			],
			[
				[
					4711,
					2927
				],
				[
					75,
					60
				]
			],
			[
				[
					4934,
					3015
				],
				[
					85,
					1
				]
			],
			[
				[
					4820,
					2659
				],
				[
					87,
					13
				]
			],
			[
				[
					4959,
					2643
				],
				[
					-2,
					-13
				]
			],
			[
				[
					4926,
					2418
				],
				[
					-21,
					-55
				]
			],
			[
				[
					4760,
					2367
				],
				[
					-158,
					57
				]
			],
			[
				[
					4589,
					2586
				],
				[
					10,
					-4
				]
			],
			[
				[
					4599,
					2582
				],
				[
					65,
					32
				]
			],
			[
				[
					4434,
					2960
				],
				[
					-27,
					-15
				]
			],
			[
				[
					4407,
					2945
				],
				[
					-7,
					-26
				]
			],
			[
				[
					4400,
					2919
				],
				[
					-84,
					-12
				],
				[
					-103,
					-151
				],
				[
					34,
					-53
				]
			],
			[
				[
					4247,
					2703
				],
				[
					9,
					-24
				]
			],
			[
				[
					4256,
					2679
				],
				[
					-72,
					-13
				]
			],
			[
				[
					4138,
					2652
				],
				[
					-26,
					-10
				]
			],
			[
				[
					4112,
					2642
				],
				[
					-76,
					-38
				]
			],
			[
				[
					4036,
					2604
				],
				[
					-76,
					-40
				]
			],
			[
				[
					3960,
					2564
				],
				[
					-49,
					82
				]
			],
			[
				[
					3911,
					2646
				],
				[
					2,
					95
				],
				[
					-135,
					1
				]
			],
			[
				[
					3778,
					2742
				],
				[
					14,
					71
				]
			],
			[
				[
					3792,
					2813
				],
				[
					14,
					25
				]
			],
			[
				[
					3806,
					2838
				],
				[
					27,
					37
				]
			],
			[
				[
					4173,
					2978
				],
				[
					44,
					-35
				]
			],
			[
				[
					4217,
					2943
				],
				[
					129,
					48
				]
			],
			[
				[
					4346,
					2991
				],
				[
					29,
					24
				]
			],
			[
				[
					4375,
					3015
				],
				[
					59,
					-55
				]
			],
			[
				[
					5972,
					4269
				],
				[
					28,
					-3
				]
			],
			[
				[
					6000,
					4266
				],
				[
					19,
					-96
				],
				[
					-57,
					-76
				],
				[
					46,
					-211
				]
			],
			[
				[
					6008,
					3883
				],
				[
					12,
					-55
				]
			],
			[
				[
					6020,
					3828
				],
				[
					-51,
					-150
				],
				[
					-129,
					105
				]
			],
			[
				[
					5840,
					3783
				],
				[
					-48,
					6
				]
			],
			[
				[
					5792,
					3789
				],
				[
					-43,
					50
				]
			],
			[
				[
					5749,
					3839
				],
				[
					-8,
					-27
				]
			],
			[
				[
					5741,
					3812
				],
				[
					-107,
					88
				],
				[
					-159,
					-21
				],
				[
					-22,
					-105
				]
			],
			[
				[
					5453,
					3774
				],
				[
					-51,
					-13
				]
			],
			[
				[
					5402,
					3761
				],
				[
					-17,
					-22
				]
			],
			[
				[
					5385,
					3739
				],
				[
					-28,
					5
				]
			],
			[
				[
					5357,
					3744
				],
				[
					-6,
					118
				],
				[
					76,
					82
				],
				[
					-61,
					44
				]
			],
			[
				[
					5366,
					3988
				],
				[
					71,
					56
				]
			],
			[
				[
					5437,
					4044
				],
				[
					-18,
					102
				]
			],
			[
				[
					5419,
					4146
				],
				[
					65,
					100
				],
				[
					57,
					7
				]
			],
			[
				[
					5541,
					4253
				],
				[
					12,
					35
				]
			],
			[
				[
					5553,
					4288
				],
				[
					69,
					34
				]
			],
			[
				[
					5622,
					4322
				],
				[
					51,
					-17
				]
			],
			[
				[
					4481,
					2327
				],
				[
					60,
					-62
				],
				[
					-4,
					-83
				],
				[
					-142,
					-219
				],
				[
					-94,
					-21
				],
				[
					-38,
					47
				]
			],
			[
				[
					4263,
					1989
				],
				[
					5,
					44
				]
			],
			[
				[
					4343,
					2256
				],
				[
					4,
					47
				]
			],
			[
				[
					4347,
					2303
				],
				[
					68,
					-7
				]
			],
			[
				[
					4420,
					3553
				],
				[
					12,
					32
				]
			],
			[
				[
					4432,
					3585
				],
				[
					65,
					-21
				],
				[
					59,
					15
				],
				[
					8,
					15
				]
			],
			[
				[
					4564,
					3594
				],
				[
					5,
					-39
				]
			],
			[
				[
					4655,
					3281
				],
				[
					-37,
					-33
				]
			],
			[
				[
					4618,
					3248
				],
				[
					-186,
					-18
				]
			],
			[
				[
					4432,
					3230
				],
				[
					-58,
					67
				]
			],
			[
				[
					4374,
					3297
				],
				[
					57,
					177
				],
				[
					-11,
					79
				]
			],
			[
				[
					4400,
					2919
				],
				[
					77,
					-118
				]
			],
			[
				[
					4477,
					2801
				],
				[
					4,
					-39
				]
			],
			[
				[
					4481,
					2762
				],
				[
					-59,
					-69
				]
			],
			[
				[
					4422,
					2693
				],
				[
					-57,
					7
				]
			],
			[
				[
					4258,
					2667
				],
				[
					-11,
					36
				]
			],
			[
				[
					4662,
					2955
				],
				[
					19,
					13
				]
			],
			[
				[
					4696,
					2960
				],
				[
					15,
					-33
				]
			],
			[
				[
					4645,
					2624
				],
				[
					-46,
					-42
				]
			],
			[
				[
					4599,
					2582
				],
				[
					-42,
					6
				],
				[
					-44,
					-11
				]
			],
			[
				[
					4488,
					2628
				],
				[
					-7,
					134
				]
			],
			[
				[
					4477,
					2801
				],
				[
					-77,
					118
				]
			],
			[
				[
					4407,
					2945
				],
				[
					113,
					10
				]
			],
			[
				[
					4520,
					2955
				],
				[
					87,
					32
				]
			],
			[
				[
					4607,
					2987
				],
				[
					55,
					-32
				]
			],
			[
				[
					5497,
					2721
				],
				[
					76,
					27
				]
			],
			[
				[
					5590,
					2701
				],
				[
					50,
					-71
				]
			],
			[
				[
					5635,
					2558
				],
				[
					-6,
					-110
				]
			],
			[
				[
					5629,
					2448
				],
				[
					-89,
					29
				]
			],
			[
				[
					5540,
					2477
				],
				[
					-2,
					30
				]
			],
			[
				[
					5538,
					2507
				],
				[
					-76,
					26
				]
			],
			[
				[
					5462,
					2533
				],
				[
					29,
					-15
				]
			],
			[
				[
					5491,
					2518
				],
				[
					-72,
					-66
				]
			],
			[
				[
					5419,
					2452
				],
				[
					-68,
					102
				]
			],
			[
				[
					5351,
					2554
				],
				[
					-30,
					-1
				]
			],
			[
				[
					5321,
					2553
				],
				[
					-76,
					11
				]
			],
			[
				[
					5204,
					2714
				],
				[
					14,
					-27
				]
			],
			[
				[
					5218,
					2687
				],
				[
					96,
					73
				]
			],
			[
				[
					5314,
					2760
				],
				[
					73,
					-16
				]
			],
			[
				[
					3778,
					2455
				],
				[
					41,
					-48
				]
			],
			[
				[
					3819,
					2407
				],
				[
					2,
					-24
				],
				[
					21,
					-20
				]
			],
			[
				[
					3838,
					2222
				],
				[
					-19,
					-34
				],
				[
					-1,
					-28
				]
			],
			[
				[
					3818,
					2160
				],
				[
					-19,
					-2
				]
			],
			[
				[
					3799,
					2158
				],
				[
					-34,
					-27
				]
			],
			[
				[
					3765,
					2131
				],
				[
					-21,
					-64
				]
			],
			[
				[
					3744,
					2067
				],
				[
					-45,
					-21
				]
			],
			[
				[
					3699,
					2046
				],
				[
					-21,
					34
				]
			],
			[
				[
					3678,
					2080
				],
				[
					-86,
					42
				]
			],
			[
				[
					3592,
					2122
				],
				[
					0,
					36
				]
			],
			[
				[
					3592,
					2158
				],
				[
					-33,
					4
				]
			],
			[
				[
					3559,
					2162
				],
				[
					-23,
					86
				],
				[
					-98,
					45
				]
			],
			[
				[
					3438,
					2293
				],
				[
					50,
					39
				]
			],
			[
				[
					3488,
					2332
				],
				[
					149,
					70
				]
			],
			[
				[
					3637,
					2402
				],
				[
					19,
					58
				]
			],
			[
				[
					3656,
					2460
				],
				[
					31,
					-5
				],
				[
					91,
					0
				]
			],
			[
				[
					3685,
					2980
				],
				[
					3,
					-22
				]
			],
			[
				[
					3688,
					2958
				],
				[
					115,
					-7
				]
			],
			[
				[
					3811,
					2891
				],
				[
					-5,
					-53
				]
			],
			[
				[
					3792,
					2813
				],
				[
					-50,
					-100
				]
			],
			[
				[
					3742,
					2713
				],
				[
					-132,
					-66
				]
			],
			[
				[
					3610,
					2647
				],
				[
					-68,
					-26
				]
			],
			[
				[
					3542,
					2621
				],
				[
					-79,
					-60
				]
			],
			[
				[
					3463,
					2561
				],
				[
					-71,
					-11
				]
			],
			[
				[
					3392,
					2550
				],
				[
					-74,
					58
				],
				[
					68,
					77
				],
				[
					-16,
					34
				]
			],
			[
				[
					3392,
					2729
				],
				[
					17,
					67
				]
			],
			[
				[
					3441,
					2773
				],
				[
					51,
					83
				]
			],
			[
				[
					3492,
					2856
				],
				[
					82,
					27
				]
			],
			[
				[
					3574,
					2883
				],
				[
					45,
					64
				]
			],
			[
				[
					3619,
					2947
				],
				[
					66,
					33
				]
			],
			[
				[
					3559,
					2162
				],
				[
					33,
					-4
				]
			],
			[
				[
					3592,
					2158
				],
				[
					0,
					-36
				]
			],
			[
				[
					3678,
					2080
				],
				[
					-64,
					-37
				]
			],
			[
				[
					3614,
					2043
				],
				[
					-93,
					-149
				]
			],
			[
				[
					3521,
					1894
				],
				[
					-79,
					61
				]
			],
			[
				[
					3422,
					1951
				],
				[
					-33,
					22
				]
			],
			[
				[
					3389,
					1973
				],
				[
					53,
					208
				]
			],
			[
				[
					3442,
					2181
				],
				[
					-4,
					112
				]
			],
			[
				[
					1936,
					1740
				],
				[
					47,
					-83
				]
			],
			[
				[
					1722,
					1455
				],
				[
					1,
					-11
				]
			],
			[
				[
					1723,
					1444
				],
				[
					-78,
					-6
				]
			],
			[
				[
					1645,
					1438
				],
				[
					-53,
					22
				]
			],
			[
				[
					1592,
					1460
				],
				[
					-18,
					113
				]
			],
			[
				[
					1574,
					1573
				],
				[
					8,
					70
				]
			],
			[
				[
					1582,
					1643
				],
				[
					21,
					67
				]
			],
			[
				[
					1603,
					1710
				],
				[
					72,
					49
				]
			],
			[
				[
					1659,
					1781
				],
				[
					37,
					21
				]
			],
			[
				[
					911,
					5300
				],
				[
					-37,
					-56
				]
			],
			[
				[
					874,
					5244
				],
				[
					27,
					-71
				]
			],
			[
				[
					901,
					5173
				],
				[
					9,
					-12
				]
			],
			[
				[
					910,
					5161
				],
				[
					-18,
					-32
				]
			],
			[
				[
					892,
					5129
				],
				[
					-11,
					-36
				]
			],
			[
				[
					881,
					5093
				],
				[
					-46,
					-4
				],
				[
					-70,
					-51
				],
				[
					-18,
					-63
				],
				[
					5,
					-12
				]
			],
			[
				[
					752,
					4963
				],
				[
					-45,
					-36
				]
			],
			[
				[
					707,
					4927
				],
				[
					-193,
					182
				],
				[
					8,
					41
				]
			],
			[
				[
					522,
					5150
				],
				[
					39,
					-10
				],
				[
					101,
					166
				],
				[
					87,
					91
				]
			],
			[
				[
					749,
					5397
				],
				[
					49,
					-1
				],
				[
					106,
					-80
				],
				[
					7,
					-16
				]
			],
			[
				[
					2102,
					2053
				],
				[
					60,
					-47
				],
				[
					69,
					58
				]
			],
			[
				[
					2231,
					2064
				],
				[
					3,
					18
				]
			],
			[
				[
					2234,
					2082
				],
				[
					19,
					17
				],
				[
					42,
					-70
				],
				[
					31,
					-20
				]
			],
			[
				[
					2326,
					2009
				],
				[
					-22,
					-29
				]
			],
			[
				[
					2350,
					1813
				],
				[
					-17,
					-72
				]
			],
			[
				[
					2258,
					1715
				],
				[
					-37,
					-60
				]
			],
			[
				[
					2232,
					1647
				],
				[
					-65,
					-115
				]
			],
			[
				[
					1968,
					1674
				],
				[
					-37,
					82
				]
			],
			[
				[
					1998,
					2001
				],
				[
					-48,
					4
				]
			],
			[
				[
					1950,
					2005
				],
				[
					99,
					104
				]
			],
			[
				[
					2049,
					2109
				],
				[
					53,
					-56
				]
			],
			[
				[
					3310,
					2618
				],
				[
					82,
					-68
				]
			],
			[
				[
					3463,
					2561
				],
				[
					55,
					-11
				]
			],
			[
				[
					3518,
					2550
				],
				[
					45,
					-81
				],
				[
					78,
					32
				]
			],
			[
				[
					3641,
					2501
				],
				[
					15,
					-41
				]
			],
			[
				[
					3656,
					2460
				],
				[
					-19,
					-58
				]
			],
			[
				[
					3488,
					2332
				],
				[
					-54,
					-41
				]
			],
			[
				[
					3434,
					2291
				],
				[
					-81,
					47
				]
			],
			[
				[
					3353,
					2338
				],
				[
					-21,
					3
				],
				[
					-3,
					15
				],
				[
					-50,
					37
				],
				[
					-41,
					-14
				]
			],
			[
				[
					3238,
					2379
				],
				[
					-56,
					15
				]
			],
			[
				[
					3182,
					2394
				],
				[
					11,
					25
				]
			],
			[
				[
					3193,
					2419
				],
				[
					-19,
					19
				]
			],
			[
				[
					3174,
					2438
				],
				[
					7,
					23
				]
			],
			[
				[
					3699,
					3386
				],
				[
					52,
					10
				]
			],
			[
				[
					3853,
					3243
				],
				[
					16,
					-9
				]
			],
			[
				[
					3895,
					3170
				],
				[
					23,
					22
				]
			],
			[
				[
					3903,
					3094
				],
				[
					-16,
					-25
				]
			],
			[
				[
					3875,
					3072
				],
				[
					-16,
					-49
				]
			],
			[
				[
					3803,
					2951
				],
				[
					-115,
					7
				]
			],
			[
				[
					3685,
					2980
				],
				[
					-66,
					-33
				]
			],
			[
				[
					3574,
					2883
				],
				[
					-88,
					-1
				]
			],
			[
				[
					3415,
					2986
				],
				[
					-3,
					68
				]
			],
			[
				[
					3412,
					3054
				],
				[
					59,
					33
				]
			],
			[
				[
					3471,
					3087
				],
				[
					48,
					102
				],
				[
					76,
					15
				],
				[
					44,
					90
				]
			],
			[
				[
					3639,
					3294
				],
				[
					-13,
					58
				]
			],
			[
				[
					3626,
					3352
				],
				[
					73,
					67
				]
			],
			[
				[
					3699,
					3419
				],
				[
					0,
					-33
				]
			],
			[
				[
					2636,
					3456
				],
				[
					26,
					-96
				]
			],
			[
				[
					2662,
					3360
				],
				[
					2,
					-27
				]
			],
			[
				[
					2624,
					3338
				],
				[
					-36,
					-79
				]
			],
			[
				[
					2588,
					3259
				],
				[
					-79,
					-25
				]
			],
			[
				[
					2509,
					3234
				],
				[
					-63,
					71
				],
				[
					72,
					123
				]
			],
			[
				[
					2518,
					3428
				],
				[
					27,
					21
				]
			],
			[
				[
					2570,
					3458
				],
				[
					66,
					-2
				]
			],
			[
				[
					1505,
					4943
				],
				[
					46,
					-40
				]
			],
			[
				[
					1551,
					4903
				],
				[
					62,
					-1
				]
			],
			[
				[
					1613,
					4902
				],
				[
					4,
					-106
				],
				[
					79,
					31
				]
			],
			[
				[
					1696,
					4827
				],
				[
					6,
					-109
				]
			],
			[
				[
					1702,
					4718
				],
				[
					7,
					-19
				]
			],
			[
				[
					1709,
					4699
				],
				[
					-37,
					-99
				]
			],
			[
				[
					1672,
					4600
				],
				[
					-17,
					-25
				]
			],
			[
				[
					1655,
					4575
				],
				[
					-67,
					25
				]
			],
			[
				[
					1588,
					4600
				],
				[
					-93,
					-16
				]
			],
			[
				[
					1495,
					4584
				],
				[
					-58,
					79
				]
			],
			[
				[
					1437,
					4663
				],
				[
					-10,
					102
				]
			],
			[
				[
					1427,
					4765
				],
				[
					26,
					4
				]
			],
			[
				[
					1453,
					4769
				],
				[
					-39,
					119
				],
				[
					83,
					64
				]
			],
			[
				[
					1497,
					4952
				],
				[
					8,
					-9
				]
			],
			[
				[
					1965,
					3573
				],
				[
					76,
					4
				],
				[
					14,
					-143
				]
			],
			[
				[
					2055,
					3434
				],
				[
					163,
					-65
				]
			],
			[
				[
					2218,
					3369
				],
				[
					-10,
					-91
				]
			],
			[
				[
					2208,
					3278
				],
				[
					11,
					-26
				]
			],
			[
				[
					2219,
					3252
				],
				[
					-70,
					1
				],
				[
					-21,
					-82
				],
				[
					-109,
					-34
				]
			],
			[
				[
					2019,
					3137
				],
				[
					-13,
					64
				]
			],
			[
				[
					1810,
					3284
				],
				[
					-32,
					26
				]
			],
			[
				[
					1778,
					3310
				],
				[
					15,
					84
				]
			],
			[
				[
					1793,
					3394
				],
				[
					43,
					19
				]
			],
			[
				[
					1836,
					3413
				],
				[
					6,
					180
				]
			],
			[
				[
					1842,
					3593
				],
				[
					123,
					-20
				]
			],
			[
				[
					1691,
					2739
				],
				[
					141,
					35
				]
			],
			[
				[
					1832,
					2774
				],
				[
					55,
					-113
				]
			],
			[
				[
					1887,
					2661
				],
				[
					-105,
					-30
				]
			],
			[
				[
					1782,
					2631
				],
				[
					-72,
					-41
				]
			],
			[
				[
					1710,
					2590
				],
				[
					-32,
					-40
				],
				[
					-30,
					-8
				]
			],
			[
				[
					1648,
					2542
				],
				[
					-5,
					14
				]
			],
			[
				[
					1643,
					2556
				],
				[
					-31,
					15
				]
			],
			[
				[
					1612,
					2571
				],
				[
					-111,
					-12
				]
			],
			[
				[
					1501,
					2559
				],
				[
					-19,
					45
				]
			],
			[
				[
					1482,
					2604
				],
				[
					-81,
					78
				],
				[
					27,
					94
				]
			],
			[
				[
					1428,
					2776
				],
				[
					24,
					22
				],
				[
					28,
					59
				]
			],
			[
				[
					1546,
					2902
				],
				[
					38,
					3
				]
			],
			[
				[
					426,
					2887
				],
				[
					-32,
					-90
				]
			],
			[
				[
					394,
					2797
				],
				[
					-43,
					27
				]
			],
			[
				[
					351,
					2824
				],
				[
					-97,
					8
				]
			],
			[
				[
					254,
					2832
				],
				[
					-35,
					28
				]
			],
			[
				[
					219,
					2860
				],
				[
					2,
					51
				],
				[
					97,
					122
				],
				[
					124,
					30
				]
			],
			[
				[
					1260,
					2541
				],
				[
					43,
					-3
				]
			],
			[
				[
					1303,
					2538
				],
				[
					62,
					-36
				]
			],
			[
				[
					1365,
					2502
				],
				[
					9,
					2
				]
			],
			[
				[
					1374,
					2504
				],
				[
					14,
					-126
				]
			],
			[
				[
					1388,
					2378
				],
				[
					-42,
					-3
				]
			],
			[
				[
					1346,
					2375
				],
				[
					0,
					-79
				]
			],
			[
				[
					1346,
					2296
				],
				[
					-19,
					-87
				]
			],
			[
				[
					1327,
					2209
				],
				[
					-97,
					-9
				]
			],
			[
				[
					1230,
					2200
				],
				[
					-50,
					40
				]
			],
			[
				[
					1180,
					2240
				],
				[
					-106,
					-18
				]
			],
			[
				[
					1031,
					2323
				],
				[
					-43,
					26
				]
			],
			[
				[
					965,
					2328
				],
				[
					-10,
					27
				]
			],
			[
				[
					933,
					2364
				],
				[
					7,
					48
				]
			],
			[
				[
					940,
					2412
				],
				[
					36,
					45
				]
			],
			[
				[
					976,
					2457
				],
				[
					69,
					39
				]
			],
			[
				[
					1045,
					2496
				],
				[
					100,
					8
				]
			],
			[
				[
					1145,
					2504
				],
				[
					53,
					84
				]
			],
			[
				[
					1198,
					2588
				],
				[
					16,
					-34
				]
			],
			[
				[
					1214,
					2554
				],
				[
					46,
					-13
				]
			],
			[
				[
					738,
					2226
				],
				[
					48,
					14
				]
			],
			[
				[
					786,
					2240
				],
				[
					36,
					-33
				]
			],
			[
				[
					849,
					2116
				],
				[
					-53,
					-60
				]
			],
			[
				[
					796,
					2056
				],
				[
					-21,
					-16
				]
			],
			[
				[
					775,
					2040
				],
				[
					-122,
					-8
				],
				[
					-54,
					47
				]
			],
			[
				[
					599,
					2079
				],
				[
					4,
					12
				]
			],
			[
				[
					620,
					2172
				],
				[
					-14,
					47
				]
			],
			[
				[
					606,
					2219
				],
				[
					53,
					15
				]
			],
			[
				[
					659,
					2234
				],
				[
					79,
					-8
				]
			],
			[
				[
					1487,
					2464
				],
				[
					58,
					-127
				],
				[
					2,
					-91
				]
			],
			[
				[
					1547,
					2246
				],
				[
					40,
					-13
				]
			],
			[
				[
					1552,
					2165
				],
				[
					-15,
					-79
				]
			],
			[
				[
					1537,
					2086
				],
				[
					-75,
					-40
				]
			],
			[
				[
					1462,
					2046
				],
				[
					-19,
					16
				]
			],
			[
				[
					1352,
					2047
				],
				[
					-21,
					99
				]
			],
			[
				[
					1331,
					2146
				],
				[
					-40,
					39
				]
			],
			[
				[
					1291,
					2185
				],
				[
					36,
					24
				]
			],
			[
				[
					1346,
					2296
				],
				[
					0,
					79
				]
			],
			[
				[
					1388,
					2378
				],
				[
					24,
					40
				]
			],
			[
				[
					1412,
					2418
				],
				[
					48,
					45
				]
			],
			[
				[
					1460,
					2463
				],
				[
					27,
					1
				]
			],
			[
				[
					3928,
					2101
				],
				[
					15,
					-23
				]
			],
			[
				[
					3943,
					2078
				],
				[
					40,
					-48
				]
			],
			[
				[
					3983,
					2030
				],
				[
					-1,
					-35
				]
			],
			[
				[
					3849,
					1931
				],
				[
					-25,
					2
				]
			],
			[
				[
					3653,
					1829
				],
				[
					-56,
					-51
				]
			],
			[
				[
					3529,
					1843
				],
				[
					-8,
					51
				]
			],
			[
				[
					3614,
					2043
				],
				[
					85,
					3
				]
			],
			[
				[
					3744,
					2067
				],
				[
					21,
					64
				]
			],
			[
				[
					3765,
					2131
				],
				[
					34,
					27
				]
			],
			[
				[
					3818,
					2160
				],
				[
					4,
					18
				]
			],
			[
				[
					6045,
					6565
				],
				[
					104,
					-89
				],
				[
					144,
					-2
				],
				[
					46,
					-119
				]
			],
			[
				[
					6339,
					6355
				],
				[
					-9,
					-18
				]
			],
			[
				[
					6330,
					6337
				],
				[
					-110,
					-66
				]
			],
			[
				[
					6220,
					6271
				],
				[
					-1,
					-44
				]
			],
			[
				[
					6219,
					6227
				],
				[
					-95,
					-86
				]
			],
			[
				[
					6124,
					6141
				],
				[
					-128,
					8
				]
			],
			[
				[
					5996,
					6149
				],
				[
					-104,
					93
				]
			],
			[
				[
					5892,
					6242
				],
				[
					23,
					32
				]
			],
			[
				[
					5915,
					6274
				],
				[
					-42,
					19
				]
			],
			[
				[
					5873,
					6293
				],
				[
					-1,
					28
				]
			],
			[
				[
					5872,
					6321
				],
				[
					-64,
					66
				]
			],
			[
				[
					5808,
					6387
				],
				[
					25,
					24
				]
			],
			[
				[
					5833,
					6411
				],
				[
					16,
					22
				]
			],
			[
				[
					5849,
					6433
				],
				[
					38,
					-30
				]
			],
			[
				[
					5887,
					6403
				],
				[
					23,
					95
				]
			],
			[
				[
					5910,
					6498
				],
				[
					-27,
					55
				]
			],
			[
				[
					5883,
					6553
				],
				[
					22,
					9
				]
			],
			[
				[
					5905,
					6562
				],
				[
					99,
					44
				]
			],
			[
				[
					6004,
					6606
				],
				[
					41,
					-41
				]
			],
			[
				[
					7544,
					5867
				],
				[
					101,
					-35
				]
			],
			[
				[
					7645,
					5832
				],
				[
					22,
					33
				]
			],
			[
				[
					7667,
					5865
				],
				[
					33,
					16
				]
			],
			[
				[
					7700,
					5881
				],
				[
					35,
					-31
				]
			],
			[
				[
					7735,
					5850
				],
				[
					12,
					-126
				]
			],
			[
				[
					7747,
					5724
				],
				[
					13,
					-7
				]
			],
			[
				[
					7760,
					5717
				],
				[
					-18,
					-37
				]
			],
			[
				[
					7742,
					5680
				],
				[
					67,
					5
				]
			],
			[
				[
					7809,
					5685
				],
				[
					-34,
					-45
				],
				[
					26,
					-115
				],
				[
					-101,
					-73
				],
				[
					71,
					-84
				],
				[
					-11,
					-80
				]
			],
			[
				[
					7760,
					5288
				],
				[
					-28,
					-26
				]
			],
			[
				[
					7732,
					5262
				],
				[
					-84,
					60
				]
			],
			[
				[
					7648,
					5322
				],
				[
					-42,
					9
				]
			],
			[
				[
					7606,
					5331
				],
				[
					-104,
					-52
				]
			],
			[
				[
					7502,
					5279
				],
				[
					-37,
					115
				]
			],
			[
				[
					7465,
					5394
				],
				[
					31,
					105
				],
				[
					-4,
					136
				],
				[
					29,
					59
				]
			],
			[
				[
					7521,
					5694
				],
				[
					-27,
					45
				]
			],
			[
				[
					7494,
					5739
				],
				[
					-35,
					39
				]
			],
			[
				[
					7459,
					5778
				],
				[
					-14,
					67
				]
			],
			[
				[
					7445,
					5845
				],
				[
					47,
					31
				]
			],
			[
				[
					7492,
					5876
				],
				[
					52,
					-9
				]
			],
			[
				[
					5221,
					2464
				],
				[
					12,
					-37
				]
			],
			[
				[
					5233,
					2427
				],
				[
					-5,
					-89
				]
			],
			[
				[
					5228,
					2338
				],
				[
					-32,
					-1
				]
			],
			[
				[
					5196,
					2337
				],
				[
					60,
					-82
				]
			],
			[
				[
					5256,
					2255
				],
				[
					121,
					-1
				]
			],
			[
				[
					5377,
					2254
				],
				[
					-5,
					-110
				]
			],
			[
				[
					5340,
					2126
				],
				[
					-22,
					-15
				]
			],
			[
				[
					5243,
					1927
				],
				[
					-79,
					13
				]
			],
			[
				[
					5164,
					1940
				],
				[
					-77,
					-34
				],
				[
					-36,
					13
				],
				[
					15,
					75
				],
				[
					-43,
					59
				],
				[
					-83,
					-12
				]
			],
			[
				[
					4940,
					2041
				],
				[
					14,
					84
				]
			],
			[
				[
					4999,
					2356
				],
				[
					-29,
					31
				]
			],
			[
				[
					4970,
					2387
				],
				[
					-9,
					21
				]
			],
			[
				[
					4996,
					2433
				],
				[
					44,
					12
				]
			],
			[
				[
					5175,
					2412
				],
				[
					46,
					52
				]
			],
			[
				[
					2207,
					2422
				],
				[
					71,
					-47
				]
			],
			[
				[
					2278,
					2375
				],
				[
					38,
					-42
				]
			],
			[
				[
					2316,
					2333
				],
				[
					-36,
					-108
				]
			],
			[
				[
					2280,
					2225
				],
				[
					-74,
					-26
				]
			],
			[
				[
					2206,
					2199
				],
				[
					-35,
					-32
				]
			],
			[
				[
					2171,
					2167
				],
				[
					-110,
					112
				],
				[
					48,
					73
				]
			],
			[
				[
					2109,
					2352
				],
				[
					-79,
					27
				]
			],
			[
				[
					2030,
					2379
				],
				[
					48,
					72
				]
			],
			[
				[
					7956,
					6871
				],
				[
					50,
					-186
				],
				[
					-123,
					-115
				]
			],
			[
				[
					7883,
					6570
				],
				[
					-228,
					33
				]
			],
			[
				[
					7655,
					6603
				],
				[
					-29,
					63
				]
			],
			[
				[
					7626,
					6666
				],
				[
					6,
					42
				]
			],
			[
				[
					7632,
					6708
				],
				[
					72,
					-19
				]
			],
			[
				[
					7704,
					6689
				],
				[
					54,
					34
				]
			],
			[
				[
					7758,
					6723
				],
				[
					-6,
					98
				]
			],
			[
				[
					7752,
					6821
				],
				[
					-10,
					31
				]
			],
			[
				[
					7742,
					6852
				],
				[
					35,
					13
				]
			],
			[
				[
					7777,
					6865
				],
				[
					12,
					36
				]
			],
			[
				[
					7789,
					6901
				],
				[
					167,
					-30
				]
			],
			[
				[
					6783,
					6122
				],
				[
					68,
					-10
				],
				[
					73,
					16
				]
			],
			[
				[
					6924,
					6128
				],
				[
					30,
					-37
				],
				[
					11,
					-66
				]
			],
			[
				[
					6965,
					6025
				],
				[
					-23,
					-28
				],
				[
					-77,
					-22
				],
				[
					52,
					-78
				]
			],
			[
				[
					6917,
					5897
				],
				[
					-101,
					-14
				]
			],
			[
				[
					6755,
					5861
				],
				[
					-31,
					27
				]
			],
			[
				[
					6724,
					5888
				],
				[
					-94,
					83
				],
				[
					-135,
					-9
				]
			],
			[
				[
					6495,
					5962
				],
				[
					2,
					104
				]
			],
			[
				[
					6497,
					6066
				],
				[
					136,
					77
				]
			],
			[
				[
					6633,
					6143
				],
				[
					61,
					15
				]
			],
			[
				[
					6694,
					6158
				],
				[
					89,
					-36
				]
			],
			[
				[
					3668,
					4003
				],
				[
					61,
					-47
				]
			],
			[
				[
					3729,
					3956
				],
				[
					-12,
					-36
				]
			],
			[
				[
					3717,
					3920
				],
				[
					-11,
					-69
				],
				[
					44,
					-16
				]
			],
			[
				[
					3750,
					3835
				],
				[
					-19,
					-26
				]
			],
			[
				[
					3731,
					3809
				],
				[
					-26,
					-23
				]
			],
			[
				[
					3705,
					3786
				],
				[
					-27,
					-35
				]
			],
			[
				[
					3678,
					3751
				],
				[
					35,
					-50
				]
			],
			[
				[
					3713,
					3701
				],
				[
					-109,
					-14
				]
			],
			[
				[
					3604,
					3687
				],
				[
					-46,
					-58
				]
			],
			[
				[
					3558,
					3629
				],
				[
					-13,
					9
				]
			],
			[
				[
					3545,
					3638
				],
				[
					-36,
					37
				]
			],
			[
				[
					3509,
					3675
				],
				[
					-63,
					-46
				]
			],
			[
				[
					3446,
					3629
				],
				[
					-23,
					31
				]
			],
			[
				[
					3423,
					3660
				],
				[
					16,
					74
				]
			],
			[
				[
					3439,
					3734
				],
				[
					37,
					31
				]
			],
			[
				[
					3476,
					3765
				],
				[
					-22,
					104
				]
			],
			[
				[
					3454,
					3869
				],
				[
					-7,
					9
				]
			],
			[
				[
					3447,
					3878
				],
				[
					42,
					40
				]
			],
			[
				[
					3489,
					3918
				],
				[
					167,
					51
				]
			],
			[
				[
					3656,
					3969
				],
				[
					12,
					34
				]
			],
			[
				[
					1127,
					4633
				],
				[
					74,
					-13
				]
			],
			[
				[
					1201,
					4620
				],
				[
					58,
					-9
				]
			],
			[
				[
					1259,
					4611
				],
				[
					49,
					-66
				]
			],
			[
				[
					1308,
					4545
				],
				[
					60,
					-78
				]
			],
			[
				[
					1431,
					4392
				],
				[
					-23,
					-89
				]
			],
			[
				[
					1408,
					4303
				],
				[
					-72,
					6
				],
				[
					-74,
					25
				],
				[
					-11,
					-13
				]
			],
			[
				[
					1251,
					4321
				],
				[
					-154,
					144
				]
			],
			[
				[
					1097,
					4465
				],
				[
					-22,
					62
				]
			],
			[
				[
					1075,
					4527
				],
				[
					-21,
					101
				]
			],
			[
				[
					1054,
					4628
				],
				[
					73,
					5
				]
			],
			[
				[
					2034,
					6280
				],
				[
					-129,
					-91
				],
				[
					3,
					-97
				],
				[
					-61,
					-156
				],
				[
					12,
					-70
				]
			],
			[
				[
					1859,
					5866
				],
				[
					-40,
					23
				]
			],
			[
				[
					1819,
					5889
				],
				[
					-95,
					12
				]
			],
			[
				[
					1724,
					5901
				],
				[
					-53,
					-30
				]
			],
			[
				[
					1671,
					5871
				],
				[
					-5,
					-21
				]
			],
			[
				[
					1666,
					5850
				],
				[
					-88,
					118
				]
			],
			[
				[
					1578,
					5968
				],
				[
					-42,
					116
				],
				[
					-50,
					-6
				]
			],
			[
				[
					1486,
					6078
				],
				[
					13,
					62
				],
				[
					109,
					93
				],
				[
					216,
					66
				],
				[
					97,
					60
				],
				[
					113,
					-79
				]
			],
			[
				[
					4014,
					5271
				],
				[
					39,
					-60
				]
			],
			[
				[
					4053,
					5211
				],
				[
					22,
					-49
				]
			],
			[
				[
					4075,
					5162
				],
				[
					31,
					-66
				]
			],
			[
				[
					4106,
					5096
				],
				[
					30,
					-32
				]
			],
			[
				[
					4136,
					5064
				],
				[
					-5,
					-47
				]
			],
			[
				[
					3721,
					5031
				],
				[
					12,
					32
				]
			],
			[
				[
					3715,
					5083
				],
				[
					44,
					32
				]
			],
			[
				[
					3812,
					5183
				],
				[
					10,
					58
				]
			],
			[
				[
					3822,
					5241
				],
				[
					33,
					37
				]
			],
			[
				[
					3856,
					5293
				],
				[
					51,
					-26
				]
			],
			[
				[
					791,
					3034
				],
				[
					13,
					-20
				]
			],
			[
				[
					1011,
					2863
				],
				[
					-3,
					-40
				]
			],
			[
				[
					1008,
					2823
				],
				[
					12,
					-43
				]
			],
			[
				[
					1004,
					2777
				],
				[
					-21,
					-17
				]
			],
			[
				[
					983,
					2760
				],
				[
					-68,
					-102
				]
			],
			[
				[
					915,
					2658
				],
				[
					-77,
					-22
				]
			],
			[
				[
					838,
					2636
				],
				[
					-25,
					72
				]
			],
			[
				[
					813,
					2708
				],
				[
					-2,
					46
				]
			],
			[
				[
					700,
					2890
				],
				[
					-38,
					57
				],
				[
					4,
					26
				]
			],
			[
				[
					666,
					2973
				],
				[
					96,
					49
				],
				[
					29,
					12
				]
			],
			[
				[
					2453,
					7148
				],
				[
					-46,
					-107
				],
				[
					85,
					-163
				]
			],
			[
				[
					2492,
					6878
				],
				[
					-73,
					-55
				]
			],
			[
				[
					2419,
					6823
				],
				[
					-85,
					-141
				]
			],
			[
				[
					2334,
					6682
				],
				[
					-46,
					-10
				]
			],
			[
				[
					2288,
					6672
				],
				[
					-270,
					186
				],
				[
					-65,
					0
				],
				[
					17,
					121
				],
				[
					136,
					63
				],
				[
					23,
					134
				],
				[
					203,
					2
				],
				[
					54,
					35
				]
			],
			[
				[
					2386,
					7213
				],
				[
					67,
					-65
				]
			],
			[
				[
					7104,
					6798
				],
				[
					93,
					-123
				]
			],
			[
				[
					7197,
					6675
				],
				[
					3,
					-14
				]
			],
			[
				[
					7200,
					6661
				],
				[
					-34,
					-61
				],
				[
					-153,
					-76
				],
				[
					-53,
					-105
				]
			],
			[
				[
					6960,
					6419
				],
				[
					-8,
					-38
				]
			],
			[
				[
					6832,
					6438
				],
				[
					4,
					80
				]
			],
			[
				[
					6836,
					6518
				],
				[
					17,
					-7
				]
			],
			[
				[
					6853,
					6511
				],
				[
					8,
					90
				]
			],
			[
				[
					6861,
					6601
				],
				[
					17,
					30
				]
			],
			[
				[
					6878,
					6631
				],
				[
					-3,
					42
				]
			],
			[
				[
					6875,
					6673
				],
				[
					-19,
					57
				]
			],
			[
				[
					6856,
					6730
				],
				[
					7,
					74
				]
			],
			[
				[
					6863,
					6804
				],
				[
					50,
					-21
				]
			],
			[
				[
					6913,
					6783
				],
				[
					58,
					26
				]
			],
			[
				[
					6971,
					6809
				],
				[
					76,
					-10
				]
			],
			[
				[
					7047,
					6799
				],
				[
					18,
					26
				]
			],
			[
				[
					7065,
					6825
				],
				[
					39,
					-27
				]
			],
			[
				[
					3164,
					5292
				],
				[
					50,
					-12
				]
			],
			[
				[
					3214,
					5280
				],
				[
					86,
					-69
				]
			],
			[
				[
					3300,
					5211
				],
				[
					63,
					-28
				]
			],
			[
				[
					3363,
					5183
				],
				[
					45,
					-15
				]
			],
			[
				[
					3408,
					5168
				],
				[
					0,
					-75
				]
			],
			[
				[
					3408,
					5093
				],
				[
					-19,
					-61
				]
			],
			[
				[
					3389,
					5032
				],
				[
					-76,
					-41
				]
			],
			[
				[
					3313,
					4991
				],
				[
					-39,
					-22
				],
				[
					-22,
					-27
				]
			],
			[
				[
					3252,
					4942
				],
				[
					-112,
					-47
				]
			],
			[
				[
					3140,
					4895
				],
				[
					-55,
					294
				]
			],
			[
				[
					3085,
					5189
				],
				[
					-54,
					31
				]
			],
			[
				[
					3031,
					5220
				],
				[
					28,
					23
				]
			],
			[
				[
					3125,
					5289
				],
				[
					39,
					3
				]
			],
			[
				[
					5731,
					5784
				],
				[
					62,
					-15
				],
				[
					53,
					-114
				]
			],
			[
				[
					5846,
					5655
				],
				[
					24,
					-88
				]
			],
			[
				[
					5870,
					5567
				],
				[
					-38,
					-99
				]
			],
			[
				[
					5832,
					5468
				],
				[
					-2,
					-74
				],
				[
					-66,
					-52
				]
			],
			[
				[
					5764,
					5342
				],
				[
					-40,
					-15
				]
			],
			[
				[
					5724,
					5327
				],
				[
					-76,
					-7
				]
			],
			[
				[
					5648,
					5320
				],
				[
					-60,
					13
				]
			],
			[
				[
					5588,
					5333
				],
				[
					12,
					88
				],
				[
					-59,
					68
				]
			],
			[
				[
					5541,
					5489
				],
				[
					-119,
					53
				]
			],
			[
				[
					5422,
					5542
				],
				[
					-23,
					40
				]
			],
			[
				[
					5399,
					5582
				],
				[
					37,
					49
				],
				[
					-11,
					104
				]
			],
			[
				[
					5425,
					5735
				],
				[
					58,
					9
				]
			],
			[
				[
					5483,
					5744
				],
				[
					108,
					-10
				]
			],
			[
				[
					5591,
					5734
				],
				[
					55,
					68
				],
				[
					29,
					2
				],
				[
					59,
					-7
				],
				[
					-3,
					-13
				]
			],
			[
				[
					4227,
					4486
				],
				[
					-25,
					-2
				]
			],
			[
				[
					4202,
					4484
				],
				[
					-6,
					-131
				]
			],
			[
				[
					4196,
					4353
				],
				[
					-11,
					-131
				]
			],
			[
				[
					4185,
					4222
				],
				[
					-61,
					18
				]
			],
			[
				[
					4124,
					4240
				],
				[
					-203,
					97
				]
			],
			[
				[
					3921,
					4337
				],
				[
					15,
					28
				],
				[
					-9,
					22
				]
			],
			[
				[
					3941,
					4409
				],
				[
					65,
					76
				]
			],
			[
				[
					4014,
					4526
				],
				[
					72,
					55
				]
			],
			[
				[
					4118,
					4542
				],
				[
					47,
					44
				]
			],
			[
				[
					4165,
					4586
				],
				[
					71,
					-50
				]
			],
			[
				[
					2779,
					1863
				],
				[
					14,
					-61
				]
			],
			[
				[
					2793,
					1802
				],
				[
					72,
					-56
				]
			],
			[
				[
					2865,
					1746
				],
				[
					-22,
					-30
				]
			],
			[
				[
					2843,
					1716
				],
				[
					-64,
					-31
				]
			],
			[
				[
					2779,
					1685
				],
				[
					-124,
					-112
				]
			],
			[
				[
					2655,
					1573
				],
				[
					-34,
					-15
				]
			],
			[
				[
					2621,
					1558
				],
				[
					-66,
					9
				]
			],
			[
				[
					2559,
					1587
				],
				[
					-85,
					45
				]
			],
			[
				[
					2454,
					1644
				],
				[
					-68,
					61
				]
			],
			[
				[
					2368,
					1717
				],
				[
					26,
					65
				]
			],
			[
				[
					2394,
					1782
				],
				[
					-15,
					18
				]
			],
			[
				[
					2379,
					1800
				],
				[
					15,
					23
				],
				[
					32,
					21
				]
			],
			[
				[
					2547,
					1881
				],
				[
					59,
					-5
				]
			],
			[
				[
					2779,
					1685
				],
				[
					25,
					-13
				]
			],
			[
				[
					2804,
					1672
				],
				[
					-41,
					-196
				],
				[
					50,
					-123
				],
				[
					-15,
					-50
				]
			],
			[
				[
					2798,
					1303
				],
				[
					-46,
					19
				]
			],
			[
				[
					2752,
					1322
				],
				[
					-53,
					28
				]
			],
			[
				[
					2699,
					1350
				],
				[
					-46,
					97
				]
			],
			[
				[
					2606,
					1515
				],
				[
					15,
					43
				]
			],
			[
				[
					2655,
					1573
				],
				[
					124,
					112
				]
			],
			[
				[
					1438,
					5200
				],
				[
					19,
					-61
				]
			],
			[
				[
					1457,
					5139
				],
				[
					29,
					7
				]
			],
			[
				[
					1478,
					5165
				],
				[
					51,
					31
				]
			],
			[
				[
					1529,
					5196
				],
				[
					50,
					17
				]
			],
			[
				[
					1579,
					5213
				],
				[
					41,
					-177
				]
			],
			[
				[
					1620,
					5036
				],
				[
					33,
					-46
				]
			],
			[
				[
					1653,
					4990
				],
				[
					-102,
					-87
				]
			],
			[
				[
					1505,
					4943
				],
				[
					-15,
					14
				],
				[
					-57,
					-3
				]
			],
			[
				[
					1433,
					4954
				],
				[
					-100,
					20
				]
			],
			[
				[
					1333,
					4974
				],
				[
					-37,
					69
				],
				[
					14,
					134
				]
			],
			[
				[
					1310,
					5177
				],
				[
					70,
					31
				]
			],
			[
				[
					1380,
					5208
				],
				[
					58,
					-8
				]
			],
			[
				[
					4601,
					4774
				],
				[
					30,
					-42
				]
			],
			[
				[
					4631,
					4732
				],
				[
					87,
					18
				]
			],
			[
				[
					4718,
					4750
				],
				[
					37,
					-146
				]
			],
			[
				[
					4755,
					4604
				],
				[
					-70,
					-34
				]
			],
			[
				[
					4652,
					4578
				],
				[
					-45,
					-12
				]
			],
			[
				[
					4464,
					4568
				],
				[
					-135,
					-18
				]
			],
			[
				[
					4319,
					4653
				],
				[
					25,
					-1
				]
			],
			[
				[
					4344,
					4652
				],
				[
					188,
					104
				]
			],
			[
				[
					4532,
					4756
				],
				[
					69,
					18
				]
			],
			[
				[
					3453,
					5534
				],
				[
					122,
					-125
				],
				[
					44,
					-6
				]
			],
			[
				[
					3619,
					5403
				],
				[
					32,
					-38
				],
				[
					63,
					-29
				]
			],
			[
				[
					3564,
					5181
				],
				[
					-66,
					-5
				]
			],
			[
				[
					3488,
					5165
				],
				[
					-33,
					-25
				]
			],
			[
				[
					3455,
					5140
				],
				[
					-7,
					38
				]
			],
			[
				[
					3448,
					5178
				],
				[
					-26,
					16
				]
			],
			[
				[
					3422,
					5194
				],
				[
					-54,
					4
				]
			],
			[
				[
					3368,
					5198
				],
				[
					56,
					84
				],
				[
					-140,
					166
				]
			],
			[
				[
					3284,
					5448
				],
				[
					25,
					67
				]
			],
			[
				[
					3393,
					5571
				],
				[
					60,
					-37
				]
			],
			[
				[
					2406,
					5786
				],
				[
					100,
					15
				]
			],
			[
				[
					2506,
					5801
				],
				[
					-15,
					-127
				]
			],
			[
				[
					2491,
					5674
				],
				[
					-127,
					-69
				]
			],
			[
				[
					2364,
					5605
				],
				[
					-41,
					30
				]
			],
			[
				[
					2323,
					5635
				],
				[
					-103,
					25
				]
			],
			[
				[
					2220,
					5660
				],
				[
					-61,
					14
				]
			],
			[
				[
					2159,
					5674
				],
				[
					-9,
					81
				]
			],
			[
				[
					2150,
					5755
				],
				[
					-33,
					39
				]
			],
			[
				[
					2117,
					5794
				],
				[
					39,
					81
				]
			],
			[
				[
					2222,
					5903
				],
				[
					94,
					-14
				]
			],
			[
				[
					7598,
					7002
				],
				[
					36,
					-8
				]
			],
			[
				[
					7634,
					6994
				],
				[
					33,
					-117
				],
				[
					45,
					-23
				]
			],
			[
				[
					7712,
					6854
				],
				[
					30,
					-2
				]
			],
			[
				[
					7752,
					6821
				],
				[
					6,
					-98
				]
			],
			[
				[
					7704,
					6689
				],
				[
					-72,
					19
				]
			],
			[
				[
					7632,
					6708
				],
				[
					-58,
					1
				]
			],
			[
				[
					7574,
					6709
				],
				[
					-48,
					12
				]
			],
			[
				[
					7526,
					6721
				],
				[
					-16,
					67
				]
			],
			[
				[
					7510,
					6788
				],
				[
					-31,
					21
				]
			],
			[
				[
					7479,
					6809
				],
				[
					-32,
					54
				]
			],
			[
				[
					7447,
					6863
				],
				[
					17,
					35
				]
			],
			[
				[
					7464,
					6898
				],
				[
					14,
					67
				]
			],
			[
				[
					7478,
					6965
				],
				[
					120,
					37
				]
			],
			[
				[
					1433,
					4954
				],
				[
					64,
					-2
				]
			],
			[
				[
					1453,
					4769
				],
				[
					-26,
					-4
				]
			],
			[
				[
					1437,
					4663
				],
				[
					3,
					-52
				]
			],
			[
				[
					1440,
					4611
				],
				[
					-75,
					-26
				]
			],
			[
				[
					1316,
					4555
				],
				[
					-8,
					-10
				]
			],
			[
				[
					1308,
					4545
				],
				[
					-70,
					94
				]
			],
			[
				[
					1238,
					4639
				],
				[
					-9,
					196
				],
				[
					65,
					109
				]
			],
			[
				[
					1294,
					4944
				],
				[
					18,
					39
				]
			],
			[
				[
					1312,
					4983
				],
				[
					21,
					-9
				]
			],
			[
				[
					7307,
					7466
				],
				[
					38,
					-12
				]
			],
			[
				[
					7355,
					7441
				],
				[
					-54,
					-72
				]
			],
			[
				[
					7301,
					7369
				],
				[
					-9,
					-156
				]
			],
			[
				[
					7292,
					7213
				],
				[
					-23,
					-64
				]
			],
			[
				[
					7269,
					7149
				],
				[
					-121,
					-35
				],
				[
					-75,
					57
				]
			],
			[
				[
					7073,
					7171
				],
				[
					-109,
					-12
				]
			],
			[
				[
					6964,
					7159
				],
				[
					-86,
					-8
				]
			],
			[
				[
					6878,
					7151
				],
				[
					61,
					132
				]
			],
			[
				[
					6939,
					7283
				],
				[
					8,
					48
				]
			],
			[
				[
					6947,
					7331
				],
				[
					58,
					22
				]
			],
			[
				[
					7005,
					7353
				],
				[
					140,
					47
				],
				[
					49,
					49
				]
			],
			[
				[
					7194,
					7449
				],
				[
					7,
					29
				]
			],
			[
				[
					7227,
					7489
				],
				[
					51,
					-12
				]
			],
			[
				[
					4276,
					3726
				],
				[
					6,
					-83
				],
				[
					104,
					11
				]
			],
			[
				[
					4386,
					3654
				],
				[
					44,
					-1
				]
			],
			[
				[
					4430,
					3653
				],
				[
					21,
					-34
				]
			],
			[
				[
					4451,
					3619
				],
				[
					-24,
					-24
				],
				[
					-7,
					-42
				]
			],
			[
				[
					4374,
					3297
				],
				[
					-35,
					9
				]
			],
			[
				[
					4339,
					3306
				],
				[
					-16,
					-11
				]
			],
			[
				[
					4152,
					3384
				],
				[
					-19,
					31
				]
			],
			[
				[
					4133,
					3415
				],
				[
					-24,
					28
				]
			],
			[
				[
					4109,
					3443
				],
				[
					-26,
					33
				]
			],
			[
				[
					4052,
					3473
				],
				[
					2,
					97
				]
			],
			[
				[
					4054,
					3570
				],
				[
					65,
					106
				],
				[
					77,
					54
				]
			],
			[
				[
					4196,
					3730
				],
				[
					44,
					30
				]
			],
			[
				[
					4240,
					3760
				],
				[
					36,
					-34
				]
			],
			[
				[
					5099,
					4941
				],
				[
					-15,
					-65
				]
			],
			[
				[
					5084,
					4876
				],
				[
					-52,
					-59
				]
			],
			[
				[
					5032,
					4817
				],
				[
					-87,
					-47
				]
			],
			[
				[
					4945,
					4770
				],
				[
					-47,
					-9
				]
			],
			[
				[
					4898,
					4761
				],
				[
					-34,
					-8
				]
			],
			[
				[
					4864,
					4753
				],
				[
					-20,
					-33
				]
			],
			[
				[
					4844,
					4720
				],
				[
					-74,
					69
				]
			],
			[
				[
					4770,
					4789
				],
				[
					-22,
					23
				]
			],
			[
				[
					4748,
					4812
				],
				[
					-33,
					7
				]
			],
			[
				[
					4715,
					4819
				],
				[
					25,
					70
				]
			],
			[
				[
					4740,
					4889
				],
				[
					-38,
					110
				]
			],
			[
				[
					4702,
					4999
				],
				[
					107,
					62
				]
			],
			[
				[
					4809,
					5061
				],
				[
					114,
					-50
				]
			],
			[
				[
					8159,
					5821
				],
				[
					-23,
					-30
				]
			],
			[
				[
					8136,
					5791
				],
				[
					4,
					-28
				]
			],
			[
				[
					8140,
					5763
				],
				[
					66,
					-106
				]
			],
			[
				[
					8206,
					5657
				],
				[
					-3,
					-28
				]
			],
			[
				[
					8203,
					5629
				],
				[
					-70,
					-216
				]
			],
			[
				[
					8133,
					5413
				],
				[
					-45,
					-77
				]
			],
			[
				[
					8088,
					5336
				],
				[
					-20,
					-81
				]
			],
			[
				[
					8068,
					5255
				],
				[
					-33,
					-32
				]
			],
			[
				[
					8035,
					5223
				],
				[
					-39,
					-15
				]
			],
			[
				[
					7996,
					5208
				],
				[
					-75,
					55
				],
				[
					-66,
					-42
				],
				[
					-111,
					9
				]
			],
			[
				[
					7744,
					5230
				],
				[
					16,
					58
				]
			],
			[
				[
					7809,
					5685
				],
				[
					-67,
					-5
				]
			],
			[
				[
					7742,
					5680
				],
				[
					18,
					37
				]
			],
			[
				[
					7760,
					5717
				],
				[
					16,
					-9
				]
			],
			[
				[
					7776,
					5708
				],
				[
					124,
					54
				]
			],
			[
				[
					7900,
					5762
				],
				[
					34,
					59
				]
			],
			[
				[
					7958,
					6131
				],
				[
					15,
					-91
				]
			],
			[
				[
					7985,
					6013
				],
				[
					-45,
					-46
				]
			],
			[
				[
					7922,
					5965
				],
				[
					-14,
					-58
				],
				[
					26,
					-58
				],
				[
					-2,
					-36
				],
				[
					-32,
					-51
				]
			],
			[
				[
					7776,
					5708
				],
				[
					-29,
					16
				]
			],
			[
				[
					7735,
					5850
				],
				[
					-35,
					31
				]
			],
			[
				[
					7667,
					5865
				],
				[
					-22,
					-33
				]
			],
			[
				[
					7544,
					5867
				],
				[
					-5,
					39
				]
			],
			[
				[
					7539,
					5906
				],
				[
					5,
					54
				],
				[
					318,
					93
				],
				[
					96,
					78
				]
			],
			[
				[
					5276,
					5926
				],
				[
					86,
					-20
				]
			],
			[
				[
					5362,
					5906
				],
				[
					17,
					-64
				]
			],
			[
				[
					5379,
					5842
				],
				[
					71,
					-102
				]
			],
			[
				[
					5450,
					5740
				],
				[
					-25,
					-5
				]
			],
			[
				[
					5399,
					5582
				],
				[
					-10,
					-25
				]
			],
			[
				[
					5389,
					5557
				],
				[
					-120,
					-23
				]
			],
			[
				[
					5269,
					5534
				],
				[
					-81,
					23
				]
			],
			[
				[
					5188,
					5557
				],
				[
					-127,
					13
				]
			],
			[
				[
					5061,
					5570
				],
				[
					8,
					37
				]
			],
			[
				[
					5069,
					5607
				],
				[
					-61,
					26
				]
			],
			[
				[
					5008,
					5633
				],
				[
					11,
					81
				]
			],
			[
				[
					5019,
					5714
				],
				[
					79,
					167
				]
			],
			[
				[
					5098,
					5881
				],
				[
					-2,
					47
				]
			],
			[
				[
					5096,
					5928
				],
				[
					124,
					25
				],
				[
					56,
					-27
				]
			],
			[
				[
					2660,
					3855
				],
				[
					61,
					-26
				],
				[
					88,
					-135
				]
			],
			[
				[
					2809,
					3694
				],
				[
					-26,
					-29
				]
			],
			[
				[
					2783,
					3665
				],
				[
					-40,
					-12
				]
			],
			[
				[
					2743,
					3653
				],
				[
					13,
					-17
				]
			],
			[
				[
					2756,
					3636
				],
				[
					-77,
					-74
				]
			],
			[
				[
					2679,
					3562
				],
				[
					-20,
					-9
				]
			],
			[
				[
					2659,
					3553
				],
				[
					-12,
					13
				]
			],
			[
				[
					2569,
					3594
				],
				[
					-22,
					74
				]
			],
			[
				[
					2547,
					3668
				],
				[
					15,
					98
				]
			],
			[
				[
					2562,
					3766
				],
				[
					1,
					43
				]
			],
			[
				[
					6337,
					3204
				],
				[
					4,
					-29
				]
			],
			[
				[
					6341,
					3175
				],
				[
					102,
					-98
				]
			],
			[
				[
					6443,
					3077
				],
				[
					-114,
					-96
				],
				[
					45,
					-113
				],
				[
					25,
					-146
				],
				[
					-175,
					-174
				]
			],
			[
				[
					6224,
					2548
				],
				[
					-132,
					33
				],
				[
					-42,
					-56
				],
				[
					-121,
					37
				]
			],
			[
				[
					5929,
					2562
				],
				[
					-16,
					10
				]
			],
			[
				[
					5942,
					2649
				],
				[
					-58,
					42
				]
			],
			[
				[
					5700,
					2875
				],
				[
					12,
					59
				]
			],
			[
				[
					5652,
					3031
				],
				[
					43,
					56
				]
			],
			[
				[
					5695,
					3087
				],
				[
					95,
					-5
				]
			],
			[
				[
					5790,
					3082
				],
				[
					150,
					-43
				],
				[
					68,
					47
				]
			],
			[
				[
					6008,
					3086
				],
				[
					141,
					150
				]
			],
			[
				[
					6149,
					3236
				],
				[
					61,
					-28
				]
			],
			[
				[
					6210,
					3208
				],
				[
					81,
					61
				]
			],
			[
				[
					6291,
					3269
				],
				[
					46,
					-65
				]
			],
			[
				[
					7574,
					6709
				],
				[
					52,
					-43
				]
			],
			[
				[
					7626,
					6666
				],
				[
					29,
					-63
				]
			],
			[
				[
					7883,
					6570
				],
				[
					69,
					60
				],
				[
					50,
					-80
				],
				[
					-22,
					-37
				],
				[
					4,
					-11
				]
			],
			[
				[
					7984,
					6502
				],
				[
					-25,
					-10
				]
			],
			[
				[
					7959,
					6492
				],
				[
					-7,
					19
				]
			],
			[
				[
					7952,
					6511
				],
				[
					-131,
					-59
				],
				[
					-2,
					-80
				]
			],
			[
				[
					7819,
					6372
				],
				[
					-159,
					-48
				]
			],
			[
				[
					7660,
					6324
				],
				[
					-71,
					-13
				],
				[
					-37,
					73
				]
			],
			[
				[
					7552,
					6384
				],
				[
					-17,
					21
				]
			],
			[
				[
					7535,
					6405
				],
				[
					-40,
					-6
				]
			],
			[
				[
					7495,
					6399
				],
				[
					-3,
					15
				]
			],
			[
				[
					7492,
					6414
				],
				[
					-62,
					190
				]
			],
			[
				[
					7430,
					6604
				],
				[
					29,
					61
				]
			],
			[
				[
					7459,
					6665
				],
				[
					22,
					58
				]
			],
			[
				[
					7481,
					6723
				],
				[
					45,
					-2
				]
			],
			[
				[
					4437,
					3830
				],
				[
					51,
					-25
				]
			],
			[
				[
					4488,
					3805
				],
				[
					-15,
					-14
				]
			],
			[
				[
					4473,
					3791
				],
				[
					18,
					-45
				]
			],
			[
				[
					4491,
					3746
				],
				[
					104,
					-8
				]
			],
			[
				[
					4595,
					3738
				],
				[
					33,
					14
				]
			],
			[
				[
					4628,
					3752
				],
				[
					40,
					-20
				]
			],
			[
				[
					4668,
					3732
				],
				[
					-43,
					-60
				]
			],
			[
				[
					4554,
					3610
				],
				[
					10,
					-16
				]
			],
			[
				[
					4432,
					3585
				],
				[
					19,
					34
				]
			],
			[
				[
					4451,
					3619
				],
				[
					-21,
					34
				]
			],
			[
				[
					4386,
					3654
				],
				[
					20,
					79
				]
			],
			[
				[
					4406,
					3733
				],
				[
					31,
					97
				]
			],
			[
				[
					3829,
					4344
				],
				[
					-26,
					-29
				]
			],
			[
				[
					3803,
					4315
				],
				[
					-47,
					-75
				]
			],
			[
				[
					3756,
					4240
				],
				[
					-87,
					16
				]
			],
			[
				[
					3669,
					4256
				],
				[
					0,
					31
				]
			],
			[
				[
					3669,
					4287
				],
				[
					-35,
					-51
				]
			],
			[
				[
					3634,
					4236
				],
				[
					-60,
					34
				]
			],
			[
				[
					3574,
					4270
				],
				[
					-15,
					45
				],
				[
					9,
					-11
				],
				[
					74,
					63
				]
			],
			[
				[
					3642,
					4367
				],
				[
					64,
					22
				],
				[
					42,
					32
				],
				[
					76,
					2
				],
				[
					13,
					-14
				]
			],
			[
				[
					4538,
					5183
				],
				[
					15,
					-18
				]
			],
			[
				[
					4553,
					5165
				],
				[
					53,
					-13
				]
			],
			[
				[
					4606,
					5152
				],
				[
					57,
					18
				],
				[
					32,
					-173
				]
			],
			[
				[
					4695,
					4997
				],
				[
					-21,
					-10
				]
			],
			[
				[
					4674,
					4987
				],
				[
					-13,
					-6
				]
			],
			[
				[
					4661,
					4981
				],
				[
					-41,
					-52
				]
			],
			[
				[
					4620,
					4929
				],
				[
					-28,
					14
				]
			],
			[
				[
					4592,
					4943
				],
				[
					-84,
					21
				]
			],
			[
				[
					4508,
					4964
				],
				[
					-31,
					62
				]
			],
			[
				[
					4477,
					5026
				],
				[
					-45,
					18
				]
			],
			[
				[
					4432,
					5044
				],
				[
					10,
					12
				]
			],
			[
				[
					4442,
					5056
				],
				[
					-19,
					25
				]
			],
			[
				[
					4423,
					5081
				],
				[
					41,
					112
				]
			],
			[
				[
					4464,
					5193
				],
				[
					74,
					-10
				]
			],
			[
				[
					5639,
					7031
				],
				[
					68,
					-55
				]
			],
			[
				[
					5707,
					6976
				],
				[
					42,
					-86
				],
				[
					-24,
					-86
				]
			],
			[
				[
					5725,
					6804
				],
				[
					-20,
					-37
				]
			],
			[
				[
					5705,
					6767
				],
				[
					-101,
					-50
				]
			],
			[
				[
					5604,
					6717
				],
				[
					-118,
					21
				]
			],
			[
				[
					5486,
					6738
				],
				[
					-11,
					18
				]
			],
			[
				[
					5475,
					6756
				],
				[
					-59,
					-40
				]
			],
			[
				[
					5416,
					6716
				],
				[
					-77,
					-30
				]
			],
			[
				[
					5339,
					6686
				],
				[
					-38,
					55
				]
			],
			[
				[
					5301,
					6741
				],
				[
					50,
					187
				],
				[
					79,
					47
				],
				[
					6,
					13
				],
				[
					48,
					17
				],
				[
					99,
					-15
				],
				[
					22,
					63
				]
			],
			[
				[
					5605,
					7053
				],
				[
					34,
					-22
				]
			],
			[
				[
					3372,
					4159
				],
				[
					53,
					26
				]
			],
			[
				[
					3425,
					4185
				],
				[
					33,
					-66
				]
			],
			[
				[
					3458,
					4119
				],
				[
					-24,
					-183
				]
			],
			[
				[
					3434,
					3936
				],
				[
					-18,
					9
				]
			],
			[
				[
					3416,
					3945
				],
				[
					-77,
					-52
				]
			],
			[
				[
					3339,
					3893
				],
				[
					-8,
					35
				]
			],
			[
				[
					3331,
					3928
				],
				[
					-83,
					-16
				]
			],
			[
				[
					3248,
					3912
				],
				[
					-105,
					-38
				]
			],
			[
				[
					3116,
					3868
				],
				[
					14,
					47
				]
			],
			[
				[
					3130,
					3915
				],
				[
					125,
					123
				]
			],
			[
				[
					3255,
					4038
				],
				[
					-20,
					120
				]
			],
			[
				[
					3235,
					4158
				],
				[
					59,
					24
				]
			],
			[
				[
					3294,
					4182
				],
				[
					45,
					36
				]
			],
			[
				[
					3339,
					4218
				],
				[
					33,
					-59
				]
			],
			[
				[
					3911,
					2646
				],
				[
					-34,
					-42
				]
			],
			[
				[
					3877,
					2604
				],
				[
					-67,
					-109
				],
				[
					-74,
					-21
				]
			],
			[
				[
					3736,
					2474
				],
				[
					3,
					-20
				]
			],
			[
				[
					3739,
					2454
				],
				[
					-40,
					-2
				],
				[
					-28,
					8
				],
				[
					-30,
					41
				]
			],
			[
				[
					3518,
					2550
				],
				[
					24,
					71
				]
			],
			[
				[
					3542,
					2621
				],
				[
					68,
					26
				]
			],
			[
				[
					3742,
					2713
				],
				[
					36,
					29
				]
			],
			[
				[
					3886,
					3929
				],
				[
					-24,
					-109
				],
				[
					92,
					-86
				]
			],
			[
				[
					3954,
					3734
				],
				[
					-16,
					-29
				]
			],
			[
				[
					3938,
					3705
				],
				[
					-42,
					-30
				]
			],
			[
				[
					3896,
					3675
				],
				[
					-32,
					-70
				]
			],
			[
				[
					3781,
					3585
				],
				[
					-38,
					-48
				]
			],
			[
				[
					3743,
					3537
				],
				[
					-38,
					49
				]
			],
			[
				[
					3705,
					3586
				],
				[
					0,
					-29
				]
			],
			[
				[
					3705,
					3557
				],
				[
					-25,
					2
				]
			],
			[
				[
					3680,
					3559
				],
				[
					-1,
					69
				]
			],
			[
				[
					3679,
					3628
				],
				[
					-32,
					32
				]
			],
			[
				[
					3647,
					3660
				],
				[
					-26,
					-19
				]
			],
			[
				[
					3621,
					3641
				],
				[
					-36,
					15
				]
			],
			[
				[
					3585,
					3656
				],
				[
					19,
					31
				]
			],
			[
				[
					3713,
					3701
				],
				[
					-35,
					50
				]
			],
			[
				[
					3678,
					3751
				],
				[
					27,
					35
				]
			],
			[
				[
					3731,
					3809
				],
				[
					29,
					29
				],
				[
					-9,
					17
				]
			],
			[
				[
					3751,
					3855
				],
				[
					-13,
					20
				]
			],
			[
				[
					3738,
					3875
				],
				[
					84,
					76
				]
			],
			[
				[
					3822,
					3951
				],
				[
					64,
					-22
				]
			],
			[
				[
					3300,
					5500
				],
				[
					-16,
					-52
				]
			],
			[
				[
					3368,
					5198
				],
				[
					-5,
					-15
				]
			],
			[
				[
					3363,
					5183
				],
				[
					-63,
					28
				]
			],
			[
				[
					3214,
					5280
				],
				[
					-31,
					9
				]
			],
			[
				[
					3166,
					5460
				],
				[
					22,
					21
				]
			],
			[
				[
					3259,
					5500
				],
				[
					41,
					0
				]
			],
			[
				[
					5996,
					6149
				],
				[
					80,
					-28
				]
			],
			[
				[
					6076,
					6121
				],
				[
					12,
					-64
				],
				[
					-133,
					-104
				]
			],
			[
				[
					5955,
					5953
				],
				[
					-31,
					-42
				]
			],
			[
				[
					5924,
					5911
				],
				[
					-74,
					-53
				]
			],
			[
				[
					5850,
					5858
				],
				[
					-110,
					45
				]
			],
			[
				[
					5740,
					5903
				],
				[
					-59,
					80
				]
			],
			[
				[
					5681,
					5983
				],
				[
					-67,
					51
				]
			],
			[
				[
					5614,
					6034
				],
				[
					33,
					4
				]
			],
			[
				[
					5647,
					6038
				],
				[
					41,
					26
				]
			],
			[
				[
					5688,
					6064
				],
				[
					15,
					58
				],
				[
					123,
					109
				]
			],
			[
				[
					5826,
					6231
				],
				[
					89,
					43
				]
			],
			[
				[
					5915,
					6274
				],
				[
					-23,
					-32
				]
			],
			[
				[
					7254,
					6687
				],
				[
					151,
					-63
				]
			],
			[
				[
					7405,
					6624
				],
				[
					25,
					-20
				]
			],
			[
				[
					7492,
					6414
				],
				[
					-44,
					-59
				]
			],
			[
				[
					7448,
					6355
				],
				[
					-23,
					-31
				]
			],
			[
				[
					7425,
					6324
				],
				[
					-37,
					-41
				]
			],
			[
				[
					7388,
					6283
				],
				[
					-36,
					25
				],
				[
					-91,
					-138
				]
			],
			[
				[
					7261,
					6170
				],
				[
					-47,
					-41
				]
			],
			[
				[
					7214,
					6129
				],
				[
					-53,
					20
				]
			],
			[
				[
					7161,
					6149
				],
				[
					-71,
					102
				]
			],
			[
				[
					7022,
					6386
				],
				[
					-62,
					33
				]
			],
			[
				[
					7200,
					6661
				],
				[
					3,
					-10
				]
			],
			[
				[
					7203,
					6651
				],
				[
					21,
					6
				]
			],
			[
				[
					7224,
					6657
				],
				[
					30,
					30
				]
			],
			[
				[
					394,
					2797
				],
				[
					39,
					-31
				]
			],
			[
				[
					490,
					2656
				],
				[
					-53,
					-45
				]
			],
			[
				[
					437,
					2611
				],
				[
					-106,
					-155
				]
			],
			[
				[
					331,
					2456
				],
				[
					27,
					143
				],
				[
					-167,
					7
				]
			],
			[
				[
					229,
					2812
				],
				[
					25,
					20
				]
			],
			[
				[
					254,
					2832
				],
				[
					97,
					-8
				]
			],
			[
				[
					4588,
					4336
				],
				[
					33,
					-17
				]
			],
			[
				[
					4728,
					4265
				],
				[
					39,
					-67
				]
			],
			[
				[
					4767,
					4198
				],
				[
					-65,
					-112
				]
			],
			[
				[
					4702,
					4086
				],
				[
					-74,
					-82
				]
			],
			[
				[
					4628,
					4004
				],
				[
					-71,
					-72
				]
			],
			[
				[
					4557,
					3932
				],
				[
					-30,
					14
				]
			],
			[
				[
					4527,
					3946
				],
				[
					-82,
					-1
				]
			],
			[
				[
					4445,
					3945
				],
				[
					11,
					352
				],
				[
					28,
					29
				]
			],
			[
				[
					4528,
					4349
				],
				[
					60,
					-13
				]
			],
			[
				[
					3626,
					3427
				],
				[
					-6,
					-64
				],
				[
					19,
					-69
				]
			],
			[
				[
					3471,
					3087
				],
				[
					-89,
					20
				]
			],
			[
				[
					3382,
					3107
				],
				[
					-16,
					22
				]
			],
			[
				[
					3366,
					3129
				],
				[
					-13,
					125
				],
				[
					62,
					4
				]
			],
			[
				[
					3415,
					3258
				],
				[
					11,
					83
				]
			],
			[
				[
					3426,
					3341
				],
				[
					17,
					49
				]
			],
			[
				[
					3443,
					3390
				],
				[
					99,
					13
				],
				[
					54,
					57
				]
			],
			[
				[
					3596,
					3460
				],
				[
					30,
					-33
				]
			],
			[
				[
					6841,
					7691
				],
				[
					21,
					1
				]
			],
			[
				[
					6862,
					7692
				],
				[
					-5,
					-18
				]
			],
			[
				[
					6857,
					7674
				],
				[
					45,
					-7
				]
			],
			[
				[
					6902,
					7667
				],
				[
					44,
					-103
				],
				[
					60,
					-30
				]
			],
			[
				[
					7006,
					7534
				],
				[
					-5,
					-101
				]
			],
			[
				[
					7001,
					7433
				],
				[
					-54,
					-102
				]
			],
			[
				[
					6947,
					7331
				],
				[
					-38,
					-27
				]
			],
			[
				[
					6909,
					7304
				],
				[
					-89,
					58
				]
			],
			[
				[
					6820,
					7362
				],
				[
					-99,
					44
				],
				[
					30,
					88
				]
			],
			[
				[
					6726,
					7493
				],
				[
					-7,
					48
				]
			],
			[
				[
					6764,
					7615
				],
				[
					36,
					62
				]
			],
			[
				[
					6800,
					7677
				],
				[
					2,
					23
				]
			],
			[
				[
					6802,
					7700
				],
				[
					39,
					-9
				]
			],
			[
				[
					6009,
					7160
				],
				[
					-6,
					-56
				]
			],
			[
				[
					6003,
					7104
				],
				[
					-45,
					-27
				]
			],
			[
				[
					5958,
					7077
				],
				[
					-9,
					-34
				]
			],
			[
				[
					5949,
					7043
				],
				[
					-6,
					-14
				]
			],
			[
				[
					5943,
					7029
				],
				[
					-97,
					-94
				],
				[
					-100,
					-56
				]
			],
			[
				[
					5746,
					6879
				],
				[
					-39,
					97
				]
			],
			[
				[
					5639,
					7031
				],
				[
					-34,
					22
				]
			],
			[
				[
					5605,
					7053
				],
				[
					157,
					178
				],
				[
					107,
					-56
				],
				[
					140,
					-15
				]
			],
			[
				[
					2427,
					3178
				],
				[
					36,
					-10
				]
			],
			[
				[
					2463,
					3168
				],
				[
					26,
					-22
				]
			],
			[
				[
					2516,
					3092
				],
				[
					17,
					-88
				],
				[
					-72,
					-76
				]
			],
			[
				[
					2461,
					2928
				],
				[
					-86,
					33
				],
				[
					-20,
					22
				],
				[
					3,
					35
				],
				[
					56,
					42
				],
				[
					12,
					30
				],
				[
					-15,
					39
				]
			],
			[
				[
					2411,
					3129
				],
				[
					-52,
					46
				]
			],
			[
				[
					2359,
					3175
				],
				[
					9,
					8
				],
				[
					-6,
					13
				]
			],
			[
				[
					2362,
					3196
				],
				[
					65,
					-18
				]
			],
			[
				[
					1230,
					2200
				],
				[
					61,
					-15
				]
			],
			[
				[
					1331,
					2146
				],
				[
					9,
					-54
				]
			],
			[
				[
					1340,
					2092
				],
				[
					-43,
					-25
				]
			],
			[
				[
					1242,
					2020
				],
				[
					-9,
					-12
				]
			],
			[
				[
					1233,
					2008
				],
				[
					-136,
					-6
				]
			],
			[
				[
					1097,
					2002
				],
				[
					-42,
					119
				]
			],
			[
				[
					1055,
					2121
				],
				[
					44,
					49
				],
				[
					70,
					40
				],
				[
					11,
					30
				]
			],
			[
				[
					3422,
					7452
				],
				[
					-44,
					-29
				],
				[
					-42,
					-62
				]
			],
			[
				[
					3336,
					7361
				],
				[
					-71,
					66
				]
			],
			[
				[
					3265,
					7427
				],
				[
					-49,
					-19
				]
			],
			[
				[
					3216,
					7408
				],
				[
					-50,
					-51
				]
			],
			[
				[
					3166,
					7357
				],
				[
					-71,
					16
				],
				[
					-25,
					-6
				]
			],
			[
				[
					3070,
					7367
				],
				[
					-108,
					100
				],
				[
					-22,
					34
				],
				[
					6,
					176
				],
				[
					53,
					74
				],
				[
					234,
					12
				]
			],
			[
				[
					3233,
					7763
				],
				[
					67,
					-194
				],
				[
					91,
					-24
				],
				[
					28,
					-67
				],
				[
					3,
					-26
				]
			],
			[
				[
					5966,
					7067
				],
				[
					84,
					-53
				]
			],
			[
				[
					6050,
					7014
				],
				[
					19,
					-54
				]
			],
			[
				[
					6069,
					6960
				],
				[
					60,
					-81
				]
			],
			[
				[
					6129,
					6879
				],
				[
					-90,
					-101
				],
				[
					-140,
					-27
				]
			],
			[
				[
					5899,
					6751
				],
				[
					-55,
					-40
				]
			],
			[
				[
					5844,
					6711
				],
				[
					-1,
					-18
				]
			],
			[
				[
					5843,
					6693
				],
				[
					-82,
					7
				]
			],
			[
				[
					5761,
					6700
				],
				[
					-22,
					32
				]
			],
			[
				[
					5739,
					6732
				],
				[
					-34,
					35
				]
			],
			[
				[
					5725,
					6804
				],
				[
					21,
					75
				]
			],
			[
				[
					5943,
					7029
				],
				[
					6,
					14
				]
			],
			[
				[
					5958,
					7077
				],
				[
					8,
					-10
				]
			],
			[
				[
					7189,
					4864
				],
				[
					79,
					-49
				]
			],
			[
				[
					7268,
					4815
				],
				[
					103,
					-68
				]
			],
			[
				[
					7371,
					4747
				],
				[
					89,
					-38
				]
			],
			[
				[
					7460,
					4709
				],
				[
					-193,
					-100
				],
				[
					139,
					-216
				],
				[
					-21,
					-156
				],
				[
					-120,
					13
				],
				[
					-86,
					-63
				],
				[
					-121,
					55
				],
				[
					-171,
					-74
				],
				[
					-76,
					79
				]
			],
			[
				[
					6946,
					4494
				],
				[
					75,
					13
				]
			],
			[
				[
					7021,
					4507
				],
				[
					46,
					91
				]
			],
			[
				[
					7067,
					4598
				],
				[
					63,
					106
				]
			],
			[
				[
					7130,
					4704
				],
				[
					-30,
					49
				]
			],
			[
				[
					7100,
					4753
				],
				[
					-30,
					54
				]
			],
			[
				[
					7070,
					4807
				],
				[
					88,
					24
				]
			],
			[
				[
					7158,
					4831
				],
				[
					31,
					33
				]
			],
			[
				[
					1238,
					4639
				],
				[
					21,
					-28
				]
			],
			[
				[
					1201,
					4620
				],
				[
					-74,
					13
				]
			],
			[
				[
					1054,
					4628
				],
				[
					3,
					-20
				]
			],
			[
				[
					864,
					4615
				],
				[
					-56,
					31
				],
				[
					-30,
					143
				]
			],
			[
				[
					778,
					4789
				],
				[
					103,
					84
				],
				[
					38,
					-40
				],
				[
					139,
					26
				],
				[
					82,
					112
				]
			],
			[
				[
					1140,
					4971
				],
				[
					122,
					-45
				],
				[
					32,
					18
				]
			],
			[
				[
					4855,
					4240
				],
				[
					52,
					-146
				]
			],
			[
				[
					4907,
					4094
				],
				[
					12,
					-36
				]
			],
			[
				[
					4919,
					4058
				],
				[
					27,
					-81
				]
			],
			[
				[
					4946,
					3977
				],
				[
					-29,
					-89
				]
			],
			[
				[
					4917,
					3888
				],
				[
					-73,
					-52
				]
			],
			[
				[
					4844,
					3836
				],
				[
					-49,
					44
				],
				[
					-112,
					-24
				],
				[
					-112,
					64
				]
			],
			[
				[
					4571,
					3920
				],
				[
					57,
					84
				]
			],
			[
				[
					4702,
					4086
				],
				[
					65,
					112
				]
			],
			[
				[
					4767,
					4198
				],
				[
					42,
					69
				]
			],
			[
				[
					4823,
					4244
				],
				[
					32,
					-4
				]
			],
			[
				[
					3753,
					5575
				],
				[
					-23,
					-22
				]
			],
			[
				[
					3722,
					5527
				],
				[
					64,
					-96
				]
			],
			[
				[
					3786,
					5431
				],
				[
					-19,
					-44
				]
			],
			[
				[
					3694,
					5345
				],
				[
					-75,
					58
				]
			],
			[
				[
					3453,
					5534
				],
				[
					29,
					102
				]
			],
			[
				[
					3504,
					5651
				],
				[
					49,
					-28
				]
			],
			[
				[
					3553,
					5623
				],
				[
					43,
					38
				]
			],
			[
				[
					2832,
					3603
				],
				[
					-12,
					-100
				]
			],
			[
				[
					2777,
					3426
				],
				[
					-115,
					-66
				]
			],
			[
				[
					2636,
					3456
				],
				[
					42,
					31
				]
			],
			[
				[
					2665,
					3530
				],
				[
					14,
					32
				]
			],
			[
				[
					2756,
					3636
				],
				[
					6,
					17
				]
			],
			[
				[
					5394,
					5196
				],
				[
					46,
					-37
				]
			],
			[
				[
					5440,
					5159
				],
				[
					2,
					-15
				],
				[
					33,
					-14
				]
			],
			[
				[
					5475,
					5130
				],
				[
					-19,
					-125
				],
				[
					16,
					-123
				]
			],
			[
				[
					5472,
					4882
				],
				[
					32,
					-50
				]
			],
			[
				[
					5504,
					4832
				],
				[
					40,
					-26
				]
			],
			[
				[
					5544,
					4806
				],
				[
					-129,
					-10
				]
			],
			[
				[
					5415,
					4796
				],
				[
					-66,
					-14
				]
			],
			[
				[
					5349,
					4782
				],
				[
					-28,
					27
				]
			],
			[
				[
					5321,
					4809
				],
				[
					-135,
					-20
				]
			],
			[
				[
					5186,
					4789
				],
				[
					-24,
					46
				]
			],
			[
				[
					5162,
					4835
				],
				[
					-76,
					-27
				]
			],
			[
				[
					5086,
					4808
				],
				[
					-2,
					68
				]
			],
			[
				[
					5084,
					4876
				],
				[
					101,
					85
				]
			],
			[
				[
					5314,
					5181
				],
				[
					80,
					15
				]
			],
			[
				[
					2190,
					4057
				],
				[
					21,
					21
				]
			],
			[
				[
					2211,
					4078
				],
				[
					26,
					-5
				]
			],
			[
				[
					2348,
					3779
				],
				[
					49,
					-18
				]
			],
			[
				[
					2507,
					3766
				],
				[
					55,
					0
				]
			],
			[
				[
					2547,
					3668
				],
				[
					-17,
					-24
				]
			],
			[
				[
					2491,
					3517
				],
				[
					-8,
					-61
				]
			],
			[
				[
					2483,
					3456
				],
				[
					35,
					-28
				]
			],
			[
				[
					2509,
					3234
				],
				[
					18,
					-17
				]
			],
			[
				[
					2527,
					3217
				],
				[
					-64,
					-49
				]
			],
			[
				[
					2427,
					3178
				],
				[
					-65,
					18
				]
			],
			[
				[
					2359,
					3175
				],
				[
					-18,
					53
				],
				[
					22,
					69
				],
				[
					-24,
					26
				],
				[
					-32,
					-12
				],
				[
					-46,
					-63
				],
				[
					-40,
					1
				],
				[
					-13,
					29
				]
			],
			[
				[
					2218,
					3369
				],
				[
					-43,
					45
				],
				[
					-120,
					20
				]
			],
			[
				[
					1965,
					3573
				],
				[
					84,
					129
				]
			],
			[
				[
					2049,
					3702
				],
				[
					-44,
					28
				],
				[
					-17,
					33
				],
				[
					77,
					153
				],
				[
					-5,
					48
				],
				[
					-41,
					46
				]
			],
			[
				[
					2019,
					4010
				],
				[
					64,
					67
				]
			],
			[
				[
					2083,
					4077
				],
				[
					107,
					-20
				]
			],
			[
				[
					6417,
					6385
				],
				[
					15,
					-25
				]
			],
			[
				[
					6432,
					6360
				],
				[
					31,
					11
				]
			],
			[
				[
					6463,
					6371
				],
				[
					51,
					-62
				],
				[
					-4,
					-83
				],
				[
					59,
					-117
				]
			],
			[
				[
					6569,
					6109
				],
				[
					-204,
					-93
				]
			],
			[
				[
					6365,
					6016
				],
				[
					-59,
					12
				],
				[
					-65,
					134
				]
			],
			[
				[
					6241,
					6162
				],
				[
					-42,
					34
				]
			],
			[
				[
					6199,
					6196
				],
				[
					20,
					31
				]
			],
			[
				[
					6219,
					6227
				],
				[
					1,
					44
				]
			],
			[
				[
					6330,
					6337
				],
				[
					24,
					37
				]
			],
			[
				[
					6354,
					6374
				],
				[
					49,
					25
				]
			],
			[
				[
					6403,
					6399
				],
				[
					14,
					-14
				]
			],
			[
				[
					6443,
					5367
				],
				[
					58,
					-38
				]
			],
			[
				[
					6501,
					5329
				],
				[
					31,
					-182
				]
			],
			[
				[
					6303,
					5012
				],
				[
					-60,
					-38
				]
			],
			[
				[
					6243,
					4974
				],
				[
					-32,
					26
				]
			],
			[
				[
					6211,
					5000
				],
				[
					11,
					44
				]
			],
			[
				[
					6222,
					5044
				],
				[
					-63,
					37
				]
			],
			[
				[
					6159,
					5081
				],
				[
					-36,
					134
				],
				[
					-16,
					18
				]
			],
			[
				[
					6107,
					5233
				],
				[
					23,
					91
				]
			],
			[
				[
					6130,
					5324
				],
				[
					3,
					34
				]
			],
			[
				[
					6133,
					5358
				],
				[
					94,
					84
				]
			],
			[
				[
					6227,
					5442
				],
				[
					119,
					-33
				]
			],
			[
				[
					6346,
					5409
				],
				[
					97,
					-42
				]
			],
			[
				[
					783,
					2440
				],
				[
					49,
					-8
				]
			],
			[
				[
					832,
					2432
				],
				[
					14,
					-85
				]
			],
			[
				[
					777,
					2273
				],
				[
					9,
					-33
				]
			],
			[
				[
					738,
					2226
				],
				[
					-79,
					8
				]
			],
			[
				[
					659,
					2234
				],
				[
					-14,
					-4
				]
			],
			[
				[
					645,
					2230
				],
				[
					20,
					89
				]
			],
			[
				[
					657,
					2339
				],
				[
					63,
					112
				]
			],
			[
				[
					720,
					2451
				],
				[
					25,
					-10
				]
			],
			[
				[
					745,
					2441
				],
				[
					18,
					24
				]
			],
			[
				[
					763,
					2465
				],
				[
					10,
					-8
				],
				[
					10,
					-17
				]
			],
			[
				[
					1390,
					2854
				],
				[
					63,
					-50
				]
			],
			[
				[
					1453,
					2804
				],
				[
					-25,
					-28
				]
			],
			[
				[
					1482,
					2604
				],
				[
					20,
					-53
				]
			],
			[
				[
					1502,
					2551
				],
				[
					-42,
					-18
				]
			],
			[
				[
					1460,
					2533
				],
				[
					-9,
					-32
				]
			],
			[
				[
					1451,
					2501
				],
				[
					22,
					-5
				]
			],
			[
				[
					1473,
					2496
				],
				[
					-13,
					-33
				]
			],
			[
				[
					1412,
					2418
				],
				[
					-38,
					86
				]
			],
			[
				[
					1365,
					2502
				],
				[
					-62,
					36
				]
			],
			[
				[
					1260,
					2541
				],
				[
					-46,
					13
				]
			],
			[
				[
					1198,
					2588
				],
				[
					-92,
					23
				]
			],
			[
				[
					1106,
					2611
				],
				[
					59,
					26
				],
				[
					-11,
					96
				]
			],
			[
				[
					1154,
					2733
				],
				[
					13,
					0
				]
			],
			[
				[
					1028,
					4116
				],
				[
					14,
					-110
				]
			],
			[
				[
					1042,
					4006
				],
				[
					23,
					-1
				]
			],
			[
				[
					1065,
					4005
				],
				[
					-13,
					-177
				]
			],
			[
				[
					941,
					3795
				],
				[
					-34,
					-84
				]
			],
			[
				[
					907,
					3711
				],
				[
					-30,
					-25
				]
			],
			[
				[
					877,
					3686
				],
				[
					-18,
					106
				]
			],
			[
				[
					859,
					3792
				],
				[
					-86,
					93
				]
			],
			[
				[
					773,
					3885
				],
				[
					-107,
					20
				]
			],
			[
				[
					666,
					3905
				],
				[
					35,
					104
				],
				[
					135,
					129
				]
			],
			[
				[
					913,
					4127
				],
				[
					21,
					-29
				],
				[
					94,
					18
				]
			],
			[
				[
					6818,
					6605
				],
				[
					43,
					-4
				]
			],
			[
				[
					6853,
					6511
				],
				[
					-17,
					7
				]
			],
			[
				[
					6768,
					6358
				],
				[
					-112,
					22
				]
			],
			[
				[
					6656,
					6380
				],
				[
					-28,
					65
				]
			],
			[
				[
					6628,
					6445
				],
				[
					41,
					134
				]
			],
			[
				[
					6669,
					6579
				],
				[
					37,
					8
				]
			],
			[
				[
					6706,
					6587
				],
				[
					62,
					-12
				]
			],
			[
				[
					6768,
					6575
				],
				[
					13,
					48
				]
			],
			[
				[
					6781,
					6623
				],
				[
					37,
					-18
				]
			],
			[
				[
					5339,
					6686
				],
				[
					47,
					16
				]
			],
			[
				[
					5386,
					6702
				],
				[
					5,
					-182
				]
			],
			[
				[
					5391,
					6520
				],
				[
					-51,
					27
				]
			],
			[
				[
					5340,
					6547
				],
				[
					-205,
					37
				],
				[
					-57,
					79
				],
				[
					51,
					93
				],
				[
					-56,
					85
				]
			],
			[
				[
					5073,
					6841
				],
				[
					120,
					130
				],
				[
					160,
					-41
				],
				[
					-52,
					-189
				]
			],
			[
				[
					3597,
					7484
				],
				[
					-159,
					-8
				]
			],
			[
				[
					3438,
					7476
				],
				[
					-16,
					-24
				]
			],
			[
				[
					3233,
					7763
				],
				[
					192,
					-1
				],
				[
					84,
					-22
				]
			],
			[
				[
					832,
					3519
				],
				[
					67,
					-87
				]
			],
			[
				[
					899,
					3432
				],
				[
					-23,
					-9
				]
			],
			[
				[
					876,
					3423
				],
				[
					-40,
					-60
				],
				[
					-41,
					-23
				],
				[
					-79,
					70
				]
			],
			[
				[
					716,
					3410
				],
				[
					-24,
					40
				],
				[
					-156,
					-98
				],
				[
					-65,
					52
				],
				[
					-7,
					157
				],
				[
					30,
					24
				]
			],
			[
				[
					494,
					3585
				],
				[
					265,
					43
				]
			],
			[
				[
					759,
					3628
				],
				[
					67,
					-25
				]
			],
			[
				[
					2323,
					6626
				],
				[
					163,
					-81
				]
			],
			[
				[
					2486,
					6545
				],
				[
					54,
					13
				]
			],
			[
				[
					2540,
					6558
				],
				[
					-1,
					-71
				],
				[
					-6,
					-35
				]
			],
			[
				[
					2533,
					6452
				],
				[
					-32,
					12
				]
			],
			[
				[
					2501,
					6464
				],
				[
					-85,
					-48
				]
			],
			[
				[
					2416,
					6416
				],
				[
					-8,
					9
				]
			],
			[
				[
					2394,
					6415
				],
				[
					-73,
					-36
				]
			],
			[
				[
					2321,
					6379
				],
				[
					-154,
					-54
				]
			],
			[
				[
					2113,
					6344
				],
				[
					84,
					70
				],
				[
					24,
					118
				],
				[
					72,
					21
				],
				[
					-5,
					119
				]
			],
			[
				[
					2288,
					6672
				],
				[
					35,
					-46
				]
			],
			[
				[
					7103,
					6212
				],
				[
					58,
					-63
				]
			],
			[
				[
					7214,
					6129
				],
				[
					20,
					14
				]
			],
			[
				[
					7234,
					6143
				],
				[
					61,
					-37
				]
			],
			[
				[
					7295,
					6106
				],
				[
					14,
					-139
				]
			],
			[
				[
					7309,
					5967
				],
				[
					-40,
					-61
				]
			],
			[
				[
					7269,
					5906
				],
				[
					-244,
					-23
				]
			],
			[
				[
					7025,
					5883
				],
				[
					-53,
					75
				]
			],
			[
				[
					6972,
					5958
				],
				[
					-14,
					120
				],
				[
					-38,
					56
				]
			],
			[
				[
					5255,
					1851
				],
				[
					46,
					-78
				]
			],
			[
				[
					5144,
					1640
				],
				[
					-112,
					155
				],
				[
					22,
					123
				],
				[
					47,
					-10
				],
				[
					63,
					32
				]
			],
			[
				[
					5164,
					1940
				],
				[
					61,
					-52
				]
			],
			[
				[
					5311,
					3635
				],
				[
					37,
					3
				]
			],
			[
				[
					5348,
					3638
				],
				[
					59,
					-4
				]
			],
			[
				[
					5407,
					3634
				],
				[
					-48,
					-106
				],
				[
					29,
					-48
				]
			],
			[
				[
					5388,
					3480
				],
				[
					-68,
					-89
				]
			],
			[
				[
					5104,
					3282
				],
				[
					-9,
					15
				]
			],
			[
				[
					4906,
					3336
				],
				[
					-16,
					32
				]
			],
			[
				[
					4986,
					3608
				],
				[
					-12,
					2
				]
			],
			[
				[
					4974,
					3610
				],
				[
					1,
					23
				],
				[
					70,
					6
				],
				[
					63,
					-26
				],
				[
					137,
					51
				]
			],
			[
				[
					5245,
					3664
				],
				[
					66,
					-29
				]
			],
			[
				[
					7513,
					8009
				],
				[
					-11,
					-152
				],
				[
					-37,
					-89
				]
			],
			[
				[
					7443,
					7750
				],
				[
					-58,
					10
				]
			],
			[
				[
					7385,
					7760
				],
				[
					-31,
					22
				]
			],
			[
				[
					7257,
					7692
				],
				[
					-228,
					66
				]
			],
			[
				[
					7029,
					7758
				],
				[
					33,
					64
				],
				[
					24,
					2
				],
				[
					13,
					85
				],
				[
					107,
					150
				]
			],
			[
				[
					7206,
					8059
				],
				[
					10,
					37
				]
			],
			[
				[
					7216,
					8096
				],
				[
					1,
					5
				]
			],
			[
				[
					7217,
					8101
				],
				[
					109,
					56
				],
				[
					81,
					-69
				],
				[
					-18,
					-75
				],
				[
					124,
					-4
				]
			],
			[
				[
					6665,
					8364
				],
				[
					16,
					-45
				]
			],
			[
				[
					6681,
					8319
				],
				[
					170,
					-47
				]
			],
			[
				[
					6851,
					8272
				],
				[
					12,
					-81
				],
				[
					-70,
					-49
				]
			],
			[
				[
					6793,
					8142
				],
				[
					-40,
					-91
				]
			],
			[
				[
					6753,
					8051
				],
				[
					-132,
					-6
				]
			],
			[
				[
					6621,
					8045
				],
				[
					-153,
					37
				]
			],
			[
				[
					6468,
					8082
				],
				[
					-2,
					37
				]
			],
			[
				[
					6466,
					8119
				],
				[
					-86,
					12
				]
			],
			[
				[
					6366,
					8157
				],
				[
					79,
					99
				]
			],
			[
				[
					6445,
					8256
				],
				[
					3,
					25
				]
			],
			[
				[
					6448,
					8281
				],
				[
					91,
					9
				],
				[
					45,
					61
				]
			],
			[
				[
					6584,
					8351
				],
				[
					81,
					13
				]
			],
			[
				[
					1522,
					4038
				],
				[
					7,
					-121
				],
				[
					-56,
					-28
				]
			],
			[
				[
					1473,
					3889
				],
				[
					8,
					-11
				]
			],
			[
				[
					1481,
					3878
				],
				[
					-160,
					-90
				]
			],
			[
				[
					1321,
					3788
				],
				[
					-50,
					77
				],
				[
					-42,
					33
				]
			],
			[
				[
					1229,
					3898
				],
				[
					45,
					11
				]
			],
			[
				[
					1274,
					3909
				],
				[
					-48,
					93
				]
			],
			[
				[
					1226,
					4002
				],
				[
					56,
					41
				]
			],
			[
				[
					1282,
					4043
				],
				[
					152,
					6
				]
			],
			[
				[
					1434,
					4049
				],
				[
					16,
					27
				]
			],
			[
				[
					1450,
					4076
				],
				[
					72,
					-38
				]
			],
			[
				[
					946,
					1396
				],
				[
					-61,
					-70
				]
			],
			[
				[
					885,
					1326
				],
				[
					4,
					-29
				]
			],
			[
				[
					889,
					1297
				],
				[
					37,
					-66
				],
				[
					-37,
					-10
				],
				[
					-142,
					-1
				],
				[
					13,
					164
				]
			],
			[
				[
					760,
					1384
				],
				[
					9,
					-4
				]
			],
			[
				[
					769,
					1380
				],
				[
					101,
					99
				]
			],
			[
				[
					908,
					1217
				],
				[
					-6,
					-54
				]
			],
			[
				[
					902,
					1163
				],
				[
					6,
					54
				]
			],
			[
				[
					2246,
					1080
				],
				[
					7,
					-126
				],
				[
					103,
					-47
				],
				[
					151,
					-2
				]
			],
			[
				[
					2507,
					905
				],
				[
					26,
					-18
				]
			],
			[
				[
					2533,
					887
				],
				[
					3,
					-103
				],
				[
					-49,
					-30
				],
				[
					-18,
					-228
				],
				[
					-104,
					-64
				],
				[
					-258,
					149
				]
			],
			[
				[
					1961,
					809
				],
				[
					99,
					155
				]
			],
			[
				[
					2060,
					964
				],
				[
					74,
					64
				]
			],
			[
				[
					2134,
					1028
				],
				[
					18,
					37
				]
			],
			[
				[
					2152,
					1065
				],
				[
					51,
					13
				]
			],
			[
				[
					2203,
					1078
				],
				[
					43,
					2
				]
			],
			[
				[
					2888,
					5800
				],
				[
					22,
					-24
				]
			],
			[
				[
					2921,
					5617
				],
				[
					-23,
					-29
				]
			],
			[
				[
					2898,
					5588
				],
				[
					-3,
					-45
				]
			],
			[
				[
					2821,
					5488
				],
				[
					22,
					-44
				]
			],
			[
				[
					2794,
					5257
				],
				[
					1,
					-47
				]
			],
			[
				[
					2795,
					5210
				],
				[
					-36,
					2
				]
			],
			[
				[
					2759,
					5212
				],
				[
					-7,
					-23
				]
			],
			[
				[
					2752,
					5189
				],
				[
					-87,
					-10
				]
			],
			[
				[
					2665,
					5179
				],
				[
					-37,
					18
				]
			],
			[
				[
					2628,
					5197
				],
				[
					-47,
					28
				]
			],
			[
				[
					2581,
					5225
				],
				[
					-41,
					40
				]
			],
			[
				[
					2540,
					5265
				],
				[
					-69,
					-36
				]
			],
			[
				[
					2471,
					5229
				],
				[
					-20,
					81
				],
				[
					51,
					172
				],
				[
					53,
					23
				],
				[
					-28,
					113
				]
			],
			[
				[
					2527,
					5618
				],
				[
					-41,
					66
				],
				[
					20,
					117
				]
			],
			[
				[
					2506,
					5801
				],
				[
					94,
					-23
				]
			],
			[
				[
					2600,
					5778
				],
				[
					40,
					99
				]
			],
			[
				[
					2640,
					5877
				],
				[
					115,
					14
				]
			],
			[
				[
					1756,
					4775
				],
				[
					48,
					-75
				],
				[
					38,
					-30
				]
			],
			[
				[
					1842,
					4670
				],
				[
					70,
					-151
				]
			],
			[
				[
					1912,
					4519
				],
				[
					5,
					-69
				]
			],
			[
				[
					1917,
					4450
				],
				[
					-23,
					-130
				],
				[
					-55,
					-47
				]
			],
			[
				[
					1839,
					4273
				],
				[
					-11,
					-22
				]
			],
			[
				[
					1828,
					4251
				],
				[
					-128,
					-3
				],
				[
					-21,
					79
				]
			],
			[
				[
					1679,
					4327
				],
				[
					60,
					219
				],
				[
					-36,
					30
				]
			],
			[
				[
					1703,
					4576
				],
				[
					6,
					123
				]
			],
			[
				[
					1702,
					4718
				],
				[
					14,
					54
				]
			],
			[
				[
					1716,
					4772
				],
				[
					40,
					3
				]
			],
			[
				[
					670,
					3237
				],
				[
					53,
					-59
				]
			],
			[
				[
					723,
					3178
				],
				[
					40,
					-47
				]
			],
			[
				[
					763,
					3131
				],
				[
					-15,
					-13
				]
			],
			[
				[
					748,
					3118
				],
				[
					43,
					-40
				]
			],
			[
				[
					780,
					3070
				],
				[
					11,
					-36
				]
			],
			[
				[
					666,
					2973
				],
				[
					-89,
					84
				]
			],
			[
				[
					577,
					3057
				],
				[
					-90,
					112
				],
				[
					111,
					82
				],
				[
					72,
					-14
				]
			],
			[
				[
					5391,
					6520
				],
				[
					39,
					-17
				]
			],
			[
				[
					5430,
					6503
				],
				[
					80,
					-76
				],
				[
					18,
					-27
				]
			],
			[
				[
					5528,
					6400
				],
				[
					-9,
					-11
				]
			],
			[
				[
					5519,
					6389
				],
				[
					-4,
					-62
				]
			],
			[
				[
					5515,
					6327
				],
				[
					-67,
					-59
				]
			],
			[
				[
					5448,
					6268
				],
				[
					-22,
					9
				]
			],
			[
				[
					5426,
					6277
				],
				[
					-36,
					46
				]
			],
			[
				[
					5390,
					6323
				],
				[
					-100,
					-3
				]
			],
			[
				[
					5290,
					6320
				],
				[
					35,
					139
				]
			],
			[
				[
					5325,
					6459
				],
				[
					1,
					26
				]
			],
			[
				[
					5326,
					6485
				],
				[
					65,
					35
				]
			],
			[
				[
					2765,
					1304
				],
				[
					77,
					-122
				]
			],
			[
				[
					2842,
					1182
				],
				[
					19,
					2
				]
			],
			[
				[
					2861,
					1184
				],
				[
					-50,
					-120
				]
			],
			[
				[
					2811,
					1064
				],
				[
					-109,
					-151
				],
				[
					-35,
					24
				]
			],
			[
				[
					2667,
					937
				],
				[
					33,
					104
				]
			],
			[
				[
					2700,
					1041
				],
				[
					7,
					96
				]
			],
			[
				[
					2707,
					1137
				],
				[
					-18,
					116
				],
				[
					63,
					69
				]
			],
			[
				[
					2752,
					1322
				],
				[
					13,
					-18
				]
			],
			[
				[
					6020,
					3828
				],
				[
					6,
					-19
				]
			],
			[
				[
					6026,
					3809
				],
				[
					68,
					-84
				]
			],
			[
				[
					6094,
					3725
				],
				[
					62,
					15
				]
			],
			[
				[
					6156,
					3740
				],
				[
					9,
					-37
				]
			],
			[
				[
					6165,
					3703
				],
				[
					20,
					-87
				]
			],
			[
				[
					6185,
					3616
				],
				[
					-47,
					-42
				]
			],
			[
				[
					6138,
					3574
				],
				[
					-8,
					-22
				]
			],
			[
				[
					6130,
					3552
				],
				[
					32,
					-33
				]
			],
			[
				[
					6162,
					3519
				],
				[
					50,
					-116
				],
				[
					47,
					15
				]
			],
			[
				[
					6259,
					3418
				],
				[
					38,
					-47
				]
			],
			[
				[
					6297,
					3371
				],
				[
					-123,
					-133
				]
			],
			[
				[
					6174,
					3238
				],
				[
					-25,
					-2
				]
			],
			[
				[
					6149,
					3236
				],
				[
					-141,
					-150
				]
			],
			[
				[
					5790,
					3082
				],
				[
					-95,
					5
				]
			],
			[
				[
					5583,
					3222
				],
				[
					-41,
					29
				]
			],
			[
				[
					5467,
					3225
				],
				[
					-20,
					60
				]
			],
			[
				[
					5475,
					3307
				],
				[
					42,
					75
				]
			],
			[
				[
					5517,
					3382
				],
				[
					87,
					106
				],
				[
					-11,
					75
				],
				[
					171,
					82
				],
				[
					24,
					108
				]
			],
			[
				[
					5788,
					3753
				],
				[
					52,
					30
				]
			],
			[
				[
					5898,
					2584
				],
				[
					31,
					-22
				]
			],
			[
				[
					6224,
					2548
				],
				[
					-60,
					-211
				],
				[
					-107,
					-106
				],
				[
					-48,
					-110
				],
				[
					-153,
					-14
				],
				[
					-78,
					128
				]
			],
			[
				[
					5778,
					2235
				],
				[
					6,
					22
				]
			],
			[
				[
					5784,
					2257
				],
				[
					-85,
					99
				]
			],
			[
				[
					5699,
					2356
				],
				[
					-2,
					27
				]
			],
			[
				[
					5697,
					2383
				],
				[
					22,
					49
				]
			],
			[
				[
					5779,
					2545
				],
				[
					113,
					64
				]
			],
			[
				[
					5924,
					5911
				],
				[
					14,
					-44
				]
			],
			[
				[
					5938,
					5867
				],
				[
					51,
					-51
				]
			],
			[
				[
					5989,
					5816
				],
				[
					18,
					-103
				]
			],
			[
				[
					6007,
					5713
				],
				[
					-59,
					-101
				]
			],
			[
				[
					5948,
					5612
				],
				[
					-19,
					-8
				]
			],
			[
				[
					5929,
					5604
				],
				[
					-16,
					-21
				]
			],
			[
				[
					5913,
					5583
				],
				[
					-67,
					72
				]
			],
			[
				[
					5731,
					5784
				],
				[
					3,
					35
				],
				[
					-8,
					2
				],
				[
					12,
					32
				],
				[
					112,
					5
				]
			],
			[
				[
					5604,
					6717
				],
				[
					135,
					15
				]
			],
			[
				[
					5761,
					6700
				],
				[
					50,
					-18
				],
				[
					72,
					-129
				]
			],
			[
				[
					5910,
					6498
				],
				[
					-23,
					-95
				]
			],
			[
				[
					5849,
					6433
				],
				[
					-88,
					15
				]
			],
			[
				[
					5761,
					6448
				],
				[
					-139,
					45
				]
			],
			[
				[
					5622,
					6493
				],
				[
					-33,
					1
				]
			],
			[
				[
					5589,
					6494
				],
				[
					-61,
					-94
				]
			],
			[
				[
					5528,
					6400
				],
				[
					-98,
					103
				]
			],
			[
				[
					5386,
					6702
				],
				[
					30,
					14
				]
			],
			[
				[
					5475,
					6756
				],
				[
					11,
					-18
				]
			],
			[
				[
					4347,
					3896
				],
				[
					98,
					49
				]
			],
			[
				[
					4527,
					3946
				],
				[
					12,
					-3
				]
			],
			[
				[
					4539,
					3943
				],
				[
					18,
					-63
				],
				[
					1,
					-22
				],
				[
					-19,
					-24
				],
				[
					-24,
					-10
				]
			],
			[
				[
					4515,
					3824
				],
				[
					-20,
					19
				]
			],
			[
				[
					4495,
					3843
				],
				[
					-58,
					-13
				]
			],
			[
				[
					4437,
					3830
				],
				[
					-31,
					-97
				]
			],
			[
				[
					4276,
					3726
				],
				[
					-36,
					34
				]
			],
			[
				[
					4240,
					3760
				],
				[
					-11,
					-3
				]
			],
			[
				[
					4229,
					3757
				],
				[
					32,
					36
				]
			],
			[
				[
					4261,
					3793
				],
				[
					-3,
					118
				]
			],
			[
				[
					4258,
					3911
				],
				[
					32,
					33
				]
			],
			[
				[
					4290,
					3944
				],
				[
					57,
					-48
				]
			],
			[
				[
					6490,
					7359
				],
				[
					41,
					26
				]
			],
			[
				[
					6531,
					7385
				],
				[
					14,
					2
				]
			],
			[
				[
					6545,
					7387
				],
				[
					7,
					-25
				],
				[
					15,
					-3
				],
				[
					12,
					-51
				]
			],
			[
				[
					6579,
					7308
				],
				[
					8,
					-57
				]
			],
			[
				[
					6587,
					7251
				],
				[
					10,
					-4
				]
			],
			[
				[
					6597,
					7247
				],
				[
					-14,
					-60
				]
			],
			[
				[
					6583,
					7187
				],
				[
					-122,
					-41
				]
			],
			[
				[
					6461,
					7146
				],
				[
					-4,
					-39
				]
			],
			[
				[
					6457,
					7107
				],
				[
					-27,
					22
				]
			],
			[
				[
					6430,
					7129
				],
				[
					-84,
					63
				]
			],
			[
				[
					6346,
					7192
				],
				[
					-15,
					46
				]
			],
			[
				[
					6331,
					7238
				],
				[
					-9,
					99
				]
			],
			[
				[
					6322,
					7337
				],
				[
					81,
					17
				],
				[
					14,
					20
				],
				[
					33,
					15
				],
				[
					40,
					-30
				]
			],
			[
				[
					6491,
					7734
				],
				[
					6,
					-15
				]
			],
			[
				[
					6497,
					7719
				],
				[
					97,
					-69
				]
			],
			[
				[
					6605,
					7426
				],
				[
					-25,
					-6
				]
			],
			[
				[
					6580,
					7420
				],
				[
					-7,
					-32
				]
			],
			[
				[
					6573,
					7388
				],
				[
					-42,
					-3
				]
			],
			[
				[
					6490,
					7359
				],
				[
					-79,
					74
				]
			],
			[
				[
					6411,
					7433
				],
				[
					-22,
					24
				]
			],
			[
				[
					6389,
					7457
				],
				[
					-131,
					20
				]
			],
			[
				[
					6258,
					7477
				],
				[
					149,
					163
				],
				[
					70,
					35
				]
			],
			[
				[
					6477,
					7675
				],
				[
					14,
					59
				]
			],
			[
				[
					4596,
					8228
				],
				[
					-76,
					-159
				],
				[
					-53,
					-17
				]
			],
			[
				[
					4467,
					8052
				],
				[
					-109,
					-52
				],
				[
					-139,
					86
				]
			],
			[
				[
					4219,
					8086
				],
				[
					97,
					99
				]
			],
			[
				[
					4316,
					8185
				],
				[
					11,
					108
				],
				[
					101,
					21
				]
			],
			[
				[
					4428,
					8314
				],
				[
					168,
					-86
				]
			],
			[
				[
					6987,
					8292
				],
				[
					117,
					-188
				],
				[
					84,
					-19
				]
			],
			[
				[
					7188,
					8085
				],
				[
					18,
					-26
				]
			],
			[
				[
					7029,
					7758
				],
				[
					-37,
					34
				]
			],
			[
				[
					6992,
					7792
				],
				[
					-17,
					-8
				],
				[
					-140,
					78
				]
			],
			[
				[
					6835,
					7862
				],
				[
					37,
					60
				],
				[
					4,
					42
				],
				[
					-52,
					6
				]
			],
			[
				[
					6824,
					7970
				],
				[
					-31,
					172
				]
			],
			[
				[
					6851,
					8272
				],
				[
					136,
					20
				]
			],
			[
				[
					3015,
					1244
				],
				[
					69,
					30
				]
			],
			[
				[
					3084,
					1274
				],
				[
					93,
					-48
				],
				[
					-13,
					-76
				],
				[
					-180,
					-49
				],
				[
					-52,
					-103
				],
				[
					-121,
					66
				]
			],
			[
				[
					2861,
					1184
				],
				[
					100,
					111
				]
			],
			[
				[
					2961,
					1295
				],
				[
					54,
					-51
				]
			],
			[
				[
					4854,
					6540
				],
				[
					39,
					-85
				]
			],
			[
				[
					4893,
					6455
				],
				[
					15,
					-107
				],
				[
					-82,
					-63
				]
			],
			[
				[
					4826,
					6285
				],
				[
					-91,
					-75
				]
			],
			[
				[
					4735,
					6210
				],
				[
					-101,
					12
				],
				[
					-79,
					66
				]
			],
			[
				[
					4555,
					6288
				],
				[
					-19,
					-2
				]
			],
			[
				[
					4559,
					6375
				],
				[
					2,
					42
				]
			],
			[
				[
					4632,
					6484
				],
				[
					60,
					13
				]
			],
			[
				[
					4772,
					6539
				],
				[
					45,
					12
				]
			],
			[
				[
					4817,
					6551
				],
				[
					37,
					-11
				]
			],
			[
				[
					3140,
					4895
				],
				[
					-84,
					-2
				]
			],
			[
				[
					3056,
					4893
				],
				[
					-14,
					82
				],
				[
					-80,
					86
				]
			],
			[
				[
					2962,
					5061
				],
				[
					-69,
					45
				]
			],
			[
				[
					2893,
					5106
				],
				[
					-24,
					40
				]
			],
			[
				[
					2997,
					5189
				],
				[
					34,
					31
				]
			],
			[
				[
					3031,
					5220
				],
				[
					16,
					-4
				],
				[
					38,
					-27
				]
			],
			[
				[
					1578,
					5968
				],
				[
					-37,
					-9
				]
			],
			[
				[
					1541,
					5959
				],
				[
					-14,
					-13
				]
			],
			[
				[
					1527,
					5946
				],
				[
					-58,
					-5
				],
				[
					-65,
					-33
				],
				[
					-65,
					-5
				]
			],
			[
				[
					1315,
					5914
				],
				[
					-4,
					42
				]
			],
			[
				[
					1324,
					5968
				],
				[
					-58,
					71
				],
				[
					71,
					92
				],
				[
					149,
					-53
				]
			],
			[
				[
					6365,
					6016
				],
				[
					32,
					-52
				]
			],
			[
				[
					6397,
					5964
				],
				[
					-21,
					-34
				]
			],
			[
				[
					6376,
					5930
				],
				[
					-128,
					-72
				]
			],
			[
				[
					6248,
					5858
				],
				[
					-142,
					-173
				]
			],
			[
				[
					6106,
					5685
				],
				[
					-57,
					-126
				]
			],
			[
				[
					6049,
					5559
				],
				[
					-101,
					53
				]
			],
			[
				[
					5948,
					5612
				],
				[
					59,
					101
				]
			],
			[
				[
					5989,
					5816
				],
				[
					-51,
					51
				]
			],
			[
				[
					5938,
					5867
				],
				[
					17,
					86
				]
			],
			[
				[
					6076,
					6121
				],
				[
					48,
					20
				]
			],
			[
				[
					6124,
					6141
				],
				[
					75,
					55
				]
			],
			[
				[
					6199,
					6196
				],
				[
					42,
					-34
				]
			],
			[
				[
					1150,
					5476
				],
				[
					61,
					-59
				]
			],
			[
				[
					1211,
					5417
				],
				[
					-44,
					-80
				]
			],
			[
				[
					1167,
					5337
				],
				[
					-90,
					-106
				]
			],
			[
				[
					1077,
					5231
				],
				[
					-57,
					38
				]
			],
			[
				[
					1020,
					5269
				],
				[
					-51,
					-23
				]
			],
			[
				[
					969,
					5246
				],
				[
					-69,
					75
				],
				[
					-50,
					34
				],
				[
					7,
					4
				],
				[
					-51,
					30
				]
			],
			[
				[
					806,
					5389
				],
				[
					42,
					75
				]
			],
			[
				[
					848,
					5464
				],
				[
					-6,
					31
				],
				[
					-28,
					45
				]
			],
			[
				[
					814,
					5540
				],
				[
					24,
					7
				],
				[
					116,
					0
				],
				[
					18,
					-32
				],
				[
					61,
					-43
				]
			],
			[
				[
					4316,
					8185
				],
				[
					-107,
					-100
				],
				[
					-127,
					-18
				]
			],
			[
				[
					4082,
					8067
				],
				[
					-54,
					92
				]
			],
			[
				[
					4028,
					8159
				],
				[
					-16,
					14
				]
			],
			[
				[
					4012,
					8173
				],
				[
					71,
					51
				],
				[
					77,
					171
				],
				[
					-76,
					45
				],
				[
					78,
					172
				],
				[
					205,
					-86
				],
				[
					61,
					-212
				]
			],
			[
				[
					3343,
					4958
				],
				[
					72,
					-146
				]
			],
			[
				[
					3415,
					4812
				],
				[
					-89,
					-18
				]
			],
			[
				[
					3313,
					4775
				],
				[
					-57,
					-23
				]
			],
			[
				[
					3207,
					4770
				],
				[
					-36,
					-50
				]
			],
			[
				[
					3171,
					4720
				],
				[
					-56,
					-21
				]
			],
			[
				[
					3073,
					4695
				],
				[
					-34,
					22
				]
			],
			[
				[
					3039,
					4717
				],
				[
					-35,
					154
				]
			],
			[
				[
					3004,
					4871
				],
				[
					136,
					24
				]
			],
			[
				[
					3252,
					4942
				],
				[
					37,
					36
				]
			],
			[
				[
					3289,
					4978
				],
				[
					20,
					-30
				],
				[
					34,
					10
				]
			],
			[
				[
					4113,
					3859
				],
				[
					20,
					-45
				],
				[
					67,
					1
				]
			],
			[
				[
					4200,
					3815
				],
				[
					34,
					-38
				]
			],
			[
				[
					4234,
					3777
				],
				[
					-5,
					-20
				]
			],
			[
				[
					4229,
					3757
				],
				[
					-33,
					-27
				]
			],
			[
				[
					4054,
					3570
				],
				[
					-36,
					29
				]
			],
			[
				[
					3921,
					3563
				],
				[
					-22,
					70
				]
			],
			[
				[
					3899,
					3633
				],
				[
					-3,
					42
				]
			],
			[
				[
					3938,
					3705
				],
				[
					58,
					52
				]
			],
			[
				[
					3996,
					3757
				],
				[
					117,
					102
				]
			],
			[
				[
					7956,
					6871
				],
				[
					-167,
					30
				]
			],
			[
				[
					7777,
					6865
				],
				[
					-65,
					-11
				]
			],
			[
				[
					7634,
					6994
				],
				[
					-34,
					38
				]
			],
			[
				[
					7600,
					7032
				],
				[
					-6,
					194
				]
			],
			[
				[
					7594,
					7226
				],
				[
					66,
					69
				],
				[
					90,
					-50
				],
				[
					127,
					-3
				],
				[
					-18,
					-118
				],
				[
					138,
					-143
				],
				[
					-41,
					-110
				]
			],
			[
				[
					6455,
					7747
				],
				[
					22,
					-72
				]
			],
			[
				[
					6258,
					7477
				],
				[
					-73,
					85
				],
				[
					47,
					62
				],
				[
					-7,
					114
				],
				[
					32,
					15
				],
				[
					72,
					13
				],
				[
					126,
					-19
				]
			],
			[
				[
					2846,
					2058
				],
				[
					79,
					-64
				]
			],
			[
				[
					2925,
					1994
				],
				[
					24,
					-53
				],
				[
					-42,
					-171
				]
			],
			[
				[
					2907,
					1770
				],
				[
					-114,
					32
				]
			],
			[
				[
					2793,
					1802
				],
				[
					-15,
					99
				],
				[
					-11,
					33
				],
				[
					-30,
					21
				],
				[
					-79,
					42
				]
			],
			[
				[
					2658,
					1997
				],
				[
					10,
					41
				]
			],
			[
				[
					2668,
					2038
				],
				[
					117,
					19
				]
			],
			[
				[
					2785,
					2057
				],
				[
					61,
					1
				]
			],
			[
				[
					7247,
					7056
				],
				[
					64,
					-81
				],
				[
					123,
					-23
				]
			],
			[
				[
					7434,
					6952
				],
				[
					30,
					-54
				]
			],
			[
				[
					7447,
					6863
				],
				[
					32,
					-54
				]
			],
			[
				[
					7510,
					6788
				],
				[
					-29,
					-65
				]
			],
			[
				[
					7459,
					6665
				],
				[
					-54,
					-41
				]
			],
			[
				[
					7254,
					6687
				],
				[
					-30,
					-30
				]
			],
			[
				[
					7203,
					6651
				],
				[
					-6,
					24
				]
			],
			[
				[
					7104,
					6798
				],
				[
					-24,
					58
				]
			],
			[
				[
					7080,
					6856
				],
				[
					28,
					28
				]
			],
			[
				[
					7108,
					6884
				],
				[
					54,
					8
				]
			],
			[
				[
					7162,
					6892
				],
				[
					1,
					138
				]
			],
			[
				[
					7163,
					7030
				],
				[
					4,
					39
				]
			],
			[
				[
					7167,
					7069
				],
				[
					80,
					-13
				]
			],
			[
				[
					4740,
					4889
				],
				[
					-25,
					-70
				]
			],
			[
				[
					4715,
					4819
				],
				[
					19,
					-21
				]
			],
			[
				[
					4734,
					4798
				],
				[
					-103,
					-66
				]
			],
			[
				[
					4601,
					4774
				],
				[
					-69,
					-18
				]
			],
			[
				[
					4344,
					4652
				],
				[
					-36,
					-4
				]
			],
			[
				[
					4258,
					4763
				],
				[
					-15,
					12
				]
			],
			[
				[
					4243,
					4775
				],
				[
					-12,
					76
				]
			],
			[
				[
					4235,
					4866
				],
				[
					5,
					72
				]
			],
			[
				[
					4240,
					4938
				],
				[
					184,
					30
				],
				[
					53,
					-27
				]
			],
			[
				[
					4477,
					4941
				],
				[
					115,
					2
				]
			],
			[
				[
					4620,
					4929
				],
				[
					41,
					52
				]
			],
			[
				[
					4674,
					4987
				],
				[
					28,
					12
				]
			],
			[
				[
					4433,
					5138
				],
				[
					-10,
					-57
				]
			],
			[
				[
					4423,
					5081
				],
				[
					19,
					-25
				]
			],
			[
				[
					4432,
					5044
				],
				[
					45,
					-18
				]
			],
			[
				[
					4508,
					4964
				],
				[
					-31,
					-23
				]
			],
			[
				[
					4240,
					4938
				],
				[
					-26,
					-47
				]
			],
			[
				[
					4147,
					4990
				],
				[
					-11,
					74
				]
			],
			[
				[
					4136,
					5064
				],
				[
					84,
					-29
				]
			],
			[
				[
					4220,
					5035
				],
				[
					45,
					61
				]
			],
			[
				[
					4265,
					5096
				],
				[
					98,
					22
				]
			],
			[
				[
					4363,
					5118
				],
				[
					3,
					23
				]
			],
			[
				[
					4366,
					5141
				],
				[
					67,
					-3
				]
			],
			[
				[
					940,
					5583
				],
				[
					-37,
					-32
				]
			],
			[
				[
					903,
					5551
				],
				[
					-94,
					-15
				],
				[
					-45,
					112
				]
			],
			[
				[
					764,
					5648
				],
				[
					-41,
					32
				]
			],
			[
				[
					723,
					5680
				],
				[
					-4,
					-16
				]
			],
			[
				[
					719,
					5664
				],
				[
					-47,
					23
				]
			],
			[
				[
					672,
					5687
				],
				[
					-2,
					-72
				]
			],
			[
				[
					670,
					5615
				],
				[
					-97,
					42
				]
			],
			[
				[
					884,
					5875
				],
				[
					43,
					-87
				]
			],
			[
				[
					5622,
					6493
				],
				[
					139,
					-45
				]
			],
			[
				[
					5761,
					6448
				],
				[
					72,
					-37
				]
			],
			[
				[
					5808,
					6387
				],
				[
					64,
					-66
				]
			],
			[
				[
					5872,
					6321
				],
				[
					1,
					-28
				]
			],
			[
				[
					5873,
					6293
				],
				[
					-47,
					-62
				]
			],
			[
				[
					5688,
					6064
				],
				[
					-73,
					66
				]
			],
			[
				[
					5615,
					6130
				],
				[
					-50,
					13
				],
				[
					-66,
					139
				]
			],
			[
				[
					5499,
					6282
				],
				[
					16,
					45
				]
			],
			[
				[
					5519,
					6389
				],
				[
					12,
					32
				],
				[
					58,
					73
				]
			],
			[
				[
					3625,
					7042
				],
				[
					89,
					-15
				]
			],
			[
				[
					3714,
					7027
				],
				[
					-31,
					-111
				]
			],
			[
				[
					3683,
					6916
				],
				[
					12,
					-62
				]
			],
			[
				[
					3695,
					6854
				],
				[
					-87,
					-49
				],
				[
					-53,
					37
				]
			],
			[
				[
					3555,
					6842
				],
				[
					-147,
					59
				]
			],
			[
				[
					3408,
					6901
				],
				[
					10,
					21
				]
			],
			[
				[
					3418,
					6922
				],
				[
					-7,
					9
				]
			],
			[
				[
					3411,
					6931
				],
				[
					48,
					-3
				],
				[
					97,
					87
				]
			],
			[
				[
					3556,
					7015
				],
				[
					69,
					27
				]
			],
			[
				[
					5419,
					2452
				],
				[
					72,
					66
				]
			],
			[
				[
					5462,
					2533
				],
				[
					76,
					-26
				]
			],
			[
				[
					5540,
					2477
				],
				[
					99,
					-53
				]
			],
			[
				[
					5668,
					2374
				],
				[
					29,
					9
				]
			],
			[
				[
					5699,
					2356
				],
				[
					85,
					-99
				]
			],
			[
				[
					5778,
					2235
				],
				[
					-101,
					-171
				],
				[
					-80,
					-67
				]
			],
			[
				[
					5605,
					2044
				],
				[
					-79,
					41
				]
			],
			[
				[
					5426,
					2174
				],
				[
					-49,
					80
				]
			],
			[
				[
					5256,
					2255
				],
				[
					-60,
					82
				]
			],
			[
				[
					5228,
					2338
				],
				[
					5,
					89
				]
			],
			[
				[
					5233,
					2427
				],
				[
					-12,
					56
				]
			],
			[
				[
					5290,
					2520
				],
				[
					31,
					33
				]
			],
			[
				[
					5321,
					2553
				],
				[
					30,
					1
				]
			],
			[
				[
					3143,
					4359
				],
				[
					173,
					-26
				]
			],
			[
				[
					3316,
					4333
				],
				[
					7,
					-122
				]
			],
			[
				[
					3323,
					4211
				],
				[
					-29,
					-29
				]
			],
			[
				[
					3235,
					4158
				],
				[
					20,
					-120
				]
			],
			[
				[
					3130,
					3915
				],
				[
					-23,
					64
				]
			],
			[
				[
					3107,
					3979
				],
				[
					-42,
					35
				],
				[
					26,
					124
				]
			],
			[
				[
					3091,
					4138
				],
				[
					-26,
					51
				]
			],
			[
				[
					3065,
					4189
				],
				[
					-45,
					15
				]
			],
			[
				[
					3020,
					4204
				],
				[
					-18,
					-13
				]
			],
			[
				[
					3002,
					4191
				],
				[
					-10,
					64
				]
			],
			[
				[
					2992,
					4255
				],
				[
					28,
					77
				]
			],
			[
				[
					3020,
					4332
				],
				[
					60,
					4
				]
			],
			[
				[
					2000,
					4887
				],
				[
					95,
					-57
				],
				[
					36,
					-15
				],
				[
					27,
					9
				],
				[
					27,
					-8
				]
			],
			[
				[
					2185,
					4816
				],
				[
					-16,
					-42
				]
			],
			[
				[
					2169,
					4774
				],
				[
					89,
					-64
				],
				[
					18,
					-85
				],
				[
					-30,
					-120
				]
			],
			[
				[
					2246,
					4505
				],
				[
					-10,
					-35
				]
			],
			[
				[
					2236,
					4470
				],
				[
					34,
					-33
				],
				[
					-11,
					-255
				],
				[
					20,
					-31
				]
			],
			[
				[
					2279,
					4151
				],
				[
					-11,
					-62
				]
			],
			[
				[
					2268,
					4089
				],
				[
					-57,
					-11
				]
			],
			[
				[
					2190,
					4057
				],
				[
					-107,
					20
				]
			],
			[
				[
					2019,
					4010
				],
				[
					-135,
					65
				],
				[
					-9,
					44
				],
				[
					47,
					38
				]
			],
			[
				[
					1922,
					4157
				],
				[
					-44,
					47
				]
			],
			[
				[
					1878,
					4204
				],
				[
					-30,
					23
				]
			],
			[
				[
					1848,
					4227
				],
				[
					-17,
					-5
				]
			],
			[
				[
					1831,
					4222
				],
				[
					8,
					51
				]
			],
			[
				[
					1917,
					4450
				],
				[
					-5,
					69
				]
			],
			[
				[
					1842,
					4670
				],
				[
					-30,
					27
				]
			],
			[
				[
					1812,
					4697
				],
				[
					91,
					28
				],
				[
					79,
					56
				]
			],
			[
				[
					1982,
					4781
				],
				[
					-47,
					36
				],
				[
					-9,
					37
				],
				[
					24,
					71
				]
			],
			[
				[
					1950,
					4925
				],
				[
					50,
					-38
				]
			],
			[
				[
					4251,
					4043
				],
				[
					49,
					-80
				]
			],
			[
				[
					4300,
					3963
				],
				[
					-42,
					-52
				]
			],
			[
				[
					4261,
					3793
				],
				[
					-27,
					-16
				]
			],
			[
				[
					4200,
					3815
				],
				[
					-71,
					5
				],
				[
					-17,
					43
				],
				[
					-10,
					79
				]
			],
			[
				[
					4102,
					3942
				],
				[
					-3,
					57
				]
			],
			[
				[
					4099,
					3999
				],
				[
					93,
					10
				]
			],
			[
				[
					4192,
					4009
				],
				[
					34,
					13
				]
			],
			[
				[
					4226,
					4022
				],
				[
					25,
					21
				]
			],
			[
				[
					2124,
					5859
				],
				[
					-7,
					-65
				]
			],
			[
				[
					2117,
					5794
				],
				[
					-22,
					-23
				]
			],
			[
				[
					2095,
					5771
				],
				[
					-92,
					7
				]
			],
			[
				[
					2003,
					5778
				],
				[
					-96,
					21
				]
			],
			[
				[
					1907,
					5799
				],
				[
					-48,
					67
				]
			],
			[
				[
					2034,
					6280
				],
				[
					53,
					36
				]
			],
			[
				[
					7217,
					8101
				],
				[
					-1,
					-5
				]
			],
			[
				[
					7216,
					8096
				],
				[
					-28,
					-11
				]
			],
			[
				[
					6987,
					8292
				],
				[
					194,
					-25
				],
				[
					116,
					62
				],
				[
					83,
					-10
				],
				[
					210,
					309
				],
				[
					96,
					72
				],
				[
					85,
					3
				],
				[
					90,
					-88
				],
				[
					-82,
					-75
				],
				[
					54,
					-178
				],
				[
					-72,
					-106
				],
				[
					-28,
					-128
				],
				[
					-136,
					-37
				],
				[
					-84,
					-82
				]
			],
			[
				[
					6671,
					7398
				],
				[
					81,
					-100
				]
			],
			[
				[
					6752,
					7298
				],
				[
					-12,
					-54
				],
				[
					-113,
					-22
				]
			],
			[
				[
					6627,
					7222
				],
				[
					-30,
					25
				]
			],
			[
				[
					6587,
					7251
				],
				[
					-8,
					57
				]
			],
			[
				[
					6545,
					7387
				],
				[
					28,
					1
				]
			],
			[
				[
					6580,
					7420
				],
				[
					75,
					6
				]
			],
			[
				[
					4082,
					8067
				],
				[
					79,
					13
				],
				[
					62,
					-173
				],
				[
					28,
					-47
				]
			],
			[
				[
					4251,
					7860
				],
				[
					98,
					-137
				]
			],
			[
				[
					4349,
					7723
				],
				[
					-6,
					-41
				],
				[
					-60,
					-152
				]
			],
			[
				[
					4283,
					7530
				],
				[
					-121,
					50
				]
			],
			[
				[
					4162,
					7580
				],
				[
					-41,
					43
				]
			],
			[
				[
					4121,
					7623
				],
				[
					-58,
					185
				]
			],
			[
				[
					4063,
					7808
				],
				[
					-113,
					172
				]
			],
			[
				[
					3950,
					7980
				],
				[
					-138,
					67
				]
			],
			[
				[
					3812,
					8047
				],
				[
					14,
					31
				]
			],
			[
				[
					3826,
					8078
				],
				[
					159,
					111
				],
				[
					27,
					-16
				]
			],
			[
				[
					4012,
					8173
				],
				[
					16,
					-14
				]
			],
			[
				[
					5615,
					6130
				],
				[
					32,
					-92
				]
			],
			[
				[
					5614,
					6034
				],
				[
					67,
					-51
				]
			],
			[
				[
					5740,
					5903
				],
				[
					6,
					-31
				],
				[
					-20,
					-42
				],
				[
					3,
					-35
				],
				[
					-82,
					8
				],
				[
					-56,
					-69
				]
			],
			[
				[
					5483,
					5744
				],
				[
					-33,
					-4
				]
			],
			[
				[
					5379,
					5842
				],
				[
					-17,
					64
				]
			],
			[
				[
					5362,
					5906
				],
				[
					-42,
					144
				]
			],
			[
				[
					5320,
					6050
				],
				[
					23,
					-2
				],
				[
					111,
					53
				],
				[
					-19,
					121
				]
			],
			[
				[
					5435,
					6222
				],
				[
					-18,
					27
				]
			],
			[
				[
					5417,
					6249
				],
				[
					9,
					28
				]
			],
			[
				[
					5448,
					6268
				],
				[
					51,
					14
				]
			],
			[
				[
					3705,
					7481
				],
				[
					72,
					-84
				]
			],
			[
				[
					3777,
					7397
				],
				[
					23,
					-174
				]
			],
			[
				[
					3800,
					7223
				],
				[
					-26,
					-86
				]
			],
			[
				[
					3774,
					7137
				],
				[
					-60,
					-110
				]
			],
			[
				[
					3625,
					7042
				],
				[
					-59,
					29
				]
			],
			[
				[
					3566,
					7071
				],
				[
					-45,
					95
				],
				[
					-63,
					36
				]
			],
			[
				[
					3458,
					7202
				],
				[
					-42,
					65
				]
			],
			[
				[
					3416,
					7267
				],
				[
					-54,
					9
				]
			],
			[
				[
					3362,
					7276
				],
				[
					-10,
					15
				],
				[
					-16,
					78
				],
				[
					59,
					72
				],
				[
					34,
					14
				],
				[
					9,
					21
				]
			],
			[
				[
					3438,
					7476
				],
				[
					122,
					-18
				],
				[
					145,
					23
				]
			],
			[
				[
					6475,
					3951
				],
				[
					27,
					-107
				],
				[
					-75,
					-61
				]
			],
			[
				[
					6427,
					3783
				],
				[
					-161,
					-44
				]
			],
			[
				[
					6266,
					3739
				],
				[
					-59,
					-6
				]
			],
			[
				[
					6207,
					3733
				],
				[
					-13,
					-21
				]
			],
			[
				[
					6194,
					3712
				],
				[
					-47,
					40
				]
			],
			[
				[
					6147,
					3752
				],
				[
					39,
					121
				],
				[
					-59,
					224
				],
				[
					68,
					85
				],
				[
					-67,
					121
				]
			],
			[
				[
					6128,
					4303
				],
				[
					6,
					17
				]
			],
			[
				[
					6134,
					4320
				],
				[
					79,
					49
				],
				[
					38,
					48
				]
			],
			[
				[
					6251,
					4417
				],
				[
					-2,
					-54
				]
			],
			[
				[
					6266,
					4312
				],
				[
					6,
					-25
				]
			],
			[
				[
					7465,
					5394
				],
				[
					37,
					-115
				]
			],
			[
				[
					7502,
					5279
				],
				[
					-24,
					-112
				]
			],
			[
				[
					7478,
					5167
				],
				[
					48,
					-95
				]
			],
			[
				[
					7526,
					5072
				],
				[
					37,
					-1
				]
			],
			[
				[
					7563,
					5071
				],
				[
					-30,
					-73
				]
			],
			[
				[
					7533,
					4998
				],
				[
					2,
					-32
				]
			],
			[
				[
					7535,
					4966
				],
				[
					-105,
					-39
				]
			],
			[
				[
					7430,
					4927
				],
				[
					-24,
					-37
				]
			],
			[
				[
					7406,
					4890
				],
				[
					-99,
					-70
				]
			],
			[
				[
					7307,
					4820
				],
				[
					-39,
					-5
				]
			],
			[
				[
					7189,
					4864
				],
				[
					-50,
					9
				]
			],
			[
				[
					7139,
					4873
				],
				[
					-173,
					131
				]
			],
			[
				[
					6966,
					5004
				],
				[
					-27,
					136
				]
			],
			[
				[
					7088,
					5200
				],
				[
					69,
					20
				]
			],
			[
				[
					7185,
					5383
				],
				[
					27,
					20
				]
			],
			[
				[
					7238,
					5419
				],
				[
					27,
					25
				],
				[
					-1,
					19
				]
			],
			[
				[
					7264,
					5463
				],
				[
					152,
					-18
				],
				[
					49,
					-51
				]
			],
			[
				[
					6210,
					6711
				],
				[
					-4,
					-58
				],
				[
					-127,
					-78
				]
			],
			[
				[
					6079,
					6575
				],
				[
					-75,
					31
				]
			],
			[
				[
					5905,
					6562
				],
				[
					-62,
					131
				]
			],
			[
				[
					5844,
					6711
				],
				[
					55,
					40
				]
			],
			[
				[
					6129,
					6879
				],
				[
					37,
					-66
				],
				[
					50,
					-28
				],
				[
					15,
					-24
				],
				[
					-9,
					-4
				],
				[
					-12,
					-46
				]
			],
			[
				[
					1569,
					5583
				],
				[
					141,
					-113
				],
				[
					130,
					15
				]
			],
			[
				[
					1840,
					5485
				],
				[
					52,
					12
				],
				[
					37,
					-42
				]
			],
			[
				[
					1929,
					5455
				],
				[
					-21,
					-29
				]
			],
			[
				[
					1908,
					5426
				],
				[
					94,
					-33
				]
			],
			[
				[
					2002,
					5393
				],
				[
					13,
					-83
				],
				[
					-12,
					-31
				],
				[
					-14,
					-19
				],
				[
					-31,
					0
				]
			],
			[
				[
					1958,
					5260
				],
				[
					-13,
					5
				]
			],
			[
				[
					1945,
					5265
				],
				[
					1,
					-30
				]
			],
			[
				[
					1946,
					5235
				],
				[
					-67,
					-9
				]
			],
			[
				[
					1879,
					5226
				],
				[
					-73,
					-29
				]
			],
			[
				[
					1806,
					5197
				],
				[
					-46,
					35
				]
			],
			[
				[
					1760,
					5232
				],
				[
					-18,
					-6
				]
			],
			[
				[
					1742,
					5226
				],
				[
					-23,
					-28
				],
				[
					-10,
					-32
				]
			],
			[
				[
					1709,
					5166
				],
				[
					-18,
					-10
				]
			],
			[
				[
					1691,
					5156
				],
				[
					-6,
					25
				]
			],
			[
				[
					1685,
					5181
				],
				[
					-52,
					-17
				]
			],
			[
				[
					1633,
					5164
				],
				[
					-54,
					49
				]
			],
			[
				[
					1529,
					5196
				],
				[
					15,
					19
				]
			],
			[
				[
					1544,
					5215
				],
				[
					-44,
					20
				]
			],
			[
				[
					1451,
					5360
				],
				[
					-46,
					136
				]
			],
			[
				[
					1405,
					5496
				],
				[
					40,
					65
				],
				[
					61,
					20
				],
				[
					21,
					-10
				],
				[
					42,
					12
				]
			],
			[
				[
					2511,
					2231
				],
				[
					-14,
					-37
				]
			],
			[
				[
					2497,
					2194
				],
				[
					15,
					-116
				]
			],
			[
				[
					2512,
					2078
				],
				[
					-65,
					-15
				]
			],
			[
				[
					2345,
					2035
				],
				[
					-19,
					-26
				]
			],
			[
				[
					2234,
					2082
				],
				[
					-5,
					42
				]
			],
			[
				[
					2229,
					2124
				],
				[
					-54,
					1
				],
				[
					9,
					40
				],
				[
					-9,
					9
				]
			],
			[
				[
					2175,
					2174
				],
				[
					31,
					25
				]
			],
			[
				[
					2280,
					2225
				],
				[
					104,
					65
				]
			],
			[
				[
					2384,
					2290
				],
				[
					3,
					-9
				]
			],
			[
				[
					2387,
					2281
				],
				[
					124,
					-50
				]
			],
			[
				[
					1274,
					3909
				],
				[
					-69,
					-15
				]
			],
			[
				[
					1205,
					3894
				],
				[
					-14,
					74
				]
			],
			[
				[
					1191,
					3968
				],
				[
					-127,
					-45
				]
			],
			[
				[
					1064,
					3923
				],
				[
					1,
					82
				]
			],
			[
				[
					1042,
					4006
				],
				[
					-14,
					110
				]
			],
			[
				[
					1028,
					4116
				],
				[
					39,
					18
				]
			],
			[
				[
					1067,
					4134
				],
				[
					31,
					54
				]
			],
			[
				[
					1098,
					4188
				],
				[
					59,
					-2
				]
			],
			[
				[
					1157,
					4186
				],
				[
					3,
					11
				]
			],
			[
				[
					1160,
					4197
				],
				[
					0,
					-10
				],
				[
					8,
					0
				],
				[
					16,
					-47
				],
				[
					35,
					-132
				],
				[
					55,
					-99
				]
			],
			[
				[
					2592,
					6801
				],
				[
					209,
					-18
				]
			],
			[
				[
					2801,
					6783
				],
				[
					17,
					-94
				]
			],
			[
				[
					2818,
					6689
				],
				[
					-221,
					-105
				],
				[
					-37,
					10
				]
			],
			[
				[
					2560,
					6594
				],
				[
					-20,
					-36
				]
			],
			[
				[
					2540,
					6558
				],
				[
					-54,
					-13
				]
			],
			[
				[
					2323,
					6626
				],
				[
					11,
					56
				]
			],
			[
				[
					2419,
					6823
				],
				[
					110,
					62
				]
			],
			[
				[
					2529,
					6885
				],
				[
					17,
					-11
				]
			],
			[
				[
					2546,
					6874
				],
				[
					46,
					-73
				]
			],
			[
				[
					3557,
					4068
				],
				[
					38,
					-5
				]
			],
			[
				[
					3595,
					4063
				],
				[
					19,
					1
				]
			],
			[
				[
					3614,
					4064
				],
				[
					18,
					-36
				]
			],
			[
				[
					3632,
					4028
				],
				[
					30,
					-19
				]
			],
			[
				[
					3662,
					4009
				],
				[
					-6,
					-40
				]
			],
			[
				[
					3489,
					3918
				],
				[
					-55,
					18
				]
			],
			[
				[
					3458,
					4119
				],
				[
					77,
					-21
				]
			],
			[
				[
					3535,
					4098
				],
				[
					22,
					-30
				]
			],
			[
				[
					4347,
					3896
				],
				[
					-57,
					48
				]
			],
			[
				[
					4290,
					3944
				],
				[
					10,
					19
				]
			],
			[
				[
					4251,
					4043
				],
				[
					-25,
					-21
				]
			],
			[
				[
					4192,
					4009
				],
				[
					-41,
					57
				]
			],
			[
				[
					4151,
					4066
				],
				[
					-34,
					123
				]
			],
			[
				[
					4117,
					4189
				],
				[
					7,
					51
				]
			],
			[
				[
					4185,
					4222
				],
				[
					46,
					84
				],
				[
					-35,
					47
				]
			],
			[
				[
					4202,
					4484
				],
				[
					38,
					9
				],
				[
					9,
					28
				]
			],
			[
				[
					4283,
					4524
				],
				[
					111,
					9
				]
			],
			[
				[
					1075,
					1279
				],
				[
					27,
					-20
				],
				[
					56,
					44
				],
				[
					6,
					-10
				],
				[
					37,
					39
				]
			],
			[
				[
					1201,
					1332
				],
				[
					5,
					-62
				]
			],
			[
				[
					1206,
					1270
				],
				[
					77,
					-37
				]
			],
			[
				[
					1283,
					1233
				],
				[
					-5,
					-63
				]
			],
			[
				[
					1251,
					1157
				],
				[
					-3,
					-32
				]
			],
			[
				[
					1274,
					1077
				],
				[
					32,
					-13
				]
			],
			[
				[
					1306,
					1064
				],
				[
					-131,
					-164
				],
				[
					-17,
					-129
				]
			],
			[
				[
					1158,
					771
				],
				[
					-55,
					95
				],
				[
					-89,
					41
				]
			],
			[
				[
					1014,
					907
				],
				[
					-34,
					29
				]
			],
			[
				[
					980,
					936
				],
				[
					-23,
					66
				]
			],
			[
				[
					957,
					1002
				],
				[
					-31,
					99
				]
			],
			[
				[
					926,
					1101
				],
				[
					29,
					76
				],
				[
					-66,
					120
				]
			],
			[
				[
					885,
					1326
				],
				[
					100,
					76
				]
			],
			[
				[
					985,
					1402
				],
				[
					-5,
					-35
				]
			],
			[
				[
					980,
					1367
				],
				[
					95,
					-88
				]
			],
			[
				[
					908,
					1217
				],
				[
					-6,
					-54
				]
			],
			[
				[
					3566,
					7071
				],
				[
					-10,
					-56
				]
			],
			[
				[
					3411,
					6931
				],
				[
					-47,
					-4
				]
			],
			[
				[
					3364,
					6927
				],
				[
					-12,
					6
				]
			],
			[
				[
					3352,
					6933
				],
				[
					5,
					132
				],
				[
					-40,
					69
				]
			],
			[
				[
					3317,
					7134
				],
				[
					3,
					27
				],
				[
					-30,
					92
				]
			],
			[
				[
					3290,
					7253
				],
				[
					72,
					23
				]
			],
			[
				[
					3416,
					7267
				],
				[
					42,
					-65
				]
			],
			[
				[
					3695,
					6854
				],
				[
					30,
					-15
				]
			],
			[
				[
					3725,
					6839
				],
				[
					27,
					-84
				]
			],
			[
				[
					3752,
					6755
				],
				[
					-145,
					-82
				]
			],
			[
				[
					3607,
					6673
				],
				[
					13,
					-45
				]
			],
			[
				[
					3620,
					6628
				],
				[
					-95,
					-72
				]
			],
			[
				[
					3525,
					6556
				],
				[
					-68,
					-45
				]
			],
			[
				[
					3457,
					6511
				],
				[
					-134,
					-66
				],
				[
					-51,
					13
				]
			],
			[
				[
					3272,
					6458
				],
				[
					-55,
					78
				],
				[
					42,
					53
				],
				[
					-37,
					60
				]
			],
			[
				[
					3222,
					6649
				],
				[
					36,
					23
				]
			],
			[
				[
					3258,
					6672
				],
				[
					7,
					62
				],
				[
					44,
					9
				],
				[
					77,
					-14
				]
			],
			[
				[
					3386,
					6729
				],
				[
					85,
					73
				]
			],
			[
				[
					3471,
					6802
				],
				[
					84,
					40
				]
			],
			[
				[
					2829,
					4727
				],
				[
					49,
					-106
				]
			],
			[
				[
					2878,
					4621
				],
				[
					80,
					-14
				]
			],
			[
				[
					2981,
					4568
				],
				[
					18,
					-67
				]
			],
			[
				[
					3003,
					4418
				],
				[
					17,
					-86
				]
			],
			[
				[
					2992,
					4255
				],
				[
					-5,
					-74
				]
			],
			[
				[
					2987,
					4181
				],
				[
					-148,
					-50
				]
			],
			[
				[
					2839,
					4131
				],
				[
					-46,
					-6
				]
			],
			[
				[
					2793,
					4125
				],
				[
					-36,
					15
				]
			],
			[
				[
					2757,
					4140
				],
				[
					-80,
					-28
				]
			],
			[
				[
					2584,
					4081
				],
				[
					-53,
					-14
				]
			],
			[
				[
					2524,
					4105
				],
				[
					-19,
					72
				]
			],
			[
				[
					2505,
					4177
				],
				[
					59,
					55
				],
				[
					43,
					209
				],
				[
					-99,
					90
				]
			],
			[
				[
					2508,
					4531
				],
				[
					-56,
					59
				]
			],
			[
				[
					2452,
					4590
				],
				[
					62,
					78
				]
			],
			[
				[
					2514,
					4668
				],
				[
					164,
					49
				]
			],
			[
				[
					2678,
					4717
				],
				[
					15,
					88
				]
			],
			[
				[
					2693,
					4805
				],
				[
					10,
					13
				]
			],
			[
				[
					2703,
					4818
				],
				[
					126,
					-91
				]
			],
			[
				[
					1646,
					3589
				],
				[
					29,
					-115
				],
				[
					69,
					-88
				]
			],
			[
				[
					1744,
					3386
				],
				[
					49,
					8
				]
			],
			[
				[
					1778,
					3310
				],
				[
					-13,
					-43
				]
			],
			[
				[
					1726,
					3276
				],
				[
					-49,
					4
				]
			],
			[
				[
					1604,
					3232
				],
				[
					-50,
					96
				]
			],
			[
				[
					1554,
					3576
				],
				[
					20,
					-13
				]
			],
			[
				[
					1574,
					3563
				],
				[
					19,
					41
				]
			],
			[
				[
					1593,
					3604
				],
				[
					53,
					-15
				]
			],
			[
				[
					4229,
					6023
				],
				[
					135,
					-115
				],
				[
					61,
					-218
				]
			],
			[
				[
					4425,
					5690
				],
				[
					38,
					4
				]
			],
			[
				[
					4463,
					5694
				],
				[
					18,
					-83
				]
			],
			[
				[
					4481,
					5611
				],
				[
					-49,
					-52
				]
			],
			[
				[
					4432,
					5559
				],
				[
					-55,
					-1
				]
			],
			[
				[
					4377,
					5558
				],
				[
					-85,
					-39
				]
			],
			[
				[
					4292,
					5519
				],
				[
					-36,
					23
				]
			],
			[
				[
					4256,
					5542
				],
				[
					-35,
					-16
				]
			],
			[
				[
					4221,
					5526
				],
				[
					-3,
					28
				],
				[
					-14,
					12
				]
			],
			[
				[
					4204,
					5566
				],
				[
					-116,
					154
				]
			],
			[
				[
					4088,
					5720
				],
				[
					-55,
					84
				],
				[
					50,
					73
				]
			],
			[
				[
					4083,
					5877
				],
				[
					-7,
					135
				],
				[
					66,
					55
				]
			],
			[
				[
					4142,
					6067
				],
				[
					87,
					-44
				]
			],
			[
				[
					4329,
					5331
				],
				[
					34,
					-213
				]
			],
			[
				[
					4363,
					5118
				],
				[
					-98,
					-22
				]
			],
			[
				[
					4220,
					5035
				],
				[
					-114,
					61
				]
			],
			[
				[
					4106,
					5096
				],
				[
					-31,
					66
				]
			],
			[
				[
					4075,
					5162
				],
				[
					38,
					83
				]
			],
			[
				[
					4113,
					5245
				],
				[
					20,
					9
				]
			],
			[
				[
					4133,
					5254
				],
				[
					51,
					27
				]
			],
			[
				[
					4184,
					5281
				],
				[
					34,
					-12
				]
			],
			[
				[
					4218,
					5269
				],
				[
					59,
					52
				]
			],
			[
				[
					4277,
					5321
				],
				[
					52,
					10
				]
			],
			[
				[
					6791,
					6859
				],
				[
					92,
					-7
				]
			],
			[
				[
					6883,
					6852
				],
				[
					-20,
					-48
				]
			],
			[
				[
					6856,
					6730
				],
				[
					19,
					-57
				]
			],
			[
				[
					6878,
					6631
				],
				[
					-60,
					-26
				]
			],
			[
				[
					6818,
					6605
				],
				[
					-37,
					18
				]
			],
			[
				[
					6781,
					6623
				],
				[
					-13,
					-48
				]
			],
			[
				[
					6706,
					6587
				],
				[
					-23,
					77
				],
				[
					33,
					88
				]
			],
			[
				[
					6716,
					6752
				],
				[
					-34,
					83
				]
			],
			[
				[
					6682,
					6835
				],
				[
					17,
					2
				]
			],
			[
				[
					6699,
					6837
				],
				[
					14,
					38
				]
			],
			[
				[
					6713,
					6875
				],
				[
					49,
					3
				],
				[
					29,
					-19
				]
			],
			[
				[
					7600,
					7032
				],
				[
					-2,
					-30
				]
			],
			[
				[
					7478,
					6965
				],
				[
					-44,
					-13
				]
			],
			[
				[
					7247,
					7056
				],
				[
					22,
					93
				]
			],
			[
				[
					7269,
					7149
				],
				[
					23,
					64
				]
			],
			[
				[
					7301,
					7369
				],
				[
					58,
					74
				],
				[
					74,
					-14
				]
			],
			[
				[
					7464,
					7444
				],
				[
					45,
					-1
				]
			],
			[
				[
					7497,
					7482
				],
				[
					86,
					-92
				],
				[
					11,
					-164
				]
			],
			[
				[
					4140,
					7603
				],
				[
					-92,
					-114
				],
				[
					50,
					-107
				],
				[
					104,
					-56
				]
			],
			[
				[
					4202,
					7326
				],
				[
					-43,
					-35
				]
			],
			[
				[
					4159,
					7291
				],
				[
					-11,
					12
				]
			],
			[
				[
					4148,
					7303
				],
				[
					-78,
					-21
				]
			],
			[
				[
					4070,
					7282
				],
				[
					-14,
					27
				]
			],
			[
				[
					4056,
					7309
				],
				[
					-45,
					-53
				],
				[
					-56,
					-38
				],
				[
					-21,
					2
				],
				[
					-68,
					43
				]
			],
			[
				[
					3866,
					7263
				],
				[
					-29,
					9
				]
			],
			[
				[
					3837,
					7272
				],
				[
					-60,
					125
				]
			],
			[
				[
					3777,
					7397
				],
				[
					-27,
					24
				]
			],
			[
				[
					3767,
					7434
				],
				[
					71,
					36
				]
			],
			[
				[
					3838,
					7470
				],
				[
					93,
					49
				]
			],
			[
				[
					3931,
					7519
				],
				[
					13,
					22
				]
			],
			[
				[
					3944,
					7541
				],
				[
					177,
					82
				]
			],
			[
				[
					4121,
					7623
				],
				[
					19,
					-20
				]
			],
			[
				[
					1748,
					250
				],
				[
					-50,
					-93
				],
				[
					-180,
					-71
				],
				[
					-54,
					-86
				],
				[
					-63,
					95
				],
				[
					-106,
					50
				],
				[
					-4,
					60
				],
				[
					35,
					27
				],
				[
					-29,
					32
				],
				[
					10,
					18
				],
				[
					39,
					29
				]
			],
			[
				[
					1632,
					409
				],
				[
					79,
					15
				]
			],
			[
				[
					3800,
					6724
				],
				[
					52,
					-47
				]
			],
			[
				[
					3852,
					6677
				],
				[
					90,
					19
				]
			],
			[
				[
					3942,
					6696
				],
				[
					21,
					-81
				],
				[
					-28,
					-38
				]
			],
			[
				[
					3865,
					6503
				],
				[
					-36,
					-67
				]
			],
			[
				[
					3829,
					6436
				],
				[
					-47,
					3
				]
			],
			[
				[
					3782,
					6439
				],
				[
					-14,
					-16
				]
			],
			[
				[
					3768,
					6423
				],
				[
					-74,
					92
				]
			],
			[
				[
					3694,
					6515
				],
				[
					-82,
					41
				]
			],
			[
				[
					3612,
					6556
				],
				[
					-19,
					-2
				]
			],
			[
				[
					3593,
					6554
				],
				[
					27,
					74
				]
			],
			[
				[
					3607,
					6673
				],
				[
					131,
					62
				]
			],
			[
				[
					3738,
					6735
				],
				[
					62,
					-11
				]
			],
			[
				[
					5333,
					4099
				],
				[
					104,
					-55
				]
			],
			[
				[
					5437,
					4044
				],
				[
					-71,
					-56
				]
			],
			[
				[
					5357,
					3744
				],
				[
					-32,
					-23
				]
			],
			[
				[
					5325,
					3721
				],
				[
					-29,
					13
				]
			],
			[
				[
					5296,
					3734
				],
				[
					-51,
					-70
				]
			],
			[
				[
					4974,
					3610
				],
				[
					-19,
					46
				]
			],
			[
				[
					4955,
					3656
				],
				[
					-24,
					58
				]
			],
			[
				[
					4931,
					3714
				],
				[
					-30,
					96
				]
			],
			[
				[
					4901,
					3810
				],
				[
					16,
					78
				]
			],
			[
				[
					4946,
					3977
				],
				[
					-27,
					81
				]
			],
			[
				[
					4907,
					4094
				],
				[
					67,
					120
				]
			],
			[
				[
					4974,
					4214
				],
				[
					126,
					41
				],
				[
					133,
					-159
				],
				[
					100,
					3
				]
			],
			[
				[
					5741,
					3812
				],
				[
					8,
					27
				]
			],
			[
				[
					5792,
					3789
				],
				[
					-4,
					-36
				]
			],
			[
				[
					5517,
					3382
				],
				[
					-33,
					-17
				]
			],
			[
				[
					5431,
					3450
				],
				[
					-43,
					30
				]
			],
			[
				[
					5407,
					3634
				],
				[
					-59,
					4
				]
			],
			[
				[
					5311,
					3635
				],
				[
					-15,
					99
				]
			],
			[
				[
					5325,
					3721
				],
				[
					60,
					18
				]
			],
			[
				[
					5402,
					3761
				],
				[
					51,
					13
				]
			],
			[
				[
					1946,
					1240
				],
				[
					77,
					-75
				]
			],
			[
				[
					2023,
					1165
				],
				[
					44,
					-53
				],
				[
					83,
					5
				]
			],
			[
				[
					2150,
					1117
				],
				[
					2,
					-52
				]
			],
			[
				[
					2134,
					1028
				],
				[
					-74,
					-64
				]
			],
			[
				[
					1904,
					767
				],
				[
					-32,
					-13
				]
			],
			[
				[
					1782,
					755
				],
				[
					-22,
					14
				]
			],
			[
				[
					1760,
					769
				],
				[
					-2,
					130
				],
				[
					-91,
					-8
				]
			],
			[
				[
					1667,
					891
				],
				[
					-46,
					-22
				]
			],
			[
				[
					1621,
					869
				],
				[
					-13,
					57
				]
			],
			[
				[
					1608,
					926
				],
				[
					18,
					61
				]
			],
			[
				[
					1626,
					987
				],
				[
					-18,
					78
				]
			],
			[
				[
					1608,
					1065
				],
				[
					12,
					-16
				]
			],
			[
				[
					1644,
					1160
				],
				[
					61,
					68
				]
			],
			[
				[
					1588,
					4600
				],
				[
					67,
					-25
				]
			],
			[
				[
					1672,
					4600
				],
				[
					31,
					-24
				]
			],
			[
				[
					1679,
					4327
				],
				[
					-36,
					-89
				]
			],
			[
				[
					1643,
					4238
				],
				[
					-54,
					52
				]
			],
			[
				[
					1589,
					4290
				],
				[
					-21,
					42
				]
			],
			[
				[
					1568,
					4332
				],
				[
					-5,
					43
				]
			],
			[
				[
					1563,
					4375
				],
				[
					-11,
					67
				]
			],
			[
				[
					1552,
					4442
				],
				[
					-48,
					76
				]
			],
			[
				[
					1504,
					4518
				],
				[
					-7,
					45
				]
			],
			[
				[
					1497,
					4563
				],
				[
					-2,
					21
				]
			],
			[
				[
					1495,
					4584
				],
				[
					93,
					16
				]
			],
			[
				[
					2728,
					6124
				],
				[
					-57,
					-208
				]
			],
			[
				[
					2676,
					5902
				],
				[
					-36,
					-25
				]
			],
			[
				[
					2600,
					5778
				],
				[
					-81,
					59
				]
			],
			[
				[
					2497,
					6097
				],
				[
					96,
					24
				]
			],
			[
				[
					2593,
					6121
				],
				[
					34,
					-2
				]
			],
			[
				[
					2627,
					6119
				],
				[
					45,
					62
				]
			],
			[
				[
					2672,
					6181
				],
				[
					95,
					-31
				]
			],
			[
				[
					5186,
					4789
				],
				[
					16,
					-87
				],
				[
					-48,
					-46
				],
				[
					-9,
					-104
				]
			],
			[
				[
					5145,
					4552
				],
				[
					-18,
					29
				]
			],
			[
				[
					5127,
					4581
				],
				[
					-123,
					-36
				]
			],
			[
				[
					5004,
					4545
				],
				[
					-71,
					83
				]
			],
			[
				[
					4933,
					4628
				],
				[
					-3,
					16
				]
			],
			[
				[
					4930,
					4644
				],
				[
					-66,
					109
				]
			],
			[
				[
					4898,
					4761
				],
				[
					47,
					9
				]
			],
			[
				[
					5032,
					4817
				],
				[
					54,
					-9
				]
			],
			[
				[
					5162,
					4835
				],
				[
					24,
					-46
				]
			],
			[
				[
					1896,
					3625
				],
				[
					30,
					-22
				]
			],
			[
				[
					1926,
					3603
				],
				[
					-84,
					-10
				]
			],
			[
				[
					1836,
					3413
				],
				[
					-92,
					-27
				]
			],
			[
				[
					1646,
					3589
				],
				[
					27,
					31
				]
			],
			[
				[
					1673,
					3620
				],
				[
					82,
					45
				]
			],
			[
				[
					1755,
					3665
				],
				[
					30,
					-1
				],
				[
					68,
					54
				]
			],
			[
				[
					1853,
					3718
				],
				[
					16,
					-2
				]
			],
			[
				[
					1869,
					3716
				],
				[
					27,
					-91
				]
			],
			[
				[
					1568,
					4332
				],
				[
					-14,
					-61
				]
			],
			[
				[
					1554,
					4271
				],
				[
					-98,
					-1
				],
				[
					13,
					-203
				]
			],
			[
				[
					1469,
					4067
				],
				[
					-19,
					9
				]
			],
			[
				[
					1434,
					4049
				],
				[
					-152,
					-6
				]
			],
			[
				[
					1226,
					4002
				],
				[
					-5,
					5
				],
				[
					-61,
					190
				]
			],
			[
				[
					1160,
					4197
				],
				[
					10,
					29
				],
				[
					59,
					30
				]
			],
			[
				[
					1229,
					4256
				],
				[
					13,
					32
				]
			],
			[
				[
					1242,
					4288
				],
				[
					13,
					44
				],
				[
					153,
					-29
				]
			],
			[
				[
					1408,
					4303
				],
				[
					49,
					55
				]
			],
			[
				[
					1522,
					4357
				],
				[
					41,
					18
				]
			],
			[
				[
					4204,
					5566
				],
				[
					14,
					-22
				]
			],
			[
				[
					4218,
					5544
				],
				[
					-31,
					-9
				],
				[
					-62,
					-45
				],
				[
					-49,
					-9
				]
			],
			[
				[
					4076,
					5481
				],
				[
					-58,
					-30
				]
			],
			[
				[
					3993,
					5459
				],
				[
					-4,
					47
				]
			],
			[
				[
					3858,
					5581
				],
				[
					20,
					5
				]
			],
			[
				[
					3985,
					5752
				],
				[
					103,
					-32
				]
			],
			[
				[
					8433,
					5612
				],
				[
					-59,
					-40
				]
			],
			[
				[
					8374,
					5572
				],
				[
					-74,
					59
				]
			],
			[
				[
					8300,
					5631
				],
				[
					19,
					-108
				]
			],
			[
				[
					8319,
					5523
				],
				[
					-21,
					-33
				]
			],
			[
				[
					8298,
					5490
				],
				[
					-83,
					-78
				]
			],
			[
				[
					8215,
					5412
				],
				[
					-49,
					-37
				]
			],
			[
				[
					8166,
					5375
				],
				[
					-33,
					38
				]
			],
			[
				[
					8203,
					5629
				],
				[
					3,
					28
				]
			],
			[
				[
					8206,
					5657
				],
				[
					-66,
					106
				]
			],
			[
				[
					8136,
					5791
				],
				[
					24,
					23
				],
				[
					3,
					22
				]
			],
			[
				[
					8263,
					6093
				],
				[
					48,
					20
				],
				[
					27,
					-5
				],
				[
					68,
					45
				],
				[
					102,
					-38
				],
				[
					90,
					-106
				],
				[
					-36,
					-75
				],
				[
					50,
					-64
				],
				[
					-154,
					-149
				],
				[
					-25,
					-109
				]
			],
			[
				[
					8106,
					5340
				],
				[
					166,
					-186
				]
			],
			[
				[
					8272,
					5154
				],
				[
					32,
					-23
				]
			],
			[
				[
					8304,
					5131
				],
				[
					40,
					2
				]
			],
			[
				[
					8344,
					5133
				],
				[
					88,
					-84
				],
				[
					-129,
					-178
				],
				[
					-28,
					-138
				],
				[
					-90,
					-4
				]
			],
			[
				[
					8185,
					4729
				],
				[
					-340,
					142
				]
			],
			[
				[
					7845,
					4871
				],
				[
					5,
					54
				]
			],
			[
				[
					7850,
					4925
				],
				[
					36,
					8
				]
			],
			[
				[
					7886,
					4933
				],
				[
					25,
					5
				]
			],
			[
				[
					7911,
					4938
				],
				[
					21,
					11
				]
			],
			[
				[
					7932,
					4949
				],
				[
					43,
					-12
				]
			],
			[
				[
					7975,
					4937
				],
				[
					24,
					207
				]
			],
			[
				[
					7999,
					5144
				],
				[
					-7,
					46
				]
			],
			[
				[
					7992,
					5190
				],
				[
					4,
					18
				]
			],
			[
				[
					8035,
					5223
				],
				[
					33,
					32
				]
			],
			[
				[
					8088,
					5336
				],
				[
					18,
					4
				]
			],
			[
				[
					6535,
					3546
				],
				[
					12,
					-99
				]
			],
			[
				[
					6580,
					3396
				],
				[
					-90,
					-46
				]
			],
			[
				[
					6490,
					3350
				],
				[
					58,
					-84
				]
			],
			[
				[
					6548,
					3266
				],
				[
					-70,
					-21
				]
			],
			[
				[
					6478,
					3245
				],
				[
					-85,
					-78
				],
				[
					-51,
					38
				]
			],
			[
				[
					6342,
					3205
				],
				[
					-51,
					64
				]
			],
			[
				[
					6210,
					3208
				],
				[
					-36,
					30
				]
			],
			[
				[
					6297,
					3371
				],
				[
					-38,
					47
				]
			],
			[
				[
					6162,
					3519
				],
				[
					-32,
					33
				]
			],
			[
				[
					6138,
					3574
				],
				[
					47,
					42
				]
			],
			[
				[
					6165,
					3703
				],
				[
					-9,
					37
				]
			],
			[
				[
					6156,
					3740
				],
				[
					38,
					-28
				]
			],
			[
				[
					6207,
					3733
				],
				[
					59,
					6
				]
			],
			[
				[
					6427,
					3783
				],
				[
					87,
					-38
				],
				[
					46,
					-82
				]
			],
			[
				[
					1158,
					771
				],
				[
					49,
					24
				]
			],
			[
				[
					1207,
					795
				],
				[
					-21,
					-70
				]
			],
			[
				[
					1186,
					725
				],
				[
					-97,
					-53
				]
			],
			[
				[
					1055,
					639
				],
				[
					-110,
					30
				],
				[
					-109,
					-39
				],
				[
					-66,
					154
				],
				[
					95,
					134
				],
				[
					27,
					151
				],
				[
					34,
					32
				]
			],
			[
				[
					957,
					1002
				],
				[
					23,
					-66
				]
			],
			[
				[
					980,
					936
				],
				[
					34,
					-29
				]
			],
			[
				[
					868,
					965
				],
				[
					-99,
					-168
				],
				[
					-54,
					86
				],
				[
					153,
					82
				]
			],
			[
				[
					4844,
					4720
				],
				[
					86,
					-76
				]
			],
			[
				[
					4933,
					4628
				],
				[
					-43,
					19
				]
			],
			[
				[
					4890,
					4647
				],
				[
					2,
					-11
				]
			],
			[
				[
					4892,
					4636
				],
				[
					-43,
					-21
				]
			],
			[
				[
					4849,
					4615
				],
				[
					-16,
					-20
				]
			],
			[
				[
					4833,
					4595
				],
				[
					-19,
					-67
				]
			],
			[
				[
					4814,
					4528
				],
				[
					-57,
					9
				]
			],
			[
				[
					4757,
					4537
				],
				[
					-19,
					54
				],
				[
					-8,
					-4
				],
				[
					-3,
					8
				]
			],
			[
				[
					4727,
					4595
				],
				[
					28,
					9
				]
			],
			[
				[
					4718,
					4750
				],
				[
					16,
					48
				]
			],
			[
				[
					4734,
					4798
				],
				[
					14,
					14
				]
			],
			[
				[
					4748,
					4812
				],
				[
					22,
					-23
				]
			],
			[
				[
					3933,
					4351
				],
				[
					-12,
					-14
				]
			],
			[
				[
					4124,
					4240
				],
				[
					-7,
					-51
				]
			],
			[
				[
					4117,
					4189
				],
				[
					34,
					-123
				]
			],
			[
				[
					4151,
					4066
				],
				[
					-52,
					-67
				]
			],
			[
				[
					4102,
					3942
				],
				[
					16,
					-40
				],
				[
					-5,
					-43
				]
			],
			[
				[
					3996,
					3757
				],
				[
					-42,
					-23
				]
			],
			[
				[
					3886,
					3929
				],
				[
					-64,
					22
				]
			],
			[
				[
					3738,
					3875
				],
				[
					13,
					-20
				]
			],
			[
				[
					3751,
					3855
				],
				[
					-1,
					-20
				]
			],
			[
				[
					3717,
					3920
				],
				[
					12,
					36
				]
			],
			[
				[
					3668,
					4003
				],
				[
					-6,
					6
				]
			],
			[
				[
					3632,
					4028
				],
				[
					25,
					67
				]
			],
			[
				[
					3657,
					4095
				],
				[
					21,
					157
				]
			],
			[
				[
					3678,
					4252
				],
				[
					78,
					-12
				]
			],
			[
				[
					3803,
					4315
				],
				[
					20,
					24
				],
				[
					59,
					11
				],
				[
					18,
					-8
				],
				[
					33,
					9
				]
			],
			[
				[
					1671,
					5871
				],
				[
					53,
					30
				]
			],
			[
				[
					1819,
					5889
				],
				[
					88,
					-90
				]
			],
			[
				[
					1907,
					5799
				],
				[
					96,
					-21
				]
			],
			[
				[
					2095,
					5771
				],
				[
					55,
					-16
				]
			],
			[
				[
					2150,
					5755
				],
				[
					8,
					-97
				]
			],
			[
				[
					2158,
					5658
				],
				[
					-166,
					-100
				],
				[
					-50,
					-68
				]
			],
			[
				[
					1942,
					5490
				],
				[
					-13,
					-35
				]
			],
			[
				[
					1929,
					5455
				],
				[
					-40,
					42
				],
				[
					-49,
					-12
				]
			],
			[
				[
					1569,
					5583
				],
				[
					-41,
					-13
				],
				[
					-20,
					11
				],
				[
					-34,
					-10
				]
			],
			[
				[
					1477,
					5937
				],
				[
					50,
					9
				]
			],
			[
				[
					1541,
					5959
				],
				[
					125,
					-109
				]
			],
			[
				[
					6147,
					3752
				],
				[
					9,
					-12
				]
			],
			[
				[
					6156,
					3740
				],
				[
					-62,
					-15
				]
			],
			[
				[
					6026,
					3809
				],
				[
					-18,
					74
				]
			],
			[
				[
					6000,
					4266
				],
				[
					62,
					44
				]
			],
			[
				[
					6062,
					4310
				],
				[
					66,
					-7
				]
			],
			[
				[
					6468,
					8082
				],
				[
					153,
					-37
				]
			],
			[
				[
					6753,
					8051
				],
				[
					71,
					-81
				]
			],
			[
				[
					6835,
					7862
				],
				[
					-95,
					36
				],
				[
					-39,
					-2
				],
				[
					-49,
					-25
				]
			],
			[
				[
					6652,
					7871
				],
				[
					-23,
					-35
				]
			],
			[
				[
					6629,
					7836
				],
				[
					-39,
					-24
				],
				[
					-98,
					-41
				]
			],
			[
				[
					6492,
					7771
				],
				[
					-24,
					61
				],
				[
					8,
					40
				],
				[
					-21,
					10
				],
				[
					-51,
					111
				],
				[
					64,
					89
				]
			],
			[
				[
					4934,
					7635
				],
				[
					-96,
					86
				]
			],
			[
				[
					4838,
					7721
				],
				[
					29,
					92
				]
			],
			[
				[
					4930,
					8172
				],
				[
					50,
					-26
				],
				[
					18,
					-103
				],
				[
					90,
					-122
				],
				[
					-138,
					-5
				],
				[
					-16,
					-281
				]
			],
			[
				[
					1595,
					1721
				],
				[
					8,
					-11
				]
			],
			[
				[
					1582,
					1643
				],
				[
					-8,
					-70
				]
			],
			[
				[
					1592,
					1460
				],
				[
					18,
					-4
				]
			],
			[
				[
					1610,
					1456
				],
				[
					-2,
					-11
				],
				[
					-32,
					7
				],
				[
					-50,
					-20
				],
				[
					-78,
					79
				],
				[
					-51,
					-20
				]
			],
			[
				[
					1397,
					1491
				],
				[
					-55,
					10
				]
			],
			[
				[
					1342,
					1501
				],
				[
					11,
					111
				]
			],
			[
				[
					1353,
					1612
				],
				[
					49,
					13
				]
			],
			[
				[
					1542,
					1765
				],
				[
					51,
					12
				]
			],
			[
				[
					3950,
					7980
				],
				[
					113,
					-172
				]
			],
			[
				[
					3944,
					7541
				],
				[
					-13,
					-22
				]
			],
			[
				[
					3838,
					7470
				],
				[
					-67,
					8
				]
			],
			[
				[
					3636,
					7762
				],
				[
					-48,
					119
				]
			],
			[
				[
					3588,
					7881
				],
				[
					51,
					64
				],
				[
					98,
					18
				],
				[
					89,
					115
				]
			],
			[
				[
					3826,
					8078
				],
				[
					-14,
					-31
				]
			],
			[
				[
					1879,
					5226
				],
				[
					67,
					9
				]
			],
			[
				[
					1946,
					5235
				],
				[
					10,
					-66
				]
			],
			[
				[
					1956,
					5169
				],
				[
					22,
					-1
				]
			],
			[
				[
					1978,
					5168
				],
				[
					57,
					-129
				]
			],
			[
				[
					2035,
					5039
				],
				[
					-7,
					-14
				]
			],
			[
				[
					2028,
					5025
				],
				[
					-75,
					-85
				]
			],
			[
				[
					1953,
					4940
				],
				[
					-20,
					44
				],
				[
					-34,
					12
				],
				[
					-44,
					-7
				],
				[
					-65,
					-35
				],
				[
					-40,
					9
				],
				[
					-14,
					29
				],
				[
					-1,
					75
				]
			],
			[
				[
					1735,
					5067
				],
				[
					-26,
					106
				],
				[
					33,
					53
				]
			],
			[
				[
					1760,
					5232
				],
				[
					46,
					-35
				]
			],
			[
				[
					4844,
					3836
				],
				[
					57,
					-26
				]
			],
			[
				[
					4931,
					3714
				],
				[
					-9,
					-40
				]
			],
			[
				[
					4680,
					3694
				],
				[
					-12,
					38
				]
			],
			[
				[
					4628,
					3752
				],
				[
					-33,
					-14
				]
			],
			[
				[
					4491,
					3746
				],
				[
					-18,
					45
				]
			],
			[
				[
					4488,
					3805
				],
				[
					7,
					38
				]
			],
			[
				[
					4515,
					3824
				],
				[
					34,
					18
				],
				[
					10,
					20
				],
				[
					-20,
					81
				]
			],
			[
				[
					4539,
					3943
				],
				[
					18,
					-11
				]
			],
			[
				[
					4557,
					3932
				],
				[
					14,
					-12
				]
			],
			[
				[
					3336,
					7361
				],
				[
					26,
					-85
				]
			],
			[
				[
					3290,
					7253
				],
				[
					22,
					-73
				]
			],
			[
				[
					3312,
					7180
				],
				[
					-84,
					-15
				]
			],
			[
				[
					3228,
					7165
				],
				[
					-156,
					83
				],
				[
					-39,
					74
				]
			],
			[
				[
					3033,
					7322
				],
				[
					45,
					50
				],
				[
					88,
					-15
				]
			],
			[
				[
					3216,
					7408
				],
				[
					49,
					19
				]
			],
			[
				[
					4961,
					5978
				],
				[
					37,
					4
				]
			],
			[
				[
					4998,
					5982
				],
				[
					20,
					-20
				]
			],
			[
				[
					5018,
					5962
				],
				[
					80,
					-81
				]
			],
			[
				[
					5019,
					5714
				],
				[
					-11,
					-81
				]
			],
			[
				[
					5069,
					5607
				],
				[
					-7,
					-29
				]
			],
			[
				[
					5062,
					5578
				],
				[
					-37,
					-56
				]
			],
			[
				[
					5025,
					5522
				],
				[
					-53,
					-19
				]
			],
			[
				[
					4972,
					5503
				],
				[
					-119,
					-4
				]
			],
			[
				[
					4853,
					5499
				],
				[
					-24,
					74
				]
			],
			[
				[
					4829,
					5573
				],
				[
					-48,
					8
				]
			],
			[
				[
					4781,
					5581
				],
				[
					-57,
					28
				]
			],
			[
				[
					4724,
					5609
				],
				[
					-38,
					38
				]
			],
			[
				[
					4686,
					5647
				],
				[
					-18,
					2
				]
			],
			[
				[
					4668,
					5649
				],
				[
					8,
					70
				]
			],
			[
				[
					4676,
					5719
				],
				[
					-57,
					146
				]
			],
			[
				[
					4619,
					5865
				],
				[
					-11,
					55
				]
			],
			[
				[
					4608,
					5920
				],
				[
					27,
					11
				]
			],
			[
				[
					4635,
					5931
				],
				[
					88,
					-24
				],
				[
					111,
					-9
				],
				[
					12,
					18
				],
				[
					-14,
					40
				]
			],
			[
				[
					4832,
					5956
				],
				[
					20,
					51
				]
			],
			[
				[
					4852,
					6007
				],
				[
					22,
					-2
				]
			],
			[
				[
					4874,
					6005
				],
				[
					87,
					-27
				]
			],
			[
				[
					2705,
					3948
				],
				[
					123,
					28
				]
			],
			[
				[
					2828,
					3976
				],
				[
					8,
					-23
				]
			],
			[
				[
					2836,
					3953
				],
				[
					-22,
					-58
				],
				[
					126,
					-43
				]
			],
			[
				[
					2905,
					3795
				],
				[
					-59,
					-97
				]
			],
			[
				[
					2846,
					3698
				],
				[
					-37,
					-4
				]
			],
			[
				[
					2660,
					3855
				],
				[
					5,
					62
				]
			],
			[
				[
					2691,
					3972
				],
				[
					14,
					-24
				]
			],
			[
				[
					6149,
					7119
				],
				[
					107,
					-15
				]
			],
			[
				[
					6256,
					7104
				],
				[
					2,
					-41
				]
			],
			[
				[
					6258,
					7063
				],
				[
					-53,
					-118
				]
			],
			[
				[
					6205,
					6945
				],
				[
					-27,
					-57
				]
			],
			[
				[
					6178,
					6888
				],
				[
					-11,
					8
				]
			],
			[
				[
					6167,
					6896
				],
				[
					-98,
					64
				]
			],
			[
				[
					6050,
					7014
				],
				[
					-84,
					53
				]
			],
			[
				[
					5966,
					7067
				],
				[
					37,
					37
				]
			],
			[
				[
					6009,
					7160
				],
				[
					140,
					-41
				]
			],
			[
				[
					8433,
					5612
				],
				[
					67,
					-120
				],
				[
					-54,
					-141
				],
				[
					17,
					-80
				],
				[
					116,
					20
				],
				[
					-19,
					-82
				],
				[
					-119,
					-17
				],
				[
					-97,
					-59
				]
			],
			[
				[
					8304,
					5131
				],
				[
					-32,
					23
				]
			],
			[
				[
					8106,
					5340
				],
				[
					60,
					35
				]
			],
			[
				[
					8166,
					5375
				],
				[
					49,
					37
				]
			],
			[
				[
					8298,
					5490
				],
				[
					21,
					33
				]
			],
			[
				[
					8300,
					5631
				],
				[
					74,
					-59
				]
			],
			[
				[
					4472,
					6289
				],
				[
					83,
					-1
				]
			],
			[
				[
					4735,
					6210
				],
				[
					23,
					-1
				],
				[
					27,
					-22
				],
				[
					43,
					-66
				],
				[
					-3,
					-61
				]
			],
			[
				[
					4825,
					6060
				],
				[
					7,
					-104
				]
			],
			[
				[
					4832,
					5956
				],
				[
					11,
					-55
				],
				[
					-92,
					0
				],
				[
					-116,
					30
				]
			],
			[
				[
					4635,
					5931
				],
				[
					-78,
					103
				]
			],
			[
				[
					4557,
					6034
				],
				[
					-108,
					-22
				],
				[
					-72,
					99
				]
			],
			[
				[
					4377,
					6111
				],
				[
					13,
					42
				],
				[
					-16,
					16
				],
				[
					10,
					12
				]
			],
			[
				[
					4384,
					6181
				],
				[
					11,
					-9
				]
			],
			[
				[
					4365,
					6304
				],
				[
					75,
					11
				]
			],
			[
				[
					6665,
					8364
				],
				[
					-81,
					-13
				]
			],
			[
				[
					6448,
					8281
				],
				[
					8,
					19
				]
			],
			[
				[
					6484,
					8682
				],
				[
					-21,
					34
				],
				[
					230,
					124
				],
				[
					111,
					-91
				],
				[
					29,
					-182
				],
				[
					-18,
					-83
				],
				[
					10,
					-193
				],
				[
					-144,
					28
				]
			],
			[
				[
					2059,
					2369
				],
				[
					50,
					-17
				]
			],
			[
				[
					2171,
					2167
				],
				[
					4,
					7
				]
			],
			[
				[
					2229,
					2124
				],
				[
					2,
					-60
				]
			],
			[
				[
					2102,
					2053
				],
				[
					-53,
					56
				]
			],
			[
				[
					1950,
					2005
				],
				[
					-23,
					-19
				]
			],
			[
				[
					1796,
					1976
				],
				[
					-26,
					39
				]
			],
			[
				[
					1650,
					2175
				],
				[
					-22,
					64
				]
			],
			[
				[
					1628,
					2239
				],
				[
					101,
					47
				],
				[
					123,
					-3
				]
			],
			[
				[
					1852,
					2283
				],
				[
					77,
					78
				]
			],
			[
				[
					1929,
					2361
				],
				[
					130,
					8
				]
			],
			[
				[
					1643,
					2556
				],
				[
					32,
					-56
				],
				[
					80,
					-48
				]
			],
			[
				[
					1755,
					2452
				],
				[
					119,
					-124
				]
			],
			[
				[
					1874,
					2328
				],
				[
					-22,
					-45
				]
			],
			[
				[
					1628,
					2239
				],
				[
					-81,
					7
				]
			],
			[
				[
					1487,
					2464
				],
				[
					-14,
					32
				]
			],
			[
				[
					1451,
					2501
				],
				[
					9,
					32
				]
			],
			[
				[
					1460,
					2533
				],
				[
					42,
					18
				]
			],
			[
				[
					1502,
					2551
				],
				[
					-1,
					8
				]
			],
			[
				[
					1501,
					2559
				],
				[
					111,
					12
				]
			],
			[
				[
					1233,
					2008
				],
				[
					-7,
					-32
				]
			],
			[
				[
					1261,
					1794
				],
				[
					-65,
					-83
				]
			],
			[
				[
					1196,
					1711
				],
				[
					-3,
					-23
				]
			],
			[
				[
					1193,
					1688
				],
				[
					-41,
					20
				]
			],
			[
				[
					1052,
					1747
				],
				[
					-38,
					81
				]
			],
			[
				[
					1014,
					1828
				],
				[
					102,
					101
				],
				[
					-2,
					71
				]
			],
			[
				[
					1114,
					2000
				],
				[
					119,
					8
				]
			],
			[
				[
					3272,
					6458
				],
				[
					67,
					-19
				]
			],
			[
				[
					3339,
					6439
				],
				[
					-1,
					-38
				]
			],
			[
				[
					2948,
					6077
				],
				[
					-42,
					37
				]
			],
			[
				[
					2906,
					6114
				],
				[
					-65,
					134
				]
			],
			[
				[
					2841,
					6248
				],
				[
					9,
					51
				]
			],
			[
				[
					2850,
					6299
				],
				[
					68,
					198
				]
			],
			[
				[
					2918,
					6497
				],
				[
					6,
					96
				]
			],
			[
				[
					2924,
					6593
				],
				[
					279,
					34
				]
			],
			[
				[
					3203,
					6627
				],
				[
					19,
					22
				]
			],
			[
				[
					1709,
					5166
				],
				[
					26,
					-99
				]
			],
			[
				[
					1735,
					5067
				],
				[
					3,
					-83
				],
				[
					18,
					-26
				],
				[
					39,
					-3
				],
				[
					85,
					41
				],
				[
					60,
					-20
				],
				[
					13,
					-36
				]
			],
			[
				[
					1953,
					4940
				],
				[
					-27,
					-104
				],
				[
					16,
					-28
				],
				[
					40,
					-27
				]
			],
			[
				[
					1812,
					4697
				],
				[
					-56,
					78
				]
			],
			[
				[
					1756,
					4775
				],
				[
					-40,
					-3
				]
			],
			[
				[
					1716,
					4772
				],
				[
					-20,
					55
				]
			],
			[
				[
					1613,
					4902
				],
				[
					40,
					88
				]
			],
			[
				[
					1620,
					5036
				],
				[
					13,
					128
				]
			],
			[
				[
					1685,
					5181
				],
				[
					6,
					-25
				]
			],
			[
				[
					2384,
					5072
				],
				[
					-125,
					-91
				]
			],
			[
				[
					2259,
					4981
				],
				[
					18,
					-35
				]
			],
			[
				[
					2277,
					4946
				],
				[
					-84,
					-60
				]
			],
			[
				[
					2193,
					4886
				],
				[
					-13,
					-25
				]
			],
			[
				[
					2180,
					4861
				],
				[
					5,
					-45
				]
			],
			[
				[
					2000,
					4887
				],
				[
					-50,
					38
				]
			],
			[
				[
					1950,
					4925
				],
				[
					3,
					15
				]
			],
			[
				[
					2028,
					5025
				],
				[
					62,
					0
				],
				[
					48,
					12
				],
				[
					70,
					45
				]
			],
			[
				[
					2208,
					5082
				],
				[
					140,
					32
				]
			],
			[
				[
					2348,
					5114
				],
				[
					36,
					-42
				]
			],
			[
				[
					4793,
					7048
				],
				[
					-39,
					56
				]
			],
			[
				[
					4947,
					7427
				],
				[
					177,
					-85
				],
				[
					14,
					-179
				],
				[
					-345,
					-115
				]
			],
			[
				[
					2869,
					5146
				],
				[
					24,
					-40
				]
			],
			[
				[
					2893,
					5106
				],
				[
					69,
					-45
				]
			],
			[
				[
					3056,
					4893
				],
				[
					-52,
					-22
				]
			],
			[
				[
					3039,
					4717
				],
				[
					-1,
					-73
				]
			],
			[
				[
					2958,
					4607
				],
				[
					-80,
					14
				]
			],
			[
				[
					2829,
					4727
				],
				[
					-98,
					87
				]
			],
			[
				[
					2693,
					5064
				],
				[
					7,
					101
				]
			],
			[
				[
					2700,
					5165
				],
				[
					52,
					24
				]
			],
			[
				[
					2759,
					5212
				],
				[
					26,
					-3
				]
			],
			[
				[
					6029,
					5010
				],
				[
					15,
					-2
				]
			],
			[
				[
					6044,
					5008
				],
				[
					4,
					-30
				]
			],
			[
				[
					6048,
					4978
				],
				[
					-64,
					-99
				],
				[
					61,
					-136
				],
				[
					-81,
					-16
				]
			],
			[
				[
					5964,
					4727
				],
				[
					-34,
					11
				]
			],
			[
				[
					5780,
					4748
				],
				[
					-89,
					27
				]
			],
			[
				[
					5691,
					4775
				],
				[
					20,
					30
				]
			],
			[
				[
					5711,
					4805
				],
				[
					-50,
					88
				],
				[
					24,
					77
				]
			],
			[
				[
					5685,
					4970
				],
				[
					31,
					40
				]
			],
			[
				[
					5716,
					5010
				],
				[
					126,
					-13
				],
				[
					50,
					30
				]
			],
			[
				[
					5892,
					5027
				],
				[
					27,
					16
				]
			],
			[
				[
					5919,
					5043
				],
				[
					80,
					14
				]
			],
			[
				[
					5999,
					5057
				],
				[
					30,
					-47
				]
			],
			[
				[
					3408,
					6901
				],
				[
					63,
					-99
				]
			],
			[
				[
					3386,
					6729
				],
				[
					-111,
					14
				],
				[
					-19,
					-40
				],
				[
					2,
					-31
				]
			],
			[
				[
					3258,
					6672
				],
				[
					-23,
					-23
				],
				[
					-18,
					0
				],
				[
					-14,
					-22
				]
			],
			[
				[
					2924,
					6593
				],
				[
					-8,
					22
				],
				[
					-9,
					-6
				],
				[
					-14,
					20
				],
				[
					-52,
					27
				],
				[
					4,
					89
				]
			],
			[
				[
					2845,
					6745
				],
				[
					75,
					-24
				],
				[
					84,
					30
				],
				[
					110,
					134
				]
			],
			[
				[
					3114,
					6885
				],
				[
					184,
					-13
				]
			],
			[
				[
					3298,
					6872
				],
				[
					11,
					32
				]
			],
			[
				[
					3309,
					6904
				],
				[
					43,
					29
				]
			],
			[
				[
					3364,
					6927
				],
				[
					54,
					-5
				]
			],
			[
				[
					2006,
					5538
				],
				[
					22,
					-50
				],
				[
					108,
					-50
				]
			],
			[
				[
					2136,
					5438
				],
				[
					56,
					-112
				]
			],
			[
				[
					2192,
					5326
				],
				[
					136,
					-4
				]
			],
			[
				[
					2328,
					5322
				],
				[
					9,
					-59
				]
			],
			[
				[
					2337,
					5263
				],
				[
					59,
					-88
				]
			],
			[
				[
					2396,
					5175
				],
				[
					-48,
					-61
				]
			],
			[
				[
					2348,
					5114
				],
				[
					-140,
					-32
				]
			],
			[
				[
					2208,
					5082
				],
				[
					-69,
					-44
				],
				[
					-47,
					-12
				],
				[
					-57,
					13
				]
			],
			[
				[
					2035,
					5039
				],
				[
					-57,
					129
				]
			],
			[
				[
					1956,
					5169
				],
				[
					-11,
					96
				]
			],
			[
				[
					1958,
					5260
				],
				[
					12,
					14
				],
				[
					20,
					-13
				],
				[
					25,
					41
				],
				[
					-13,
					91
				]
			],
			[
				[
					1908,
					5426
				],
				[
					34,
					64
				]
			],
			[
				[
					1942,
					5490
				],
				[
					64,
					48
				]
			],
			[
				[
					2647,
					2710
				],
				[
					93,
					49
				],
				[
					130,
					-17
				]
			],
			[
				[
					2870,
					2742
				],
				[
					-14,
					-21
				]
			],
			[
				[
					2915,
					2497
				],
				[
					71,
					-67
				]
			],
			[
				[
					3036,
					2375
				],
				[
					4,
					-85
				]
			],
			[
				[
					3040,
					2290
				],
				[
					35,
					-129
				]
			],
			[
				[
					3075,
					2161
				],
				[
					-150,
					-167
				]
			],
			[
				[
					2846,
					2058
				],
				[
					-61,
					-1
				]
			],
			[
				[
					2668,
					2038
				],
				[
					-8,
					-13
				]
			],
			[
				[
					2600,
					2002
				],
				[
					-22,
					42
				]
			],
			[
				[
					2541,
					2011
				],
				[
					-44,
					183
				]
			],
			[
				[
					2511,
					2231
				],
				[
					-124,
					50
				]
			],
			[
				[
					2384,
					2290
				],
				[
					-68,
					43
				]
			],
			[
				[
					2278,
					2375
				],
				[
					-33,
					84
				]
			],
			[
				[
					2161,
					2900
				],
				[
					-1,
					26
				]
			],
			[
				[
					2160,
					2926
				],
				[
					34,
					18
				]
			],
			[
				[
					2194,
					2944
				],
				[
					32,
					-38
				]
			],
			[
				[
					2226,
					2906
				],
				[
					127,
					100
				]
			],
			[
				[
					2353,
					3006
				],
				[
					15,
					-41
				],
				[
					82,
					-30
				],
				[
					50,
					-41
				],
				[
					126,
					-104
				],
				[
					16,
					-28
				],
				[
					5,
					-52
				]
			],
			[
				[
					2505,
					4177
				],
				[
					-59,
					-14
				]
			],
			[
				[
					2345,
					4119
				],
				[
					-46,
					-37
				]
			],
			[
				[
					2299,
					4082
				],
				[
					-20,
					69
				]
			],
			[
				[
					2236,
					4470
				],
				[
					54,
					6
				]
			],
			[
				[
					2290,
					4476
				],
				[
					104,
					37
				]
			],
			[
				[
					2394,
					4513
				],
				[
					114,
					18
				]
			],
			[
				[
					4070,
					7282
				],
				[
					78,
					21
				]
			],
			[
				[
					4159,
					7291
				],
				[
					64,
					19
				]
			],
			[
				[
					4223,
					7310
				],
				[
					58,
					-38
				]
			],
			[
				[
					4281,
					7272
				],
				[
					17,
					2
				]
			],
			[
				[
					4298,
					7274
				],
				[
					58,
					-23
				]
			],
			[
				[
					4356,
					7251
				],
				[
					63,
					-2
				]
			],
			[
				[
					4419,
					7249
				],
				[
					0,
					-108
				]
			],
			[
				[
					4430,
					7155
				],
				[
					58,
					-52
				],
				[
					32,
					-14
				]
			],
			[
				[
					4405,
					6836
				],
				[
					-46,
					-4
				]
			],
			[
				[
					4231,
					6879
				],
				[
					-37,
					38
				]
			],
			[
				[
					4083,
					6896
				],
				[
					-70,
					46
				]
			],
			[
				[
					4013,
					6942
				],
				[
					-21,
					67
				]
			],
			[
				[
					3992,
					7009
				],
				[
					3,
					12
				]
			],
			[
				[
					3995,
					7021
				],
				[
					28,
					59
				]
			],
			[
				[
					4023,
					7080
				],
				[
					-53,
					147
				]
			],
			[
				[
					3970,
					7227
				],
				[
					86,
					82
				]
			],
			[
				[
					4781,
					5581
				],
				[
					48,
					-8
				]
			],
			[
				[
					4853,
					5499
				],
				[
					119,
					4
				]
			],
			[
				[
					4972,
					5503
				],
				[
					82,
					-49
				]
			],
			[
				[
					5054,
					5454
				],
				[
					59,
					-70
				]
			],
			[
				[
					4905,
					5140
				],
				[
					7,
					-72
				]
			],
			[
				[
					4912,
					5068
				],
				[
					-103,
					-7
				]
			],
			[
				[
					4809,
					5061
				],
				[
					-114,
					-64
				]
			],
			[
				[
					4606,
					5152
				],
				[
					-53,
					13
				]
			],
			[
				[
					4538,
					5183
				],
				[
					-74,
					10
				]
			],
			[
				[
					4464,
					5193
				],
				[
					-31,
					-55
				]
			],
			[
				[
					4433,
					5138
				],
				[
					-67,
					3
				]
			],
			[
				[
					4366,
					5141
				],
				[
					-30,
					196
				]
			],
			[
				[
					4336,
					5337
				],
				[
					35,
					-2
				]
			],
			[
				[
					4371,
					5335
				],
				[
					59,
					35
				]
			],
			[
				[
					4430,
					5370
				],
				[
					31,
					28
				]
			],
			[
				[
					4461,
					5398
				],
				[
					-53,
					136
				]
			],
			[
				[
					4408,
					5534
				],
				[
					24,
					25
				]
			],
			[
				[
					4481,
					5611
				],
				[
					0,
					28
				]
			],
			[
				[
					4481,
					5639
				],
				[
					82,
					-55
				],
				[
					78,
					43
				]
			],
			[
				[
					4641,
					5627
				],
				[
					27,
					22
				]
			],
			[
				[
					4686,
					5647
				],
				[
					38,
					-38
				]
			],
			[
				[
					2745,
					7260
				],
				[
					42,
					-28
				]
			],
			[
				[
					2787,
					7232
				],
				[
					-41,
					-55
				]
			],
			[
				[
					2868,
					7020
				],
				[
					-61,
					-130
				],
				[
					-6,
					-107
				]
			],
			[
				[
					2592,
					6801
				],
				[
					-46,
					73
				]
			],
			[
				[
					2529,
					6885
				],
				[
					-37,
					-7
				]
			],
			[
				[
					2453,
					7148
				],
				[
					-67,
					65
				]
			],
			[
				[
					2386,
					7213
				],
				[
					32,
					113
				],
				[
					67,
					81
				],
				[
					109,
					16
				]
			],
			[
				[
					1975,
					3064
				],
				[
					28,
					-88
				],
				[
					108,
					-43
				]
			],
			[
				[
					2110,
					2910
				],
				[
					22,
					-72
				]
			],
			[
				[
					2051,
					2791
				],
				[
					-31,
					-64
				]
			],
			[
				[
					2020,
					2727
				],
				[
					-101,
					3
				]
			],
			[
				[
					1919,
					2730
				],
				[
					-87,
					44
				]
			],
			[
				[
					1899,
					3069
				],
				[
					43,
					46
				]
			],
			[
				[
					1942,
					3115
				],
				[
					33,
					-51
				]
			],
			[
				[
					1610,
					1456
				],
				[
					35,
					-18
				]
			],
			[
				[
					1723,
					1444
				],
				[
					10,
					-16
				]
			],
			[
				[
					1661,
					1281
				],
				[
					-10,
					12
				]
			],
			[
				[
					1541,
					1266
				],
				[
					-157,
					38
				]
			],
			[
				[
					1303,
					1250
				],
				[
					-20,
					-17
				]
			],
			[
				[
					1206,
					1270
				],
				[
					-9,
					82
				]
			],
			[
				[
					1197,
					1352
				],
				[
					33,
					27
				]
			],
			[
				[
					1230,
					1379
				],
				[
					140,
					26
				]
			],
			[
				[
					1370,
					1405
				],
				[
					-7,
					44
				]
			],
			[
				[
					1363,
					1449
				],
				[
					34,
					42
				]
			],
			[
				[
					3422,
					5194
				],
				[
					26,
					-16
				]
			],
			[
				[
					3455,
					5140
				],
				[
					25,
					11
				]
			],
			[
				[
					3536,
					5105
				],
				[
					-6,
					-21
				]
			],
			[
				[
					3585,
					4796
				],
				[
					-69,
					-30
				]
			],
			[
				[
					3516,
					4766
				],
				[
					-101,
					46
				]
			],
			[
				[
					3343,
					4958
				],
				[
					-34,
					-15
				],
				[
					-4,
					20
				],
				[
					-13,
					5
				],
				[
					-3,
					10
				]
			],
			[
				[
					3289,
					4978
				],
				[
					24,
					13
				]
			],
			[
				[
					3389,
					5032
				],
				[
					19,
					61
				]
			],
			[
				[
					3408,
					5168
				],
				[
					14,
					26
				]
			],
			[
				[
					1599,
					1080
				],
				[
					9,
					-15
				]
			],
			[
				[
					1608,
					1065
				],
				[
					18,
					-78
				]
			],
			[
				[
					1608,
					926
				],
				[
					6,
					-18
				]
			],
			[
				[
					1614,
					908
				],
				[
					-25,
					-17
				],
				[
					-16,
					9
				],
				[
					-26,
					-30
				],
				[
					6,
					-71
				],
				[
					-56,
					-93
				]
			],
			[
				[
					1497,
					706
				],
				[
					0,
					-28
				]
			],
			[
				[
					1415,
					663
				],
				[
					-74,
					16
				]
			],
			[
				[
					1323,
					663
				],
				[
					-37,
					6
				]
			],
			[
				[
					1262,
					702
				],
				[
					-32,
					6
				]
			],
			[
				[
					1134,
					681
				],
				[
					52,
					44
				]
			],
			[
				[
					1207,
					795
				],
				[
					-49,
					-24
				]
			],
			[
				[
					1306,
					1064
				],
				[
					6,
					69
				]
			],
			[
				[
					3558,
					3629
				],
				[
					27,
					27
				]
			],
			[
				[
					3621,
					3641
				],
				[
					26,
					19
				]
			],
			[
				[
					3647,
					3660
				],
				[
					32,
					-32
				]
			],
			[
				[
					3679,
					3628
				],
				[
					1,
					-69
				]
			],
			[
				[
					3680,
					3559
				],
				[
					25,
					-2
				]
			],
			[
				[
					3705,
					3586
				],
				[
					38,
					-49
				]
			],
			[
				[
					3743,
					3537
				],
				[
					1,
					-45
				]
			],
			[
				[
					3720,
					3427
				],
				[
					-21,
					-41
				]
			],
			[
				[
					3699,
					3386
				],
				[
					0,
					33
				]
			],
			[
				[
					3626,
					3352
				],
				[
					0,
					75
				]
			],
			[
				[
					3626,
					3427
				],
				[
					-30,
					33
				]
			],
			[
				[
					3443,
					3390
				],
				[
					-16,
					66
				]
			],
			[
				[
					3427,
					3456
				],
				[
					4,
					57
				]
			],
			[
				[
					3449,
					3614
				],
				[
					-3,
					15
				]
			],
			[
				[
					3509,
					3675
				],
				[
					36,
					-37
				]
			],
			[
				[
					4377,
					5558
				],
				[
					31,
					-24
				]
			],
			[
				[
					4461,
					5398
				],
				[
					-31,
					-28
				]
			],
			[
				[
					4371,
					5335
				],
				[
					-35,
					2
				]
			],
			[
				[
					4336,
					5337
				],
				[
					-7,
					-6
				]
			],
			[
				[
					4277,
					5321
				],
				[
					-59,
					-52
				]
			],
			[
				[
					4184,
					5281
				],
				[
					-51,
					-27
				]
			],
			[
				[
					4113,
					5245
				],
				[
					-60,
					-34
				]
			],
			[
				[
					4053,
					5211
				],
				[
					-43,
					131
				]
			],
			[
				[
					4010,
					5342
				],
				[
					12,
					89
				]
			],
			[
				[
					4022,
					5431
				],
				[
					54,
					50
				]
			],
			[
				[
					4218,
					5544
				],
				[
					3,
					-18
				]
			],
			[
				[
					4256,
					5542
				],
				[
					36,
					-23
				]
			],
			[
				[
					5415,
					4796
				],
				[
					59,
					-14
				],
				[
					118,
					34
				]
			],
			[
				[
					5592,
					4816
				],
				[
					60,
					-51
				]
			],
			[
				[
					5652,
					4765
				],
				[
					22,
					-26
				]
			],
			[
				[
					5605,
					4366
				],
				[
					-59,
					24
				]
			],
			[
				[
					5546,
					4390
				],
				[
					-165,
					91
				]
			],
			[
				[
					5381,
					4481
				],
				[
					-73,
					-14
				],
				[
					-26,
					7
				],
				[
					-17,
					-10
				],
				[
					-24,
					7
				],
				[
					-45,
					41
				]
			],
			[
				[
					5196,
					4512
				],
				[
					-34,
					11
				]
			],
			[
				[
					5162,
					4523
				],
				[
					-17,
					29
				]
			],
			[
				[
					5321,
					4809
				],
				[
					28,
					-27
				]
			],
			[
				[
					6457,
					7107
				],
				[
					30,
					-6
				]
			],
			[
				[
					6487,
					7101
				],
				[
					30,
					-99
				],
				[
					62,
					14
				],
				[
					62,
					-73
				]
			],
			[
				[
					6641,
					6943
				],
				[
					56,
					-3
				],
				[
					22,
					-26
				],
				[
					-8,
					-58
				],
				[
					-12,
					-19
				]
			],
			[
				[
					6682,
					6835
				],
				[
					34,
					-83
				]
			],
			[
				[
					6716,
					6752
				],
				[
					-33,
					-85
				],
				[
					-14,
					-88
				]
			],
			[
				[
					6628,
					6445
				],
				[
					-50,
					-44
				],
				[
					-46,
					-21
				],
				[
					-32,
					1
				],
				[
					-25,
					14
				],
				[
					-10,
					-22
				],
				[
					-33,
					-13
				]
			],
			[
				[
					6417,
					6385
				],
				[
					-14,
					14
				]
			],
			[
				[
					6354,
					6374
				],
				[
					-15,
					-19
				]
			],
			[
				[
					6045,
					6565
				],
				[
					34,
					10
				]
			],
			[
				[
					6210,
					6711
				],
				[
					21,
					62
				],
				[
					-57,
					32
				],
				[
					-41,
					69
				],
				[
					34,
					22
				]
			],
			[
				[
					6178,
					6888
				],
				[
					27,
					57
				]
			],
			[
				[
					6258,
					7063
				],
				[
					23,
					52
				]
			],
			[
				[
					6281,
					7115
				],
				[
					47,
					15
				]
			],
			[
				[
					6328,
					7130
				],
				[
					102,
					-1
				]
			],
			[
				[
					6888,
					5113
				],
				[
					78,
					-109
				]
			],
			[
				[
					7139,
					4873
				],
				[
					19,
					-42
				]
			],
			[
				[
					7070,
					4807
				],
				[
					30,
					-54
				]
			],
			[
				[
					7130,
					4704
				],
				[
					-63,
					-106
				]
			],
			[
				[
					7021,
					4507
				],
				[
					-88,
					37
				]
			],
			[
				[
					6702,
					4603
				],
				[
					-75,
					-7
				]
			],
			[
				[
					6814,
					5122
				],
				[
					62,
					4
				]
			],
			[
				[
					1760,
					769
				],
				[
					14,
					-61
				]
			],
			[
				[
					1618,
					489
				],
				[
					-21,
					-11
				]
			],
			[
				[
					1602,
					487
				],
				[
					-90,
					25
				]
			],
			[
				[
					1540,
					570
				],
				[
					-54,
					50
				]
			],
			[
				[
					1502,
					662
				],
				[
					-5,
					44
				]
			],
			[
				[
					1614,
					908
				],
				[
					7,
					-39
				]
			],
			[
				[
					1621,
					869
				],
				[
					46,
					22
				]
			],
			[
				[
					2953,
					7058
				],
				[
					37,
					-64
				],
				[
					95,
					-27
				]
			],
			[
				[
					3085,
					6967
				],
				[
					45,
					-34
				]
			],
			[
				[
					3130,
					6933
				],
				[
					1,
					-20
				]
			],
			[
				[
					3131,
					6913
				],
				[
					22,
					-19
				]
			],
			[
				[
					3153,
					6894
				],
				[
					-39,
					-9
				]
			],
			[
				[
					2845,
					6745
				],
				[
					-44,
					38
				]
			],
			[
				[
					2922,
					7062
				],
				[
					31,
					-4
				]
			],
			[
				[
					6921,
					7793
				],
				[
					-52,
					-72
				]
			],
			[
				[
					6869,
					7721
				],
				[
					-7,
					-29
				]
			],
			[
				[
					6841,
					7691
				],
				[
					-39,
					9
				]
			],
			[
				[
					6800,
					7677
				],
				[
					-31,
					-43
				]
			],
			[
				[
					6683,
					7708
				],
				[
					-72,
					25
				]
			],
			[
				[
					6611,
					7733
				],
				[
					-114,
					-14
				]
			],
			[
				[
					6491,
					7734
				],
				[
					-36,
					13
				]
			],
			[
				[
					6455,
					7747
				],
				[
					20,
					21
				]
			],
			[
				[
					6475,
					7768
				],
				[
					50,
					11
				],
				[
					40,
					29
				],
				[
					64,
					28
				]
			],
			[
				[
					6652,
					7871
				],
				[
					73,
					28
				],
				[
					90,
					-26
				],
				[
					83,
					-43
				],
				[
					23,
					-37
				]
			],
			[
				[
					5955,
					5252
				],
				[
					102,
					-23
				]
			],
			[
				[
					6057,
					5229
				],
				[
					10,
					-14
				]
			],
			[
				[
					6067,
					5215
				],
				[
					55,
					2
				],
				[
					37,
					-136
				]
			],
			[
				[
					6159,
					5081
				],
				[
					-86,
					-15
				]
			],
			[
				[
					6073,
					5066
				],
				[
					-29,
					-58
				]
			],
			[
				[
					6029,
					5010
				],
				[
					-30,
					47
				]
			],
			[
				[
					5919,
					5043
				],
				[
					-27,
					-16
				]
			],
			[
				[
					5716,
					5010
				],
				[
					-73,
					-26
				]
			],
			[
				[
					5643,
					4984
				],
				[
					-30,
					67
				]
			],
			[
				[
					5613,
					5051
				],
				[
					-3,
					75
				]
			],
			[
				[
					5610,
					5126
				],
				[
					16,
					50
				]
			],
			[
				[
					5626,
					5176
				],
				[
					37,
					9
				]
			],
			[
				[
					5663,
					5185
				],
				[
					90,
					64
				],
				[
					154,
					31
				]
			],
			[
				[
					5907,
					5280
				],
				[
					48,
					-28
				]
			],
			[
				[
					6656,
					6380
				],
				[
					109,
					-18
				],
				[
					89,
					-101
				]
			],
			[
				[
					6854,
					6261
				],
				[
					70,
					-133
				]
			],
			[
				[
					6783,
					6122
				],
				[
					-89,
					36
				]
			],
			[
				[
					6633,
					6143
				],
				[
					-64,
					-34
				]
			],
			[
				[
					6463,
					6371
				],
				[
					55,
					6
				],
				[
					84,
					39
				],
				[
					54,
					-36
				]
			],
			[
				[
					4194,
					2422
				],
				[
					-39,
					-33
				]
			],
			[
				[
					3819,
					2390
				],
				[
					0,
					17
				]
			],
			[
				[
					3778,
					2455
				],
				[
					-39,
					-1
				]
			],
			[
				[
					3739,
					2454
				],
				[
					-6,
					10
				],
				[
					3,
					10
				]
			],
			[
				[
					3877,
					2604
				],
				[
					83,
					-40
				]
			],
			[
				[
					4036,
					2604
				],
				[
					76,
					38
				]
			],
			[
				[
					4112,
					2642
				],
				[
					42,
					-22
				]
			],
			[
				[
					3185,
					1649
				],
				[
					26,
					-43
				]
			],
			[
				[
					3211,
					1606
				],
				[
					-79,
					-201
				]
			],
			[
				[
					3132,
					1405
				],
				[
					83,
					-151
				],
				[
					-30,
					-6
				],
				[
					-101,
					26
				]
			],
			[
				[
					3015,
					1244
				],
				[
					-54,
					51
				]
			],
			[
				[
					2961,
					1295
				],
				[
					-119,
					-113
				]
			],
			[
				[
					2765,
					1304
				],
				[
					33,
					-1
				]
			],
			[
				[
					2804,
					1672
				],
				[
					39,
					44
				]
			],
			[
				[
					2865,
					1746
				],
				[
					80,
					-41
				],
				[
					64,
					52
				]
			],
			[
				[
					3009,
					1757
				],
				[
					75,
					-83
				]
			],
			[
				[
					1020,
					5269
				],
				[
					-19,
					-31
				]
			],
			[
				[
					1001,
					5238
				],
				[
					17,
					-64
				],
				[
					179,
					-132
				],
				[
					-12,
					-65
				]
			],
			[
				[
					1185,
					4977
				],
				[
					-45,
					-6
				]
			],
			[
				[
					778,
					4789
				],
				[
					-57,
					49
				],
				[
					-14,
					89
				]
			],
			[
				[
					752,
					4963
				],
				[
					7,
					67
				],
				[
					19,
					21
				],
				[
					62,
					40
				],
				[
					41,
					2
				]
			],
			[
				[
					892,
					5129
				],
				[
					18,
					32
				]
			],
			[
				[
					901,
					5173
				],
				[
					-27,
					71
				]
			],
			[
				[
					911,
					5300
				],
				[
					58,
					-54
				]
			],
			[
				[
					939,
					3393
				],
				[
					65,
					-51
				]
			],
			[
				[
					1135,
					3149
				],
				[
					14,
					-41
				]
			],
			[
				[
					1149,
					3108
				],
				[
					-39,
					-29
				]
			],
			[
				[
					952,
					3118
				],
				[
					-27,
					20
				]
			],
			[
				[
					925,
					3138
				],
				[
					-25,
					-7
				]
			],
			[
				[
					806,
					3112
				],
				[
					-29,
					-16
				]
			],
			[
				[
					777,
					3096
				],
				[
					-29,
					22
				]
			],
			[
				[
					763,
					3131
				],
				[
					-40,
					47
				]
			],
			[
				[
					670,
					3237
				],
				[
					47,
					68
				],
				[
					-1,
					105
				]
			],
			[
				[
					716,
					3410
				],
				[
					84,
					-73
				],
				[
					49,
					38
				],
				[
					27,
					48
				]
			],
			[
				[
					899,
					3432
				],
				[
					40,
					-39
				]
			],
			[
				[
					1219,
					5304
				],
				[
					87,
					-73
				]
			],
			[
				[
					1366,
					5199
				],
				[
					-56,
					-22
				]
			],
			[
				[
					1312,
					4983
				],
				[
					-8,
					-30
				],
				[
					-40,
					-27
				],
				[
					-73,
					35
				],
				[
					-6,
					16
				]
			],
			[
				[
					1001,
					5238
				],
				[
					76,
					-7
				]
			],
			[
				[
					1167,
					5337
				],
				[
					26,
					44
				]
			],
			[
				[
					1193,
					5381
				],
				[
					26,
					-77
				]
			],
			[
				[
					2411,
					3129
				],
				[
					13,
					-48
				],
				[
					-71,
					-75
				]
			],
			[
				[
					2226,
					2906
				],
				[
					-32,
					38
				]
			],
			[
				[
					2160,
					2926
				],
				[
					-49,
					7
				]
			],
			[
				[
					1975,
					3064
				],
				[
					9,
					65
				]
			],
			[
				[
					2019,
					3144
				],
				[
					0,
					-7
				]
			],
			[
				[
					2219,
					3252
				],
				[
					37,
					-6
				],
				[
					65,
					74
				],
				[
					21,
					2
				],
				[
					19,
					-17
				],
				[
					-16,
					-53
				],
				[
					2,
					-56
				],
				[
					64,
					-67
				]
			],
			[
				[
					1497,
					3856
				],
				[
					87,
					-19
				]
			],
			[
				[
					1584,
					3837
				],
				[
					122,
					-11
				],
				[
					4,
					-45
				],
				[
					23,
					-59
				]
			],
			[
				[
					1733,
					3722
				],
				[
					33,
					5
				],
				[
					13,
					-40
				],
				[
					20,
					0
				],
				[
					5,
					-12
				]
			],
			[
				[
					1804,
					3675
				],
				[
					-49,
					-10
				]
			],
			[
				[
					1673,
					3620
				],
				[
					-80,
					-16
				]
			],
			[
				[
					1574,
					3563
				],
				[
					-32,
					22
				]
			],
			[
				[
					1505,
					3614
				],
				[
					-57,
					3
				],
				[
					-161,
					154
				]
			],
			[
				[
					1287,
					3771
				],
				[
					194,
					107
				]
			],
			[
				[
					1481,
					3878
				],
				[
					16,
					-22
				]
			],
			[
				[
					5627,
					5254
				],
				[
					-5,
					-23
				]
			],
			[
				[
					5622,
					5231
				],
				[
					4,
					-55
				]
			],
			[
				[
					5610,
					5126
				],
				[
					3,
					-75
				]
			],
			[
				[
					5643,
					4984
				],
				[
					42,
					-14
				]
			],
			[
				[
					5711,
					4805
				],
				[
					-59,
					-40
				]
			],
			[
				[
					5592,
					4816
				],
				[
					-48,
					-10
				]
			],
			[
				[
					5504,
					4832
				],
				[
					-32,
					50
				]
			],
			[
				[
					5475,
					5130
				],
				[
					-24,
					12
				]
			],
			[
				[
					5451,
					5142
				],
				[
					18,
					9
				],
				[
					-2,
					49
				],
				[
					20,
					40
				]
			],
			[
				[
					5487,
					5240
				],
				[
					78,
					4
				]
			],
			[
				[
					5565,
					5244
				],
				[
					62,
					10
				]
			],
			[
				[
					3020,
					4204
				],
				[
					45,
					-15
				]
			],
			[
				[
					3065,
					4189
				],
				[
					26,
					-51
				]
			],
			[
				[
					3107,
					3979
				],
				[
					3,
					-51
				]
			],
			[
				[
					2986,
					3895
				],
				[
					-46,
					-43
				]
			],
			[
				[
					2836,
					3953
				],
				[
					-8,
					23
				]
			],
			[
				[
					2705,
					3948
				],
				[
					26,
					60
				]
			],
			[
				[
					2729,
					4095
				],
				[
					28,
					45
				]
			],
			[
				[
					2793,
					4125
				],
				[
					46,
					6
				]
			],
			[
				[
					2987,
					4181
				],
				[
					15,
					10
				]
			],
			[
				[
					1643,
					4238
				],
				[
					185,
					13
				]
			],
			[
				[
					1828,
					4251
				],
				[
					3,
					-29
				]
			],
			[
				[
					1848,
					4227
				],
				[
					30,
					-23
				]
			],
			[
				[
					1922,
					4157
				],
				[
					-41,
					-26
				],
				[
					-8,
					-31
				],
				[
					16,
					-29
				],
				[
					109,
					-47
				]
			],
			[
				[
					1998,
					4024
				],
				[
					-17,
					-39
				],
				[
					-28,
					-22
				],
				[
					-28,
					-3
				]
			],
			[
				[
					1925,
					3960
				],
				[
					-129,
					-49
				]
			],
			[
				[
					1796,
					3911
				],
				[
					-2,
					-71
				]
			],
			[
				[
					1794,
					3840
				],
				[
					-210,
					-3
				]
			],
			[
				[
					1497,
					3856
				],
				[
					-24,
					33
				]
			],
			[
				[
					1522,
					4038
				],
				[
					-53,
					29
				]
			],
			[
				[
					1554,
					4271
				],
				[
					35,
					19
				]
			],
			[
				[
					2049,
					3702
				],
				[
					-123,
					-99
				]
			],
			[
				[
					1896,
					3625
				],
				[
					-27,
					91
				]
			],
			[
				[
					1853,
					3718
				],
				[
					-49,
					-43
				]
			],
			[
				[
					1733,
					3722
				],
				[
					-26,
					101
				],
				[
					87,
					17
				]
			],
			[
				[
					1796,
					3911
				],
				[
					129,
					49
				]
			],
			[
				[
					1925,
					3960
				],
				[
					43,
					11
				],
				[
					30,
					53
				]
			],
			[
				[
					1998,
					4024
				],
				[
					58,
					-54
				],
				[
					10,
					-31
				],
				[
					-8,
					-50
				],
				[
					-70,
					-121
				],
				[
					12,
					-33
				],
				[
					49,
					-33
				]
			],
			[
				[
					3193,
					2419
				],
				[
					-11,
					-25
				]
			],
			[
				[
					3238,
					2379
				],
				[
					36,
					16
				],
				[
					33,
					-18
				]
			],
			[
				[
					3307,
					2377
				],
				[
					-22,
					-24
				],
				[
					-9,
					-34
				]
			],
			[
				[
					3276,
					2319
				],
				[
					-91,
					-155
				]
			],
			[
				[
					3185,
					2164
				],
				[
					-31,
					-4
				]
			],
			[
				[
					3154,
					2160
				],
				[
					-79,
					1
				]
			],
			[
				[
					3040,
					2290
				],
				[
					3,
					53
				]
			],
			[
				[
					3142,
					2394
				],
				[
					32,
					44
				]
			],
			[
				[
					4155,
					6067
				],
				[
					-13,
					0
				]
			],
			[
				[
					4083,
					5877
				],
				[
					-86,
					-67
				]
			],
			[
				[
					3890,
					5989
				],
				[
					-9,
					-4
				]
			],
			[
				[
					3774,
					6018
				],
				[
					-22,
					1
				]
			],
			[
				[
					3752,
					6019
				],
				[
					-14,
					138
				]
			],
			[
				[
					3738,
					6157
				],
				[
					40,
					78
				]
			],
			[
				[
					3778,
					6235
				],
				[
					44,
					46
				],
				[
					-76,
					113
				]
			],
			[
				[
					3746,
					6394
				],
				[
					36,
					45
				]
			],
			[
				[
					3829,
					6436
				],
				[
					108,
					3
				]
			],
			[
				[
					548,
					1913
				],
				[
					-8,
					-29
				]
			],
			[
				[
					540,
					1884
				],
				[
					63,
					-7
				]
			],
			[
				[
					603,
					1877
				],
				[
					149,
					17
				]
			],
			[
				[
					752,
					1894
				],
				[
					2,
					-49
				]
			],
			[
				[
					817,
					1451
				],
				[
					-48,
					-71
				]
			],
			[
				[
					760,
					1384
				],
				[
					-74,
					-42
				],
				[
					-114,
					204
				],
				[
					-101,
					-4
				],
				[
					-97,
					40
				],
				[
					-13,
					172
				],
				[
					-58,
					111
				],
				[
					52,
					52
				],
				[
					-15,
					130
				],
				[
					95,
					-20
				]
			],
			[
				[
					7828,
					6291
				],
				[
					31,
					-125
				],
				[
					79,
					-14
				]
			],
			[
				[
					7938,
					6152
				],
				[
					20,
					-21
				]
			],
			[
				[
					7539,
					5906
				],
				[
					-47,
					-30
				]
			],
			[
				[
					7445,
					5845
				],
				[
					-28,
					194
				]
			],
			[
				[
					7417,
					6039
				],
				[
					64,
					3
				],
				[
					90,
					89
				],
				[
					19,
					84
				]
			],
			[
				[
					7590,
					6215
				],
				[
					42,
					-32
				],
				[
					33,
					3
				],
				[
					11,
					20
				],
				[
					100,
					61
				]
			],
			[
				[
					7776,
					6267
				],
				[
					57,
					72
				]
			],
			[
				[
					7833,
					6339
				],
				[
					-5,
					-48
				]
			],
			[
				[
					7660,
					6324
				],
				[
					83,
					13
				]
			],
			[
				[
					7743,
					6337
				],
				[
					-10,
					-42
				]
			],
			[
				[
					7733,
					6295
				],
				[
					20,
					-38
				],
				[
					-99,
					-74
				],
				[
					-55,
					16
				],
				[
					-9,
					16
				]
			],
			[
				[
					7417,
					6039
				],
				[
					16,
					-189
				]
			],
			[
				[
					7433,
					5850
				],
				[
					-17,
					30
				]
			],
			[
				[
					7416,
					5880
				],
				[
					-43,
					2
				]
			],
			[
				[
					7373,
					5882
				],
				[
					-9,
					-10
				]
			],
			[
				[
					7364,
					5872
				],
				[
					-8,
					51
				]
			],
			[
				[
					7356,
					5923
				],
				[
					-47,
					44
				]
			],
			[
				[
					7295,
					6106
				],
				[
					-61,
					37
				]
			],
			[
				[
					7234,
					6143
				],
				[
					27,
					27
				]
			],
			[
				[
					7388,
					6283
				],
				[
					37,
					41
				]
			],
			[
				[
					7448,
					6355
				],
				[
					47,
					44
				]
			],
			[
				[
					7535,
					6405
				],
				[
					17,
					-21
				]
			],
			[
				[
					1072,
					2718
				],
				[
					82,
					15
				]
			],
			[
				[
					1106,
					2611
				],
				[
					39,
					-107
				]
			],
			[
				[
					1045,
					2496
				],
				[
					-69,
					-39
				]
			],
			[
				[
					940,
					2412
				],
				[
					-13,
					13
				]
			],
			[
				[
					927,
					2425
				],
				[
					-95,
					7
				]
			],
			[
				[
					783,
					2440
				],
				[
					-20,
					25
				]
			],
			[
				[
					763,
					2465
				],
				[
					20,
					12
				]
			],
			[
				[
					783,
					2477
				],
				[
					-19,
					58
				],
				[
					85,
					79
				]
			],
			[
				[
					849,
					2614
				],
				[
					66,
					44
				]
			],
			[
				[
					983,
					2760
				],
				[
					35,
					-29
				]
			],
			[
				[
					3317,
					3303
				],
				[
					21,
					-45
				]
			],
			[
				[
					3338,
					3258
				],
				[
					28,
					-129
				]
			],
			[
				[
					3382,
					3107
				],
				[
					30,
					-53
				]
			],
			[
				[
					3412,
					3054
				],
				[
					-25,
					-36
				],
				[
					-93,
					-53
				],
				[
					-77,
					-9
				]
			],
			[
				[
					3217,
					2956
				],
				[
					-60,
					-14
				]
			],
			[
				[
					3157,
					2942
				],
				[
					-22,
					-6
				]
			],
			[
				[
					3135,
					2936
				],
				[
					-88,
					-11
				]
			],
			[
				[
					3047,
					2925
				],
				[
					43,
					159
				]
			],
			[
				[
					3090,
					3084
				],
				[
					25,
					29
				]
			],
			[
				[
					3115,
					3113
				],
				[
					-32,
					44
				]
			],
			[
				[
					3083,
					3157
				],
				[
					43,
					23
				]
			],
			[
				[
					3093,
					3252
				],
				[
					59,
					43
				]
			],
			[
				[
					3152,
					3295
				],
				[
					85,
					20
				]
			],
			[
				[
					3237,
					3315
				],
				[
					80,
					-12
				]
			],
			[
				[
					4618,
					3248
				],
				[
					49,
					1
				]
			],
			[
				[
					4695,
					2995
				],
				[
					-33,
					-40
				]
			],
			[
				[
					4662,
					2955
				],
				[
					-55,
					32
				]
			],
			[
				[
					4520,
					2955
				],
				[
					-86,
					5
				]
			],
			[
				[
					4434,
					2960
				],
				[
					-59,
					55
				]
			],
			[
				[
					4375,
					3015
				],
				[
					-29,
					-24
				]
			],
			[
				[
					4217,
					2943
				],
				[
					-38,
					46
				]
			],
			[
				[
					4170,
					3054
				],
				[
					-23,
					25
				]
			],
			[
				[
					4248,
					3228
				],
				[
					91,
					78
				]
			],
			[
				[
					4339,
					3306
				],
				[
					93,
					-76
				]
			],
			[
				[
					773,
					3885
				],
				[
					86,
					-93
				]
			],
			[
				[
					877,
					3686
				],
				[
					-9,
					-26
				]
			],
			[
				[
					801,
					3626
				],
				[
					-42,
					2
				]
			],
			[
				[
					759,
					3628
				],
				[
					-265,
					-43
				]
			],
			[
				[
					494,
					3585
				],
				[
					-25,
					59
				],
				[
					126,
					129
				],
				[
					71,
					132
				]
			],
			[
				[
					666,
					3905
				],
				[
					107,
					-20
				]
			],
			[
				[
					6909,
					7304
				],
				[
					30,
					-21
				]
			],
			[
				[
					6878,
					7151
				],
				[
					17,
					-7
				]
			],
			[
				[
					6895,
					7144
				],
				[
					-163,
					-121
				]
			],
			[
				[
					6732,
					7023
				],
				[
					-91,
					-80
				]
			],
			[
				[
					6487,
					7101
				],
				[
					-26,
					45
				]
			],
			[
				[
					6583,
					7187
				],
				[
					44,
					35
				]
			],
			[
				[
					6752,
					7298
				],
				[
					68,
					64
				]
			],
			[
				[
					1024,
					5913
				],
				[
					-123,
					84
				],
				[
					-205,
					59
				],
				[
					-99,
					232
				],
				[
					70,
					27
				],
				[
					88,
					-54
				],
				[
					42,
					-89
				],
				[
					218,
					-7
				],
				[
					19,
					-75
				],
				[
					97,
					6
				],
				[
					103,
					-70
				]
			],
			[
				[
					4666,
					8086
				],
				[
					12,
					-67
				]
			],
			[
				[
					4655,
					7817
				],
				[
					-68,
					34
				]
			],
			[
				[
					4587,
					7851
				],
				[
					-94,
					54
				],
				[
					-16,
					69
				]
			],
			[
				[
					4477,
					7974
				],
				[
					-12,
					56
				]
			],
			[
				[
					4465,
					8030
				],
				[
					2,
					22
				]
			],
			[
				[
					4596,
					8228
				],
				[
					73,
					-35
				]
			],
			[
				[
					4636,
					8166
				],
				[
					-13,
					-47
				]
			],
			[
				[
					5217,
					6370
				],
				[
					70,
					-33
				]
			],
			[
				[
					5287,
					6337
				],
				[
					3,
					-17
				]
			],
			[
				[
					5290,
					6320
				],
				[
					100,
					3
				]
			],
			[
				[
					5390,
					6323
				],
				[
					27,
					-74
				]
			],
			[
				[
					5435,
					6222
				],
				[
					22,
					-112
				],
				[
					-88,
					-42
				],
				[
					-49,
					-18
				]
			],
			[
				[
					5320,
					6050
				],
				[
					-44,
					-124
				]
			],
			[
				[
					5096,
					5928
				],
				[
					-78,
					34
				]
			],
			[
				[
					4998,
					5982
				],
				[
					-37,
					-4
				]
			],
			[
				[
					4961,
					5978
				],
				[
					-87,
					27
				]
			],
			[
				[
					4852,
					6007
				],
				[
					-27,
					53
				]
			],
			[
				[
					4825,
					6060
				],
				[
					8,
					33
				],
				[
					-6,
					30
				]
			],
			[
				[
					4827,
					6123
				],
				[
					119,
					-22
				],
				[
					106,
					64
				]
			],
			[
				[
					5052,
					6165
				],
				[
					1,
					63
				]
			],
			[
				[
					5053,
					6228
				],
				[
					102,
					101
				]
			],
			[
				[
					5155,
					6329
				],
				[
					27,
					58
				]
			],
			[
				[
					5182,
					6387
				],
				[
					35,
					-17
				]
			],
			[
				[
					1070,
					2135
				],
				[
					-15,
					-14
				]
			],
			[
				[
					1097,
					2002
				],
				[
					17,
					-2
				]
			],
			[
				[
					1014,
					1828
				],
				[
					-9,
					-36
				]
			],
			[
				[
					794,
					1865
				],
				[
					-41,
					11
				]
			],
			[
				[
					753,
					1876
				],
				[
					-1,
					18
				]
			],
			[
				[
					752,
					1894
				],
				[
					47,
					31
				]
			],
			[
				[
					799,
					1925
				],
				[
					-26,
					67
				]
			],
			[
				[
					773,
					1992
				],
				[
					23,
					64
				]
			],
			[
				[
					796,
					2056
				],
				[
					66,
					66
				],
				[
					17,
					32
				]
			],
			[
				[
					954,
					2157
				],
				[
					62,
					28
				]
			],
			[
				[
					2707,
					1137
				],
				[
					-7,
					-96
				]
			],
			[
				[
					2667,
					937
				],
				[
					-18,
					-53
				],
				[
					-116,
					3
				]
			],
			[
				[
					2533,
					887
				],
				[
					16,
					50
				]
			],
			[
				[
					2549,
					937
				],
				[
					-42,
					29
				]
			],
			[
				[
					2507,
					966
				],
				[
					-63,
					-12
				]
			],
			[
				[
					2444,
					954
				],
				[
					0,
					49
				]
			],
			[
				[
					2444,
					1003
				],
				[
					33,
					85
				]
			],
			[
				[
					2477,
					1088
				],
				[
					-15,
					110
				]
			],
			[
				[
					2665,
					1329
				],
				[
					34,
					21
				]
			],
			[
				[
					6724,
					5888
				],
				[
					38,
					-35
				]
			],
			[
				[
					6668,
					5597
				],
				[
					-34,
					2
				]
			],
			[
				[
					6634,
					5599
				],
				[
					-110,
					-8
				]
			],
			[
				[
					6524,
					5591
				],
				[
					-76,
					-59
				],
				[
					-120,
					-2
				],
				[
					-24,
					54
				]
			],
			[
				[
					6304,
					5584
				],
				[
					-69,
					-3
				]
			],
			[
				[
					6235,
					5581
				],
				[
					-83,
					-13
				]
			],
			[
				[
					6152,
					5568
				],
				[
					-46,
					117
				]
			],
			[
				[
					6106,
					5685
				],
				[
					142,
					173
				]
			],
			[
				[
					6248,
					5858
				],
				[
					128,
					72
				]
			],
			[
				[
					6397,
					5964
				],
				[
					100,
					102
				]
			],
			[
				[
					6497,
					6066
				],
				[
					-2,
					-104
				]
			],
			[
				[
					7269,
					5906
				],
				[
					87,
					17
				]
			],
			[
				[
					7356,
					5923
				],
				[
					-52,
					-43
				]
			],
			[
				[
					7304,
					5880
				],
				[
					9,
					-115
				]
			],
			[
				[
					7313,
					5765
				],
				[
					-86,
					-49
				]
			],
			[
				[
					6903,
					5895
				],
				[
					14,
					2
				]
			],
			[
				[
					6965,
					6025
				],
				[
					7,
					-67
				]
			],
			[
				[
					6972,
					5958
				],
				[
					53,
					-75
				]
			],
			[
				[
					2646,
					6458
				],
				[
					51,
					-21
				]
			],
			[
				[
					2697,
					6437
				],
				[
					14,
					-105
				]
			],
			[
				[
					2711,
					6332
				],
				[
					24,
					-98
				]
			],
			[
				[
					2735,
					6234
				],
				[
					59,
					14
				]
			],
			[
				[
					2794,
					6248
				],
				[
					27,
					-6
				]
			],
			[
				[
					2759,
					6161
				],
				[
					-87,
					20
				]
			],
			[
				[
					2672,
					6181
				],
				[
					-45,
					-62
				]
			],
			[
				[
					2593,
					6121
				],
				[
					-76,
					-26
				],
				[
					-32,
					8
				],
				[
					-5,
					15
				],
				[
					-15,
					-6
				],
				[
					-8,
					45
				]
			],
			[
				[
					2470,
					6207
				],
				[
					18,
					123
				]
			],
			[
				[
					2444,
					6368
				],
				[
					-28,
					48
				]
			],
			[
				[
					2501,
					6464
				],
				[
					19,
					-14
				],
				[
					126,
					8
				]
			],
			[
				[
					2020,
					2727
				],
				[
					-10,
					-33
				]
			],
			[
				[
					2030,
					2379
				],
				[
					29,
					-10
				]
			],
			[
				[
					1929,
					2361
				],
				[
					-55,
					-33
				]
			],
			[
				[
					1755,
					2452
				],
				[
					-57,
					27
				],
				[
					-46,
					52
				],
				[
					-4,
					11
				]
			],
			[
				[
					1710,
					2590
				],
				[
					72,
					41
				]
			],
			[
				[
					1887,
					2661
				],
				[
					32,
					69
				]
			],
			[
				[
					838,
					2636
				],
				[
					11,
					-22
				]
			],
			[
				[
					783,
					2477
				],
				[
					-38,
					-36
				]
			],
			[
				[
					720,
					2451
				],
				[
					-51,
					-65
				]
			],
			[
				[
					588,
					2451
				],
				[
					-37,
					11
				]
			],
			[
				[
					437,
					2611
				],
				[
					72,
					57
				]
			],
			[
				[
					546,
					2659
				],
				[
					61,
					52
				]
			],
			[
				[
					789,
					2718
				],
				[
					24,
					-10
				]
			],
			[
				[
					6211,
					5000
				],
				[
					32,
					-26
				]
			],
			[
				[
					6243,
					4974
				],
				[
					39,
					-25
				]
			],
			[
				[
					6440,
					4552
				],
				[
					-139,
					-93
				],
				[
					-52,
					-20
				],
				[
					2,
					-22
				]
			],
			[
				[
					6251,
					4417
				],
				[
					-117,
					-97
				]
			],
			[
				[
					6062,
					4310
				],
				[
					46,
					50
				]
			],
			[
				[
					5979,
					4642
				],
				[
					-15,
					85
				]
			],
			[
				[
					6048,
					4978
				],
				[
					25,
					88
				]
			],
			[
				[
					6159,
					5081
				],
				[
					63,
					-37
				]
			],
			[
				[
					5062,
					5578
				],
				[
					-1,
					-8
				]
			],
			[
				[
					5188,
					5557
				],
				[
					81,
					-23
				]
			],
			[
				[
					5389,
					5557
				],
				[
					33,
					-15
				]
			],
			[
				[
					5422,
					5542
				],
				[
					119,
					-53
				]
			],
			[
				[
					5588,
					5333
				],
				[
					-20,
					1
				]
			],
			[
				[
					5568,
					5334
				],
				[
					-8,
					-29
				]
			],
			[
				[
					5560,
					5305
				],
				[
					13,
					3
				]
			],
			[
				[
					5573,
					5308
				],
				[
					-8,
					-64
				]
			],
			[
				[
					5565,
					5244
				],
				[
					-78,
					-4
				]
			],
			[
				[
					5451,
					5142
				],
				[
					-11,
					17
				]
			],
			[
				[
					5394,
					5196
				],
				[
					-66,
					-14
				]
			],
			[
				[
					5307,
					5211
				],
				[
					-89,
					14
				]
			],
			[
				[
					5135,
					5367
				],
				[
					-81,
					87
				]
			],
			[
				[
					5054,
					5454
				],
				[
					-29,
					68
				]
			],
			[
				[
					5025,
					5522
				],
				[
					37,
					56
				]
			],
			[
				[
					3612,
					6556
				],
				[
					82,
					-41
				]
			],
			[
				[
					3768,
					6423
				],
				[
					-22,
					-29
				]
			],
			[
				[
					3778,
					6235
				],
				[
					-45,
					-33
				]
			],
			[
				[
					3380,
					6300
				],
				[
					-14,
					33
				]
			],
			[
				[
					3339,
					6439
				],
				[
					118,
					72
				]
			],
			[
				[
					3525,
					6556
				],
				[
					68,
					-2
				]
			],
			[
				[
					3328,
					3551
				],
				[
					19,
					-42
				]
			],
			[
				[
					3405,
					3513
				],
				[
					22,
					-57
				]
			],
			[
				[
					3427,
					3456
				],
				[
					-1,
					-115
				]
			],
			[
				[
					3415,
					3258
				],
				[
					-77,
					0
				]
			],
			[
				[
					3317,
					3303
				],
				[
					-80,
					12
				]
			],
			[
				[
					3152,
					3295
				],
				[
					-62,
					-2
				]
			],
			[
				[
					3090,
					3293
				],
				[
					-59,
					-24
				]
			],
			[
				[
					3034,
					3297
				],
				[
					42,
					73
				]
			],
			[
				[
					3106,
					3517
				],
				[
					69,
					21
				]
			],
			[
				[
					3198,
					3521
				],
				[
					72,
					54
				]
			],
			[
				[
					3270,
					3575
				],
				[
					28,
					-2
				]
			],
			[
				[
					3292,
					1624
				],
				[
					114,
					-31
				]
			],
			[
				[
					3530,
					1446
				],
				[
					3,
					-104
				]
			],
			[
				[
					3479,
					1373
				],
				[
					-76,
					-19
				]
			],
			[
				[
					3189,
					1304
				],
				[
					-57,
					101
				]
			],
			[
				[
					3211,
					1606
				],
				[
					-5,
					10
				]
			],
			[
				[
					3284,
					1637
				],
				[
					8,
					-13
				]
			],
			[
				[
					4283,
					7530
				],
				[
					-10,
					-13
				]
			],
			[
				[
					4273,
					7517
				],
				[
					51,
					4
				]
			],
			[
				[
					4324,
					7521
				],
				[
					47,
					-36
				],
				[
					55,
					-170
				],
				[
					-7,
					-66
				]
			],
			[
				[
					4356,
					7251
				],
				[
					-58,
					23
				]
			],
			[
				[
					4298,
					7274
				],
				[
					-17,
					-2
				]
			],
			[
				[
					4223,
					7310
				],
				[
					-21,
					16
				]
			],
			[
				[
					4140,
					7603
				],
				[
					22,
					-23
				]
			],
			[
				[
					4162,
					7580
				],
				[
					106,
					-44
				],
				[
					15,
					-6
				]
			],
			[
				[
					436,
					5746
				],
				[
					-64,
					-162
				]
			],
			[
				[
					372,
					5584
				],
				[
					-195,
					101
				],
				[
					94,
					70
				],
				[
					-29,
					125
				],
				[
					-80,
					107
				],
				[
					226,
					58
				]
			],
			[
				[
					6328,
					8128
				],
				[
					138,
					-9
				]
			],
			[
				[
					6492,
					7771
				],
				[
					-17,
					-3
				]
			],
			[
				[
					6455,
					7747
				],
				[
					-156,
					20
				],
				[
					-72,
					66
				],
				[
					3,
					150
				],
				[
					-34,
					170
				]
			],
			[
				[
					6208,
					8177
				],
				[
					89,
					-30
				]
			],
			[
				[
					2323,
					5635
				],
				[
					41,
					-30
				]
			],
			[
				[
					2491,
					5674
				],
				[
					36,
					-56
				]
			],
			[
				[
					2471,
					5229
				],
				[
					-84,
					-18
				]
			],
			[
				[
					2387,
					5211
				],
				[
					-50,
					52
				]
			],
			[
				[
					2337,
					5263
				],
				[
					-9,
					59
				]
			],
			[
				[
					2192,
					5326
				],
				[
					-56,
					112
				]
			],
			[
				[
					2006,
					5538
				],
				[
					152,
					120
				]
			],
			[
				[
					2158,
					5658
				],
				[
					1,
					16
				]
			],
			[
				[
					2159,
					5674
				],
				[
					61,
					-14
				]
			],
			[
				[
					1251,
					4321
				],
				[
					-9,
					-33
				]
			],
			[
				[
					1229,
					4256
				],
				[
					-63,
					-34
				],
				[
					-9,
					-36
				]
			],
			[
				[
					1157,
					4186
				],
				[
					-59,
					2
				]
			],
			[
				[
					1067,
					4134
				],
				[
					-109,
					-31
				],
				[
					-18,
					130
				]
			],
			[
				[
					1065,
					4441
				],
				[
					32,
					24
				]
			],
			[
				[
					3312,
					7180
				],
				[
					5,
					-46
				]
			],
			[
				[
					3352,
					6933
				],
				[
					-43,
					-29
				]
			],
			[
				[
					3298,
					6872
				],
				[
					-145,
					22
				]
			],
			[
				[
					3153,
					6894
				],
				[
					-22,
					19
				]
			],
			[
				[
					3130,
					6933
				],
				[
					-45,
					34
				]
			],
			[
				[
					2953,
					7058
				],
				[
					12,
					2
				]
			],
			[
				[
					2965,
					7060
				],
				[
					0,
					45
				]
			],
			[
				[
					3130,
					7216
				],
				[
					98,
					-51
				]
			],
			[
				[
					723,
					5680
				],
				[
					41,
					-32
				]
			],
			[
				[
					764,
					5648
				],
				[
					50,
					-108
				]
			],
			[
				[
					814,
					5540
				],
				[
					22,
					-34
				],
				[
					12,
					-42
				]
			],
			[
				[
					806,
					5389
				],
				[
					-57,
					8
				]
			],
			[
				[
					522,
					5150
				],
				[
					57,
					161
				],
				[
					-196,
					68
				],
				[
					-11,
					205
				]
			],
			[
				[
					372,
					5584
				],
				[
					34,
					85
				]
			],
			[
				[
					548,
					5668
				],
				[
					122,
					-53
				]
			],
			[
				[
					672,
					5687
				],
				[
					47,
					-23
				]
			],
			[
				[
					3434,
					2291
				],
				[
					8,
					-110
				]
			],
			[
				[
					3240,
					1914
				],
				[
					-46,
					22
				],
				[
					-27,
					34
				],
				[
					29,
					74
				]
			],
			[
				[
					3196,
					2044
				],
				[
					16,
					56
				]
			],
			[
				[
					3212,
					2100
				],
				[
					-27,
					64
				]
			],
			[
				[
					3276,
					2319
				],
				[
					15,
					42
				],
				[
					16,
					16
				]
			],
			[
				[
					3307,
					2377
				],
				[
					46,
					-39
				]
			],
			[
				[
					6760,
					3201
				],
				[
					24,
					-95
				],
				[
					-81,
					-57
				],
				[
					-260,
					28
				]
			],
			[
				[
					6341,
					3175
				],
				[
					-4,
					29
				]
			],
			[
				[
					6337,
					3204
				],
				[
					5,
					1
				]
			],
			[
				[
					6478,
					3245
				],
				[
					70,
					21
				]
			],
			[
				[
					6490,
					3350
				],
				[
					104,
					-15
				]
			],
			[
				[
					3154,
					2160
				],
				[
					58,
					-60
				]
			],
			[
				[
					3212,
					2100
				],
				[
					-16,
					-56
				]
			],
			[
				[
					3196,
					2044
				],
				[
					-28,
					-66
				],
				[
					8,
					-23
				]
			],
			[
				[
					3176,
					1955
				],
				[
					-29,
					-51
				]
			],
			[
				[
					3129,
					1862
				],
				[
					-75,
					-53
				]
			],
			[
				[
					3009,
					1757
				],
				[
					-102,
					13
				]
			],
			[
				[
					2925,
					1994
				],
				[
					113,
					100
				],
				[
					116,
					66
				]
			],
			[
				[
					6668,
					5597
				],
				[
					45,
					-70
				]
			],
			[
				[
					6700,
					5423
				],
				[
					6,
					-74
				]
			],
			[
				[
					6684,
					5339
				],
				[
					12,
					-32
				]
			],
			[
				[
					6696,
					5307
				],
				[
					69,
					-15
				]
			],
			[
				[
					6787,
					5272
				],
				[
					37,
					-68
				]
			],
			[
				[
					6840,
					5209
				],
				[
					25,
					-68
				],
				[
					-99,
					-32
				]
			],
			[
				[
					6618,
					5206
				],
				[
					-16,
					-40
				]
			],
			[
				[
					6526,
					5177
				],
				[
					-25,
					152
				]
			],
			[
				[
					6443,
					5367
				],
				[
					-97,
					42
				]
			],
			[
				[
					6346,
					5409
				],
				[
					-75,
					68
				]
			],
			[
				[
					6271,
					5477
				],
				[
					-14,
					2
				]
			],
			[
				[
					6257,
					5479
				],
				[
					18,
					41
				]
			],
			[
				[
					6275,
					5520
				],
				[
					-26,
					27
				]
			],
			[
				[
					6249,
					5547
				],
				[
					55,
					37
				]
			],
			[
				[
					6524,
					5591
				],
				[
					110,
					8
				]
			],
			[
				[
					7984,
					6502
				],
				[
					47,
					-70
				]
			],
			[
				[
					8031,
					6432
				],
				[
					-16,
					-73
				]
			],
			[
				[
					8034,
					6274
				],
				[
					76,
					-28
				]
			],
			[
				[
					8098,
					6157
				],
				[
					-38,
					-11
				]
			],
			[
				[
					8021,
					6122
				],
				[
					-83,
					30
				]
			],
			[
				[
					7828,
					6291
				],
				[
					5,
					48
				]
			],
			[
				[
					7776,
					6267
				],
				[
					-43,
					28
				]
			],
			[
				[
					7743,
					6337
				],
				[
					76,
					35
				]
			],
			[
				[
					7952,
					6511
				],
				[
					7,
					-19
				]
			],
			[
				[
					4465,
					8030
				],
				[
					12,
					-56
				]
			],
			[
				[
					4587,
					7851
				],
				[
					31,
					-21
				],
				[
					81,
					-26
				]
			],
			[
				[
					4740,
					7755
				],
				[
					-279,
					-101
				],
				[
					-102,
					-158
				]
			],
			[
				[
					4359,
					7496
				],
				[
					-35,
					25
				]
			],
			[
				[
					4273,
					7517
				],
				[
					26,
					45
				],
				[
					50,
					161
				]
			],
			[
				[
					4251,
					7860
				],
				[
					-63,
					134
				],
				[
					-26,
					80
				],
				[
					54,
					19
				],
				[
					3,
					-7
				]
			],
			[
				[
					7073,
					7171
				],
				[
					94,
					-102
				]
			],
			[
				[
					7167,
					7069
				],
				[
					-4,
					-39
				]
			],
			[
				[
					7162,
					6892
				],
				[
					-54,
					-8
				]
			],
			[
				[
					7080,
					6856
				],
				[
					-15,
					-31
				]
			],
			[
				[
					7047,
					6799
				],
				[
					-76,
					10
				]
			],
			[
				[
					6913,
					6783
				],
				[
					-30,
					69
				]
			],
			[
				[
					6791,
					6859
				],
				[
					-36,
					20
				],
				[
					-42,
					-4
				]
			],
			[
				[
					6713,
					6875
				],
				[
					4,
					51
				],
				[
					-23,
					26
				],
				[
					38,
					71
				]
			],
			[
				[
					6895,
					7144
				],
				[
					69,
					15
				]
			],
			[
				[
					4347,
					6202
				],
				[
					37,
					-21
				]
			],
			[
				[
					4384,
					6181
				],
				[
					-11,
					-18
				],
				[
					17,
					-17
				],
				[
					-13,
					-35
				]
			],
			[
				[
					4557,
					6034
				],
				[
					51,
					-114
				]
			],
			[
				[
					4608,
					5920
				],
				[
					11,
					-55
				]
			],
			[
				[
					4676,
					5719
				],
				[
					-35,
					-92
				]
			],
			[
				[
					4481,
					5639
				],
				[
					-18,
					55
				]
			],
			[
				[
					4463,
					5694
				],
				[
					-38,
					-4
				]
			],
			[
				[
					4229,
					6023
				],
				[
					-33,
					98
				]
			],
			[
				[
					4228,
					6109
				],
				[
					40,
					42
				]
			],
			[
				[
					4244,
					6164
				],
				[
					103,
					38
				]
			],
			[
				[
					4934,
					7635
				],
				[
					-91,
					-123
				]
			],
			[
				[
					4697,
					7537
				],
				[
					-107,
					37
				]
			],
			[
				[
					4450,
					7415
				],
				[
					-54,
					-7
				]
			],
			[
				[
					4396,
					7408
				],
				[
					-37,
					88
				]
			],
			[
				[
					7373,
					5882
				],
				[
					43,
					-2
				]
			],
			[
				[
					7433,
					5850
				],
				[
					26,
					-72
				]
			],
			[
				[
					7494,
					5739
				],
				[
					27,
					-45
				]
			],
			[
				[
					7264,
					5463
				],
				[
					2,
					-16
				]
			],
			[
				[
					7291,
					5626
				],
				[
					-18,
					113
				]
			],
			[
				[
					7273,
					5739
				],
				[
					40,
					26
				]
			],
			[
				[
					7304,
					5880
				],
				[
					60,
					-8
				]
			],
			[
				[
					5340,
					6547
				],
				[
					-14,
					-62
				]
			],
			[
				[
					5325,
					6459
				],
				[
					-38,
					-122
				]
			],
			[
				[
					5217,
					6370
				],
				[
					-35,
					17
				]
			],
			[
				[
					5182,
					6387
				],
				[
					-27,
					-58
				]
			],
			[
				[
					5053,
					6228
				],
				[
					-1,
					-63
				]
			],
			[
				[
					4827,
					6123
				],
				[
					-52,
					73
				],
				[
					51,
					89
				]
			],
			[
				[
					4893,
					6455
				],
				[
					-39,
					85
				]
			],
			[
				[
					4854,
					6540
				],
				[
					-59,
					66
				]
			],
			[
				[
					4869,
					6675
				],
				[
					-47,
					30
				]
			],
			[
				[
					4886,
					6828
				],
				[
					32,
					78
				],
				[
					155,
					-65
				]
			],
			[
				[
					3157,
					2942
				],
				[
					20,
					-11
				]
			],
			[
				[
					2996,
					2709
				],
				[
					-41,
					47
				]
			],
			[
				[
					2928,
					2772
				],
				[
					15,
					19
				]
			],
			[
				[
					2943,
					2791
				],
				[
					38,
					108
				]
			],
			[
				[
					2981,
					2899
				],
				[
					66,
					26
				]
			],
			[
				[
					3047,
					2925
				],
				[
					88,
					11
				]
			],
			[
				[
					2136,
					1433
				],
				[
					-9,
					-14
				]
			],
			[
				[
					2235,
					1424
				],
				[
					16,
					39
				]
			],
			[
				[
					2323,
					1469
				],
				[
					32,
					-45
				]
			],
			[
				[
					2398,
					1244
				],
				[
					64,
					-46
				]
			],
			[
				[
					2477,
					1088
				],
				[
					-33,
					-85
				]
			],
			[
				[
					2444,
					954
				],
				[
					63,
					12
				]
			],
			[
				[
					2549,
					937
				],
				[
					-42,
					-32
				]
			],
			[
				[
					2246,
					1080
				],
				[
					-43,
					-2
				]
			],
			[
				[
					2152,
					1065
				],
				[
					-2,
					52
				]
			],
			[
				[
					2023,
					1165
				],
				[
					-1,
					105
				]
			],
			[
				[
					2061,
					1460
				],
				[
					58,
					-14
				],
				[
					17,
					-13
				]
			],
			[
				[
					578,
					2040
				],
				[
					21,
					39
				]
			],
			[
				[
					775,
					2040
				],
				[
					-2,
					-48
				]
			],
			[
				[
					799,
					1925
				],
				[
					-196,
					-48
				]
			],
			[
				[
					540,
					1884
				],
				[
					17,
					49
				]
			],
			[
				[
					557,
					1933
				],
				[
					0,
					37
				]
			],
			[
				[
					535,
					2003
				],
				[
					-26,
					49
				]
			],
			[
				[
					509,
					2052
				],
				[
					37,
					6
				]
			],
			[
				[
					2539,
					4679
				],
				[
					-25,
					-11
				]
			],
			[
				[
					2452,
					4590
				],
				[
					-58,
					-77
				]
			],
			[
				[
					2290,
					4476
				],
				[
					-44,
					29
				]
			],
			[
				[
					2169,
					4774
				],
				[
					19,
					57
				],
				[
					-8,
					30
				]
			],
			[
				[
					2193,
					4886
				],
				[
					84,
					60
				]
			],
			[
				[
					2259,
					4981
				],
				[
					45,
					22
				]
			],
			[
				[
					2304,
					5003
				],
				[
					126,
					-175
				],
				[
					58,
					-133
				],
				[
					51,
					-16
				]
			],
			[
				[
					7732,
					5262
				],
				[
					12,
					-32
				]
			],
			[
				[
					7992,
					5190
				],
				[
					7,
					-46
				]
			],
			[
				[
					7975,
					4937
				],
				[
					-43,
					12
				]
			],
			[
				[
					7911,
					4938
				],
				[
					-25,
					-5
				]
			],
			[
				[
					7850,
					4925
				],
				[
					-15,
					-31
				]
			],
			[
				[
					7835,
					4894
				],
				[
					-29,
					-39
				],
				[
					-110,
					61
				],
				[
					4,
					84
				]
			],
			[
				[
					7700,
					5000
				],
				[
					-76,
					-38
				],
				[
					-52,
					23
				],
				[
					-9,
					86
				]
			],
			[
				[
					7526,
					5072
				],
				[
					-48,
					95
				]
			],
			[
				[
					7606,
					5331
				],
				[
					42,
					-9
				]
			],
			[
				[
					7835,
					4894
				],
				[
					10,
					-23
				]
			],
			[
				[
					8185,
					4729
				],
				[
					-208,
					-183
				],
				[
					-64,
					-93
				],
				[
					-135,
					0
				],
				[
					-61,
					87
				],
				[
					37,
					119
				],
				[
					-165,
					69
				],
				[
					-129,
					-19
				]
			],
			[
				[
					7371,
					4747
				],
				[
					-64,
					73
				]
			],
			[
				[
					7406,
					4890
				],
				[
					24,
					37
				]
			],
			[
				[
					7430,
					4927
				],
				[
					105,
					39
				]
			],
			[
				[
					7533,
					4998
				],
				[
					72,
					-27
				],
				[
					1,
					-8
				],
				[
					40,
					3
				],
				[
					54,
					34
				]
			],
			[
				[
					5127,
					4581
				],
				[
					35,
					-58
				]
			],
			[
				[
					5196,
					4512
				],
				[
					61,
					-46
				],
				[
					124,
					15
				]
			],
			[
				[
					5546,
					4390
				],
				[
					76,
					-68
				]
			],
			[
				[
					5553,
					4288
				],
				[
					-12,
					-35
				]
			],
			[
				[
					5419,
					4146
				],
				[
					-86,
					-47
				]
			],
			[
				[
					4974,
					4214
				],
				[
					-69,
					-49
				],
				[
					-50,
					75
				]
			],
			[
				[
					4855,
					4240
				],
				[
					17,
					18
				]
			],
			[
				[
					4833,
					4424
				],
				[
					-19,
					104
				]
			],
			[
				[
					4833,
					4595
				],
				[
					16,
					20
				]
			],
			[
				[
					4849,
					4615
				],
				[
					43,
					21
				]
			],
			[
				[
					4890,
					4647
				],
				[
					114,
					-102
				]
			],
			[
				[
					6411,
					7433
				],
				[
					1,
					-74
				],
				[
					-90,
					-22
				]
			],
			[
				[
					6331,
					7238
				],
				[
					15,
					-46
				]
			],
			[
				[
					6346,
					7192
				],
				[
					-18,
					-62
				]
			],
			[
				[
					6328,
					7130
				],
				[
					-47,
					-15
				]
			],
			[
				[
					6281,
					7115
				],
				[
					-25,
					-11
				]
			],
			[
				[
					6149,
					7119
				],
				[
					-37,
					131
				],
				[
					167,
					91
				],
				[
					110,
					116
				]
			],
			[
				[
					3416,
					3945
				],
				[
					31,
					-67
				]
			],
			[
				[
					3454,
					3869
				],
				[
					22,
					-104
				]
			],
			[
				[
					3439,
					3734
				],
				[
					-43,
					-61
				]
			],
			[
				[
					3376,
					3764
				],
				[
					-27,
					51
				]
			],
			[
				[
					3319,
					3828
				],
				[
					20,
					65
				]
			],
			[
				[
					3707,
					4482
				],
				[
					21,
					-79
				],
				[
					-86,
					-36
				]
			],
			[
				[
					3574,
					4270
				],
				[
					-27,
					21
				]
			],
			[
				[
					3547,
					4291
				],
				[
					-38,
					25
				]
			],
			[
				[
					3509,
					4316
				],
				[
					-84,
					-131
				]
			],
			[
				[
					3372,
					4159
				],
				[
					-33,
					59
				]
			],
			[
				[
					3339,
					4218
				],
				[
					-16,
					-7
				]
			],
			[
				[
					3383,
					4442
				],
				[
					16,
					56
				]
			],
			[
				[
					3532,
					4504
				],
				[
					29,
					113
				]
			],
			[
				[
					3547,
					4291
				],
				[
					87,
					-55
				]
			],
			[
				[
					3634,
					4236
				],
				[
					35,
					51
				]
			],
			[
				[
					3669,
					4256
				],
				[
					9,
					-4
				]
			],
			[
				[
					3657,
					4095
				],
				[
					-43,
					-31
				]
			],
			[
				[
					3595,
					4063
				],
				[
					-38,
					5
				]
			],
			[
				[
					3557,
					4068
				],
				[
					-22,
					30
				]
			],
			[
				[
					3509,
					4316
				],
				[
					38,
					-25
				]
			],
			[
				[
					2872,
					2940
				],
				[
					79,
					-9
				]
			],
			[
				[
					2987,
					2920
				],
				[
					-6,
					-21
				]
			],
			[
				[
					2943,
					2791
				],
				[
					-73,
					-49
				]
			],
			[
				[
					2647,
					2710
				],
				[
					-7,
					58
				],
				[
					-20,
					29
				],
				[
					-159,
					131
				]
			],
			[
				[
					2461,
					2928
				],
				[
					99,
					30
				]
			],
			[
				[
					2611,
					2958
				],
				[
					70,
					11
				]
			],
			[
				[
					2681,
					2969
				],
				[
					3,
					67
				]
			],
			[
				[
					2684,
					3036
				],
				[
					50,
					-40
				],
				[
					66,
					58
				],
				[
					20,
					-1
				],
				[
					66,
					4
				]
			],
			[
				[
					2850,
					6299
				],
				[
					-56,
					-51
				]
			],
			[
				[
					2794,
					6248
				],
				[
					-59,
					-14
				]
			],
			[
				[
					2711,
					6332
				],
				[
					-14,
					105
				]
			],
			[
				[
					2646,
					6458
				],
				[
					-113,
					-6
				]
			],
			[
				[
					2533,
					6452
				],
				[
					2,
					89
				],
				[
					25,
					53
				]
			],
			[
				[
					2818,
					6689
				],
				[
					24,
					-36
				],
				[
					80,
					-51
				],
				[
					-4,
					-105
				]
			],
			[
				[
					3866,
					7263
				],
				[
					75,
					-46
				],
				[
					29,
					10
				]
			],
			[
				[
					4023,
					7080
				],
				[
					-28,
					-59
				]
			],
			[
				[
					3995,
					7021
				],
				[
					-68,
					-59
				]
			],
			[
				[
					3927,
					6962
				],
				[
					-90,
					19
				]
			],
			[
				[
					3837,
					6981
				],
				[
					-32,
					-19
				]
			],
			[
				[
					3805,
					6962
				],
				[
					-63,
					26
				]
			],
			[
				[
					3742,
					6988
				],
				[
					-5,
					70
				]
			],
			[
				[
					3737,
					7058
				],
				[
					37,
					79
				]
			],
			[
				[
					3774,
					7137
				],
				[
					26,
					86
				]
			],
			[
				[
					3800,
					7223
				],
				[
					37,
					49
				]
			],
			[
				[
					6049,
					5559
				],
				[
					103,
					9
				]
			],
			[
				[
					6235,
					5581
				],
				[
					14,
					-34
				]
			],
			[
				[
					6275,
					5520
				],
				[
					-18,
					-41
				]
			],
			[
				[
					6271,
					5477
				],
				[
					-44,
					-35
				]
			],
			[
				[
					6133,
					5358
				],
				[
					-3,
					-34
				]
			],
			[
				[
					6130,
					5324
				],
				[
					-23,
					-91
				]
			],
			[
				[
					6107,
					5233
				],
				[
					-40,
					-18
				]
			],
			[
				[
					6067,
					5215
				],
				[
					-10,
					14
				]
			],
			[
				[
					5955,
					5252
				],
				[
					-48,
					28
				]
			],
			[
				[
					5663,
					5185
				],
				[
					-41,
					46
				]
			],
			[
				[
					5627,
					5254
				],
				[
					-54,
					54
				]
			],
			[
				[
					5560,
					5305
				],
				[
					8,
					29
				]
			],
			[
				[
					5568,
					5334
				],
				[
					80,
					-14
				]
			],
			[
				[
					5648,
					5320
				],
				[
					76,
					7
				]
			],
			[
				[
					5764,
					5342
				],
				[
					67,
					53
				],
				[
					1,
					73
				]
			],
			[
				[
					5870,
					5567
				],
				[
					43,
					16
				]
			],
			[
				[
					5929,
					5604
				],
				[
					120,
					-45
				]
			],
			[
				[
					2628,
					5197
				],
				[
					30,
					-89
				]
			],
			[
				[
					2542,
					4934
				],
				[
					67,
					-58
				]
			],
			[
				[
					2659,
					4867
				],
				[
					34,
					-62
				]
			],
			[
				[
					2678,
					4717
				],
				[
					-139,
					-38
				]
			],
			[
				[
					2304,
					5003
				],
				[
					80,
					69
				]
			],
			[
				[
					2384,
					5072
				],
				[
					12,
					103
				]
			],
			[
				[
					2396,
					5175
				],
				[
					-9,
					36
				]
			],
			[
				[
					2387,
					5211
				],
				[
					78,
					15
				],
				[
					75,
					39
				]
			],
			[
				[
					2540,
					5265
				],
				[
					41,
					-40
				]
			],
			[
				[
					3742,
					6988
				],
				[
					63,
					-26
				]
			],
			[
				[
					3805,
					6962
				],
				[
					32,
					19
				]
			],
			[
				[
					3927,
					6962
				],
				[
					65,
					47
				]
			],
			[
				[
					4013,
					6942
				],
				[
					-23,
					-113
				]
			],
			[
				[
					3990,
					6829
				],
				[
					-44,
					-82
				]
			],
			[
				[
					3959,
					6699
				],
				[
					-107,
					-22
				]
			],
			[
				[
					3800,
					6724
				],
				[
					-62,
					11
				]
			],
			[
				[
					3738,
					6735
				],
				[
					14,
					20
				]
			],
			[
				[
					3725,
					6839
				],
				[
					-42,
					77
				]
			],
			[
				[
					3714,
					7027
				],
				[
					23,
					31
				]
			],
			[
				[
					1374,
					1663
				],
				[
					-21,
					-51
				]
			],
			[
				[
					1342,
					1501
				],
				[
					21,
					-52
				]
			],
			[
				[
					1370,
					1405
				],
				[
					-140,
					-26
				]
			],
			[
				[
					1230,
					1379
				],
				[
					-33,
					-27
				]
			],
			[
				[
					1197,
					1352
				],
				[
					4,
					-20
				]
			],
			[
				[
					1075,
					1279
				],
				[
					-95,
					88
				]
			],
			[
				[
					985,
					1402
				],
				[
					64,
					17
				]
			],
			[
				[
					1176,
					1694
				],
				[
					17,
					-6
				]
			],
			[
				[
					1196,
					1711
				],
				[
					85,
					44
				]
			],
			[
				[
					6992,
					7792
				],
				[
					14,
					-25
				],
				[
					63,
					-25
				],
				[
					152,
					-40
				]
			],
			[
				[
					7198,
					7695
				],
				[
					3,
					-26
				],
				[
					-12,
					-23
				],
				[
					-40,
					-7
				],
				[
					-32,
					-45
				],
				[
					20,
					-27
				],
				[
					36,
					-19
				],
				[
					28,
					-64
				],
				[
					-7,
					-35
				]
			],
			[
				[
					7005,
					7353
				],
				[
					-4,
					80
				]
			],
			[
				[
					7001,
					7433
				],
				[
					5,
					101
				]
			],
			[
				[
					6902,
					7667
				],
				[
					-45,
					7
				]
			],
			[
				[
					6857,
					7674
				],
				[
					12,
					47
				]
			],
			[
				[
					6921,
					7793
				],
				[
					60,
					-11
				],
				[
					11,
					10
				]
			]
		],
		"transform": {
			"scale": [
				0.0004145531070705779,
				0.0002480636152443112
			],
			"translate": [
				5.878025523533185,
				50.33856106917782
			]
		},
		"objects": {
			"nrw": {
				"type": "GeometryCollection",
				"geometries": [
					{
						"arcs": [
							[
								0,
								1,
								2,
								3,
								4,
								5,
								6,
								7,
								8,
								9
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382020",
							"GEN": "Hennef (Sieg)"
						}
					},
					{
						"arcs": [
							[
								10,
								11,
								12,
								13,
								14,
								15,
								16,
								17,
								18
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05362036",
							"GEN": "Pulheim"
						}
					},
					{
						"arcs": [
							[
								19,
								20,
								21,
								22,
								23,
								24,
								25,
								26,
								27,
								28,
								29,
								30,
								31,
								32,
								33,
								34,
								35,
								36
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05966020",
							"GEN": "Lennestadt"
						}
					},
					{
						"arcs": [
							[
								37,
								38,
								39,
								40,
								41,
								42,
								43,
								44,
								45,
								46,
								47,
								48,
								49,
								50,
								51,
								52
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05962028",
							"GEN": "Kierspe"
						}
					},
					{
						"arcs": [
							[
								53,
								54,
								55,
								56,
								57,
								58,
								59,
								60,
								61,
								62,
								63
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05774016",
							"GEN": "Büren"
						}
					},
					{
						"arcs": [
							[
								64,
								65,
								66,
								67,
								68,
								69,
								70,
								71,
								72
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566040",
							"GEN": "Lengerich"
						}
					},
					{
						"arcs": [
							[
								73,
								74,
								75,
								76,
								77,
								78,
								79,
								80,
								81,
								82,
								83,
								84,
								85,
								86,
								87,
								88,
								89,
								90,
								91,
								92,
								93,
								94,
								95,
								96,
								97,
								98,
								99,
								100,
								101
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05913000",
							"GEN": "Dortmund"
						}
					},
					{
						"arcs": [
							[
								102,
								103,
								104,
								105,
								106,
								107,
								108,
								109,
								110,
								111,
								112,
								113,
								114
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05366032",
							"GEN": "Nettersheim"
						}
					},
					{
						"arcs": [
							[
								115,
								116,
								117,
								118,
								119,
								120,
								121,
								122,
								123,
								124,
								125,
								126,
								127,
								128,
								129,
								130,
								131,
								132,
								133,
								134,
								135
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05774032",
							"GEN": "Paderborn"
						}
					},
					{
						"arcs": [
							[
								136,
								137,
								138,
								139,
								140,
								141,
								142,
								143,
								144,
								145,
								146,
								147,
								148
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05358012",
							"GEN": "Heimbach"
						}
					},
					{
						"arcs": [
							[
								149,
								150,
								151,
								152,
								153,
								154,
								155,
								156,
								157
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05562014",
							"GEN": "Gladbeck"
						}
					},
					{
						"arcs": [
							[
								158,
								159,
								160,
								161,
								162,
								163,
								164,
								165,
								166
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05358040",
							"GEN": "Merzenich"
						}
					},
					{
						"arcs": [
							[
								167,
								168,
								169,
								170,
								171,
								172,
								173,
								174,
								175,
								176,
								177
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154044",
							"GEN": "Rees"
						}
					},
					{
						"arcs": [
							[
								178,
								179,
								180,
								181,
								182,
								-99,
								183,
								184,
								185,
								186,
								187,
								188,
								189,
								190,
								191
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05562036",
							"GEN": "Waltrop"
						}
					},
					{
						"arcs": [
							[
								192,
								193,
								194,
								195,
								196,
								197,
								198,
								199,
								200,
								201,
								202,
								203,
								204,
								205,
								206,
								207
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05366040",
							"GEN": "Weilerswist"
						}
					},
					{
						"arcs": [
							[
								208,
								209,
								210,
								211,
								212,
								213,
								214,
								215,
								216,
								-197,
								217
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382064",
							"GEN": "Swisttal"
						}
					},
					{
						"arcs": [
							[
								218,
								219,
								220,
								221,
								222,
								223,
								224,
								225,
								226,
								227,
								228
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05758020",
							"GEN": "Kirchlengern"
						}
					},
					{
						"arcs": [
							[
								-70,
								229,
								-68,
								230,
								231,
								232,
								233,
								234,
								235,
								236
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566032",
							"GEN": "Ladbergen"
						}
					},
					{
						"arcs": [
							[
								237,
								238,
								239,
								240,
								241,
								242,
								243,
								244,
								245,
								246,
								247,
								248
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05366044",
							"GEN": "Zülpich"
						}
					},
					{
						"arcs": [
							[
								-233,
								249,
								250,
								251,
								252,
								253,
								254,
								255,
								256
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05570032",
							"GEN": "Ostbevern"
						}
					},
					{
						"arcs": [
							[
								257,
								258,
								259,
								260
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554020",
							"GEN": "Gronau (Westf.)"
						}
					},
					{
						"arcs": [
							[
								261,
								262,
								263,
								264,
								265,
								266,
								267,
								268,
								269,
								270,
								271,
								272,
								-179,
								273,
								274,
								275,
								276,
								277,
								278,
								279
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05978032",
							"GEN": "Selm"
						}
					},
					{
						"arcs": [
							[
								280,
								281,
								282,
								283,
								284,
								285,
								286,
								287,
								288,
								289,
								290,
								291,
								292,
								293,
								294,
								295,
								296,
								297,
								298,
								299
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05562016",
							"GEN": "Haltern am See"
						}
					},
					{
						"arcs": [
							[
								300,
								301,
								302,
								303,
								304,
								305,
								306,
								307,
								-59,
								308
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05958012",
							"GEN": "Brilon"
						}
					},
					{
						"arcs": [
							[
								309,
								310,
								311,
								312,
								-163,
								313,
								314,
								315,
								316,
								317,
								318,
								319,
								320,
								321,
								322,
								323
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05358008",
							"GEN": "Düren"
						}
					},
					{
						"arcs": [
							[
								324,
								325,
								326,
								327,
								328,
								329,
								330,
								331,
								332,
								333,
								334,
								335,
								336,
								337,
								338,
								339,
								340,
								341,
								342,
								343,
								344,
								345,
								346,
								347,
								348,
								349,
								350,
								351,
								352,
								353,
								354,
								355,
								356
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05124000",
							"GEN": "Wuppertal"
						}
					},
					{
						"arcs": [
							[
								357,
								358,
								359,
								360,
								361,
								362,
								363,
								364,
								365,
								366,
								367,
								368,
								369,
								370,
								371,
								372,
								373
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05770032",
							"GEN": "Porta Westfalica"
						}
					},
					{
						"arcs": [
							[
								374,
								375,
								376,
								377,
								378,
								379,
								380
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154052",
							"GEN": "Straelen"
						}
					},
					{
						"arcs": [
							[
								381,
								382,
								383,
								384,
								385,
								386,
								387,
								388,
								389,
								390,
								391
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566092",
							"GEN": "Westerkappeln"
						}
					},
					{
						"arcs": [
							[
								-175,
								392,
								393,
								394,
								395,
								396,
								397,
								398,
								399,
								400,
								401,
								402,
								403,
								404,
								405,
								406,
								407
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05170052",
							"GEN": "Xanten"
						}
					},
					{
						"arcs": [
							[
								-105,
								408,
								409,
								-107,
								410
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05366008",
							"GEN": "Blankenheim"
						}
					},
					{
						"arcs": [
							[
								411,
								412,
								413,
								414,
								415,
								416,
								417,
								418,
								419,
								420
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05158020",
							"GEN": "Langenfeld (Rhld.)"
						}
					},
					{
						"arcs": [
							[
								421,
								422,
								423,
								424
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382008",
							"GEN": "Bad Honnef"
						}
					},
					{
						"arcs": [
							[
								425,
								426,
								427,
								428,
								429,
								430,
								431,
								432,
								433,
								434,
								435,
								-127,
								436,
								-125,
								437
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05774012",
							"GEN": "Borchen"
						}
					},
					{
						"arcs": [
							[
								438,
								439,
								440,
								441,
								442,
								443,
								444,
								445,
								446,
								447,
								448,
								449,
								-109,
								450,
								451,
								452,
								453,
								454,
								455,
								456
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05366020",
							"GEN": "Hellenthal"
						}
					},
					{
						"arcs": [
							[
								457,
								458,
								459,
								460,
								461,
								462
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05958028",
							"GEN": "Medebach"
						}
					},
					{
						"arcs": [
							[
								463,
								464,
								465,
								466,
								467,
								468,
								469,
								470,
								471,
								472,
								473
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05974048",
							"GEN": "Welver"
						}
					},
					{
						"arcs": [
							[
								474,
								475,
								476,
								477,
								478,
								479,
								480,
								481,
								482,
								483,
								484,
								485,
								486,
								487,
								488,
								489,
								490
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05970012",
							"GEN": "Erndtebrück"
						}
					},
					{
						"arcs": [
							[
								491,
								492,
								493,
								494,
								495,
								496,
								497,
								498,
								499
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05362040",
							"GEN": "Wesseling"
						}
					},
					{
						"arcs": [
							[
								500,
								501,
								502,
								503,
								504,
								505,
								506,
								507,
								508,
								509,
								510,
								511,
								512,
								513,
								514,
								515,
								516,
								517,
								518,
								519,
								520,
								521,
								522,
								523,
								524
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05515000",
							"GEN": "Münster"
						}
					},
					{
						"arcs": [
							[
								525,
								526,
								527,
								528,
								529,
								530,
								531,
								532,
								533,
								534,
								535,
								536,
								537
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05378004",
							"GEN": "Bergisch Gladbach"
						}
					},
					{
						"arcs": [
							[
								538,
								539,
								540,
								541,
								542,
								543,
								544
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05378008",
							"GEN": "Burscheid"
						}
					},
					{
						"arcs": [
							[
								545,
								546,
								547,
								548,
								549,
								550,
								551,
								552,
								553
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05974044",
							"GEN": "Warstein"
						}
					},
					{
						"arcs": [
							[
								554,
								555,
								556,
								557,
								-3,
								558,
								559,
								560
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382016",
							"GEN": "Eitorf"
						}
					},
					{
						"arcs": [
							[
								561,
								562,
								563,
								564,
								-556,
								565,
								566,
								567,
								568,
								569,
								570
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382076",
							"GEN": "Windeck"
						}
					},
					{
						"arcs": [
							[
								571,
								572,
								573,
								574,
								575,
								576,
								577,
								578,
								579,
								580,
								581,
								582,
								583,
								584,
								585,
								586,
								587,
								588,
								589
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05116000",
							"GEN": "Mönchengladbach"
						}
					},
					{
						"arcs": [
							[
								590,
								591,
								592,
								593,
								594,
								595
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05970008",
							"GEN": "Burbach"
						}
					},
					{
						"arcs": [
							[
								596,
								597,
								598,
								599,
								600,
								601
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05970016",
							"GEN": "Freudenberg"
						}
					},
					{
						"arcs": [
							[
								602,
								603,
								604,
								605,
								606,
								607,
								608
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766052",
							"GEN": "Lügde"
						}
					},
					{
						"arcs": [
							[
								609,
								610,
								611,
								612,
								-589,
								613,
								614,
								615,
								616,
								617,
								618,
								619,
								620
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05166032",
							"GEN": "Viersen"
						}
					},
					{
						"arcs": [
							[
								621,
								622,
								623,
								624,
								625,
								626,
								627,
								628
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154036",
							"GEN": "Kleve"
						}
					},
					{
						"arcs": [
							[
								-615,
								629,
								-587,
								630,
								631,
								632,
								633,
								634,
								635,
								636,
								637
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05166024",
							"GEN": "Schwalmtal"
						}
					},
					{
						"arcs": [
							[
								638,
								639,
								640,
								641,
								642,
								643,
								644,
								645,
								646,
								647,
								648,
								649,
								650,
								651,
								652
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05970024",
							"GEN": "Kreuztal"
						}
					},
					{
						"arcs": [
							[
								653,
								654,
								655,
								656,
								657,
								658,
								659,
								660,
								661,
								662,
								663,
								664,
								665
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05334016",
							"GEN": "Herzogenrath"
						}
					},
					{
						"arcs": [
							[
								666,
								667,
								668
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05370024",
							"GEN": "Selfkant"
						}
					},
					{
						"arcs": [
							[
								669,
								670,
								671,
								672,
								673,
								674,
								675,
								676,
								677,
								678,
								679
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05370016",
							"GEN": "Heinsberg"
						}
					},
					{
						"arcs": [
							[
								680,
								681,
								682,
								683,
								684,
								685,
								686,
								687,
								688,
								689,
								690,
								691,
								692,
								693,
								694
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05358004",
							"GEN": "Aldenhoven"
						}
					},
					{
						"arcs": [
							[
								695,
								696,
								697,
								698,
								699,
								700,
								701,
								-529,
								702,
								703,
								704
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05378012",
							"GEN": "Kürten"
						}
					},
					{
						"arcs": [
							[
								705,
								706,
								707,
								708,
								709,
								-51,
								710,
								-49,
								711,
								-47,
								712,
								713,
								714,
								715,
								716,
								717,
								718,
								719,
								720,
								721
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05962012",
							"GEN": "Halver"
						}
					},
					{
						"arcs": [
							[
								722,
								723,
								724,
								725,
								726,
								727,
								728,
								729,
								730,
								731,
								732,
								733
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05962052",
							"GEN": "Plettenberg"
						}
					},
					{
						"arcs": [
							[
								734,
								735,
								736,
								737,
								738,
								739,
								740,
								741,
								742
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05770044",
							"GEN": "Stemwede"
						}
					},
					{
						"arcs": [
							[
								743,
								744,
								745,
								746,
								747,
								748,
								749,
								750,
								751,
								752,
								753,
								754,
								755,
								-580,
								756,
								-578,
								757,
								-576,
								758,
								759
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05162012",
							"GEN": "Jüchen"
						}
					},
					{
						"arcs": [
							[
								760,
								761,
								762,
								763,
								764,
								765,
								766,
								767,
								768,
								-748,
								769,
								770,
								-745,
								771,
								772,
								773
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05162008",
							"GEN": "Grevenbroich"
						}
					},
					{
						"arcs": [
							[
								774,
								775,
								776,
								777,
								778,
								779,
								780,
								781,
								782,
								783,
								784
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05334032",
							"GEN": "Stolberg (Rhld.)"
						}
					},
					{
						"arcs": [
							[
								785,
								786,
								787,
								788,
								789,
								790,
								791,
								792,
								793,
								794,
								795,
								796,
								797,
								798,
								799
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05158028",
							"GEN": "Ratingen"
						}
					},
					{
						"arcs": [
							[
								800,
								801,
								802,
								803,
								804,
								805,
								-281,
								806,
								807,
								808,
								809,
								810
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05558016",
							"GEN": "Dülmen"
						}
					},
					{
						"arcs": [
							[
								811,
								812,
								813,
								814,
								815,
								-789,
								816,
								817,
								818
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05158012",
							"GEN": "Heiligenhaus"
						}
					},
					{
						"arcs": [
							[
								-603,
								819,
								820,
								821,
								822,
								823,
								824,
								825,
								826,
								827,
								828,
								829
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05762024",
							"GEN": "Marienmünster"
						}
					},
					{
						"arcs": [
							[
								830,
								831,
								832,
								833,
								834,
								835,
								836,
								837,
								838,
								839,
								840,
								841,
								842,
								843,
								844,
								845
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05962040",
							"GEN": "Menden (Sauerland)"
						}
					},
					{
						"arcs": [
							[
								846,
								-342,
								847,
								848,
								849,
								850,
								851,
								852,
								853,
								854,
								855,
								-412,
								856,
								-420,
								857,
								858,
								859,
								860,
								-344
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05122000",
							"GEN": "Solingen"
						}
					},
					{
						"arcs": [
							[
								861,
								862,
								863,
								864,
								865,
								866,
								867,
								868,
								869,
								870
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154048",
							"GEN": "Rheurdt"
						}
					},
					{
						"arcs": [
							[
								871,
								872,
								873,
								874,
								875,
								876,
								877,
								878,
								879,
								-258,
								880
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554024",
							"GEN": "Heek"
						}
					},
					{
						"arcs": [
							[
								881,
								882,
								883,
								884,
								885,
								886,
								887,
								888
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566060",
							"GEN": "Neuenkirchen"
						}
					},
					{
						"arcs": [
							[
								889,
								890,
								891,
								892,
								893,
								894,
								895,
								896
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766004",
							"GEN": "Augustdorf"
						}
					},
					{
						"arcs": [
							[
								897,
								898,
								899,
								900,
								901,
								902,
								903,
								904,
								905,
								906
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05158004",
							"GEN": "Erkrath"
						}
					},
					{
						"arcs": [
							[
								907,
								908,
								909,
								-34,
								910,
								911,
								912,
								913,
								914,
								915,
								916,
								917,
								-729,
								918
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05966004",
							"GEN": "Attendorn"
						}
					},
					{
						"arcs": [
							[
								919,
								920,
								921,
								-582,
								922,
								923,
								-754,
								924,
								925,
								926,
								927,
								928,
								929,
								930,
								931,
								932,
								933,
								934,
								935,
								936,
								937,
								938,
								939
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05370004",
							"GEN": "Erkelenz"
						}
					},
					{
						"arcs": [
							[
								940,
								941,
								942,
								943,
								944,
								945,
								946
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05370028",
							"GEN": "Übach-Palenberg"
						}
					},
					{
						"arcs": [
							[
								-290,
								947,
								948,
								949,
								950,
								951,
								952,
								953,
								954,
								955,
								956,
								957,
								958,
								-292,
								959
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05562024",
							"GEN": "Marl"
						}
					},
					{
						"arcs": [
							[
								960,
								961,
								962,
								963,
								964,
								965,
								966,
								967,
								968,
								-81,
								969
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05978016",
							"GEN": "Holzwickede"
						}
					},
					{
						"arcs": [
							[
								-407,
								970,
								971,
								972,
								973,
								974,
								975,
								976,
								977
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154024",
							"GEN": "Kalkar"
						}
					},
					{
						"arcs": [
							[
								978,
								979,
								980,
								981,
								982,
								983,
								984,
								985,
								986,
								987,
								988,
								989,
								990,
								991,
								992,
								993,
								994
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554012",
							"GEN": "Borken"
						}
					},
					{
						"arcs": [
							[
								995,
								996,
								997,
								998,
								-591,
								999,
								-595,
								1000,
								1001,
								1002,
								1003,
								1004,
								1005,
								1006
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05970044",
							"GEN": "Wilnsdorf"
						}
					},
					{
						"arcs": [
							[
								-28,
								1007,
								1008,
								1009,
								1010,
								-489,
								1011,
								1012,
								1013,
								1014,
								1015,
								1016,
								1017,
								1018,
								1019,
								1020,
								1021,
								-30,
								1022
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05966016",
							"GEN": "Kirchhundem"
						}
					},
					{
						"arcs": [
							[
								1023,
								1024,
								1025,
								-544,
								1026,
								1027,
								-855
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05378016",
							"GEN": "Leichlingen (Rhld.)"
						}
					},
					{
						"arcs": [
							[
								-94,
								1028,
								1029,
								1030,
								1031,
								1032,
								1033,
								1034,
								1035,
								1036,
								1037,
								1038,
								1039,
								1040,
								1041,
								1042,
								1043,
								1044,
								1045,
								1046
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05911000",
							"GEN": "Bochum"
						}
					},
					{
						"arcs": [
							[
								1047,
								1048,
								1049,
								1050,
								1051,
								1052,
								-562,
								1053,
								-570,
								1054,
								1055,
								1056,
								1057,
								1058,
								1059
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05374044",
							"GEN": "Waldbröl"
						}
					},
					{
						"arcs": [
							[
								1060,
								1061,
								1062,
								1063,
								1064,
								1065,
								1066,
								-1050,
								1067,
								1068,
								-1060,
								1069,
								1070,
								1071,
								1072,
								1073,
								1074,
								1075,
								1076,
								1077
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05374040",
							"GEN": "Reichshof"
						}
					},
					{
						"arcs": [
							[
								-43,
								1078,
								1079,
								1080,
								1081,
								1082,
								1083,
								1084,
								1085,
								1086,
								1087,
								1088
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05374024",
							"GEN": "Marienheide"
						}
					},
					{
						"arcs": [
							[
								1089,
								1090,
								1091,
								1092,
								1093,
								1094,
								1095,
								1096,
								-315,
								1097,
								-161,
								1098,
								1099,
								1100
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05358052",
							"GEN": "Nörvenich"
						}
					},
					{
						"arcs": [
							[
								-497,
								1101,
								1102,
								1103,
								1104,
								1105,
								1106,
								1107,
								1108,
								1109,
								1110
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05362012",
							"GEN": "Brühl"
						}
					},
					{
						"arcs": [
							[
								1111,
								1112,
								1113,
								1114,
								1115,
								1116,
								1117,
								1118,
								1119,
								1120
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382060",
							"GEN": "Siegburg"
						}
					},
					{
						"arcs": [
							[
								-254,
								1121,
								1122,
								1123,
								1124,
								1125,
								1126,
								1127,
								1128,
								-503,
								1129,
								1130,
								1131
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05570044",
							"GEN": "Telgte"
						}
					},
					{
						"arcs": [
							[
								1132,
								1133,
								1134,
								1135,
								1136,
								1137,
								-262,
								1138,
								1139,
								1140,
								1141,
								1142,
								1143,
								-283,
								1144,
								-805,
								1145
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05558024",
							"GEN": "Lüdinghausen"
						}
					},
					{
						"arcs": [
							[
								-1115,
								1146,
								-8,
								1147,
								1148,
								1149,
								1150,
								1151,
								1152,
								1153,
								1154
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382056",
							"GEN": "Sankt Augustin"
						}
					},
					{
						"arcs": [
							[
								1155,
								1156,
								-299,
								1157,
								1158,
								1159,
								1160,
								1161,
								1162,
								1163,
								1164,
								1165,
								1166
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554044",
							"GEN": "Reken"
						}
					},
					{
						"arcs": [
							[
								1167,
								1168,
								1169,
								1170,
								-1058,
								1171,
								1172,
								1173
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05374032",
							"GEN": "Nümbrecht"
						}
					},
					{
						"arcs": [
							[
								1174,
								-32,
								1175,
								-1021,
								1176,
								1177,
								1178,
								1179,
								1180,
								1181,
								1182,
								-913,
								1183
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05966024",
							"GEN": "Olpe"
						}
					},
					{
						"arcs": [
							[
								1184,
								-1178,
								1185,
								-649,
								1186,
								-600,
								1187,
								-1063,
								1188,
								1189,
								-1180
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05966028",
							"GEN": "Wenden"
						}
					},
					{
						"arcs": [
							[
								1190,
								1191,
								1192,
								1193,
								1194,
								-1073,
								1195,
								1196,
								1197,
								1198,
								1199,
								1200,
								1201,
								1202,
								-1083,
								1203,
								1204,
								1205,
								1206
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05374012",
							"GEN": "Gummersbach"
						}
					},
					{
						"arcs": [
							[
								-550,
								1207,
								1208,
								1209,
								1210,
								1211,
								1212,
								1213,
								1214,
								1215,
								1216,
								1217,
								1218,
								1219,
								1220,
								1221,
								1222,
								1223,
								1224
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05958032",
							"GEN": "Meschede"
						}
					},
					{
						"arcs": [
							[
								1225,
								1226,
								-1052,
								1227,
								1228,
								-1065
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05374028",
							"GEN": "Morsbach"
						}
					},
					{
						"arcs": [
							[
								1229,
								1230,
								1231,
								-731,
								1232,
								1233,
								1234,
								1235
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05962020",
							"GEN": "Herscheid"
						}
					},
					{
						"arcs": [
							[
								1236,
								1237,
								1238,
								1239,
								-1076,
								1240,
								-1193
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05374004",
							"GEN": "Bergneustadt"
						}
					},
					{
						"arcs": [
							[
								1241,
								-915,
								1242,
								-1182,
								1243,
								1244,
								-1061,
								1245,
								-1238,
								1246,
								-1192,
								1247,
								1248,
								1249
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05966008",
							"GEN": "Drolshagen"
						}
					},
					{
						"arcs": [
							[
								-1013,
								1250,
								-487,
								1251,
								-485,
								1252,
								1253,
								1254,
								1255,
								1256,
								1257,
								1258,
								1259,
								1260,
								-640,
								1261,
								1262,
								1263
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05970020",
							"GEN": "Hilchenbach"
						}
					},
					{
						"arcs": [
							[
								1264,
								1265,
								-1168,
								1266,
								1267,
								1268,
								1269,
								1270,
								1271,
								1272,
								1273,
								1274,
								1275,
								1276,
								1277,
								1278,
								1279
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382036",
							"GEN": "Much"
						}
					},
					{
						"arcs": [
							[
								1280,
								1281,
								-1085,
								1282,
								-1202,
								1283,
								1284,
								1285,
								1286,
								1287,
								1288,
								-701,
								1289,
								-699,
								1290,
								1291,
								1292,
								1293
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05374020",
							"GEN": "Lindlar"
						}
					},
					{
						"arcs": [
							[
								-1276,
								1294,
								1295,
								-1273,
								1296,
								1297,
								1298,
								-1112,
								1299,
								1300,
								1301
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382040",
							"GEN": "Neunkirchen-Seelscheid"
						}
					},
					{
						"arcs": [
							[
								1302,
								-247,
								1303,
								1304,
								1305,
								1306,
								1307,
								1308,
								1309,
								-1094,
								1310,
								-1092
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05358060",
							"GEN": "Vettweiß"
						}
					},
					{
						"arcs": [
							[
								1311,
								1312,
								1313,
								1314,
								1315,
								1316,
								1317,
								1318,
								1319,
								1320
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154064",
							"GEN": "Weeze"
						}
					},
					{
						"arcs": [
							[
								1321,
								1322,
								1323,
								1324,
								-1107,
								1325,
								-205,
								1326,
								-203,
								1327,
								-249,
								1328,
								-1090,
								1329,
								1330,
								1331
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05362020",
							"GEN": "Erftstadt"
						}
					},
					{
						"arcs": [
							[
								1332,
								-1288,
								1333,
								1334,
								1335,
								1336,
								-1278,
								1337,
								1338,
								1339,
								1340,
								1341,
								1342,
								1343,
								-531
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05378024",
							"GEN": "Overath"
						}
					},
					{
						"arcs": [
							[
								1344,
								-716,
								1345,
								-714,
								1346,
								-45,
								1347,
								-1088,
								1348,
								-1086,
								1349,
								-1281,
								1350,
								-1293,
								1351,
								-696,
								1352,
								1353,
								1354,
								1355,
								1356,
								1357
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05374052",
							"GEN": "Wipperfürth"
						}
					},
					{
						"arcs": [
							[
								1358,
								1359,
								-859,
								1360,
								1361,
								1362,
								1363,
								-904,
								1364
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05158016",
							"GEN": "Hilden"
						}
					},
					{
						"arcs": [
							[
								1365,
								1366,
								1367,
								1368,
								1369,
								1370,
								1371,
								1372,
								1373,
								1374,
								1375,
								1376,
								1377,
								1378
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05170020",
							"GEN": "Kamp-Lintfort"
						}
					},
					{
						"arcs": [
							[
								1379,
								1380,
								1381,
								1382,
								1383,
								1384,
								-761,
								1385,
								1386,
								1387,
								1388,
								1389
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05162024",
							"GEN": "Neuss"
						}
					},
					{
						"arcs": [
							[
								-768,
								1390,
								1391,
								1392,
								1393,
								1394,
								1395,
								1396,
								1397,
								1398,
								1399,
								1400,
								-750,
								1401
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05362004",
							"GEN": "Bedburg"
						}
					},
					{
						"arcs": [
							[
								-679,
								1402,
								1403,
								1404,
								1405,
								1406
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05370032",
							"GEN": "Waldfeucht"
						}
					},
					{
						"arcs": [
							[
								1407,
								1408,
								1409,
								1410,
								1411,
								1412,
								1413,
								1414,
								1415,
								1416,
								-686,
								1417,
								-684,
								1418,
								-682,
								1419,
								1420,
								1421,
								1422,
								1423,
								1424,
								1425
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05358024",
							"GEN": "Jülich"
						}
					},
					{
						"arcs": [
							[
								1426,
								1427,
								-692,
								1428,
								1429,
								1430,
								1431,
								-657,
								1432,
								1433,
								1434
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05334004",
							"GEN": "Alsdorf"
						}
					},
					{
						"arcs": [
							[
								1435,
								1436,
								-166,
								1437,
								1438,
								1439,
								-311,
								1440,
								1441,
								1442,
								-1414,
								1443,
								-1412,
								1444,
								1445,
								1446
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05358048",
							"GEN": "Niederzier"
						}
					},
					{
						"arcs": [
							[
								-1173,
								1447,
								1448,
								1449,
								-568,
								1450,
								-560,
								1451,
								-1,
								1452,
								-1298,
								1453,
								-1271,
								1454,
								1455,
								-1268,
								1456
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382052",
							"GEN": "Ruppichteroth"
						}
					},
					{
						"arcs": [
							[
								1457,
								1458,
								1459,
								1460,
								1461,
								1462,
								1463,
								1464,
								1465,
								1466,
								1467,
								1468,
								1469,
								1470,
								1471,
								1472,
								1473,
								1474,
								1475
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05754008",
							"GEN": "Gütersloh"
						}
					},
					{
						"arcs": [
							[
								1476,
								1477,
								1478,
								1479,
								1480,
								1481,
								1482,
								1483,
								1484,
								1485,
								1486,
								1487,
								1488,
								1489,
								1490,
								1491,
								1492,
								1493,
								1494,
								1495
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05762004",
							"GEN": "Bad Driburg"
						}
					},
					{
						"arcs": [
							[
								1496,
								1497,
								1498,
								1499,
								1500,
								1501,
								-1006,
								1502,
								-1004,
								1503,
								1504,
								1505,
								-597,
								1506,
								1507,
								-647,
								1508,
								-645,
								1509
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05970040",
							"GEN": "Siegen"
						}
					},
					{
						"arcs": [
							[
								1510,
								1511,
								1512,
								1513,
								1514,
								1515,
								1516,
								1517,
								-13
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05362024",
							"GEN": "Frechen"
						}
					},
					{
						"arcs": [
							[
								1518,
								1519,
								1520,
								1521,
								1522,
								1523,
								1524,
								1525,
								1526,
								1527,
								1528
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766012",
							"GEN": "Barntrup"
						}
					},
					{
						"arcs": [
							[
								1529,
								1530,
								1531,
								1532,
								-136,
								1533,
								1534,
								1535,
								1536,
								1537,
								1538
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05774024",
							"GEN": "Hövelhof"
						}
					},
					{
						"arcs": [
							[
								1539,
								1540,
								1541,
								1542,
								1543,
								1544,
								1545,
								1546,
								1547,
								1548,
								1549,
								1550,
								1551,
								1552,
								1553,
								1554,
								1555,
								1556,
								1557,
								1558
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05954008",
							"GEN": "Ennepetal"
						}
					},
					{
						"arcs": [
							[
								1559,
								1560,
								1561,
								1562,
								-867,
								1563,
								1564,
								1565,
								1566,
								1567,
								1568
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154028",
							"GEN": "Kerken"
						}
					},
					{
						"arcs": [
							[
								1569,
								1570,
								1571,
								1572,
								1573,
								1574,
								1575,
								1576
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554008",
							"GEN": "Bocholt"
						}
					},
					{
						"arcs": [
							[
								-270,
								1577,
								1578,
								1579,
								1580,
								1581,
								-74,
								1582,
								-101,
								1583,
								-182,
								1584,
								1585,
								-272,
								1586
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05978024",
							"GEN": "Lünen"
						}
					},
					{
						"arcs": [
							[
								1587,
								-934,
								1588,
								1589,
								-931,
								1590,
								1591,
								1592,
								1593,
								1594,
								-671,
								1595,
								1596
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05370020",
							"GEN": "Hückelhoven"
						}
					},
					{
						"arcs": [
							[
								1597,
								1598,
								1599,
								1600,
								1601,
								1602
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554068",
							"GEN": "Vreden"
						}
					},
					{
						"arcs": [
							[
								1603,
								1604,
								1605,
								1606,
								-890,
								1607,
								1608,
								1609,
								1610,
								1611,
								1612,
								1613,
								1614,
								1615,
								1616,
								1617,
								1618
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766040",
							"GEN": "Lage"
						}
					},
					{
						"arcs": [
							[
								1619,
								1620,
								1621,
								1622,
								1623,
								1624,
								1625,
								1626,
								1627,
								1628,
								1629,
								1630,
								-952,
								1631
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05562032",
							"GEN": "Recklinghausen"
						}
					},
					{
						"arcs": [
							[
								1632,
								1633,
								1634,
								1635,
								1636,
								1637,
								1638,
								1639,
								1640,
								1641,
								1642,
								1643,
								1644,
								1645
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05570048",
							"GEN": "Wadersloh"
						}
					},
					{
						"arcs": [
							[
								-967,
								1646,
								1647,
								1648,
								1649,
								1650,
								1651,
								-87,
								1652,
								-85,
								1653,
								-83,
								1654,
								1655
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05978028",
							"GEN": "Schwerte"
						}
					},
					{
						"arcs": [
							[
								-495,
								1656,
								1657,
								1658,
								1659,
								1660,
								1661,
								1662,
								-209,
								1663,
								-195,
								1664,
								-193,
								1665,
								1666,
								1667,
								-1103,
								1668
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382012",
							"GEN": "Bornheim"
						}
					},
					{
						"arcs": [
							[
								1669,
								1670,
								1671,
								1672,
								1673,
								-211,
								1674,
								-1662,
								1675
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382004",
							"GEN": "Alfter"
						}
					},
					{
						"arcs": [
							[
								1676,
								1677,
								-397,
								1678,
								1679,
								1680,
								1681,
								1682,
								-1366,
								1683,
								1684,
								1685,
								1686,
								1687
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05170004",
							"GEN": "Alpen"
						}
					},
					{
						"arcs": [
							[
								1688,
								1689,
								1690,
								1691,
								-845,
								1692,
								-843,
								1693,
								-963,
								1694,
								1695,
								1696
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05978012",
							"GEN": "Fröndenberg/Ruhr"
						}
					},
					{
						"arcs": [
							[
								1697,
								1698,
								-191,
								1699,
								-189,
								1700,
								1701,
								1702,
								1703,
								1704,
								1705,
								-285,
								1706
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05562008",
							"GEN": "Datteln"
						}
					},
					{
						"arcs": [
							[
								-987,
								1707,
								1708,
								1709,
								1710,
								1711,
								1712,
								1713,
								1714,
								1715,
								-989,
								1716
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554040",
							"GEN": "Raesfeld"
						}
					},
					{
						"arcs": [
							[
								1717,
								1718,
								1719,
								-1526,
								1720,
								-1524,
								1721,
								1722,
								1723,
								1724,
								1725,
								1726,
								1727,
								1728,
								1729
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766024",
							"GEN": "Dörentrup"
						}
					},
					{
						"arcs": [
							[
								-1685,
								1730,
								-1378,
								1731,
								-1376,
								1732,
								1733,
								-869,
								1734,
								1735,
								1736,
								1737,
								1738
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154020",
							"GEN": "Issum"
						}
					},
					{
						"arcs": [
							[
								-367,
								1739,
								-365,
								1740,
								1741,
								1742,
								1743,
								1744,
								1745,
								1746,
								1747,
								1748,
								1749,
								1750,
								-369,
								1751
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05758036",
							"GEN": "Vlotho"
						}
					},
					{
						"arcs": [
							[
								1752,
								1753,
								1754,
								1755,
								-1236,
								1756,
								1757,
								-38,
								1758,
								1759,
								1760,
								-708,
								1761,
								1762,
								1763,
								1764
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05962032",
							"GEN": "Lüdenscheid"
						}
					},
					{
						"arcs": [
							[
								-471,
								1765,
								1766,
								1767,
								1768,
								1769,
								1770,
								1771,
								1772,
								1773,
								1774,
								1775,
								1776,
								1777
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05974052",
							"GEN": "Werl"
						}
					},
					{
						"arcs": [
							[
								1778,
								1779,
								1780,
								1781,
								1782,
								1783,
								1784,
								1785,
								1786,
								1787,
								1788,
								-1485,
								1789,
								1790,
								1791,
								1792,
								1793,
								-823
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05762016",
							"GEN": "Brakel"
						}
					},
					{
						"arcs": [
							[
								1794,
								-827,
								1795,
								-825,
								1796,
								-1793,
								1797,
								-1481,
								1798,
								-1479,
								1799,
								-1477,
								1800,
								1801
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05762028",
							"GEN": "Nieheim"
						}
					},
					{
						"arcs": [
							[
								1802,
								1803,
								1804,
								1805,
								-1643,
								1806,
								1807,
								1808,
								1809,
								1810,
								1811,
								1812,
								1813,
								1814,
								1815
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05570008",
							"GEN": "Beckum"
						}
					},
					{
						"arcs": [
							[
								1816,
								1817,
								1818,
								1819,
								1820,
								1821,
								1822,
								-899,
								1823,
								1824,
								1825,
								-792
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05158024",
							"GEN": "Mettmann"
						}
					},
					{
						"arcs": [
							[
								1826,
								1827,
								1828,
								1829,
								1830,
								-476,
								1831,
								-491,
								1832,
								-1009,
								1833,
								1834,
								1835,
								1836,
								1837,
								1838,
								1839
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05970004",
							"GEN": "Bad Berleburg"
						}
					},
					{
						"arcs": [
							[
								-1724,
								1840,
								1841,
								-1520,
								1842,
								1843,
								1844,
								1845,
								1846,
								1847,
								1848,
								1849,
								1850,
								1851,
								1852,
								1853,
								1854
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766016",
							"GEN": "Blomberg"
						}
					},
					{
						"arcs": [
							[
								1855,
								1856,
								1857,
								1858,
								1859,
								1860,
								1861,
								-733,
								1862,
								-1231,
								1863,
								1864,
								-1754,
								1865,
								1866
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05962060",
							"GEN": "Werdohl"
						}
					},
					{
						"arcs": [
							[
								-90,
								1867,
								1868,
								1869,
								1870,
								1871,
								1872,
								1873,
								1874
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05954020",
							"GEN": "Herdecke"
						}
					},
					{
						"arcs": [
							[
								1875,
								1876,
								1877,
								1878,
								1879,
								1880,
								1881,
								1882,
								1883,
								1884,
								1885,
								1886,
								1887,
								1888
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05978008",
							"GEN": "Bönen"
						}
					},
					{
						"arcs": [
							[
								1889,
								1890,
								1891,
								1892,
								1893,
								1894,
								1895,
								1896,
								1897,
								1898,
								1899
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05754048",
							"GEN": "Versmold"
						}
					},
					{
						"arcs": [
							[
								1900,
								1901,
								1902,
								1903,
								1904,
								1905,
								1906,
								1907,
								-355,
								1908,
								1909,
								1910,
								1911,
								1912,
								1913
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05954028",
							"GEN": "Sprockhövel"
						}
					},
					{
						"arcs": [
							[
								1914,
								1915,
								1916,
								1917,
								-1335,
								1918,
								1919,
								-1285,
								1920,
								-1200
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05374008",
							"GEN": "Engelskirchen"
						}
					},
					{
						"arcs": [
							[
								1921,
								1922,
								1923,
								1924,
								-720,
								1925,
								1926,
								1927,
								1928,
								1929,
								1930,
								1931,
								1932,
								1933,
								-1547,
								1934,
								1935,
								-1544,
								1936,
								1937,
								1938,
								1939
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05954004",
							"GEN": "Breckerfeld"
						}
					},
					{
						"arcs": [
							[
								1940,
								-1705,
								1941,
								1942,
								-1621,
								1943,
								-949,
								1944,
								-288,
								1945
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05562028",
							"GEN": "Oer-Erkenschwick"
						}
					},
					{
						"arcs": [
							[
								-1464,
								1946,
								1947,
								1948,
								1949,
								1950,
								1951,
								1952,
								1953,
								1954,
								1955,
								1956,
								1957
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05754028",
							"GEN": "Rheda-Wiedenbrück"
						}
					},
					{
						"arcs": [
							[
								1958,
								1959,
								-1852,
								1960,
								1961,
								1962,
								1963,
								1964,
								1965,
								1966,
								-892,
								1967,
								-1606,
								1968,
								1969,
								1970
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766020",
							"GEN": "Detmold"
						}
					},
					{
						"arcs": [
							[
								-1404,
								1971,
								-677,
								1972,
								1973,
								1974,
								-668,
								1975,
								1976
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05370008",
							"GEN": "Gangelt"
						}
					},
					{
						"arcs": [
							[
								1977,
								-837,
								1978,
								1979,
								1980,
								1981,
								1982,
								1983,
								1984,
								-840,
								1985
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05962016",
							"GEN": "Hemer"
						}
					},
					{
						"arcs": [
							[
								1986,
								-1355,
								1987,
								1988,
								1989,
								1990,
								1991,
								1992,
								1993
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05374016",
							"GEN": "Hückeswagen"
						}
					},
					{
						"arcs": [
							[
								1994,
								1995,
								1996,
								1997,
								1998,
								1999,
								2000,
								2001,
								2002,
								-223,
								2003,
								-221,
								2004,
								2005,
								2006
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05758024",
							"GEN": "Löhne"
						}
					},
					{
						"arcs": [
							[
								2007,
								2008,
								2009,
								2010,
								2011,
								2012,
								-1890,
								2013,
								2014
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05754004",
							"GEN": "Borgholzhausen"
						}
					},
					{
						"arcs": [
							[
								2015,
								2016,
								-417,
								2017,
								2018,
								2019,
								2020,
								2021
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05158026",
							"GEN": "Monheim am Rhein"
						}
					},
					{
						"arcs": [
							[
								2022,
								-1442,
								2023,
								2024,
								-323,
								2025,
								2026,
								2027,
								2028,
								-1416
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05358020",
							"GEN": "Inden"
						}
					},
					{
						"arcs": [
							[
								2029,
								2030,
								2031,
								2032,
								2033,
								2034,
								2035
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566068",
							"GEN": "Ochtrup"
						}
					},
					{
						"arcs": [
							[
								2036,
								2037,
								2038,
								2039,
								2040,
								2041,
								2042,
								2043,
								2044,
								-1892,
								2045,
								-2012,
								2046,
								-2010,
								2047
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05754012",
							"GEN": "Halle (Westf.)"
						}
					},
					{
						"arcs": [
							[
								2048,
								2049,
								2050,
								2051,
								-303,
								2052,
								2053,
								2054,
								2055,
								2056,
								2057,
								2058
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05958024",
							"GEN": "Marsberg"
						}
					},
					{
						"arcs": [
							[
								-1737,
								2059,
								-1561,
								2060,
								-1569,
								2061,
								-381,
								2062,
								2063,
								2064
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154012",
							"GEN": "Geldern"
						}
					},
					{
						"arcs": [
							[
								2065,
								2066,
								2067,
								2068,
								2069,
								2070,
								2071,
								-1981,
								2072,
								2073,
								-835,
								2074
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05962008",
							"GEN": "Balve"
						}
					},
					{
						"arcs": [
							[
								-1141,
								2075,
								-278,
								2076,
								2077,
								-275,
								2078,
								-1698,
								2079,
								-1144,
								2080,
								2081
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05558036",
							"GEN": "Olfen"
						}
					},
					{
						"arcs": [
							[
								-346,
								2082,
								-861,
								2083,
								-1359,
								2084,
								-902,
								2085,
								-1821,
								2086
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05158008",
							"GEN": "Haan"
						}
					},
					{
						"arcs": [
							[
								2087,
								2088,
								2089,
								2090,
								2091,
								2092,
								2093,
								2094,
								2095,
								2096,
								2097,
								2098,
								2099,
								-469,
								2100
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05974040",
							"GEN": "Soest"
						}
					},
					{
						"arcs": [
							[
								2101,
								2102,
								-796,
								2103,
								-794,
								2104,
								-1825,
								2105,
								-907,
								2106,
								2107,
								-1363,
								2108,
								2109,
								-2016,
								2110,
								-2021,
								2111,
								-1382,
								2112,
								-1380,
								2113,
								2114,
								2115,
								2116
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05111000",
							"GEN": "Düsseldorf"
						}
					},
					{
						"arcs": [
							[
								2117,
								2118,
								2119,
								2120,
								2121,
								2122,
								2123,
								2124,
								-1460,
								2125,
								2126,
								2127
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05754044",
							"GEN": "Verl"
						}
					},
					{
						"arcs": [
							[
								2128,
								2129,
								-62,
								2130,
								2131,
								2132,
								2133,
								2134,
								2135,
								2136,
								2137,
								2138,
								2139
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05974020",
							"GEN": "Geseke"
						}
					},
					{
						"arcs": [
							[
								2140,
								2141,
								-694,
								2142,
								-1427,
								2143,
								2144,
								2145,
								-944,
								2146,
								2147,
								2148,
								2149
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05334008",
							"GEN": "Baesweiler"
						}
					},
					{
						"arcs": [
							[
								2150,
								2151,
								-1400,
								2152,
								2153,
								2154,
								2155,
								2156,
								-1446,
								2157,
								-1410,
								2158,
								-1408,
								2159,
								-1425,
								2160,
								2161,
								2162,
								-927
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05358056",
							"GEN": "Titz"
						}
					},
					{
						"arcs": [
							[
								2163,
								2164,
								2165,
								-618,
								2166,
								2167,
								2168,
								2169,
								2170,
								2171,
								-379,
								2172
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05166016",
							"GEN": "Nettetal"
						}
					},
					{
						"arcs": [
							[
								2173,
								-1610,
								2174,
								-1608,
								-897,
								2175,
								2176,
								2177,
								2178,
								2179,
								2180,
								2181
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766056",
							"GEN": "Oerlinghausen"
						}
					},
					{
						"arcs": [
							[
								-1898,
								2182,
								2183,
								2184,
								2185,
								2186
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05570036",
							"GEN": "Sassenberg"
						}
					},
					{
						"arcs": [
							[
								-887,
								2187,
								2188,
								-2036,
								2189
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566096",
							"GEN": "Wettringen"
						}
					},
					{
						"arcs": [
							[
								-633,
								2190,
								2191,
								2192,
								2193,
								2194,
								2195
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05166020",
							"GEN": "Niederkrüchten"
						}
					},
					{
						"arcs": [
							[
								2196,
								2197,
								2198,
								2199,
								2200,
								2201,
								-979,
								2202,
								2203,
								-993,
								2204,
								2205
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554060",
							"GEN": "Südlohn"
						}
					},
					{
						"arcs": [
							[
								2206,
								-1966,
								2207,
								2208,
								2209,
								2210,
								2211,
								2212,
								2213,
								-894
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766064",
							"GEN": "Schlangen"
						}
					},
					{
						"arcs": [
							[
								-1002,
								2214,
								-593,
								2215,
								2216
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05970036",
							"GEN": "Neunkirchen"
						}
					},
					{
						"arcs": [
							[
								2217,
								2218,
								2219,
								2220,
								-36,
								2221,
								-909,
								2222,
								-726,
								2223,
								2224,
								2225
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05966012",
							"GEN": "Finnentrop"
						}
					},
					{
						"arcs": [
							[
								2226,
								-359,
								2227,
								2228,
								-373,
								2229,
								2230,
								2231,
								2232,
								2233
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05770024",
							"GEN": "Minden"
						}
					},
					{
						"arcs": [
							[
								2234,
								2235,
								2236,
								2237,
								2238,
								2239,
								2240,
								2241,
								-738,
								2242,
								2243,
								2244,
								2245
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05770008",
							"GEN": "Espelkamp"
						}
					},
					{
						"arcs": [
							[
								2246,
								2247,
								2248,
								2249,
								2250,
								2251,
								2252,
								2253,
								2254,
								2255
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05166028",
							"GEN": "Tönisvorst"
						}
					},
					{
						"arcs": [
							[
								2256,
								2257,
								2258,
								2259,
								2260,
								-781
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05334024",
							"GEN": "Roetgen"
						}
					},
					{
						"arcs": [
							[
								2263,
								2264,
								2265,
								-103,
								2266,
								2267,
								2268,
								2269,
								2270
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05366004",
							"GEN": "Bad Münstereifel"
						}
					},
					{
						"arcs": [
							[
								-1159,
								2271,
								-297,
								2272,
								2273,
								-294,
								2274,
								-958,
								2275,
								2276,
								2277,
								2278,
								2279,
								2280,
								2281,
								2282,
								2283,
								2284,
								2285,
								2286,
								2287
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05562012",
							"GEN": "Dorsten"
						}
					},
					{
						"arcs": [
							[
								2288,
								2289,
								2290,
								2291,
								2292,
								2293,
								2294,
								2295,
								-1370,
								2296,
								2297
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05170024",
							"GEN": "Moers"
						}
					},
					{
						"arcs": [
							[
								2298,
								2299,
								2300,
								2301,
								-936,
								2302,
								-1597,
								2303,
								2304
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05370036",
							"GEN": "Wassenberg"
						}
					},
					{
						"arcs": [
							[
								2305,
								2306,
								2307,
								2308,
								2309,
								2310,
								2311,
								2312,
								2313,
								2314,
								2315
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05570012",
							"GEN": "Beelen"
						}
					},
					{
						"arcs": [
							[
								2316,
								2317,
								2318,
								2319,
								2320,
								2321,
								2322,
								2323
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382032",
							"GEN": "Meckenheim"
						}
					},
					{
						"arcs": [
							[
								2324,
								2325,
								2326,
								2327,
								2328,
								2329,
								2330,
								2331,
								2332,
								2333,
								2334,
								2335,
								2336,
								-1836,
								2337,
								-26,
								2338,
								-24,
								2339,
								-22,
								2340,
								2341,
								2342,
								-1211
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05958040",
							"GEN": "Schmallenberg"
						}
					},
					{
						"arcs": [
							[
								-478,
								2343,
								-1830,
								2344,
								2345,
								2346,
								2347,
								2348,
								-480,
								2349
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05970028",
							"GEN": "Bad Laasphe"
						}
					},
					{
						"arcs": [
							[
								2350,
								2351,
								2352,
								2353,
								2354,
								2355,
								2356,
								-1633,
								2357,
								-1950
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05754024",
							"GEN": "Langenberg"
						}
					},
					{
						"arcs": [
							[
								-1894,
								2358,
								-2044,
								2359,
								-1473,
								2360,
								-1471,
								2361,
								2362,
								2363,
								2364,
								2365,
								-2306,
								-2184,
								2366,
								-1896,
								2367
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05754016",
							"GEN": "Harsewinkel"
						}
					},
					{
						"arcs": [
							[
								2368,
								-1984,
								2369,
								2370,
								2371,
								2372,
								2373,
								-1866,
								-1753,
								2374,
								2375,
								2376,
								2377,
								2378,
								2379
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05962004",
							"GEN": "Altena"
						}
					},
					{
						"arcs": [
							[
								2380,
								2381,
								2382,
								2383,
								2384,
								2385,
								2386,
								2387,
								2388,
								2389,
								2390,
								2391,
								2392
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05758008",
							"GEN": "Enger"
						}
					},
					{
						"arcs": [
							[
								2393,
								2394,
								-227,
								2395,
								2396,
								2397,
								-2381,
								2398,
								2399,
								2400,
								2401,
								2402
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05758004",
							"GEN": "Bünde"
						}
					},
					{
						"arcs": [
							[
								2403,
								2404,
								2405,
								2406,
								2407
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566072",
							"GEN": "Recke"
						}
					},
					{
						"arcs": [
							[
								2408,
								2409,
								-2231,
								2410,
								2411,
								2412,
								2413,
								-2237,
								2414
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05770012",
							"GEN": "Hille"
						}
					},
					{
						"arcs": [
							[
								2415,
								2416,
								-2319,
								2417,
								2418
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382072",
							"GEN": "Wachtberg"
						}
					},
					{
						"arcs": [
							[
								2419,
								2420,
								2421,
								2422,
								2423,
								-505,
								2424,
								-1128,
								2425,
								-1126,
								2426,
								2427
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05570024",
							"GEN": "Everswinkel"
						}
					},
					{
						"arcs": [
							[
								-1629,
								2428,
								2429,
								2430,
								2431,
								-954,
								2432,
								2433
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05562020",
							"GEN": "Herten"
						}
					},
					{
						"arcs": [
							[
								-1576,
								2434,
								2435,
								2436,
								-170,
								2437,
								-168,
								2438
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554032",
							"GEN": "Isselburg"
						}
					},
					{
						"arcs": [
							[
								-2122,
								2439,
								2440,
								2441,
								2442,
								2443,
								2444,
								2445,
								-2353,
								2446,
								2447,
								-1948,
								2448,
								2449,
								2450
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05754032",
							"GEN": "Rietberg"
						}
					},
					{
						"arcs": [
							[
								-972,
								2451,
								2452,
								2453,
								2454,
								2455,
								2456,
								2457,
								2458,
								2459
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154056",
							"GEN": "Uedem"
						}
					},
					{
						"arcs": [
							[
								-2407,
								2460,
								2461,
								2462,
								2463
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566020",
							"GEN": "Hopsten"
						}
					},
					{
						"arcs": [
							[
								2464,
								2465,
								-1046,
								2466,
								-1044,
								2467,
								2468,
								-1041,
								2469,
								2470,
								2471,
								-1628,
								2472,
								2473
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05916000",
							"GEN": "Herne"
						}
					},
					{
						"arcs": [
							[
								2474,
								2475,
								2476,
								2477,
								-1763,
								2478,
								-706,
								2479,
								2480,
								-1924,
								2481,
								2482
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05962056",
							"GEN": "Schalksmühle"
						}
					},
					{
						"arcs": [
							[
								2483,
								-1528,
								2484,
								-1719,
								2485,
								2486,
								2487
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766028",
							"GEN": "Extertal"
						}
					},
					{
						"arcs": [
							[
								2488,
								-2402,
								2489
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05758028",
							"GEN": "Rödinghausen"
						}
					},
					{
						"arcs": [
							[
								2490,
								2491,
								2492,
								2493,
								2494,
								2495,
								2496
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382044",
							"GEN": "Niederkassel"
						}
					},
					{
						"arcs": [
							[
								2497,
								2498,
								-1728,
								2499,
								-1726,
								2500,
								-1854,
								2501,
								-1959,
								2502,
								-1970,
								2503,
								-1604,
								2504,
								2505,
								2506,
								2507,
								2508,
								2509
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766044",
							"GEN": "Lemgo"
						}
					},
					{
						"arcs": [
							[
								-1776,
								2510,
								2511,
								2512,
								-1689,
								2513,
								-1696,
								2514,
								-961,
								2515,
								2516,
								-78,
								2517,
								2518,
								2519,
								-1882,
								2520,
								-1880,
								2521
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05978036",
							"GEN": "Unna"
						}
					},
					{
						"arcs": [
							[
								2522,
								2523,
								-1886,
								2524,
								-1884,
								2525,
								-2519,
								2526,
								-76,
								2527,
								2528,
								2529,
								2530,
								2531,
								2532
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05978020",
							"GEN": "Kamen"
						}
					},
					{
						"arcs": [
							[
								-975,
								2533,
								2534,
								2535,
								2536,
								2537,
								2538,
								2539,
								-624,
								2540
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154004",
							"GEN": "Bedburg-Hau"
						}
					},
					{
						"arcs": [
							[
								-2364,
								2541,
								2542,
								-1469,
								2543,
								2544,
								2545,
								-1956,
								2546,
								2547,
								2548,
								-2309,
								2549
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05754020",
							"GEN": "Herzebrock-Clarholz"
						}
					},
					{
						"arcs": [
							[
								2550,
								2551,
								2552,
								2553,
								2554,
								2555,
								2556,
								2557,
								2558
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566036",
							"GEN": "Laer"
						}
					},
					{
						"arcs": [
							[
								-1259,
								2559,
								-1257,
								2560,
								-1255,
								2561,
								-482,
								2562,
								-2348,
								2563,
								-2346,
								2564,
								-998,
								2565,
								-996,
								2566,
								-1501,
								2567,
								-1499,
								2568,
								2569,
								-642,
								2570,
								2571
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05970032",
							"GEN": "Netphen"
						}
					},
					{
						"arcs": [
							[
								-1034,
								2572,
								2573,
								2574,
								-1912,
								2575,
								-1910,
								2576,
								2577,
								2578,
								2579,
								2580,
								2581,
								2582,
								2583
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05954016",
							"GEN": "Hattingen"
						}
					},
					{
						"arcs": [
							[
								2584,
								2585,
								2586,
								2587,
								2588,
								2589,
								2590,
								-2102,
								2591,
								-2116,
								2592,
								2593,
								2594,
								2595,
								2596,
								-2292,
								2597,
								-2290,
								2598,
								2599,
								2600,
								2601
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05112000",
							"GEN": "Duisburg"
						}
					},
					{
						"arcs": [
							[
								2602,
								2603,
								-2378,
								2604,
								-2476,
								2605,
								2606,
								2607,
								2608,
								2609
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05962044",
							"GEN": "Nachrodt-Wiblingwerde"
						}
					},
					{
						"arcs": [
							[
								-991,
								2610,
								2611,
								2612,
								2613,
								2614,
								-1570,
								2615
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554048",
							"GEN": "Rhede"
						}
					},
					{
						"arcs": [
							[
								-2234,
								2616,
								2617,
								-2409,
								2618
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05770028",
							"GEN": "Petershagen"
						}
					},
					{
						"arcs": [
							[
								-225,
								2619,
								2620,
								2621,
								-2385,
								2622,
								-2383,
								2623,
								-2397,
								2624
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05758016",
							"GEN": "Hiddenhausen"
						}
					},
					{
						"arcs": [
							[
								-2462,
								2625,
								2626,
								2627,
								2628,
								2629,
								2630,
								2631,
								2632,
								2633,
								2634,
								2635
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566016",
							"GEN": "Hörstel"
						}
					},
					{
						"arcs": [
							[
								-2548,
								2636,
								-1954,
								2637,
								-1952,
								2638,
								-1645,
								2639,
								-1805,
								2640,
								2641,
								2642,
								2643,
								2644,
								-2311,
								2645
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05570028",
							"GEN": "Oelde"
						}
					},
					{
						"arcs": [
							[
								2646,
								2647,
								2648,
								2649,
								-2551,
								2650,
								2651,
								2652,
								2653,
								2654,
								2655
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566084",
							"GEN": "Steinfurt"
						}
					},
					{
						"arcs": [
							[
								-305,
								2656,
								2657,
								2658,
								2659,
								2660,
								2661,
								2662,
								2663,
								2664,
								-307,
								2665
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05958036",
							"GEN": "Olsberg"
						}
					},
					{
						"arcs": [
							[
								2666,
								2667,
								2668,
								2669,
								2670,
								2671,
								2672,
								2673,
								2674,
								2675,
								-2049,
								2676,
								2677,
								2678,
								-429,
								2679,
								-427,
								2680,
								-122,
								2681,
								2682
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05774028",
							"GEN": "Lichtenau"
						}
					},
					{
						"arcs": [
							[
								2683,
								2684,
								-1475,
								2685,
								-2042,
								2686,
								-2040,
								2687
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05754040",
							"GEN": "Steinhagen"
						}
					},
					{
						"arcs": [
							[
								2688,
								2689,
								2690,
								2691,
								2692,
								2693,
								2694,
								2695,
								2696,
								2697,
								2698,
								2699,
								2700,
								2701,
								2702,
								2703,
								-1680,
								2704,
								2705,
								-394,
								2706,
								2707
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05170048",
							"GEN": "Wesel"
						}
					},
					{
						"arcs": [
							[
								2708,
								2709,
								2710,
								-1109,
								2711,
								-1324,
								2712,
								2713,
								2714,
								-1514,
								2715,
								2716,
								2717
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05362028",
							"GEN": "Hürth"
						}
					},
					{
						"arcs": [
							[
								2718,
								2719,
								2720,
								2721,
								-2165,
								2722,
								2723,
								2724,
								2725,
								2726,
								2727
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05166008",
							"GEN": "Grefrath"
						}
					},
					{
						"arcs": [
							[
								2728,
								2729,
								2730,
								2731,
								2732,
								-2197,
								2733,
								-1600,
								2734,
								2735,
								2736
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554056",
							"GEN": "Stadtlohn"
						}
					},
					{
						"arcs": [
							[
								2737,
								2738,
								2739,
								2740,
								2741,
								-1558,
								2742,
								-1903,
								2743,
								2744
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05954012",
							"GEN": "Gevelsberg"
						}
					},
					{
						"arcs": [
							[
								-841,
								-1985,
								-2369,
								2745,
								2746,
								-2603,
								2747,
								-2609,
								2748,
								2749,
								2750,
								-1650,
								2751,
								-1648,
								2752,
								-965,
								2753
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05962024",
							"GEN": "Iserlohn"
						}
					},
					{
						"arcs": [
							[
								2754,
								2755,
								2756,
								2757,
								-146,
								2758,
								-144,
								2759,
								2760,
								2761,
								2762,
								2763,
								2764,
								2765,
								-2258,
								2766,
								2767,
								2768
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05334028",
							"GEN": "Simmerath"
						}
					},
					{
						"arcs": [
							[
								-2652,
								2770,
								-2558,
								2771,
								2772,
								2773,
								2774,
								2775,
								-2654,
								2776
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566024",
							"GEN": "Horstmar"
						}
					},
					{
						"arcs": [
							[
								-2554,
								2777,
								2778,
								2779,
								2780,
								2781,
								2782,
								2783,
								2784,
								2785,
								2786,
								2787,
								2788
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05558008",
							"GEN": "Billerbeck"
						}
					},
					{
						"arcs": [
							[
								2789,
								2790,
								-1038,
								2791,
								-1036,
								2792,
								-2583,
								2793,
								2794,
								2795,
								2796,
								2797,
								-818,
								2798,
								-787,
								2799,
								2800,
								2801,
								2802,
								2803,
								2804,
								2805,
								2806
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05113000",
							"GEN": "Essen"
						}
					},
					{
						"arcs": [
							[
								2807,
								2808,
								-1387,
								2809,
								-773,
								2810,
								-760,
								2811,
								-574,
								2812,
								2813,
								2814
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05162020",
							"GEN": "Korschenbroich"
						}
					},
					{
						"arcs": [
							[
								2815,
								2816,
								2817,
								2818,
								2819,
								2820,
								2821,
								2822,
								2823,
								2824,
								2825,
								2826,
								2827
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05558004",
							"GEN": "Ascheberg"
						}
					},
					{
						"arcs": [
							[
								2828,
								2829,
								-2530,
								2830,
								2831,
								2832,
								2833,
								2834,
								2835,
								2836,
								2837
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05978004",
							"GEN": "Bergkamen"
						}
					},
					{
						"arcs": [
							[
								2838,
								2839,
								-1614,
								2840,
								-1612,
								2841,
								2842,
								2843,
								-2180,
								2844,
								2845,
								2846,
								2847,
								2848
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766048",
							"GEN": "Leopoldshöhe"
						}
					},
					{
						"arcs": [
							[
								-2487,
								2849,
								-1730,
								2850,
								-2498,
								2851,
								2852,
								-1742,
								2853,
								-363,
								2854,
								-361,
								2855
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766036",
							"GEN": "Kalletal"
						}
					},
					{
						"arcs": [
							[
								2856,
								2857,
								2858,
								2859,
								2860,
								2861,
								2862,
								2863,
								2864,
								-884,
								2865,
								2866,
								2867,
								2868,
								2869
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566008",
							"GEN": "Emsdetten"
						}
					},
					{
						"arcs": [
							[
								-410,
								2870,
								-452,
								2871
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05366012",
							"GEN": "Dahlem"
						}
					},
					{
						"arcs": [
							[
								2872,
								2873,
								2874,
								-518,
								2875,
								2876,
								2877,
								2878,
								2879,
								2880,
								2881,
								-2781,
								2882,
								2883
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05558020",
							"GEN": "Havixbeck"
						}
					},
					{
						"arcs": [
							[
								2884,
								2885,
								-1219,
								2886,
								2887,
								2888,
								-2225,
								2889,
								2890,
								2891,
								2892,
								-2069,
								2893,
								-2067,
								2894,
								2895
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05958044",
							"GEN": "Sundern (Sauerland)"
						}
					},
					{
						"arcs": [
							[
								2896,
								-1213,
								2897,
								-2342,
								2898,
								-20,
								2899,
								-2220,
								2900,
								-2218,
								2901,
								-2888,
								2902,
								-1217,
								2903,
								-1215
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05958016",
							"GEN": "Eslohe (Sauerland)"
						}
					},
					{
						"arcs": [
							[
								2904,
								2905,
								2906,
								-2269,
								2907,
								-2267,
								-115,
								2908,
								-113,
								2909,
								2910,
								2911,
								2912,
								2913,
								2914,
								2915,
								-140,
								2916,
								-242
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05366028",
							"GEN": "Mechernich"
						}
					},
					{
						"arcs": [
							[
								2917,
								-1372,
								2918,
								-2295,
								2919,
								2920,
								2921,
								2922,
								2923,
								2924,
								2925,
								2926,
								2927
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05170028",
							"GEN": "Neukirchen-Vluyn"
						}
					},
					{
						"arcs": [
							[
								-1163,
								2928,
								-1161,
								2929,
								-2287,
								2930,
								-985,
								2931,
								2932,
								2933,
								2934
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554028",
							"GEN": "Heiden"
						}
					},
					{
						"arcs": [
							[
								2935,
								2936,
								2937,
								2938,
								2939,
								2940,
								-1770,
								2941,
								-1768,
								2942,
								-2098,
								2943
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05974012",
							"GEN": "Ense"
						}
					},
					{
						"arcs": [
							[
								2944,
								2945,
								-1389,
								2946,
								-2808,
								2947,
								2948,
								2949,
								2950,
								2951
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05162016",
							"GEN": "Kaarst"
						}
					},
					{
						"arcs": [
							[
								-2923,
								2952,
								2953,
								2954,
								-2255,
								2955,
								-2253,
								2956,
								2957,
								2958,
								2959,
								2960,
								-865,
								2961
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05166012",
							"GEN": "Kempen"
						}
					},
					{
						"arcs": [
							[
								-2825,
								2962,
								2963,
								2964,
								-266,
								2965,
								-264,
								2966,
								-1137,
								2967
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05558028",
							"GEN": "Nordkirchen"
						}
					},
					{
						"arcs": [
							[
								2968,
								2969,
								2970,
								2971,
								2972,
								2973,
								2974,
								-1783,
								2975,
								2976,
								-1780,
								2977,
								-821,
								2978
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05762020",
							"GEN": "Höxter"
						}
					},
					{
						"arcs": [
							[
								2979,
								2980,
								2981,
								2982,
								2983,
								2984,
								2985,
								2986,
								2987,
								2988,
								2989,
								2990,
								2991,
								-1787,
								2992,
								-1785,
								2993
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05762012",
							"GEN": "Borgentreich"
						}
					},
					{
						"arcs": [
							[
								-462,
								2994,
								-460,
								2995,
								2996,
								2997,
								2998,
								2999,
								-1839,
								3000,
								-2335,
								3001,
								-2333,
								3002,
								-2331,
								3003,
								-2329,
								3004,
								3005,
								-2660,
								3006,
								-2658,
								3007
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05958048",
							"GEN": "Winterberg"
						}
					},
					{
						"arcs": [
							[
								[
									-2762,
									3008,
									3009,
									3010,
									-454,
									3011,
									-2765,
									3012,
									3013
								]
							],
							[
								[
									3014
								]
							]
						],
						"type": "MultiPolygon",
						"properties": {
							"AGS": "05334020",
							"GEN": "Monschau"
						}
					},
					{
						"arcs": [
							[
								-1772,
								3015,
								-2940,
								3016,
								3017,
								3018,
								3019,
								3020,
								3021,
								3022,
								3023,
								-1691,
								3024,
								3025,
								3026
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05974056",
							"GEN": "Wickede (Ruhr)"
						}
					},
					{
						"arcs": [
							[
								3027,
								-1651,
								3028,
								3029,
								3030,
								-2607,
								3031,
								-2483,
								3032,
								-1922,
								3033,
								-1939,
								3034,
								3035,
								-1542,
								3036,
								-1540,
								3037,
								-2741,
								3038,
								3039,
								3040,
								-1869,
								3041
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05914000",
							"GEN": "Hagen"
						}
					},
					{
						"arcs": [
							[
								-1574,
								3042,
								-1572,
								3043,
								3044,
								-2613,
								3045,
								3046,
								3047,
								3048,
								3049,
								-2689,
								3050,
								-172,
								3051,
								-2436,
								3052
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05170012",
							"GEN": "Hamminkeln"
						}
					},
					{
						"arcs": [
							[
								-2662,
								3053,
								3054,
								-2326,
								3055,
								-1209,
								3056,
								3057
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05958008",
							"GEN": "Bestwig"
						}
					},
					{
						"arcs": [
							[
								3058,
								-2239,
								3059,
								-2413,
								3060,
								3061,
								3062,
								3063
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05770020",
							"GEN": "Lübbecke"
						}
					},
					{
						"arcs": [
							[
								3064,
								3065,
								-382,
								3066
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566048",
							"GEN": "Lotte"
						}
					},
					{
						"arcs": [
							[
								3067,
								-1309,
								3068,
								-1307,
								3069,
								3070,
								3071,
								3072,
								3073,
								-317,
								3074,
								-1096
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05358028",
							"GEN": "Kreuzau"
						}
					},
					{
						"arcs": [
							[
								-2633,
								3075,
								-2631,
								-2869,
								3076,
								-2867,
								3077,
								-882,
								3078,
								3079,
								3080
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566076",
							"GEN": "Rheine"
						}
					},
					{
						"arcs": [
							[
								-2697,
								3081,
								3082,
								3083,
								3084,
								3085,
								3086,
								3087,
								3088,
								-2699,
								3089
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05170044",
							"GEN": "Voerde (Niederrhein)"
						}
					},
					{
						"arcs": [
							[
								-2071,
								3090,
								-2892,
								3091,
								-723,
								3092,
								-1861,
								3093,
								-1859,
								3094,
								-1857,
								3095,
								-2372,
								3096,
								3097,
								3098
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05962048",
							"GEN": "Neuenrade"
						}
					},
					{
						"arcs": [
							[
								-2031,
								3099,
								-2776,
								3100,
								3101,
								3102,
								3103,
								-2033,
								3104
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566052",
							"GEN": "Metelen"
						}
					},
					{
						"arcs": [
							[
								3105,
								3106,
								3107,
								-1814,
								3108,
								-1812,
								3109,
								3110,
								3111,
								3112,
								3113,
								3114,
								3115,
								3116,
								3117,
								3118,
								3119,
								3120,
								3121,
								3122,
								3123,
								3124,
								3125
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05570004",
							"GEN": "Ahlen"
						}
					},
					{
						"arcs": [
							[
								3126,
								3127,
								3128,
								-351,
								3129,
								3130,
								-1817,
								3131,
								-814,
								3132
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05158036",
							"GEN": "Wülfrath"
						}
					},
					{
						"arcs": [
							[
								3133,
								3134,
								3135,
								3136,
								3137,
								3138,
								-2038,
								3139,
								3140,
								-2008,
								3141
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05754052",
							"GEN": "Werther (Westf.)"
						}
					},
					{
						"arcs": [
							[
								-2969,
								3142,
								-2982,
								3143,
								-2980,
								3144,
								3145,
								-2973,
								3146,
								-2971,
								3147
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05762008",
							"GEN": "Beverungen"
						}
					},
					{
						"arcs": [
							[
								-507,
								3148,
								-2423,
								3149,
								3150,
								3151,
								3152,
								3153,
								3154,
								3155,
								-509,
								3156
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05570040",
							"GEN": "Sendenhorst"
						}
					},
					{
						"arcs": [
							[
								-2235,
								3157,
								-2245,
								3158,
								-735,
								3159
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05770040",
							"GEN": "Rahden"
						}
					},
					{
						"arcs": [
							[
								3160,
								-1516,
								3161,
								-2714,
								3162,
								-1322,
								3163,
								-1331,
								3164,
								-1100,
								3165,
								-159,
								3166,
								3167,
								3168,
								3169
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05362032",
							"GEN": "Kerpen"
						}
					},
					{
						"arcs": [
							[
								-1397,
								3170,
								3171,
								3172,
								-3168,
								3173,
								-1436,
								3174,
								-2156,
								3175,
								3176,
								3177,
								3178
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05362016",
							"GEN": "Elsdorf"
						}
					},
					{
						"arcs": [
							[
								3179,
								-321,
								3180,
								3181,
								3182,
								-777,
								3183,
								3184,
								3185
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05358032",
							"GEN": "Langerwehe"
						}
					},
					{
						"arcs": [
							[
								-2785,
								3186,
								3187,
								-809,
								3188,
								3189,
								3190,
								3191,
								3192,
								3193,
								3194
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05558012",
							"GEN": "Coesfeld"
						}
					},
					{
						"arcs": [
							[
								-2701,
								3195,
								3196,
								3197,
								-2600,
								3198,
								3199,
								3200,
								-1368,
								3201,
								-1682,
								3202,
								-2703,
								3203
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05170032",
							"GEN": "Rheinberg"
						}
					},
					{
						"arcs": [
							[
								3204,
								3205,
								3206,
								3207,
								3208,
								-2585,
								3209,
								3210,
								-3087,
								3211,
								3212,
								3213
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05170008",
							"GEN": "Dinslaken"
						}
					},
					{
						"arcs": [
							[
								3214,
								-231,
								-67,
								3215
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566044",
							"GEN": "Lienen"
						}
					},
					{
						"arcs": [
							[
								-955,
								3216,
								3217,
								-2430,
								3218,
								-2471,
								3219,
								-1039,
								3220,
								-2790,
								3221,
								-150,
								3222,
								3223,
								-2278,
								3224
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05513000",
							"GEN": "Gelsenkirchen"
						}
					},
					{
						"arcs": [
							[
								3225,
								3226,
								3227,
								3228,
								-546,
								3229,
								3230,
								3231,
								3232,
								3233,
								3234,
								3235,
								3236
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05974004",
							"GEN": "Anröchte"
						}
					},
					{
						"arcs": [
							[
								-2556,
								3237,
								-2788,
								3238,
								3239,
								-3194,
								3240,
								3241,
								3242,
								3243,
								3244,
								-2773,
								3245
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05558040",
							"GEN": "Rosendahl"
						}
					},
					{
						"arcs": [
							[
								3246,
								3247,
								3248,
								3249,
								3250,
								3251,
								3252,
								3253,
								3254,
								-3084,
								3255,
								-2694,
								3256,
								-2692,
								3257,
								3258
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05170016",
							"GEN": "Hünxe"
						}
					},
					{
						"arcs": [
							[
								3259,
								3260,
								-537,
								3261,
								-535,
								3262,
								3263,
								3264,
								-2491,
								3265,
								-2496,
								3266,
								-492,
								3267,
								-499,
								3268,
								-2709,
								3269,
								-2717,
								3270,
								-1512,
								3271,
								-11,
								3272,
								3273,
								3274,
								3275,
								3276
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05315000",
							"GEN": "Köln"
						}
					},
					{
						"arcs": [
							[
								-2801,
								3277,
								-800,
								3278,
								3279,
								-2589,
								3280,
								3281,
								3282
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05117000",
							"GEN": "Mülheim an der Ruhr"
						}
					},
					{
						"arcs": [
							[
								-2861,
								3283,
								-2859,
								3284,
								3285,
								3286,
								3287,
								3288,
								3289,
								-235,
								3290,
								-256,
								-1131,
								3291,
								-501,
								3292,
								-524,
								3293,
								3294,
								3295,
								3296,
								3297,
								3298
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566012",
							"GEN": "Greven"
						}
					},
					{
						"arcs": [
							[
								-3116,
								3299,
								-3114,
								3300,
								3301,
								3302,
								-474,
								3303,
								3304,
								3305,
								-1878,
								3306,
								-1876,
								3307,
								3308,
								3309,
								3310,
								3311,
								3312,
								3313,
								3314,
								3315,
								-2819,
								3316,
								3317,
								3318,
								-3118,
								3319
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05915000",
							"GEN": "Hamm"
						}
					},
					{
						"arcs": [
							[
								-260,
								3320,
								3321,
								-878,
								3322,
								-2729,
								3323,
								-2736,
								3324,
								-1598,
								3325,
								3326
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554004",
							"GEN": "Ahaus"
						}
					},
					{
						"arcs": [
							[
								3327,
								-18,
								3328,
								-16,
								3329,
								3330,
								3331,
								-766,
								3332,
								3333
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05162028",
							"GEN": "Rommerskirchen"
						}
					},
					{
						"arcs": [
							[
								3334,
								-1305,
								3335,
								-245,
								3336,
								-137,
								3337,
								-148,
								3338,
								-2757,
								3339,
								3340,
								3341,
								3342,
								3343,
								-3071
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05358044",
							"GEN": "Nideggen"
						}
					},
					{
						"arcs": [
							[
								3344,
								-1702,
								3345,
								-187,
								3346,
								-185,
								-97,
								3347,
								3348,
								-2465,
								3349,
								3350,
								-1626,
								3351,
								-1624,
								3352
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05562004",
							"GEN": "Castrop-Rauxel"
						}
					},
					{
						"arcs": [
							[
								3353,
								3354,
								-2914,
								3355,
								3356,
								3357,
								-443,
								3358,
								-441,
								3359,
								-439,
								3360,
								-456,
								3361,
								-3010,
								3362,
								-2761,
								3363,
								-142
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05366036",
							"GEN": "Schleiden"
						}
					},
					{
						"arcs": [
							[
								-1549,
								3364,
								-1933,
								3365,
								3366,
								3367,
								3368,
								-1928,
								3369,
								3370,
								-718,
								3371,
								3372,
								-1357,
								3373,
								3374,
								-1993,
								3375,
								3376,
								-331,
								3377,
								-1551,
								3378
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05374036",
							"GEN": "Radevormwald"
						}
					},
					{
						"arcs": [
							[
								3379,
								-3315,
								3380,
								-3313,
								3381,
								3382,
								-2838,
								3383,
								-2836,
								3384,
								-2834,
								3385,
								3386,
								3387,
								3388,
								-2964,
								3389,
								-2823,
								3390,
								-2821
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05978040",
							"GEN": "Werne"
						}
					},
					{
						"arcs": [
							[
								-2094,
								3391,
								3392,
								3393,
								-552,
								3394,
								3395,
								3396,
								3397,
								3398,
								-2936,
								-2096,
								3399
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05974032",
							"GEN": "Möhnesee"
						}
					},
					{
						"arcs": [
							[
								-2389,
								3400,
								3401,
								3402,
								-2847,
								3403,
								3404,
								-2178,
								3405,
								-2118,
								3406,
								-2127,
								3407,
								-1458,
								3408,
								-2684,
								3409,
								-3138,
								3410,
								-3136,
								3411,
								3412,
								3413
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05711000",
							"GEN": "Bielefeld"
						}
					},
					{
						"arcs": [
							[
								-431,
								3414,
								-2678,
								3415,
								-2058,
								3416,
								-2056,
								3417,
								-2054,
								3418,
								-301,
								3419,
								-57,
								3420
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05774040",
							"GEN": "Bad Wünnenberg"
						}
					},
					{
						"arcs": [
							[
								3421,
								-111,
								3422,
								-449,
								3423,
								-447,
								3424,
								-445,
								3425,
								-3357,
								3426,
								3427,
								-2911
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05366024",
							"GEN": "Kall"
						}
					},
					{
						"arcs": [
							[
								3428,
								3429,
								3430,
								3431,
								3432,
								-3242,
								3433,
								-3323,
								-877,
								3434
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554036",
							"GEN": "Legden"
						}
					},
					{
						"arcs": [
							[
								3435,
								3436,
								-1995,
								3437,
								-2006,
								3438,
								-219,
								3439,
								3440,
								-2394,
								3441,
								3442,
								3443,
								-3062,
								3444
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05770016",
							"GEN": "Hüllhorst"
						}
					},
					{
						"arcs": [
							[
								3445,
								3446,
								3447,
								3448,
								3449,
								-3226,
								3450,
								-3236,
								3451,
								-3234,
								3452,
								3453,
								3454,
								3455,
								3456,
								3457,
								3458
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05974016",
							"GEN": "Erwitte"
						}
					},
					{
						"arcs": [
							[
								3459,
								3460,
								-1530,
								3461,
								-1538,
								3462,
								-2120,
								3463
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05754036",
							"GEN": "Schloß Holte-Stukenbrock"
						}
					},
					{
						"arcs": [
							[
								-1071,
								3464,
								-1170,
								3465,
								-1265,
								3466,
								3467,
								-1916,
								3468,
								-1198,
								3469,
								3470
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05374048",
							"GEN": "Wiehl"
						}
					},
					{
						"arcs": [
							[
								-1151,
								3471,
								3472,
								3473,
								-2416,
								3474,
								3475,
								-2317,
								3476,
								-1671,
								3477,
								-1659,
								3478,
								3479
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05314000",
							"GEN": "Bonn"
						}
					},
					{
						"arcs": [
							[
								-2456,
								3480,
								3481,
								3482,
								-2064,
								3483,
								-1318,
								3484,
								-1316,
								3485,
								-1314,
								3486,
								-1312,
								3487
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154032",
							"GEN": "Kevelaer"
						}
					},
					{
						"arcs": [
							[
								3488,
								-585,
								3489,
								3490,
								-921,
								3491,
								3492,
								-939,
								3493,
								3494,
								-2301,
								3495,
								-2299,
								3496,
								3497,
								-2192,
								3498
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05370040",
							"GEN": "Wegberg"
						}
					},
					{
						"arcs": [
							[
								3499,
								-402,
								3500,
								-1686,
								-1739,
								3501,
								-3482,
								3502,
								-2454,
								3503,
								3504
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05170040",
							"GEN": "Sonsbeck"
						}
					},
					{
						"arcs": [
							[
								3505,
								-3276,
								3506,
								-3274,
								3507,
								-3328,
								3508,
								-763,
								3509,
								-1384,
								3510
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05162004",
							"GEN": "Dormagen"
						}
					},
					{
						"arcs": [
							[
								3511,
								3512,
								3513,
								3514,
								-2949,
								3515,
								-2814,
								3516,
								-572,
								3517,
								3518,
								3519
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05166036",
							"GEN": "Willich"
						}
					},
					{
						"arcs": [
							[
								3520,
								3521,
								-3456,
								3522,
								-3454,
								3523,
								-3232,
								3524,
								-3393,
								3525,
								-2092,
								3526,
								-2090,
								3527,
								3528,
								3529,
								3530
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05974008",
							"GEN": "Bad Sassendorf"
						}
					},
					{
						"arcs": [
							[
								3531,
								3532,
								-2578,
								3533,
								-353,
								3534,
								-3129,
								3535,
								-3127,
								3536,
								-812,
								3537,
								-2797,
								3538,
								-2795,
								3539,
								-2581
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05158032",
							"GEN": "Velbert"
						}
					},
					{
						"arcs": [
							[
								3540,
								3541,
								-2596,
								3542,
								-2594,
								3543,
								3544,
								3545,
								3546,
								3547,
								-3512,
								3548,
								-2247,
								3549,
								-2954,
								3550,
								-2921
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05114000",
							"GEN": "Krefeld"
						}
					},
					{
						"arcs": [
							[
								3551,
								-2945,
								3552,
								-2951,
								3553,
								-3514,
								3554,
								-3547,
								3555,
								3556,
								3557
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05162022",
							"GEN": "Meerbusch"
						}
					},
					{
						"arcs": [
							[
								-1343,
								3558,
								-1341,
								3559,
								3560,
								3561,
								3562,
								3563,
								-3264,
								3564,
								-533,
								3565
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05378028",
							"GEN": "Rösrath"
						}
					},
					{
						"arcs": [
							[
								-516,
								3566,
								-2827,
								3567,
								-1135,
								3568,
								-1133,
								3569,
								3570,
								3571,
								3572,
								3573,
								-2877,
								3574
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05558044",
							"GEN": "Senden"
						}
					},
					{
						"arcs": [
							[
								-665,
								3575,
								3576,
								3577,
								3578,
								-783,
								3579,
								-2260,
								3580
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05334002",
							"GEN": "Aachen"
						}
					},
					{
						"arcs": [
							[
								3581,
								3582,
								-1802,
								3583,
								-1495,
								3584,
								3585,
								3586,
								3587,
								3588
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05762032",
							"GEN": "Steinheim"
						}
					},
					{
						"arcs": [
							[
								-1848,
								3589,
								3590,
								3591,
								-3586,
								3592,
								3593,
								3594,
								3595,
								3596,
								3597,
								-2210,
								3598,
								3599,
								-1964,
								3600,
								-1962,
								3601,
								-1850,
								3602
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766032",
							"GEN": "Horn-Bad Meinberg"
						}
					},
					{
						"arcs": [
							[
								-929,
								3603,
								-2162,
								3604,
								-1423,
								3605,
								-1421,
								3606,
								3607,
								-2141,
								3608,
								3609,
								3610,
								3611,
								-1592,
								3612
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05358036",
							"GEN": "Linnich"
						}
					},
					{
						"arcs": [
							[
								3613,
								3614,
								-1989,
								3615,
								3616,
								3617,
								3618,
								3619,
								3620,
								3621,
								3622,
								3623,
								-852,
								3624,
								3625,
								3626
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05378032",
							"GEN": "Wermelskirchen"
						}
					},
					{
						"arcs": [
							[
								-1234,
								3627,
								-917,
								3628,
								3629,
								-1249,
								3630,
								3631,
								3632,
								-1205,
								3633,
								-1081,
								3634,
								-40,
								3635,
								3636
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05962036",
							"GEN": "Meinerzhagen"
						}
					},
					{
						"arcs": [
							[
								3637,
								-2169,
								3638,
								-635,
								3639,
								3640,
								3641,
								3642
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05166004",
							"GEN": "Brüggen"
						}
					},
					{
						"arcs": [
							[
								-2002,
								3643,
								-1747,
								3644,
								3645,
								3646,
								-3402,
								3647,
								-2387,
								3648,
								-2621,
								3649
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05758012",
							"GEN": "Herford"
						}
					},
					{
						"arcs": [
							[
								-177,
								3650
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154008",
							"GEN": "Emmerich am Rhein"
						}
					},
					{
						"arcs": [
							[
								-389,
								3651,
								-387,
								3652,
								3653,
								3654,
								3655,
								-2404,
								3656,
								-391,
								3657
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566056",
							"GEN": "Mettingen"
						}
					},
					{
						"arcs": [
							[
								3658,
								3659,
								3660,
								3661,
								-2644,
								3662,
								3663,
								-1816,
								3664,
								-3107,
								3665,
								3666,
								-3125,
								3667,
								3668,
								3669,
								3670,
								3671,
								3672,
								3673
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05570020",
							"GEN": "Ennigerloh"
						}
					},
					{
						"arcs": [
							[
								-688,
								3674,
								-2028,
								3675,
								-3185,
								3676,
								-775,
								3677,
								3678,
								3679,
								3680,
								3681,
								3682,
								-690,
								3683
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05334012",
							"GEN": "Eschweiler"
						}
					},
					{
						"arcs": [
							[
								-2323,
								3684,
								-2321,
								3685,
								3686,
								3687,
								3688,
								3689,
								3690,
								3691,
								-214,
								3692,
								-1673
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382048",
							"GEN": "Rheinbach"
						}
					},
					{
						"arcs": [
							[
								-1535,
								3693,
								-134,
								3694,
								3695,
								3696,
								3697,
								3698,
								3699,
								3700,
								3701,
								-2441,
								3702,
								3703
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05774020",
							"GEN": "Delbrück"
						}
					},
					{
						"arcs": [
							[
								-2212,
								3704,
								3705,
								3706,
								3707,
								-117,
								3708,
								-1532,
								3709,
								3710
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05774008",
							"GEN": "Bad Lippspringe"
						}
					},
					{
						"arcs": [
							[
								3711,
								3712,
								3713,
								3714,
								3715,
								-1165,
								3716,
								3717,
								-2933,
								3718,
								-983,
								3719,
								-981,
								3720,
								-2201,
								3721
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554064",
							"GEN": "Velen"
						}
					},
					{
						"arcs": [
							[
								-3331,
								3722,
								-14,
								-1518,
								3723,
								-3170,
								3724,
								-3172,
								3725,
								-1395,
								3726,
								-1393,
								3727
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05362008",
							"GEN": "Bergheim"
						}
					},
					{
						"arcs": [
							[
								-1594,
								3728,
								-3611,
								3729,
								-2148,
								3730,
								-942,
								3731,
								-947,
								-1974,
								3732,
								-675,
								3733,
								-673,
								3734
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05370012",
							"GEN": "Geilenkirchen"
						}
					},
					{
						"arcs": [
							[
								-2133,
								3735,
								3736,
								-60,
								3737,
								3738,
								-2663,
								-3058,
								3739,
								-548,
								3740,
								-3228,
								3741,
								-3449,
								3742
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05974036",
							"GEN": "Rüthen"
						}
					},
					{
						"arcs": [
							[
								3743,
								-1810,
								3744,
								-1808,
								3745,
								3746,
								-1640,
								3747,
								3748,
								3749,
								3750,
								3751,
								-3529,
								3752,
								-2088,
								3753,
								-467,
								3754,
								-465,
								3755,
								3756,
								3757
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05974024",
							"GEN": "Lippetal"
						}
					},
					{
						"arcs": [
							[
								-2881,
								3758,
								-2879,
								3759,
								-3573,
								3760,
								-801,
								3761,
								-810,
								-3188,
								3762,
								-2783,
								3763
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05558032",
							"GEN": "Nottuln"
						}
					},
					{
						"arcs": [
							[
								-335,
								3764,
								-333,
								3765,
								3766,
								-1991,
								3767,
								-3614,
								3768,
								-3626,
								3769,
								3770,
								-849,
								3771,
								-340,
								3772,
								-338,
								3773,
								3774
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05120000",
							"GEN": "Remscheid"
						}
					},
					{
						"arcs": [
							[
								3775,
								-5,
								3776,
								-422,
								3777,
								-424,
								3778,
								-3473,
								3779,
								-1149,
								3780
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382024",
							"GEN": "Königswinter"
						}
					},
					{
						"arcs": [
							[
								3781,
								3782,
								3783,
								-3289,
								3784,
								3785,
								-3286,
								3786,
								-2857,
								3787,
								3788
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566080",
							"GEN": "Saerbeck"
						}
					},
					{
						"arcs": [
							[
								-628,
								3789,
								3790
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154040",
							"GEN": "Kranenburg"
						}
					},
					{
						"arcs": [
							[
								-740,
								3791,
								-2241,
								-3064,
								3792,
								-3443,
								3793,
								-742,
								3794
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05770036",
							"GEN": "Preußisch Oldendorf"
						}
					},
					{
						"arcs": [
							[
								-1712,
								3795,
								-1710,
								3796,
								-2284,
								3797,
								3798,
								3799,
								-3249,
								3800,
								-3247,
								3801,
								3802,
								3803
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05170036",
							"GEN": "Schermbeck"
						}
					},
					{
						"arcs": [
							[
								-1566,
								3804,
								-2959,
								3805,
								3806,
								-2725,
								3807,
								-377,
								3808
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154060",
							"GEN": "Wachtendonk"
						}
					},
					{
						"arcs": [
							[
								-3102,
								3809,
								-2774,
								3810,
								-3244,
								3811,
								3812,
								-3431,
								3813,
								-3429,
								3814,
								3815,
								-874,
								3816
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554052",
							"GEN": "Schöppingen"
						}
					},
					{
						"arcs": [
							[
								-2537,
								3817,
								3818,
								3819,
								-2458,
								3820,
								-1320,
								3821,
								3822,
								-626,
								3823,
								-2539,
								3824
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05154016",
							"GEN": "Goch"
						}
					},
					{
						"arcs": [
							[
								-1339,
								3825,
								-1301,
								-1120,
								3826,
								3827,
								3828,
								-3562,
								3829,
								3830
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382028",
							"GEN": "Lohmar"
						}
					},
					{
						"arcs": [
							[
								-458,
								3831,
								-1828,
								3832,
								3833,
								-2999,
								3834,
								-2997,
								3835
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05958020",
							"GEN": "Hallenberg"
						}
					},
					{
						"arcs": [
							[
								3836,
								3837,
								3838,
								3839,
								-1117,
								3840,
								-1153,
								3841,
								-2492,
								3842
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05382068",
							"GEN": "Troisdorf"
						}
					},
					{
						"arcs": [
							[
								-3695,
								3843,
								-132,
								3844,
								-130,
								3845,
								3846,
								-435,
								3847,
								-433,
								3848,
								-55,
								3849,
								-64,
								3850,
								-2129,
								3851,
								3852,
								3853,
								3854,
								3855,
								3856,
								-3697,
								3857
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05774036",
							"GEN": "Salzkotten"
						}
					},
					{
						"arcs": [
							[
								-1844,
								3858,
								3859,
								-607,
								3860,
								-605,
								3861,
								-829,
								3862,
								-3582,
								3863,
								-3588,
								3864,
								-3591,
								3865,
								-1846,
								3866
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766060",
							"GEN": "Schieder-Schwalenberg"
						}
					},
					{
						"arcs": [
							[
								-2405,
								-3656,
								3867,
								-3654,
								3868,
								-385,
								3869,
								3870,
								-3783,
								3871,
								-2627,
								3872
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566028",
							"GEN": "Ibbenbüren"
						}
					},
					{
						"arcs": [
							[
								3873,
								3874,
								-2508,
								3875,
								-2506,
								3876,
								-1618,
								3877,
								-1616,
								3878,
								-2839,
								3879,
								3880,
								-3646,
								3881,
								-1745
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05766008",
							"GEN": "Bad Salzuflen"
						}
					},
					{
						"arcs": [
							[
								3882,
								3883,
								-3154,
								3884,
								3885,
								-3120,
								3886,
								-3318,
								3887,
								3888,
								-2816,
								3889,
								-514,
								3890,
								-512,
								3891
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05570016",
							"GEN": "Drensteinfurt"
						}
					},
					{
						"arcs": [
							[
								-3065,
								3892,
								-65,
								3893,
								-72,
								3894,
								3895,
								-3870,
								-384
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566088",
							"GEN": "Tecklenburg"
						}
					},
					{
						"arcs": [
							[
								-3596,
								3896,
								-3594,
								3897,
								-1493,
								3898,
								-1491,
								-2683,
								3899,
								-120,
								3900,
								3901,
								-3707,
								3902
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05774004",
							"GEN": "Altenbeken"
						}
					},
					{
						"arcs": [
							[
								-2186,
								3903,
								-2315,
								3904,
								-3659,
								3905,
								3906,
								-3672,
								3907,
								-3670,
								3908,
								-2421,
								3909,
								3910,
								-1123,
								3911,
								-252,
								3912
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05570052",
							"GEN": "Warendorf"
						}
					},
					{
						"arcs": [
							[
								-3619,
								3913,
								-703,
								-528,
								3914,
								-526,
								3915,
								3916,
								3917,
								3918
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05378020",
							"GEN": "Odenthal"
						}
					},
					{
						"arcs": [
							[
								3919,
								-201,
								3920,
								-199,
								3921,
								-216,
								3922,
								-3692,
								3923,
								-3690,
								3924,
								-3688,
								3925,
								-2264,
								3926,
								-2270,
								3927,
								-2906,
								3928,
								-240,
								3929
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05366016",
							"GEN": "Euskirchen"
						}
					},
					{
						"arcs": [
							[
								-659,
								3930,
								-1431,
								3931,
								-3681,
								3932,
								-3577,
								3933,
								3934,
								-662,
								3935,
								3936
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05334036",
							"GEN": "Würselen"
						}
					},
					{
						"arcs": [
							[
								3937,
								-2803,
								3938,
								-3282,
								3939,
								-2587,
								3940,
								-3208,
								3941,
								-3206,
								3942,
								3943
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05119000",
							"GEN": "Oberhausen"
						}
					},
					{
						"arcs": [
							[
								-1487,
								3944,
								-1788,
								-2992,
								3945,
								-2990,
								3946,
								-2988,
								3947,
								-2986,
								3948,
								3949,
								3950,
								-2670,
								3951,
								-2668,
								-1489,
								3952
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05762040",
							"GEN": "Willebadessen"
						}
					},
					{
						"arcs": [
							[
								-3950,
								3953,
								-2984,
								3954,
								-2051,
								3955,
								-2675,
								3956,
								3957,
								-2672,
								3958
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05762036",
							"GEN": "Warburg"
						}
					},
					{
						"arcs": [
							[
								-2938,
								3959,
								-3398,
								3960,
								-3396,
								3961,
								-1224,
								3962,
								-1222,
								3963,
								-2896,
								3964,
								3965,
								-833,
								3966,
								-3021,
								3967,
								3968,
								-3018,
								3969
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05958004",
							"GEN": "Arnsberg"
						}
					},
					{
						"arcs": [
							[
								-2400,
								3970,
								-2392,
								3971,
								3972,
								3973,
								3974,
								-3134,
								3975
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05758032",
							"GEN": "Spenge"
						}
					},
					{
						"arcs": [
							[
								3976,
								-1556,
								3977,
								-1554,
								3978,
								-328,
								3979,
								-326,
								3980,
								-1905
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05954024",
							"GEN": "Schwelm"
						}
					},
					{
						"arcs": [
							[
								-92,
								3981,
								-1874,
								3982,
								3983,
								3984,
								-1901,
								3985,
								3986,
								-2574,
								-1032,
								3987,
								-1030,
								3988
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05954036",
							"GEN": "Witten"
						}
					},
					{
						"arcs": [
							[
								3989,
								3990,
								-1871,
								3991,
								-3040,
								3992,
								-2739,
								3993,
								3994,
								-2744,
								-1902,
								-3985,
								3995
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05954032",
							"GEN": "Wetter (Ruhr)"
						}
					},
					{
						"arcs": [
							[
								-543,
								3996,
								-541,
								3997,
								-3917,
								3998,
								-3260,
								3999,
								4000,
								-415,
								4001,
								4002,
								4003
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05316000",
							"GEN": "Leverkusen"
						}
					},
					{
						"arcs": [
							[
								-3192,
								4004,
								4005,
								-3714,
								4006,
								-3712,
								4007,
								4008,
								-2731,
								4009
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05554016",
							"GEN": "Gescher"
						}
					},
					{
						"arcs": [
							[
								-2863,
								4010,
								-3298,
								4011,
								4012,
								4013,
								4014,
								4015,
								4016,
								4017,
								4018,
								4019
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566064",
							"GEN": "Nordwalde"
						}
					},
					{
						"arcs": [
							[
								4020,
								-3699,
								4021,
								-3856,
								4022,
								-3854,
								4023,
								-2138,
								4024,
								4025,
								4026,
								4027,
								-3446,
								4028,
								-3458,
								4029,
								-3521,
								4030,
								-3750,
								4031,
								4032,
								4033,
								-1637,
								4034,
								-1635,
								4035,
								-2356,
								4036
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05974028",
							"GEN": "Lippstadt"
						}
					},
					{
						"arcs": [
							[
								-2281,
								4037,
								-155,
								4038,
								-153,
								4039,
								-2805,
								4040,
								-3944,
								4041,
								4042,
								4043,
								4044,
								4045
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05512000",
							"GEN": "Bottrop"
						}
					},
					{
						"arcs": [
							[
								4046,
								4047,
								-4014,
								4048,
								-3295,
								4049,
								4050,
								-521,
								4051,
								-2873,
								4052,
								4053,
								-2779,
								4054,
								-2552,
								4055,
								-4017
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05566004",
							"GEN": "Altenberge"
						}
					},
					{
						"arcs": [
							[
								-319,
								4056,
								-3073,
								4057,
								-3343,
								4058,
								4059,
								4060,
								-2755,
								4061,
								-2768,
								4062,
								-779,
								4063,
								-3182,
								4064
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05358016",
							"GEN": "Hürtgenwald"
						}
					},
					{
						"arcs": [
							[
								4065,
								-371,
								4066,
								-1750,
								4067,
								4068,
								-1998,
								4069,
								4070,
								-3436,
								4071
							]
						],
						"type": "Polygon",
						"properties": {
							"AGS": "05770004",
							"GEN": "Bad Oeynhausen"
						}
					}
				]
			}
		},
		"crs": {
			"type": "name",
			"properties": {
				"name": "urn:ogc:def:crs:OGC:1.3:CRS84"
			}
		}
	};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	module.exports = "ags,t,m,f,ags,pwi,pwa,pwn,wi,wa,wn,pwi_h,pwa_h,pwn_h,search\n05111000,612178,295896,316282,05111000,8.9,5.8,3.1,54669,35525,19144,\"6.7,8.5,8.6,8.9,9.1,9.2,9.3,9.3,9.4,9.4,9.2,9.1,8.9\",\"5.0,5.9,5.9,6.0,6.0,6.0,6.1,6.0,6.0,5.9,6.1,6.0,5.8\",\"1.7,2.6,2.7,2.9,3.1,3.2,3.3,3.3,3.4,3.4,3.1,3.1,3.1\",\"düsseldorf, stadt\"\n05112000,491231,241417,249814,05112000,8.5,6.3,2.2,41813,31151,10662,\"6.7,7.9,8.1,8.3,8.6,8.7,8.8,8.8,8.9,8.9,8.7,8.8,8.5\",\"5.7,6.3,6.3,6.5,6.5,6.5,6.6,6.5,6.5,6.5,6.6,6.7,6.3\",\"1.0,1.6,1.7,1.8,2.0,2.2,2.3,2.3,2.4,2.4,2.1,2.2,2.2\",\"duisburg, stadt\"\n05113000,582624,282565,300059,05113000,8.7,6.4,2.3,50674,37211,13463,\"6.5,7.8,7.8,8.1,8.3,8.5,8.8,8.9,9.0,9.1,8.9,9.0,8.7\",\"5.4,6.0,6.0,6.2,6.2,6.3,6.4,6.5,6.5,6.5,6.7,6.7,6.4\",\"1.1,1.8,1.8,2.0,2.1,2.3,2.4,2.5,2.6,2.6,2.2,2.3,2.3\",\"essen, stadt\"\n05114000,225144,109487,115657,05114000,9.7,6.8,2.9,21928,15373,6555,\"6.9,8.4,8.4,8.8,9.1,9.4,9.5,9.6,9.6,10.1,9.9,9.9,9.7\",\"5.5,6.3,6.3,6.4,6.6,6.7,6.7,6.7,6.6,6.9,7.1,7.0,6.8\",\"1.3,2.0,2.2,2.4,2.5,2.7,2.7,2.8,2.9,3.2,2.8,2.9,2.9\",\"krefeld, stadt\"\n05116000,259996,127512,132484,05116000,10.3,7.1,3.2,26669,18472,8197,\"7.4,9.0,9.0,9.4,9.7,9.9,10.1,10.2,10.5,10.5,10.5,10.4,10.3\",\"6.0,6.9,6.8,7.0,7.1,7.1,7.2,7.2,7.3,7.2,7.5,7.3,7.1\",\"1.4,2.1,2.3,2.4,2.6,2.9,2.9,3.0,3.3,3.3,3.0,3.1,3.2\",\"mönchengladbach, stadt\"\n05117000,169278,81461,87817,05117000,8.7,6.2,2.5,14694,10465,4229,\"6.9,8.2,8.3,8.6,8.8,9.0,9.3,9.4,9.3,9.3,9.1,9.0,8.7\",\"5.6,6.3,6.3,6.5,6.5,6.5,6.7,6.7,6.6,6.5,6.6,6.5,6.2\",\"1.2,1.9,1.9,2.1,2.3,2.5,2.6,2.7,2.8,2.8,2.5,2.5,2.5\",\"mülheim an der ruhr, stadt\"\n05119000,210934,103284,107650,05119000,9.0,6.7,2.2,18889,14196,4693,\"6.9,8.2,8.2,8.5,8.7,8.9,9.2,9.3,9.4,9.3,9.3,9.3,9.0\",\"5.9,6.5,6.5,6.6,6.6,6.7,6.9,6.9,6.9,6.9,7.1,7.1,6.7\",\"1.1,1.6,1.7,1.9,2.1,2.2,2.3,2.4,2.5,2.5,2.2,2.2,2.2\",\"oberhausen, stadt\"\n05120000,109499,53725,55774,05120000,10.5,6.9,3.5,11448,7570,3878,\"8.3,9.8,9.7,10.3,10.6,10.8,10.4,10.9,11.0,10.8,10.6,10.7,10.5\",\"6.3,7.0,6.9,7.1,7.2,7.3,7.1,7.4,7.3,7.0,7.1,7.1,6.9\",\"2.0,2.8,2.9,3.2,3.4,3.6,3.4,3.4,3.8,3.8,3.5,3.6,3.5\",\"remscheid, stadt\"\n05122000,158726,76948,81778,05122000,9.8,6.4,3.4,15546,10121,5425,\"7.5,9.0,8.9,9.3,9.7,10.0,9.6,9.8,10.0,10.1,10.0,10.2,9.8\",\"5.8,6.5,6.3,6.5,6.6,6.7,6.5,6.6,6.5,6.5,6.7,6.8,6.4\",\"1.7,2.5,2.6,2.8,3.0,3.3,3.1,3.2,3.4,3.6,3.3,3.4,3.4\",\"solingen, klingenstadt\"\n05124000,350046,170822,179224,05124000,9.5,6.6,2.9,33360,23110,10250,\"7.3,8.6,8.7,9.1,9.4,9.6,9.7,9.7,9.8,10.0,9.8,9.8,9.5\",\"5.7,6.3,6.4,6.5,6.6,6.7,6.8,6.7,6.6,6.7,7.0,6.9,6.6\",\"1.6,2.3,2.4,2.6,2.8,3.0,2.9,3.1,3.2,3.2,2.8,2.9,2.9\",\"wuppertal, stadt\"\n05154004,13033,6701,6332,05154004,9.9,6.7,3.2,1292,870,422,\"7.2,9.1,9.3,9.6,10.2,10.1,10.2,10.0,10.1,10.7,10.4,10.3,9.9\",\"5.9,7.0,7.0,7.2,7.5,7.3,7.2,7.0,7.1,7.4,7.3,7.1,6.7\",\"1.3,2.1,2.3,2.4,2.7,2.9,3.1,3.1,3.0,3.3,3.1,3.2,3.2\",bedburg-hau\n05154008,30968,15705,15263,05154008,9.7,7.3,2.5,3011,2250,761,\"8.8,9.9,10.2,10.7,10.8,10.8,10.8,10.5,10.6,10.4,10.4,10.5,9.7\",\"7.4,7.9,8.1,8.3,8.3,8.1,8.0,7.8,7.8,7.6,8.0,8.0,7.3\",\"1.4,2.0,2.1,2.4,2.6,2.7,2.8,2.7,2.7,2.8,2.4,2.5,2.5\",\"emmerich am rhein, stadt\"\n05154012,33841,17037,16804,05154012,11.1,7.8,3.3,3770,2648,1122,\"9.2,10.7,10.7,11.6,11.6,12.0,12.3,12.3,12.3,12.5,12.3,12.1,11.1\",\"7.6,8.4,8.2,8.7,8.5,8.7,8.7,8.7,8.7,8.7,9.0,8.6,7.8\",\"1.5,2.3,2.5,3.0,3.1,3.3,3.6,3.6,3.6,3.8,3.3,3.4,3.3\",\"geldern, stadt\"\n05154016,33889,16990,16899,05154016,11.1,7.7,3.3,3745,2626,1119,\"8.7,10.0,10.1,10.4,10.8,11.1,11.4,11.4,11.3,11.7,11.8,11.7,11.1\",\"7.3,8.0,8.0,8.0,8.2,8.3,8.4,8.3,8.2,8.3,8.6,8.4,7.7\",\"1.4,2.0,2.2,2.4,2.6,2.8,3.0,3.1,3.1,3.4,3.2,3.3,3.3\",\"goch, stadt\"\n05154020,12037,5896,6141,05154020,11.0,7.9,3.1,1321,953,368,\"8.4,10.2,10.0,10.6,10.8,11.1,11.4,11.5,11.7,11.4,11.3,11.4,11.0\",\"7.0,8.1,8.0,8.2,8.3,8.4,8.5,8.5,8.4,8.2,8.6,8.6,7.9\",\"1.3,2.1,2.0,2.4,2.5,2.6,2.8,3.0,3.3,3.2,2.7,2.8,3.1\",issum\n05154024,13854,6884,6970,05154024,12.8,9.3,3.5,1775,1291,484,\"9.5,10.9,11.0,11.3,12.0,12.0,12.8,12.8,13.2,13.2,13.2,13.4,12.8\",\"8.0,8.7,8.6,8.6,9.1,9.0,9.6,9.3,9.4,9.3,9.8,10.0,9.3\",\"1.6,2.2,2.3,2.7,2.9,3.0,3.2,3.5,3.8,3.9,3.4,3.4,3.5\",\"kalkar, stadt\"\n05154028,13262,6670,6592,05154028,10.1,7.2,2.9,1338,957,381,\"8.3,9.9,10.0,10.3,10.7,11.0,11.2,11.8,11.3,11.3,10.9,11.3,10.1\",\"7.0,7.7,7.8,7.9,8.1,8.3,8.4,8.5,8.2,8.3,8.0,8.3,7.2\",\"1.4,2.1,2.3,2.4,2.6,2.7,2.8,3.2,3.1,3.0,3.0,3.0,2.9\",kerken\n05154032,28311,13925,14386,05154032,11.8,8.5,3.3,3334,2394,940,\"9.3,10.9,11.1,11.6,12.0,12.5,12.8,12.9,12.7,12.9,12.9,12.9,11.8\",\"7.8,8.8,8.8,9.0,9.1,9.4,9.7,9.5,9.5,9.3,9.5,9.4,8.5\",\"1.5,2.1,2.3,2.6,2.9,3.1,3.2,3.4,3.3,3.6,3.4,3.6,3.3\",\"kevelaer, stadt\"\n05154036,49729,24457,25272,05154036,10.8,7.7,3.1,5385,3849,1536,\"8.4,9.9,10.0,10.4,10.6,10.9,10.7,10.6,10.8,11.2,11.2,11.2,10.8\",\"6.9,7.7,7.7,7.9,8.0,8.0,7.8,7.7,7.7,7.9,8.2,8.1,7.7\",\"1.5,2.2,2.3,2.5,2.6,2.9,2.9,2.9,3.1,3.3,3.0,3.1,3.1\",\"kleve, stadt\"\n05154040,10648,5444,5204,05154040,10.0,6.9,3.0,1061,740,321,\"7.6,9.1,9.1,9.7,9.6,9.9,9.7,9.9,10.1,10.4,10.3,10.5,10.0\",\"6.6,7.2,7.1,7.2,7.2,7.3,7.0,6.9,7.0,7.0,7.1,7.2,6.9\",\"1.0,1.9,2.0,2.5,2.4,2.5,2.7,2.9,3.1,3.4,3.2,3.2,3.0\",kranenburg\n05154044,21349,10608,10741,05154044,12.1,8.9,3.2,2581,1895,686,\"8.9,10.0,9.9,10.5,11.0,11.1,11.3,11.5,11.9,12.1,12.2,12.2,12.1\",\"7.5,7.9,7.9,8.2,8.6,8.5,8.5,8.5,8.7,8.9,9.2,9.1,8.9\",\"1.5,2.1,2.0,2.3,2.4,2.7,2.8,3.0,3.2,3.2,3.0,3.0,3.2\",\"rees, stadt\"\n05154048,6709,3327,3382,05154048,9.5,7.0,2.5,636,467,169,\"6.6,8.5,9.1,9.4,9.5,9.0,9.2,9.5,9.7,9.6,9.8,9.8,9.5\",\"5.6,6.7,7.2,7.2,7.0,6.6,7.0,7.1,7.2,7.1,7.5,7.3,7.0\",\"1.1,1.8,1.9,2.2,2.5,2.4,2.2,2.4,2.5,2.6,2.3,2.5,2.5\",rheurdt\n05154052,15641,7768,7873,05154052,12.7,8.6,4.2,1993,1341,652,\"10.5,12.8,12.6,13.1,13.1,13.2,13.8,13.9,14.5,14.0,14.0,13.8,12.7\",\"8.5,9.7,9.5,9.5,9.5,9.4,9.7,9.7,9.9,9.3,9.4,9.2,8.6\",\"2.0,3.1,3.1,3.6,3.6,3.8,4.1,4.3,4.6,4.7,4.6,4.6,4.2\",\"straelen, stadt\"\n05154056,8266,4111,4155,05154056,11.5,7.9,3.6,950,649,301,\"8.2,9.9,10.3,10.5,10.7,11.2,11.7,12.4,12.7,12.3,12.3,12.3,11.5\",\"7.1,8.0,8.0,7.9,7.7,8.3,8.4,8.9,8.8,8.4,8.8,8.7,7.9\",\"1.1,1.9,2.3,2.5,2.9,2.9,3.3,3.6,3.9,3.9,3.5,3.6,3.6\",uedem\n05154060,8189,4115,4074,05154060,11.1,7.7,3.4,913,632,281,\"8.5,9.8,10.3,11.1,11.1,12.0,12.5,11.9,11.4,11.6,11.8,11.7,11.1\",\"7.3,7.9,7.9,8.5,7.9,8.4,9.1,8.5,7.9,7.9,8.4,8.3,7.7\",\"1.3,1.9,2.4,2.6,3.2,3.6,3.4,3.4,3.5,3.7,3.5,3.4,3.4\",wachtendonk\n05154064,10611,5350,5261,05154064,10.9,8.1,2.8,1159,861,298,\"9.3,10.8,11.4,11.6,11.3,11.5,11.8,11.8,11.1,11.7,11.9,11.8,10.9\",\"8.1,8.8,9.5,9.5,9.0,8.8,8.9,8.8,8.1,8.8,9.0,8.8,8.1\",\"1.2,2.0,2.0,2.1,2.3,2.7,3.0,3.0,3.0,3.0,2.9,3.0,2.8\",weeze\n05158004,44086,21054,23032,05158004,9.9,6.7,3.2,4349,2959,1390,\"6.8,8.2,8.4,8.7,9.0,9.5,9.8,9.7,9.8,10.4,10.0,10.0,9.9\",\"5.3,6.1,6.1,6.2,6.3,6.5,6.9,6.8,6.7,6.9,6.9,6.9,6.7\",\"1.5,2.2,2.4,2.5,2.7,3.0,2.9,3.0,3.2,3.5,3.1,3.1,3.2\",\"erkrath, fundort des neanderthalers, stadt\"\n05158008,30410,14579,15831,05158008,9.3,6.3,3.0,2817,1910,907,\"7.4,8.9,8.8,9.1,9.4,9.8,9.8,9.7,10.0,9.8,9.5,9.7,9.3\",\"5.9,6.6,6.3,6.6,6.5,6.6,6.5,6.6,6.8,6.5,6.4,6.6,6.3\",\"1.5,2.4,2.5,2.5,2.9,3.2,3.2,3.1,3.2,3.3,3.1,3.2,3.0\",\"haan, stadt\"\n05158012,25793,12654,13139,05158012,10.1,6.5,3.6,2610,1677,933,\"8.0,9.4,9.5,10.0,10.5,10.8,10.0,10.6,10.5,10.6,10.7,10.5,10.1\",\"6.2,6.7,6.8,6.9,7.1,7.2,6.9,7.1,6.8,6.8,7.0,7.0,6.5\",\"1.9,2.7,2.7,3.1,3.5,3.7,3.2,3.5,3.7,3.8,3.6,3.6,3.6\",\"heiligenhaus, stadt\"\n05158016,55185,26620,28565,05158016,9.8,6.4,3.5,5435,3506,1929,\"7.4,8.6,9.1,9.2,9.6,9.9,10.0,10.1,10.2,10.4,10.3,10.3,9.8\",\"5.6,6.1,6.3,6.2,6.3,6.4,6.5,6.6,6.5,6.5,6.8,6.7,6.4\",\"1.8,2.5,2.8,3.0,3.3,3.5,3.5,3.6,3.6,3.9,3.6,3.6,3.5\",\"hilden, stadt\"\n05158020,58033,28239,29794,05158020,9.3,6.1,3.1,5384,3567,1817,\"6.7,8.1,8.3,8.7,9.0,9.1,9.2,9.4,9.5,9.8,9.7,9.8,9.3\",\"5.4,6.0,6.0,6.2,6.3,6.3,6.3,6.4,6.3,6.4,6.6,6.6,6.1\",\"1.3,2.1,2.3,2.5,2.7,2.8,2.8,3.0,3.2,3.4,3.1,3.1,3.1\",\"langenfeld (rheinland), stadt\"\n05158024,38291,18413,19878,05158024,9.0,6.2,2.8,3460,2376,1084,\"6.4,7.8,7.9,8.3,8.4,8.6,8.6,8.9,9.1,9.5,9.4,9.4,9.0\",\"5.1,5.9,5.8,6.1,6.1,6.0,5.9,6.0,6.0,6.4,6.4,6.4,6.2\",\"1.2,1.9,2.1,2.2,2.3,2.7,2.8,2.8,3.0,3.1,2.9,3.0,2.8\",\"mettmann, stadt\"\n05158026,40885,19650,21235,05158026,9.8,6.7,3.2,4026,2736,1290,\"7.2,8.6,8.6,9.2,9.4,9.8,9.8,9.6,10.0,10.8,10.3,10.3,9.8\",\"5.8,6.4,6.3,6.6,6.6,6.6,6.7,6.4,6.6,7.0,7.1,7.1,6.7\",\"1.4,2.2,2.3,2.6,2.8,3.1,3.2,3.2,3.4,3.8,3.2,3.2,3.2\",\"monheim am rhein, stadt\"\n05158028,87943,42217,45726,05158028,9.7,6.4,3.3,8521,5644,2877,\"7.0,8.3,8.7,9.1,9.4,9.6,9.6,9.6,9.6,10.1,10.1,10.0,9.7\",\"5.5,6.0,6.2,6.3,6.4,6.4,6.5,6.4,6.4,6.7,6.8,6.8,6.4\",\"1.6,2.3,2.5,2.8,2.9,3.2,3.1,3.2,3.2,3.5,3.2,3.2,3.3\",\"ratingen, stadt\"\n05158032,81430,39660,41770,05158032,10.1,6.6,3.4,8202,5400,2802,\"7.7,9.3,9.4,9.9,10.4,10.5,10.1,10.3,10.4,10.6,10.7,10.7,10.1\",\"5.9,6.7,6.6,6.7,7.0,7.1,6.9,6.9,6.8,6.9,7.3,7.3,6.6\",\"1.8,2.6,2.7,3.1,3.4,3.5,3.2,3.4,3.6,3.7,3.4,3.5,3.4\",\"velbert, stadt\"\n05158036,21223,10362,10861,05158036,9.7,6.6,3.1,2064,1399,665,\"7.3,8.5,8.9,9.3,9.7,9.9,9.8,10.0,10.2,10.3,10.1,10.1,9.7\",\"5.7,6.2,6.5,6.6,6.8,6.9,6.8,7.0,7.0,7.0,7.0,6.9,6.6\",\"1.5,2.3,2.4,2.7,2.9,3.0,2.9,3.0,3.2,3.3,3.1,3.3,3.1\",\"wülfrath, stadt\"\n05162004,64064,31816,32248,05162004,8.9,6.1,2.8,5692,3926,1766,\"7.1,8.1,8.2,8.5,8.7,8.8,9.0,9.2,9.3,9.3,9.2,9.1,8.9\",\"5.8,6.2,6.2,6.3,6.3,6.3,6.4,6.5,6.4,6.3,6.5,6.4,6.1\",\"1.3,1.9,2.0,2.1,2.4,2.5,2.6,2.7,2.9,3.0,2.7,2.8,2.8\",\"dormagen, stadt\"\n05162008,63051,30723,32328,05162008,9.5,6.6,2.9,6007,4147,1860,\"7.0,8.3,8.6,8.8,9.0,9.4,9.6,9.7,10.1,10.3,10.1,10.0,9.5\",\"5.6,6.2,6.3,6.4,6.5,6.7,6.9,6.9,7.0,7.1,7.1,7.1,6.6\",\"1.4,2.1,2.2,2.4,2.5,2.7,2.7,2.9,3.1,3.2,3.0,2.9,2.9\",\"grevenbroich, stadt\"\n05162012,23260,11590,11670,05162012,9.3,6.5,2.8,2172,1519,653,\"7.2,8.2,8.2,8.3,8.5,8.9,9.2,9.3,9.3,9.5,9.6,9.6,9.3\",\"6.0,6.4,6.4,6.4,6.5,6.6,6.8,6.8,6.6,6.7,6.8,6.8,6.5\",\"1.2,1.8,1.8,1.9,2.0,2.2,2.4,2.5,2.7,2.8,2.8,2.7,2.8\",jüchen\n05162016,43286,20812,22474,05162016,8.6,5.8,2.8,3729,2531,1198,\"6.9,8.4,8.4,8.6,9.0,9.2,9.4,9.1,9.3,9.2,9.2,8.9,8.6\",\"5.5,6.2,6.2,6.2,6.3,6.4,6.5,6.3,6.3,6.1,6.3,6.1,5.8\",\"1.3,2.2,2.2,2.4,2.6,2.8,2.9,2.8,3.1,3.1,2.8,2.8,2.8\",\"kaarst, stadt\"\n05162020,32922,16085,16837,05162020,9.0,6.3,2.7,2953,2067,886,\"6.5,7.7,8.0,8.3,8.7,8.8,9.0,8.8,9.2,9.6,9.4,9.5,9.0\",\"5.2,5.8,6.0,6.1,6.3,6.2,6.3,6.1,6.2,6.5,6.4,6.5,6.3\",\"1.2,1.8,2.0,2.3,2.5,2.6,2.7,2.7,3.0,3.1,2.9,3.0,2.7\",\"korschenbroich, stadt\"\n05162022,54892,26183,28709,05162022,8.5,5.8,2.7,4692,3199,1493,\"6.1,7.4,7.6,8.1,8.4,8.6,8.6,8.8,8.9,8.9,8.8,8.8,8.5\",\"4.8,5.6,5.6,5.8,6.0,6.0,6.0,6.1,6.1,6.0,6.1,6.1,5.8\",\"1.2,1.8,2.1,2.2,2.4,2.6,2.6,2.7,2.8,2.8,2.6,2.7,2.7\",\"meerbusch, stadt\"\n05162024,155414,75929,79485,05162024,9.8,6.4,3.3,15158,10019,5139,\"7.7,9.1,9.4,9.7,10.0,10.0,10.1,10.1,10.2,10.3,10.1,10.1,9.8\",\"6.1,6.7,6.8,6.9,6.9,6.8,6.8,6.7,6.7,6.7,6.8,6.7,6.4\",\"1.6,2.4,2.6,2.8,3.0,3.2,3.2,3.3,3.5,3.6,3.3,3.4,3.3\",\"neuss, stadt\"\n05162028,13137,6512,6625,05162028,8.6,6.0,2.6,1131,785,346,\"6.7,7.7,8.0,8.5,8.5,8.6,8.7,8.9,9.3,9.5,9.4,8.9,8.6\",\"5.6,6.1,6.2,6.4,6.4,6.4,6.4,6.5,6.6,6.6,6.6,6.3,6.0\",\"1.1,1.6,1.8,2.1,2.1,2.2,2.3,2.4,2.7,2.9,2.7,2.7,2.6\",rommerskirchen\n05166004,15648,7677,7971,05166004,11.3,7.6,3.7,1765,1192,573,\"8.3,9.8,9.8,10.5,11.0,11.2,11.5,11.5,11.6,11.9,11.6,11.8,11.3\",\"6.8,7.6,7.5,7.9,8.0,8.0,8.2,8.2,8.1,8.2,8.1,8.3,7.6\",\"1.5,2.3,2.3,2.6,2.9,3.2,3.3,3.3,3.5,3.7,3.5,3.5,3.7\",\"brüggen, burggemeinde\"\n05166008,14914,7342,7572,05166008,10.1,6.8,3.3,1509,1016,493,\"7.1,8.4,8.6,9.2,9.3,9.4,10.0,10.0,10.0,10.6,10.6,10.5,10.1\",\"5.7,6.4,6.2,6.6,6.8,6.7,6.9,6.9,6.8,7.0,7.2,7.1,6.8\",\"1.3,2.1,2.4,2.6,2.4,2.8,3.1,3.0,3.2,3.5,3.3,3.4,3.3\",\"grefrath, sport- und freizeitgemeinde\"\n05166012,34837,16911,17926,05166012,10.2,6.9,3.3,3555,2419,1136,\"7.8,9.3,9.5,9.7,9.9,10.3,10.3,10.3,10.5,10.7,10.6,10.5,10.2\",\"6.4,7.0,7.0,7.1,7.2,7.3,7.3,7.1,7.2,7.3,7.4,7.3,6.9\",\"1.4,2.3,2.5,2.7,2.7,3.1,3.0,3.2,3.3,3.4,3.2,3.2,3.3\",\"kempen, stadt\"\n05166016,41964,20769,21195,05166016,10.6,7.5,3.1,4447,3133,1314,\"8.1,9.3,9.6,10.2,10.7,10.9,11.0,11.2,11.3,11.0,11.2,11.3,10.6\",\"6.5,7.0,7.1,7.5,7.8,7.8,7.8,7.8,7.8,7.7,8.0,8.0,7.5\",\"1.6,2.3,2.5,2.8,2.9,3.1,3.2,3.4,3.5,3.3,3.2,3.3,3.1\",\"nettetal, stadt\"\n05166020,15184,7487,7697,05166020,9.6,6.4,3.2,1454,974,480,\"6.8,8.4,8.6,9.4,9.4,9.8,9.8,9.8,9.9,10.2,10.0,10.1,9.6\",\"5.6,6.4,6.5,6.8,6.7,6.8,6.8,6.6,6.7,6.8,6.9,7.0,6.4\",\"1.2,2.0,2.1,2.5,2.7,3.0,3.0,3.2,3.2,3.3,3.1,3.2,3.2\",niederkrüchten\n05166024,19139,9441,9698,05166024,9.9,6.8,3.1,1893,1298,595,\"7.6,9.1,9.5,9.8,10.2,10.5,10.7,10.7,11.0,10.4,10.6,10.7,9.9\",\"6.2,6.9,7.0,7.3,7.6,7.6,7.5,7.4,7.4,7.0,7.3,7.4,6.8\",\"1.4,2.2,2.5,2.5,2.7,3.0,3.2,3.3,3.6,3.4,3.3,3.3,3.1\",schwalmtal\n05166028,29296,14301,14995,05166028,9.7,6.4,3.3,2847,1879,968,\"7.1,8.5,8.7,9.0,9.2,9.8,9.8,9.9,9.9,10.0,9.9,10.0,9.7\",\"5.7,6.3,6.2,6.5,6.4,7.0,6.8,6.7,6.6,6.6,6.8,6.7,6.4\",\"1.4,2.2,2.5,2.5,2.7,2.9,3.0,3.2,3.3,3.4,3.1,3.3,3.3\",\"tönisvorst, stadt\"\n05166032,75931,36727,39204,05166032,9.8,6.8,3.0,7412,5132,2280,\"7.4,8.7,8.7,9.2,9.4,9.7,9.8,9.9,9.9,10.0,10.2,10.2,9.8\",\"6.0,6.7,6.6,6.8,6.9,6.9,6.9,7.0,6.9,6.9,7.3,7.1,6.8\",\"1.3,2.1,2.1,2.4,2.5,2.7,2.9,2.9,3.0,3.2,3.0,3.1,3.0\",\"viersen, stadt\"\n05166036,50748,24815,25933,05166036,9.7,6.5,3.3,4947,3286,1661,\"6.7,8.0,8.2,8.5,8.8,8.9,9.4,9.6,9.8,10.0,9.9,10.1,9.7\",\"5.4,6.0,6.1,6.2,6.4,6.2,6.6,6.6,6.6,6.6,6.8,6.8,6.5\",\"1.2,2.0,2.1,2.3,2.4,2.8,2.8,3.0,3.2,3.4,3.1,3.3,3.3\",\"willich, stadt\"\n05170004,12798,6375,6423,05170004,10.3,7.5,2.9,1321,955,366,\"7.9,9.4,9.1,9.6,10.0,10.2,10.7,10.5,10.8,10.8,10.6,10.4,10.3\",\"6.6,7.4,7.2,7.5,7.6,7.7,7.9,7.7,7.7,7.7,7.7,7.5,7.5\",\"1.3,2.0,1.9,2.1,2.5,2.5,2.7,2.8,3.0,3.1,2.8,2.8,2.9\",alpen\n05170008,67452,32635,34817,05170008,9.4,7.0,2.4,6363,4741,1622,\"6.9,8.1,8.1,8.5,8.7,8.9,9.1,9.2,9.3,9.5,9.5,9.6,9.4\",\"5.8,6.4,6.3,6.6,6.6,6.7,6.8,6.9,6.8,6.9,7.1,7.2,7.0\",\"1.1,1.7,1.8,1.9,2.1,2.2,2.3,2.3,2.5,2.5,2.4,2.5,2.4\",\"dinslaken, stadt\"\n05170012,26996,13477,13519,05170012,11.3,8.2,3.2,3060,2206,854,\"8.3,9.6,9.9,10.2,10.5,10.9,11.1,11.0,11.2,11.6,12.0,11.9,11.3\",\"6.9,7.6,7.6,7.9,8.0,8.1,8.2,8.1,8.1,8.4,8.8,8.7,8.2\",\"1.4,2.0,2.3,2.4,2.5,2.7,2.9,3.0,3.1,3.1,3.2,3.1,3.2\",\"hamminkeln, stadt\"\n05170016,13771,6767,7004,05170016,9.3,6.8,2.5,1275,934,341,\"7.3,8.0,8.1,8.7,9.0,9.4,9.1,9.4,9.7,9.7,9.7,9.6,9.3\",\"6.2,6.5,6.3,6.8,6.7,7.0,6.8,6.9,7.0,7.1,7.1,7.0,6.8\",\"1.1,1.5,1.8,1.9,2.2,2.4,2.3,2.5,2.7,2.6,2.7,2.5,2.5\",hünxe\n05170020,37683,18588,19095,05170020,10.5,8.2,2.3,3965,3084,881,\"7.8,8.9,8.9,9.2,9.5,9.8,10.0,10.3,10.4,10.7,10.7,10.8,10.5\",\"6.6,7.3,7.1,7.3,7.4,7.7,7.8,8.0,8.1,8.1,8.4,8.5,8.2\",\"1.1,1.6,1.7,1.9,2.1,2.1,2.2,2.2,2.3,2.6,2.2,2.3,2.3\",\"kamp-lintfort, stadt\"\n05170024,104529,50973,53556,05170024,9.1,6.8,2.3,9546,7138,2408,\"6.6,7.8,8.0,8.3,8.5,8.6,8.9,9.2,9.2,9.4,9.5,9.6,9.1\",\"5.6,6.2,6.3,6.5,6.6,6.5,6.7,6.9,6.8,6.9,7.3,7.2,6.8\",\"1.0,1.6,1.7,1.8,1.9,2.1,2.2,2.3,2.4,2.5,2.2,2.3,2.3\",\"moers, stadt\"\n05170028,27178,13184,13994,05170028,9.6,7.2,2.4,2614,1968,646,\"7.0,8.3,8.3,8.6,8.9,9.1,9.6,9.6,9.6,9.9,10.0,10.0,9.6\",\"5.9,6.5,6.4,6.5,6.8,6.9,7.2,7.0,6.8,7.1,7.5,7.5,7.2\",\"1.1,1.8,1.9,2.1,2.2,2.2,2.4,2.6,2.7,2.8,2.5,2.5,2.4\",\"neukirchen-vluyn, stadt\"\n05170032,31023,15140,15883,05170032,9.5,6.9,2.6,2950,2142,808,\"6.9,8.2,8.4,8.8,9.0,9.3,9.5,9.6,9.5,9.8,9.5,9.8,9.5\",\"5.7,6.5,6.5,6.7,6.8,6.7,6.9,6.9,6.9,7.0,7.0,7.2,6.9\",\"1.2,1.7,2.0,2.1,2.2,2.6,2.6,2.6,2.6,2.8,2.4,2.6,2.6\",\"rheinberg, stadt\"\n05170036,13635,6750,6885,05170036,11.0,7.9,3.1,1498,1080,418,\"8.0,9.4,9.5,9.9,10.2,10.7,10.8,10.9,11.0,11.2,11.1,11.1,11.0\",\"6.9,7.6,7.6,7.8,8.1,8.5,8.2,8.1,8.0,8.1,8.2,8.1,7.9\",\"1.1,1.8,1.9,2.1,2.1,2.3,2.6,2.8,3.0,3.2,2.8,3.1,3.1\",schermbeck\n05170040,8819,4363,4456,05170040,11.3,7.8,3.5,997,691,306,\"8.7,9.9,9.8,10.0,10.3,10.8,11.4,11.2,11.4,11.3,10.8,11.5,11.3\",\"7.3,7.9,7.6,7.4,7.6,8.0,8.3,8.0,8.0,8.0,7.8,8.1,7.8\",\"1.4,2.1,2.2,2.6,2.7,2.8,3.1,3.2,3.4,3.3,3.0,3.4,3.5\",sonsbeck\n05170044,36675,18073,18602,05170044,9.5,7.2,2.3,3478,2625,853,\"7.5,8.7,8.9,9.2,9.5,10.0,10.2,10.1,10.2,10.2,9.9,10.0,9.5\",\"6.2,6.9,7.1,7.2,7.4,7.6,7.7,7.5,7.5,7.4,7.6,7.5,7.2\",\"1.2,1.9,1.8,2.0,2.1,2.4,2.5,2.6,2.7,2.7,2.3,2.4,2.3\",\"voerde (niederrhein), stadt\"\n05170048,60595,29522,31073,05170048,10.0,7.3,2.7,6048,4435,1613,\"7.9,9.2,9.3,9.5,9.8,10.1,10.3,10.4,10.6,10.6,10.5,10.5,10.0\",\"6.6,7.3,7.3,7.4,7.6,7.6,7.6,7.6,7.6,7.6,7.9,7.8,7.3\",\"1.3,1.9,2.0,2.1,2.3,2.5,2.6,2.8,3.0,2.9,2.7,2.7,2.7\",\"wesel, stadt\"\n05170052,21510,10549,10961,05170052,10.9,7.9,3.0,2339,1695,644,\"8.2,9.7,9.7,10.0,10.5,10.8,11.0,11.1,11.1,10.9,10.9,10.8,10.9\",\"6.9,7.8,7.7,7.8,7.8,8.1,8.1,8.1,8.1,7.9,8.2,7.9,7.9\",\"1.2,1.9,2.0,2.1,2.6,2.7,2.9,3.0,2.9,3.0,2.8,2.9,3.0\",\"xanten, stadt\"\n05314000,318809,151954,166855,05314000,9.2,6.3,3.0,29483,19926,9557,\"6.4,7.8,7.9,8.2,8.4,8.6,8.9,8.8,8.9,9.6,9.3,9.4,9.2\",\"4.8,5.5,5.5,5.6,5.6,5.7,5.8,5.7,5.7,6.1,6.4,6.4,6.3\",\"1.6,2.3,2.4,2.6,2.7,2.9,3.0,3.1,3.2,3.4,2.9,3.0,3.0\",\"bonn, stadt\"\n05315000,1060582,516976,543606,05315000,9.3,6.2,3.1,98699,66046,32653,\"6.6,8.1,8.2,8.6,8.8,9.1,9.3,9.4,9.6,9.6,9.4,9.5,9.3\",\"5.1,5.9,5.8,6.0,6.1,6.1,6.2,6.2,6.2,6.2,6.4,6.4,6.2\",\"1.5,2.3,2.4,2.6,2.7,3.0,3.1,3.2,3.3,3.4,2.9,3.0,3.1\",\"köln, stadt\"\n05316000,163487,79590,83897,05316000,8.6,6.0,2.7,14107,9741,4366,\"6.6,7.8,8.0,8.2,8.5,8.6,8.9,9.0,9.1,9.1,8.8,8.8,8.6\",\"5.3,5.8,5.8,6.0,6.1,6.0,6.2,6.2,6.2,6.1,6.1,6.1,6.0\",\"1.3,2.0,2.1,2.2,2.4,2.6,2.7,2.8,2.9,3.0,2.6,2.7,2.7\",\"leverkusen, stadt\"\n05334002,245885,127613,118272,05334002,11.4,8.7,2.7,28020,21347,6673,\"*,*,*,*,*,*,*,10.5,10.8,11.8,11.6,11.7,11.4\",\"*,*,*,*,*,*,*,7.6,7.7,8.4,8.9,9.0,8.7\",\"*,*,*,*,*,*,*,2.9,3.1,3.4,2.7,2.8,2.7\",\"aachen, stadt\"\n05334004,46880,23281,23599,05334004,10.3,7.4,2.9,4831,3460,1371,\"*,*,*,*,*,*,*,11.2,11.2,10.9,10.9,10.7,10.3\",\"*,*,*,*,*,*,*,8.3,8.1,7.8,7.9,7.8,7.4\",\"*,*,*,*,*,*,*,2.9,3.1,3.1,2.9,2.9,2.9\",\"alsdorf, stadt\"\n05334008,26819,13120,13699,05334008,10.5,7.4,3.1,2807,1985,822,\"*,*,*,*,*,*,*,10.2,10.5,10.9,11.1,10.9,10.5\",\"*,*,*,*,*,*,*,7.5,7.6,7.7,8.1,7.9,7.4\",\"*,*,*,*,*,*,*,2.7,2.9,3.1,2.9,3.1,3.1\",\"baesweiler, stadt\"\n05334012,55909,27322,28587,05334012,10.1,7.3,2.8,5674,4102,1572,\"*,*,*,*,*,*,*,10.4,10.5,10.5,10.2,10.4,10.1\",\"*,*,*,*,*,*,*,7.7,7.5,7.5,7.6,7.6,7.3\",\"*,*,*,*,*,*,*,2.8,3.0,3.0,2.6,2.8,2.8\",\"eschweiler, stadt\"\n05334016,46583,22665,23918,05334016,9.5,6.7,2.8,4447,3123,1324,\"*,*,*,*,*,*,*,10.3,10.1,9.9,9.7,10.1,9.5\",\"*,*,*,*,*,*,*,7.3,7.1,6.9,7.0,7.1,6.7\",\"*,*,*,*,*,*,*,3.0,3.0,3.0,2.8,3.0,2.8\",\"herzogenrath, stadt\"\n05334020,12352,6234,6118,05334020,13.1,8.7,4.4,1613,1071,542,\"*,*,*,*,*,*,*,13.2,13.3,13.9,13.7,14.1,13.1\",\"*,*,*,*,*,*,*,9.1,9.1,9.3,9.7,9.8,8.7\",\"*,*,*,*,*,*,*,4.2,4.2,4.6,4.0,4.3,4.4\",\"monschau, stadt\"\n05334024,8527,4214,4313,05334024,9.4,6.5,2.9,804,554,250,\"*,*,*,*,*,*,*,9.6,9.6,9.3,9.4,9.2,9.4\",\"*,*,*,*,*,*,*,6.9,6.8,6.5,7.0,6.5,6.5\",\"*,*,*,*,*,*,*,2.7,2.8,2.8,2.5,2.7,2.9\",\"roetgen, tor zur eifel\"\n05334028,15266,7583,7683,05334028,13.2,8.7,4.4,2008,1332,676,\"*,*,*,*,*,*,*,13.5,13.2,13.5,13.5,13.8,13.2\",\"*,*,*,*,*,*,*,9.5,9.1,9.1,9.2,9.2,8.7\",\"*,*,*,*,*,*,*,3.9,4.0,4.4,4.3,4.6,4.4\",simmerath\n05334032,56739,28112,28627,05334032,10.3,7.2,3.1,5872,4098,1774,\"*,*,*,*,*,*,*,10.6,10.6,10.9,10.7,10.7,10.3\",\"*,*,*,*,*,*,*,7.5,7.3,7.5,7.7,7.7,7.2\",\"*,*,*,*,*,*,*,3.1,3.2,3.4,3.1,3.1,3.1\",\"stolberg (rhld.), kupferstadt\"\n05334036,38962,19116,19846,05334036,9.4,6.5,3.0,3679,2515,1164,\"*,*,*,*,*,*,*,10.0,10.2,9.9,9.8,9.8,9.4\",\"*,*,*,*,*,*,*,7.0,6.9,6.6,6.7,6.8,6.5\",\"*,*,*,*,*,*,*,3.0,3.3,3.3,3.1,3.1,3.0\",\"würselen, stadt\"\n05358004,13932,6995,6937,05358004,10.8,7.9,2.9,1509,1101,408,\"8.0,9.4,9.7,10.7,10.8,10.9,11.0,11.1,11.4,11.2,11.1,11.2,10.8\",\"6.8,7.4,7.4,8.2,8.0,8.0,8.0,8.0,8.2,8.1,8.0,8.1,7.9\",\"1.2,2.0,2.3,2.5,2.7,2.9,3.0,3.1,3.2,3.1,3.1,3.1,2.9\",aldenhoven\n05358008,90244,44599,45645,05358008,10.1,7.3,2.8,9134,6590,2544,\"7.2,8.5,8.7,9.3,9.4,9.6,9.7,9.9,10.0,10.4,10.4,10.4,10.1\",\"5.8,6.6,6.6,7.0,6.9,6.9,7.1,7.1,7.2,7.4,7.7,7.5,7.3\",\"1.3,1.9,2.2,2.3,2.4,2.6,2.6,2.7,2.8,3.0,2.7,2.9,2.8\",\"düren, stadt\"\n05358012,4366,2203,2163,05358012,11.9,8.7,3.2,518,379,139,\"9.2,10.0,9.9,10.8,10.5,11.4,11.5,11.2,11.9,11.7,11.5,12.1,11.9\",\"7.4,7.9,7.8,8.3,8.2,8.6,8.4,8.2,8.3,8.1,8.7,8.9,8.7\",\"1.9,2.1,2.0,2.6,2.3,2.8,3.1,3.0,3.5,3.6,2.8,3.2,3.2\",\"heimbach, stadt\"\n05358016,8780,4426,4354,05358016,10.3,6.8,3.4,902,600,302,\"6.5,8.0,7.8,8.7,9.3,9.4,10.0,10.0,10.0,10.8,10.9,10.8,10.3\",\"5.4,6.0,5.9,6.4,6.8,6.6,6.9,7.1,6.7,7.1,7.5,7.1,6.8\",\"1.1,2.0,2.0,2.3,2.6,2.8,3.0,2.8,3.3,3.7,3.4,3.7,3.4\",hürtgenwald\n05358020,7272,3579,3693,05358020,9.5,6.4,3.2,694,463,231,\"7.6,9.1,9.3,9.5,9.6,10.3,11.0,11.2,11.2,10.4,10.5,10.6,9.5\",\"6.1,6.9,7.0,7.3,7.1,7.4,7.9,7.8,7.7,6.9,7.2,7.0,6.4\",\"1.4,2.2,2.3,2.3,2.5,2.9,3.2,3.4,3.4,3.5,3.2,3.5,3.2\",inden\n05358024,32601,16318,16283,05358024,9.8,7.1,2.7,3189,2322,867,\"7.4,8.7,8.8,9.1,9.6,9.9,10.0,9.9,10.0,10.2,10.3,10.3,9.8\",\"6.2,6.7,6.8,7.0,7.3,7.3,7.4,7.3,7.3,7.3,7.6,7.5,7.1\",\"1.2,2.0,2.0,2.1,2.3,2.6,2.6,2.6,2.7,2.9,2.6,2.7,2.7\",\"jülich, stadt\"\n05358028,17441,8579,8862,05358028,10.7,7.5,3.3,1869,1300,569,\"7.2,8.7,8.9,9.4,9.7,9.8,9.8,10.1,10.4,10.9,11.1,11.0,10.7\",\"6.1,6.9,6.9,7.1,7.2,7.3,7.1,7.5,7.6,7.7,8.0,7.8,7.5\",\"1.1,1.9,2.0,2.3,2.5,2.5,2.7,2.7,2.8,3.1,3.1,3.2,3.3\",kreuzau\n05358032,13791,6871,6920,05358032,10.3,7.4,2.9,1419,1018,401,\"6.4,7.9,8.1,9.0,9.2,9.4,9.7,10.2,10.2,10.5,10.4,10.4,10.3\",\"5.4,6.2,6.1,6.8,6.9,6.8,7.2,7.4,7.3,7.4,7.4,7.4,7.4\",\"1.0,1.7,2.0,2.2,2.2,2.6,2.5,2.8,2.9,3.1,2.9,3.0,2.9\",langerwehe\n05358036,12591,6253,6338,05358036,10.5,7.5,3.0,1323,943,380,\"7.2,8.7,8.4,8.9,9.1,9.2,9.3,9.1,9.6,10.3,10.3,10.4,10.5\",\"6.1,6.8,6.6,6.8,6.8,6.7,6.6,6.6,6.9,7.3,7.6,7.6,7.5\",\"1.1,1.9,1.8,2.1,2.3,2.5,2.7,2.5,2.7,3.0,2.7,2.8,3.0\",\"linnich, stadt\"\n05358040,9950,4948,5002,05358040,9.9,7.0,2.9,986,693,293,\"7.3,8.8,8.9,9.7,10.0,10.0,10.5,10.3,10.3,10.1,9.5,10.2,9.9\",\"6.1,6.9,6.6,7.0,7.4,7.1,7.5,7.2,7.0,6.8,6.7,7.1,7.0\",\"1.2,1.9,2.3,2.6,2.6,2.9,3.1,3.1,3.3,3.2,2.8,3.1,2.9\",merzenich\n05358044,9893,4832,5061,05358044,11.5,8.2,3.3,1135,808,327,\"7.2,8.5,8.9,9.3,9.8,9.8,10.1,10.2,10.5,11.3,11.4,11.6,11.5\",\"6.0,6.7,6.9,7.2,7.5,7.4,7.6,7.5,7.7,8.1,8.3,8.3,8.2\",\"1.2,1.8,1.9,2.1,2.3,2.5,2.5,2.7,2.8,3.3,3.1,3.4,3.3\",\"nideggen, stadt\"\n05358048,13915,6876,7039,05358048,10.5,7.4,3.1,1466,1028,438,\"7.6,9.0,9.1,9.7,10.0,10.1,10.3,10.6,10.9,10.9,10.7,10.6,10.5\",\"6.3,7.0,7.1,7.2,7.4,7.5,7.5,7.8,7.7,7.5,7.5,7.4,7.4\",\"1.3,2.0,2.0,2.5,2.6,2.7,2.7,2.8,3.2,3.4,3.3,3.3,3.1\",niederzier\n05358052,10552,5249,5303,05358052,10.5,7.2,3.3,1104,760,344,\"7.1,8.4,8.5,9.2,9.6,9.6,9.8,9.7,9.8,10.6,10.4,10.5,10.5\",\"6.0,6.7,6.6,6.9,7.2,6.8,6.9,7.0,6.6,7.0,7.2,7.3,7.2\",\"1.0,1.7,1.9,2.3,2.4,2.8,2.8,2.7,3.2,3.6,3.2,3.1,3.3\",nörvenich\n05358056,8277,4150,4127,05358056,9.0,6.2,2.8,749,516,233,\"7.4,8.4,8.6,9.1,9.2,9.9,10.0,9.9,9.6,9.5,9.5,9.6,9.0\",\"6.2,6.6,6.6,6.8,6.7,7.1,7.0,7.1,6.8,6.4,6.8,6.6,6.2\",\"1.2,1.8,2.0,2.2,2.5,2.8,2.9,2.7,2.9,3.2,2.7,3.0,2.8\",titz\n05358060,9223,4644,4579,05358060,10.5,7.6,3.0,971,698,273,\"7.3,8.8,9.2,9.7,10.4,10.9,10.6,10.9,11.3,11.4,11.0,11.1,10.5\",\"6.2,6.9,7.0,7.6,7.9,8.1,8.0,8.1,8.2,7.9,8.0,8.1,7.6\",\"1.1,1.9,2.2,2.1,2.5,2.8,2.6,2.8,3.1,3.5,3.0,3.0,3.0\",vettweiß\n05362004,23334,11676,11658,05362004,9.7,6.8,2.9,2266,1590,676,\"6.7,7.9,8.1,8.1,8.5,8.7,9.2,9.6,9.8,10.3,10.2,10.1,9.7\",\"5.6,6.3,6.4,6.2,6.5,6.6,7.0,7.2,7.1,7.4,7.5,7.4,6.8\",\"1.1,1.6,1.7,1.9,2.0,2.0,2.2,2.3,2.7,2.9,2.6,2.7,2.9\",\"bedburg, stadt\"\n05362008,60390,29779,30611,05362008,9.8,6.8,3.0,5892,4090,1802,\"6.9,8.4,8.5,8.6,9.0,9.2,9.6,9.6,9.8,10.0,10.0,10.0,9.8\",\"5.6,6.4,6.4,6.4,6.6,6.6,6.9,6.8,6.9,6.9,7.2,7.1,6.8\",\"1.3,2.0,2.0,2.2,2.4,2.6,2.7,2.8,2.9,3.1,2.8,2.9,3.0\",\"bergheim, stadt\"\n05362012,44768,21443,23325,05362012,9.0,6.1,2.9,4048,2732,1316,\"6.6,7.6,7.7,8.2,8.3,8.5,8.8,8.9,8.9,8.9,9.0,9.0,9.0\",\"5.3,5.7,5.6,5.8,5.7,5.9,6.0,5.9,5.9,5.9,6.2,6.2,6.1\",\"1.3,1.9,2.0,2.3,2.6,2.6,2.7,3.1,3.1,3.0,2.7,2.8,2.9\",\"brühl, stadt\"\n05362016,21232,10453,10779,05362016,9.1,6.3,2.9,1942,1329,613,\"6.7,7.9,7.6,8.2,8.5,8.8,9.1,9.2,9.2,9.4,9.6,9.5,9.1\",\"5.5,6.0,5.7,6.0,6.0,6.3,6.4,6.4,6.3,6.3,6.8,6.7,6.3\",\"1.3,1.9,2.0,2.2,2.5,2.6,2.7,2.8,2.9,3.1,2.8,2.9,2.9\",\"elsdorf, stadt\"\n05362020,49786,24168,25618,05362020,8.6,6.0,2.6,4273,2966,1307,\"6.1,7.4,7.4,7.6,8.0,8.2,8.6,8.9,8.9,8.9,8.8,8.8,8.6\",\"5.0,5.6,5.6,5.6,5.9,5.8,6.2,6.3,6.2,6.1,6.2,6.1,6.0\",\"1.1,1.7,1.8,2.0,2.1,2.4,2.5,2.6,2.7,2.8,2.6,2.6,2.6\",\"erftstadt, stadt\"\n05362024,51999,25311,26688,05362024,9.4,6.2,3.2,4883,3207,1676,\"7.2,8.5,8.6,9.0,9.2,9.4,9.9,9.8,9.7,9.9,9.7,9.6,9.4\",\"5.7,6.3,6.2,6.4,6.3,6.4,6.6,6.5,6.4,6.5,6.5,6.5,6.2\",\"1.5,2.2,2.4,2.6,2.9,3.0,3.2,3.3,3.3,3.4,3.1,3.1,3.2\",\"frechen, stadt\"\n05362028,59496,29173,30323,05362028,9.6,6.3,3.3,5691,3729,1962,\"7.2,8.6,8.8,8.9,9.2,9.4,9.6,9.7,9.7,10.2,9.7,9.9,9.6\",\"5.8,6.5,6.4,6.4,6.4,6.5,6.4,6.5,6.3,6.6,6.6,6.5,6.3\",\"1.4,2.1,2.3,2.5,2.7,3.0,3.2,3.2,3.5,3.7,3.1,3.3,3.3\",\"hürth, stadt\"\n05362032,65477,32337,33140,05362032,9.8,6.6,3.2,6388,4289,2099,\"7.2,8.6,8.7,9.0,9.4,9.7,9.8,9.8,10.0,10.3,10.1,10.0,9.8\",\"5.8,6.6,6.5,6.6,6.8,6.7,6.8,6.7,6.8,6.9,7.0,6.9,6.6\",\"1.3,2.0,2.2,2.4,2.7,3.0,3.0,3.0,3.2,3.4,3.1,3.1,3.2\",\"kerpen, kolpingstadt\"\n05362036,54200,26267,27933,05362036,8.4,5.6,2.8,4563,3058,1505,\"6.3,7.3,7.6,7.8,7.9,8.1,8.5,8.6,8.5,8.7,8.5,8.7,8.4\",\"5.1,5.6,5.6,5.7,5.7,5.7,5.9,6.0,5.8,6.0,5.9,6.0,5.6\",\"1.2,1.7,2.0,2.2,2.2,2.4,2.6,2.6,2.7,2.8,2.7,2.7,2.8\",\"pulheim, stadt\"\n05362040,35975,17843,18132,05362040,9.9,6.7,3.1,3544,2428,1116,\"7.3,8.5,8.6,9.4,10.0,10.2,10.5,10.4,10.5,10.5,10.2,10.1,9.9\",\"5.8,6.2,6.3,6.6,6.9,7.0,7.0,7.0,6.9,7.0,7.0,7.0,6.7\",\"1.5,2.3,2.4,2.8,3.1,3.3,3.4,3.4,3.6,3.5,3.2,3.1,3.1\",\"wesseling, stadt\"\n05366004,17367,8536,8831,05366004,10.5,7.2,3.3,1825,1248,577,\"6.8,8.0,8.7,8.9,9.1,9.4,9.6,10.0,10.1,10.3,10.4,10.8,10.5\",\"5.7,6.3,6.7,6.9,6.8,6.9,6.8,7.0,7.0,7.1,7.3,7.4,7.2\",\"1.1,1.7,2.0,2.1,2.3,2.6,2.8,3.0,3.0,3.2,3.1,3.4,3.3\",\"bad münstereifel, stadt\"\n05366008,8471,4343,4128,05366008,10.1,6.9,3.2,856,587,269,\"7.5,8.7,9.0,9.2,9.5,9.9,10.0,10.0,10.2,10.0,10.2,10.1,10.1\",\"6.3,6.9,7.0,7.0,7.3,7.4,7.4,7.0,7.1,7.0,7.1,6.9,6.9\",\"1.2,1.8,2.0,2.2,2.2,2.5,2.6,3.0,3.0,3.0,3.1,3.1,3.2\",blankenheim\n05366012,4236,2085,2151,05366012,11.9,8.4,3.5,502,354,148,\"8.5,9.3,9.3,10.0,10.5,10.2,11.0,11.4,11.7,11.2,11.7,11.9,11.9\",\"6.7,7.4,7.3,8.1,8.1,7.8,8.1,8.3,8.5,7.7,8.4,8.4,8.4\",\"1.8,1.9,2.0,1.9,2.4,2.5,2.9,3.1,3.2,3.5,3.4,3.5,3.5\",dahlem\n05366016,56769,27854,28915,05366016,9.8,6.7,3.1,5587,3803,1784,\"7.4,8.6,8.9,9.5,9.8,10.0,10.0,10.1,10.2,10.0,9.9,10.1,9.8\",\"6.0,6.5,6.6,6.9,7.0,7.1,6.9,6.9,7.0,6.7,6.9,6.9,6.7\",\"1.4,2.1,2.2,2.5,2.7,2.9,3.1,3.2,3.2,3.3,3.0,3.2,3.1\",\"euskirchen, stadt\"\n05366020,8094,4125,3969,05366020,11.5,7.6,3.9,929,615,314,\"8.0,9.5,9.9,10.2,10.8,11.0,11.0,11.5,11.9,12.0,11.9,11.8,11.5\",\"6.4,6.9,7.3,7.4,8.1,7.9,7.8,8.1,8.3,7.9,8.2,7.7,7.6\",\"1.6,2.5,2.5,2.9,2.7,3.1,3.3,3.4,3.6,4.2,3.7,4.0,3.9\",hellenthal\n05366024,11229,5606,5623,05366024,10.8,7.3,3.5,1216,822,394,\"7.6,9.0,9.0,9.4,9.7,10.0,10.0,10.0,10.4,10.8,11.1,11.1,10.8\",\"6.3,7.1,7.1,7.3,7.4,7.3,7.3,7.3,7.2,7.5,7.9,7.6,7.3\",\"1.3,1.9,2.0,2.1,2.4,2.7,2.7,2.8,3.1,3.2,3.2,3.5,3.5\",kall\n05366028,27170,13551,13619,05366028,10.0,6.9,3.1,2729,1880,849,\"7.6,8.6,8.7,9.1,9.3,9.6,9.7,10.0,10.3,10.6,10.3,10.3,10.0\",\"6.1,6.5,6.6,6.8,6.8,7.0,7.0,7.1,7.1,7.3,7.4,7.3,6.9\",\"1.5,2.1,2.2,2.3,2.5,2.6,2.7,2.9,3.2,3.3,2.9,3.0,3.1\",\"mechernich, stadt\"\n05366032,7469,3713,3756,05366032,11.2,7.2,4.0,839,541,298,\"7.6,8.9,8.8,8.9,9.2,10.3,9.9,10.2,10.4,10.7,11.2,11.1,11.2\",\"6.2,6.9,6.8,6.7,6.9,7.4,6.9,7.0,7.1,7.3,7.5,7.5,7.2\",\"1.4,2.0,2.1,2.2,2.3,2.9,3.0,3.2,3.4,3.4,3.6,3.6,4.0\",nettersheim\n05366036,13272,6623,6649,05366036,11.4,7.7,3.7,1513,1021,492,\"8.5,10.0,10.2,10.9,11.0,11.1,11.5,12.0,11.9,12.3,11.8,12.1,11.4\",\"6.8,7.5,7.7,8.1,7.8,7.8,8.0,8.6,8.4,8.3,8.2,8.3,7.7\",\"1.7,2.4,2.5,2.8,3.2,3.3,3.4,3.4,3.6,4.1,3.7,3.7,3.7\",\"schleiden, stadt\"\n05366040,16997,8404,8593,05366040,9.2,6.0,3.2,1571,1027,544,\"6.4,7.7,7.7,8.3,8.5,8.8,9.2,9.2,9.1,9.3,9.2,9.5,9.2\",\"5.3,6.0,5.7,6.0,6.0,6.1,6.2,6.2,6.0,6.2,6.1,6.4,6.0\",\"1.1,1.8,2.1,2.3,2.6,2.8,3.0,3.0,3.1,3.1,3.0,3.1,3.2\",weilerswist\n05366044,20091,9919,10172,05366044,10.3,7.0,3.3,2079,1415,664,\"7.7,8.7,9.1,9.6,9.6,10.2,10.2,10.1,10.3,10.5,10.5,10.9,10.3\",\"6.3,6.7,6.8,7.1,7.1,7.3,7.3,7.1,7.2,7.0,7.3,7.5,7.0\",\"1.3,2.0,2.2,2.4,2.5,2.9,2.9,3.0,3.1,3.4,3.2,3.4,3.3\",\"zülpich, stadt\"\n05370004,43350,21170,22180,05370004,10.1,7.1,3.1,4386,3058,1328,\"8.2,9.3,9.2,9.5,9.8,9.9,9.9,10.1,10.3,10.6,10.6,10.6,10.1\",\"6.9,7.4,7.3,7.4,7.5,7.4,7.3,7.4,7.4,7.4,7.7,7.6,7.1\",\"1.3,1.9,2.0,2.1,2.3,2.5,2.7,2.7,2.9,3.1,2.9,3.1,3.1\",\"erkelenz, stadt\"\n05370008,12015,6002,6013,05370008,9.9,7.0,2.8,1187,847,340,\"7.9,9.0,9.2,9.4,9.6,10.0,10.1,10.6,10.5,10.1,10.2,10.3,9.9\",\"6.8,7.5,7.5,7.8,7.6,7.7,7.8,7.9,7.8,7.5,7.7,7.6,7.0\",\"1.1,1.5,1.6,1.6,2.1,2.3,2.3,2.7,2.7,2.6,2.5,2.7,2.8\",gangelt\n05370012,26963,13424,13539,05370012,11.1,7.9,3.2,3006,2135,871,\"8.0,9.1,8.9,9.2,9.7,9.9,10.2,10.0,10.5,11.2,11.2,11.2,11.1\",\"6.9,7.4,7.1,7.3,7.4,7.4,7.6,7.2,7.5,7.8,8.0,7.9,7.9\",\"1.1,1.8,1.8,2.0,2.3,2.6,2.6,2.9,3.0,3.3,3.2,3.3,3.2\",\"geilenkirchen, stadt\"\n05370016,41538,20387,21151,05370016,10.4,7.6,2.9,4323,3139,1184,\"9.3,10.6,10.6,10.7,10.7,10.8,11.0,11.2,11.1,10.9,10.8,10.7,10.4\",\"8.1,8.9,8.7,8.7,8.5,8.5,8.4,8.5,8.3,8.1,8.2,8.0,7.6\",\"1.3,1.7,1.8,2.0,2.2,2.3,2.6,2.7,2.8,2.8,2.6,2.7,2.9\",\"heinsberg, stadt\"\n05370020,39531,19537,19994,05370020,10.0,7.3,2.7,3967,2903,1064,\"8.1,9.5,9.6,10.0,10.3,10.6,10.4,10.6,10.7,10.7,10.7,10.6,10.0\",\"7.1,7.9,7.9,7.9,8.1,8.2,8.0,8.0,8.0,7.8,8.0,7.8,7.3\",\"1.1,1.7,1.8,2.1,2.1,2.4,2.4,2.6,2.7,2.9,2.7,2.7,2.7\",\"hückelhoven, stadt\"\n05370024,10167,5173,4994,05370024,7.8,6.1,1.7,794,623,171,\"6.0,7.1,7.1,7.4,7.7,7.9,8.2,8.3,8.4,8.1,8.0,7.9,7.8\",\"5.1,6.0,5.8,6.2,6.2,6.4,6.5,6.6,6.6,6.4,6.4,6.2,6.1\",\"0.9,1.1,1.3,1.2,1.4,1.5,1.7,1.6,1.9,1.7,1.6,1.7,1.7\",selfkant\n05370028,24377,12270,12107,05370028,10.6,7.9,2.7,2594,1932,662,\"9.0,10.2,10.1,10.7,10.8,11.3,11.4,11.0,11.1,11.2,11.6,11.5,10.6\",\"7.8,8.3,8.2,8.6,8.5,9.0,8.9,8.2,8.2,8.4,8.8,8.7,7.9\",\"1.2,1.8,1.9,2.1,2.2,2.3,2.5,2.8,2.9,2.8,2.8,2.7,2.7\",\"übach-palenberg, stadt\"\n05370032,8861,4447,4414,05370032,9.9,7.5,2.4,876,665,211,\"7.8,8.4,8.8,8.9,9.1,9.7,9.7,10.2,10.5,10.7,10.3,10.3,9.9\",\"6.8,7.0,7.2,7.2,7.3,7.4,7.4,7.8,7.9,7.9,7.9,8.0,7.5\",\"1.0,1.4,1.6,1.7,1.8,2.2,2.2,2.4,2.6,2.7,2.3,2.3,2.4\",waldfeucht\n05370036,17898,8889,9009,05370036,9.7,6.9,2.8,1734,1233,501,\"8.5,9.3,9.6,9.9,9.9,10.0,9.9,10.2,10.3,10.5,10.3,10.3,9.7\",\"7.5,7.8,7.9,8.0,7.9,7.5,7.5,7.7,7.6,7.5,7.5,7.4,6.9\",\"1.0,1.5,1.7,1.9,2.0,2.5,2.3,2.5,2.7,2.9,2.8,2.9,2.8\",\"wassenberg, stadt\"\n05370040,27827,13657,14170,05370040,10.1,7.1,3.1,2816,1962,854,\"7.5,8.8,8.8,9.1,9.3,9.6,10.0,10.3,10.3,10.5,10.5,10.6,10.1\",\"6.2,7.0,6.8,7.0,7.0,7.1,7.3,7.5,7.3,7.4,7.5,7.6,7.1\",\"1.3,1.8,2.0,2.2,2.3,2.5,2.7,2.8,2.9,3.0,3.0,3.1,3.1\",\"wegberg, stadt\"\n05374004,18940,9294,9646,05374004,10.1,7.2,2.9,1911,1365,546,\"7.0,8.1,8.3,8.8,9.0,9.5,9.1,9.2,9.5,10.0,10.0,10.0,10.1\",\"5.7,6.0,6.1,6.3,6.6,6.6,6.5,6.7,6.7,7.0,7.2,7.2,7.2\",\"1.4,2.0,2.2,2.5,2.5,2.9,2.6,2.5,2.8,3.0,2.7,2.9,2.9\",\"bergneustadt, stadt\"\n05374008,19307,9395,9912,05374008,10.6,6.7,3.8,2043,1300,743,\"7.8,9.3,9.2,9.5,9.7,10.1,10.0,10.2,10.6,10.7,10.7,10.6,10.6\",\"6.2,7.0,6.6,6.8,6.8,6.8,6.7,6.8,7.0,6.8,7.2,7.0,6.7\",\"1.6,2.4,2.5,2.7,2.9,3.3,3.2,3.4,3.6,3.9,3.5,3.6,3.8\",engelskirchen\n05374012,50412,24870,25542,05374012,10.9,7.2,3.6,5477,3648,1829,\"7.9,8.9,9.0,9.4,9.7,10.1,10.0,10.3,10.3,10.5,10.8,10.9,10.9\",\"6.2,6.6,6.4,6.7,6.8,6.9,7.0,7.0,6.8,6.8,7.4,7.5,7.2\",\"1.7,2.4,2.6,2.7,2.9,3.1,3.0,3.3,3.4,3.7,3.4,3.5,3.6\",\"gummersbach, stadt\"\n05374016,15275,7620,7655,05374016,10.7,7.2,3.5,1629,1099,530,\"8.5,9.7,10.1,10.3,10.6,10.9,10.6,10.6,10.6,11.0,11.1,11.0,10.7\",\"6.7,7.2,7.4,7.3,7.4,7.7,7.5,7.5,7.2,7.6,7.7,7.6,7.2\",\"1.8,2.4,2.7,3.0,3.2,3.2,3.1,3.2,3.4,3.4,3.4,3.4,3.5\",\"hückeswagen, schloss-stadt\"\n05374020,21382,10491,10891,05374020,11.9,7.9,3.9,2536,1695,841,\"8.3,9.5,10.1,10.4,10.9,11.4,11.3,11.7,11.8,12.3,12.1,12.0,11.9\",\"6.8,7.3,7.6,7.6,7.8,7.9,7.8,8.1,8.1,8.3,8.4,8.1,7.9\",\"1.5,2.2,2.5,2.8,3.0,3.5,3.5,3.6,3.7,4.0,3.7,3.9,3.9\",lindlar\n05374024,13560,6750,6810,05374024,10.5,6.8,3.7,1423,924,499,\"7.6,9.2,9.3,9.4,9.9,10.1,9.3,10.0,10.3,10.4,10.6,10.7,10.5\",\"6.2,6.9,6.8,6.6,7.0,6.8,6.5,6.7,6.7,6.8,7.1,7.0,6.8\",\"1.4,2.3,2.5,2.7,2.9,3.3,2.8,3.3,3.6,3.6,3.6,3.7,3.7\",marienheide\n05374028,10402,5228,5174,05374028,11.7,8.1,3.6,1214,844,370,\"8.5,9.7,9.2,9.7,10.5,10.3,10.5,10.4,11.1,11.5,11.5,11.3,11.7\",\"7.1,7.5,7.1,7.2,7.9,7.3,7.7,7.8,7.9,7.9,8.2,7.7,8.1\",\"1.5,2.2,2.1,2.4,2.6,3.0,2.8,2.7,3.1,3.5,3.3,3.6,3.6\",morsbach\n05374032,17002,8310,8692,05374032,9.9,6.5,3.4,1690,1104,586,\"7.8,8.7,8.7,8.9,9.4,9.7,9.7,10.0,10.0,10.0,10.3,10.4,9.9\",\"6.5,6.6,6.6,6.5,6.7,6.7,6.7,7.0,6.7,6.5,7.0,7.0,6.5\",\"1.3,2.1,2.1,2.4,2.7,3.0,3.0,3.0,3.3,3.4,3.3,3.4,3.4\",nümbrecht\n05374036,22386,10916,11470,05374036,10.7,7.1,3.6,2397,1587,810,\"8.7,10.3,10.3,10.6,11.2,11.3,10.7,11.3,11.6,11.2,10.9,10.9,10.7\",\"6.5,7.3,7.2,7.6,7.7,7.5,7.3,7.5,7.5,7.2,7.3,7.2,7.1\",\"2.2,3.0,3.1,3.1,3.5,3.8,3.4,3.8,4.1,4.0,3.7,3.7,3.6\",\"radevormwald, stadt auf der höhe\"\n05374040,18837,9499,9338,05374040,10.5,7.0,3.5,1971,1319,652,\"7.9,8.9,9.0,9.1,9.3,9.8,9.7,9.7,10.0,10.5,10.7,10.8,10.5\",\"6.4,6.8,6.7,6.7,6.7,6.9,6.8,6.7,6.8,7.1,7.6,7.4,7.0\",\"1.5,2.1,2.3,2.4,2.7,3.0,2.9,2.9,3.2,3.4,3.1,3.4,3.5\",reichshof\n05374044,19194,9389,9805,05374044,10.1,6.6,3.5,1941,1275,666,\"8.4,9.4,8.8,9.1,9.2,9.2,9.2,9.2,9.8,9.9,10.1,10.6,10.1\",\"6.9,6.9,6.4,6.5,6.4,6.6,6.5,6.6,6.4,6.6,7.0,7.2,6.6\",\"1.5,2.5,2.4,2.5,2.8,2.6,2.7,2.7,3.4,3.3,3.1,3.4,3.5\",\"waldbröl, stadt\"\n05374048,25274,12253,13021,05374048,10.5,6.9,3.6,2653,1734,919,\"8.1,9.0,9.0,9.2,9.5,10.1,9.7,9.7,10.1,10.2,10.5,10.5,10.5\",\"6.4,6.9,6.6,6.6,6.8,6.9,6.6,6.6,6.7,6.7,7.0,7.0,6.9\",\"1.7,2.2,2.3,2.7,2.8,3.2,3.0,3.1,3.4,3.6,3.5,3.5,3.6\",\"wiehl, stadt\"\n05374052,21481,10655,10826,05374052,12.7,8.3,4.3,2721,1791,930,\"9.4,10.9,11.1,11.3,11.6,12.1,11.5,11.5,11.9,12.9,12.8,12.7,12.7\",\"7.4,8.1,8.2,7.9,8.1,8.4,8.0,8.0,8.0,8.5,8.6,8.4,8.3\",\"2.0,2.9,2.9,3.3,3.5,3.7,3.5,3.5,3.8,4.5,4.2,4.2,4.3\",\"wipperfürth, hansestadt\"\n05378004,111366,53479,57887,05378004,9.3,6.2,3.0,10327,6960,3367,\"6.9,8.2,8.4,8.8,9.1,9.3,9.8,9.7,9.9,9.7,9.6,9.5,9.3\",\"5.5,6.1,6.1,6.3,6.4,6.5,6.8,6.6,6.7,6.5,6.7,6.5,6.2\",\"1.4,2.1,2.3,2.5,2.6,2.8,3.0,3.0,3.2,3.2,2.9,3.0,3.0\",\"bergisch gladbach, stadt\"\n05378008,18256,9037,9219,05378008,10.0,6.8,3.2,1826,1241,585,\"6.9,8.2,8.1,8.6,9.1,9.2,9.5,9.9,10.1,10.3,10.1,10.1,10.0\",\"5.5,5.9,5.7,6.1,6.5,6.3,6.7,6.9,6.9,6.9,7.0,7.0,6.8\",\"1.5,2.3,2.3,2.5,2.6,2.9,2.8,3.0,3.2,3.4,3.0,3.1,3.2\",\"burscheid, stadt\"\n05378012,19893,9823,10070,05378012,11.1,7.6,3.6,2213,1505,708,\"9.0,10.3,10.6,11.0,11.0,11.4,11.4,11.2,11.6,11.9,11.7,11.7,11.1\",\"7.2,7.8,7.9,7.9,7.9,7.9,8.0,7.8,7.9,8.1,8.1,8.0,7.6\",\"1.8,2.6,2.7,3.1,3.1,3.5,3.4,3.4,3.7,3.8,3.6,3.7,3.6\",kürten\n05378016,27937,13468,14469,05378016,8.5,5.9,2.6,2378,1662,716,\"6.4,7.3,7.5,8.1,8.3,8.5,8.3,8.5,8.8,8.7,8.6,8.9,8.5\",\"5.3,5.6,5.6,6.0,6.0,6.0,5.9,6.1,6.2,6.0,6.2,6.3,5.9\",\"1.1,1.6,1.9,2.1,2.3,2.5,2.4,2.4,2.7,2.7,2.5,2.6,2.6\",\"leichlingen (rheinland), blütenstadt\"\n05378020,15123,7456,7667,05378020,8.8,5.8,3.0,1332,875,457,\"6.2,7.3,7.1,7.4,8.0,8.4,8.5,8.6,8.8,9.4,9.4,9.3,8.8\",\"5.2,5.6,5.4,5.5,5.8,5.9,5.9,5.9,6.0,6.5,6.5,6.2,5.8\",\"1.0,1.7,1.7,1.9,2.2,2.5,2.6,2.7,2.8,2.9,2.9,3.1,3.0\",odenthal\n05378024,27264,13439,13825,05378024,10.5,7.0,3.5,2870,1911,959,\"7.6,9.4,9.5,9.9,10.2,10.6,10.5,10.5,10.7,10.8,10.5,10.7,10.5\",\"6.0,6.9,6.9,7.1,7.3,7.5,7.2,7.2,7.2,7.2,7.1,7.2,7.0\",\"1.6,2.5,2.5,2.8,2.9,3.2,3.3,3.3,3.5,3.6,3.4,3.5,3.5\",\"overath, stadt\"\n05378028,28386,13934,14452,05378028,9.2,6.1,3.1,2624,1735,889,\"6.4,7.8,7.8,8.1,8.4,8.9,9.0,9.0,9.3,9.3,9.2,9.5,9.2\",\"5.1,5.7,5.6,5.8,5.9,6.1,6.1,6.0,6.1,6.1,6.3,6.3,6.1\",\"1.4,2.0,2.2,2.3,2.4,2.8,2.9,3.0,3.2,3.2,2.9,3.2,3.1\",\"rösrath, stadt\"\n05378032,34504,16802,17702,05378032,10.5,7.0,3.5,3619,2403,1216,\"8.1,9.5,9.5,9.8,10.2,10.6,10.3,10.5,10.6,10.5,10.4,10.8,10.5\",\"6.3,7.1,6.9,7.1,7.3,7.3,7.2,7.2,7.1,7.0,7.0,7.2,7.0\",\"1.8,2.4,2.7,2.7,3.0,3.2,3.1,3.3,3.5,3.5,3.4,3.6,3.5\",\"wermelskirchen, stadt\"\n05382004,23435,11515,11920,05382004,9.9,6.3,3.7,2324,1467,857,\"6.8,8.1,8.3,8.6,9.2,9.6,9.7,9.8,10.0,10.0,9.8,9.9,9.9\",\"5.1,5.6,5.6,5.9,6.0,6.2,6.2,6.4,6.5,6.3,6.3,6.6,6.3\",\"1.8,2.4,2.7,2.7,3.2,3.3,3.5,3.4,3.5,3.7,3.5,3.4,3.7\",alfter\n05382008,25654,12337,13317,05382008,9.7,6.4,3.3,2495,1640,855,\"6.8,8.0,8.3,8.6,8.8,9.6,9.6,9.6,9.8,9.7,9.8,9.8,9.7\",\"5.2,5.7,5.9,5.9,6.0,6.5,6.3,6.3,6.4,6.4,6.6,6.4,6.4\",\"1.6,2.3,2.4,2.7,2.8,3.1,3.3,3.3,3.3,3.3,3.2,3.4,3.3\",\"bad honnef, stadt\"\n05382012,47636,23280,24356,05382012,9.6,6.1,3.4,4553,2912,1641,\"6.7,8.1,8.0,8.4,8.6,8.9,9.0,9.3,9.6,10.0,10.0,10.0,9.6\",\"5.1,5.8,5.6,5.7,5.8,5.9,6.0,6.1,6.1,6.3,6.6,6.5,6.1\",\"1.6,2.3,2.4,2.7,2.8,3.0,3.1,3.2,3.5,3.7,3.4,3.5,3.4\",\"bornheim, stadt\"\n05382016,18864,9428,9436,05382016,9.7,6.8,2.9,1827,1285,542,\"7.5,8.4,8.6,8.6,8.8,9.0,9.2,9.1,9.6,10.3,9.9,10.0,9.7\",\"6.3,6.5,6.5,6.4,6.5,6.5,6.6,6.4,6.7,7.1,7.2,7.2,6.8\",\"1.3,1.9,2.2,2.1,2.3,2.6,2.6,2.7,2.9,3.2,2.7,2.9,2.9\",eitorf\n05382020,46902,22868,24034,05382020,10.0,6.5,3.4,4673,3072,1601,\"7.2,8.7,8.6,9.0,9.3,9.7,9.7,9.8,9.9,10.2,10.3,10.2,10.0\",\"5.8,6.6,6.3,6.6,6.6,6.7,6.7,6.6,6.7,6.7,7.0,6.9,6.5\",\"1.4,2.1,2.3,2.5,2.7,3.0,3.0,3.2,3.3,3.5,3.3,3.3,3.4\",\"hennef (sieg), stadt\"\n05382024,40702,19858,20844,05382024,9.2,6.1,3.1,3754,2487,1267,\"6.8,8.3,8.4,8.6,8.9,9.1,9.4,9.4,9.4,9.5,9.4,9.4,9.2\",\"5.4,6.1,6.1,6.2,6.3,6.3,6.5,6.4,6.2,6.3,6.4,6.4,6.1\",\"1.4,2.2,2.3,2.4,2.6,2.8,2.9,3.0,3.2,3.3,3.0,3.0,3.1\",\"königswinter, stadt\"\n05382028,30348,14915,15433,05382028,9.0,6.1,2.9,2718,1837,881,\"6.7,7.6,7.7,8.2,8.4,8.5,8.5,8.7,8.6,9.3,9.1,9.2,9.0\",\"5.5,5.7,5.7,6.0,5.9,6.0,6.0,6.0,5.7,6.2,6.2,6.4,6.1\",\"1.2,1.9,1.9,2.2,2.5,2.5,2.5,2.7,2.9,3.1,2.9,2.9,2.9\",\"lohmar, stadt\"\n05382032,24357,11905,12452,05382032,9.2,6.3,2.9,2229,1526,703,\"7.3,8.6,8.5,9.0,9.4,9.7,9.9,9.9,9.9,10.0,9.7,9.6,9.2\",\"5.9,6.4,6.4,6.6,6.9,7.0,7.0,6.7,6.8,6.6,6.8,6.6,6.3\",\"1.4,2.1,2.1,2.4,2.5,2.7,2.8,3.3,3.1,3.4,2.9,3.0,2.9\",\"meckenheim, stadt\"\n05382036,14468,7078,7390,05382036,10.1,6.8,3.3,1459,977,482,\"7.0,8.3,8.3,8.6,9.0,9.3,9.5,9.6,10.0,10.4,10.5,10.5,10.1\",\"5.9,6.4,6.2,6.5,6.6,6.6,6.8,6.6,6.8,6.8,7.2,7.2,6.8\",\"1.2,1.9,2.0,2.1,2.4,2.7,2.8,3.0,3.2,3.6,3.3,3.4,3.3\",much\n05382040,19862,9811,10051,05382040,9.3,6.1,3.2,1848,1217,631,\"6.8,7.9,8.3,8.9,8.9,9.3,9.4,9.3,9.3,10.1,10.1,9.8,9.3\",\"5.4,5.9,6.0,6.4,6.4,6.5,6.6,6.4,6.3,6.8,6.9,6.7,6.1\",\"1.4,2.0,2.3,2.5,2.5,2.8,2.9,2.9,3.0,3.3,3.2,3.1,3.2\",neunkirchen-seelscheid\n05382044,37583,18543,19040,05382044,9.2,5.9,3.3,3447,2201,1246,\"7.0,8.1,8.2,8.6,8.8,9.1,9.2,9.1,9.4,9.5,9.4,9.3,9.2\",\"5.6,5.9,5.8,6.0,6.0,6.1,5.9,5.9,6.0,6.0,6.1,6.0,5.9\",\"1.4,2.2,2.4,2.6,2.8,3.0,3.3,3.2,3.3,3.5,3.2,3.2,3.3\",\"niederkassel, stadt\"\n05382048,27224,13508,13716,05382048,10.0,6.8,3.2,2728,1848,880,\"7.3,8.4,8.6,8.7,9.2,9.5,9.7,9.8,9.9,10.3,9.9,10.1,10.0\",\"5.8,6.4,6.4,6.4,6.5,6.7,6.9,6.8,6.7,6.9,6.8,6.9,6.8\",\"1.5,2.0,2.2,2.3,2.7,2.8,2.8,3.0,3.2,3.4,3.1,3.2,3.2\",\"rheinbach, stadt\"\n05382052,10461,5126,5335,05382052,9.3,6.5,2.8,971,680,291,\"6.3,7.8,7.4,8.0,8.5,8.7,9.0,9.3,8.9,9.4,9.1,9.4,9.3\",\"5.1,5.9,5.6,6.0,6.2,6.1,6.3,6.8,6.3,6.5,6.7,6.8,6.5\",\"1.2,1.9,1.8,2.0,2.3,2.5,2.7,2.5,2.6,2.9,2.5,2.6,2.8\",ruppichteroth\n05382056,55709,27246,28463,05382056,8.8,5.8,3.0,4891,3205,1686,\"6.6,7.8,8.1,8.5,8.7,9.0,9.3,9.1,9.0,9.3,9.2,9.1,8.8\",\"5.3,5.7,5.8,6.0,6.0,6.0,6.1,6.0,5.8,6.0,6.2,6.1,5.8\",\"1.4,2.1,2.4,2.6,2.7,3.0,3.2,3.1,3.2,3.4,3.0,3.0,3.0\",\"sankt augustin, stadt\"\n05382060,41016,20169,20847,05382060,9.4,6.0,3.4,3846,2469,1377,\"7.5,8.6,8.8,9.2,9.5,9.7,9.8,9.7,9.7,9.8,9.8,9.8,9.4\",\"5.9,6.3,6.3,6.5,6.5,6.5,6.5,6.4,6.2,6.2,6.5,6.4,6.0\",\"1.6,2.3,2.5,2.8,3.0,3.3,3.3,3.3,3.5,3.6,3.3,3.3,3.4\",\"siegburg, stadt\"\n05382064,18204,8995,9209,05382064,9.0,5.9,3.1,1631,1072,559,\"6.7,8.0,8.0,8.1,8.5,8.8,9.1,9.1,9.0,9.4,9.5,9.3,9.0\",\"5.5,6.1,5.8,5.8,6.0,6.1,6.3,6.3,6.0,6.2,6.4,6.2,5.9\",\"1.2,1.8,2.1,2.2,2.5,2.7,2.8,2.9,3.0,3.2,3.1,3.1,3.1\",swisttal\n05382068,74400,36404,37996,05382068,9.9,6.3,3.6,7369,4680,2689,\"7.1,8.5,8.6,8.8,9.1,9.4,9.5,9.7,9.9,10.3,10.2,10.2,9.9\",\"5.5,6.1,6.1,6.0,6.1,6.2,6.4,6.4,6.3,6.5,6.6,6.5,6.3\",\"1.6,2.4,2.5,2.8,3.0,3.2,3.1,3.4,3.6,3.8,3.6,3.7,3.6\",\"troisdorf, stadt\"\n05382072,20457,10090,10367,05382072,8.9,5.6,3.3,1822,1151,671,\"6.0,7.4,7.7,7.8,8.2,8.6,8.6,8.7,8.8,9.1,9.1,9.0,8.9\",\"4.7,5.4,5.6,5.6,5.6,5.7,5.6,5.6,5.5,5.6,5.9,5.6,5.6\",\"1.3,2.0,2.1,2.3,2.7,2.9,3.0,3.1,3.4,3.5,3.2,3.4,3.3\",wachtberg\n05382076,18931,9479,9452,05382076,9.2,6.6,2.6,1738,1251,487,\"6.4,7.1,7.2,7.1,7.4,7.8,7.8,7.9,8.1,8.9,9.2,9.2,9.2\",\"5.4,5.8,5.8,5.5,5.7,5.8,5.7,5.9,5.9,6.4,6.8,6.8,6.6\",\"1.0,1.4,1.4,1.6,1.8,2.0,2.0,2.0,2.2,2.4,2.3,2.3,2.6\",windeck\n05512000,117143,57004,60139,05512000,9.4,7.2,2.2,10999,8402,2597,\"7.3,8.5,8.4,8.9,9.1,9.3,9.5,9.8,9.9,9.8,9.9,9.8,9.4\",\"6.3,6.9,6.9,7.2,7.2,7.2,7.4,7.5,7.6,7.4,7.7,7.6,7.2\",\"1.0,1.5,1.6,1.7,1.9,2.1,2.1,2.3,2.3,2.4,2.2,2.2,2.2\",\"bottrop, stadt\"\n05513000,260368,129267,131101,05513000,8.7,6.7,2.0,22552,17336,5216,\"6.8,8.0,7.8,8.1,8.3,8.5,8.9,9.0,9.0,8.7,8.9,8.9,8.7\",\"5.8,6.5,6.3,6.5,6.5,6.5,6.8,6.9,6.9,6.6,7.0,6.9,6.7\",\"1.0,1.5,1.5,1.6,1.8,1.9,2.0,2.1,2.1,2.1,2.0,2.0,2.0\",\"gelsenkirchen, stadt\"\n05515000,310039,148447,161592,05515000,11.1,7.7,3.3,34282,24009,10273,\"8.1,9.8,10.1,10.3,10.6,10.9,11.2,11.0,11.2,11.3,11.1,11.3,11.1\",\"6.1,7.0,7.1,7.3,7.4,7.4,7.5,7.3,7.4,7.4,7.8,8.0,7.7\",\"2.0,2.8,3.0,3.0,3.2,3.5,3.7,3.7,3.8,3.9,3.3,3.4,3.3\",\"münster, stadt\"\n05554004,39277,19613,19664,05554004,15.3,10.4,4.9,6013,4092,1921,\"10.9,12.2,12.4,12.8,13.5,14.1,14.5,14.7,15.2,15.4,15.7,15.6,15.3\",\"9.1,9.7,9.6,9.7,10.1,10.2,10.5,10.5,10.5,10.5,10.9,10.8,10.4\",\"1.8,2.5,2.8,3.1,3.4,3.9,4.0,4.2,4.6,4.9,4.8,4.9,4.9\",\"ahaus, stadt\"\n05554008,71443,35039,36404,05554008,12.7,9.0,3.7,9043,6411,2632,\"9.6,10.9,10.8,11.1,11.5,11.8,12.3,12.4,12.6,13.0,12.9,12.9,12.7\",\"7.7,8.3,8.2,8.4,8.5,8.7,9.1,9.1,8.9,9.2,9.4,9.3,9.0\",\"1.9,2.6,2.6,2.7,2.9,3.1,3.2,3.4,3.6,3.8,3.5,3.6,3.7\",\"bocholt, stadt\"\n05554012,42272,20803,21469,05554012,12.6,8.7,3.9,5319,3659,1660,\"9.5,10.7,11.2,11.7,11.9,12.2,12.4,12.4,12.9,12.7,12.7,13.0,12.6\",\"7.9,8.4,8.6,8.9,8.9,9.0,9.1,9.1,9.0,8.8,9.1,9.1,8.7\",\"1.7,2.3,2.6,2.8,3.0,3.2,3.3,3.4,3.8,3.9,3.6,3.9,3.9\",\"borken, stadt\"\n05554016,17118,8644,8474,05554016,12.8,9.0,3.7,2184,1544,640,\"9.5,10.6,10.5,11.0,11.4,11.7,11.8,12.0,12.5,12.8,13.1,12.9,12.8\",\"7.8,8.5,8.2,8.7,8.7,8.8,8.8,8.9,9.1,9.0,9.6,9.2,9.0\",\"1.6,2.2,2.3,2.3,2.8,2.9,3.1,3.1,3.4,3.8,3.5,3.7,3.7\",\"gescher, glockenstadt\"\n05554020,47010,23468,23542,05554020,12.0,8.7,3.3,5623,4084,1539,\"9.7,10.5,10.3,10.9,11.3,11.6,11.8,11.9,12.3,12.7,12.6,12.5,12.0\",\"8.4,8.8,8.4,8.6,8.9,8.9,9.0,8.9,9.0,9.2,9.4,9.1,8.7\",\"1.3,1.7,2.0,2.3,2.4,2.7,2.8,3.0,3.3,3.5,3.2,3.3,3.3\",\"gronau (westf.), stadt\"\n05554024,8505,4315,4190,05554024,14.3,10.1,4.3,1218,856,362,\"9.9,10.6,10.6,11.1,11.5,12.7,13.5,13.8,13.9,15.0,15.4,15.0,14.3\",\"8.1,8.3,8.2,8.4,8.4,9.2,10.1,9.7,9.7,10.4,10.9,10.7,10.1\",\"1.8,2.4,2.4,2.7,3.1,3.5,3.4,4.1,4.2,4.5,4.5,4.4,4.3\",heek\n05554028,8152,4127,4025,05554028,12.8,8.9,3.9,1041,727,314,\"9.5,11.4,12.0,11.5,11.8,12.6,12.9,13.0,13.0,12.8,13.1,13.0,12.8\",\"7.8,8.9,9.4,8.9,9.0,9.6,9.7,9.7,9.5,9.4,9.5,9.4,8.9\",\"1.6,2.5,2.6,2.5,2.8,3.0,3.2,3.3,3.5,3.4,3.5,3.5,3.9\",heiden\n05554032,10736,5387,5349,05554032,13.4,9.5,3.9,1437,1021,416,\"10.1,11.2,11.1,11.7,12.1,12.6,13.3,13.1,13.5,14.1,13.6,13.4,13.4\",\"8.3,8.8,8.4,8.9,8.9,9.2,9.8,9.6,9.6,10.0,9.8,9.7,9.5\",\"1.7,2.4,2.7,2.8,3.2,3.3,3.5,3.5,3.9,4.0,3.8,3.7,3.9\",\"isselburg, stadt\"\n05554036,7254,3794,3460,05554036,13.7,9.5,4.2,997,689,308,\"10.7,11.7,12.5,12.7,13.1,13.9,14.2,14.4,14.9,14.5,14.8,14.1,13.7\",\"8.7,9.1,9.6,9.7,9.7,9.9,10.2,10.2,10.5,9.9,10.5,10.0,9.5\",\"2.0,2.6,2.9,3.0,3.4,4.0,4.0,4.2,4.4,4.5,4.2,4.1,4.2\",legden\n05554040,11378,5735,5643,05554040,12.8,9.0,3.8,1454,1024,430,\"8.5,9.8,10.3,11.2,11.9,12.2,12.9,13.0,13.4,13.3,13.1,13.0,12.8\",\"7.3,7.8,8.1,8.8,9.2,9.4,9.7,9.4,9.7,9.3,9.5,9.2,9.0\",\"1.2,2.0,2.2,2.4,2.8,2.8,3.3,3.5,3.7,4.0,3.6,3.7,3.8\",raesfeld\n05554044,14532,7398,7134,05554044,12.0,8.3,3.6,1741,1212,529,\"8.8,10.3,10.4,11.1,11.4,11.6,11.9,12.1,12.5,12.0,12.0,12.0,12.0\",\"7.3,8.1,8.2,8.6,8.6,8.5,8.8,8.7,9.0,8.6,8.7,8.4,8.3\",\"1.5,2.2,2.2,2.5,2.8,3.1,3.1,3.4,3.6,3.4,3.3,3.6,3.6\",reken\n05554048,19284,9622,9662,05554048,12.3,8.8,3.5,2370,1693,677,\"9.2,10.6,11.0,11.5,11.8,11.7,12.3,12.6,12.6,12.7,13.0,12.9,12.3\",\"7.5,8.3,8.5,8.9,9.0,8.8,9.1,9.3,9.2,9.1,9.5,9.4,8.8\",\"1.7,2.3,2.5,2.7,2.8,2.9,3.1,3.3,3.4,3.6,3.5,3.5,3.5\",\"rhede, stadt\"\n05554052,7280,3895,3385,05554052,12.7,8.7,4.0,921,633,288,\"8.8,10.4,10.2,9.8,9.8,10.0,10.5,10.8,10.4,12.8,12.6,12.9,12.7\",\"7.1,8.1,7.9,7.5,7.4,6.9,7.3,7.6,7.2,8.8,8.9,9.0,8.7\",\"1.7,2.3,2.3,2.2,2.5,3.0,3.2,3.2,3.2,4.0,3.7,3.9,4.0\",schöppingen\n05554056,20411,10267,10144,05554056,15.3,10.0,5.2,3119,2048,1071,\"11.6,13.3,13.1,13.8,14.3,14.6,15.1,15.0,15.5,16.0,15.9,16.0,15.3\",\"9.5,10.3,10.2,10.4,10.6,10.6,10.8,10.5,10.8,10.8,10.6,10.7,10.0\",\"2.1,3.0,2.9,3.4,3.7,4.1,4.3,4.5,4.7,5.2,5.2,5.3,5.2\",\"stadtlohn, stadt\"\n05554060,9134,4542,4592,05554060,13.9,9.5,4.4,1271,869,402,\"11.0,12.3,12.6,13.6,13.4,13.7,14.0,13.9,14.4,14.6,14.8,14.6,13.9\",\"9.2,9.8,9.7,10.2,9.9,9.9,9.8,9.8,9.8,10.0,10.6,10.3,9.5\",\"1.8,2.5,3.0,3.3,3.5,3.8,4.2,4.1,4.7,4.5,4.1,4.3,4.4\",südlohn\n05554064,13192,6737,6455,05554064,13.1,9.3,3.8,1725,1225,500,\"9.2,10.6,10.8,11.2,11.5,11.9,12.2,12.2,12.9,12.9,13.0,13.4,13.1\",\"7.7,8.5,8.5,8.4,8.5,8.7,9.0,8.9,9.3,9.3,9.6,9.5,9.3\",\"1.5,2.1,2.3,2.8,3.0,3.1,3.2,3.3,3.6,3.7,3.4,3.8,3.8\",\"velen, stadt\"\n05554068,22688,11587,11101,05554068,16.4,10.9,5.5,3720,2482,1238,\"11.1,12.7,13.0,13.6,14.5,14.9,15.5,15.5,15.9,16.2,16.6,16.9,16.4\",\"8.8,9.5,9.6,10.0,10.4,10.6,11.1,11.1,11.0,11.0,11.3,11.4,10.9\",\"2.3,3.2,3.4,3.6,4.1,4.3,4.4,4.4,4.9,5.2,5.3,5.5,5.5\",\"vreden, stadt\"\n05558004,15253,7618,7635,05558004,10.5,7.4,3.1,1600,1128,472,\"7.5,8.8,9.1,9.5,10.0,10.2,10.6,10.7,10.9,11.0,10.9,10.9,10.5\",\"6.2,6.9,7.0,7.2,7.5,7.4,7.8,7.6,7.7,7.6,7.7,7.7,7.4\",\"1.3,2.0,2.1,2.4,2.5,2.8,2.9,3.1,3.2,3.4,3.2,3.2,3.1\",ascheberg\n05558008,11593,5812,5781,05558008,11.6,7.8,3.8,1342,904,438,\"8.3,9.5,9.4,9.6,10.0,10.7,11.1,11.1,11.1,11.3,11.6,11.2,11.6\",\"6.9,7.3,7.3,7.2,7.5,7.9,7.9,7.6,7.7,7.7,8.1,7.6,7.8\",\"1.3,2.1,2.1,2.4,2.5,2.8,3.2,3.4,3.5,3.6,3.5,3.7,3.8\",\"billerbeck, stadt\"\n05558012,36116,17738,18378,05558012,11.9,8.0,3.8,4286,2904,1382,\"9.3,10.5,10.4,10.8,11.1,11.3,11.6,11.9,12.2,12.3,12.2,12.4,11.9\",\"7.5,8.1,8.1,8.2,8.2,8.1,8.2,8.4,8.5,8.5,8.6,8.6,8.0\",\"1.8,2.4,2.3,2.7,3.0,3.2,3.4,3.6,3.7,3.8,3.6,3.8,3.8\",\"coesfeld, stadt\"\n05558016,46613,22685,23928,05558016,10.7,7.6,3.2,5004,3522,1482,\"8.1,9.3,9.5,9.9,10.2,10.7,10.7,10.9,11.1,11.1,11.3,11.1,10.7\",\"6.7,7.3,7.4,7.5,7.7,7.9,7.9,7.9,7.8,7.8,8.1,8.0,7.6\",\"1.4,2.0,2.2,2.4,2.5,2.8,2.8,2.9,3.2,3.4,3.2,3.2,3.2\",\"dülmen, stadt\"\n05558020,11689,5732,5957,05558020,10.4,7.0,3.3,1210,820,390,\"6.9,8.0,8.4,9.1,9.2,9.7,10.0,9.9,9.6,9.9,10.1,10.4,10.4\",\"5.4,6.0,5.9,6.7,6.7,7.1,7.1,7.0,6.8,6.8,7.2,7.1,7.0\",\"1.5,2.0,2.5,2.4,2.5,2.5,2.8,2.9,2.8,3.1,3.0,3.3,3.3\",havixbeck\n05558024,24263,12054,12209,05558024,10.6,7.4,3.1,2563,1805,758,\"7.7,8.9,8.8,9.2,9.9,9.9,10.3,10.5,10.5,10.8,11.0,10.8,10.6\",\"6.5,7.0,6.8,7.1,7.6,7.3,7.6,7.6,7.4,7.6,8.0,7.7,7.4\",\"1.2,1.9,1.9,2.1,2.4,2.6,2.7,2.9,3.1,3.3,3.0,3.1,3.1\",\"lüdinghausen, stadt\"\n05558028,9781,4845,4936,05558028,10.5,7.4,3.1,1026,724,302,\"7.7,8.7,9.1,9.3,9.3,9.9,9.9,10.1,9.7,11.0,10.4,10.7,10.5\",\"6.6,6.8,7.0,7.0,6.9,7.3,7.3,7.3,7.0,7.7,7.6,7.6,7.4\",\"1.1,1.9,2.1,2.3,2.5,2.5,2.6,2.7,2.8,3.2,2.8,3.1,3.1\",nordkirchen\n05558032,19436,9641,9795,05558032,11.0,7.5,3.6,2143,1452,691,\"8.1,9.3,9.4,9.7,10.3,10.5,10.7,10.8,10.8,11.0,11.1,11.1,11.0\",\"6.4,6.9,6.9,7.1,7.3,7.3,7.5,7.5,7.4,7.4,7.7,7.7,7.5\",\"1.7,2.4,2.5,2.5,3.0,3.2,3.2,3.3,3.4,3.6,3.4,3.5,3.6\",nottuln\n05558036,12490,6145,6345,05558036,10.0,7.2,2.8,1250,905,345,\"7.1,8.2,8.2,8.7,9.0,9.3,9.6,9.7,10.0,10.1,10.2,10.5,10.0\",\"6.1,6.7,6.7,6.9,7.1,7.3,7.4,7.2,7.2,7.1,7.4,7.5,7.2\",\"1.1,1.5,1.6,1.7,1.9,2.0,2.2,2.6,2.9,2.9,2.8,3.0,2.8\",\"olfen, stadt\"\n05558040,10712,5507,5205,05558040,12.5,8.1,4.3,1337,872,465,\"8.9,10.0,10.4,10.4,10.6,11.5,11.9,12.3,12.6,12.3,13.2,13.4,12.5\",\"7.3,7.8,8.0,8.0,8.0,8.6,8.6,8.8,9.0,8.7,9.4,9.2,8.1\",\"1.6,2.2,2.4,2.4,2.6,2.8,3.3,3.5,3.7,3.6,3.8,4.2,4.3\",rosendahl\n05558044,20455,10176,10279,05558044,10.8,7.2,3.6,2209,1482,727,\"7.7,9.0,9.2,9.6,10.1,10.3,10.3,10.6,10.8,11.1,10.9,10.9,10.8\",\"6.4,6.8,6.8,7.1,7.1,7.1,7.1,7.3,7.0,7.3,7.5,7.5,7.2\",\"1.3,2.2,2.3,2.5,2.9,3.2,3.3,3.4,3.8,3.8,3.4,3.4,3.6\",senden\n05562004,74220,36210,38010,05562004,8.6,6.4,2.3,6411,4719,1692,\"7.1,8.1,8.1,8.4,8.5,8.7,9.1,9.1,9.1,9.3,9.1,9.1,8.6\",\"6.1,6.5,6.5,6.6,6.5,6.6,6.9,6.9,6.8,6.8,7.0,6.9,6.4\",\"1.0,1.6,1.6,1.8,2.0,2.1,2.2,2.2,2.3,2.4,2.1,2.2,2.3\",\"castrop-rauxel, stadt\"\n05562008,34521,16922,17599,05562008,9.5,7.3,2.2,3277,2505,772,\"7.1,8.4,8.3,8.8,8.9,9.2,9.3,9.4,9.3,9.6,9.5,9.7,9.5\",\"6.1,7.0,6.8,7.1,7.0,7.1,7.2,7.2,7.1,7.3,7.4,7.5,7.3\",\"1.0,1.5,1.5,1.8,2.0,2.1,2.1,2.2,2.2,2.4,2.0,2.1,2.2\",\"datteln, stadt\"\n05562012,75431,36714,38717,05562012,10.4,7.9,2.5,7808,5949,1859,\"8.1,9.1,9.2,9.5,9.9,10.3,10.6,10.7,10.8,10.6,10.6,10.6,10.4\",\"7.0,7.5,7.5,7.7,7.9,8.1,8.3,8.3,8.2,8.1,8.2,8.2,7.9\",\"1.0,1.6,1.7,1.8,2.0,2.2,2.3,2.4,2.5,2.6,2.3,2.3,2.5\",\"dorsten, stadt\"\n05562014,75455,36801,38654,05562014,9.5,7.4,2.2,7205,5576,1629,\"7.2,8.5,8.4,8.7,8.8,8.9,9.2,9.4,9.7,9.7,9.8,9.9,9.5\",\"6.3,7.1,6.9,7.0,7.1,7.1,7.2,7.4,7.4,7.5,7.7,7.8,7.4\",\"0.9,1.5,1.5,1.7,1.8,1.8,2.0,2.1,2.3,2.2,2.1,2.1,2.2\",\"gladbeck, stadt\"\n05562016,38020,18535,19485,05562016,9.4,6.9,2.5,3587,2629,958,\"7.5,8.5,8.6,8.9,9.0,9.0,9.3,9.6,9.4,9.5,9.5,9.6,9.4\",\"6.4,6.9,6.9,7.0,7.0,6.8,6.9,7.1,6.9,7.1,7.2,7.1,6.9\",\"1.1,1.6,1.8,1.9,2.0,2.2,2.3,2.5,2.5,2.5,2.3,2.5,2.5\",\"haltern am see, stadt\"\n05562020,61163,29875,31288,05562020,9.0,7.0,2.0,5493,4298,1195,\"7.3,8.2,8.4,8.6,8.9,8.9,9.2,9.2,9.4,9.3,9.3,9.3,9.0\",\"6.3,6.9,6.9,6.9,7.1,7.0,7.0,7.1,7.2,7.1,7.4,7.4,7.0\",\"1.0,1.4,1.5,1.6,1.8,1.9,2.1,2.1,2.2,2.2,1.9,2.0,2.0\",\"herten, stadt\"\n05562024,83926,41288,42638,05562024,9.2,7.1,2.1,7707,5980,1727,\"7.3,8.3,8.3,8.6,9.0,9.3,9.6,9.6,9.6,9.8,9.6,9.6,9.2\",\"6.4,6.8,6.8,6.9,7.3,7.3,7.5,7.5,7.4,7.5,7.6,7.6,7.1\",\"1.0,1.5,1.5,1.6,1.7,2.0,2.1,2.1,2.2,2.3,2.0,2.0,2.1\",\"marl, stadt\"\n05562028,31387,15553,15834,05562028,8.5,6.7,1.8,2668,2108,560,\"7.6,8.8,8.8,9.0,9.2,9.6,9.7,9.5,9.4,9.1,8.7,8.9,8.5\",\"6.5,7.2,7.2,7.2,7.2,7.3,7.5,7.4,7.2,6.9,6.9,7.0,6.7\",\"1.0,1.6,1.6,1.8,2.0,2.3,2.2,2.1,2.2,2.2,1.8,1.9,1.8\",\"oer-erkenschwick, stadt\"\n05562032,114330,55697,58633,05562032,9.4,7.1,2.2,10707,8143,2564,\"7.2,8.4,8.3,8.5,8.7,8.8,9.0,9.2,9.2,9.4,9.3,9.6,9.4\",\"6.1,6.8,6.7,6.7,6.8,6.8,7.0,7.0,7.0,7.1,7.2,7.4,7.1\",\"1.1,1.6,1.6,1.7,1.9,2.0,2.1,2.2,2.3,2.3,2.1,2.2,2.2\",\"recklinghausen, stadt\"\n05562036,29354,14298,15056,05562036,9.5,7.2,2.3,2802,2117,685,\"7.8,8.8,8.9,9.0,9.2,9.4,9.6,9.7,9.8,9.8,9.7,9.9,9.5\",\"6.8,7.3,7.3,7.3,7.2,7.3,7.5,7.4,7.5,7.5,7.6,7.7,7.2\",\"1.0,1.5,1.6,1.7,1.9,2.1,2.1,2.2,2.3,2.3,2.1,2.2,2.3\",\"waltrop, stadt\"\n05566004,10315,5201,5114,05566004,10.4,7.0,3.5,1075,718,357,\"7.7,9.0,9.3,9.7,10.1,9.9,10.5,10.4,10.2,10.5,10.6,10.5,10.4\",\"6.2,6.7,6.7,6.8,7.2,6.8,7.0,6.9,6.7,6.9,7.2,6.8,7.0\",\"1.6,2.2,2.6,2.9,2.9,3.1,3.5,3.5,3.6,3.6,3.4,3.7,3.5\",altenberge\n05566008,36320,18009,18311,05566008,12.1,8.2,3.9,4412,2979,1433,\"10.3,11.4,11.1,11.5,11.9,12.4,12.3,12.2,12.6,12.5,12.7,12.7,12.1\",\"8.4,8.9,8.5,8.7,8.8,8.9,8.9,8.6,8.8,8.5,8.9,8.7,8.2\",\"1.9,2.5,2.6,2.9,3.0,3.4,3.4,3.6,3.8,4.0,3.8,4.0,3.9\",\"emsdetten, stadt\"\n05566012,36674,18087,18587,05566012,11.1,7.3,3.8,4072,2684,1388,\"8.5,9.6,9.7,9.9,10.3,10.5,10.6,10.9,11.2,11.8,11.7,11.6,11.1\",\"6.5,7.1,7.1,7.1,7.2,7.2,7.3,7.5,7.5,7.8,8.0,7.8,7.3\",\"1.9,2.5,2.6,2.8,3.1,3.3,3.3,3.4,3.7,4.0,3.7,3.7,3.8\",\"greven, stadt\"\n05566016,19995,10048,9947,05566016,12.6,8.8,3.8,2515,1760,755,\"9.2,10.6,11.0,11.4,12.0,12.3,12.3,12.3,12.6,12.7,12.8,12.7,12.6\",\"7.6,8.4,8.5,8.6,9.0,9.2,9.1,8.8,8.8,8.9,9.0,9.1,8.8\",\"1.6,2.2,2.4,2.8,3.1,3.0,3.2,3.6,3.8,3.8,3.7,3.7,3.8\",\"hörstel, stadt\"\n05566020,7642,3973,3669,05566020,14.0,9.6,4.4,1072,732,340,\"10.2,11.5,12.3,12.9,13.1,13.3,13.4,13.7,13.9,14.2,13.7,14.2,14.0\",\"8.3,9.1,9.7,9.9,10.0,9.9,9.8,9.7,9.6,9.6,9.3,9.6,9.6\",\"1.9,2.5,2.6,3.0,3.0,3.4,3.6,4.0,4.3,4.6,4.3,4.5,4.4\",hopsten\n05566024,6447,3274,3173,05566024,10.8,7.8,3.0,696,501,195,\"8.6,10.3,10.7,11.0,10.9,11.1,11.5,11.5,12.0,11.2,11.6,11.8,10.8\",\"7.2,8.4,8.5,8.6,8.6,8.7,8.7,8.4,8.7,8.0,8.5,8.5,7.8\",\"1.4,2.0,2.2,2.3,2.3,2.5,2.8,3.1,3.3,3.2,3.1,3.3,3.0\",\"horstmar, stadt der burgmannshöfe\"\n05566028,50935,25176,25759,05566028,12.0,8.4,3.6,6097,4281,1816,\"9.1,10.5,10.6,10.9,11.3,11.6,11.8,11.7,11.8,12.2,12.1,12.1,12.0\",\"7.6,8.3,8.3,8.3,8.4,8.4,8.4,8.3,8.3,8.5,8.6,8.5,8.4\",\"1.5,2.2,2.3,2.6,2.9,3.2,3.3,3.4,3.5,3.8,3.4,3.6,3.6\",\"ibbenbüren, stadt\"\n05566032,6694,3321,3373,05566032,11.3,7.1,4.3,757,472,285,\"7.8,9.3,9.7,9.8,10.3,10.7,11.7,11.5,11.8,12.1,11.6,11.6,11.3\",\"6.4,6.9,7.2,7.0,7.1,7.4,8.1,7.8,7.7,8.0,7.7,7.4,7.1\",\"1.5,2.4,2.5,2.8,3.2,3.4,3.6,3.7,4.1,4.1,4.0,4.3,4.3\",ladbergen\n05566036,6721,3370,3351,05566036,10.6,7.4,3.2,713,499,214,\"9.5,10.7,10.7,10.7,10.8,11.3,12.0,11.1,11.6,11.1,10.9,10.5,10.6\",\"7.8,8.3,8.3,8.3,8.4,8.3,8.8,8.2,8.0,7.7,7.7,7.4,7.4\",\"1.7,2.4,2.4,2.4,2.4,3.0,3.2,2.9,3.6,3.4,3.2,3.1,3.2\",laer\n05566040,22461,11129,11332,05566040,10.6,7.1,3.5,2373,1590,783,\"7.8,9.2,9.1,9.7,10.4,10.2,10.2,10.4,10.7,11.0,10.7,10.8,10.6\",\"6.1,6.8,6.8,6.9,7.4,7.0,7.0,7.1,7.2,7.3,7.4,7.3,7.1\",\"1.7,2.4,2.4,2.8,3.0,3.2,3.2,3.3,3.6,3.7,3.3,3.5,3.5\",\"lengerich, stadt\"\n05566044,8559,4316,4243,05566044,10.8,7.2,3.6,921,616,305,\"7.9,8.9,8.9,9.4,9.8,9.8,10.0,10.1,10.6,10.8,10.5,11.0,10.8\",\"6.6,6.9,6.8,7.0,7.2,7.1,7.0,7.0,7.0,7.2,7.2,7.4,7.2\",\"1.3,2.0,2.1,2.4,2.6,2.8,3.0,3.0,3.6,3.6,3.3,3.6,3.6\",lienen\n05566048,14175,7094,7081,05566048,12.5,8.0,4.5,1771,1128,643,\"8.3,9.5,9.6,10.3,10.8,11.3,11.4,11.5,11.8,12.2,12.3,12.2,12.5\",\"6.4,7.0,7.0,7.4,7.6,7.6,7.5,7.3,7.5,7.7,7.7,7.7,8.0\",\"1.9,2.5,2.6,2.9,3.2,3.7,3.9,4.2,4.4,4.5,4.6,4.5,4.5\",lotte\n05566052,6461,3262,3199,05566052,11.6,8.3,3.3,748,537,211,\"9.7,11.1,10.8,11.2,11.7,11.8,12.7,12.8,12.1,12.4,12.4,11.9,11.6\",\"8.4,9.2,8.7,8.8,9.4,9.3,10.0,9.7,8.8,9.3,9.3,8.8,8.3\",\"1.4,1.9,2.1,2.4,2.3,2.4,2.7,3.1,3.3,3.1,3.1,3.1,3.3\",metelen\n05566056,11815,5875,5940,05566056,12.8,9.1,3.7,1510,1074,436,\"9.2,10.9,11.1,10.9,11.3,11.5,11.9,12.1,12.4,12.8,12.9,12.9,12.8\",\"7.8,8.6,8.8,8.6,8.6,8.8,8.9,9.0,9.1,9.4,9.8,9.4,9.1\",\"1.4,2.3,2.3,2.4,2.7,2.7,2.9,3.1,3.3,3.4,3.2,3.5,3.7\",mettingen\n05566060,13743,6908,6835,05566060,13.1,9.4,3.7,1806,1297,509,\"9.4,10.9,11.1,11.7,12.5,12.7,13.1,13.3,13.6,13.6,13.7,13.6,13.1\",\"7.8,8.6,8.6,8.8,9.2,9.4,9.6,9.8,10.0,9.8,10.4,9.9,9.4\",\"1.7,2.3,2.6,2.9,3.3,3.3,3.4,3.5,3.7,3.8,3.3,3.7,3.7\",neuenkirchen\n05566064,9388,4650,4738,05566064,12.1,8.3,3.8,1137,777,360,\"8.9,10.1,10.4,10.3,10.4,11.2,11.7,11.7,12.1,12.1,12.2,12.5,12.1\",\"7.5,7.9,8.1,7.9,8.0,8.1,8.4,8.4,8.4,8.4,8.7,8.5,8.3\",\"1.5,2.2,2.4,2.3,2.5,3.1,3.3,3.3,3.8,3.6,3.5,4.0,3.8\",nordwalde\n05566068,19599,9922,9677,05566068,12.9,8.9,4.0,2530,1751,779,\"8.9,10.3,10.7,11.2,11.6,12.0,11.8,12.1,12.6,13.0,13.5,13.6,12.9\",\"7.3,8.0,8.2,8.4,8.6,8.7,8.5,8.6,8.7,8.9,9.7,9.6,8.9\",\"1.6,2.3,2.5,2.7,3.0,3.3,3.3,3.5,3.9,4.1,3.8,4.0,4.0\",\"ochtrup, stadt\"\n05566072,11363,5661,5702,05566072,14.9,10.7,4.2,1693,1213,480,\"9.8,11.5,11.8,11.9,12.3,12.7,13.3,13.6,13.8,14.4,14.4,14.8,14.9\",\"8.1,9.1,9.5,9.2,9.3,9.6,9.8,10.1,10.1,10.4,10.6,10.6,10.7\",\"1.6,2.5,2.4,2.8,2.9,3.0,3.5,3.5,3.7,4.0,3.8,4.1,4.2\",recke\n05566076,74852,36911,37941,05566076,11.8,8.3,3.5,8829,6184,2645,\"9.4,10.7,10.6,11.0,11.6,11.8,11.6,11.6,11.8,12.2,12.1,12.0,11.8\",\"7.8,8.5,8.4,8.5,8.8,8.8,8.6,8.5,8.5,8.5,8.8,8.5,8.3\",\"1.6,2.2,2.3,2.5,2.8,3.0,3.0,3.1,3.3,3.6,3.3,3.5,3.5\",\"rheine, stadt\"\n05566080,7191,3639,3552,05566080,12.1,8.0,4.1,871,573,298,\"9.0,9.9,10.1,10.2,10.5,11.3,11.6,11.0,12.0,12.0,12.8,12.9,12.1\",\"7.1,7.5,7.2,7.2,7.5,8.1,7.8,7.5,8.1,8.2,8.9,8.7,8.0\",\"1.9,2.4,2.9,2.9,3.1,3.2,3.7,3.5,3.9,3.8,3.9,4.2,4.1\",\"saerbeck, nrw-klimakommune\"\n05566084,33682,16719,16963,05566084,11.8,8.4,3.4,3980,2836,1144,\"9.8,10.7,10.6,10.9,11.1,11.7,11.8,12.0,12.1,12.3,12.5,12.6,11.8\",\"8.1,8.3,8.4,8.3,8.4,8.7,8.8,8.7,8.7,8.7,9.2,9.2,8.4\",\"1.7,2.3,2.2,2.6,2.7,2.9,3.0,3.3,3.4,3.5,3.4,3.4,3.4\",\"steinfurt, stadt\"\n05566088,9062,4573,4489,05566088,10.4,7.1,3.2,938,647,291,\"7.9,9.2,9.5,10.2,10.3,10.4,9.8,10.1,10.4,10.4,10.4,10.6,10.4\",\"6.7,7.0,7.2,7.7,7.6,7.5,7.2,7.1,7.3,7.3,7.6,7.6,7.1\",\"1.2,2.2,2.2,2.5,2.7,2.9,2.7,3.0,3.1,3.1,2.9,3.0,3.2\",\"tecklenburg, stadt\"\n05566092,11178,5582,5596,05566092,11.5,7.8,3.8,1287,867,420,\"8.5,9.8,10.1,10.1,10.3,10.6,10.9,11.4,11.4,11.7,11.6,11.5,11.5\",\"6.9,7.5,7.9,7.6,7.6,7.7,7.8,7.9,7.8,7.9,8.1,8.0,7.8\",\"1.6,2.3,2.1,2.5,2.8,2.9,3.1,3.5,3.6,3.9,3.5,3.5,3.8\",westerkappeln\n05566096,8102,4082,4020,05566096,13.0,9.3,3.7,1057,756,301,\"8.7,10.5,10.8,10.9,12.2,12.4,12.9,12.4,12.5,12.6,13.0,13.0,13.0\",\"7.2,8.1,8.3,8.4,9.3,9.3,9.5,9.0,8.8,8.9,9.4,9.3,9.3\",\"1.5,2.4,2.5,2.5,2.9,3.1,3.4,3.4,3.7,3.7,3.6,3.7,3.7\",wettringen\n05570004,52287,25551,26736,05570004,11.0,8.2,2.8,5748,4282,1466,\"8.1,9.1,9.4,9.5,10.0,10.3,10.6,10.9,11.1,11.2,11.3,11.2,11.0\",\"6.8,7.3,7.4,7.4,7.6,7.7,7.9,8.0,7.9,8.1,8.6,8.5,8.2\",\"1.3,1.8,1.9,2.1,2.3,2.6,2.7,2.9,3.1,3.1,2.7,2.7,2.8\",\"ahlen, stadt\"\n05570008,36560,18089,18471,05570008,10.9,7.6,3.4,3997,2762,1235,\"8.4,9.8,9.9,10.4,10.7,11.0,11.0,11.1,11.3,11.5,11.4,11.3,10.9\",\"6.9,7.4,7.4,7.7,7.7,7.7,7.8,7.8,7.7,7.8,8.1,7.9,7.6\",\"1.5,2.3,2.5,2.8,3.0,3.3,3.2,3.3,3.6,3.7,3.3,3.4,3.4\",\"beckum, stadt\"\n05570012,6380,3217,3163,05570012,13.2,8.9,4.4,844,566,278,\"9.5,11.3,11.5,11.0,12.2,13.3,13.3,14.1,13.8,13.6,14.1,14.0,13.2\",\"7.6,8.7,8.3,8.0,8.8,9.1,9.3,9.8,9.8,9.0,9.6,9.3,8.9\",\"1.9,2.5,3.2,3.0,3.4,4.2,4.0,4.4,3.9,4.6,4.5,4.7,4.4\",beelen\n05570016,15542,7757,7785,05570016,9.7,6.9,2.9,1513,1067,446,\"6.9,8.3,8.5,9.0,9.3,9.3,9.6,9.4,9.8,10.1,10.1,10.0,9.7\",\"5.7,6.5,6.6,6.8,6.9,6.8,7.0,6.8,6.9,7.0,7.3,7.1,6.9\",\"1.1,1.8,1.9,2.2,2.4,2.5,2.6,2.7,2.9,3.1,2.8,3.0,2.9\",\"drensteinfurt, stadt\"\n05570020,20037,10075,9962,05570020,10.8,7.3,3.4,2156,1468,688,\"7.9,9.0,9.1,9.9,10.3,10.7,11.0,11.1,11.7,11.5,11.3,11.6,10.8\",\"6.4,7.0,7.0,7.3,7.4,7.6,7.8,7.6,8.2,7.9,7.9,8.1,7.3\",\"1.4,2.1,2.2,2.6,2.9,3.2,3.3,3.4,3.5,3.6,3.5,3.5,3.4\",\"ennigerloh, stadt\"\n05570024,9583,4766,4817,05570024,10.4,6.6,3.8,999,633,366,\"7.7,8.6,9.2,9.6,10.3,10.0,10.4,10.6,10.3,10.6,10.6,10.6,10.4\",\"6.0,6.4,6.8,7.0,7.5,7.1,7.2,7.1,6.7,6.8,7.0,7.0,6.6\",\"1.7,2.2,2.4,2.6,2.8,2.8,3.2,3.5,3.7,3.8,3.6,3.7,3.8\",everswinkel\n05570028,29299,14660,14639,05570028,11.2,7.6,3.6,3296,2235,1061,\"8.9,10.2,10.4,10.8,10.5,10.7,10.9,11.1,11.4,11.7,11.7,11.7,11.2\",\"7.2,7.8,7.8,8.0,7.6,7.4,7.6,7.7,7.9,7.9,8.1,8.2,7.6\",\"1.7,2.4,2.6,2.9,2.9,3.2,3.3,3.4,3.5,3.8,3.6,3.5,3.6\",\"oelde, stadt\"\n05570032,10873,5438,5435,05570032,12.1,7.8,4.3,1314,843,471,\"8.5,9.8,9.7,10.7,10.6,11.1,11.7,11.7,12.0,12.3,12.1,12.0,12.1\",\"6.9,7.4,7.2,7.8,7.6,7.8,8.0,7.9,8.0,8.2,8.1,8.0,7.8\",\"1.6,2.5,2.5,2.9,3.0,3.3,3.6,3.8,4.0,4.1,4.1,3.9,4.3\",ostbevern\n05570036,14403,7263,7140,05570036,12.7,7.8,4.9,1835,1123,712,\"9.2,10.4,10.5,11.4,12.0,12.2,12.6,12.2,12.7,12.9,13.2,13.2,12.7\",\"7.2,7.7,7.7,8.1,8.1,8.1,8.3,8.2,8.3,8.1,8.6,8.3,7.8\",\"2.0,2.7,2.8,3.3,3.9,4.2,4.3,4.0,4.4,4.7,4.6,4.9,4.9\",\"sassenberg, stadt\"\n05570040,13218,6583,6635,05570040,11.9,8.1,3.8,1577,1077,500,\"7.9,9.0,9.1,9.5,9.7,10.0,10.5,10.7,11.3,11.4,11.5,11.6,11.9\",\"6.3,6.8,7.0,7.1,7.0,7.1,7.5,7.4,7.4,7.5,7.8,7.9,8.1\",\"1.6,2.1,2.1,2.4,2.8,2.9,3.0,3.3,3.9,4.0,3.6,3.7,3.8\",\"sendenhorst, stadt\"\n05570044,19557,9461,10096,05570044,10.6,7.0,3.6,2077,1371,706,\"8.2,9.4,9.5,9.7,9.8,10.4,10.4,10.4,10.8,11.2,10.7,10.5,10.6\",\"6.6,7.1,7.1,7.0,7.0,7.2,7.1,7.0,7.2,7.4,7.4,7.0,7.0\",\"1.6,2.4,2.4,2.7,2.8,3.2,3.3,3.3,3.5,3.9,3.4,3.5,3.6\",\"telgte, stadt\"\n05570048,12443,6318,6125,05570048,12.0,8.2,3.8,1494,1022,472,\"8.7,10.3,10.5,11.1,11.5,12.1,12.2,12.1,12.0,12.6,12.4,12.3,12.0\",\"7.2,8.0,8.1,8.2,8.4,8.6,8.7,8.4,8.2,8.7,8.8,8.6,8.2\",\"1.6,2.3,2.5,2.9,3.1,3.5,3.6,3.7,3.8,3.9,3.6,3.7,3.8\",wadersloh\n05570052,37249,18087,19162,05570052,12.0,7.9,4.1,4461,2936,1525,\"8.5,9.5,9.6,10.0,10.7,10.9,11.4,11.4,11.7,12.0,12.1,12.2,12.0\",\"6.8,7.1,7.1,7.3,7.6,7.7,7.9,7.8,7.8,7.9,8.2,8.2,7.9\",\"1.7,2.4,2.4,2.7,3.1,3.2,3.5,3.5,3.8,4.1,3.9,4.0,4.1\",\"warendorf, stadt\"\n05711000,333090,161148,171942,05711000,9.5,6.4,3.1,31661,21417,10244,\"7.0,8.4,8.5,8.7,9.0,9.1,9.2,9.3,9.6,9.4,9.3,9.6,9.5\",\"5.4,6.0,6.0,6.1,6.1,6.0,6.0,6.1,6.2,6.0,6.4,6.6,6.4\",\"1.7,2.4,2.5,2.6,2.9,3.1,3.1,3.2,3.3,3.4,2.9,3.0,3.1\",\"bielefeld, stadt\"\n05754004,8801,4357,4444,05754004,10.3,6.5,3.7,904,574,330,\"7.7,8.8,8.6,9.2,9.6,10.2,10.6,10.2,10.4,10.5,10.1,10.1,10.3\",\"6.1,6.5,6.3,6.6,6.6,7.0,7.0,6.7,6.7,6.8,6.8,6.8,6.5\",\"1.7,2.3,2.2,2.6,3.1,3.2,3.6,3.5,3.7,3.7,3.3,3.3,3.7\",\"borgholzhausen, stadt\"\n05754008,97586,48366,49220,05754008,10.2,6.6,3.6,9990,6456,3534,\"7.6,8.8,8.8,9.1,9.4,9.7,9.7,9.9,10.0,10.2,10.3,10.5,10.2\",\"5.9,6.4,6.3,6.4,6.3,6.4,6.4,6.5,6.4,6.5,6.9,7.0,6.6\",\"1.7,2.4,2.5,2.7,3.0,3.3,3.4,3.4,3.6,3.7,3.5,3.6,3.6\",\"gütersloh, stadt\"\n05754012,21709,10770,10939,05754012,9.9,6.2,3.7,2145,1342,803,\"7.3,8.6,8.7,9.1,9.4,9.6,9.3,9.7,9.4,9.8,10.0,10.4,9.9\",\"5.6,6.2,6.2,6.3,6.3,6.1,6.1,6.3,6.1,6.2,6.5,6.7,6.2\",\"1.7,2.4,2.6,2.8,3.1,3.5,3.2,3.5,3.4,3.6,3.6,3.7,3.7\",\"halle (westf.), stadt\"\n05754016,24769,12571,12198,05754016,11.5,7.5,4.0,2847,1867,980,\"8.3,9.6,10.1,10.4,10.8,11.0,11.4,11.4,11.6,11.9,12.1,11.9,11.5\",\"6.7,7.2,7.4,7.4,7.5,7.5,7.9,7.8,7.8,7.7,8.1,8.0,7.5\",\"1.6,2.4,2.7,3.0,3.3,3.5,3.5,3.6,3.8,4.2,4.0,3.9,4.0\",\"harsewinkel, die mähdrescherstadt\"\n05754020,15965,7982,7983,05754020,12.3,8.1,4.1,1962,1301,661,\"9.3,10.9,11.0,11.4,11.8,12.1,12.0,12.4,12.4,12.2,12.3,12.3,12.3\",\"7.4,8.0,7.9,8.1,8.2,8.4,8.2,8.4,8.3,8.2,8.5,8.3,8.1\",\"1.9,2.9,3.2,3.3,3.6,3.7,3.8,4.0,4.0,4.0,3.8,4.0,4.1\",herzebrock-clarholz\n05754024,8375,4236,4139,05754024,11.8,7.2,4.6,988,605,383,\"9.5,10.6,11.0,12.1,12.1,12.4,12.5,12.2,12.6,12.4,12.5,12.4,11.8\",\"7.7,8.1,8.4,9.0,8.7,8.7,8.8,8.3,8.3,8.0,8.2,7.8,7.2\",\"1.8,2.5,2.6,3.1,3.4,3.7,3.7,3.9,4.2,4.5,4.3,4.5,4.6\",langenberg\n05754028,48000,23902,24098,05754028,11.3,7.2,4.1,5407,3457,1950,\"8.2,9.5,9.9,10.3,10.3,10.5,10.7,10.7,10.9,11.3,11.4,11.5,11.3\",\"6.4,6.9,7.1,7.2,7.2,7.2,7.3,7.2,7.3,7.4,7.6,7.6,7.2\",\"1.8,2.6,2.8,3.1,3.1,3.3,3.4,3.5,3.6,3.9,3.8,3.9,4.1\",\"rheda-wiedenbrück, stadt\"\n05754032,29436,14901,14535,05754032,13.2,8.5,4.7,3894,2512,1382,\"9.8,11.1,11.2,11.8,12.1,12.9,12.8,12.9,13.3,13.5,13.7,13.4,13.2\",\"7.9,8.3,8.2,8.5,8.5,8.8,8.8,8.7,8.8,8.8,9.1,8.8,8.5\",\"1.9,2.8,3.0,3.3,3.6,4.1,4.0,4.3,4.5,4.7,4.6,4.6,4.7\",\"rietberg, stadt\"\n05754036,27092,13435,13657,05754036,11.1,7.3,3.8,3005,1989,1016,\"8.5,10.0,10.3,10.7,10.9,10.9,11.0,11.1,11.5,11.4,11.1,11.2,11.1\",\"6.7,7.3,7.3,7.5,7.6,7.4,7.5,7.4,7.7,7.5,7.6,7.5,7.3\",\"1.8,2.6,2.9,3.2,3.3,3.5,3.5,3.7,3.8,3.9,3.5,3.7,3.8\",\"schloß holte-stukenbrock, stadt\"\n05754040,20749,10242,10507,05754040,10.1,6.6,3.5,2097,1370,727,\"7.9,9.1,9.2,9.7,9.9,10.1,10.2,10.3,10.3,10.3,10.3,10.3,10.1\",\"6.3,6.7,6.7,6.8,6.8,6.7,6.8,6.8,6.7,6.6,7.1,6.9,6.6\",\"1.7,2.4,2.5,2.9,3.1,3.4,3.4,3.6,3.7,3.7,3.2,3.4,3.5\",steinhagen\n05754044,25512,13060,12452,05754044,11.3,7.4,3.9,2893,1891,1002,\"8.4,9.2,9.9,10.3,10.3,10.6,10.5,10.7,10.7,11.1,11.2,11.4,11.3\",\"6.7,6.9,7.1,7.2,7.4,7.1,7.1,7.1,6.9,7.2,7.5,7.6,7.4\",\"1.7,2.3,2.8,3.0,3.0,3.5,3.4,3.6,3.8,3.9,3.7,3.8,3.9\",\"verl, stadt\"\n05754048,21230,10686,10544,05754048,12.1,7.2,4.9,2572,1536,1036,\"8.8,10.6,10.7,11.2,11.9,12.2,12.1,12.2,12.5,12.4,12.2,12.0,12.1\",\"6.6,7.5,7.5,7.5,7.7,7.7,7.6,7.6,7.7,7.5,7.6,7.3,7.2\",\"2.3,3.1,3.2,3.7,4.2,4.5,4.4,4.6,4.8,4.9,4.6,4.7,4.9\",\"versmold, stadt\"\n05754052,11418,5714,5704,05754052,9.5,6.3,3.2,1090,725,365,\"7.2,8.3,8.2,8.8,9.1,8.9,9.3,9.3,9.5,9.4,9.6,9.6,9.5\",\"5.8,6.2,6.0,6.4,6.2,5.9,6.3,6.1,6.3,6.0,6.5,6.5,6.3\",\"1.4,2.0,2.2,2.4,2.9,3.0,3.0,3.2,3.2,3.4,3.1,3.1,3.2\",\"werther (westf.), stadt\"\n05758004,45615,22277,23338,05758004,9.6,6.1,3.5,4379,2801,1578,\"7.8,9.1,9.6,9.7,10.2,10.4,10.2,10.3,10.4,10.2,9.9,10.0,9.6\",\"6.0,6.5,6.8,6.8,6.9,7.0,6.8,6.8,6.6,6.4,6.5,6.5,6.1\",\"1.8,2.7,2.8,2.9,3.3,3.4,3.4,3.5,3.8,3.8,3.4,3.4,3.5\",\"bünde, stadt\"\n05758008,20658,10193,10465,05758008,9.2,5.8,3.4,1898,1195,703,\"6.6,7.9,8.2,8.6,8.9,9.3,9.2,9.7,9.5,9.4,9.4,9.3,9.2\",\"5.2,5.6,5.8,6.1,6.2,6.3,6.2,6.4,6.2,6.2,6.3,6.2,5.8\",\"1.4,2.3,2.4,2.5,2.7,3.0,3.0,3.3,3.3,3.3,3.0,3.2,3.4\",\"enger, widukindstadt\"\n05758012,66521,32485,34036,05758012,9.2,6.0,3.1,6106,4022,2084,\"6.9,8.4,8.7,8.9,9.1,9.3,9.3,9.6,9.9,9.7,9.5,9.4,9.2\",\"5.5,6.2,6.2,6.2,6.2,6.3,6.2,6.2,6.3,6.1,6.3,6.2,6.0\",\"1.5,2.3,2.5,2.7,2.9,3.1,3.1,3.4,3.6,3.6,3.1,3.2,3.1\",\"herford, hansestadt\"\n05758016,19758,9805,9953,05758016,8.5,5.3,3.2,1679,1044,635,\"6.4,7.6,8.1,8.4,8.6,8.8,8.6,8.9,9.0,9.0,8.7,8.8,8.5\",\"5.1,5.7,5.9,6.1,6.0,6.1,5.8,6.0,5.9,5.9,5.8,5.7,5.3\",\"1.3,1.9,2.1,2.4,2.6,2.7,2.8,2.9,3.1,3.2,2.9,3.1,3.2\",hiddenhausen\n05758020,16085,7896,8189,05758020,8.9,6.0,2.9,1436,962,474,\"7.1,8.2,8.7,9.0,9.5,9.9,9.7,9.9,9.9,9.6,9.8,9.6,8.9\",\"5.6,6.1,6.2,6.4,6.7,6.8,6.5,6.6,6.5,6.4,6.9,6.5,6.0\",\"1.6,2.2,2.5,2.6,2.8,3.1,3.2,3.3,3.4,3.1,2.9,3.1,2.9\",kirchlengern\n05758024,40086,19759,20327,05758024,9.2,6.1,3.1,3673,2435,1238,\"7.7,8.7,8.8,8.9,9.3,9.6,9.7,9.5,9.8,9.9,9.5,9.4,9.2\",\"6.0,6.3,6.3,6.2,6.3,6.4,6.5,6.4,6.2,6.3,6.4,6.3,6.1\",\"1.6,2.4,2.6,2.7,3.0,3.2,3.2,3.2,3.5,3.6,3.1,3.1,3.1\",\"löhne, stadt\"\n05758028,9717,4841,4876,05758028,9.9,6.2,3.7,962,606,356,\"6.7,8.3,8.3,8.5,9.2,8.9,9.3,9.5,9.5,10.0,10.0,10.2,9.9\",\"5.2,6.2,6.1,6.1,6.6,6.4,6.6,6.6,6.4,6.6,6.6,6.8,6.2\",\"1.4,2.1,2.1,2.4,2.7,2.5,2.7,2.9,3.1,3.4,3.4,3.4,3.7\",rödinghausen\n05758032,14768,7232,7536,05758032,8.8,5.8,3.0,1298,861,437,\"6.8,7.7,8.0,8.4,8.7,8.9,8.8,9.2,9.0,9.0,9.0,9.0,8.8\",\"5.4,5.8,5.9,6.1,6.2,6.0,6.0,6.2,6.0,5.9,6.2,6.1,5.8\",\"1.3,1.9,2.1,2.3,2.4,2.9,2.8,3.0,3.0,3.1,2.7,2.9,3.0\",\"spenge, stadt\"\n05758036,18914,9447,9467,05758036,9.2,6.1,3.1,1739,1161,578,\"7.4,8.3,8.6,9.2,9.0,9.4,9.4,9.6,9.9,9.5,9.4,9.3,9.2\",\"5.8,6.1,6.2,6.5,6.2,6.3,6.3,6.4,6.4,6.1,6.3,6.2,6.1\",\"1.6,2.1,2.4,2.7,2.7,3.1,3.0,3.2,3.5,3.4,3.1,3.2,3.1\",\"vlotho, stadt\"\n05762004,18699,9140,9559,05762004,10.5,7.2,3.2,1956,1352,604,\"7.7,8.9,9.1,9.2,9.5,9.8,10.1,10.1,10.7,10.7,10.7,10.9,10.5\",\"6.5,7.1,7.2,7.1,7.2,7.0,7.4,7.2,7.3,7.3,7.7,7.8,7.2\",\"1.2,1.8,1.9,2.1,2.3,2.8,2.7,2.9,3.4,3.4,3.0,3.1,3.2\",\"bad driburg, stadt\"\n05762008,13442,6641,6801,05762008,10.1,7.5,2.6,1360,1004,356,\"8.2,9.2,9.1,9.6,9.7,9.8,9.8,9.7,10.0,10.4,10.3,10.3,10.1\",\"6.8,7.4,7.4,7.7,7.6,7.5,7.6,7.5,7.5,7.7,7.9,7.7,7.5\",\"1.4,1.7,1.7,1.9,2.1,2.4,2.2,2.2,2.5,2.7,2.4,2.6,2.6\",\"beverungen, stadt\"\n05762012,9497,4944,4553,05762012,8.6,6.0,2.5,816,574,242,\"7.7,8.6,8.7,9.0,9.0,9.2,9.1,9.3,9.1,9.0,9.1,8.9,8.6\",\"6.7,7.1,7.2,7.1,7.0,7.1,7.0,7.0,6.7,6.4,6.6,6.5,6.0\",\"1.0,1.4,1.5,1.9,2.0,2.1,2.2,2.3,2.4,2.6,2.5,2.4,2.5\",\"borgentreich, orgelstadt\"\n05762016,16586,8368,8218,05762016,9.3,6.6,2.7,1539,1097,442,\"6.9,8.1,8.4,8.4,8.9,9.1,9.3,9.5,9.6,9.5,10.0,9.7,9.3\",\"5.9,6.5,6.7,6.7,7.0,7.0,7.0,7.0,6.8,6.6,7.4,7.1,6.6\",\"1.0,1.6,1.6,1.7,1.9,2.1,2.3,2.5,2.7,2.9,2.6,2.6,2.7\",\"brakel, stadt\"\n05762020,29589,14691,14898,05762020,9.1,6.8,2.3,2704,2021,683,\"6.9,7.7,7.9,8.1,8.5,8.7,8.9,8.8,8.9,9.3,9.2,9.5,9.1\",\"5.8,6.2,6.3,6.4,6.7,6.7,6.7,6.7,6.7,6.8,7.0,7.2,6.8\",\"1.1,1.5,1.6,1.7,1.8,2.0,2.2,2.1,2.2,2.5,2.2,2.4,2.3\",\"höxter, stadt\"\n05762024,5125,2592,2533,05762024,9.3,6.7,2.6,477,344,133,\"6.2,7.2,7.5,8.5,7.9,8.3,9.2,9.6,10.4,9.6,9.6,9.9,9.3\",\"5.3,5.9,6.0,6.5,6.0,6.5,6.9,7.5,7.9,7.2,7.1,7.3,6.7\",\"0.9,1.3,1.5,1.9,2.0,1.8,2.3,2.1,2.4,2.4,2.5,2.6,2.6\",\"marienmünster, stadt\"\n05762028,6254,3231,3023,05762028,9.9,7.2,2.7,621,450,171,\"7.7,8.6,8.9,9.6,10.0,10.4,10.2,10.5,10.8,11.1,10.3,10.5,9.9\",\"6.3,6.7,7.0,7.5,7.5,8.1,7.7,7.9,7.8,8.1,7.7,7.7,7.2\",\"1.4,1.9,1.9,2.1,2.5,2.2,2.5,2.6,3.0,3.0,2.7,2.8,2.7\",\"nieheim, stadt\"\n05762032,12922,6446,6476,05762032,10.1,7.1,3.0,1301,919,382,\"8.8,9.7,9.8,10.0,10.0,10.5,10.6,11.1,11.3,11.3,11.1,11.3,10.1\",\"7.4,7.9,8.0,8.0,7.9,8.1,8.0,8.2,8.3,8.3,8.4,8.5,7.1\",\"1.4,1.9,1.8,2.0,2.1,2.4,2.7,2.9,3.0,3.0,2.7,2.8,3.0\",\"steinheim, stadt\"\n05762036,23629,11761,11868,05762036,9.1,6.5,2.6,2149,1545,604,\"7.2,8.2,8.2,8.7,8.9,9.3,9.7,9.9,9.6,9.9,9.6,9.6,9.1\",\"6.1,6.6,6.7,6.9,7.0,7.2,7.4,7.4,6.9,7.1,7.1,6.9,6.5\",\"1.1,1.6,1.4,1.8,1.9,2.1,2.3,2.5,2.7,2.8,2.5,2.7,2.6\",\"warburg, hansestadt\"\n05762040,8267,4192,4075,05762040,8.7,6.5,2.2,720,537,183,\"7.2,7.8,8.0,8.0,8.3,8.3,8.6,8.5,8.6,9.1,8.8,8.8,8.7\",\"6.2,6.4,6.7,6.6,6.8,6.6,7.0,6.6,6.5,6.9,7.1,6.7,6.5\",\"1.0,1.4,1.4,1.5,1.6,1.7,1.6,1.9,2.1,2.3,1.7,2.1,2.2\",\"willebadessen, stadt\"\n05766004,9828,5074,4754,05766004,9.0,6.0,3.0,883,586,297,\"6.7,8.3,8.1,8.7,9.5,9.6,9.4,9.6,10.0,9.9,9.2,9.6,9.0\",\"5.5,6.2,6.1,6.5,6.9,6.9,6.8,7.0,6.9,6.8,6.6,6.6,6.0\",\"1.2,2.1,2.1,2.2,2.6,2.7,2.6,2.6,3.1,3.0,2.6,3.0,3.0\",augustdorf\n05766008,53341,25619,27722,05766008,9.7,6.7,3.0,5152,3558,1594,\"7.2,8.6,8.5,8.8,8.9,9.2,9.3,9.5,9.6,9.7,9.7,9.9,9.7\",\"5.8,6.4,6.3,6.4,6.4,6.5,6.6,6.5,6.5,6.6,6.8,6.8,6.7\",\"1.5,2.2,2.2,2.4,2.5,2.7,2.8,3.0,3.1,3.1,2.9,3.1,3.0\",\"bad salzuflen, stadt\"\n05766012,8846,4418,4428,05766012,8.4,6.2,2.2,746,548,198,\"6.7,7.6,7.8,8.6,8.3,8.7,8.9,8.9,9.2,9.1,8.9,8.6,8.4\",\"5.5,6.3,6.3,6.9,6.5,6.9,6.8,6.6,6.7,6.6,6.7,6.5,6.2\",\"1.2,1.4,1.5,1.7,1.8,1.8,2.1,2.3,2.5,2.4,2.2,2.1,2.2\",\"barntrup, stadt\"\n05766016,15370,7671,7699,05766016,8.0,5.6,2.4,1225,862,363,\"6.2,7.1,7.1,7.0,7.3,7.6,7.8,7.9,8.2,8.2,8.1,7.9,8.0\",\"5.0,5.5,5.2,5.2,5.2,5.3,5.5,5.4,5.5,5.5,5.7,5.6,5.6\",\"1.2,1.6,1.8,1.8,2.2,2.2,2.2,2.5,2.7,2.7,2.4,2.3,2.4\",\"blomberg, stadt\"\n05766020,74817,36141,38676,05766020,9.0,6.4,2.6,6715,4754,1961,\"6.9,7.9,8.0,8.3,8.5,8.8,8.9,8.9,9.3,9.2,8.9,9.1,9.0\",\"5.5,6.0,5.9,6.1,6.2,6.2,6.2,6.2,6.4,6.4,6.4,6.5,6.4\",\"1.3,1.9,2.1,2.2,2.4,2.6,2.6,2.7,2.9,2.9,2.5,2.6,2.6\",\"detmold, stadt\"\n05766024,7970,4048,3922,05766024,8.2,5.6,2.6,654,447,207,\"6.7,8.2,8.4,8.7,8.7,8.7,8.5,8.8,9.4,9.0,8.4,8.8,8.2\",\"5.7,6.4,6.4,6.5,6.3,6.5,6.3,6.5,6.7,6.1,6.1,6.0,5.6\",\"1.0,1.8,1.9,2.2,2.4,2.2,2.2,2.4,2.6,3.0,2.3,2.8,2.6\",dörentrup\n05766028,11522,5795,5727,05766028,9.5,6.8,2.7,1098,789,309,\"7.3,8.3,8.3,8.4,8.9,9.2,9.2,9.3,9.7,9.9,10.0,10.2,9.5\",\"6.1,6.6,6.6,6.6,6.7,6.7,6.8,6.8,6.8,7.0,7.3,7.3,6.8\",\"1.2,1.7,1.7,1.9,2.2,2.5,2.4,2.6,2.9,3.0,2.7,2.9,2.7\",extertal\n05766032,17126,8324,8802,05766032,9.5,6.8,2.7,1621,1164,457,\"6.5,7.5,7.8,8.2,8.3,8.3,8.5,8.7,8.9,9.3,8.9,9.2,9.5\",\"5.3,5.8,5.8,6.2,6.2,6.2,6.3,6.3,6.3,6.5,6.6,6.8,6.8\",\"1.2,1.7,2.0,2.0,2.1,2.1,2.2,2.4,2.6,2.7,2.3,2.5,2.7\",\"horn-bad meinberg, stadt\"\n05766036,13914,6902,7012,05766036,9.1,6.5,2.6,1268,905,363,\"6.7,7.7,7.9,8.3,8.2,8.8,8.6,9.0,9.4,9.4,9.4,9.2,9.1\",\"5.5,6.0,6.0,6.3,6.1,6.4,6.2,6.5,6.6,6.6,6.8,6.6,6.5\",\"1.2,1.8,1.9,2.1,2.1,2.4,2.4,2.5,2.8,2.9,2.6,2.7,2.6\",kalletal\n05766040,35120,17336,17784,05766040,9.8,6.9,2.9,3442,2423,1019,\"7.5,8.6,9.0,9.3,9.2,9.7,9.4,9.6,9.6,9.5,9.4,9.9,9.8\",\"6.0,6.5,6.8,7.0,6.6,6.8,6.7,6.8,6.7,6.5,6.7,7.1,6.9\",\"1.5,2.1,2.2,2.3,2.6,2.9,2.7,2.9,2.9,3.0,2.8,2.9,2.9\",\"lage, stadt\"\n05766044,41276,20457,20819,05766044,9.3,6.6,2.7,3821,2709,1112,\"7.0,8.0,8.2,8.6,8.7,8.8,9.1,9.2,9.5,9.6,9.4,9.6,9.3\",\"5.6,6.1,6.3,6.3,6.3,6.2,6.5,6.4,6.5,6.5,6.7,6.9,6.6\",\"1.4,1.9,2.0,2.3,2.4,2.6,2.6,2.8,3.0,3.1,2.6,2.7,2.7\",\"lemgo, stadt\"\n05766048,16401,8148,8253,05766048,9.4,6.5,3.0,1549,1059,490,\"7.0,8.3,8.3,9.0,9.3,9.5,9.5,9.7,10.0,10.1,9.8,9.7,9.4\",\"5.7,6.4,6.3,6.6,6.7,6.8,6.7,6.8,6.9,6.9,7.0,6.9,6.5\",\"1.2,1.9,2.0,2.4,2.6,2.7,2.8,2.9,3.1,3.2,2.9,2.8,3.0\",leopoldshöhe\n05766052,9751,4851,4900,05766052,9.5,6.7,2.7,922,656,266,\"7.2,8.2,8.4,8.8,8.5,8.9,9.3,9.1,9.3,9.5,9.6,9.7,9.5\",\"5.9,6.5,6.5,6.8,6.5,6.7,6.8,6.6,6.4,6.5,7.0,6.9,6.7\",\"1.2,1.7,1.9,2.0,2.0,2.2,2.5,2.5,2.8,3.0,2.6,2.8,2.7\",\"lügde, stadt der osterräder\"\n05766056,17616,8722,8894,05766056,8.8,5.9,3.0,1559,1034,525,\"6.9,8.2,8.3,8.6,8.6,8.8,9.0,9.0,9.4,9.5,9.5,9.5,8.8\",\"5.5,6.0,5.9,6.1,6.1,6.1,6.2,6.1,6.3,6.2,6.6,6.3,5.9\",\"1.5,2.2,2.4,2.5,2.6,2.8,2.8,2.9,3.1,3.3,2.8,3.1,3.0\",\"oerlinghausen, stadt\"\n05766060,8708,4341,4367,05766060,8.1,5.9,2.2,706,517,189,\"6.4,7.7,7.7,8.3,8.2,8.6,9.1,9.0,9.1,8.8,8.6,8.4,8.1\",\"5.4,6.2,6.2,6.5,6.3,6.4,6.8,6.6,6.5,6.2,6.4,6.3,5.9\",\"0.9,1.6,1.5,1.7,1.8,2.2,2.3,2.4,2.6,2.6,2.2,2.1,2.2\",\"schieder-schwalenberg, stadt\"\n05766064,9144,4643,4501,05766064,9.5,6.7,2.8,871,615,256,\"6.7,7.8,7.5,8.6,9.0,8.7,9.2,9.5,9.7,10.1,9.8,10.1,9.5\",\"5.3,5.9,5.9,6.3,6.4,6.3,6.5,6.8,6.7,6.9,7.4,7.3,6.7\",\"1.4,1.9,1.7,2.3,2.6,2.4,2.7,2.7,3.1,3.2,2.4,2.8,2.8\",schlangen\n05770004,48990,23905,25085,05770004,8.7,5.9,2.8,4247,2880,1367,\"6.8,8.0,8.2,8.8,8.9,9.5,9.3,9.3,9.5,9.1,8.8,9.0,8.7\",\"5.4,6.0,6.0,6.4,6.3,6.6,6.5,6.3,6.4,6.0,6.0,6.1,5.9\",\"1.4,2.1,2.2,2.4,2.6,2.8,2.8,2.9,3.1,3.1,2.7,2.9,2.8\",\"bad oeynhausen, stadt\"\n05770008,24921,12213,12708,05770008,9.1,6.0,3.2,2278,1486,792,\"7.0,8.2,8.0,8.3,8.6,9.1,9.0,9.4,9.3,9.6,9.2,9.6,9.1\",\"5.6,6.0,5.9,5.9,6.0,6.2,6.3,6.2,5.9,5.9,6.1,6.5,6.0\",\"1.4,2.2,2.1,2.4,2.6,3.0,2.7,3.3,3.3,3.6,3.1,3.2,3.2\",\"espelkamp, stadt\"\n05770012,15916,7890,8026,05770012,9.1,6.2,2.9,1442,985,457,\"6.5,7.8,8.0,8.1,8.0,8.2,8.1,8.6,8.7,8.8,9.0,9.0,9.1\",\"5.5,6.2,6.1,5.9,5.7,5.6,5.7,5.8,5.9,5.9,6.1,6.0,6.2\",\"1.0,1.6,1.9,2.2,2.3,2.5,2.5,2.7,2.9,3.0,2.9,2.9,2.9\",hille\n05770016,13271,6651,6620,05770016,10.0,6.4,3.6,1321,847,474,\"7.4,8.9,8.9,9.4,9.5,10.2,9.9,9.9,9.9,10.2,10.1,10.0,10.0\",\"6.0,6.7,6.4,6.7,6.6,6.9,6.6,6.4,6.4,6.6,6.4,6.5,6.4\",\"1.5,2.2,2.5,2.7,2.9,3.3,3.3,3.5,3.6,3.7,3.7,3.5,3.6\",hüllhorst\n05770020,25462,12270,13192,05770020,9.4,6.0,3.4,2384,1525,859,\"7.1,8.4,8.5,9.1,9.1,9.2,9.4,9.5,9.5,9.8,9.5,9.7,9.4\",\"5.6,6.2,6.1,6.3,6.3,6.3,6.4,6.5,6.4,6.4,6.4,6.4,6.0\",\"1.5,2.1,2.4,2.7,2.8,2.9,3.0,3.0,3.1,3.4,3.0,3.3,3.4\",\"lübbecke, stadt\"\n05770024,81598,40066,41532,05770024,8.5,5.9,2.5,6902,4839,2063,\"6.5,7.6,7.6,7.9,8.1,8.3,8.3,8.4,8.5,8.6,8.6,8.6,8.5\",\"5.3,5.8,5.8,5.9,5.9,5.9,5.9,5.7,5.8,5.8,6.2,6.1,5.9\",\"1.2,1.8,1.8,2.0,2.3,2.4,2.4,2.7,2.7,2.8,2.4,2.4,2.5\",\"minden, stadt\"\n05770028,25663,12945,12718,05770028,8.9,6.3,2.6,2281,1619,662,\"6.9,7.9,7.9,8.3,8.6,8.9,8.9,9.0,9.2,9.2,9.1,9.0,8.9\",\"5.6,6.1,6.1,6.3,6.4,6.6,6.6,6.5,6.4,6.4,6.6,6.5,6.3\",\"1.3,1.8,1.8,2.0,2.2,2.3,2.4,2.5,2.8,2.9,2.4,2.5,2.6\",\"petershagen, stadt\"\n05770032,35430,17486,17944,05770032,8.5,5.7,2.8,3009,2019,990,\"6.9,7.9,8.1,8.5,8.8,9.0,9.2,9.2,9.1,9.0,8.7,8.8,8.5\",\"5.6,6.1,6.2,6.4,6.4,6.4,6.5,6.5,6.2,6.0,6.2,6.0,5.7\",\"1.2,1.8,1.9,2.1,2.4,2.6,2.7,2.7,2.9,3.0,2.6,2.7,2.8\",\"porta westfalica, stadt\"\n05770036,12647,6258,6389,05770036,10.1,6.7,3.4,1279,851,428,\"6.8,8.2,8.2,8.6,9.0,9.4,9.6,9.9,10.4,10.1,10.2,10.8,10.1\",\"5.4,6.1,6.0,6.2,6.4,6.5,6.6,6.7,6.9,6.5,7.0,7.3,6.7\",\"1.4,2.1,2.2,2.5,2.6,2.9,3.0,3.1,3.5,3.6,3.2,3.5,3.4\",\"preußisch oldendorf, stadt\"\n05770040,15581,7844,7737,05770040,9.9,6.3,3.6,1541,974,567,\"6.7,7.8,8.1,8.4,8.9,9.0,9.1,9.2,9.8,9.8,9.9,9.7,9.9\",\"5.4,5.9,5.9,6.1,6.4,6.1,6.3,5.9,6.1,6.0,6.4,6.3,6.3\",\"1.2,1.9,2.2,2.3,2.5,2.9,2.9,3.3,3.7,3.7,3.4,3.4,3.6\",\"rahden, stadt\"\n05770044,13571,6960,6611,05770044,10.7,7.0,3.7,1451,950,501,\"7.3,8.1,8.4,9.0,9.1,10.0,9.9,10.3,10.9,10.7,11.0,11.1,10.7\",\"5.9,6.2,6.1,6.4,6.4,6.7,6.8,6.8,7.1,6.8,7.1,7.1,7.0\",\"1.4,1.9,2.3,2.5,2.6,3.2,3.1,3.5,3.8,3.8,3.9,4.0,3.7\",stemwede\n05774004,9294,4707,4587,05774004,9.6,6.8,2.9,896,628,268,\"7.3,8.5,7.9,8.6,8.9,9.6,9.7,9.9,10.0,10.0,9.4,9.3,9.6\",\"6.0,6.7,6.2,6.5,6.6,6.9,6.9,6.9,6.8,6.8,6.8,6.7,6.8\",\"1.3,1.8,1.7,2.1,2.3,2.7,2.8,2.9,3.2,3.2,2.6,2.7,2.9\",altenbeken\n05774008,15572,7576,7996,05774008,10.3,6.8,3.5,1605,1054,551,\"7.3,8.9,8.7,9.0,9.3,9.6,9.8,10.1,10.3,10.6,10.3,10.3,10.3\",\"5.8,6.7,6.5,6.5,6.5,6.8,6.9,6.8,6.9,7.0,7.1,6.9,6.8\",\"1.5,2.2,2.3,2.6,2.8,2.8,2.9,3.2,3.4,3.6,3.3,3.4,3.5\",\"bad lippspringe, stadt\"\n05774012,13447,6695,6752,05774012,9.2,6.3,2.9,1242,849,393,\"7.5,8.3,8.4,8.4,8.7,9.0,9.2,9.2,9.6,9.7,9.5,9.7,9.2\",\"6.1,6.4,6.0,6.1,6.1,6.2,6.5,6.5,6.6,6.4,6.7,6.8,6.3\",\"1.5,1.9,2.4,2.3,2.6,2.8,2.7,2.7,3.0,3.2,2.8,2.9,2.9\",borchen\n05774016,21772,11305,10467,05774016,11.3,7.6,3.7,2459,1644,815,\"8.5,9.9,10.3,10.7,10.9,11.2,11.4,11.4,11.8,11.7,11.3,11.7,11.3\",\"7.0,7.7,8.0,8.0,8.0,8.1,8.0,7.9,8.0,8.0,8.0,8.0,7.6\",\"1.5,2.2,2.3,2.7,2.9,3.1,3.3,3.5,3.8,3.7,3.3,3.7,3.7\",\"büren, stadt\"\n05774020,31964,16316,15648,05774020,12.6,8.6,3.9,4019,2762,1257,\"9.5,10.8,11.1,11.8,12.3,12.8,12.7,13.1,13.3,13.1,13.3,13.0,12.6\",\"7.8,8.2,8.4,8.8,9.0,9.1,9.1,9.2,9.1,8.9,9.4,9.1,8.6\",\"1.8,2.5,2.7,2.9,3.4,3.6,3.6,3.8,4.2,4.1,3.9,3.9,3.9\",\"delbrück, stadt\"\n05774024,16080,8166,7914,05774024,12.2,8.0,4.2,1961,1292,669,\"9.4,10.7,11.0,11.2,11.9,12.0,11.9,11.9,11.8,11.9,12.1,12.3,12.2\",\"7.5,7.9,8.1,8.1,8.5,8.4,8.4,8.2,7.9,7.9,8.3,8.3,8.0\",\"2.0,2.8,2.8,3.1,3.4,3.6,3.5,3.7,3.8,4.1,3.9,4.0,4.2\",\"hövelhof, sennegemeinde\"\n05774028,10589,5449,5140,05774028,10.0,6.9,3.1,1062,735,327,\"6.7,8.1,8.5,8.8,8.9,9.4,9.2,9.3,9.4,10.0,9.7,9.9,10.0\",\"5.7,6.4,6.7,6.9,6.8,6.8,6.8,6.8,6.7,6.9,7.1,7.2,6.9\",\"1.1,1.6,1.8,1.9,2.1,2.5,2.4,2.4,2.7,3.1,2.6,2.8,3.1\",\"lichtenau, stadt\"\n05774032,148126,73680,74446,05774032,10.5,7.4,3.0,15528,11030,4498,\"7.7,9.0,9.2,9.6,9.7,10.1,10.3,10.5,10.8,11.1,10.8,10.8,10.5\",\"6.1,6.7,6.9,7.1,7.0,7.0,7.1,7.1,7.3,7.5,7.9,7.8,7.4\",\"1.7,2.3,2.3,2.5,2.7,3.1,3.2,3.3,3.5,3.6,2.9,3.0,3.0\",\"paderborn, stadt\"\n05774036,25186,12493,12693,05774036,10.2,7.2,3.0,2568,1820,748,\"8.2,9.1,9.5,9.6,9.9,10.1,10.4,10.5,10.8,10.8,10.8,10.8,10.2\",\"6.6,6.8,7.2,7.1,7.2,7.3,7.5,7.3,7.4,7.4,7.8,7.6,7.2\",\"1.6,2.2,2.2,2.5,2.7,2.8,2.9,3.2,3.4,3.5,3.0,3.1,3.0\",\"salzkotten, stadt\"\n05774040,12302,6162,6140,05774040,11.7,8.2,3.5,1437,1009,428,\"8.9,9.6,10.1,10.8,11.0,11.3,10.8,11.7,11.9,12.0,12.0,11.9,11.7\",\"7.4,7.5,7.9,8.4,8.3,8.4,7.8,8.4,8.5,8.3,8.7,8.4,8.2\",\"1.5,2.1,2.2,2.3,2.6,2.9,3.0,3.3,3.4,3.7,3.3,3.5,3.5\",\"bad wünnenberg, stadt\"\n05911000,364742,177427,187315,05911000,8.8,6.6,2.2,32256,24052,8204,\"6.5,7.7,7.7,8.2,8.4,8.6,8.8,8.9,9.0,9.2,9.1,9.2,8.8\",\"5.3,6.0,6.0,6.2,6.4,6.4,6.5,6.5,6.6,6.6,6.9,6.9,6.6\",\"1.1,1.7,1.8,1.9,2.0,2.2,2.3,2.4,2.5,2.6,2.1,2.2,2.2\",\"bochum, stadt\"\n05913000,586181,287846,298335,05913000,8.5,6.4,2.2,49951,37260,12691,\"6.4,7.7,7.7,8.1,8.2,8.4,8.5,8.5,8.7,8.9,8.7,8.7,8.5\",\"5.4,6.0,6.0,6.2,6.2,6.2,6.3,6.2,6.3,6.3,6.6,6.6,6.4\",\"1.0,1.6,1.7,1.8,2.0,2.2,2.3,2.3,2.4,2.5,2.1,2.1,2.2\",\"dortmund, stadt\"\n05914000,189044,92207,96837,05914000,9.6,6.9,2.7,18085,12968,5117,\"7.2,8.5,8.5,8.8,9.1,9.3,9.3,9.6,9.7,9.7,9.7,9.7,9.6\",\"5.9,6.5,6.4,6.6,6.6,6.7,6.6,6.8,6.7,6.7,7.0,7.0,6.9\",\"1.3,1.9,2.1,2.2,2.4,2.6,2.7,2.8,2.9,3.0,2.7,2.7,2.7\",\"hagen, stadt der fernuniversität\"\n05915000,179397,88166,91231,05915000,9.5,7.1,2.4,16974,12657,4317,\"7.2,8.3,8.4,8.7,8.8,9.2,9.4,9.5,9.6,9.9,9.9,9.9,9.5\",\"6.1,6.7,6.7,6.9,6.8,6.9,7.0,7.0,7.1,7.2,7.5,7.5,7.1\",\"1.1,1.6,1.7,1.8,2.0,2.3,2.3,2.5,2.5,2.7,2.4,2.4,2.4\",\"hamm, stadt\"\n05916000,155851,75940,79911,05916000,8.2,6.2,2.0,12785,9709,3076,\"6.6,7.6,7.4,7.6,7.9,8.1,8.3,8.5,8.3,8.7,8.4,8.4,8.2\",\"5.6,6.1,5.9,6.0,6.1,6.2,6.2,6.4,6.2,6.5,6.6,6.5,6.2\",\"1.0,1.4,1.5,1.6,1.7,1.9,2.0,2.1,2.1,2.2,1.8,1.9,2.0\",\"herne, stadt\"\n05954004,9004,4442,4562,05954004,8.2,5.7,2.5,738,512,226,\"6.2,7.3,7.4,8.0,8.1,8.4,8.3,8.7,8.7,8.8,8.6,8.9,8.2\",\"5.0,5.4,5.4,5.8,5.8,5.9,5.8,6.2,6.0,5.9,6.1,6.3,5.7\",\"1.2,1.9,2.0,2.2,2.3,2.5,2.5,2.5,2.8,3.0,2.5,2.6,2.5\",\"breckerfeld, hansestadt\"\n05954008,29926,14635,15291,05954008,9.3,6.2,3.1,2798,1869,929,\"7.2,8.4,8.4,8.8,9.4,9.7,9.7,9.8,10.0,9.8,9.7,9.7,9.3\",\"5.9,6.3,6.3,6.3,6.7,6.7,6.8,6.7,6.8,6.5,6.8,6.7,6.2\",\"1.4,2.1,2.2,2.5,2.7,2.9,2.9,3.1,3.2,3.3,3.0,3.1,3.1\",\"ennepetal, stadt der kluterthöhle\"\n05954012,31315,15290,16025,05954012,9.9,6.9,3.1,3103,2147,956,\"7.3,8.6,8.9,9.3,9.7,10.0,9.9,10.0,10.1,10.2,10.3,10.3,9.9\",\"6.0,6.6,6.8,6.9,6.9,7.1,7.1,7.0,7.0,6.9,7.2,7.2,6.9\",\"1.3,2.0,2.2,2.4,2.7,2.9,2.9,3.0,3.1,3.3,3.1,3.1,3.1\",\"gevelsberg, stadt\"\n05954016,54834,26608,28226,05954016,9.4,6.7,2.7,5130,3661,1469,\"7.2,8.5,8.7,8.9,9.3,9.5,9.6,9.7,9.9,10.0,9.8,9.7,9.4\",\"6.1,6.6,6.6,6.7,6.8,6.8,6.8,6.9,7.0,7.0,7.2,7.0,6.7\",\"1.1,1.9,2.1,2.2,2.5,2.7,2.8,2.8,2.9,3.0,2.6,2.7,2.7\",\"hattingen, stadt\"\n05954020,22818,10869,11949,05954020,8.8,6.1,2.7,2007,1390,617,\"6.6,7.3,7.6,8.2,8.2,8.6,8.5,8.7,8.9,9.4,9.3,9.3,8.8\",\"5.4,5.6,5.7,6.0,6.1,6.1,6.2,6.3,6.4,6.5,6.6,6.6,6.1\",\"1.2,1.7,1.9,2.2,2.2,2.4,2.3,2.4,2.5,2.9,2.7,2.7,2.7\",\"herdecke, stadt\"\n05954024,28330,13598,14732,05954024,8.9,6.2,2.7,2517,1748,769,\"6.9,8.2,8.2,8.6,9.1,9.3,9.0,9.1,9.1,9.3,9.2,8.9,8.9\",\"5.4,6.0,6.0,6.2,6.4,6.4,6.3,6.3,6.1,6.4,6.5,6.3,6.2\",\"1.4,2.2,2.2,2.4,2.7,2.9,2.7,2.8,3.0,2.9,2.7,2.7,2.7\",\"schwelm, stadt\"\n05954028,25205,12161,13044,05954028,9.0,6.2,2.8,2261,1553,708,\"6.5,7.9,8.3,8.4,8.9,9.2,9.4,9.6,9.6,9.7,9.3,9.2,9.0\",\"5.2,6.0,6.2,6.2,6.4,6.5,6.5,6.7,6.6,6.5,6.4,6.3,6.2\",\"1.3,1.9,2.1,2.3,2.5,2.7,2.8,2.9,3.0,3.2,2.9,2.9,2.8\",\"sprockhövel, stadt\"\n05954032,27822,13712,14110,05954032,8.2,5.7,2.4,2274,1597,677,\"5.9,7.2,7.6,7.9,8.1,8.4,8.4,8.7,8.7,8.9,8.7,8.7,8.2\",\"4.8,5.4,5.7,5.7,5.8,5.8,5.9,6.2,6.1,6.1,6.3,6.3,5.7\",\"1.1,1.8,2.0,2.2,2.3,2.5,2.4,2.5,2.7,2.8,2.4,2.5,2.4\",\"wetter (ruhr), stadt\"\n05954036,96700,46997,49703,05954036,9.0,6.6,2.4,8751,6383,2368,\"7.0,8.3,8.3,8.8,9.2,9.2,9.4,9.3,9.2,9.4,9.3,9.4,9.0\",\"5.8,6.4,6.4,6.7,6.9,6.8,6.9,6.7,6.6,6.7,6.9,7.0,6.6\",\"1.2,1.9,1.9,2.1,2.2,2.4,2.4,2.5,2.7,2.7,2.4,2.4,2.4\",\"witten, stadt\"\n05958004,73784,36277,37507,05958004,11.4,7.8,3.7,8435,5727,2708,\"9.3,10.7,10.5,10.8,11.6,12.0,12.0,12.0,12.2,12.0,11.9,11.9,11.4\",\"7.7,8.3,8.0,8.1,8.5,8.5,8.5,8.5,8.4,8.3,8.3,8.2,7.8\",\"1.6,2.4,2.5,2.7,3.1,3.5,3.5,3.5,3.8,3.7,3.6,3.7,3.7\",\"arnsberg, stadt\"\n05958008,11170,5646,5524,05958008,13.0,8.6,4.5,1457,957,500,\"9.5,11.0,10.8,11.3,11.9,12.9,12.8,13.1,13.3,12.9,13.1,13.4,13.0\",\"7.5,8.1,7.8,7.9,8.0,8.8,8.7,8.7,8.9,8.7,8.9,9.1,8.6\",\"2.0,2.8,3.0,3.4,3.8,4.1,4.1,4.3,4.4,4.1,4.2,4.3,4.5\",bestwig\n05958012,26232,13070,13162,05958012,12.2,8.2,4.1,3209,2144,1065,\"9.1,10.2,10.4,11.0,11.3,11.9,12.1,12.3,12.4,12.4,12.6,12.8,12.2\",\"7.6,7.9,7.9,8.4,8.4,8.5,8.6,8.6,8.4,8.3,8.7,8.7,8.2\",\"1.5,2.3,2.5,2.7,2.9,3.4,3.5,3.7,3.9,4.1,4.0,4.1,4.1\",\"brilon, stadt\"\n05958016,8942,4554,4388,05958016,12.5,8.9,3.5,1115,800,315,\"8.4,9.7,10.1,10.4,11.3,11.9,11.4,11.7,11.9,12.4,12.6,12.8,12.5\",\"7.0,7.7,7.9,8.2,8.6,8.7,8.4,8.4,8.4,8.5,8.9,9.3,8.9\",\"1.4,2.0,2.2,2.2,2.7,3.2,3.0,3.3,3.6,3.9,3.7,3.5,3.5\",eslohe (sauerland)\n05958020,4541,2309,2232,05958020,11.8,8.7,3.1,536,396,140,\"9.1,10.2,10.6,10.9,11.5,11.4,12.2,12.4,12.4,12.1,12.4,12.3,11.8\",\"7.8,8.4,8.8,8.8,8.8,8.7,9.2,9.0,9.0,8.4,9.0,9.0,8.7\",\"1.3,1.8,1.8,2.1,2.7,2.8,3.0,3.4,3.4,3.7,3.4,3.3,3.1\",\"hallenberg, stadt\"\n05958024,19968,10182,9786,05958024,9.6,6.7,2.9,1921,1334,587,\"7.1,8.3,8.2,8.5,8.7,9.5,9.4,9.6,9.6,9.9,9.8,9.7,9.6\",\"6.2,6.7,6.5,6.6,6.5,6.9,6.8,7.0,6.8,6.9,7.1,7.0,6.7\",\"0.9,1.6,1.7,1.8,2.2,2.7,2.5,2.6,2.7,3.0,2.7,2.7,2.9\",\"marsberg, stadt\"\n05958028,7938,4008,3930,05958028,13.5,9.3,4.2,1071,735,336,\"8.9,10.6,10.6,10.8,11.8,12.7,12.7,13.2,13.8,13.9,14.1,13.8,13.5\",\"7.5,8.5,8.3,8.5,9.0,9.3,9.4,9.4,9.3,9.2,9.9,9.6,9.3\",\"1.4,2.1,2.3,2.3,2.8,3.5,3.3,3.7,4.5,4.7,4.1,4.2,4.2\",\"medebach, hansestadt\"\n05958032,30119,14916,15203,05958032,11.5,8.1,3.4,3478,2444,1034,\"8.3,9.5,9.9,10.0,10.6,10.8,10.7,11.2,11.3,11.6,11.7,11.7,11.5\",\"6.9,7.5,7.6,7.6,7.9,7.9,7.9,8.2,8.1,8.1,8.4,8.3,8.1\",\"1.5,2.0,2.3,2.4,2.7,2.9,2.8,3.0,3.2,3.5,3.3,3.4,3.4\",\"meschede, kreis- und  hochschulstadt\"\n05958036,14874,7389,7485,05958036,12.2,7.9,4.3,1820,1176,644,\"8.8,10.2,10.6,11.1,11.7,12.3,13.0,12.6,12.8,12.6,12.7,12.8,12.2\",\"7.3,7.9,8.1,8.1,8.3,8.8,8.9,8.4,8.5,8.0,8.8,8.2,7.9\",\"1.5,2.3,2.5,3.0,3.4,3.5,4.0,4.3,4.3,4.6,3.9,4.5,4.3\",\"olsberg, stadt\"\n05958040,25230,12826,12404,05958040,13.4,8.9,4.5,3382,2241,1141,\"9.3,11.0,11.4,11.5,12.0,12.5,12.9,13.1,13.2,13.1,13.6,13.6,13.4\",\"7.7,8.6,8.5,8.6,8.7,9.0,9.1,8.9,8.9,8.7,9.4,9.2,8.9\",\"1.6,2.5,2.9,2.9,3.3,3.6,3.8,4.1,4.3,4.4,4.2,4.4,4.5\",\"schmallenberg, stadt\"\n05958044,28166,14153,14013,05958044,13.1,8.8,4.3,3693,2488,1205,\"10.3,11.8,12.1,12.5,13.1,13.1,12.9,13.6,13.7,13.6,13.4,13.5,13.1\",\"8.7,9.3,9.3,9.2,9.6,9.4,9.1,9.6,9.3,9.2,9.3,9.3,8.8\",\"1.6,2.5,2.8,3.2,3.6,3.8,3.8,4.0,4.4,4.4,4.1,4.2,4.3\",\"sundern (sauerland), stadt\"\n05958048,12798,6434,6364,05958048,15.5,9.8,5.7,1985,1256,729,\"9.8,11.5,11.3,12.2,12.7,13.6,14.1,14.6,14.8,15.4,15.7,15.4,15.5\",\"8.1,8.9,8.4,8.7,9.1,9.4,9.8,10.0,9.8,9.8,10.3,10.1,9.8\",\"1.7,2.6,2.9,3.5,3.6,4.1,4.3,4.6,5.0,5.6,5.4,5.3,5.7\",\"winterberg, stadt\"\n05962004,17375,8592,8783,05962004,9.2,6.4,2.8,1604,1109,495,\"7.0,8.0,8.2,8.7,8.9,9.2,9.0,9.2,9.3,9.3,9.2,9.3,9.2\",\"5.8,6.1,6.3,6.5,6.4,6.6,6.5,6.5,6.3,6.3,6.4,6.3,6.4\",\"1.2,1.9,1.9,2.2,2.5,2.6,2.4,2.7,3.0,3.0,2.7,2.9,2.8\",\"altena, stadt\"\n05962008,11602,5745,5857,05962008,12.4,9.0,3.5,1444,1043,401,\"10.1,11.9,12.1,12.9,12.9,13.1,13.0,13.0,13.2,12.9,12.7,13.3,12.4\",\"8.6,9.1,9.3,9.6,9.5,9.6,9.8,9.4,9.5,9.2,9.4,9.5,9.0\",\"1.5,2.8,2.8,3.3,3.4,3.5,3.2,3.5,3.7,3.8,3.3,3.8,3.5\",\"balve, stadt\"\n05962012,16117,7886,8231,05962012,9.4,6.0,3.4,1514,970,544,\"7.8,9.1,9.6,9.6,10.0,10.3,9.6,9.8,10.1,10.1,9.8,9.5,9.4\",\"6.1,6.7,6.9,6.7,6.8,6.7,6.7,6.8,6.7,6.8,6.6,6.2,6.0\",\"1.6,2.5,2.7,3.0,3.2,3.6,3.0,3.0,3.4,3.3,3.3,3.3,3.4\",\"halver, stadt\"\n05962016,33535,16498,17037,05962016,10.9,7.7,3.2,3660,2584,1076,\"7.9,9.2,9.2,9.8,10.2,10.6,10.3,10.7,10.5,10.7,10.8,11.3,10.9\",\"6.5,7.1,7.0,7.3,7.4,7.5,7.5,7.6,7.4,7.4,7.8,8.0,7.7\",\"1.4,2.1,2.2,2.5,2.8,3.1,2.8,3.1,3.1,3.3,3.1,3.3,3.2\",\"hemer, stadt\"\n05962020,7217,3577,3640,05962020,9.1,5.6,3.5,658,405,253,\"7.4,8.9,9.2,9.2,9.6,10.1,9.3,9.6,10.2,9.5,9.7,9.5,9.1\",\"5.6,6.1,6.1,6.0,6.2,6.5,6.2,5.9,6.6,6.3,6.5,6.3,5.6\",\"1.7,2.8,3.1,3.3,3.4,3.6,3.1,3.7,3.5,3.2,3.2,3.2,3.5\",herscheid\n05962024,93537,45770,47767,05962024,10.0,7.1,2.9,9372,6617,2755,\"8.1,9.4,9.5,10.1,10.1,10.5,10.1,10.3,10.4,10.3,10.3,10.4,10.0\",\"6.7,7.3,7.2,7.5,7.4,7.6,7.4,7.3,7.3,7.2,7.4,7.4,7.1\",\"1.4,2.1,2.3,2.6,2.7,2.9,2.7,3.0,3.1,3.2,2.9,3.0,2.9\",\"iserlohn, stadt\"\n05962028,16300,8060,8240,05962028,10.6,7.3,3.2,1722,1193,529,\"7.7,8.6,8.9,9.2,9.7,9.6,9.0,9.8,10.2,10.4,10.5,10.8,10.6\",\"6.2,6.4,6.7,6.6,6.9,6.7,6.5,7.0,7.2,7.2,7.5,7.7,7.3\",\"1.5,2.2,2.3,2.6,2.8,2.9,2.6,2.8,3.1,3.2,3.0,3.1,3.2\",\"kierspe, stadt\"\n05962032,73354,35955,37399,05962032,9.0,5.6,3.4,6583,4113,2470,\"7.3,8.5,8.5,8.7,9.1,9.2,9.0,9.2,9.4,9.6,9.3,9.2,9.0\",\"5.6,5.9,5.9,5.9,6.0,5.9,6.0,6.0,5.8,5.8,6.0,5.9,5.6\",\"1.7,2.5,2.6,2.8,3.1,3.2,3.1,3.3,3.6,3.8,3.3,3.4,3.4\",\"lüdenscheid, stadt\"\n05962036,20670,10359,10311,05962036,10.1,7.1,3.0,2078,1460,618,\"8.7,10.0,9.8,10.1,10.4,10.8,10.2,10.6,10.6,10.4,10.1,10.4,10.1\",\"7.0,7.6,7.4,7.6,7.7,7.9,7.5,7.7,7.3,7.0,7.2,7.2,7.1\",\"1.7,2.4,2.4,2.5,2.7,3.0,2.7,2.9,3.2,3.4,2.9,3.2,3.0\",\"meinerzhagen, stadt\"\n05962040,53485,26238,27247,05962040,10.4,7.4,3.0,5580,3977,1603,\"9.0,10.1,10.3,10.8,10.9,11.2,11.2,11.6,11.5,11.4,11.2,11.1,10.4\",\"7.7,8.1,8.1,8.3,8.2,8.2,8.2,8.4,8.1,8.0,8.2,8.1,7.4\",\"1.3,2.0,2.2,2.5,2.7,3.0,3.0,3.2,3.3,3.5,3.0,3.0,3.0\",\"menden (sauerland), stadt\"\n05962044,6644,3332,3312,05962044,8.8,6.4,2.5,586,422,164,\"6.6,8.1,8.2,8.8,9.4,10.0,9.1,9.1,9.5,9.2,9.1,9.0,8.8\",\"5.6,6.4,6.5,6.8,6.8,7.4,6.7,6.5,6.9,6.4,6.8,6.6,6.4\",\"0.9,1.7,1.7,2.0,2.6,2.6,2.3,2.6,2.6,2.8,2.3,2.5,2.5\",nachrodt-wiblingwerde\n05962048,12024,5991,6033,05962048,10.3,7.0,3.3,1235,840,395,\"8.3,9.8,9.7,10.4,10.6,11.0,10.7,11.2,10.9,11.0,10.8,10.6,10.3\",\"6.8,7.6,7.5,7.8,7.7,7.9,7.9,7.9,7.6,7.7,7.8,7.3,7.0\",\"1.5,2.3,2.2,2.6,2.9,3.0,2.8,3.3,3.4,3.3,3.1,3.3,3.3\",\"neuenrade, stadt\"\n05962052,25781,12851,12930,05962052,10.1,6.9,3.2,2603,1785,818,\"8.8,10.1,10.1,10.8,10.8,11.1,10.0,10.8,10.9,10.8,10.6,10.6,10.1\",\"7.0,7.4,7.4,7.7,7.4,7.7,7.2,7.4,7.4,7.2,7.6,7.4,6.9\",\"1.9,2.6,2.6,3.0,3.4,3.4,2.9,3.4,3.6,3.6,3.1,3.2,3.2\",\"plettenberg, stadt\"\n05962056,10528,5194,5334,05962056,9.6,6.1,3.5,1011,638,373,\"8.2,9.2,9.5,9.3,9.8,9.5,9.2,10.0,10.1,9.8,9.8,10.0,9.6\",\"6.6,6.8,6.7,6.4,6.7,6.2,6.1,6.6,6.4,6.0,6.4,6.2,6.1\",\"1.6,2.4,2.8,2.9,3.1,3.2,3.2,3.4,3.7,3.8,3.3,3.8,3.5\",schalksmühle\n05962060,18002,8939,9063,05962060,9.2,6.6,2.6,1656,1191,465,\"7.4,8.3,8.7,9.3,9.3,9.8,9.1,9.4,9.4,9.4,9.5,9.4,9.2\",\"5.8,6.1,6.3,6.7,6.4,6.8,6.6,6.6,6.4,6.5,6.8,6.8,6.6\",\"1.5,2.2,2.3,2.6,2.8,3.0,2.5,2.8,3.0,2.9,2.7,2.6,2.6\",\"werdohl, stadt\"\n05966004,24676,12499,12177,05966004,11.0,7.5,3.6,2722,1843,879,\"9.2,10.6,10.6,10.7,11.1,11.4,11.0,11.3,11.4,11.3,11.6,11.5,11.0\",\"7.5,7.9,7.8,7.9,7.9,8.0,7.7,7.9,7.8,7.7,8.2,8.0,7.5\",\"1.8,2.7,2.8,2.9,3.1,3.4,3.3,3.4,3.7,3.6,3.4,3.5,3.6\",\"attendorn, hansestadt\"\n05966008,11874,6003,5871,05966008,12.0,8.1,3.9,1429,960,469,\"9.2,10.6,10.6,10.9,11.3,11.8,11.4,12.1,11.8,12.3,13.0,12.8,12.0\",\"7.3,7.7,7.7,7.6,7.9,8.1,7.9,8.4,7.9,8.4,8.8,8.6,8.1\",\"1.9,2.9,2.9,3.3,3.4,3.7,3.5,3.7,4.0,3.9,4.2,4.1,3.9\",\"drolshagen, stadt\"\n05966012,17258,8849,8409,05966012,12.7,8.6,4.1,2193,1480,713,\"9.7,11.6,11.6,12.0,12.5,12.8,12.0,12.9,13.1,13.2,13.6,13.2,12.7\",\"8.0,8.8,8.9,8.9,9.2,9.3,8.7,9.1,9.0,9.1,9.6,9.1,8.6\",\"1.7,2.9,2.7,3.1,3.4,3.5,3.3,3.8,4.0,4.1,4.1,4.2,4.1\",finnentrop\n05966016,11854,6016,5838,05966016,12.8,8.5,4.3,1522,1007,515,\"8.2,10.0,10.0,10.8,10.8,11.4,11.9,12.4,12.5,12.6,12.5,12.8,12.8\",\"6.9,7.7,7.7,8.0,7.8,8.1,8.3,8.7,8.4,8.5,8.6,8.6,8.5\",\"1.3,2.3,2.4,2.8,3.0,3.4,3.6,3.7,4.1,4.1,3.9,4.2,4.3\",kirchhundem\n05966020,26073,13154,12919,05966020,13.0,9.0,4.0,3390,2338,1052,\"9.4,11.0,11.1,11.6,12.2,12.4,12.2,12.4,12.5,12.9,13.4,13.3,13.0\",\"8.0,8.7,8.7,8.9,9.0,9.0,8.9,9.0,8.8,8.9,9.4,9.2,9.0\",\"1.4,2.3,2.4,2.7,3.2,3.4,3.3,3.4,3.7,4.1,4.0,4.1,4.0\",\"lennestadt, stadt\"\n05966024,24757,12107,12650,05966024,11.8,7.6,4.2,2913,1875,1038,\"8.6,10.1,10.3,10.7,10.8,11.3,11.2,11.5,11.5,11.8,12.1,12.0,11.8\",\"6.9,7.5,7.5,7.6,7.5,7.7,7.8,7.7,7.5,7.7,8.2,8.0,7.6\",\"1.8,2.7,2.8,3.1,3.3,3.6,3.4,3.8,4.0,4.1,3.9,4.0,4.2\",\"olpe, stadt\"\n05966028,19873,9996,9877,05966028,12.5,8.4,4.1,2494,1677,817,\"10.1,11.4,11.8,12.1,12.3,12.6,12.6,12.7,12.7,12.8,12.7,12.7,12.5\",\"8.2,8.5,8.8,8.9,8.7,8.7,8.7,8.9,8.6,8.8,8.9,8.7,8.4\",\"1.9,2.9,3.0,3.1,3.6,3.9,3.9,3.8,4.1,4.1,3.8,4.0,4.1\",wenden\n05970004,19774,10017,9757,05970004,10.6,6.9,3.7,2099,1362,737,\"8.5,9.7,9.9,10.6,10.8,11.4,11.2,11.2,11.8,11.6,11.7,11.0,10.6\",\"6.7,7.1,7.1,7.5,7.5,7.7,7.5,7.3,7.5,7.2,7.6,7.1,6.9\",\"1.9,2.6,2.9,3.1,3.3,3.7,3.7,3.9,4.3,4.5,4.0,3.9,3.7\",\"bad berleburg, stadt\"\n05970008,14969,7758,7211,05970008,11.8,7.8,4.0,1771,1173,598,\"9.8,10.8,10.6,11.2,11.8,12.2,11.5,11.7,12.3,12.1,11.9,12.1,11.8\",\"8.1,8.4,8.1,8.4,8.5,8.6,8.1,8.1,8.3,8.0,8.2,8.1,7.8\",\"1.7,2.4,2.5,2.7,3.2,3.5,3.3,3.6,4.0,4.0,3.7,3.9,4.0\",burbach\n05970012,7206,3671,3535,05970012,11.7,8.0,3.7,843,575,268,\"9.5,11.0,11.2,11.8,12.2,12.6,12.5,12.6,12.8,12.5,12.0,12.3,11.7\",\"7.9,8.7,8.6,8.8,9.2,9.3,8.9,8.9,8.8,8.6,8.4,8.7,8.0\",\"1.6,2.3,2.6,3.1,3.0,3.4,3.7,3.7,4.0,3.9,3.7,3.7,3.7\",erndtebrück\n05970016,17929,8935,8994,05970016,11.1,7.8,3.3,1993,1398,595,\"8.6,9.7,9.7,10.5,11.0,11.2,11.2,11.0,11.3,11.5,11.6,11.3,11.1\",\"7.3,7.5,7.4,7.9,8.0,7.9,7.9,7.8,7.8,7.8,8.2,7.9,7.8\",\"1.3,2.1,2.3,2.6,3.0,3.3,3.3,3.2,3.4,3.7,3.4,3.4,3.3\",\"freudenberg, stadt\"\n05970020,15169,7537,7632,05970020,10.3,7.3,2.9,1556,1112,444,\"8.1,9.0,8.9,9.5,9.7,10.3,10.2,10.2,10.7,11.2,10.9,10.9,10.3\",\"6.7,7.0,6.7,7.0,7.1,7.4,7.2,7.3,7.4,7.8,7.9,7.8,7.3\",\"1.4,2.0,2.2,2.5,2.6,2.9,2.9,2.9,3.2,3.4,2.9,3.1,2.9\",\"hilchenbach, stadt\"\n05970024,31500,15642,15858,05970024,10.4,7.5,2.9,3263,2348,915,\"7.8,8.9,9.0,9.3,9.8,10.1,10.1,10.1,10.4,10.4,10.7,10.5,10.4\",\"6.5,6.8,6.8,6.9,7.0,7.1,7.2,7.2,7.1,7.1,7.7,7.6,7.5\",\"1.3,2.0,2.2,2.4,2.8,2.9,2.9,2.9,3.2,3.4,3.1,2.9,2.9\",\"kreuztal, stadt\"\n05970028,14276,7261,7015,05970028,10.7,7.6,3.1,1523,1080,443,\"8.1,9.2,9.4,9.9,10.6,10.9,11.1,11.1,11.1,11.4,11.5,11.6,10.7\",\"6.9,7.5,7.2,7.7,8.3,8.3,8.5,8.4,8.2,8.1,8.3,8.2,7.6\",\"1.2,1.7,2.1,2.2,2.3,2.6,2.6,2.8,2.9,3.3,3.2,3.3,3.1\",\"bad laasphe, stadt\"\n05970032,23393,11720,11673,05970032,11.6,8.0,3.6,2707,1875,832,\"8.2,10.0,10.3,10.7,11.2,11.7,11.8,11.7,11.8,12.3,12.1,12.0,11.6\",\"6.9,7.7,7.8,8.0,8.2,8.3,8.5,8.3,8.3,8.4,8.6,8.5,8.0\",\"1.4,2.3,2.5,2.7,3.0,3.4,3.3,3.5,3.6,3.9,3.5,3.5,3.6\",\"netphen, stadt\"\n05970036,13717,6954,6763,05970036,11.7,8.2,3.5,1609,1130,479,\"9.6,11.1,10.7,11.4,11.7,11.6,11.3,11.7,12.3,11.9,12.5,12.3,11.7\",\"8.0,8.4,8.1,8.5,8.6,8.4,8.3,8.5,8.8,8.3,8.9,8.7,8.2\",\"1.7,2.7,2.6,2.9,3.1,3.2,3.0,3.1,3.5,3.6,3.6,3.6,3.5\",neunkirchen\n05970040,102355,49925,52430,05970040,11.8,8.5,3.3,12104,8705,3399,\"8.3,9.5,9.7,10.3,10.6,10.9,11.1,11.0,11.4,11.8,11.8,11.9,11.8\",\"6.7,7.3,7.3,7.6,7.6,7.6,7.8,7.7,7.7,8.0,8.6,8.6,8.5\",\"1.5,2.2,2.4,2.7,2.9,3.2,3.4,3.4,3.6,3.8,3.2,3.3,3.3\",\"siegen, universitätsstadt\"\n05970044,20512,10206,10306,05970044,12.3,8.5,3.8,2522,1750,772,\"8.6,9.9,10.2,11.1,11.5,12.0,12.0,12.0,12.5,12.5,12.4,12.7,12.3\",\"7.1,7.7,7.6,8.2,8.3,8.5,8.5,8.5,8.7,8.6,8.9,8.9,8.5\",\"1.5,2.2,2.6,2.9,3.2,3.5,3.5,3.6,3.8,3.9,3.5,3.8,3.8\",wilnsdorf\n05974004,10557,5361,5196,05974004,12.9,8.6,4.2,1357,911,446,\"9.5,10.8,10.8,11.4,11.8,12.2,12.2,12.3,12.7,13.1,12.6,13.3,12.9\",\"7.8,8.5,8.3,8.6,8.9,8.5,8.5,8.8,8.9,8.9,8.8,9.2,8.6\",\"1.7,2.3,2.4,2.8,2.9,3.7,3.7,3.5,3.8,4.2,3.8,4.1,4.2\",anröchte\n05974008,11931,5735,6196,05974008,9.6,6.9,2.7,1147,819,328,\"7.3,8.9,9.1,9.3,9.8,9.8,9.9,10.1,10.2,10.4,10.4,10.2,9.6\",\"6.0,7.0,7.2,7.1,7.2,7.1,7.2,7.5,7.4,7.4,7.6,7.1,6.9\",\"1.3,1.8,1.9,2.2,2.6,2.6,2.7,2.7,2.9,3.1,2.8,3.0,2.7\",bad sassendorf\n05974012,12442,6269,6173,05974012,12.0,8.0,4.0,1494,993,501,\"9.5,10.6,10.5,11.6,12.0,12.5,12.4,12.6,12.4,13.0,13.1,12.7,12.0\",\"7.7,7.9,7.9,8.4,8.7,8.9,8.9,8.7,8.4,8.8,9.0,8.6,8.0\",\"1.8,2.7,2.6,3.1,3.3,3.5,3.5,3.9,4.0,4.2,4.0,4.0,4.0\",ense\n05974016,16128,7968,8160,05974016,11.0,7.4,3.5,1771,1200,571,\"8.9,10.4,10.4,10.7,11.2,11.1,11.1,10.6,11.1,11.3,11.1,11.5,11.0\",\"7.4,8.2,8.1,8.2,8.3,8.0,8.1,7.7,7.8,7.7,7.9,8.0,7.4\",\"1.4,2.2,2.4,2.5,2.9,3.1,3.0,2.9,3.3,3.6,3.2,3.5,3.5\",\"erwitte, stadt\"\n05974020,21070,10487,10583,05974020,11.4,8.0,3.4,2405,1679,726,\"8.7,10.1,9.9,10.7,11.1,11.5,11.5,11.8,12.4,12.3,12.0,12.2,11.4\",\"7.2,7.9,7.7,8.1,8.3,8.4,8.5,8.5,8.6,8.4,8.6,8.8,8.0\",\"1.5,2.2,2.1,2.6,2.8,3.1,3.0,3.3,3.8,3.9,3.3,3.5,3.4\",\"geseke, stadt\"\n05974024,12027,6044,5983,05974024,11.2,7.7,3.5,1349,931,418,\"7.6,8.7,8.9,9.7,10.0,9.9,10.2,10.3,10.9,11.1,11.6,11.7,11.2\",\"6.4,7.1,7.2,7.7,7.7,7.4,7.5,7.7,8.0,7.7,8.2,8.3,7.7\",\"1.2,1.6,1.7,2.0,2.3,2.5,2.7,2.6,2.9,3.4,3.3,3.4,3.5\",lippetal\n05974028,67233,33073,34160,05974028,10.8,7.4,3.5,7278,4954,2324,\"9.0,10.0,9.8,10.4,10.4,10.7,10.8,10.9,11.1,11.1,11.2,11.3,10.8\",\"7.2,7.5,7.3,7.6,7.5,7.6,7.8,7.7,7.6,7.6,7.9,7.9,7.4\",\"1.8,2.4,2.5,2.7,2.8,3.1,3.1,3.3,3.5,3.5,3.4,3.4,3.5\",\"lippstadt, stadt\"\n05974032,11608,5987,5621,05974032,10.1,7.3,2.9,1178,844,334,\"7.7,8.9,9.6,10.1,10.5,10.8,11.2,11.0,11.5,11.4,11.2,11.1,10.1\",\"6.5,7.0,7.3,7.6,7.7,7.9,8.3,7.8,8.1,7.9,8.0,8.0,7.3\",\"1.2,1.9,2.3,2.5,2.8,3.0,3.0,3.2,3.4,3.5,3.2,3.0,2.9\",möhnesee\n05974036,11095,5790,5305,05974036,10.9,7.5,3.4,1211,830,381,\"8.1,9.5,9.5,9.9,10.3,10.6,11.0,11.3,12.0,11.7,11.8,11.4,10.9\",\"6.8,7.5,7.4,7.6,7.5,7.5,7.9,7.9,8.2,8.2,8.4,8.0,7.5\",\"1.4,2.0,2.1,2.4,2.8,3.1,3.1,3.3,3.8,3.5,3.4,3.3,3.4\",\"rüthen, stadt\"\n05974040,47974,23245,24729,05974040,10.8,7.7,3.1,5184,3684,1500,\"8.4,9.7,9.8,10.4,10.5,10.6,10.8,11.0,11.1,11.5,11.2,11.5,10.8\",\"6.8,7.4,7.6,7.8,7.8,7.5,7.7,7.8,7.6,7.8,8.0,8.3,7.7\",\"1.6,2.3,2.3,2.5,2.7,3.1,3.1,3.3,3.5,3.7,3.2,3.3,3.1\",\"soest, stadt\"\n05974044,25407,12721,12686,05974044,9.9,7.0,2.9,2518,1781,737,\"7.4,8.6,8.4,9.0,9.4,9.3,9.4,9.7,9.9,10.3,10.2,10.2,9.9\",\"6.0,6.5,6.6,6.9,6.9,6.7,6.9,7.0,6.9,7.2,7.4,7.4,7.0\",\"1.3,2.0,1.8,2.1,2.5,2.6,2.6,2.7,3.0,3.1,2.8,2.8,2.9\",\"warstein, stadt\"\n05974048,12140,6071,6069,05974048,9.6,6.6,3.0,1164,804,360,\"7.2,8.2,8.7,8.8,9.2,9.5,9.8,9.9,9.9,9.9,9.7,10.4,9.6\",\"6.1,6.4,6.8,6.9,7.0,7.1,7.3,7.4,7.0,7.1,7.1,7.4,6.6\",\"1.1,1.8,1.9,1.9,2.2,2.4,2.5,2.6,2.9,2.8,2.7,3.0,3.0\",welver\n05974052,30638,15681,14957,05974052,11.1,7.9,3.2,3397,2417,980,\"8.2,9.4,9.3,10.2,10.6,10.7,11.0,11.3,11.0,11.6,11.5,11.7,11.1\",\"6.9,7.3,7.1,7.8,7.8,7.8,8.0,8.1,7.9,8.1,8.2,8.5,7.9\",\"1.4,2.1,2.2,2.4,2.8,2.9,3.1,3.2,3.1,3.5,3.3,3.2,3.2\",\"werl, stadt\"\n05974056,12745,6629,6116,05974056,10.9,7.4,3.5,1386,937,449,\"8.5,10.3,9.8,10.8,11.3,11.5,11.7,12.0,12.4,12.6,12.6,11.8,10.9\",\"7.2,7.7,7.5,8.2,8.3,8.4,8.4,8.6,8.6,8.8,9.0,8.2,7.4\",\"1.3,2.6,2.3,2.6,3.0,3.1,3.3,3.4,3.8,3.9,3.7,3.6,3.5\",wickede (ruhr)\n05978004,47803,23562,24241,05978004,10.3,8.1,2.2,4924,3850,1074,\"7.4,8.5,8.4,8.9,9.2,9.4,9.4,9.8,10.0,10.2,10.2,10.3,10.3\",\"6.4,7.1,6.8,7.1,7.2,7.2,7.2,7.5,7.7,7.8,8.1,8.2,8.1\",\"1.0,1.5,1.6,1.8,2.0,2.2,2.2,2.2,2.3,2.4,2.1,2.1,2.2\",\"bergkamen, stadt\"\n05978008,18059,8790,9269,05978008,9.0,6.8,2.1,1621,1234,387,\"6.6,7.5,7.7,8.0,8.3,8.7,8.8,9.3,9.3,9.3,9.1,9.5,9.0\",\"5.7,6.2,6.3,6.3,6.4,6.7,6.8,7.1,7.1,7.0,7.1,7.3,6.8\",\"0.9,1.3,1.4,1.7,1.9,2.0,2.0,2.1,2.2,2.3,2.0,2.2,2.1\",bönen\n05978012,20961,10293,10668,05978012,9.7,7.0,2.7,2037,1471,566,\"7.2,8.3,8.3,8.5,9.0,9.1,9.1,9.1,9.4,9.9,9.8,10.0,9.7\",\"6.0,6.5,6.4,6.5,6.8,6.8,6.8,6.7,6.7,7.0,7.2,7.3,7.0\",\"1.1,1.8,1.8,2.0,2.2,2.2,2.3,2.4,2.6,2.8,2.6,2.7,2.7\",\"fröndenberg/ruhr, stadt\"\n05978016,17085,8310,8775,05978016,9.2,6.6,2.5,1564,1130,434,\"7.1,8.3,8.3,8.8,9.1,9.6,9.7,9.6,9.6,9.8,9.9,9.9,9.2\",\"6.0,6.6,6.6,6.5,6.7,7.0,7.1,7.0,6.9,7.0,7.2,7.1,6.6\",\"1.0,1.7,1.7,2.3,2.4,2.6,2.6,2.6,2.7,2.8,2.7,2.7,2.5\",holzwickede\n05978020,43868,21485,22383,05978020,8.9,6.7,2.2,3926,2945,981,\"6.7,7.7,7.7,8.2,8.5,8.8,9.0,9.3,9.5,9.4,9.3,9.4,8.9\",\"5.7,6.2,6.2,6.5,6.6,6.8,6.8,7.0,7.2,7.0,7.3,7.2,6.7\",\"1.0,1.6,1.5,1.7,1.9,2.0,2.2,2.3,2.3,2.5,2.0,2.2,2.2\",\"kamen, stadt\"\n05978024,85867,41810,44057,05978024,9.2,7.0,2.2,7900,6024,1876,\"7.1,8.2,8.2,8.4,8.6,8.7,9.0,9.1,9.2,9.3,9.3,9.4,9.2\",\"6.2,6.8,6.7,6.8,6.8,6.8,7.0,7.1,7.1,7.1,7.3,7.3,7.0\",\"0.9,1.4,1.5,1.7,1.8,1.9,2.0,2.0,2.1,2.2,1.9,2.0,2.2\",\"lünen, stadt\"\n05978028,46723,22767,23956,05978028,8.9,6.4,2.5,4145,2983,1162,\"7.0,8.0,8.3,8.7,8.9,9.0,9.1,9.3,9.2,9.8,9.5,9.4,8.9\",\"5.9,6.3,6.5,6.7,6.7,6.6,6.5,6.7,6.7,7.0,7.1,6.9,6.4\",\"1.1,1.7,1.8,2.0,2.2,2.4,2.5,2.6,2.6,2.8,2.4,2.4,2.5\",\"schwerte, hansestadt an der ruhr\"\n05978032,26603,13272,13331,05978032,9.8,7.3,2.5,2607,1930,677,\"7.7,8.6,8.7,9.0,9.3,9.6,9.9,10.1,10.2,10.4,10.6,10.4,9.8\",\"6.5,7.0,7.0,7.0,7.3,7.4,7.7,7.6,7.4,7.6,8.0,7.7,7.3\",\"1.1,1.6,1.7,1.9,2.0,2.1,2.2,2.5,2.8,2.9,2.7,2.7,2.5\",\"selm, stadt\"\n05978036,59111,28581,30530,05978036,9.6,6.9,2.7,5651,4059,1592,\"6.6,7.7,7.9,8.2,8.3,8.7,9.0,9.1,9.2,10.1,10.0,9.9,9.6\",\"5.5,6.0,6.1,6.3,6.3,6.5,6.6,6.6,6.6,7.2,7.3,7.2,6.9\",\"1.1,1.7,1.7,2.0,2.0,2.2,2.4,2.5,2.6,2.9,2.7,2.7,2.7\",\"unna, stadt\"\n05978040,29955,14568,15387,05978040,9.4,6.9,2.5,2826,2076,750,\"7.5,8.6,8.7,9.1,9.2,9.5,9.5,9.8,9.9,10.2,9.9,9.8,9.4\",\"6.3,6.9,6.9,7.1,7.2,7.2,7.1,7.4,7.4,7.4,7.4,7.3,6.9\",\"1.1,1.7,1.8,2.0,2.0,2.3,2.4,2.4,2.5,2.8,2.6,2.5,2.5\",\"werne, stadt\"\n"

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/topojson/topojson Version 3.0.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.topojson = global.topojson || {})));
	}(this, (function (exports) { 'use strict';
	
	var identity = function(x) {
	  return x;
	};
	
	var transform = function(transform) {
	  if (transform == null) return identity;
	  var x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(input, i) {
	    if (!i) x0 = y0 = 0;
	    var j = 2, n = input.length, output = new Array(n);
	    output[0] = (x0 += input[0]) * kx + dx;
	    output[1] = (y0 += input[1]) * ky + dy;
	    while (j < n) output[j] = input[j], ++j;
	    return output;
	  };
	};
	
	var bbox = function(topology) {
	  var t = transform(topology.transform), key,
	      x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;
	
	  function bboxPoint(p) {
	    p = t(p);
	    if (p[0] < x0) x0 = p[0];
	    if (p[0] > x1) x1 = p[0];
	    if (p[1] < y0) y0 = p[1];
	    if (p[1] > y1) y1 = p[1];
	  }
	
	  function bboxGeometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(bboxGeometry); break;
	      case "Point": bboxPoint(o.coordinates); break;
	      case "MultiPoint": o.coordinates.forEach(bboxPoint); break;
	    }
	  }
	
	  topology.arcs.forEach(function(arc) {
	    var i = -1, n = arc.length, p;
	    while (++i < n) {
	      p = t(arc[i], i);
	      if (p[0] < x0) x0 = p[0];
	      if (p[0] > x1) x1 = p[0];
	      if (p[1] < y0) y0 = p[1];
	      if (p[1] > y1) y1 = p[1];
	    }
	  });
	
	  for (key in topology.objects) {
	    bboxGeometry(topology.objects[key]);
	  }
	
	  return [x0, y0, x1, y1];
	};
	
	var reverse = function(array, n) {
	  var t, j = array.length, i = j - n;
	  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
	};
	
	var feature = function(topology, o) {
	  return o.type === "GeometryCollection"
	      ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature$1(topology, o); })}
	      : feature$1(topology, o);
	};
	
	function feature$1(topology, o) {
	  var id = o.id,
	      bbox = o.bbox,
	      properties = o.properties == null ? {} : o.properties,
	      geometry = object(topology, o);
	  return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
	      : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
	      : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
	}
	
	function object(topology, o) {
	  var transformPoint = transform(topology.transform),
	      arcs = topology.arcs;
	
	  function arc(i, points) {
	    if (points.length) points.pop();
	    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
	      points.push(transformPoint(a[k], k));
	    }
	    if (i < 0) reverse(points, n);
	  }
	
	  function point(p) {
	    return transformPoint(p);
	  }
	
	  function line(arcs) {
	    var points = [];
	    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
	    if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
	    return points;
	  }
	
	  function ring(arcs) {
	    var points = line(arcs);
	    while (points.length < 4) points.push(points[0]); // This may happen if an arc has only two points.
	    return points;
	  }
	
	  function polygon(arcs) {
	    return arcs.map(ring);
	  }
	
	  function geometry(o) {
	    var type = o.type, coordinates;
	    switch (type) {
	      case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
	      case "Point": coordinates = point(o.coordinates); break;
	      case "MultiPoint": coordinates = o.coordinates.map(point); break;
	      case "LineString": coordinates = line(o.arcs); break;
	      case "MultiLineString": coordinates = o.arcs.map(line); break;
	      case "Polygon": coordinates = polygon(o.arcs); break;
	      case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
	      default: return null;
	    }
	    return {type: type, coordinates: coordinates};
	  }
	
	  return geometry(o);
	}
	
	var stitch = function(topology, arcs) {
	  var stitchedArcs = {},
	      fragmentByStart = {},
	      fragmentByEnd = {},
	      fragments = [],
	      emptyIndex = -1;
	
	  // Stitch empty arcs first, since they may be subsumed by other arcs.
	  arcs.forEach(function(i, j) {
	    var arc = topology.arcs[i < 0 ? ~i : i], t;
	    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
	      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
	    }
	  });
	
	  arcs.forEach(function(i) {
	    var e = ends(i),
	        start = e[0],
	        end = e[1],
	        f, g;
	
	    if (f = fragmentByEnd[start]) {
	      delete fragmentByEnd[f.end];
	      f.push(i);
	      f.end = end;
	      if (g = fragmentByStart[end]) {
	        delete fragmentByStart[g.start];
	        var fg = g === f ? f : f.concat(g);
	        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else if (f = fragmentByStart[end]) {
	      delete fragmentByStart[f.start];
	      f.unshift(i);
	      f.start = start;
	      if (g = fragmentByEnd[start]) {
	        delete fragmentByEnd[g.end];
	        var gf = g === f ? f : g.concat(f);
	        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else {
	      f = [i];
	      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
	    }
	  });
	
	  function ends(i) {
	    var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
	    if (topology.transform) p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; });
	    else p1 = arc[arc.length - 1];
	    return i < 0 ? [p1, p0] : [p0, p1];
	  }
	
	  function flush(fragmentByEnd, fragmentByStart) {
	    for (var k in fragmentByEnd) {
	      var f = fragmentByEnd[k];
	      delete fragmentByStart[f.start];
	      delete f.start;
	      delete f.end;
	      f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });
	      fragments.push(f);
	    }
	  }
	
	  flush(fragmentByEnd, fragmentByStart);
	  flush(fragmentByStart, fragmentByEnd);
	  arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]); });
	
	  return fragments;
	};
	
	var mesh = function(topology) {
	  return object(topology, meshArcs.apply(this, arguments));
	};
	
	function meshArcs(topology, object$$1, filter) {
	  var arcs, i, n;
	  if (arguments.length > 1) arcs = extractArcs(topology, object$$1, filter);
	  else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
	  return {type: "MultiLineString", arcs: stitch(topology, arcs)};
	}
	
	function extractArcs(topology, object$$1, filter) {
	  var arcs = [],
	      geomsByArc = [],
	      geom;
	
	  function extract0(i) {
	    var j = i < 0 ? ~i : i;
	    (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});
	  }
	
	  function extract1(arcs) {
	    arcs.forEach(extract0);
	  }
	
	  function extract2(arcs) {
	    arcs.forEach(extract1);
	  }
	
	  function extract3(arcs) {
	    arcs.forEach(extract2);
	  }
	
	  function geometry(o) {
	    switch (geom = o, o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "LineString": extract1(o.arcs); break;
	      case "MultiLineString": case "Polygon": extract2(o.arcs); break;
	      case "MultiPolygon": extract3(o.arcs); break;
	    }
	  }
	
	  geometry(object$$1);
	
	  geomsByArc.forEach(filter == null
	      ? function(geoms) { arcs.push(geoms[0].i); }
	      : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i); });
	
	  return arcs;
	}
	
	function planarRingArea(ring) {
	  var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
	  while (++i < n) a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
	  return Math.abs(area); // Note: doubled area!
	}
	
	var merge = function(topology) {
	  return object(topology, mergeArcs.apply(this, arguments));
	};
	
	function mergeArcs(topology, objects) {
	  var polygonsByArc = {},
	      polygons = [],
	      groups = [];
	
	  objects.forEach(geometry);
	
	  function geometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "Polygon": extract(o.arcs); break;
	      case "MultiPolygon": o.arcs.forEach(extract); break;
	    }
	  }
	
	  function extract(polygon) {
	    polygon.forEach(function(ring) {
	      ring.forEach(function(arc) {
	        (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
	      });
	    });
	    polygons.push(polygon);
	  }
	
	  function area(ring) {
	    return planarRingArea(object(topology, {type: "Polygon", arcs: [ring]}).coordinates[0]);
	  }
	
	  polygons.forEach(function(polygon) {
	    if (!polygon._) {
	      var group = [],
	          neighbors = [polygon];
	      polygon._ = 1;
	      groups.push(group);
	      while (polygon = neighbors.pop()) {
	        group.push(polygon);
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
	              if (!polygon._) {
	                polygon._ = 1;
	                neighbors.push(polygon);
	              }
	            });
	          });
	        });
	      }
	    }
	  });
	
	  polygons.forEach(function(polygon) {
	    delete polygon._;
	  });
	
	  return {
	    type: "MultiPolygon",
	    arcs: groups.map(function(polygons) {
	      var arcs = [], n;
	
	      // Extract the exterior (unique) arcs.
	      polygons.forEach(function(polygon) {
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) {
	              arcs.push(arc);
	            }
	          });
	        });
	      });
	
	      // Stitch the arcs into one or more rings.
	      arcs = stitch(topology, arcs);
	
	      // If more than one ring is returned,
	      // at most one of these rings can be the exterior;
	      // choose the one with the greatest absolute area.
	      if ((n = arcs.length) > 1) {
	        for (var i = 1, k = area(arcs[0]), ki, t; i < n; ++i) {
	          if ((ki = area(arcs[i])) > k) {
	            t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
	          }
	        }
	      }
	
	      return arcs;
	    })
	  };
	}
	
	var bisect = function(a, x) {
	  var lo = 0, hi = a.length;
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	    if (a[mid] < x) lo = mid + 1;
	    else hi = mid;
	  }
	  return lo;
	};
	
	var neighbors = function(objects) {
	  var indexesByArc = {}, // arc index -> array of object indexes
	      neighbors = objects.map(function() { return []; });
	
	  function line(arcs, i) {
	    arcs.forEach(function(a) {
	      if (a < 0) a = ~a;
	      var o = indexesByArc[a];
	      if (o) o.push(i);
	      else indexesByArc[a] = [i];
	    });
	  }
	
	  function polygon(arcs, i) {
	    arcs.forEach(function(arc) { line(arc, i); });
	  }
	
	  function geometry(o, i) {
	    if (o.type === "GeometryCollection") o.geometries.forEach(function(o) { geometry(o, i); });
	    else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
	  }
	
	  var geometryType = {
	    LineString: line,
	    MultiLineString: polygon,
	    Polygon: polygon,
	    MultiPolygon: function(arcs, i) { arcs.forEach(function(arc) { polygon(arc, i); }); }
	  };
	
	  objects.forEach(geometry);
	
	  for (var i in indexesByArc) {
	    for (var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j) {
	      for (var k = j + 1; k < m; ++k) {
	        var ij = indexes[j], ik = indexes[k], n;
	        if ((n = neighbors[ij])[i = bisect(n, ik)] !== ik) n.splice(i, 0, ik);
	        if ((n = neighbors[ik])[i = bisect(n, ij)] !== ij) n.splice(i, 0, ij);
	      }
	    }
	  }
	
	  return neighbors;
	};
	
	var untransform = function(transform) {
	  if (transform == null) return identity;
	  var x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(input, i) {
	    if (!i) x0 = y0 = 0;
	    var j = 2,
	        n = input.length,
	        output = new Array(n),
	        x1 = Math.round((input[0] - dx) / kx),
	        y1 = Math.round((input[1] - dy) / ky);
	    output[0] = x1 - x0, x0 = x1;
	    output[1] = y1 - y0, y0 = y1;
	    while (j < n) output[j] = input[j], ++j;
	    return output;
	  };
	};
	
	var quantize = function(topology, transform) {
	  if (topology.transform) throw new Error("already quantized");
	
	  if (!transform || !transform.scale) {
	    if (!((n = Math.floor(transform)) >= 2)) throw new Error("n must be \u22652");
	    box = topology.bbox || bbox(topology);
	    var x0 = box[0], y0 = box[1], x1 = box[2], y1 = box[3], n;
	    transform = {scale: [x1 - x0 ? (x1 - x0) / (n - 1) : 1, y1 - y0 ? (y1 - y0) / (n - 1) : 1], translate: [x0, y0]};
	  } else {
	    box = topology.bbox;
	  }
	
	  var t = untransform(transform), box, key, inputs = topology.objects, outputs = {};
	
	  function quantizePoint(point) {
	    return t(point);
	  }
	
	  function quantizeGeometry(input) {
	    var output;
	    switch (input.type) {
	      case "GeometryCollection": output = {type: "GeometryCollection", geometries: input.geometries.map(quantizeGeometry)}; break;
	      case "Point": output = {type: "Point", coordinates: quantizePoint(input.coordinates)}; break;
	      case "MultiPoint": output = {type: "MultiPoint", coordinates: input.coordinates.map(quantizePoint)}; break;
	      default: return input;
	    }
	    if (input.id != null) output.id = input.id;
	    if (input.bbox != null) output.bbox = input.bbox;
	    if (input.properties != null) output.properties = input.properties;
	    return output;
	  }
	
	  function quantizeArc(input) {
	    var i = 0, j = 1, n = input.length, p, output = new Array(n); // pessimistic
	    output[0] = t(input[0], 0);
	    while (++i < n) if ((p = t(input[i], i))[0] || p[1]) output[j++] = p; // non-coincident points
	    if (j === 1) output[j++] = [0, 0]; // an arc must have at least two points
	    output.length = j;
	    return output;
	  }
	
	  for (key in inputs) outputs[key] = quantizeGeometry(inputs[key]);
	
	  return {
	    type: "Topology",
	    bbox: box,
	    transform: transform,
	    objects: outputs,
	    arcs: topology.arcs.map(quantizeArc)
	  };
	};
	
	// Computes the bounding box of the specified hash of GeoJSON objects.
	var bounds = function(objects) {
	  var x0 = Infinity,
	      y0 = Infinity,
	      x1 = -Infinity,
	      y1 = -Infinity;
	
	  function boundGeometry(geometry) {
	    if (geometry != null && boundGeometryType.hasOwnProperty(geometry.type)) boundGeometryType[geometry.type](geometry);
	  }
	
	  var boundGeometryType = {
	    GeometryCollection: function(o) { o.geometries.forEach(boundGeometry); },
	    Point: function(o) { boundPoint(o.coordinates); },
	    MultiPoint: function(o) { o.coordinates.forEach(boundPoint); },
	    LineString: function(o) { boundLine(o.arcs); },
	    MultiLineString: function(o) { o.arcs.forEach(boundLine); },
	    Polygon: function(o) { o.arcs.forEach(boundLine); },
	    MultiPolygon: function(o) { o.arcs.forEach(boundMultiLine); }
	  };
	
	  function boundPoint(coordinates) {
	    var x = coordinates[0],
	        y = coordinates[1];
	    if (x < x0) x0 = x;
	    if (x > x1) x1 = x;
	    if (y < y0) y0 = y;
	    if (y > y1) y1 = y;
	  }
	
	  function boundLine(coordinates) {
	    coordinates.forEach(boundPoint);
	  }
	
	  function boundMultiLine(coordinates) {
	    coordinates.forEach(boundLine);
	  }
	
	  for (var key in objects) {
	    boundGeometry(objects[key]);
	  }
	
	  return x1 >= x0 && y1 >= y0 ? [x0, y0, x1, y1] : undefined;
	};
	
	var hashset = function(size, hash, equal, type, empty) {
	  if (arguments.length === 3) {
	    type = Array;
	    empty = null;
	  }
	
	  var store = new type(size = 1 << Math.max(4, Math.ceil(Math.log(size) / Math.LN2))),
	      mask = size - 1;
	
	  for (var i = 0; i < size; ++i) {
	    store[i] = empty;
	  }
	
	  function add(value) {
	    var index = hash(value) & mask,
	        match = store[index],
	        collisions = 0;
	    while (match != empty) {
	      if (equal(match, value)) return true;
	      if (++collisions >= size) throw new Error("full hashset");
	      match = store[index = (index + 1) & mask];
	    }
	    store[index] = value;
	    return true;
	  }
	
	  function has(value) {
	    var index = hash(value) & mask,
	        match = store[index],
	        collisions = 0;
	    while (match != empty) {
	      if (equal(match, value)) return true;
	      if (++collisions >= size) break;
	      match = store[index = (index + 1) & mask];
	    }
	    return false;
	  }
	
	  function values() {
	    var values = [];
	    for (var i = 0, n = store.length; i < n; ++i) {
	      var match = store[i];
	      if (match != empty) values.push(match);
	    }
	    return values;
	  }
	
	  return {
	    add: add,
	    has: has,
	    values: values
	  };
	};
	
	var hashmap = function(size, hash, equal, keyType, keyEmpty, valueType) {
	  if (arguments.length === 3) {
	    keyType = valueType = Array;
	    keyEmpty = null;
	  }
	
	  var keystore = new keyType(size = 1 << Math.max(4, Math.ceil(Math.log(size) / Math.LN2))),
	      valstore = new valueType(size),
	      mask = size - 1;
	
	  for (var i = 0; i < size; ++i) {
	    keystore[i] = keyEmpty;
	  }
	
	  function set(key, value) {
	    var index = hash(key) & mask,
	        matchKey = keystore[index],
	        collisions = 0;
	    while (matchKey != keyEmpty) {
	      if (equal(matchKey, key)) return valstore[index] = value;
	      if (++collisions >= size) throw new Error("full hashmap");
	      matchKey = keystore[index = (index + 1) & mask];
	    }
	    keystore[index] = key;
	    valstore[index] = value;
	    return value;
	  }
	
	  function maybeSet(key, value) {
	    var index = hash(key) & mask,
	        matchKey = keystore[index],
	        collisions = 0;
	    while (matchKey != keyEmpty) {
	      if (equal(matchKey, key)) return valstore[index];
	      if (++collisions >= size) throw new Error("full hashmap");
	      matchKey = keystore[index = (index + 1) & mask];
	    }
	    keystore[index] = key;
	    valstore[index] = value;
	    return value;
	  }
	
	  function get(key, missingValue) {
	    var index = hash(key) & mask,
	        matchKey = keystore[index],
	        collisions = 0;
	    while (matchKey != keyEmpty) {
	      if (equal(matchKey, key)) return valstore[index];
	      if (++collisions >= size) break;
	      matchKey = keystore[index = (index + 1) & mask];
	    }
	    return missingValue;
	  }
	
	  function keys() {
	    var keys = [];
	    for (var i = 0, n = keystore.length; i < n; ++i) {
	      var matchKey = keystore[i];
	      if (matchKey != keyEmpty) keys.push(matchKey);
	    }
	    return keys;
	  }
	
	  return {
	    set: set,
	    maybeSet: maybeSet, // set if unset
	    get: get,
	    keys: keys
	  };
	};
	
	var equalPoint = function(pointA, pointB) {
	  return pointA[0] === pointB[0] && pointA[1] === pointB[1];
	};
	
	// TODO if quantized, use simpler Int32 hashing?
	
	var buffer = new ArrayBuffer(16);
	var floats = new Float64Array(buffer);
	var uints = new Uint32Array(buffer);
	
	var hashPoint = function(point) {
	  floats[0] = point[0];
	  floats[1] = point[1];
	  var hash = uints[0] ^ uints[1];
	  hash = hash << 5 ^ hash >> 7 ^ uints[2] ^ uints[3];
	  return hash & 0x7fffffff;
	};
	
	// Given an extracted (pre-)topology, identifies all of the junctions. These are
	// the points at which arcs (lines or rings) will need to be cut so that each
	// arc is represented uniquely.
	//
	// A junction is a point where at least one arc deviates from another arc going
	// through the same point. For example, consider the point B. If there is a arc
	// through ABC and another arc through CBA, then B is not a junction because in
	// both cases the adjacent point pairs are {A,C}. However, if there is an
	// additional arc ABD, then {A,D} != {A,C}, and thus B becomes a junction.
	//
	// For a closed ring ABCA, the first point A’s adjacent points are the second
	// and last point {B,C}. For a line, the first and last point are always
	// considered junctions, even if the line is closed; this ensures that a closed
	// line is never rotated.
	var join = function(topology) {
	  var coordinates = topology.coordinates,
	      lines = topology.lines,
	      rings = topology.rings,
	      indexes = index(),
	      visitedByIndex = new Int32Array(coordinates.length),
	      leftByIndex = new Int32Array(coordinates.length),
	      rightByIndex = new Int32Array(coordinates.length),
	      junctionByIndex = new Int8Array(coordinates.length),
	      junctionCount = 0, // upper bound on number of junctions
	      i, n,
	      previousIndex,
	      currentIndex,
	      nextIndex;
	
	  for (i = 0, n = coordinates.length; i < n; ++i) {
	    visitedByIndex[i] = leftByIndex[i] = rightByIndex[i] = -1;
	  }
	
	  for (i = 0, n = lines.length; i < n; ++i) {
	    var line = lines[i],
	        lineStart = line[0],
	        lineEnd = line[1];
	    currentIndex = indexes[lineStart];
	    nextIndex = indexes[++lineStart];
	    ++junctionCount, junctionByIndex[currentIndex] = 1; // start
	    while (++lineStart <= lineEnd) {
	      sequence(i, previousIndex = currentIndex, currentIndex = nextIndex, nextIndex = indexes[lineStart]);
	    }
	    ++junctionCount, junctionByIndex[nextIndex] = 1; // end
	  }
	
	  for (i = 0, n = coordinates.length; i < n; ++i) {
	    visitedByIndex[i] = -1;
	  }
	
	  for (i = 0, n = rings.length; i < n; ++i) {
	    var ring = rings[i],
	        ringStart = ring[0] + 1,
	        ringEnd = ring[1];
	    previousIndex = indexes[ringEnd - 1];
	    currentIndex = indexes[ringStart - 1];
	    nextIndex = indexes[ringStart];
	    sequence(i, previousIndex, currentIndex, nextIndex);
	    while (++ringStart <= ringEnd) {
	      sequence(i, previousIndex = currentIndex, currentIndex = nextIndex, nextIndex = indexes[ringStart]);
	    }
	  }
	
	  function sequence(i, previousIndex, currentIndex, nextIndex) {
	    if (visitedByIndex[currentIndex] === i) return; // ignore self-intersection
	    visitedByIndex[currentIndex] = i;
	    var leftIndex = leftByIndex[currentIndex];
	    if (leftIndex >= 0) {
	      var rightIndex = rightByIndex[currentIndex];
	      if ((leftIndex !== previousIndex || rightIndex !== nextIndex)
	        && (leftIndex !== nextIndex || rightIndex !== previousIndex)) {
	        ++junctionCount, junctionByIndex[currentIndex] = 1;
	      }
	    } else {
	      leftByIndex[currentIndex] = previousIndex;
	      rightByIndex[currentIndex] = nextIndex;
	    }
	  }
	
	  function index() {
	    var indexByPoint = hashmap(coordinates.length * 1.4, hashIndex, equalIndex, Int32Array, -1, Int32Array),
	        indexes = new Int32Array(coordinates.length);
	
	    for (var i = 0, n = coordinates.length; i < n; ++i) {
	      indexes[i] = indexByPoint.maybeSet(i, i);
	    }
	
	    return indexes;
	  }
	
	  function hashIndex(i) {
	    return hashPoint(coordinates[i]);
	  }
	
	  function equalIndex(i, j) {
	    return equalPoint(coordinates[i], coordinates[j]);
	  }
	
	  visitedByIndex = leftByIndex = rightByIndex = null;
	
	  var junctionByPoint = hashset(junctionCount * 1.4, hashPoint, equalPoint), j;
	
	  // Convert back to a standard hashset by point for caller convenience.
	  for (i = 0, n = coordinates.length; i < n; ++i) {
	    if (junctionByIndex[j = indexes[i]]) {
	      junctionByPoint.add(coordinates[j]);
	    }
	  }
	
	  return junctionByPoint;
	};
	
	// Given an extracted (pre-)topology, cuts (or rotates) arcs so that all shared
	// point sequences are identified. The topology can then be subsequently deduped
	// to remove exact duplicate arcs.
	var cut = function(topology) {
	  var junctions = join(topology),
	      coordinates = topology.coordinates,
	      lines = topology.lines,
	      rings = topology.rings,
	      next,
	      i, n;
	
	  for (i = 0, n = lines.length; i < n; ++i) {
	    var line = lines[i],
	        lineMid = line[0],
	        lineEnd = line[1];
	    while (++lineMid < lineEnd) {
	      if (junctions.has(coordinates[lineMid])) {
	        next = {0: lineMid, 1: line[1]};
	        line[1] = lineMid;
	        line = line.next = next;
	      }
	    }
	  }
	
	  for (i = 0, n = rings.length; i < n; ++i) {
	    var ring = rings[i],
	        ringStart = ring[0],
	        ringMid = ringStart,
	        ringEnd = ring[1],
	        ringFixed = junctions.has(coordinates[ringStart]);
	    while (++ringMid < ringEnd) {
	      if (junctions.has(coordinates[ringMid])) {
	        if (ringFixed) {
	          next = {0: ringMid, 1: ring[1]};
	          ring[1] = ringMid;
	          ring = ring.next = next;
	        } else { // For the first junction, we can rotate rather than cut.
	          rotateArray(coordinates, ringStart, ringEnd, ringEnd - ringMid);
	          coordinates[ringEnd] = coordinates[ringStart];
	          ringFixed = true;
	          ringMid = ringStart; // restart; we may have skipped junctions
	        }
	      }
	    }
	  }
	
	  return topology;
	};
	
	function rotateArray(array, start, end, offset) {
	  reverse$1(array, start, end);
	  reverse$1(array, start, start + offset);
	  reverse$1(array, start + offset, end);
	}
	
	function reverse$1(array, start, end) {
	  for (var mid = start + ((end-- - start) >> 1), t; start < mid; ++start, --end) {
	    t = array[start], array[start] = array[end], array[end] = t;
	  }
	}
	
	// Given a cut topology, combines duplicate arcs.
	var dedup = function(topology) {
	  var coordinates = topology.coordinates,
	      lines = topology.lines, line,
	      rings = topology.rings, ring,
	      arcCount = lines.length + rings.length,
	      i, n;
	
	  delete topology.lines;
	  delete topology.rings;
	
	  // Count the number of (non-unique) arcs to initialize the hashmap safely.
	  for (i = 0, n = lines.length; i < n; ++i) {
	    line = lines[i]; while (line = line.next) ++arcCount;
	  }
	  for (i = 0, n = rings.length; i < n; ++i) {
	    ring = rings[i]; while (ring = ring.next) ++arcCount;
	  }
	
	  var arcsByEnd = hashmap(arcCount * 2 * 1.4, hashPoint, equalPoint),
	      arcs = topology.arcs = [];
	
	  for (i = 0, n = lines.length; i < n; ++i) {
	    line = lines[i];
	    do {
	      dedupLine(line);
	    } while (line = line.next);
	  }
	
	  for (i = 0, n = rings.length; i < n; ++i) {
	    ring = rings[i];
	    if (ring.next) { // arc is no longer closed
	      do {
	        dedupLine(ring);
	      } while (ring = ring.next);
	    } else {
	      dedupRing(ring);
	    }
	  }
	
	  function dedupLine(arc) {
	    var startPoint,
	        endPoint,
	        startArcs, startArc,
	        endArcs, endArc,
	        i, n;
	
	    // Does this arc match an existing arc in order?
	    if (startArcs = arcsByEnd.get(startPoint = coordinates[arc[0]])) {
	      for (i = 0, n = startArcs.length; i < n; ++i) {
	        startArc = startArcs[i];
	        if (equalLine(startArc, arc)) {
	          arc[0] = startArc[0];
	          arc[1] = startArc[1];
	          return;
	        }
	      }
	    }
	
	    // Does this arc match an existing arc in reverse order?
	    if (endArcs = arcsByEnd.get(endPoint = coordinates[arc[1]])) {
	      for (i = 0, n = endArcs.length; i < n; ++i) {
	        endArc = endArcs[i];
	        if (reverseEqualLine(endArc, arc)) {
	          arc[1] = endArc[0];
	          arc[0] = endArc[1];
	          return;
	        }
	      }
	    }
	
	    if (startArcs) startArcs.push(arc); else arcsByEnd.set(startPoint, [arc]);
	    if (endArcs) endArcs.push(arc); else arcsByEnd.set(endPoint, [arc]);
	    arcs.push(arc);
	  }
	
	  function dedupRing(arc) {
	    var endPoint,
	        endArcs,
	        endArc,
	        i, n;
	
	    // Does this arc match an existing line in order, or reverse order?
	    // Rings are closed, so their start point and end point is the same.
	    if (endArcs = arcsByEnd.get(endPoint = coordinates[arc[0]])) {
	      for (i = 0, n = endArcs.length; i < n; ++i) {
	        endArc = endArcs[i];
	        if (equalRing(endArc, arc)) {
	          arc[0] = endArc[0];
	          arc[1] = endArc[1];
	          return;
	        }
	        if (reverseEqualRing(endArc, arc)) {
	          arc[0] = endArc[1];
	          arc[1] = endArc[0];
	          return;
	        }
	      }
	    }
	
	    // Otherwise, does this arc match an existing ring in order, or reverse order?
	    if (endArcs = arcsByEnd.get(endPoint = coordinates[arc[0] + findMinimumOffset(arc)])) {
	      for (i = 0, n = endArcs.length; i < n; ++i) {
	        endArc = endArcs[i];
	        if (equalRing(endArc, arc)) {
	          arc[0] = endArc[0];
	          arc[1] = endArc[1];
	          return;
	        }
	        if (reverseEqualRing(endArc, arc)) {
	          arc[0] = endArc[1];
	          arc[1] = endArc[0];
	          return;
	        }
	      }
	    }
	
	    if (endArcs) endArcs.push(arc); else arcsByEnd.set(endPoint, [arc]);
	    arcs.push(arc);
	  }
	
	  function equalLine(arcA, arcB) {
	    var ia = arcA[0], ib = arcB[0],
	        ja = arcA[1], jb = arcB[1];
	    if (ia - ja !== ib - jb) return false;
	    for (; ia <= ja; ++ia, ++ib) if (!equalPoint(coordinates[ia], coordinates[ib])) return false;
	    return true;
	  }
	
	  function reverseEqualLine(arcA, arcB) {
	    var ia = arcA[0], ib = arcB[0],
	        ja = arcA[1], jb = arcB[1];
	    if (ia - ja !== ib - jb) return false;
	    for (; ia <= ja; ++ia, --jb) if (!equalPoint(coordinates[ia], coordinates[jb])) return false;
	    return true;
	  }
	
	  function equalRing(arcA, arcB) {
	    var ia = arcA[0], ib = arcB[0],
	        ja = arcA[1], jb = arcB[1],
	        n = ja - ia;
	    if (n !== jb - ib) return false;
	    var ka = findMinimumOffset(arcA),
	        kb = findMinimumOffset(arcB);
	    for (var i = 0; i < n; ++i) {
	      if (!equalPoint(coordinates[ia + (i + ka) % n], coordinates[ib + (i + kb) % n])) return false;
	    }
	    return true;
	  }
	
	  function reverseEqualRing(arcA, arcB) {
	    var ia = arcA[0], ib = arcB[0],
	        ja = arcA[1], jb = arcB[1],
	        n = ja - ia;
	    if (n !== jb - ib) return false;
	    var ka = findMinimumOffset(arcA),
	        kb = n - findMinimumOffset(arcB);
	    for (var i = 0; i < n; ++i) {
	      if (!equalPoint(coordinates[ia + (i + ka) % n], coordinates[jb - (i + kb) % n])) return false;
	    }
	    return true;
	  }
	
	  // Rings are rotated to a consistent, but arbitrary, start point.
	  // This is necessary to detect when a ring and a rotated copy are dupes.
	  function findMinimumOffset(arc) {
	    var start = arc[0],
	        end = arc[1],
	        mid = start,
	        minimum = mid,
	        minimumPoint = coordinates[mid];
	    while (++mid < end) {
	      var point = coordinates[mid];
	      if (point[0] < minimumPoint[0] || point[0] === minimumPoint[0] && point[1] < minimumPoint[1]) {
	        minimum = mid;
	        minimumPoint = point;
	      }
	    }
	    return minimum - start;
	  }
	
	  return topology;
	};
	
	// Given an array of arcs in absolute (but already quantized!) coordinates,
	// converts to fixed-point delta encoding.
	// This is a destructive operation that modifies the given arcs!
	var delta = function(arcs) {
	  var i = -1,
	      n = arcs.length;
	
	  while (++i < n) {
	    var arc = arcs[i],
	        j = 0,
	        k = 1,
	        m = arc.length,
	        point = arc[0],
	        x0 = point[0],
	        y0 = point[1],
	        x1,
	        y1;
	
	    while (++j < m) {
	      point = arc[j], x1 = point[0], y1 = point[1];
	      if (x1 !== x0 || y1 !== y0) arc[k++] = [x1 - x0, y1 - y0], x0 = x1, y0 = y1;
	    }
	
	    if (k === 1) arc[k++] = [0, 0]; // Each arc must be an array of two or more positions.
	
	    arc.length = k;
	  }
	
	  return arcs;
	};
	
	// Extracts the lines and rings from the specified hash of geometry objects.
	//
	// Returns an object with three properties:
	//
	// * coordinates - shared buffer of [x, y] coordinates
	// * lines - lines extracted from the hash, of the form [start, end]
	// * rings - rings extracted from the hash, of the form [start, end]
	//
	// For each ring or line, start and end represent inclusive indexes into the
	// coordinates buffer. For rings (and closed lines), coordinates[start] equals
	// coordinates[end].
	//
	// For each line or polygon geometry in the input hash, including nested
	// geometries as in geometry collections, the `coordinates` array is replaced
	// with an equivalent `arcs` array that, for each line (for line string
	// geometries) or ring (for polygon geometries), points to one of the above
	// lines or rings.
	var extract = function(objects) {
	  var index = -1,
	      lines = [],
	      rings = [],
	      coordinates = [];
	
	  function extractGeometry(geometry) {
	    if (geometry && extractGeometryType.hasOwnProperty(geometry.type)) extractGeometryType[geometry.type](geometry);
	  }
	
	  var extractGeometryType = {
	    GeometryCollection: function(o) { o.geometries.forEach(extractGeometry); },
	    LineString: function(o) { o.arcs = extractLine(o.arcs); },
	    MultiLineString: function(o) { o.arcs = o.arcs.map(extractLine); },
	    Polygon: function(o) { o.arcs = o.arcs.map(extractRing); },
	    MultiPolygon: function(o) { o.arcs = o.arcs.map(extractMultiRing); }
	  };
	
	  function extractLine(line) {
	    for (var i = 0, n = line.length; i < n; ++i) coordinates[++index] = line[i];
	    var arc = {0: index - n + 1, 1: index};
	    lines.push(arc);
	    return arc;
	  }
	
	  function extractRing(ring) {
	    for (var i = 0, n = ring.length; i < n; ++i) coordinates[++index] = ring[i];
	    var arc = {0: index - n + 1, 1: index};
	    rings.push(arc);
	    return arc;
	  }
	
	  function extractMultiRing(rings) {
	    return rings.map(extractRing);
	  }
	
	  for (var key in objects) {
	    extractGeometry(objects[key]);
	  }
	
	  return {
	    type: "Topology",
	    coordinates: coordinates,
	    lines: lines,
	    rings: rings,
	    objects: objects
	  };
	};
	
	// Given a hash of GeoJSON objects, returns a hash of GeoJSON geometry objects.
	// Any null input geometry objects are represented as {type: null} in the output.
	// Any feature.{id,properties,bbox} are transferred to the output geometry object.
	// Each output geometry object is a shallow copy of the input (e.g., properties, coordinates)!
	var geometry = function(inputs) {
	  var outputs = {}, key;
	  for (key in inputs) outputs[key] = geomifyObject(inputs[key]);
	  return outputs;
	};
	
	function geomifyObject(input) {
	  return input == null ? {type: null}
	      : (input.type === "FeatureCollection" ? geomifyFeatureCollection
	      : input.type === "Feature" ? geomifyFeature
	      : geomifyGeometry)(input);
	}
	
	function geomifyFeatureCollection(input) {
	  var output = {type: "GeometryCollection", geometries: input.features.map(geomifyFeature)};
	  if (input.bbox != null) output.bbox = input.bbox;
	  return output;
	}
	
	function geomifyFeature(input) {
	  var output = geomifyGeometry(input.geometry), key; // eslint-disable-line no-unused-vars
	  if (input.id != null) output.id = input.id;
	  if (input.bbox != null) output.bbox = input.bbox;
	  for (key in input.properties) { output.properties = input.properties; break; }
	  return output;
	}
	
	function geomifyGeometry(input) {
	  if (input == null) return {type: null};
	  var output = input.type === "GeometryCollection" ? {type: "GeometryCollection", geometries: input.geometries.map(geomifyGeometry)}
	      : input.type === "Point" || input.type === "MultiPoint" ? {type: input.type, coordinates: input.coordinates}
	      : {type: input.type, arcs: input.coordinates}; // TODO Check for unknown types?
	  if (input.bbox != null) output.bbox = input.bbox;
	  return output;
	}
	
	var prequantize = function(objects, bbox, n) {
	  var x0 = bbox[0],
	      y0 = bbox[1],
	      x1 = bbox[2],
	      y1 = bbox[3],
	      kx = x1 - x0 ? (n - 1) / (x1 - x0) : 1,
	      ky = y1 - y0 ? (n - 1) / (y1 - y0) : 1;
	
	  function quantizePoint(input) {
	    return [Math.round((input[0] - x0) * kx), Math.round((input[1] - y0) * ky)];
	  }
	
	  function quantizePoints(input, m) {
	    var i = -1,
	        j = 0,
	        n = input.length,
	        output = new Array(n), // pessimistic
	        pi,
	        px,
	        py,
	        x,
	        y;
	
	    while (++i < n) {
	      pi = input[i];
	      x = Math.round((pi[0] - x0) * kx);
	      y = Math.round((pi[1] - y0) * ky);
	      if (x !== px || y !== py) output[j++] = [px = x, py = y]; // non-coincident points
	    }
	
	    output.length = j;
	    while (j < m) j = output.push([output[0][0], output[0][1]]);
	    return output;
	  }
	
	  function quantizeLine(input) {
	    return quantizePoints(input, 2);
	  }
	
	  function quantizeRing(input) {
	    return quantizePoints(input, 4);
	  }
	
	  function quantizePolygon(input) {
	    return input.map(quantizeRing);
	  }
	
	  function quantizeGeometry(o) {
	    if (o != null && quantizeGeometryType.hasOwnProperty(o.type)) quantizeGeometryType[o.type](o);
	  }
	
	  var quantizeGeometryType = {
	    GeometryCollection: function(o) { o.geometries.forEach(quantizeGeometry); },
	    Point: function(o) { o.coordinates = quantizePoint(o.coordinates); },
	    MultiPoint: function(o) { o.coordinates = o.coordinates.map(quantizePoint); },
	    LineString: function(o) { o.arcs = quantizeLine(o.arcs); },
	    MultiLineString: function(o) { o.arcs = o.arcs.map(quantizeLine); },
	    Polygon: function(o) { o.arcs = quantizePolygon(o.arcs); },
	    MultiPolygon: function(o) { o.arcs = o.arcs.map(quantizePolygon); }
	  };
	
	  for (var key in objects) {
	    quantizeGeometry(objects[key]);
	  }
	
	  return {
	    scale: [1 / kx, 1 / ky],
	    translate: [x0, y0]
	  };
	};
	
	// Constructs the TopoJSON Topology for the specified hash of features.
	// Each object in the specified hash must be a GeoJSON object,
	// meaning FeatureCollection, a Feature or a geometry object.
	var topology = function(objects, quantization) {
	  var bbox = bounds(objects = geometry(objects)),
	      transform = quantization > 0 && bbox && prequantize(objects, bbox, quantization),
	      topology = dedup(cut(extract(objects))),
	      coordinates = topology.coordinates,
	      indexByArc = hashmap(topology.arcs.length * 1.4, hashArc, equalArc);
	
	  objects = topology.objects; // for garbage collection
	  topology.bbox = bbox;
	  topology.arcs = topology.arcs.map(function(arc, i) {
	    indexByArc.set(arc, i);
	    return coordinates.slice(arc[0], arc[1] + 1);
	  });
	
	  delete topology.coordinates;
	  coordinates = null;
	
	  function indexGeometry(geometry$$1) {
	    if (geometry$$1 && indexGeometryType.hasOwnProperty(geometry$$1.type)) indexGeometryType[geometry$$1.type](geometry$$1);
	  }
	
	  var indexGeometryType = {
	    GeometryCollection: function(o) { o.geometries.forEach(indexGeometry); },
	    LineString: function(o) { o.arcs = indexArcs(o.arcs); },
	    MultiLineString: function(o) { o.arcs = o.arcs.map(indexArcs); },
	    Polygon: function(o) { o.arcs = o.arcs.map(indexArcs); },
	    MultiPolygon: function(o) { o.arcs = o.arcs.map(indexMultiArcs); }
	  };
	
	  function indexArcs(arc) {
	    var indexes = [];
	    do {
	      var index = indexByArc.get(arc);
	      indexes.push(arc[0] < arc[1] ? index : ~index);
	    } while (arc = arc.next);
	    return indexes;
	  }
	
	  function indexMultiArcs(arcs) {
	    return arcs.map(indexArcs);
	  }
	
	  for (var key in objects) {
	    indexGeometry(objects[key]);
	  }
	
	  if (transform) {
	    topology.transform = transform;
	    topology.arcs = delta(topology.arcs);
	  }
	
	  return topology;
	};
	
	function hashArc(arc) {
	  var i = arc[0], j = arc[1], t;
	  if (j < i) t = i, i = j, j = t;
	  return i + 31 * j;
	}
	
	function equalArc(arcA, arcB) {
	  var ia = arcA[0], ja = arcA[1],
	      ib = arcB[0], jb = arcB[1], t;
	  if (ja < ia) t = ia, ia = ja, ja = t;
	  if (jb < ib) t = ib, ib = jb, jb = t;
	  return ia === ib && ja === jb;
	}
	
	var prune = function(topology) {
	  var oldObjects = topology.objects,
	      newObjects = {},
	      oldArcs = topology.arcs,
	      newArcs = [],
	      newArcIndex = -1,
	      newIndexByOldIndex = new Array(oldArcs.length),
	      key;
	
	  function pruneGeometry(input) {
	    var output;
	    switch (input.type) {
	      case "GeometryCollection": output = {type: "GeometryCollection", geometries: input.geometries.map(pruneGeometry)}; break;
	      case "LineString": output = {type: "LineString", arcs: pruneArcs(input.arcs)}; break;
	      case "MultiLineString": output = {type: "MultiLineString", arcs: input.arcs.map(pruneArcs)}; break;
	      case "Polygon": output = {type: "Polygon", arcs: input.arcs.map(pruneArcs)}; break;
	      case "MultiPolygon": output = {type: "MultiPolygon", arcs: input.arcs.map(pruneMultiArcs)}; break;
	      default: return input;
	    }
	    if (input.id != null) output.id = input.id;
	    if (input.bbox != null) output.bbox = input.bbox;
	    if (input.properties != null) output.properties = input.properties;
	    return output;
	  }
	
	  function pruneArc(oldIndex) {
	    var oldReverse = oldIndex < 0 && (oldIndex = ~oldIndex, true), newIndex;
	
	    // If this is the first instance of this arc, record it under its new index.
	    if ((newIndex = newIndexByOldIndex[oldIndex]) == null) {
	      newIndexByOldIndex[oldIndex] = newIndex = ++newArcIndex;
	      newArcs[newIndex] = oldArcs[oldIndex];
	    }
	
	    return oldReverse ? ~newIndex : newIndex;
	  }
	
	  function pruneArcs(arcs) {
	    return arcs.map(pruneArc);
	  }
	
	  function pruneMultiArcs(arcs) {
	    return arcs.map(pruneArcs);
	  }
	
	  for (key in oldObjects) {
	    newObjects[key] = pruneGeometry(oldObjects[key]);
	  }
	
	  return {
	    type: "Topology",
	    bbox: topology.bbox,
	    transform: topology.transform,
	    objects: newObjects,
	    arcs: newArcs
	  };
	};
	
	var filter = function(topology, filter) {
	  var oldObjects = topology.objects,
	      newObjects = {},
	      key;
	
	  if (filter == null) filter = filterTrue;
	
	  function filterGeometry(input) {
	    var output, arcs;
	    switch (input.type) {
	      case "Polygon": {
	        arcs = filterRings(input.arcs);
	        output = arcs ? {type: "Polygon", arcs: arcs} : {type: null};
	        break;
	      }
	      case "MultiPolygon": {
	        arcs = input.arcs.map(filterRings).filter(filterIdentity);
	        output = arcs.length ? {type: "MultiPolygon", arcs: arcs} : {type: null};
	        break;
	      }
	      case "GeometryCollection": {
	        arcs = input.geometries.map(filterGeometry).filter(filterNotNull);
	        output = arcs.length ? {type: "GeometryCollection", geometries: arcs} : {type: null};
	        break;
	      }
	      default: return input;
	    }
	    if (input.id != null) output.id = input.id;
	    if (input.bbox != null) output.bbox = input.bbox;
	    if (input.properties != null) output.properties = input.properties;
	    return output;
	  }
	
	  function filterRings(arcs) {
	    return arcs.length && filterExteriorRing(arcs[0]) // if the exterior is small, ignore any holes
	        ? [arcs[0]].concat(arcs.slice(1).filter(filterInteriorRing))
	        : null;
	  }
	
	  function filterExteriorRing(ring) {
	    return filter(ring, false);
	  }
	
	  function filterInteriorRing(ring) {
	    return filter(ring, true);
	  }
	
	  for (key in oldObjects) {
	    newObjects[key] = filterGeometry(oldObjects[key]);
	  }
	
	  return prune({
	    type: "Topology",
	    bbox: topology.bbox,
	    transform: topology.transform,
	    objects: newObjects,
	    arcs: topology.arcs
	  });
	};
	
	function filterTrue() {
	  return true;
	}
	
	function filterIdentity(x) {
	  return x;
	}
	
	function filterNotNull(geometry) {
	  return geometry.type != null;
	}
	
	var filterAttached = function(topology) {
	  var uniqueRingByArc = {}, // arc index -> index of unique associated ring, or -1 if used by multiple rings
	      ringIndex = 0,
	      name;
	
	  function testGeometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(testGeometry); break;
	      case "Polygon": testArcs(o.arcs); break;
	      case "MultiPolygon": o.arcs.forEach(testArcs); break;
	    }
	  }
	
	  function testArcs(arcs) {
	    for (var i = 0, n = arcs.length; i < n; ++i, ++ringIndex) {
	      for (var ring = arcs[i], j = 0, m = ring.length; j < m; ++j) {
	        var arc = ring[j];
	        if (arc < 0) arc = ~arc;
	        var uniqueRing = uniqueRingByArc[arc];
	        if (uniqueRing >= 0 && uniqueRing !== ringIndex) uniqueRingByArc[arc] = -1;
	        else uniqueRingByArc[arc] = ringIndex;
	      }
	    }
	  }
	
	  for (name in topology.objects) {
	    testGeometry(topology.objects[name]);
	  }
	
	  return function(ring) {
	    for (var j = 0, m = ring.length, arc; j < m; ++j) {
	      if (arc = ring[j], uniqueRingByArc[arc < 0 ? ~arc : arc] < 0) {
	        return true;
	      }
	    }
	    return false;
	  };
	};
	
	function planarTriangleArea(triangle) {
	  var a = triangle[0], b = triangle[1], c = triangle[2];
	  return Math.abs((a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1])) / 2;
	}
	
	function planarRingArea$1(ring) {
	  var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
	  while (++i < n) a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
	  return Math.abs(area) / 2;
	}
	
	var filterWeight = function(topology, minWeight, weight) {
	  minWeight = minWeight == null ? Number.MIN_VALUE : +minWeight;
	
	  if (weight == null) weight = planarRingArea$1;
	
	  return function(ring, interior) {
	    return weight(feature(topology, {type: "Polygon", arcs: [ring]}).geometry.coordinates[0], interior) >= minWeight;
	  };
	};
	
	var filterAttachedWeight = function(topology, minWeight, weight) {
	  var a = filterAttached(topology),
	      w = filterWeight(topology, minWeight, weight);
	  return function(ring, interior) {
	    return a(ring, interior) || w(ring, interior);
	  };
	};
	
	function compare(a, b) {
	  return a[1][2] - b[1][2];
	}
	
	var newHeap = function() {
	  var heap = {},
	      array = [],
	      size = 0;
	
	  heap.push = function(object) {
	    up(array[object._ = size] = object, size++);
	    return size;
	  };
	
	  heap.pop = function() {
	    if (size <= 0) return;
	    var removed = array[0], object;
	    if (--size > 0) object = array[size], down(array[object._ = 0] = object, 0);
	    return removed;
	  };
	
	  heap.remove = function(removed) {
	    var i = removed._, object;
	    if (array[i] !== removed) return; // invalid request
	    if (i !== --size) object = array[size], (compare(object, removed) < 0 ? up : down)(array[object._ = i] = object, i);
	    return i;
	  };
	
	  function up(object, i) {
	    while (i > 0) {
	      var j = ((i + 1) >> 1) - 1,
	          parent = array[j];
	      if (compare(object, parent) >= 0) break;
	      array[parent._ = i] = parent;
	      array[object._ = i = j] = object;
	    }
	  }
	
	  function down(object, i) {
	    while (true) {
	      var r = (i + 1) << 1,
	          l = r - 1,
	          j = i,
	          child = array[j];
	      if (l < size && compare(array[l], child) < 0) child = array[j = l];
	      if (r < size && compare(array[r], child) < 0) child = array[j = r];
	      if (j === i) break;
	      array[child._ = i] = child;
	      array[object._ = i = j] = object;
	    }
	  }
	
	  return heap;
	};
	
	function copy(point) {
	  return [point[0], point[1], 0];
	}
	
	var presimplify = function(topology, weight) {
	  var point = topology.transform ? transform(topology.transform) : copy,
	      heap = newHeap();
	
	  if (weight == null) weight = planarTriangleArea;
	
	  var arcs = topology.arcs.map(function(arc) {
	    var triangles = [],
	        maxWeight = 0,
	        triangle,
	        i,
	        n;
	
	    arc = arc.map(point);
	
	    for (i = 1, n = arc.length - 1; i < n; ++i) {
	      triangle = [arc[i - 1], arc[i], arc[i + 1]];
	      triangle[1][2] = weight(triangle);
	      triangles.push(triangle);
	      heap.push(triangle);
	    }
	
	    // Always keep the arc endpoints!
	    arc[0][2] = arc[n][2] = Infinity;
	
	    for (i = 0, n = triangles.length; i < n; ++i) {
	      triangle = triangles[i];
	      triangle.previous = triangles[i - 1];
	      triangle.next = triangles[i + 1];
	    }
	
	    while (triangle = heap.pop()) {
	      var previous = triangle.previous,
	          next = triangle.next;
	
	      // If the weight of the current point is less than that of the previous
	      // point to be eliminated, use the latter’s weight instead. This ensures
	      // that the current point cannot be eliminated without eliminating
	      // previously- eliminated points.
	      if (triangle[1][2] < maxWeight) triangle[1][2] = maxWeight;
	      else maxWeight = triangle[1][2];
	
	      if (previous) {
	        previous.next = next;
	        previous[2] = triangle[2];
	        update(previous);
	      }
	
	      if (next) {
	        next.previous = previous;
	        next[0] = triangle[0];
	        update(next);
	      }
	    }
	
	    return arc;
	  });
	
	  function update(triangle) {
	    heap.remove(triangle);
	    triangle[1][2] = weight(triangle);
	    heap.push(triangle);
	  }
	
	  return {
	    type: "Topology",
	    bbox: topology.bbox,
	    objects: topology.objects,
	    arcs: arcs
	  };
	};
	
	var quantile = function(topology, p) {
	  var array = [];
	
	  topology.arcs.forEach(function(arc) {
	    arc.forEach(function(point) {
	      if (isFinite(point[2])) { // Ignore endpoints, whose weight is Infinity.
	        array.push(point[2]);
	      }
	    });
	  });
	
	  return array.length && quantile$1(array.sort(descending), p);
	};
	
	function quantile$1(array, p) {
	  if (!(n = array.length)) return;
	  if ((p = +p) <= 0 || n < 2) return array[0];
	  if (p >= 1) return array[n - 1];
	  var n,
	      h = (n - 1) * p,
	      i = Math.floor(h),
	      a = array[i],
	      b = array[i + 1];
	  return a + (b - a) * (h - i);
	}
	
	function descending(a, b) {
	  return b - a;
	}
	
	var simplify = function(topology, minWeight) {
	  minWeight = minWeight == null ? Number.MIN_VALUE : +minWeight;
	
	  // Remove points whose weight is less than the minimum weight.
	  var arcs = topology.arcs.map(function(input) {
	    var i = -1,
	        j = 0,
	        n = input.length,
	        output = new Array(n), // pessimistic
	        point;
	
	    while (++i < n) {
	      if ((point = input[i])[2] >= minWeight) {
	        output[j++] = [point[0], point[1]];
	      }
	    }
	
	    output.length = j;
	    return output;
	  });
	
	  return {
	    type: "Topology",
	    transform: topology.transform,
	    bbox: topology.bbox,
	    objects: topology.objects,
	    arcs: arcs
	  };
	};
	
	var pi = Math.PI;
	var tau = 2 * pi;
	var quarterPi = pi / 4;
	var radians = pi / 180;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var sin = Math.sin;
	
	function halfArea(ring, closed) {
	  var i = 0,
	      n = ring.length,
	      sum = 0,
	      point = ring[closed ? i++ : n - 1],
	      lambda0, lambda1 = point[0] * radians,
	      phi1 = (point[1] * radians) / 2 + quarterPi,
	      cosPhi0, cosPhi1 = cos(phi1),
	      sinPhi0, sinPhi1 = sin(phi1);
	
	  for (; i < n; ++i) {
	    point = ring[i];
	    lambda0 = lambda1, lambda1 = point[0] * radians;
	    phi1 = (point[1] * radians) / 2 + quarterPi;
	    cosPhi0 = cosPhi1, cosPhi1 = cos(phi1);
	    sinPhi0 = sinPhi1, sinPhi1 = sin(phi1);
	
	    // Spherical excess E for a spherical triangle with vertices: south pole,
	    // previous point, current point.  Uses a formula derived from Cagnoli’s
	    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
	    // See https://github.com/d3/d3-geo/blob/master/README.md#geoArea
	    var dLambda = lambda1 - lambda0,
	        sdLambda = dLambda >= 0 ? 1 : -1,
	        adLambda = sdLambda * dLambda,
	        k = sinPhi0 * sinPhi1,
	        u = cosPhi0 * cosPhi1 + k * cos(adLambda),
	        v = k * sdLambda * sin(adLambda);
	    sum += atan2(v, u);
	  }
	
	  return sum;
	}
	
	function sphericalRingArea(ring, interior) {
	  var sum = halfArea(ring, true);
	  if (interior) sum *= -1;
	  return (sum < 0 ? tau + sum : sum) * 2;
	}
	
	function sphericalTriangleArea(t) {
	  var sum = halfArea(t, false);
	  return (sum < 0 ? tau + sum : sum) * 2;
	}
	
	exports.bbox = bbox;
	exports.feature = feature;
	exports.mesh = mesh;
	exports.meshArcs = meshArcs;
	exports.merge = merge;
	exports.mergeArcs = mergeArcs;
	exports.neighbors = neighbors;
	exports.quantize = quantize;
	exports.transform = transform;
	exports.untransform = untransform;
	exports.topology = topology;
	exports.filter = filter;
	exports.filterAttached = filterAttached;
	exports.filterAttachedWeight = filterAttachedWeight;
	exports.filterWeight = filterWeight;
	exports.planarRingArea = planarRingArea$1;
	exports.planarTriangleArea = planarTriangleArea;
	exports.presimplify = presimplify;
	exports.quantile = quantile;
	exports.simplify = simplify;
	exports.sphericalRingArea = sphericalRingArea;
	exports.sphericalTriangleArea = sphericalTriangleArea;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js